// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../node_modules/slick-carousel/slick/slick.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../node_modules/slick-carousel/slick/slick-theme.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23636f83%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27rgba%28255, 255, 255, 0.87%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27rgba%28255, 255, 255, 0.87%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27rgba%28255, 255, 255, 0.87%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%2870, 53, 41, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23998fed%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.87%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%232eb85c%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23e55353%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23e55353%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2844, 56, 74, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27var%28--cui-body-color%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%232d1cc5%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%2844, 56, 74, 0.95%29%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.87%29%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.87%29%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27currentColor%27 stroke-width=%272.25%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 11 14%27%3E%3Cpath fill=%27rgba%28255, 255, 255, 0.38%29%27 d=%27M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 11 14%27%3E%3Cpath fill=%27rgba%28255, 255, 255, 0.87%29%27 d=%27M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.6%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.87%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../assets/images/switch-circle.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%3csvg width=%27100%25%27 height=%27100%25%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3crect width=%27100%25%27 height=%27100%25%27 fill=%27none%27 rx=%274%27 ry=%274%27 stroke=%27%23149BFFFF%27 stroke-width=%273%27 stroke-dasharray=%276%2c 14%27 stroke-dashoffset=%270%27 stroke-linecap=%27square%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
 * CoreUI  v4.3.0 (https://coreui.io)
 * Copyright (c) 2023 creativeLabs Łukasz Holeczek
 * Licensed under MIT (https://github.com/coreui/coreui/blob/main/LICENSE)
 */
:root {
  --cui-blue: #21699E;
  --cui-indigo: #6610f2;
  --cui-purple: #6f42c1;
  --cui-pink: #d63384;
  --cui-red: #FF0F00;
  --cui-orange: #F8601B;
  --cui-yellow: #FCCA0D;
  --cui-green: #4EAE5D;
  --cui-teal: #20c997;
  --cui-cyan: #0dcaf0;
  --cui-black: #463529;
  --cui-white: #FFFFFF;
  --cui-gray: #8a93a2;
  --cui-gray-dark: #636f83;
  --cui-gray-100: #ebedef;
  --cui-gray-200: #d8dbe0;
  --cui-gray-300: #c4c9d0;
  --cui-gray-400: #b1b7c1;
  --cui-gray-500: #9da5b1;
  --cui-gray-600: #8a93a2;
  --cui-gray-700: #768192;
  --cui-gray-800: #636f83;
  --cui-gray-900: #4f5d73;
  --cui-primary: #321fdb;
  --cui-secondary: #9da5b1;
  --cui-success: #2eb85c;
  --cui-info: #39f;
  --cui-warning: #f9b115;
  --cui-danger: #e55353;
  --cui-light: #ebedef;
  --cui-dark: #818181;
  --cui-primary-rgb: 50, 31, 219;
  --cui-secondary-rgb: 157, 165, 177;
  --cui-success-rgb: 46, 184, 92;
  --cui-info-rgb: 51, 153, 255;
  --cui-warning-rgb: 249, 177, 21;
  --cui-danger-rgb: 229, 83, 83;
  --cui-light-rgb: 235, 237, 239;
  --cui-dark-rgb: 129, 129, 129;
  --cui-white-rgb: 255, 255, 255;
  --cui-black-rgb: 70, 53, 41;
  --cui-body-color-rgb: 44, 56, 74;
  --cui-body-bg-rgb: 255, 255, 255;
  --cui-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --cui-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --cui-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --cui-body-font-family: var(--cui-font-sans-serif);
  --cui-body-font-size: 1rem;
  --cui-body-font-weight: 400;
  --cui-body-line-height: 1.5;
  --cui-body-color: rgba(44, 56, 74, 0.95);
  --cui-body-color-rgb: 44, 56, 74;
  --cui-body-bg: #FFFFFF;
  --cui-body-bg-rgb: 255, 255, 255;
  --cui-emphasis-color: #463529;
  --cui-emphasis-color-rgb: 70, 53, 41;
  --cui-secondary-color: rgba(44, 56, 74, 0.681);
  --cui-secondary-color-rgb: 44, 56, 74;
  --cui-secondary-bg: #d8dbe0;
  --cui-secondary-bg-rgb: 216, 219, 224;
  --cui-tertiary-color: rgba(44, 56, 74, 0.38);
  --cui-tertiary-color-rgb: 44, 56, 74;
  --cui-tertiary-bg: #ebedef;
  --cui-tertiary-bg-rgb: 235, 237, 239;
  --cui-high-emphasis: rgba(44, 56, 74, 0.95);
  --cui-medium-emphasis: rgba(44, 56, 74, 0.681);
  --cui-disabled: rgba(44, 56, 74, 0.38);
  --cui-high-emphasis-inverse: rgba(255, 255, 255, 0.87);
  --cui-medium-emphasis-inverse: rgba(255, 255, 255, 0.6);
  --cui-disabled-inverse: rgba(255, 255, 255, 0.38);
  --cui-heading-color: inherit;
  --cui-link-color: #321fdb;
  --cui-link-color-rgb: 50, 31, 219;
  --cui-link-decoration: underline;
  --cui-link-hover-color: #2819af;
  --cui-link-hover-color-rgb: 40, 25, 175;
  --cui-code-color: #d63384;
  --cui-highlight-bg: #fef4cf;
  --cui-border-width: 1px;
  --cui-border-style: solid;
  --cui-border-color: #d8dbe0;
  --cui-border-color-translucent: rgba(70, 53, 41, 0.175);
  --cui-border-radius: 0.375rem;
  --cui-border-radius-sm: 0.25rem;
  --cui-border-radius-lg: 0.5rem;
  --cui-border-radius-xl: 1rem;
  --cui-border-radius-xxl: 2rem;
  --cui-border-radius-2xl: var(--cui-border-radius-xxl);
  --cui-border-radius-pill: 50rem;
  --cui-box-shadow: 0 0.5rem 1rem rgba(70, 53, 41, 0.15);
  --cui-box-shadow-sm: 0 0.125rem 0.25rem rgba(70, 53, 41, 0.075);
  --cui-box-shadow-lg: 0 1rem 3rem rgba(70, 53, 41, 0.175);
  --cui-box-shadow-inset: inset 0 1px 2px rgba(70, 53, 41, 0.075);
  --cui-focus-ring-width: 0.25rem;
  --cui-focus-ring-opacity: 0.25;
  --cui-focus-ring-color: rgba(50, 31, 219, 0.25);
  --cui-form-valid-color: #2eb85c;
  --cui-form-valid-border-color: #2eb85c;
  --cui-form-invalid-color: #e55353;
  --cui-form-invalid-border-color: #e55353;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--cui-body-font-family);
  font-size: var(--cui-body-font-size);
  font-weight: var(--cui-body-font-weight);
  line-height: var(--cui-body-line-height);
  color: var(--cui-body-color);
  text-align: var(--cui-body-text-align);
  background-color: var(--cui-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(70, 53, 41, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--cui-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--cui-heading-color);
}

h1, .h1 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.5rem;
  }
}

h2, .h2 {
  font-size: calc(1.325rem + 0.9vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 2rem;
  }
}

h3, .h3 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.75rem;
  }
}

h4, .h4 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.5rem;
  }
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
}
html:not([dir=rtl]) dd {
  margin-left: 0;
}
*[dir=rtl] dd {
  margin-right: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  background-color: var(--cui-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--cui-link-color-rgb), var(--cui-link-opacity, 1));
  text-decoration: underline;
}
a:hover {
  --cui-link-color-rgb: var(--cui-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--cui-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
  color: var(--cui-pre-color, );
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--cui-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--cui-kbd-color, var(--cui-body-bg));
  background-color: var(--cui-kbd-bg, var(--cui-body-color));
  border-radius: 0.25rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--cui-table-caption-color, var(--cui-secondary-color));
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
html:not([dir=rtl]) legend {
  float: left;
}
*[dir=rtl] legend {
  float: right;
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

*[dir=rtl] [type=tel],
*[dir=rtl] [type=url],
*[dir=rtl] [type=email],
*[dir=rtl] [type=number] {
  direction: ltr;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  list-style: none;
}
html:not([dir=rtl]) .list-unstyled {
  padding-left: 0;
}
*[dir=rtl] .list-unstyled {
  padding-right: 0;
}

.list-inline {
  list-style: none;
}
html:not([dir=rtl]) .list-inline {
  padding-left: 0;
}
*[dir=rtl] .list-inline {
  padding-right: 0;
}

.list-inline-item {
  display: inline-block;
}
html:not([dir=rtl]) .list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}
*[dir=rtl] .list-inline-item:not(:last-child) {
  margin-left: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #8a93a2;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--cui-thumbnail-bg, var(--cui-body-bg));
  border: var(--cui-border-width) solid var(--cui-thumbnail-border-color, var(--cui-border-color));
  border-radius: var(--cui-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--cui-figure-caption-color, var(--cui-secondary-color));
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --cui-gutter-x: 1.5rem;
  --cui-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--cui-gutter-x) * 0.5);
  padding-left: calc(var(--cui-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --cui-breakpoint-xs: 0;
  --cui-breakpoint-sm: 576px;
  --cui-breakpoint-md: 768px;
  --cui-breakpoint-lg: 992px;
  --cui-breakpoint-xl: 1200px;
  --cui-breakpoint-xxl: 1400px;
  --cui-mobile-breakpoint: md;
}

.row {
  --cui-gutter-x: 1.5rem;
  --cui-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--cui-gutter-y));
  margin-right: calc(-0.5 * var(--cui-gutter-x));
  margin-left: calc(-0.5 * var(--cui-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--cui-gutter-x) * 0.5);
  padding-left: calc(var(--cui-gutter-x) * 0.5);
  margin-top: var(--cui-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

html:not([dir=rtl]) .offset-1 {
  margin-left: 8.33333333%;
}
*[dir=rtl] .offset-1 {
  margin-right: 8.33333333%;
}

html:not([dir=rtl]) .offset-2 {
  margin-left: 16.66666667%;
}
*[dir=rtl] .offset-2 {
  margin-right: 16.66666667%;
}

html:not([dir=rtl]) .offset-3 {
  margin-left: 25%;
}
*[dir=rtl] .offset-3 {
  margin-right: 25%;
}

html:not([dir=rtl]) .offset-4 {
  margin-left: 33.33333333%;
}
*[dir=rtl] .offset-4 {
  margin-right: 33.33333333%;
}

html:not([dir=rtl]) .offset-5 {
  margin-left: 41.66666667%;
}
*[dir=rtl] .offset-5 {
  margin-right: 41.66666667%;
}

html:not([dir=rtl]) .offset-6 {
  margin-left: 50%;
}
*[dir=rtl] .offset-6 {
  margin-right: 50%;
}

html:not([dir=rtl]) .offset-7 {
  margin-left: 58.33333333%;
}
*[dir=rtl] .offset-7 {
  margin-right: 58.33333333%;
}

html:not([dir=rtl]) .offset-8 {
  margin-left: 66.66666667%;
}
*[dir=rtl] .offset-8 {
  margin-right: 66.66666667%;
}

html:not([dir=rtl]) .offset-9 {
  margin-left: 75%;
}
*[dir=rtl] .offset-9 {
  margin-right: 75%;
}

html:not([dir=rtl]) .offset-10 {
  margin-left: 83.33333333%;
}
*[dir=rtl] .offset-10 {
  margin-right: 83.33333333%;
}

html:not([dir=rtl]) .offset-11 {
  margin-left: 91.66666667%;
}
*[dir=rtl] .offset-11 {
  margin-right: 91.66666667%;
}

.g-0,
.gx-0 {
  --cui-gutter-x: 0;
}

.g-0,
.gy-0 {
  --cui-gutter-y: 0;
}

.g-1,
.gx-1 {
  --cui-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --cui-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --cui-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --cui-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --cui-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --cui-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --cui-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --cui-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --cui-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --cui-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  html:not([dir=rtl]) .offset-sm-0 {
    margin-left: 0;
  }
  *[dir=rtl] .offset-sm-0 {
    margin-right: 0;
  }
  html:not([dir=rtl]) .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  *[dir=rtl] .offset-sm-1 {
    margin-right: 8.33333333%;
  }
  html:not([dir=rtl]) .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  *[dir=rtl] .offset-sm-2 {
    margin-right: 16.66666667%;
  }
  html:not([dir=rtl]) .offset-sm-3 {
    margin-left: 25%;
  }
  *[dir=rtl] .offset-sm-3 {
    margin-right: 25%;
  }
  html:not([dir=rtl]) .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  *[dir=rtl] .offset-sm-4 {
    margin-right: 33.33333333%;
  }
  html:not([dir=rtl]) .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  *[dir=rtl] .offset-sm-5 {
    margin-right: 41.66666667%;
  }
  html:not([dir=rtl]) .offset-sm-6 {
    margin-left: 50%;
  }
  *[dir=rtl] .offset-sm-6 {
    margin-right: 50%;
  }
  html:not([dir=rtl]) .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  *[dir=rtl] .offset-sm-7 {
    margin-right: 58.33333333%;
  }
  html:not([dir=rtl]) .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  *[dir=rtl] .offset-sm-8 {
    margin-right: 66.66666667%;
  }
  html:not([dir=rtl]) .offset-sm-9 {
    margin-left: 75%;
  }
  *[dir=rtl] .offset-sm-9 {
    margin-right: 75%;
  }
  html:not([dir=rtl]) .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  *[dir=rtl] .offset-sm-10 {
    margin-right: 83.33333333%;
  }
  html:not([dir=rtl]) .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  *[dir=rtl] .offset-sm-11 {
    margin-right: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --cui-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --cui-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --cui-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --cui-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --cui-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --cui-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  html:not([dir=rtl]) .offset-md-0 {
    margin-left: 0;
  }
  *[dir=rtl] .offset-md-0 {
    margin-right: 0;
  }
  html:not([dir=rtl]) .offset-md-1 {
    margin-left: 8.33333333%;
  }
  *[dir=rtl] .offset-md-1 {
    margin-right: 8.33333333%;
  }
  html:not([dir=rtl]) .offset-md-2 {
    margin-left: 16.66666667%;
  }
  *[dir=rtl] .offset-md-2 {
    margin-right: 16.66666667%;
  }
  html:not([dir=rtl]) .offset-md-3 {
    margin-left: 25%;
  }
  *[dir=rtl] .offset-md-3 {
    margin-right: 25%;
  }
  html:not([dir=rtl]) .offset-md-4 {
    margin-left: 33.33333333%;
  }
  *[dir=rtl] .offset-md-4 {
    margin-right: 33.33333333%;
  }
  html:not([dir=rtl]) .offset-md-5 {
    margin-left: 41.66666667%;
  }
  *[dir=rtl] .offset-md-5 {
    margin-right: 41.66666667%;
  }
  html:not([dir=rtl]) .offset-md-6 {
    margin-left: 50%;
  }
  *[dir=rtl] .offset-md-6 {
    margin-right: 50%;
  }
  html:not([dir=rtl]) .offset-md-7 {
    margin-left: 58.33333333%;
  }
  *[dir=rtl] .offset-md-7 {
    margin-right: 58.33333333%;
  }
  html:not([dir=rtl]) .offset-md-8 {
    margin-left: 66.66666667%;
  }
  *[dir=rtl] .offset-md-8 {
    margin-right: 66.66666667%;
  }
  html:not([dir=rtl]) .offset-md-9 {
    margin-left: 75%;
  }
  *[dir=rtl] .offset-md-9 {
    margin-right: 75%;
  }
  html:not([dir=rtl]) .offset-md-10 {
    margin-left: 83.33333333%;
  }
  *[dir=rtl] .offset-md-10 {
    margin-right: 83.33333333%;
  }
  html:not([dir=rtl]) .offset-md-11 {
    margin-left: 91.66666667%;
  }
  *[dir=rtl] .offset-md-11 {
    margin-right: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --cui-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --cui-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --cui-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --cui-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --cui-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --cui-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  html:not([dir=rtl]) .offset-lg-0 {
    margin-left: 0;
  }
  *[dir=rtl] .offset-lg-0 {
    margin-right: 0;
  }
  html:not([dir=rtl]) .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  *[dir=rtl] .offset-lg-1 {
    margin-right: 8.33333333%;
  }
  html:not([dir=rtl]) .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  *[dir=rtl] .offset-lg-2 {
    margin-right: 16.66666667%;
  }
  html:not([dir=rtl]) .offset-lg-3 {
    margin-left: 25%;
  }
  *[dir=rtl] .offset-lg-3 {
    margin-right: 25%;
  }
  html:not([dir=rtl]) .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  *[dir=rtl] .offset-lg-4 {
    margin-right: 33.33333333%;
  }
  html:not([dir=rtl]) .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  *[dir=rtl] .offset-lg-5 {
    margin-right: 41.66666667%;
  }
  html:not([dir=rtl]) .offset-lg-6 {
    margin-left: 50%;
  }
  *[dir=rtl] .offset-lg-6 {
    margin-right: 50%;
  }
  html:not([dir=rtl]) .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  *[dir=rtl] .offset-lg-7 {
    margin-right: 58.33333333%;
  }
  html:not([dir=rtl]) .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  *[dir=rtl] .offset-lg-8 {
    margin-right: 66.66666667%;
  }
  html:not([dir=rtl]) .offset-lg-9 {
    margin-left: 75%;
  }
  *[dir=rtl] .offset-lg-9 {
    margin-right: 75%;
  }
  html:not([dir=rtl]) .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  *[dir=rtl] .offset-lg-10 {
    margin-right: 83.33333333%;
  }
  html:not([dir=rtl]) .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  *[dir=rtl] .offset-lg-11 {
    margin-right: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --cui-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --cui-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --cui-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --cui-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --cui-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --cui-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  html:not([dir=rtl]) .offset-xl-0 {
    margin-left: 0;
  }
  *[dir=rtl] .offset-xl-0 {
    margin-right: 0;
  }
  html:not([dir=rtl]) .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  *[dir=rtl] .offset-xl-1 {
    margin-right: 8.33333333%;
  }
  html:not([dir=rtl]) .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  *[dir=rtl] .offset-xl-2 {
    margin-right: 16.66666667%;
  }
  html:not([dir=rtl]) .offset-xl-3 {
    margin-left: 25%;
  }
  *[dir=rtl] .offset-xl-3 {
    margin-right: 25%;
  }
  html:not([dir=rtl]) .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  *[dir=rtl] .offset-xl-4 {
    margin-right: 33.33333333%;
  }
  html:not([dir=rtl]) .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  *[dir=rtl] .offset-xl-5 {
    margin-right: 41.66666667%;
  }
  html:not([dir=rtl]) .offset-xl-6 {
    margin-left: 50%;
  }
  *[dir=rtl] .offset-xl-6 {
    margin-right: 50%;
  }
  html:not([dir=rtl]) .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  *[dir=rtl] .offset-xl-7 {
    margin-right: 58.33333333%;
  }
  html:not([dir=rtl]) .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  *[dir=rtl] .offset-xl-8 {
    margin-right: 66.66666667%;
  }
  html:not([dir=rtl]) .offset-xl-9 {
    margin-left: 75%;
  }
  *[dir=rtl] .offset-xl-9 {
    margin-right: 75%;
  }
  html:not([dir=rtl]) .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  *[dir=rtl] .offset-xl-10 {
    margin-right: 83.33333333%;
  }
  html:not([dir=rtl]) .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  *[dir=rtl] .offset-xl-11 {
    margin-right: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --cui-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --cui-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --cui-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --cui-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --cui-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --cui-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  html:not([dir=rtl]) .offset-xxl-0 {
    margin-left: 0;
  }
  *[dir=rtl] .offset-xxl-0 {
    margin-right: 0;
  }
  html:not([dir=rtl]) .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  *[dir=rtl] .offset-xxl-1 {
    margin-right: 8.33333333%;
  }
  html:not([dir=rtl]) .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  *[dir=rtl] .offset-xxl-2 {
    margin-right: 16.66666667%;
  }
  html:not([dir=rtl]) .offset-xxl-3 {
    margin-left: 25%;
  }
  *[dir=rtl] .offset-xxl-3 {
    margin-right: 25%;
  }
  html:not([dir=rtl]) .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  *[dir=rtl] .offset-xxl-4 {
    margin-right: 33.33333333%;
  }
  html:not([dir=rtl]) .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  *[dir=rtl] .offset-xxl-5 {
    margin-right: 41.66666667%;
  }
  html:not([dir=rtl]) .offset-xxl-6 {
    margin-left: 50%;
  }
  *[dir=rtl] .offset-xxl-6 {
    margin-right: 50%;
  }
  html:not([dir=rtl]) .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  *[dir=rtl] .offset-xxl-7 {
    margin-right: 58.33333333%;
  }
  html:not([dir=rtl]) .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  *[dir=rtl] .offset-xxl-8 {
    margin-right: 66.66666667%;
  }
  html:not([dir=rtl]) .offset-xxl-9 {
    margin-left: 75%;
  }
  *[dir=rtl] .offset-xxl-9 {
    margin-right: 75%;
  }
  html:not([dir=rtl]) .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  *[dir=rtl] .offset-xxl-10 {
    margin-right: 83.33333333%;
  }
  html:not([dir=rtl]) .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  *[dir=rtl] .offset-xxl-11 {
    margin-right: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --cui-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --cui-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --cui-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --cui-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --cui-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --cui-gutter-y: 3rem;
  }
}
.table {
  --cui-table-color-type: initial;
  --cui-table-bg-type: initial;
  --cui-table-color-state: initial;
  --cui-table-bg-state: initial;
  --cui-table-color: var(--cui-body-color);
  --cui-table-bg: var(--cui-body-bg);
  --cui-table-border-color: var(--cui-border-color);
  --cui-table-accent-bg: transparent;
  --cui-table-striped-color: var(--cui-body-color);
  --cui-table-striped-bg: rgba(70, 53, 41, 0.05);
  --cui-table-active-color: var(--cui-body-color);
  --cui-table-active-bg: rgba(70, 53, 41, 0.1);
  --cui-table-hover-color: var(--cui-body-color);
  --cui-table-hover-bg: rgba(70, 53, 41, 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--cui-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--cui-table-color-state, var(--cui-table-color-type, var(--cui-table-color)));
  background-color: var(--cui-table-bg);
  border-bottom-width: var(--cui-border-width);
  box-shadow: inset 0 0 0 9999px var(--cui-table-bg-state, var(--cui-table-bg-type, var(--cui-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--cui-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--cui-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--cui-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --cui-table-color-type: var(--cui-table-striped-color);
  --cui-table-bg-type: var(--cui-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --cui-table-color-type: var(--cui-table-striped-color);
  --cui-table-bg-type: var(--cui-table-striped-bg);
}

.table-active {
  --cui-table-color-state: var(--cui-table-active-color);
  --cui-table-bg-state: var(--cui-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --cui-table-color-state: var(--cui-table-hover-color);
  --cui-table-bg-state: var(--cui-table-hover-bg);
}

.table-primary {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #d6d2f8;
  --cui-table-border-color: rgba(198, 196, 232, 0.995);
  --cui-table-striped-bg: rgba(206, 203, 240, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(198, 196, 232, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(202, 199, 236, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-secondary {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #ebedef;
  --cui-table-border-color: rgba(218, 220, 224, 0.995);
  --cui-table-striped-bg: rgba(226, 229, 232, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(218, 220, 224, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(222, 225, 228, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-success {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #d5f1de;
  --cui-table-border-color: rgba(198, 224, 208, 0.995);
  --cui-table-striped-bg: rgba(205, 233, 215, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(198, 224, 208, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(201, 228, 212, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-info {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #d6ebff;
  --cui-table-border-color: rgba(198, 219, 238, 0.995);
  --cui-table-striped-bg: rgba(206, 227, 247, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(198, 219, 238, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(202, 223, 243, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-warning {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #feefd0;
  --cui-table-border-color: rgba(235, 222, 196, 0.995);
  --cui-table-striped-bg: rgba(244, 231, 202, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(235, 222, 196, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(240, 226, 199, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-danger {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #fadddd;
  --cui-table-border-color: rgba(231, 206, 208, 0.995);
  --cui-table-striped-bg: rgba(241, 214, 214, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(231, 206, 208, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(236, 210, 211, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-light {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #ebedef;
  --cui-table-border-color: rgba(218, 220, 224, 0.995);
  --cui-table-striped-bg: rgba(226, 229, 232, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(218, 220, 224, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(222, 225, 228, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-dark {
  --cui-table-color: #FFFFFF;
  --cui-table-bg: #818181;
  --cui-table-border-color: #8e8e8e;
  --cui-table-striped-bg: #878787;
  --cui-table-striped-color: #FFFFFF;
  --cui-table-active-bg: #8e8e8e;
  --cui-table-active-color: #463529;
  --cui-table-hover-bg: #8a8a8a;
  --cui-table-hover-color: #FFFFFF;
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
  color: var(--cui-form-label-color, );
}

.col-form-label {
  padding-top: calc(0.375rem + var(--cui-border-width));
  padding-bottom: calc(0.375rem + var(--cui-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
  color: var(--cui-form-label-color, );
}

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--cui-border-width));
  padding-bottom: calc(0.5rem + var(--cui-border-width));
  font-size: 1.25rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--cui-border-width));
  padding-bottom: calc(0.25rem + var(--cui-border-width));
  font-size: 0.875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--cui-form-text-color, var(--cui-secondary-color));
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--cui-input-color, var(--cui-body-color));
  appearance: none;
  background-color: var(--cui-input-bg, var(--cui-body-bg));
  background-clip: padding-box;
  border: var(--cui-border-width) solid var(--cui-input-border-color, var(--cui-border-color));
  border-radius: var(--cui-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--cui-input-focus-color, var(--cui-body-color));
  background-color: var(--cui-input-focus-bg, var(--cui-body-bg));
  border-color: var(--cui-input-focus-border-color, #998fed);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(50, 31, 219, 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: var(--cui-input-placeholder-color, var(--cui-secondary-color));
  opacity: 1;
}
.form-control:disabled {
  background-color: var(--cui-secondary-bg);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--cui-form-file-button-color, var(--cui-body-color));
  background-color: var(--cui-form-file-button-bg, var(--cui-tertiary-bg));
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--cui-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--cui-form-file-button-hover-bg, var(--cui-secondary-bg));
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--cui-input-plaintext-color, var(--cui-body-color));
  background-color: transparent;
  border: solid transparent;
  border-width: var(--cui-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--cui-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--cui-border-radius-sm);
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--cui-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--cui-border-radius-lg);
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(var(--cui-border-width) * 2));
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--cui-border-width) * 2));
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--cui-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(var(--cui-border-width) * 2));
  padding: 0.375rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--cui-border-radius);
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--cui-border-radius);
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--cui-border-width) * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--cui-border-width) * 2));
}

.form-select {
  --cui-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--cui-form-select-color, var(--cui-body-color));
  appearance: none;
  background-color: var(--cui-form-select-bg, var(--cui-body-bg));
  background-image: var(--cui-form-select-bg-img), var(--cui-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-size: 16px 12px;
  border: var(--cui-border-width) solid var(--cui-form-select-border-color, var(--cui-border-color));
  border-radius: var(--cui-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
html:not([dir=rtl]) .form-select {
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
}
*[dir=rtl] .form-select {
  padding: 0.375rem 0.75rem 0.375rem 2.25rem;
}
html:not([dir=rtl]) .form-select {
  background-position: right 0.75rem center;
}
*[dir=rtl] .form-select {
  background-position: left 0.75rem center;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: var(--cui-form-select-focus-border-color, #998fed);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(50, 31, 219, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  background-image: none;
}
html:not([dir=rtl]) .form-select[multiple], html:not([dir=rtl]) .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
}
*[dir=rtl] .form-select[multiple], *[dir=rtl] .form-select[size]:not([size="1"]) {
  padding-left: 0.75rem;
}
.form-select:disabled {
  color: var(--cui-form-select-disabled-color, );
  background-color: var(--cui-form-select-disabled-bg, var(--cui-secondary-bg));
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--cui-form-select-color, var(--cui-body-color));
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.875rem;
  border-radius: var(--cui-border-radius-sm);
}
html:not([dir=rtl]) .form-select-sm {
  padding-left: 0.5rem;
}
*[dir=rtl] .form-select-sm {
  padding-right: 0.5rem;
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 1.25rem;
  border-radius: var(--cui-border-radius-lg);
}
html:not([dir=rtl]) .form-select-lg {
  padding-left: 1rem;
}
*[dir=rtl] .form-select-lg {
  padding-right: 1rem;
}

.form-check {
  display: block;
  min-height: 1.5rem;
  margin-bottom: 0.125rem;
}
html:not([dir=rtl]) .form-check {
  padding-left: 1.5em;
}
*[dir=rtl] .form-check {
  padding-right: 1.5em;
}
html:not([dir=rtl]) .form-check .form-check-input {
  float: left;
}
*[dir=rtl] .form-check .form-check-input {
  float: right;
}
html:not([dir=rtl]) .form-check .form-check-input {
  margin-left: -1.5em;
}
*[dir=rtl] .form-check .form-check-input {
  margin-right: -1.5em;
}

html:not([dir=rtl]) .form-check-reverse {
  padding-right: 1.5em;
}
*[dir=rtl] .form-check-reverse {
  padding-left: 1.5em;
}
html:not([dir=rtl]) .form-check-reverse {
  padding-left: 0;
}
*[dir=rtl] .form-check-reverse {
  padding-right: 0;
}
html:not([dir=rtl]) .form-check-reverse {
  text-align: right;
}
*[dir=rtl] .form-check-reverse {
  text-align: left;
}
html:not([dir=rtl]) .form-check-reverse .form-check-input {
  float: right;
}
*[dir=rtl] .form-check-reverse .form-check-input {
  float: left;
}
html:not([dir=rtl]) .form-check-reverse .form-check-input {
  margin-right: -1.5em;
}
*[dir=rtl] .form-check-reverse .form-check-input {
  margin-left: -1.5em;
}
html:not([dir=rtl]) .form-check-reverse .form-check-input {
  margin-left: 0;
}
*[dir=rtl] .form-check-reverse .form-check-input {
  margin-right: 0;
}

.form-check-input {
  --cui-form-check-bg: var(--cui-body-bg);
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--cui-form-check-bg);
  background-image: var(--cui-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--cui-border-width) solid var(--cui-border-color);
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: #998fed;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(50, 31, 219, 0.25);
}
.form-check-input:checked {
  background-color: var(--cui-form-check-input-checked-bg-color, #321fdb);
  border-color: var(--cui-form-check-input-checked-border-color, #321fdb);
}
.form-check-input:checked[type=checkbox] {
  --cui-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.form-check-input:checked[type=radio] {
  --cui-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #321fdb;
  border-color: #321fdb;
  --cui-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-check-label {
  color: var(--cui-form-check-label-color, );
}

html:not([dir=rtl]) .form-switch {
  padding-left: 2.5em;
}
*[dir=rtl] .form-switch {
  padding-right: 2.5em;
}
.form-switch .form-check-input {
  --cui-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  width: 2em;
  background-image: var(--cui-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
html:not([dir=rtl]) .form-switch .form-check-input {
  margin-left: -2.5em;
}
*[dir=rtl] .form-switch .form-check-input {
  margin-right: -2.5em;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --cui-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --cui-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
html:not([dir=rtl]) .form-switch.form-check-reverse {
  padding-right: 1.5em;
}
*[dir=rtl] .form-switch.form-check-reverse {
  padding-left: 1.5em;
}
html:not([dir=rtl]) .form-switch.form-check-reverse {
  padding-left: 0;
}
*[dir=rtl] .form-switch.form-check-reverse {
  padding-right: 0;
}
html:not([dir=rtl]) .form-switch.form-check-reverse .form-check-input {
  margin-right: -1.5em;
}
*[dir=rtl] .form-switch.form-check-reverse .form-check-input {
  margin-left: -1.5em;
}
html:not([dir=rtl]) .form-switch.form-check-reverse .form-check-input {
  margin-left: 0;
}
*[dir=rtl] .form-switch.form-check-reverse .form-check-input {
  margin-right: 0;
}

.form-switch-lg {
  min-height: 1.25em;
}
html:not([dir=rtl]) .form-switch-lg {
  padding-left: 2.25em;
}
*[dir=rtl] .form-switch-lg {
  padding-right: 2.25em;
}
.form-switch-lg .form-check-input {
  width: 1.75em;
  height: 1.25em;
}
html:not([dir=rtl]) .form-switch-lg .form-check-input {
  margin-left: -2.25em;
}
*[dir=rtl] .form-switch-lg .form-check-input {
  margin-right: -2.25em;
}
.form-switch-lg .form-check-label {
  padding-top: calc((1.25em - 1rem) / 2);
}

.form-switch-xl {
  min-height: 1.5em;
}
html:not([dir=rtl]) .form-switch-xl {
  padding-left: 2.5em;
}
*[dir=rtl] .form-switch-xl {
  padding-right: 2.5em;
}
.form-switch-xl .form-check-input {
  width: 2em;
  height: 1.5em;
}
html:not([dir=rtl]) .form-switch-xl .form-check-input {
  margin-left: -2.5em;
}
*[dir=rtl] .form-switch-xl .form-check-input {
  margin-right: -2.5em;
}
.form-switch-xl .form-check-label {
  padding-top: calc((1.5em - 1rem) / 2);
}

.form-check-inline {
  display: inline-block;
}
html:not([dir=rtl]) .form-check-inline {
  margin-right: 1rem;
}
*[dir=rtl] .form-check-inline {
  margin-left: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #FFFFFF, 0 0 0 0.25rem rgba(50, 31, 219, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #FFFFFF, 0 0 0 0.25rem rgba(50, 31, 219, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: var(--cui-form-range-thumb-bg, #321fdb);
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: var(--cui-form-range-thumb-active-bg, #c2bcf4);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--cui-form-range-track-bg, var(--cui-tertiary-bg));
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: var(--cui-form-range-thumb-bg, #321fdb);
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: var(--cui-form-range-thumb-active-bg, #c2bcf4);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--cui-form-range-track-bg, var(--cui-tertiary-bg));
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--cui-form-range-thumb-disabled-bg, var(--cui-secondary-color));
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--cui-form-range-thumb-disabled-bg, var(--cui-secondary-color));
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(var(--cui-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--cui-border-width) * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--cui-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
html:not([dir=rtl]) .form-floating > label {
  left: 0;
}
*[dir=rtl] .form-floating > label {
  right: 0;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  color: rgba(var(--cui-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--cui-body-bg);
  border-radius: var(--cui-border-radius);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--cui-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: var(--cui-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #8a93a2;
}
.form-floating > :disabled ~ label::after,
.form-floating > .form-control:disabled ~ label::after {
  background-color: var(--cui-secondary-bg);
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--cui-input-group-addon-color, var(--cui-body-color));
  text-align: center;
  white-space: nowrap;
  background-color: var(--cui-input-group-addon-bg, var(--cui-tertiary-bg));
  border: var(--cui-border-width) solid var(--cui-input-group-addon-border-color, var(--cui-border-color));
  border-radius: var(--cui-border-radius);
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--cui-border-radius-lg);
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--cui-border-radius-sm);
}

html:not([dir=rtl]) .input-group-lg > .form-select,
html:not([dir=rtl]) .input-group-sm > .form-select {
  padding-right: 3rem;
}
*[dir=rtl] .input-group-lg > .form-select,
*[dir=rtl] .input-group-sm > .form-select {
  padding-left: 3rem;
}

html:not([dir=rtl]) .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
html:not([dir=rtl]) .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
html:not([dir=rtl]) .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
html:not([dir=rtl]) .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
}
*[dir=rtl] .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
*[dir=rtl] .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
*[dir=rtl] .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
*[dir=rtl] .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-left-radius: 0;
}
html:not([dir=rtl]) .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
html:not([dir=rtl]) .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
html:not([dir=rtl]) .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
html:not([dir=rtl]) .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-bottom-right-radius: 0;
}
*[dir=rtl] .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
*[dir=rtl] .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
*[dir=rtl] .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
*[dir=rtl] .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-bottom-left-radius: 0;
}
html:not([dir=rtl]) .input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
html:not([dir=rtl]) .input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
html:not([dir=rtl]) .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
html:not([dir=rtl]) .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
}
*[dir=rtl] .input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
*[dir=rtl] .input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
*[dir=rtl] .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
*[dir=rtl] .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-left-radius: 0;
}
html:not([dir=rtl]) .input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
html:not([dir=rtl]) .input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
html:not([dir=rtl]) .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
html:not([dir=rtl]) .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-bottom-right-radius: 0;
}
*[dir=rtl] .input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
*[dir=rtl] .input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
*[dir=rtl] .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
*[dir=rtl] .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-bottom-left-radius: 0;
}
html:not([dir=rtl]) .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(var(--cui-border-width) * -1);
}
*[dir=rtl] .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-right: calc(var(--cui-border-width) * -1);
}
html:not([dir=rtl]) .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  border-top-left-radius: 0;
}
*[dir=rtl] .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  border-top-right-radius: 0;
}
html:not([dir=rtl]) .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  border-bottom-left-radius: 0;
}
*[dir=rtl] .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  border-bottom-right-radius: 0;
}
html:not([dir=rtl]) .input-group > .form-floating:not(:first-child) > .form-control,
html:not([dir=rtl]) .input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
}
*[dir=rtl] .input-group > .form-floating:not(:first-child) > .form-control,
*[dir=rtl] .input-group > .form-floating:not(:first-child) > .form-select {
  border-top-right-radius: 0;
}
html:not([dir=rtl]) .input-group > .form-floating:not(:first-child) > .form-control,
html:not([dir=rtl]) .input-group > .form-floating:not(:first-child) > .form-select {
  border-bottom-left-radius: 0;
}
*[dir=rtl] .input-group > .form-floating:not(:first-child) > .form-control,
*[dir=rtl] .input-group > .form-floating:not(:first-child) > .form-select {
  border-bottom-right-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--cui-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--cui-success);
  border-radius: var(--cui-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--cui-form-valid-border-color);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
html:not([dir=rtl]) .was-validated .form-control:valid, html:not([dir=rtl]) .form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
}
*[dir=rtl] .was-validated .form-control:valid, *[dir=rtl] .form-control.is-valid {
  padding-left: calc(1.5em + 0.75rem);
}
html:not([dir=rtl]) .was-validated .form-control:valid, html:not([dir=rtl]) .form-control.is-valid {
  background-position: right calc(0.375em + 0.1875rem) center;
}
*[dir=rtl] .was-validated .form-control:valid, *[dir=rtl] .form-control.is-valid {
  background-position: left calc(0.375em + 0.1875rem) center;
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--cui-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-success-rgb), 0.25);
}

html:not([dir=rtl]) .was-validated textarea.form-control:valid, html:not([dir=rtl]) textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
}
*[dir=rtl] .was-validated textarea.form-control:valid, *[dir=rtl] textarea.form-control.is-valid {
  padding-left: calc(1.5em + 0.75rem);
}
html:not([dir=rtl]) .was-validated textarea.form-control:valid, html:not([dir=rtl]) textarea.form-control.is-valid {
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}
*[dir=rtl] .was-validated textarea.form-control:valid, *[dir=rtl] textarea.form-control.is-valid {
  background-position: top calc(0.375em + 0.1875rem) left calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--cui-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --cui-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
html:not([dir=rtl]) .was-validated .form-select:valid:not([multiple]):not([size]), html:not([dir=rtl]) .was-validated .form-select:valid:not([multiple])[size="1"], html:not([dir=rtl]) .form-select.is-valid:not([multiple]):not([size]), html:not([dir=rtl]) .form-select.is-valid:not([multiple])[size="1"] {
  padding-right: 4.125rem;
}
*[dir=rtl] .was-validated .form-select:valid:not([multiple]):not([size]), *[dir=rtl] .was-validated .form-select:valid:not([multiple])[size="1"], *[dir=rtl] .form-select.is-valid:not([multiple]):not([size]), *[dir=rtl] .form-select.is-valid:not([multiple])[size="1"] {
  padding-left: 4.125rem;
}
html:not([dir=rtl]) .was-validated .form-select:valid:not([multiple]):not([size]), html:not([dir=rtl]) .was-validated .form-select:valid:not([multiple])[size="1"], html:not([dir=rtl]) .form-select.is-valid:not([multiple]):not([size]), html:not([dir=rtl]) .form-select.is-valid:not([multiple])[size="1"] {
  background-position: right 0.75rem center, center right 2.25rem;
}
*[dir=rtl] .was-validated .form-select:valid:not([multiple]):not([size]), *[dir=rtl] .was-validated .form-select:valid:not([multiple])[size="1"], *[dir=rtl] .form-select.is-valid:not([multiple]):not([size]), *[dir=rtl] .form-select.is-valid:not([multiple])[size="1"] {
  background-position: left 0.75rem center, center left 2.25rem;
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--cui-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--cui-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--cui-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--cui-form-valid-color);
}

html:not([dir=rtl]) .form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}
*[dir=rtl] .form-check-inline .form-check-input ~ .valid-feedback {
  margin-right: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--cui-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--cui-danger);
  border-radius: var(--cui-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--cui-form-invalid-border-color);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
html:not([dir=rtl]) .was-validated .form-control:invalid, html:not([dir=rtl]) .form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
}
*[dir=rtl] .was-validated .form-control:invalid, *[dir=rtl] .form-control.is-invalid {
  padding-left: calc(1.5em + 0.75rem);
}
html:not([dir=rtl]) .was-validated .form-control:invalid, html:not([dir=rtl]) .form-control.is-invalid {
  background-position: right calc(0.375em + 0.1875rem) center;
}
*[dir=rtl] .was-validated .form-control:invalid, *[dir=rtl] .form-control.is-invalid {
  background-position: left calc(0.375em + 0.1875rem) center;
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--cui-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-danger-rgb), 0.25);
}

html:not([dir=rtl]) .was-validated textarea.form-control:invalid, html:not([dir=rtl]) textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
}
*[dir=rtl] .was-validated textarea.form-control:invalid, *[dir=rtl] textarea.form-control.is-invalid {
  padding-left: calc(1.5em + 0.75rem);
}
html:not([dir=rtl]) .was-validated textarea.form-control:invalid, html:not([dir=rtl]) textarea.form-control.is-invalid {
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}
*[dir=rtl] .was-validated textarea.form-control:invalid, *[dir=rtl] textarea.form-control.is-invalid {
  background-position: top calc(0.375em + 0.1875rem) left calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--cui-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --cui-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
html:not([dir=rtl]) .was-validated .form-select:invalid:not([multiple]):not([size]), html:not([dir=rtl]) .was-validated .form-select:invalid:not([multiple])[size="1"], html:not([dir=rtl]) .form-select.is-invalid:not([multiple]):not([size]), html:not([dir=rtl]) .form-select.is-invalid:not([multiple])[size="1"] {
  padding-right: 4.125rem;
}
*[dir=rtl] .was-validated .form-select:invalid:not([multiple]):not([size]), *[dir=rtl] .was-validated .form-select:invalid:not([multiple])[size="1"], *[dir=rtl] .form-select.is-invalid:not([multiple]):not([size]), *[dir=rtl] .form-select.is-invalid:not([multiple])[size="1"] {
  padding-left: 4.125rem;
}
html:not([dir=rtl]) .was-validated .form-select:invalid:not([multiple]):not([size]), html:not([dir=rtl]) .was-validated .form-select:invalid:not([multiple])[size="1"], html:not([dir=rtl]) .form-select.is-invalid:not([multiple]):not([size]), html:not([dir=rtl]) .form-select.is-invalid:not([multiple])[size="1"] {
  background-position: right 0.75rem center, center right 2.25rem;
}
*[dir=rtl] .was-validated .form-select:invalid:not([multiple]):not([size]), *[dir=rtl] .was-validated .form-select:invalid:not([multiple])[size="1"], *[dir=rtl] .form-select.is-invalid:not([multiple]):not([size]), *[dir=rtl] .form-select.is-invalid:not([multiple])[size="1"] {
  background-position: left 0.75rem center, center left 2.25rem;
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--cui-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--cui-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--cui-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--cui-form-invalid-color);
}

html:not([dir=rtl]) .form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}
*[dir=rtl] .form-check-inline .form-check-input ~ .invalid-feedback {
  margin-right: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --cui-btn-padding-x: 0.75rem;
  --cui-btn-padding-y: 0.375rem;
  --cui-btn-font-family: ;
  --cui-btn-font-size: 1rem;
  --cui-btn-font-weight: 400;
  --cui-btn-line-height: 1.5;
  --cui-btn-color: var(--cui-body-color);
  --cui-btn-bg: transparent;
  --cui-btn-border-width: var(--cui-border-width);
  --cui-btn-border-color: transparent;
  --cui-btn-border-radius: var(--cui-border-radius);
  --cui-btn-hover-border-color: transparent;
  --cui-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(70, 53, 41, 0.075);
  --cui-btn-disabled-opacity: 0.65;
  --cui-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--cui-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--cui-btn-padding-y) var(--cui-btn-padding-x);
  font-family: var(--cui-btn-font-family);
  font-size: var(--cui-btn-font-size);
  font-weight: var(--cui-btn-font-weight);
  line-height: var(--cui-btn-line-height);
  color: var(--cui-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--cui-btn-border-width) solid var(--cui-btn-border-color);
  border-radius: var(--cui-btn-border-radius);
  background-color: var(--cui-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--cui-btn-hover-color);
  background-color: var(--cui-btn-hover-bg);
  border-color: var(--cui-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--cui-btn-color);
  background-color: var(--cui-btn-bg);
  border-color: var(--cui-btn-border-color);
}
.btn:focus-visible {
  color: var(--cui-btn-hover-color);
  background-color: var(--cui-btn-hover-bg);
  border-color: var(--cui-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--cui-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--cui-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--cui-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--cui-btn-active-color);
  background-color: var(--cui-btn-active-bg);
  border-color: var(--cui-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--cui-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--cui-btn-disabled-color);
  pointer-events: none;
  background-color: var(--cui-btn-disabled-bg);
  border-color: var(--cui-btn-disabled-border-color);
  opacity: var(--cui-btn-disabled-opacity);
}

.btn-transparent {
  --cui-btn-active-border-color: transparent;
  --cui-btn-disabled-border-color: transparent;
  --cui-btn-hover-border-color: transparent;
}

.btn-primary {
  --cui-btn-color: rgba(255, 255, 255, 0.87);
  --cui-btn-bg: #321fdb;
  --cui-btn-border-color: #321fdb;
  --cui-btn-hover-color: rgba(255, 255, 255, 0.87);
  --cui-btn-hover-bg: #5141e0;
  --cui-btn-hover-border-color: #4735df;
  --cui-btn-focus-shadow-rgb: 75, 58, 223;
  --cui-btn-active-color: rgba(255, 255, 255, 0.87);
  --cui-btn-active-bg: #5b4ce2;
  --cui-btn-active-border-color: #4735df;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(70, 53, 41, 0.125);
  --cui-btn-disabled-color: rgba(255, 255, 255, 0.87);
  --cui-btn-disabled-bg: #321fdb;
  --cui-btn-disabled-border-color: #321fdb;
}

.btn-secondary {
  --cui-btn-color: #463529;
  --cui-btn-bg: #9da5b1;
  --cui-btn-border-color: #9da5b1;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-hover-bg: #acb3bd;
  --cui-btn-hover-border-color: #a7aeb9;
  --cui-btn-focus-shadow-rgb: 144, 148, 157;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #b1b7c1;
  --cui-btn-active-border-color: #a7aeb9;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(70, 53, 41, 0.125);
  --cui-btn-disabled-color: #463529;
  --cui-btn-disabled-bg: #9da5b1;
  --cui-btn-disabled-border-color: #9da5b1;
}

.btn-success {
  --cui-btn-color: #463529;
  --cui-btn-bg: #2eb85c;
  --cui-btn-border-color: #2eb85c;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-hover-bg: #4dc374;
  --cui-btn-hover-border-color: #43bf6c;
  --cui-btn-focus-shadow-rgb: 50, 164, 84;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #58c67d;
  --cui-btn-active-border-color: #43bf6c;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(70, 53, 41, 0.125);
  --cui-btn-disabled-color: #463529;
  --cui-btn-disabled-bg: #2eb85c;
  --cui-btn-disabled-border-color: #2eb85c;
}

.btn-danger {
  --cui-btn-color: #FFFFFF;
  --cui-btn-bg: #e55353;
  --cui-btn-border-color: #e55353;
  --cui-btn-hover-color: #463529;
  --cui-btn-hover-bg: #e96d6d;
  --cui-btn-hover-border-color: #e86464;
  --cui-btn-focus-shadow-rgb: 233, 109, 109;
  --cui-btn-active-color: #463529;
  --cui-btn-active-bg: #ea7575;
  --cui-btn-active-border-color: #e86464;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(70, 53, 41, 0.125);
  --cui-btn-disabled-color: #FFFFFF;
  --cui-btn-disabled-bg: #e55353;
  --cui-btn-disabled-border-color: #e55353;
}

.btn-warning {
  --cui-btn-color: rgba(44, 56, 74, 0.95);
  --cui-btn-bg: #f9b115;
  --cui-btn-border-color: #f9b115;
  --cui-btn-hover-color: #463529;
  --cui-btn-hover-bg: #d49612;
  --cui-btn-hover-border-color: #c78e11;
  --cui-btn-focus-shadow-rgb: 221, 160, 28;
  --cui-btn-active-color: #463529;
  --cui-btn-active-bg: #c78e11;
  --cui-btn-active-border-color: #bb8510;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(70, 53, 41, 0.125);
  --cui-btn-disabled-color: rgba(44, 56, 74, 0.95);
  --cui-btn-disabled-bg: #f9b115;
  --cui-btn-disabled-border-color: #f9b115;
}

.btn-info {
  --cui-btn-color: #463529;
  --cui-btn-bg: #39f;
  --cui-btn-border-color: #39f;
  --cui-btn-hover-color: #463529;
  --cui-btn-hover-bg: #52a8ff;
  --cui-btn-hover-border-color: #47a3ff;
  --cui-btn-focus-shadow-rgb: 54, 138, 223;
  --cui-btn-active-color: #463529;
  --cui-btn-active-bg: #5cadff;
  --cui-btn-active-border-color: #47a3ff;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(70, 53, 41, 0.125);
  --cui-btn-disabled-color: #463529;
  --cui-btn-disabled-bg: #39f;
  --cui-btn-disabled-border-color: #39f;
}

.btn-light {
  --cui-btn-color: rgba(44, 56, 74, 0.95);
  --cui-btn-bg: #ebedef;
  --cui-btn-border-color: #ebedef;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-hover-bg: #c8c9cb;
  --cui-btn-hover-border-color: #bcbebf;
  --cui-btn-focus-shadow-rgb: 209, 212, 216;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #bcbebf;
  --cui-btn-active-border-color: #b0b2b3;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(70, 53, 41, 0.125);
  --cui-btn-disabled-color: rgba(44, 56, 74, 0.95);
  --cui-btn-disabled-bg: #ebedef;
  --cui-btn-disabled-border-color: #ebedef;
}

.btn-dark {
  --cui-btn-color: #FFFFFF;
  --cui-btn-bg: #818181;
  --cui-btn-border-color: #818181;
  --cui-btn-hover-color: #463529;
  --cui-btn-hover-bg: #949494;
  --cui-btn-hover-border-color: #8e8e8e;
  --cui-btn-focus-shadow-rgb: 148, 148, 148;
  --cui-btn-active-color: #463529;
  --cui-btn-active-bg: #9a9a9a;
  --cui-btn-active-border-color: #8e8e8e;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(70, 53, 41, 0.125);
  --cui-btn-disabled-color: #FFFFFF;
  --cui-btn-disabled-bg: #818181;
  --cui-btn-disabled-border-color: #818181;
}

.btn-outline-primary {
  --cui-btn-color: #321fdb;
  --cui-btn-border-color: #321fdb;
  --cui-btn-hover-color: rgba(255, 255, 255, 0.87);
  --cui-btn-hover-bg: #5b4ce2;
  --cui-btn-hover-border-color: #4735df;
  --cui-btn-focus-shadow-rgb: 50, 31, 219;
  --cui-btn-active-color: rgba(255, 255, 255, 0.87);
  --cui-btn-active-bg: #5b4ce2;
  --cui-btn-active-border-color: #4735df;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(70, 53, 41, 0.125);
  --cui-btn-disabled-color: #321fdb;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-secondary {
  --cui-btn-color: #9da5b1;
  --cui-btn-border-color: #9da5b1;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-hover-bg: #b1b7c1;
  --cui-btn-hover-border-color: #a7aeb9;
  --cui-btn-focus-shadow-rgb: 157, 165, 177;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #b1b7c1;
  --cui-btn-active-border-color: #a7aeb9;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(70, 53, 41, 0.125);
  --cui-btn-disabled-color: #9da5b1;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-success {
  --cui-btn-color: #2eb85c;
  --cui-btn-border-color: #2eb85c;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-hover-bg: #58c67d;
  --cui-btn-hover-border-color: #43bf6c;
  --cui-btn-focus-shadow-rgb: 46, 184, 92;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #58c67d;
  --cui-btn-active-border-color: #43bf6c;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(70, 53, 41, 0.125);
  --cui-btn-disabled-color: #2eb85c;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-danger {
  --cui-btn-color: #e55353;
  --cui-btn-border-color: #e55353;
  --cui-btn-hover-color: #463529;
  --cui-btn-hover-bg: #ea7575;
  --cui-btn-hover-border-color: #e86464;
  --cui-btn-focus-shadow-rgb: 229, 83, 83;
  --cui-btn-active-color: #463529;
  --cui-btn-active-bg: #ea7575;
  --cui-btn-active-border-color: #e86464;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(70, 53, 41, 0.125);
  --cui-btn-disabled-color: #e55353;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-warning {
  --cui-btn-color: #f9b115;
  --cui-btn-border-color: #f9b115;
  --cui-btn-hover-color: #463529;
  --cui-btn-hover-bg: #c78e11;
  --cui-btn-hover-border-color: #bb8510;
  --cui-btn-focus-shadow-rgb: 249, 177, 21;
  --cui-btn-active-color: #463529;
  --cui-btn-active-bg: #c78e11;
  --cui-btn-active-border-color: #bb8510;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(70, 53, 41, 0.125);
  --cui-btn-disabled-color: #f9b115;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-info {
  --cui-btn-color: #39f;
  --cui-btn-border-color: #39f;
  --cui-btn-hover-color: #463529;
  --cui-btn-hover-bg: #5cadff;
  --cui-btn-hover-border-color: #47a3ff;
  --cui-btn-focus-shadow-rgb: 51, 153, 255;
  --cui-btn-active-color: #463529;
  --cui-btn-active-bg: #5cadff;
  --cui-btn-active-border-color: #47a3ff;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(70, 53, 41, 0.125);
  --cui-btn-disabled-color: #39f;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-light {
  --cui-btn-color: #ebedef;
  --cui-btn-border-color: #ebedef;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-hover-bg: #bcbebf;
  --cui-btn-hover-border-color: #b0b2b3;
  --cui-btn-focus-shadow-rgb: 235, 237, 239;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #bcbebf;
  --cui-btn-active-border-color: #b0b2b3;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(70, 53, 41, 0.125);
  --cui-btn-disabled-color: #ebedef;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-dark {
  --cui-btn-color: #818181;
  --cui-btn-border-color: #818181;
  --cui-btn-hover-color: #463529;
  --cui-btn-hover-bg: #9a9a9a;
  --cui-btn-hover-border-color: #8e8e8e;
  --cui-btn-focus-shadow-rgb: 129, 129, 129;
  --cui-btn-active-color: #463529;
  --cui-btn-active-bg: #9a9a9a;
  --cui-btn-active-border-color: #8e8e8e;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(70, 53, 41, 0.125);
  --cui-btn-disabled-color: #818181;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-ghost-primary {
  --cui-btn-color: #321fdb;
  --cui-btn-hover-bg: #5141e0;
  --cui-btn-hover-border-color: #4735df;
  --cui-btn-hover-color: rgba(255, 255, 255, 0.87);
  --cui-btn-active-bg: #5b4ce2;
  --cui-btn-active-border-color: #4735df;
  --cui-btn-active-color: rgba(255, 255, 255, 0.87);
  --cui-btn-disabled-color: #321fdb;
  --cui-btn-shadow: rgba(50, 31, 219, 0.5);
}

.btn-ghost-secondary {
  --cui-btn-color: #9da5b1;
  --cui-btn-hover-bg: #acb3bd;
  --cui-btn-hover-border-color: #a7aeb9;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #b1b7c1;
  --cui-btn-active-border-color: #a7aeb9;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-disabled-color: #9da5b1;
  --cui-btn-shadow: rgba(157, 165, 177, 0.5);
}

.btn-ghost-success {
  --cui-btn-color: #2eb85c;
  --cui-btn-hover-bg: #4dc374;
  --cui-btn-hover-border-color: #43bf6c;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #58c67d;
  --cui-btn-active-border-color: #43bf6c;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-disabled-color: #2eb85c;
  --cui-btn-shadow: rgba(46, 184, 92, 0.5);
}

.btn-ghost-danger {
  --cui-btn-color: #e55353;
  --cui-btn-hover-bg: #e96d6d;
  --cui-btn-hover-border-color: #e86464;
  --cui-btn-hover-color: #463529;
  --cui-btn-active-bg: #ea7575;
  --cui-btn-active-border-color: #e86464;
  --cui-btn-active-color: #463529;
  --cui-btn-disabled-color: #e55353;
  --cui-btn-shadow: rgba(229, 83, 83, 0.5);
}

.btn-ghost-warning {
  --cui-btn-color: #f9b115;
  --cui-btn-hover-bg: #d49612;
  --cui-btn-hover-border-color: #c78e11;
  --cui-btn-hover-color: #463529;
  --cui-btn-active-bg: #c78e11;
  --cui-btn-active-border-color: #bb8510;
  --cui-btn-active-color: #463529;
  --cui-btn-disabled-color: #f9b115;
  --cui-btn-shadow: rgba(249, 177, 21, 0.5);
}

.btn-ghost-info {
  --cui-btn-color: #39f;
  --cui-btn-hover-bg: #52a8ff;
  --cui-btn-hover-border-color: #47a3ff;
  --cui-btn-hover-color: #463529;
  --cui-btn-active-bg: #5cadff;
  --cui-btn-active-border-color: #47a3ff;
  --cui-btn-active-color: #463529;
  --cui-btn-disabled-color: #39f;
  --cui-btn-shadow: rgba(51, 153, 255, 0.5);
}

.btn-ghost-light {
  --cui-btn-color: #ebedef;
  --cui-btn-hover-bg: #c8c9cb;
  --cui-btn-hover-border-color: #bcbebf;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #bcbebf;
  --cui-btn-active-border-color: #b0b2b3;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-disabled-color: #ebedef;
  --cui-btn-shadow: rgba(235, 237, 239, 0.5);
}

.btn-ghost-dark {
  --cui-btn-color: #818181;
  --cui-btn-hover-bg: #949494;
  --cui-btn-hover-border-color: #8e8e8e;
  --cui-btn-hover-color: #463529;
  --cui-btn-active-bg: #9a9a9a;
  --cui-btn-active-border-color: #8e8e8e;
  --cui-btn-active-color: #463529;
  --cui-btn-disabled-color: #818181;
  --cui-btn-shadow: rgba(129, 129, 129, 0.5);
}

.btn-link {
  --cui-btn-font-weight: 400;
  --cui-btn-color: var(--cui-link-color);
  --cui-btn-bg: transparent;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-color: var(--cui-link-hover-color);
  --cui-btn-hover-border-color: transparent;
  --cui-btn-active-border-color: transparent;
  --cui-btn-disabled-color: #8a93a2;
  --cui-btn-disabled-border-color: transparent;
  --cui-btn-box-shadow: none;
  --cui-btn-focus-shadow-rgb: 75, 58, 223;
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--cui-btn-color);
}

.btn-lg, .btn-group-lg > .btn {
  --cui-btn-padding-y: 0.5rem;
  --cui-btn-padding-x: 1rem;
  --cui-btn-font-size: 1.25rem;
  --cui-btn-border-radius: var(--cui-border-radius-lg);
}

.btn-sm, .btn-group-sm > .btn {
  --cui-btn-padding-y: 0.25rem;
  --cui-btn-padding-x: 0.5rem;
  --cui-btn-font-size: 0.875rem;
  --cui-btn-border-radius: var(--cui-border-radius-sm);
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
html:not([dir=rtl]) .dropdown-toggle::after {
  margin-left: 0.255em;
}
*[dir=rtl] .dropdown-toggle::after {
  margin-right: 0.255em;
}
html:not([dir=rtl]) .dropdown-toggle:empty::after {
  margin-left: 0;
}
*[dir=rtl] .dropdown-toggle:empty::after {
  margin-right: 0;
}

.dropdown-menu {
  --cui-dropdown-zindex: 1000;
  --cui-dropdown-min-width: 10rem;
  --cui-dropdown-padding-x: 0;
  --cui-dropdown-padding-y: 0.5rem;
  --cui-dropdown-spacer: 0.125rem;
  --cui-dropdown-font-size: 1rem;
  --cui-dropdown-color: var(--cui-body-color);
  --cui-dropdown-bg: var(--cui-body-bg);
  --cui-dropdown-border-color: var(--cui-border-color-translucent);
  --cui-dropdown-border-radius: var(--cui-border-radius);
  --cui-dropdown-border-width: var(--cui-border-width);
  --cui-dropdown-inner-border-radius: calc(var(--cui-border-radius) - var(--cui-border-width));
  --cui-dropdown-divider-bg: var(--cui-border-color-translucent);
  --cui-dropdown-divider-margin-y: 0.5rem;
  --cui-dropdown-box-shadow: 0 0.5rem 1rem rgba(70, 53, 41, 0.15);
  --cui-dropdown-link-color: var(--cui-body-color);
  --cui-dropdown-link-hover-color: var(--cui-body-color);
  --cui-dropdown-link-hover-bg: var(--cui-tertiary-bg);
  --cui-dropdown-link-active-color: rgba(255, 255, 255, 0.87);
  --cui-dropdown-link-active-bg: #321fdb;
  --cui-dropdown-link-disabled-color: var(--cui-tertiary-color);
  --cui-dropdown-item-padding-x: 1rem;
  --cui-dropdown-item-padding-y: 0.25rem;
  --cui-dropdown-header-color: #8a93a2;
  --cui-dropdown-header-padding-x: 1rem;
  --cui-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--cui-dropdown-zindex);
  display: none;
  min-width: var(--cui-dropdown-min-width);
  padding: var(--cui-dropdown-padding-y) var(--cui-dropdown-padding-x);
  margin: 0;
  font-size: var(--cui-dropdown-font-size);
  color: var(--cui-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--cui-dropdown-bg);
  background-clip: padding-box;
  border: var(--cui-dropdown-border-width) solid var(--cui-dropdown-border-color);
  border-radius: var(--cui-dropdown-border-radius);
}
.dropdown-menu[data-coreui-popper] {
  top: 100%;
  margin-top: var(--cui-dropdown-spacer);
}
html:not([dir=rtl]) .dropdown-menu[data-coreui-popper] {
  left: 0;
}
*[dir=rtl] .dropdown-menu[data-coreui-popper] {
  right: 0;
}

.dropdown-menu-start {
  --cui-position: start;
}
html:not([dir=rtl]) .dropdown-menu-start[data-coreui-popper] {
  right: auto;
}
*[dir=rtl] .dropdown-menu-start[data-coreui-popper] {
  left: auto;
}
html:not([dir=rtl]) .dropdown-menu-start[data-coreui-popper] {
  left: 0;
}
*[dir=rtl] .dropdown-menu-start[data-coreui-popper] {
  right: 0;
}

.dropdown-menu-end {
  --cui-position: end;
}
html:not([dir=rtl]) .dropdown-menu-end[data-coreui-popper] {
  right: 0;
}
*[dir=rtl] .dropdown-menu-end[data-coreui-popper] {
  left: 0;
}
html:not([dir=rtl]) .dropdown-menu-end[data-coreui-popper] {
  left: auto;
}
*[dir=rtl] .dropdown-menu-end[data-coreui-popper] {
  right: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --cui-position: start;
  }
  html:not([dir=rtl]) .dropdown-menu-sm-start[data-coreui-popper] {
    right: auto;
  }
  *[dir=rtl] .dropdown-menu-sm-start[data-coreui-popper] {
    left: auto;
  }
  html:not([dir=rtl]) .dropdown-menu-sm-start[data-coreui-popper] {
    left: 0;
  }
  *[dir=rtl] .dropdown-menu-sm-start[data-coreui-popper] {
    right: 0;
  }
  .dropdown-menu-sm-end {
    --cui-position: end;
  }
  html:not([dir=rtl]) .dropdown-menu-sm-end[data-coreui-popper] {
    right: 0;
  }
  *[dir=rtl] .dropdown-menu-sm-end[data-coreui-popper] {
    left: 0;
  }
  html:not([dir=rtl]) .dropdown-menu-sm-end[data-coreui-popper] {
    left: auto;
  }
  *[dir=rtl] .dropdown-menu-sm-end[data-coreui-popper] {
    right: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --cui-position: start;
  }
  html:not([dir=rtl]) .dropdown-menu-md-start[data-coreui-popper] {
    right: auto;
  }
  *[dir=rtl] .dropdown-menu-md-start[data-coreui-popper] {
    left: auto;
  }
  html:not([dir=rtl]) .dropdown-menu-md-start[data-coreui-popper] {
    left: 0;
  }
  *[dir=rtl] .dropdown-menu-md-start[data-coreui-popper] {
    right: 0;
  }
  .dropdown-menu-md-end {
    --cui-position: end;
  }
  html:not([dir=rtl]) .dropdown-menu-md-end[data-coreui-popper] {
    right: 0;
  }
  *[dir=rtl] .dropdown-menu-md-end[data-coreui-popper] {
    left: 0;
  }
  html:not([dir=rtl]) .dropdown-menu-md-end[data-coreui-popper] {
    left: auto;
  }
  *[dir=rtl] .dropdown-menu-md-end[data-coreui-popper] {
    right: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --cui-position: start;
  }
  html:not([dir=rtl]) .dropdown-menu-lg-start[data-coreui-popper] {
    right: auto;
  }
  *[dir=rtl] .dropdown-menu-lg-start[data-coreui-popper] {
    left: auto;
  }
  html:not([dir=rtl]) .dropdown-menu-lg-start[data-coreui-popper] {
    left: 0;
  }
  *[dir=rtl] .dropdown-menu-lg-start[data-coreui-popper] {
    right: 0;
  }
  .dropdown-menu-lg-end {
    --cui-position: end;
  }
  html:not([dir=rtl]) .dropdown-menu-lg-end[data-coreui-popper] {
    right: 0;
  }
  *[dir=rtl] .dropdown-menu-lg-end[data-coreui-popper] {
    left: 0;
  }
  html:not([dir=rtl]) .dropdown-menu-lg-end[data-coreui-popper] {
    left: auto;
  }
  *[dir=rtl] .dropdown-menu-lg-end[data-coreui-popper] {
    right: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --cui-position: start;
  }
  html:not([dir=rtl]) .dropdown-menu-xl-start[data-coreui-popper] {
    right: auto;
  }
  *[dir=rtl] .dropdown-menu-xl-start[data-coreui-popper] {
    left: auto;
  }
  html:not([dir=rtl]) .dropdown-menu-xl-start[data-coreui-popper] {
    left: 0;
  }
  *[dir=rtl] .dropdown-menu-xl-start[data-coreui-popper] {
    right: 0;
  }
  .dropdown-menu-xl-end {
    --cui-position: end;
  }
  html:not([dir=rtl]) .dropdown-menu-xl-end[data-coreui-popper] {
    right: 0;
  }
  *[dir=rtl] .dropdown-menu-xl-end[data-coreui-popper] {
    left: 0;
  }
  html:not([dir=rtl]) .dropdown-menu-xl-end[data-coreui-popper] {
    left: auto;
  }
  *[dir=rtl] .dropdown-menu-xl-end[data-coreui-popper] {
    right: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --cui-position: start;
  }
  html:not([dir=rtl]) .dropdown-menu-xxl-start[data-coreui-popper] {
    right: auto;
  }
  *[dir=rtl] .dropdown-menu-xxl-start[data-coreui-popper] {
    left: auto;
  }
  html:not([dir=rtl]) .dropdown-menu-xxl-start[data-coreui-popper] {
    left: 0;
  }
  *[dir=rtl] .dropdown-menu-xxl-start[data-coreui-popper] {
    right: 0;
  }
  .dropdown-menu-xxl-end {
    --cui-position: end;
  }
  html:not([dir=rtl]) .dropdown-menu-xxl-end[data-coreui-popper] {
    right: 0;
  }
  *[dir=rtl] .dropdown-menu-xxl-end[data-coreui-popper] {
    left: 0;
  }
  html:not([dir=rtl]) .dropdown-menu-xxl-end[data-coreui-popper] {
    left: auto;
  }
  *[dir=rtl] .dropdown-menu-xxl-end[data-coreui-popper] {
    right: auto;
  }
}
.dropup .dropdown-menu[data-coreui-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--cui-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
html:not([dir=rtl]) .dropup .dropdown-toggle::after {
  margin-left: 0.255em;
}
*[dir=rtl] .dropup .dropdown-toggle::after {
  margin-right: 0.255em;
}
html:not([dir=rtl]) .dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}
*[dir=rtl] .dropup .dropdown-toggle:empty::after {
  margin-right: 0;
}

.dropend .dropdown-menu[data-coreui-popper] {
  top: 0;
  margin-top: 0;
}
html:not([dir=rtl]) .dropend .dropdown-menu[data-coreui-popper] {
  right: auto;
}
*[dir=rtl] .dropend .dropdown-menu[data-coreui-popper] {
  left: auto;
}
html:not([dir=rtl]) .dropend .dropdown-menu[data-coreui-popper] {
  left: 100%;
}
*[dir=rtl] .dropend .dropdown-menu[data-coreui-popper] {
  right: 100%;
}
html:not([dir=rtl]) .dropend .dropdown-menu[data-coreui-popper] {
  margin-left: var(--cui-dropdown-spacer);
}
*[dir=rtl] .dropend .dropdown-menu[data-coreui-popper] {
  margin-right: var(--cui-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
html:not([dir=rtl]) .dropend .dropdown-toggle::after {
  margin-left: 0.255em;
}
*[dir=rtl] .dropend .dropdown-toggle::after {
  margin-right: 0.255em;
}
html:not([dir=rtl]) .dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
*[dir=rtl] .dropend .dropdown-toggle:empty::after {
  margin-right: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-coreui-popper] {
  top: 0;
  margin-top: 0;
}
html:not([dir=rtl]) .dropstart .dropdown-menu[data-coreui-popper] {
  right: 100%;
}
*[dir=rtl] .dropstart .dropdown-menu[data-coreui-popper] {
  left: 100%;
}
html:not([dir=rtl]) .dropstart .dropdown-menu[data-coreui-popper] {
  left: auto;
}
*[dir=rtl] .dropstart .dropdown-menu[data-coreui-popper] {
  right: auto;
}
html:not([dir=rtl]) .dropstart .dropdown-menu[data-coreui-popper] {
  margin-right: var(--cui-dropdown-spacer);
}
*[dir=rtl] .dropstart .dropdown-menu[data-coreui-popper] {
  margin-left: var(--cui-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  vertical-align: 0.255em;
  content: "";
}
html:not([dir=rtl]) .dropstart .dropdown-toggle::after {
  margin-left: 0.255em;
}
*[dir=rtl] .dropstart .dropdown-toggle::after {
  margin-right: 0.255em;
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
html:not([dir=rtl]) .dropstart .dropdown-toggle::before {
  margin-right: 0.255em;
}
*[dir=rtl] .dropstart .dropdown-toggle::before {
  margin-left: 0.255em;
}
html:not([dir=rtl]) .dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
*[dir=rtl] .dropstart .dropdown-toggle:empty::after {
  margin-right: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--cui-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--cui-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--cui-dropdown-item-padding-y) var(--cui-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--cui-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--cui-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--cui-dropdown-link-hover-color);
  background-color: var(--cui-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--cui-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--cui-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--cui-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--cui-dropdown-header-padding-y) var(--cui-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--cui-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--cui-dropdown-item-padding-y) var(--cui-dropdown-item-padding-x);
  color: var(--cui-dropdown-link-color);
}

.dropdown-menu-dark {
  --cui-dropdown-color: #c4c9d0;
  --cui-dropdown-bg: #636f83;
  --cui-dropdown-border-color: var(--cui-border-color-translucent);
  --cui-dropdown-box-shadow: ;
  --cui-dropdown-link-color: #c4c9d0;
  --cui-dropdown-link-hover-color: rgba(255, 255, 255, 0.87);
  --cui-dropdown-divider-bg: var(--cui-border-color-translucent);
  --cui-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --cui-dropdown-link-active-color: rgba(255, 255, 255, 0.87);
  --cui-dropdown-link-active-bg: #321fdb;
  --cui-dropdown-link-disabled-color: #9da5b1;
  --cui-dropdown-header-color: #9da5b1;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: var(--cui-border-radius);
}
html:not([dir=rtl]) .btn-group > :not(.btn-check:first-child) + .btn,
html:not([dir=rtl]) .btn-group > .btn-group:not(:first-child) {
  margin-left: calc(var(--cui-border-width) * -1);
}
*[dir=rtl] .btn-group > :not(.btn-check:first-child) + .btn,
*[dir=rtl] .btn-group > .btn-group:not(:first-child) {
  margin-right: calc(var(--cui-border-width) * -1);
}
html:not([dir=rtl]) .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
html:not([dir=rtl]) .btn-group > .btn.dropdown-toggle-split:first-child,
html:not([dir=rtl]) .btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
}
*[dir=rtl] .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
*[dir=rtl] .btn-group > .btn.dropdown-toggle-split:first-child,
*[dir=rtl] .btn-group > .btn-group:not(:last-child) > .btn {
  border-top-left-radius: 0;
}
html:not([dir=rtl]) .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
html:not([dir=rtl]) .btn-group > .btn.dropdown-toggle-split:first-child,
html:not([dir=rtl]) .btn-group > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
}
*[dir=rtl] .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
*[dir=rtl] .btn-group > .btn.dropdown-toggle-split:first-child,
*[dir=rtl] .btn-group > .btn-group:not(:last-child) > .btn {
  border-bottom-left-radius: 0;
}
html:not([dir=rtl]) .btn-group > .btn:nth-child(n+3),
html:not([dir=rtl]) .btn-group > :not(.btn-check) + .btn,
html:not([dir=rtl]) .btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
}
*[dir=rtl] .btn-group > .btn:nth-child(n+3),
*[dir=rtl] .btn-group > :not(.btn-check) + .btn,
*[dir=rtl] .btn-group > .btn-group:not(:first-child) > .btn {
  border-top-right-radius: 0;
}
html:not([dir=rtl]) .btn-group > .btn:nth-child(n+3),
html:not([dir=rtl]) .btn-group > :not(.btn-check) + .btn,
html:not([dir=rtl]) .btn-group > .btn-group:not(:first-child) > .btn {
  border-bottom-left-radius: 0;
}
*[dir=rtl] .btn-group > .btn:nth-child(n+3),
*[dir=rtl] .btn-group > :not(.btn-check) + .btn,
*[dir=rtl] .btn-group > .btn-group:not(:first-child) > .btn {
  border-bottom-right-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
html:not([dir=rtl]) .dropdown-toggle-split::after, html:not([dir=rtl]) .dropup .dropdown-toggle-split::after, html:not([dir=rtl]) .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
*[dir=rtl] .dropdown-toggle-split::after, *[dir=rtl] .dropup .dropdown-toggle-split::after, *[dir=rtl] .dropend .dropdown-toggle-split::after {
  margin-right: 0;
}
html:not([dir=rtl]) .dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}
*[dir=rtl] .dropstart .dropdown-toggle-split::before {
  margin-left: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(var(--cui-border-width) * -1);
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --cui-nav-link-padding-x: 1rem;
  --cui-nav-link-padding-y: 0.5rem;
  --cui-nav-link-font-weight: ;
  --cui-nav-link-color: var(--cui-link-color);
  --cui-nav-link-hover-color: var(--cui-link-hover-color);
  --cui-nav-link-disabled-color: var(--cui-secondary-color);
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0;
  list-style: none;
}
html:not([dir=rtl]) .nav {
  padding-left: 0;
}
*[dir=rtl] .nav {
  padding-right: 0;
}

.nav-link {
  display: block;
  padding: var(--cui-nav-link-padding-y) var(--cui-nav-link-padding-x);
  font-size: var(--cui-nav-link-font-size);
  font-weight: var(--cui-nav-link-font-weight);
  color: var(--cui-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--cui-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(50, 31, 219, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--cui-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --cui-nav-tabs-border-width: var(--cui-border-width);
  --cui-nav-tabs-border-color: var(--cui-border-color);
  --cui-nav-tabs-border-radius: var(--cui-border-radius);
  --cui-nav-tabs-link-hover-border-color: var(--cui-secondary-bg) var(--cui-secondary-bg) var(--cui-border-color);
  --cui-nav-tabs-link-active-color: var(--cui-emphasis-color);
  --cui-nav-tabs-link-active-bg: var(--cui-body-bg);
  --cui-nav-tabs-link-active-border-color: var(--cui-border-color) var(--cui-border-color) var(--cui-body-bg);
  border-bottom: var(--cui-nav-tabs-border-width) solid var(--cui-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--cui-nav-tabs-border-width));
  border: var(--cui-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--cui-nav-tabs-border-radius);
  border-top-right-radius: var(--cui-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--cui-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--cui-nav-tabs-link-active-color);
  background-color: var(--cui-nav-tabs-link-active-bg);
  border-color: var(--cui-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--cui-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --cui-nav-pills-border-radius: var(--cui-border-radius);
  --cui-nav-pills-link-active-color: rgba(255, 255, 255, 0.87);
  --cui-nav-pills-link-active-bg: #321fdb;
}
.nav-pills .nav-link {
  border-radius: var(--cui-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--cui-nav-pills-link-active-color);
  background-color: var(--cui-nav-pills-link-active-bg);
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --cui-navbar-padding-x: 0;
  --cui-navbar-padding-y: 0.5rem;
  --cui-navbar-color: rgba(var(--cui-emphasis-color-rgb), 0.65);
  --cui-navbar-hover-color: rgba(var(--cui-emphasis-color-rgb), 0.8);
  --cui-navbar-disabled-color: rgba(var(--cui-emphasis-color-rgb), 0.3);
  --cui-navbar-active-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-navbar-brand-padding-y: 0.3125rem;
  --cui-navbar-brand-margin-end: 1rem;
  --cui-navbar-brand-font-size: 1.25rem;
  --cui-navbar-brand-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-navbar-brand-hover-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-navbar-nav-link-padding-x: 0.5rem;
  --cui-navbar-toggler-padding-y: 0.25rem;
  --cui-navbar-toggler-padding-x: 0.75rem;
  --cui-navbar-toggler-font-size: 1.25rem;
  --cui-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  --cui-navbar-toggler-border-color: rgba(var(--cui-emphasis-color-rgb), 0.15);
  --cui-navbar-toggler-border-radius: var(--cui-border-radius);
  --cui-navbar-toggler-focus-width: 0.25rem;
  --cui-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--cui-navbar-padding-y) var(--cui-navbar-padding-x);
}
.navbar .header > .container,
.navbar .header > .container-fluid,
.navbar .header > .container-sm,
.navbar .header > .container-md,
.navbar .header > .container-lg,
.navbar .header > .container-xl,
.navbar .header > .container-xxl, .navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--cui-navbar-brand-padding-y);
  padding-bottom: var(--cui-navbar-brand-padding-y);
  font-size: var(--cui-navbar-brand-font-size);
  color: var(--cui-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
html:not([dir=rtl]) .navbar-brand {
  margin-right: var(--cui-navbar-brand-margin-end);
}
*[dir=rtl] .navbar-brand {
  margin-left: var(--cui-navbar-brand-margin-end);
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--cui-navbar-brand-hover-color);
}

.navbar-nav {
  --cui-nav-link-padding-x: 0;
  --cui-nav-link-padding-y: 0.5rem;
  --cui-nav-link-font-weight: ;
  --cui-nav-link-color: var(--cui-navbar-color);
  --cui-nav-link-hover-color: var(--cui-navbar-hover-color);
  --cui-nav-link-disabled-color: var(--cui-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  list-style: none;
}
html:not([dir=rtl]) .navbar-nav {
  padding-left: 0;
}
*[dir=rtl] .navbar-nav {
  padding-right: 0;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--cui-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--cui-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--cui-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--cui-navbar-toggler-padding-y) var(--cui-navbar-toggler-padding-x);
  font-size: var(--cui-navbar-toggler-font-size);
  line-height: 1;
  color: var(--cui-navbar-color);
  background-color: transparent;
  border: var(--cui-border-width) solid var(--cui-navbar-toggler-border-color);
  border-radius: var(--cui-navbar-toggler-border-radius);
  transition: var(--cui-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--cui-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--cui-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--cui-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--cui-navbar-nav-link-padding-x);
  padding-left: var(--cui-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark {
  --cui-navbar-color: rgba(255, 255, 255, 0.55);
  --cui-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --cui-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --cui-navbar-active-color: #FFFFFF;
  --cui-navbar-brand-color: #FFFFFF;
  --cui-navbar-brand-hover-color: #FFFFFF;
  --cui-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --cui-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.card {
  --cui-card-spacer-y: 1rem;
  --cui-card-spacer-x: 1rem;
  --cui-card-title-spacer-y: 0.5rem;
  --cui-card-title-color: ;
  --cui-card-subtitle-color: ;
  --cui-card-border-width: var(--cui-border-width);
  --cui-card-border-color: var(--cui-border-color-translucent);
  --cui-card-border-radius: var(--cui-border-radius);
  --cui-card-box-shadow: ;
  --cui-card-inner-border-radius: calc(var(--cui-border-radius) - (var(--cui-border-width)));
  --cui-card-cap-padding-y: 0.5rem;
  --cui-card-cap-padding-x: 1rem;
  --cui-card-cap-bg: rgba(var(--cui-body-color-rgb), 0.03);
  --cui-card-cap-color: ;
  --cui-card-height: ;
  --cui-card-color: ;
  --cui-card-bg: var(--cui-body-bg);
  --cui-card-img-overlay-padding: 1rem;
  --cui-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--cui-card-height);
  color: var(--cui-body-color);
  word-wrap: break-word;
  background-color: var(--cui-card-bg);
  background-clip: border-box;
  border: var(--cui-card-border-width) solid var(--cui-card-border-color);
  border-radius: var(--cui-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--cui-card-inner-border-radius);
  border-top-right-radius: var(--cui-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--cui-card-inner-border-radius);
  border-bottom-left-radius: var(--cui-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--cui-card-spacer-y) var(--cui-card-spacer-x);
  color: var(--cui-card-color);
}

.card-title {
  margin-bottom: var(--cui-card-title-spacer-y);
  color: var(--cui-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--cui-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--cui-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

html:not([dir=rtl]) .card-link + .card-link {
  margin-left: var(--cui-card-spacer-x);
}
*[dir=rtl] .card-link + .card-link {
  margin-right: var(--cui-card-spacer-x);
}

.card-header {
  padding: var(--cui-card-cap-padding-y) var(--cui-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--cui-card-cap-color);
  background-color: var(--cui-card-cap-bg);
  border-bottom: var(--cui-card-border-width) solid var(--cui-card-border-color);
}
.card-header:first-child {
  border-radius: var(--cui-card-inner-border-radius) var(--cui-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--cui-card-cap-padding-y) var(--cui-card-cap-padding-x);
  color: var(--cui-card-cap-color);
  background-color: var(--cui-card-cap-bg);
  border-top: var(--cui-card-border-width) solid var(--cui-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--cui-card-inner-border-radius) var(--cui-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--cui-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--cui-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--cui-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--cui-card-bg);
  border-bottom-color: var(--cui-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--cui-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--cui-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--cui-card-img-overlay-padding);
  border-radius: var(--cui-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--cui-card-inner-border-radius);
  border-top-right-radius: var(--cui-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--cui-card-inner-border-radius);
  border-bottom-left-radius: var(--cui-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--cui-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  html:not([dir=rtl]) .card-group > .card + .card {
    margin-left: 0;
  }
  *[dir=rtl] .card-group > .card + .card {
    margin-right: 0;
  }
  html:not([dir=rtl]) .card-group > .card + .card {
    border-left: 0;
  }
  *[dir=rtl] .card-group > .card + .card {
    border-right: 0;
  }
  html:not([dir=rtl]) .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
  }
  *[dir=rtl] .card-group > .card:not(:last-child) {
    border-top-left-radius: 0;
  }
  html:not([dir=rtl]) .card-group > .card:not(:last-child) {
    border-bottom-right-radius: 0;
  }
  *[dir=rtl] .card-group > .card:not(:last-child) {
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  html:not([dir=rtl]) .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
  }
  *[dir=rtl] .card-group > .card:not(:first-child) {
    border-top-right-radius: 0;
  }
  html:not([dir=rtl]) .card-group > .card:not(:first-child) {
    border-bottom-left-radius: 0;
  }
  *[dir=rtl] .card-group > .card:not(:first-child) {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --cui-accordion-color: var(--cui-body-color);
  --cui-accordion-bg: var(--cui-body-bg);
  --cui-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --cui-accordion-border-color: var(--cui-border-color);
  --cui-accordion-border-width: var(--cui-border-width);
  --cui-accordion-border-radius: var(--cui-border-radius);
  --cui-accordion-inner-border-radius: calc(var(--cui-border-radius) - (var(--cui-border-width)));
  --cui-accordion-btn-padding-x: 1.25rem;
  --cui-accordion-btn-padding-y: 1rem;
  --cui-accordion-btn-color: var(--cui-body-color);
  --cui-accordion-btn-bg: var(--cui-accordion-bg);
  --cui-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --cui-accordion-btn-icon-width: 1.25rem;
  --cui-accordion-btn-icon-transform: rotate(-180deg);
  --cui-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --cui-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  --cui-accordion-btn-focus-border-color: #998fed;
  --cui-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(50, 31, 219, 0.25);
  --cui-accordion-body-padding-x: 1.25rem;
  --cui-accordion-body-padding-y: 1rem;
  --cui-accordion-active-color: #2d1cc5;
  --cui-accordion-active-bg: #ebe9fb;
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--cui-accordion-btn-padding-y) var(--cui-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--cui-accordion-btn-color);
  text-align: left;
  background-color: var(--cui-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--cui-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--cui-accordion-active-color);
  background-color: var(--cui-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--cui-accordion-border-width)) 0 var(--cui-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--cui-accordion-btn-active-icon);
  transform: var(--cui-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--cui-accordion-btn-icon-width);
  height: var(--cui-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--cui-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--cui-accordion-btn-icon-width);
  transition: var(--cui-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  border-color: var(--cui-accordion-btn-focus-border-color);
  outline: 0;
  box-shadow: var(--cui-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--cui-accordion-color);
  background-color: var(--cui-accordion-bg);
  border: var(--cui-accordion-border-width) solid var(--cui-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--cui-accordion-border-radius);
  border-top-right-radius: var(--cui-accordion-border-radius);
}
.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: var(--cui-accordion-inner-border-radius);
  border-top-right-radius: var(--cui-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--cui-accordion-border-radius);
  border-bottom-left-radius: var(--cui-accordion-border-radius);
}
.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: var(--cui-accordion-inner-border-radius);
  border-bottom-left-radius: var(--cui-accordion-inner-border-radius);
}
.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: var(--cui-accordion-border-radius);
  border-bottom-left-radius: var(--cui-accordion-border-radius);
}

.accordion-body {
  padding: var(--cui-accordion-body-padding-y) var(--cui-accordion-body-padding-x);
}

.accordion-flush .accordion-collapse {
  border-width: 0;
}
.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {
  border-radius: 0;
}

.breadcrumb {
  --cui-breadcrumb-padding-x: 0;
  --cui-breadcrumb-padding-y: 0;
  --cui-breadcrumb-margin-bottom: 1rem;
  --cui-breadcrumb-bg: ;
  --cui-breadcrumb-border-radius: ;
  --cui-breadcrumb-divider-color: var(--cui-secondary-color);
  --cui-breadcrumb-item-padding-x: 0.5rem;
  --cui-breadcrumb-item-active-color: var(--cui-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--cui-breadcrumb-padding-y) var(--cui-breadcrumb-padding-x);
  margin-bottom: var(--cui-breadcrumb-margin-bottom);
  font-size: var(--cui-breadcrumb-font-size);
  list-style: none;
  background-color: var(--cui-breadcrumb-bg);
  border-radius: var(--cui-breadcrumb-border-radius);
}

html:not([dir=rtl]) .breadcrumb-item + .breadcrumb-item {
  padding-left: var(--cui-breadcrumb-item-padding-x);
}
*[dir=rtl] .breadcrumb-item + .breadcrumb-item {
  padding-right: var(--cui-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  color: var(--cui-breadcrumb-divider-color);
}
html:not([dir=rtl]) .breadcrumb-item + .breadcrumb-item::before {
  float: left;
}
*[dir=rtl] .breadcrumb-item + .breadcrumb-item::before {
  float: right;
}
html:not([dir=rtl]) .breadcrumb-item + .breadcrumb-item::before {
  padding-right: var(--cui-breadcrumb-item-padding-x);
}
*[dir=rtl] .breadcrumb-item + .breadcrumb-item::before {
  padding-left: var(--cui-breadcrumb-item-padding-x);
}
html:not([dir=rtl]) .breadcrumb-item + .breadcrumb-item::before {
  content: var(--cui-breadcrumb-divider, "/");
}
*[dir=rtl] .breadcrumb-item + .breadcrumb-item::before {
  content: var(--cui-breadcrumb-divider-flipped, "/");
}
.breadcrumb-item.active {
  color: var(--cui-breadcrumb-item-active-color);
}

.pagination {
  --cui-pagination-padding-x: 0.75rem;
  --cui-pagination-padding-y: 0.375rem;
  --cui-pagination-font-size: 1rem;
  --cui-pagination-color: var(--cui-link-color);
  --cui-pagination-bg: var(--cui-body-bg);
  --cui-pagination-border-width: var(--cui-border-width);
  --cui-pagination-border-color: var(--cui-border-color);
  --cui-pagination-border-radius: var(--cui-border-radius);
  --cui-pagination-hover-color: var(--cui-link-hover-color);
  --cui-pagination-hover-bg: var(--cui-tertiary-bg);
  --cui-pagination-hover-border-color: var(--cui-border-color);
  --cui-pagination-focus-color: var(--cui-link-hover-color);
  --cui-pagination-focus-bg: var(--cui-secondary-bg);
  --cui-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(50, 31, 219, 0.25);
  --cui-pagination-active-color: rgba(255, 255, 255, 0.87);
  --cui-pagination-active-bg: #321fdb;
  --cui-pagination-active-border-color: #321fdb;
  --cui-pagination-disabled-color: var(--cui-secondary-color);
  --cui-pagination-disabled-bg: var(--cui-secondary-bg);
  --cui-pagination-disabled-border-color: var(--cui-border-color);
  display: flex;
  list-style: none;
}
html:not([dir=rtl]) .pagination {
  padding-left: 0;
}
*[dir=rtl] .pagination {
  padding-right: 0;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--cui-pagination-padding-y) var(--cui-pagination-padding-x);
  font-size: var(--cui-pagination-font-size);
  color: var(--cui-pagination-color);
  text-decoration: none;
  background-color: var(--cui-pagination-bg);
  border: var(--cui-pagination-border-width) solid var(--cui-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--cui-pagination-hover-color);
  background-color: var(--cui-pagination-hover-bg);
  border-color: var(--cui-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--cui-pagination-focus-color);
  background-color: var(--cui-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--cui-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--cui-pagination-active-color);
  background-color: var(--cui-pagination-active-bg);
  border-color: var(--cui-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--cui-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--cui-pagination-disabled-bg);
  border-color: var(--cui-pagination-disabled-border-color);
}

html:not([dir=rtl]) .page-item:not(:first-child) .page-link {
  margin-left: calc(var(--cui-border-width) * -1);
}
*[dir=rtl] .page-item:not(:first-child) .page-link {
  margin-right: calc(var(--cui-border-width) * -1);
}
html:not([dir=rtl]) .page-item:first-child .page-link {
  border-top-left-radius: var(--cui-pagination-border-radius);
}
*[dir=rtl] .page-item:first-child .page-link {
  border-top-right-radius: var(--cui-pagination-border-radius);
}
html:not([dir=rtl]) .page-item:first-child .page-link {
  border-bottom-left-radius: var(--cui-pagination-border-radius);
}
*[dir=rtl] .page-item:first-child .page-link {
  border-bottom-right-radius: var(--cui-pagination-border-radius);
}
html:not([dir=rtl]) .page-item:last-child .page-link {
  border-top-right-radius: var(--cui-pagination-border-radius);
}
*[dir=rtl] .page-item:last-child .page-link {
  border-top-left-radius: var(--cui-pagination-border-radius);
}
html:not([dir=rtl]) .page-item:last-child .page-link {
  border-bottom-right-radius: var(--cui-pagination-border-radius);
}
*[dir=rtl] .page-item:last-child .page-link {
  border-bottom-left-radius: var(--cui-pagination-border-radius);
}

.pagination-lg {
  --cui-pagination-padding-x: 1.5rem;
  --cui-pagination-padding-y: 0.75rem;
  --cui-pagination-font-size: 1.25rem;
  --cui-pagination-border-radius: var(--cui-border-radius-lg);
}

.pagination-sm {
  --cui-pagination-padding-x: 0.5rem;
  --cui-pagination-padding-y: 0.25rem;
  --cui-pagination-font-size: 0.875rem;
  --cui-pagination-border-radius: var(--cui-border-radius-sm);
}

.badge {
  --cui-badge-padding-x: 0.65em;
  --cui-badge-padding-y: 0.35em;
  --cui-badge-font-size: 0.75em;
  --cui-badge-font-weight: 700;
  --cui-badge-color: rgba(255, 255, 255, 0.87);
  --cui-badge-border-radius: var(--cui-border-radius);
  display: inline-block;
  padding: var(--cui-badge-padding-y) var(--cui-badge-padding-x);
  font-size: var(--cui-badge-font-size);
  font-weight: var(--cui-badge-font-weight);
  line-height: 1;
  color: var(--cui-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--cui-badge-border-radius, 0);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-sm {
  --cui-badge-padding-x: 0.5em;
  --cui-badge-padding-y: 0.3em;
  font-size: 0.65em;
}

.alert {
  --cui-alert-bg: transparent;
  --cui-alert-padding-x: 1rem;
  --cui-alert-padding-y: 1rem;
  --cui-alert-margin-bottom: 1rem;
  --cui-alert-color: inherit;
  --cui-alert-border-color: transparent;
  --cui-alert-border: var(--cui-border-width) solid var(--cui-alert-border-color);
  --cui-alert-border-radius: var(--cui-border-radius);
  --cui-alert-link-color: inherit;
  position: relative;
  padding: var(--cui-alert-padding-y) var(--cui-alert-padding-x);
  margin-bottom: var(--cui-alert-margin-bottom);
  color: var(--cui-alert-color);
  background-color: var(--cui-alert-bg);
  border: var(--cui-alert-border);
  border-radius: var(--cui-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--cui-alert-link-color);
}

html:not([dir=rtl]) .alert-dismissible {
  padding-right: 3rem;
}
*[dir=rtl] .alert-dismissible {
  padding-left: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}
html:not([dir=rtl]) .alert-dismissible .btn-close {
  right: 0;
}
*[dir=rtl] .alert-dismissible .btn-close {
  left: 0;
}

.alert-primary {
  --cui-alert-color: #1e1383;
  --cui-alert-bg: #d6d2f8;
  --cui-alert-border-color: #c2bcf4;
  --cui-alert-link-color: #180f69;
}

.alert-secondary {
  --cui-alert-color: #5e636a;
  --cui-alert-bg: #ebedef;
  --cui-alert-border-color: #e2e4e8;
  --cui-alert-link-color: #4b4f55;
}

.alert-success {
  --cui-alert-color: #1c6e37;
  --cui-alert-bg: #d5f1de;
  --cui-alert-border-color: #c0eace;
  --cui-alert-link-color: #16582c;
}

.alert-info {
  --cui-alert-color: #1f5c99;
  --cui-alert-bg: #d6ebff;
  --cui-alert-border-color: #c2e0ff;
  --cui-alert-link-color: #194a7a;
}

.alert-warning {
  --cui-alert-color: #956a0d;
  --cui-alert-bg: #feefd0;
  --cui-alert-border-color: #fde8b9;
  --cui-alert-link-color: #77550a;
}

.alert-danger {
  --cui-alert-color: #893232;
  --cui-alert-bg: #fadddd;
  --cui-alert-border-color: #f7cbcb;
  --cui-alert-link-color: #6e2828;
}

.alert-light {
  --cui-alert-color: #8d8e8f;
  --cui-alert-bg: #fbfbfc;
  --cui-alert-border-color: #f9fafa;
  --cui-alert-link-color: #717272;
}

.alert-dark {
  --cui-alert-color: #4d4d4d;
  --cui-alert-bg: #e6e6e6;
  --cui-alert-border-color: #d9d9d9;
  --cui-alert-link-color: #3e3e3e;
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress,
.progress-stacked {
  --cui-progress-height: 1rem;
  --cui-progress-font-size: 0.75rem;
  --cui-progress-bg: var(--cui-secondary-bg);
  --cui-progress-border-radius: var(--cui-border-radius);
  --cui-progress-box-shadow: var(--cui-box-shadow-inset);
  --cui-progress-bar-color: rgba(255, 255, 255, 0.87);
  --cui-progress-bar-bg: var(--cui-primary);
  --cui-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--cui-progress-height);
  overflow: hidden;
  font-size: var(--cui-progress-font-size);
  background-color: var(--cui-progress-bg);
  border-radius: var(--cui-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--cui-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--cui-progress-bar-bg);
  transition: var(--cui-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--cui-progress-height) var(--cui-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.progress-thin {
  height: 4px;
}

.progress.progress-white {
  background-color: rgba(255, 255, 255, 0.2);
}
.progress.progress-white .progress-bar {
  background-color: #FFFFFF;
}

.progress-group {
  display: flex;
  flex-flow: row wrap;
  margin-bottom: 1rem;
}

.progress-group-prepend {
  flex: 0 0 100px;
  align-self: center;
}

.progress-group-header {
  display: flex;
  flex-basis: 100%;
  align-items: center;
  margin-bottom: 0.25rem;
}

.progress-group-bars {
  flex-grow: 1;
  align-self: center;
}
.progress-group-bars .progress:not(:last-child) {
  margin-bottom: 2px;
}

.progress-group-header + .progress-group-bars {
  flex-basis: 100%;
}

.list-group {
  --cui-list-group-color: var(--cui-body-color);
  --cui-list-group-bg: var(--cui-body-bg);
  --cui-list-group-border-color: var(--cui-border-color);
  --cui-list-group-border-width: var(--cui-border-width);
  --cui-list-group-border-radius: var(--cui-border-radius);
  --cui-list-group-item-padding-x: 1rem;
  --cui-list-group-item-padding-y: 0.5rem;
  --cui-list-group-action-color: var(--cui-secondary-color);
  --cui-list-group-action-hover-color: var(--cui-emphasis-color);
  --cui-list-group-action-hover-bg: var(--cui-tertiary-bg);
  --cui-list-group-action-active-color: var(--cui-body-color);
  --cui-list-group-action-active-bg: var(--cui-secondary-bg);
  --cui-list-group-disabled-color: var(--cui-secondary-color);
  --cui-list-group-disabled-bg: var(--cui-body-bg);
  --cui-list-group-active-color: rgba(255, 255, 255, 0.87);
  --cui-list-group-active-bg: #321fdb;
  --cui-list-group-active-border-color: #321fdb;
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  border-radius: var(--cui-list-group-border-radius);
}
html:not([dir=rtl]) .list-group {
  padding-left: 0;
}
*[dir=rtl] .list-group {
  padding-right: 0;
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--cui-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--cui-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--cui-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--cui-list-group-action-active-color);
  background-color: var(--cui-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--cui-list-group-item-padding-y) var(--cui-list-group-item-padding-x);
  color: var(--cui-list-group-color);
  text-decoration: none;
  background-color: var(--cui-list-group-bg);
  border: var(--cui-list-group-border-width) solid var(--cui-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--cui-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--cui-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--cui-list-group-active-color);
  background-color: var(--cui-list-group-active-bg);
  border-color: var(--cui-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--cui-list-group-border-width));
  border-top-width: var(--cui-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
html:not([dir=rtl]) .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--cui-list-group-border-radius);
}
*[dir=rtl] .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-right-radius: var(--cui-list-group-border-radius);
}
html:not([dir=rtl]) .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-top-right-radius: 0;
}
*[dir=rtl] .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-top-left-radius: 0;
}
html:not([dir=rtl]) .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--cui-list-group-border-radius);
}
*[dir=rtl] .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-left-radius: var(--cui-list-group-border-radius);
}
html:not([dir=rtl]) .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-bottom-left-radius: 0;
}
*[dir=rtl] .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-bottom-right-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--cui-list-group-border-width);
}
html:not([dir=rtl]) .list-group-horizontal > .list-group-item + .list-group-item {
  border-left-width: 0;
}
*[dir=rtl] .list-group-horizontal > .list-group-item + .list-group-item {
  border-right-width: 0;
}
html:not([dir=rtl]) .list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--cui-list-group-border-width));
}
*[dir=rtl] .list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-right: calc(-1 * var(--cui-list-group-border-width));
}
html:not([dir=rtl]) .list-group-horizontal > .list-group-item + .list-group-item.active {
  border-left-width: var(--cui-list-group-border-width);
}
*[dir=rtl] .list-group-horizontal > .list-group-item + .list-group-item.active {
  border-right-width: var(--cui-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  html:not([dir=rtl]) .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-right-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-top-right-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-top-left-radius: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-left-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-bottom-left-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-bottom-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--cui-list-group-border-width);
  }
  html:not([dir=rtl]) .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-left-width: 0;
  }
  *[dir=rtl] .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-right-width: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--cui-list-group-border-width));
  }
  *[dir=rtl] .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-right: calc(-1 * var(--cui-list-group-border-width));
  }
  html:not([dir=rtl]) .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    border-left-width: var(--cui-list-group-border-width);
  }
  *[dir=rtl] .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    border-right-width: var(--cui-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  html:not([dir=rtl]) .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-right-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-top-right-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-top-left-radius: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-left-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-bottom-left-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-bottom-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--cui-list-group-border-width);
  }
  html:not([dir=rtl]) .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-left-width: 0;
  }
  *[dir=rtl] .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-right-width: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--cui-list-group-border-width));
  }
  *[dir=rtl] .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-right: calc(-1 * var(--cui-list-group-border-width));
  }
  html:not([dir=rtl]) .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    border-left-width: var(--cui-list-group-border-width);
  }
  *[dir=rtl] .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    border-right-width: var(--cui-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  html:not([dir=rtl]) .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-right-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-top-right-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-top-left-radius: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-left-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-bottom-left-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-bottom-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--cui-list-group-border-width);
  }
  html:not([dir=rtl]) .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-left-width: 0;
  }
  *[dir=rtl] .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-right-width: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--cui-list-group-border-width));
  }
  *[dir=rtl] .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-right: calc(-1 * var(--cui-list-group-border-width));
  }
  html:not([dir=rtl]) .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    border-left-width: var(--cui-list-group-border-width);
  }
  *[dir=rtl] .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    border-right-width: var(--cui-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  html:not([dir=rtl]) .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-right-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-top-right-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-top-left-radius: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-left-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-bottom-left-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-bottom-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--cui-list-group-border-width);
  }
  html:not([dir=rtl]) .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-left-width: 0;
  }
  *[dir=rtl] .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-right-width: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--cui-list-group-border-width));
  }
  *[dir=rtl] .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-right: calc(-1 * var(--cui-list-group-border-width));
  }
  html:not([dir=rtl]) .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    border-left-width: var(--cui-list-group-border-width);
  }
  *[dir=rtl] .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    border-right-width: var(--cui-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  html:not([dir=rtl]) .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-right-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-top-right-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-top-left-radius: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-left-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-bottom-left-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-bottom-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--cui-list-group-border-width);
  }
  html:not([dir=rtl]) .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-left-width: 0;
  }
  *[dir=rtl] .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-right-width: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--cui-list-group-border-width));
  }
  *[dir=rtl] .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-right: calc(-1 * var(--cui-list-group-border-width));
  }
  html:not([dir=rtl]) .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    border-left-width: var(--cui-list-group-border-width);
  }
  *[dir=rtl] .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    border-right-width: var(--cui-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--cui-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --cui-list-group-color: contrast-ratio-correction(#1e1383, #d6d2f8, 40%, "primary");
  --cui-list-group-bg: #d6d2f8;
  --cui-list-group-hover-bg: #2d1cc5;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#1e1383, #d6d2f8, 40%, "primary");
  --cui-list-group-action-active-color: #FFFFFF;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#1e1383, #d6d2f8, 40%, "primary");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#1e1383, #d6d2f8, 40%, "primary");
}

.list-group-item-secondary {
  --cui-list-group-color: contrast-ratio-correction(#5e636a, #ebedef, 40%, "secondary");
  --cui-list-group-bg: #ebedef;
  --cui-list-group-hover-bg: #8d959f;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#5e636a, #ebedef, 40%, "secondary");
  --cui-list-group-action-active-color: #FFFFFF;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#5e636a, #ebedef, 40%, "secondary");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#5e636a, #ebedef, 40%, "secondary");
}

.list-group-item-success {
  --cui-list-group-color: contrast-ratio-correction(#1c6e37, #d5f1de, 40%, "success");
  --cui-list-group-bg: #d5f1de;
  --cui-list-group-hover-bg: #29a653;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#1c6e37, #d5f1de, 40%, "success");
  --cui-list-group-action-active-color: #FFFFFF;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#1c6e37, #d5f1de, 40%, "success");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#1c6e37, #d5f1de, 40%, "success");
}

.list-group-item-danger {
  --cui-list-group-color: contrast-ratio-correction(#893232, #fadddd, 40%, "danger");
  --cui-list-group-bg: #fadddd;
  --cui-list-group-hover-bg: #ce4b4b;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#893232, #fadddd, 40%, "danger");
  --cui-list-group-action-active-color: #FFFFFF;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#893232, #fadddd, 40%, "danger");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#893232, #fadddd, 40%, "danger");
}

.list-group-item-warning {
  --cui-list-group-color: contrast-ratio-correction(#956a0d, #feefd0, 40%, "warning");
  --cui-list-group-bg: #feefd0;
  --cui-list-group-hover-bg: #e09f13;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#956a0d, #feefd0, 40%, "warning");
  --cui-list-group-action-active-color: #FFFFFF;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#956a0d, #feefd0, 40%, "warning");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#956a0d, #feefd0, 40%, "warning");
}

.list-group-item-info {
  --cui-list-group-color: contrast-ratio-correction(#1f5c99, #d6ebff, 40%, "info");
  --cui-list-group-bg: #d6ebff;
  --cui-list-group-hover-bg: #2e8ae6;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#1f5c99, #d6ebff, 40%, "info");
  --cui-list-group-action-active-color: #FFFFFF;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#1f5c99, #d6ebff, 40%, "info");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#1f5c99, #d6ebff, 40%, "info");
}

.list-group-item-light {
  --cui-list-group-color: contrast-ratio-correction(#8d8e8f, #fbfbfc, 40%, "light");
  --cui-list-group-bg: #fbfbfc;
  --cui-list-group-hover-bg: #d4d5d7;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#8d8e8f, #fbfbfc, 40%, "light");
  --cui-list-group-action-active-color: #FFFFFF;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#8d8e8f, #fbfbfc, 40%, "light");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#8d8e8f, #fbfbfc, 40%, "light");
}

.list-group-item-dark {
  --cui-list-group-color: contrast-ratio-correction(#4d4d4d, #e6e6e6, 40%, "dark");
  --cui-list-group-bg: #e6e6e6;
  --cui-list-group-hover-bg: #747474;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#4d4d4d, #e6e6e6, 40%, "dark");
  --cui-list-group-action-active-color: #FFFFFF;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#4d4d4d, #e6e6e6, 40%, "dark");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#4d4d4d, #e6e6e6, 40%, "dark");
}

.btn-close {
  --cui-btn-close-color: rgba(44, 56, 74, 0.95);
  --cui-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --cui-btn-close-opacity: 0.5;
  --cui-btn-close-hover-opacity: 0.75;
  --cui-btn-close-focus-shadow: 0 0 0 0.25rem rgba(50, 31, 219, 0.25);
  --cui-btn-close-focus-opacity: 1;
  --cui-btn-close-disabled-opacity: 0.25;
  --cui-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--cui-btn-close-color);
  background: transparent var(--cui-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--cui-btn-close-opacity);
}
.btn-close:hover {
  color: var(--cui-btn-close-color);
  text-decoration: none;
  opacity: var(--cui-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--cui-btn-close-focus-shadow);
  opacity: var(--cui-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--cui-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--cui-btn-close-white-filter);
}

.toast {
  --cui-toast-zindex: 1090;
  --cui-toast-padding-x: 0.75rem;
  --cui-toast-padding-y: 0.5rem;
  --cui-toast-spacing: 1.5rem;
  --cui-toast-max-width: 350px;
  --cui-toast-font-size: 0.875rem;
  --cui-toast-color: ;
  --cui-toast-bg: rgba(var(--cui-body-bg-rgb), 0.85);
  --cui-toast-border-width: var(--cui-border-width);
  --cui-toast-border-color: var(--cui-border-color-translucent);
  --cui-toast-border-radius: var(--cui-border-radius);
  --cui-toast-box-shadow: var(--cui-box-shadow);
  --cui-toast-header-color: var(--cui-secondary-color);
  --cui-toast-header-bg: rgba(var(--cui-body-bg-rgb), 0.85);
  --cui-toast-header-border-color: var(--cui-border-color-translucent);
  width: var(--cui-toast-max-width);
  max-width: 100%;
  font-size: var(--cui-toast-font-size);
  color: var(--cui-toast-color);
  pointer-events: auto;
  background-color: var(--cui-toast-bg);
  background-clip: padding-box;
  border: var(--cui-toast-border-width) solid var(--cui-toast-border-color);
  box-shadow: var(--cui-toast-box-shadow);
  border-radius: var(--cui-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --cui-toast-zindex: 1090;
  position: absolute;
  z-index: var(--cui-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--cui-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--cui-toast-padding-y) var(--cui-toast-padding-x);
  color: var(--cui-toast-header-color);
  background-color: var(--cui-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--cui-toast-border-width) solid var(--cui-toast-header-border-color);
  border-top-left-radius: calc(var(--cui-toast-border-radius) - var(--cui-toast-border-width));
  border-top-right-radius: calc(var(--cui-toast-border-radius) - var(--cui-toast-border-width));
}
html:not([dir=rtl]) .toast-header .btn-close {
  margin-right: calc(-0.5 * var(--cui-toast-padding-x));
}
*[dir=rtl] .toast-header .btn-close {
  margin-left: calc(-0.5 * var(--cui-toast-padding-x));
}
html:not([dir=rtl]) .toast-header .btn-close {
  margin-left: var(--cui-toast-padding-x);
}
*[dir=rtl] .toast-header .btn-close {
  margin-right: var(--cui-toast-padding-x);
}

.toast-body {
  padding: var(--cui-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --cui-modal-zindex: 1055;
  --cui-modal-width: 500px;
  --cui-modal-padding: 1rem;
  --cui-modal-margin: 0.5rem;
  --cui-modal-color: ;
  --cui-modal-bg: var(--cui-body-bg);
  --cui-modal-border-color: var(--cui-border-color-translucent);
  --cui-modal-border-width: var(--cui-border-width);
  --cui-modal-border-radius: var(--cui-border-radius-lg);
  --cui-modal-box-shadow: 0 0.125rem 0.25rem rgba(70, 53, 41, 0.075);
  --cui-modal-inner-border-radius: calc(var(--cui-border-radius-lg) - (var(--cui-border-width)));
  --cui-modal-header-padding-x: 1rem;
  --cui-modal-header-padding-y: 1rem;
  --cui-modal-header-padding: 1rem 1rem;
  --cui-modal-header-border-color: var(--cui-border-color);
  --cui-modal-header-border-width: var(--cui-border-width);
  --cui-modal-title-line-height: 1.5;
  --cui-modal-footer-gap: 0.5rem;
  --cui-modal-footer-bg: ;
  --cui-modal-footer-border-color: var(--cui-border-color);
  --cui-modal-footer-border-width: var(--cui-border-width);
  position: fixed;
  top: 0;
  z-index: var(--cui-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}
html:not([dir=rtl]) .modal {
  left: 0;
}
*[dir=rtl] .modal {
  right: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--cui-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--cui-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--cui-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--cui-modal-color);
  pointer-events: auto;
  background-color: var(--cui-modal-bg);
  background-clip: padding-box;
  border: var(--cui-modal-border-width) solid var(--cui-modal-border-color);
  border-radius: var(--cui-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --cui-backdrop-zindex: 1050;
  --cui-backdrop-bg: #463529;
  --cui-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--cui-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--cui-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--cui-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--cui-modal-header-padding);
  border-bottom: var(--cui-modal-header-border-width) solid var(--cui-modal-header-border-color);
  border-top-left-radius: var(--cui-modal-inner-border-radius);
  border-top-right-radius: var(--cui-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--cui-modal-header-padding-y) * 0.5) calc(var(--cui-modal-header-padding-x) * 0.5);
}
html:not([dir=rtl]) .modal-header .btn-close {
  margin: calc(-0.5 * var(--cui-modal-header-padding-y)) calc(-0.5 * var(--cui-modal-header-padding-x)) calc(-0.5 * var(--cui-modal-header-padding-y)) auto;
}
*[dir=rtl] .modal-header .btn-close {
  margin: calc(-0.5 * var(--cui-modal-header-padding-y)) auto calc(-0.5 * var(--cui-modal-header-padding-y)) calc(-0.5 * var(--cui-modal-header-padding-x));
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--cui-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--cui-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--cui-modal-padding) - var(--cui-modal-footer-gap) * 0.5);
  background-color: var(--cui-modal-footer-bg);
  border-top: var(--cui-modal-footer-border-width) solid var(--cui-modal-footer-border-color);
  border-bottom-right-radius: var(--cui-modal-inner-border-radius);
  border-bottom-left-radius: var(--cui-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--cui-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --cui-modal-margin: 1.75rem;
    --cui-modal-box-shadow: 0 0.5rem 1rem rgba(70, 53, 41, 0.15);
  }
  .modal-dialog {
    max-width: var(--cui-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --cui-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --cui-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --cui-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --cui-tooltip-zindex: 1080;
  --cui-tooltip-max-width: 200px;
  --cui-tooltip-padding-x: 0.5rem;
  --cui-tooltip-padding-y: 0.25rem;
  --cui-tooltip-margin: ;
  --cui-tooltip-font-size: 0.875rem;
  --cui-tooltip-color: var(--cui-body-bg);
  --cui-tooltip-bg: var(--cui-emphasis-color);
  --cui-tooltip-border-radius: var(--cui-border-radius);
  --cui-tooltip-opacity: 0.9;
  --cui-tooltip-arrow-width: 0.8rem;
  --cui-tooltip-arrow-height: 0.4rem;
  z-index: var(--cui-tooltip-zindex);
  display: block;
  margin: var(--cui-tooltip-margin);
  font-family: var(--cui-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--cui-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--cui-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--cui-tooltip-arrow-width);
  height: var(--cui-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--cui-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--cui-tooltip-arrow-height) calc(var(--cui-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--cui-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--cui-tooltip-arrow-height));
  width: var(--cui-tooltip-arrow-height);
  height: var(--cui-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--cui-tooltip-arrow-width) * 0.5) var(--cui-tooltip-arrow-height) calc(var(--cui-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--cui-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--cui-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--cui-tooltip-arrow-width) * 0.5) var(--cui-tooltip-arrow-height);
  border-bottom-color: var(--cui-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--cui-tooltip-arrow-height));
  width: var(--cui-tooltip-arrow-height);
  height: var(--cui-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--cui-tooltip-arrow-width) * 0.5) 0 calc(var(--cui-tooltip-arrow-width) * 0.5) var(--cui-tooltip-arrow-height);
  border-left-color: var(--cui-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--cui-tooltip-max-width);
  padding: var(--cui-tooltip-padding-y) var(--cui-tooltip-padding-x);
  color: var(--cui-tooltip-color);
  text-align: center;
  background-color: var(--cui-tooltip-bg);
  border-radius: var(--cui-tooltip-border-radius);
}

.popover {
  --cui-popover-zindex: 1070;
  --cui-popover-max-width: 276px;
  --cui-popover-font-size: 0.875rem;
  --cui-popover-bg: var(--cui-body-bg);
  --cui-popover-border-width: var(--cui-border-width);
  --cui-popover-border-color: var(--cui-border-color-translucent);
  --cui-popover-border-radius: var(--cui-border-radius-lg);
  --cui-popover-inner-border-radius: calc(var(--cui-border-radius-lg) - var(--cui-border-width));
  --cui-popover-box-shadow: 0 0.5rem 1rem rgba(70, 53, 41, 0.15);
  --cui-popover-header-padding-x: 1rem;
  --cui-popover-header-padding-y: 0.5rem;
  --cui-popover-header-font-size: 1rem;
  --cui-popover-header-color: inherit;
  --cui-popover-header-bg: var(--cui-secondary-bg);
  --cui-popover-body-padding-x: 1rem;
  --cui-popover-body-padding-y: 1rem;
  --cui-popover-body-color: var(--cui-body-color);
  --cui-popover-arrow-width: 1rem;
  --cui-popover-arrow-height: 0.5rem;
  --cui-popover-arrow-border: var(--cui-popover-border-color);
  z-index: var(--cui-popover-zindex);
  display: block;
  max-width: var(--cui-popover-max-width);
  font-family: var(--cui-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--cui-popover-font-size);
  word-wrap: break-word;
  background-color: var(--cui-popover-bg);
  background-clip: padding-box;
  border: var(--cui-popover-border-width) solid var(--cui-popover-border-color);
  border-radius: var(--cui-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--cui-popover-arrow-width);
  height: var(--cui-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--cui-popover-arrow-height) calc(var(--cui-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--cui-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--cui-popover-border-width);
  border-top-color: var(--cui-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width));
  width: var(--cui-popover-arrow-height);
  height: var(--cui-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--cui-popover-arrow-width) * 0.5) var(--cui-popover-arrow-height) calc(var(--cui-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--cui-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--cui-popover-border-width);
  border-right-color: var(--cui-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--cui-popover-arrow-width) * 0.5) var(--cui-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--cui-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--cui-popover-border-width);
  border-bottom-color: var(--cui-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--cui-popover-arrow-width);
  margin-left: calc(-0.5 * var(--cui-popover-arrow-width));
  content: "";
  border-bottom: var(--cui-popover-border-width) solid var(--cui-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width));
  width: var(--cui-popover-arrow-height);
  height: var(--cui-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--cui-popover-arrow-width) * 0.5) 0 calc(var(--cui-popover-arrow-width) * 0.5) var(--cui-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--cui-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--cui-popover-border-width);
  border-left-color: var(--cui-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--cui-popover-header-padding-y) var(--cui-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--cui-popover-header-font-size);
  color: var(--cui-popover-header-color);
  background-color: var(--cui-popover-header-bg);
  border-bottom: var(--cui-popover-border-width) solid var(--cui-popover-border-color);
  border-top-left-radius: var(--cui-popover-inner-border-radius);
  border-top-right-radius: var(--cui-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--cui-popover-body-padding-y) var(--cui-popover-body-padding-x);
  color: var(--cui-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: var(--cui-carousel-control-color, rgba(255, 255, 255, 0.87));
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: var(--cui-carousel-control-color, rgba(255, 255, 255, 0.87));
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators [data-coreui-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: var(--cui-carousel-indicator-active-bg, #FFFFFF);
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-coreui-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: var(--cui-carousel-caption-color, rgba(255, 255, 255, 0.87));
  text-align: center;
}

.carousel-dark {
  --cui-carousel-indicator-active-bg: #463529;
  --cui-carousel-caption-color: rgba(44, 56, 74, 0.95);
}
.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-coreui-target] {
  background-color: #463529;
}
.carousel-dark .carousel-caption {
  color: rgba(44, 56, 74, 0.95);
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--cui-spinner-width);
  height: var(--cui-spinner-height);
  vertical-align: var(--cui-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--cui-spinner-animation-speed) linear infinite var(--cui-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --cui-spinner-width: 2rem;
  --cui-spinner-height: 2rem;
  --cui-spinner-vertical-align: -0.125em;
  --cui-spinner-border-width: 0.25em;
  --cui-spinner-animation-speed: 0.75s;
  --cui-spinner-animation-name: spinner-border;
  border: var(--cui-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --cui-spinner-width: 1rem;
  --cui-spinner-height: 1rem;
  --cui-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --cui-spinner-width: 2rem;
  --cui-spinner-height: 2rem;
  --cui-spinner-vertical-align: -0.125em;
  --cui-spinner-animation-speed: 0.75s;
  --cui-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --cui-spinner-width: 1rem;
  --cui-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --cui-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --cui-offcanvas-zindex: 1045;
  --cui-offcanvas-width: 400px;
  --cui-offcanvas-height: 30vh;
  --cui-offcanvas-padding-x: 1rem;
  --cui-offcanvas-padding-y: 1rem;
  --cui-offcanvas-color: var(--cui-body-color);
  --cui-offcanvas-bg: var(--cui-body-bg);
  --cui-offcanvas-border-width: var(--cui-border-width);
  --cui-offcanvas-border-color: var(--cui-border-color-translucent);
  --cui-offcanvas-box-shadow: 0 0.125rem 0.25rem rgba(70, 53, 41, 0.075);
  --cui-offcanvas-transition: transform 0.3s ease-in-out;
  --cui-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    width: var(--cui-offcanvas-width);
  }
  html:not([dir=rtl]) .offcanvas-sm.offcanvas-start {
    left: 0;
  }
  *[dir=rtl] .offcanvas-sm.offcanvas-start {
    right: 0;
  }
  html:not([dir=rtl]) .offcanvas-sm.offcanvas-start {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-sm.offcanvas-start {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  html:not([dir=rtl]) .offcanvas-sm.offcanvas-start {
    transform: translateX(-100%);
  }
  *[dir=rtl] .offcanvas-sm.offcanvas-start {
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    width: var(--cui-offcanvas-width);
    transform: translateX(100%);
  }
  html:not([dir=rtl]) .offcanvas-sm.offcanvas-end {
    right: 0;
  }
  *[dir=rtl] .offcanvas-sm.offcanvas-end {
    left: 0;
  }
  html:not([dir=rtl]) .offcanvas-sm.offcanvas-end {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-sm.offcanvas-end {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    width: var(--cui-offcanvas-width);
  }
  html:not([dir=rtl]) .offcanvas-md.offcanvas-start {
    left: 0;
  }
  *[dir=rtl] .offcanvas-md.offcanvas-start {
    right: 0;
  }
  html:not([dir=rtl]) .offcanvas-md.offcanvas-start {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-md.offcanvas-start {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  html:not([dir=rtl]) .offcanvas-md.offcanvas-start {
    transform: translateX(-100%);
  }
  *[dir=rtl] .offcanvas-md.offcanvas-start {
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    width: var(--cui-offcanvas-width);
    transform: translateX(100%);
  }
  html:not([dir=rtl]) .offcanvas-md.offcanvas-end {
    right: 0;
  }
  *[dir=rtl] .offcanvas-md.offcanvas-end {
    left: 0;
  }
  html:not([dir=rtl]) .offcanvas-md.offcanvas-end {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-md.offcanvas-end {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    width: var(--cui-offcanvas-width);
  }
  html:not([dir=rtl]) .offcanvas-lg.offcanvas-start {
    left: 0;
  }
  *[dir=rtl] .offcanvas-lg.offcanvas-start {
    right: 0;
  }
  html:not([dir=rtl]) .offcanvas-lg.offcanvas-start {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-lg.offcanvas-start {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  html:not([dir=rtl]) .offcanvas-lg.offcanvas-start {
    transform: translateX(-100%);
  }
  *[dir=rtl] .offcanvas-lg.offcanvas-start {
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    width: var(--cui-offcanvas-width);
    transform: translateX(100%);
  }
  html:not([dir=rtl]) .offcanvas-lg.offcanvas-end {
    right: 0;
  }
  *[dir=rtl] .offcanvas-lg.offcanvas-end {
    left: 0;
  }
  html:not([dir=rtl]) .offcanvas-lg.offcanvas-end {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-lg.offcanvas-end {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    width: var(--cui-offcanvas-width);
  }
  html:not([dir=rtl]) .offcanvas-xl.offcanvas-start {
    left: 0;
  }
  *[dir=rtl] .offcanvas-xl.offcanvas-start {
    right: 0;
  }
  html:not([dir=rtl]) .offcanvas-xl.offcanvas-start {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-xl.offcanvas-start {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  html:not([dir=rtl]) .offcanvas-xl.offcanvas-start {
    transform: translateX(-100%);
  }
  *[dir=rtl] .offcanvas-xl.offcanvas-start {
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    width: var(--cui-offcanvas-width);
    transform: translateX(100%);
  }
  html:not([dir=rtl]) .offcanvas-xl.offcanvas-end {
    right: 0;
  }
  *[dir=rtl] .offcanvas-xl.offcanvas-end {
    left: 0;
  }
  html:not([dir=rtl]) .offcanvas-xl.offcanvas-end {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-xl.offcanvas-end {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    width: var(--cui-offcanvas-width);
  }
  html:not([dir=rtl]) .offcanvas-xxl.offcanvas-start {
    left: 0;
  }
  *[dir=rtl] .offcanvas-xxl.offcanvas-start {
    right: 0;
  }
  html:not([dir=rtl]) .offcanvas-xxl.offcanvas-start {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-xxl.offcanvas-start {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  html:not([dir=rtl]) .offcanvas-xxl.offcanvas-start {
    transform: translateX(-100%);
  }
  *[dir=rtl] .offcanvas-xxl.offcanvas-start {
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    width: var(--cui-offcanvas-width);
    transform: translateX(100%);
  }
  html:not([dir=rtl]) .offcanvas-xxl.offcanvas-end {
    right: 0;
  }
  *[dir=rtl] .offcanvas-xxl.offcanvas-end {
    left: 0;
  }
  html:not([dir=rtl]) .offcanvas-xxl.offcanvas-end {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-xxl.offcanvas-end {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--cui-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--cui-offcanvas-color);
  visibility: hidden;
  background-color: var(--cui-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--cui-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  width: var(--cui-offcanvas-width);
}
html:not([dir=rtl]) .offcanvas.offcanvas-start {
  left: 0;
}
*[dir=rtl] .offcanvas.offcanvas-start {
  right: 0;
}
html:not([dir=rtl]) .offcanvas.offcanvas-start {
  border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
}
*[dir=rtl] .offcanvas.offcanvas-start {
  border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
}
html:not([dir=rtl]) .offcanvas.offcanvas-start {
  transform: translateX(-100%);
}
*[dir=rtl] .offcanvas.offcanvas-start {
  transform: translateX(100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  width: var(--cui-offcanvas-width);
  transform: translateX(100%);
}
html:not([dir=rtl]) .offcanvas.offcanvas-end {
  right: 0;
}
*[dir=rtl] .offcanvas.offcanvas-end {
  left: 0;
}
html:not([dir=rtl]) .offcanvas.offcanvas-end {
  border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
}
*[dir=rtl] .offcanvas.offcanvas-end {
  border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--cui-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--cui-offcanvas-height);
  max-height: 100%;
  border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none !important;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: var(--cui-offcanvas-backdrop-bg, #463529);
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--cui-offcanvas-padding-y) var(--cui-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--cui-offcanvas-padding-y) * 0.5) calc(var(--cui-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--cui-offcanvas-padding-y));
  margin-bottom: calc(-0.5 * var(--cui-offcanvas-padding-y));
}
html:not([dir=rtl]) .offcanvas-header .btn-close {
  margin-right: calc(-0.5 * var(--cui-offcanvas-padding-x));
}
*[dir=rtl] .offcanvas-header .btn-close {
  margin-left: calc(-0.5 * var(--cui-offcanvas-padding-x));
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--cui-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--cui-offcanvas-padding-y) var(--cui-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  -webkit-mask-image: linear-gradient(130deg, #463529 55%, rgba(0, 0, 0, 0.8) 75%, #463529 95%);
          mask-image: linear-gradient(130deg, #463529 55%, rgba(0, 0, 0, 0.8) 75%, #463529 95%);
  -webkit-mask-size: 200% 100%;
          mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    -webkit-mask-position: -200% 0%;
            mask-position: -200% 0%;
  }
}
.avatar {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  border-radius: 50em;
  transition: margin 0.15s;
  width: 2rem;
  height: 2rem;
  font-size: 0.8rem;
}
@media (prefers-reduced-motion: reduce) {
  .avatar {
    transition: none;
  }
}
.avatar .avatar-status {
  width: 0.5333333333rem;
  height: 0.5333333333rem;
}

.avatar-img {
  width: 100%;
  height: auto;
  border-radius: 50em;
}

.avatar-status {
  position: absolute;
  bottom: 0;
  display: block;
  border: 1px solid #FFFFFF;
  border-radius: 50em;
}
html:not([dir=rtl]) .avatar-status {
  right: 0;
}
*[dir=rtl] .avatar-status {
  left: 0;
}

.avatar-sm {
  width: 1.5rem;
  height: 1.5rem;
  font-size: 0.6rem;
}
.avatar-sm .avatar-status {
  width: 0.4rem;
  height: 0.4rem;
}

.avatar-md {
  width: 2.5rem;
  height: 2.5rem;
  font-size: 1rem;
}
.avatar-md .avatar-status {
  width: 0.6666666667rem;
  height: 0.6666666667rem;
}

.avatar-lg {
  width: 3rem;
  height: 3rem;
  font-size: 1.2rem;
}
.avatar-lg .avatar-status {
  width: 0.8rem;
  height: 0.8rem;
}

.avatar-xl {
  width: 4rem;
  height: 4rem;
  font-size: 1.6rem;
}
.avatar-xl .avatar-status {
  width: 1.0666666667rem;
  height: 1.0666666667rem;
}

.avatars-stack {
  display: flex;
}
html:not([dir=rtl]) .avatars-stack .avatar {
  margin-right: -0.8rem;
}
*[dir=rtl] .avatars-stack .avatar {
  margin-left: -0.8rem;
}
html:not([dir=rtl]) .avatars-stack .avatar:hover {
  margin-right: 0;
}
*[dir=rtl] .avatars-stack .avatar:hover {
  margin-left: 0;
}
html:not([dir=rtl]) .avatars-stack .avatar-sm {
  margin-right: -0.6rem;
}
*[dir=rtl] .avatars-stack .avatar-sm {
  margin-left: -0.6rem;
}
html:not([dir=rtl]) .avatars-stack .avatar-md {
  margin-right: -1rem;
}
*[dir=rtl] .avatars-stack .avatar-md {
  margin-left: -1rem;
}
html:not([dir=rtl]) .avatars-stack .avatar-lg {
  margin-right: -1.2rem;
}
*[dir=rtl] .avatars-stack .avatar-lg {
  margin-left: -1.2rem;
}
html:not([dir=rtl]) .avatars-stack .avatar-xl {
  margin-right: -1.6rem;
}
*[dir=rtl] .avatars-stack .avatar-xl {
  margin-left: -1.6rem;
}

.callout {
  --cui-callout-padding-x: 1rem;
  --cui-callout-padding-y: 1rem;
  --cui-callout-margin-x: 0;
  --cui-callout-margin-y: 1rem;
  --cui-callout-border-width: var(--cui-border-width);
  --cui-callout-border-color: var(--cui-border-color);
  --cui-callout-border-left-width: calc(var(--cui-border-width) * 4);
  --cui-callout-border-radius: var(--cui-border-radius);
  padding: var(--cui-callout-padding-y) var(--cui-callout-padding-x);
  margin: var(--cui-callout-margin-y) var(--cui-callout-margin-x);
  border: var(--cui-callout-border-width) solid var(--cui-callout-border-color);
  border-radius: var(--cui-callout-border-radius);
}
html:not([dir=rtl]) .callout {
  border-left-width: var(--cui-callout-border-left-width);
}
*[dir=rtl] .callout {
  border-right-width: var(--cui-callout-border-right-width);
}
html:not([dir=rtl]) .callout {
  border-left-color: var(--cui-callout-border-left-color);
}
*[dir=rtl] .callout {
  border-right-color: var(--cui-callout-border-right-color);
}

.callout-primary {
  --cui-callout-border-left-color: #321fdb;
}

.callout-secondary {
  --cui-callout-border-left-color: #9da5b1;
}

.callout-success {
  --cui-callout-border-left-color: #2eb85c;
}

.callout-danger {
  --cui-callout-border-left-color: #e55353;
}

.callout-warning {
  --cui-callout-border-left-color: #f9b115;
}

.callout-info {
  --cui-callout-border-left-color: #39f;
}

.callout-light {
  --cui-callout-border-left-color: #ebedef;
}

.callout-dark {
  --cui-callout-border-left-color: #818181;
}

.footer {
  --cui-footer-min-height: 3rem;
  --cui-footer-padding-x: 1rem;
  --cui-footer-padding-y: 0.5rem;
  --cui-footer-color: var(--cui-body-color);
  --cui-footer-bg: var(--cui-tertiary-bg);
  --cui-footer-border-color: var(--cui-border-color);
  --cui-footer-border: var(--cui-border-width) solid var(--cui-footer-border-color);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  min-height: var(--cui-footer-min-height);
  padding: var(--cui-footer-padding-y) var(--cui-footer-padding-x);
  color: var(--cui-footer-color);
  background: var(--cui-footer-bg);
  border-top: var(--cui-footer-border);
}

.footer-fixed {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.footer-sticky {
  position: sticky;
  bottom: 0;
  z-index: 1030;
}

.header {
  --cui-header-min-height: 4rem;
  --cui-header-padding-x: 0.5rem;
  --cui-header-padding-y: 0.5rem;
  --cui-header-bg: var(--cui-body-bg);
  --cui-header-color: rgba(var(--cui-emphasis-color-rgb), 0.65);
  --cui-header-border-color: var(--cui-border-color);
  --cui-header-border: var(--cui-border-width) solid var(--cui-header-border-color);
  --cui-header-hover-color: rgba(var(--cui-emphasis-color-rgb), 0.8);
  --cui-header-disabled-color: rgba(var(--cui-emphasis-color-rgb), 0.3);
  --cui-header-active-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-header-brand-padding-y: 0.3125rem;
  --cui-header-brand-color: #4f5d73;
  --cui-header-brand-hover-color: #475468;
  --cui-header-toggler-padding-x: 0.75rem;
  --cui-header-toggler-padding-y: 0.25rem;
  --cui-header-toggler-bg: transparent;
  --cui-header-toggler-color: rgba(var(--cui-emphasis-color-rgb), 0.65);
  --cui-header-toggler-border-radius: var(--cui-border-radius);
  --cui-header-toggler-hover-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-header-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --cui-header-toggler-hover-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --cui-header-nav-link-padding-x: 0.5rem;
  --cui-header-nav-link-padding-y: 0.5rem;
  --cui-header-divider-border-color: var(--cui-border-color);
  --cui-header-divider-border: var(--cui-border-width) solid var(--cui-header-divider-border-color);
  --cui-subheader-min-height: 3rem;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  min-height: var(--cui-header-min-height);
  padding: var(--cui-header-padding-y) var(--cui-header-padding-x);
  background: var(--cui-header-bg);
  border-bottom: var(--cui-header-border);
}
.header > .container,
.header > .container-fluid,
.header > .container-sm,
.header > .container-md,
.header > .container-lg,
.header > .container-xl,
.header > .container-xxl, .header .navbar > .container,
.header .navbar > .container-fluid,
.header .navbar > .container-sm,
.header .navbar > .container-md,
.header .navbar > .container-lg,
.header .navbar > .container-xl,
.header .navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.header .container:first-child,
.header .container-fluid:first-child,
.header .container-sm:first-child,
.header .container-md:first-child,
.header .container-lg:first-child,
.header .container-xl:first-child,
.header .container-xxl:first-child {
  min-height: calc(var(--cui-header-min-height) - 2 * var(--cui-header-padding-y));
}
.header .container:nth-child(n+2),
.header .container-fluid:nth-child(n+2),
.header .container-sm:nth-child(n+2),
.header .container-md:nth-child(n+2),
.header .container-lg:nth-child(n+2),
.header .container-xl:nth-child(n+2),
.header .container-xxl:nth-child(n+2) {
  min-height: calc(var(--cui-subheader-min-height) - 2 * var(--cui-header-padding-y));
}
.header.header-sticky {
  position: sticky;
  top: 0;
  z-index: 1029;
}

.header-divider {
  flex-basis: calc(100% + 2 * var(--cui-header-padding-x));
  height: 0;
  margin: var(--cui-header-padding-y) calc(var(--cui-header-padding-x) * -1);
  border-top: var(--cui-header-divider-border);
}

.header-brand {
  padding-top: var(--cui-header-brand-padding-y);
  padding-bottom: var(--cui-header-brand-padding-y);
  font-size: 1.25rem;
  color: var(--cui-header-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
html:not([dir=rtl]) .header-brand {
  margin-right: 1rem;
}
*[dir=rtl] .header-brand {
  margin-left: 1rem;
}
.header-brand:hover, .header-brand:focus {
  color: var(--cui-header-brand-hover-color);
}

.header-nav {
  display: flex;
  flex-direction: row;
  margin-bottom: 0;
  list-style: none;
}
html:not([dir=rtl]) .header-nav {
  padding-left: 0;
}
*[dir=rtl] .header-nav {
  padding-right: 0;
}
.header-nav .nav-link {
  padding: var(--cui-header-nav-link-padding-y) var(--cui-header-nav-link-padding-x);
  color: var(--cui-header-color);
}
.header-nav .nav-link:hover, .header-nav .nav-link:focus {
  color: var(--cui-header-hover-color);
}
.header-nav .nav-link.disabled {
  color: var(--cui-header-disabled-color);
}
.header-nav .show > .nav-link,
.header-nav .nav-link.active {
  color: var(--cui-header-active-color);
}
.header-nav .dropdown-menu {
  position: absolute;
}

.header-text {
  padding-top: var(--cui-header-nav-link-padding-y);
  padding-bottom: var(--cui-header-nav-link-padding-y);
  color: var(--cui-header-color);
}
.header-text a {
  color: var(--cui-header-active-color);
}
.header-text a:hover, .header-text a:focus {
  color: var(--cui-header-active-color);
}

.header-toggler {
  padding: var(--cui-header-toggler-padding-y) var(--cui-header-toggler-padding-x);
  font-size: 1.25rem;
  color: var(--cui-header-toggler-color);
  background-color: var(--cui-header-toggler-bg);
  border: 0;
  border-radius: var(--cui-header-toggler-border-radius);
}
.header-toggler:hover {
  color: var(--cui-header-toggler-hover-color);
  text-decoration: none;
}
.header-toggler:focus {
  outline: 0;
}
.header-toggler:not(:disabled) {
  cursor: pointer;
}

.header-toggler-icon {
  display: block;
  height: 1.5625rem;
  background-image: var(--cui-header-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;
}
.header-toggler-icon:hover {
  background-image: var(--cui-header-toggler-hover-icon-bg);
}

.icon {
  display: inline-block;
  color: inherit;
  text-align: center;
  vertical-align: -0.125rem;
  fill: currentcolor;
}
.icon:not(.icon-c-s):not(.icon-custom-size) {
  width: 1rem;
  height: 1rem;
  font-size: 1rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-xxl {
  width: 2rem;
  height: 2rem;
  font-size: 2rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-xl {
  width: 1.5rem;
  height: 1.5rem;
  font-size: 1.5rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-lg {
  width: 1.25rem;
  height: 1.25rem;
  font-size: 1.25rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-sm {
  width: 0.875rem;
  height: 0.875rem;
  font-size: 0.875rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-3xl {
  width: 3rem;
  height: 3rem;
  font-size: 3rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-4xl {
  width: 4rem;
  height: 4rem;
  font-size: 4rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-5xl {
  width: 5rem;
  height: 5rem;
  font-size: 5rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-6xl {
  width: 6rem;
  height: 6rem;
  font-size: 6rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-7xl {
  width: 7rem;
  height: 7rem;
  font-size: 7rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-8xl {
  width: 8rem;
  height: 8rem;
  font-size: 8rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-9xl {
  width: 9rem;
  height: 9rem;
  font-size: 9rem;
}

.sidebar {
  --cui-sidebar-width: 16rem;
  --cui-sidebar-bg: #3c4b64;
  --cui-sidebar-padding-x: 0;
  --cui-sidebar-padding-y: 0;
  --cui-sidebar-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-border-width: 0;
  --cui-sidebar-border-color: transparent;
  --cui-sidebar-brand-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-brand-height: 4rem;
  --cui-sidebar-brand-bg: rgba(70, 53, 41, 0.2);
  --cui-sidebar-header-height: 4rem;
  --cui-sidebar-header-bg: rgba(70, 53, 41, 0.2);
  --cui-sidebar-header-padding-x: 1rem;
  --cui-sidebar-header-padding-y: 0.75rem;
  --cui-sidebar-footer-bg: rgba(70, 53, 41, 0.2);
  --cui-sidebar-footer-height: auto;
  --cui-sidebar-footer-padding-x: 1rem;
  --cui-sidebar-footer-padding-y: 0.75rem;
  --cui-sidebar-toggler-bg: rgba(70, 53, 41, 0.2);
  --cui-sidebar-toggler-height: 3rem;
  --cui-sidebar-toggler-indicator: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  --cui-sidebar-toggler-indicator-width: 4rem;
  --cui-sidebar-toggler-indicator-height: 3rem;
  --cui-sidebar-toggler-hover-bg: rgba(0, 0, 0, 0.3);
  --cui-sidebar-toggler-indicator-hover: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  --cui-sidebar-narrow-width: 4rem;
  --cui-sidebar-nav-title-padding-x: 1rem;
  --cui-sidebar-nav-title-padding-y: 0.75rem;
  --cui-sidebar-nav-title-margin-top: 1rem;
  --cui-sidebar-nav-title-color: rgba(255, 255, 255, 0.6);
  --cui-sidebar-nav-link-padding-x: 1rem;
  --cui-sidebar-nav-link-padding-y: 0.8445rem;
  --cui-sidebar-nav-link-color: rgba(255, 255, 255, 0.6);
  --cui-sidebar-nav-link-bg: transparent;
  --cui-sidebar-nav-link-border-color: transparent;
  --cui-sidebar-nav-link-border: 0 solid var(--cui-sidebar-nav-link-border-color);
  --cui-sidebar-nav-link-border-radius: 0;
  --cui-sidebar-nav-link-active-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-nav-link-active-bg: rgba(255, 255, 255, 0.05);
  --cui-sidebar-nav-link-active-icon-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-nav-link-disabled-color: rgba(255, 255, 255, 0.38);
  --cui-sidebar-nav-link-disabled-icon-color: rgba(255, 255, 255, 0.6);
  --cui-sidebar-nav-link-hover-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-nav-link-hover-bg: rgba(255, 255, 255, 0.05);
  --cui-sidebar-nav-link-hover-icon-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-nav-icon-width: 4rem;
  --cui-sidebar-nav-icon-height: 1.25rem;
  --cui-sidebar-nav-icon-font-size: 1.25rem;
  --cui-sidebar-nav-link-icon-color: rgba(255, 255, 255, 0.6);
  --cui-sidebar-nav-group-bg: rgba(0, 0, 0, 0.2);
  --cui-sidebar-nav-group-items-padding-y: 0;
  --cui-sidebar-nav-group-items-padding-x: 0;
  --cui-sidebar-nav-group-indicator: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  --cui-sidebar-nav-group-indicator-hover: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  --cui-sidebar-nav-group-toggle-show-color: rgba(255, 255, 255, 0.6);
  position: relative;
  display: flex;
  flex: 0 0 var(--cui-sidebar-width);
  flex-direction: column;
  order: -1;
  width: var(--cui-sidebar-width);
  padding: var(--cui-sidebar-padding-y) var(--cui-sidebar-padding-x);
  color: var(--cui-sidebar-color);
  background: var(--cui-sidebar-bg);
  box-shadow: none;
  transition: margin-left 0.15s, margin-right 0.15s, box-shadow 0.075s, transform 0.15s, width 0.15s, z-index 0s ease 0.15s;
}
html:not([dir=rtl]) .sidebar {
  border-right: var(--cui-sidebar-border-width) solid var(--cui-sidebar-border-color);
}
*[dir=rtl] .sidebar {
  border-left: var(--cui-sidebar-border-width) solid var(--cui-sidebar-border-color);
}
@media (prefers-reduced-motion: reduce) {
  .sidebar {
    transition: none;
  }
}
html:not([dir=rtl]) .sidebar:not(.sidebar-end) {
  margin-left: 0;
}
*[dir=rtl] .sidebar:not(.sidebar-end) {
  margin-right: 0;
}
.sidebar:not(.sidebar-end) ~ * {
  --cui-sidebar-occupy-start: 16rem;
}
.sidebar.sidebar-end {
  order: 99;
}
html:not([dir=rtl]) .sidebar.sidebar-end {
  margin-right: 0;
}
*[dir=rtl] .sidebar.sidebar-end {
  margin-left: 0;
}
.sidebar.sidebar-end ~ * {
  --cui-sidebar-occupy-end: 16rem;
}
.sidebar[class*=bg-] {
  border-color: rgba(70, 53, 41, 0.1);
}
.sidebar.sidebar-sm {
  --cui-sidebar-width: 12rem;
}
@media (min-width: 768px) {
  .sidebar.sidebar-sm:not(.sidebar-end):not(.hide) ~ * {
    --cui-sidebar-occupy-start: 12rem;
  }
  .sidebar.sidebar-sm.sidebar-end:not(.hide) ~ * {
    --cui-sidebar-occupy-end: 12rem;
  }
}
.sidebar.sidebar-lg {
  --cui-sidebar-width: 20rem;
}
@media (min-width: 768px) {
  .sidebar.sidebar-lg:not(.sidebar-end):not(.hide) ~ * {
    --cui-sidebar-occupy-start: 20rem;
  }
  .sidebar.sidebar-lg.sidebar-end:not(.hide) ~ * {
    --cui-sidebar-occupy-end: 20rem;
  }
}
.sidebar.sidebar-xl {
  --cui-sidebar-width: 24rem;
}
@media (min-width: 768px) {
  .sidebar.sidebar-xl:not(.sidebar-end):not(.hide) ~ * {
    --cui-sidebar-occupy-start: 24rem;
  }
  .sidebar.sidebar-xl.sidebar-end:not(.hide) ~ * {
    --cui-sidebar-occupy-end: 24rem;
  }
}
@media (min-width: 768px) {
  html:not([dir=rtl]) .sidebar.hide:not(.sidebar-end) {
    margin-left: calc(-1 * var(--cui-sidebar-width));
  }
  *[dir=rtl] .sidebar.hide:not(.sidebar-end) {
    margin-right: calc(-1 * var(--cui-sidebar-width));
  }
  .sidebar.hide:not(.sidebar-end) ~ * {
    --cui-sidebar-occupy-start: 0;
  }
  html:not([dir=rtl]) .sidebar.hide.sidebar-end {
    margin-right: calc(-1 * var(--cui-sidebar-width));
  }
  *[dir=rtl] .sidebar.hide.sidebar-end {
    margin-left: calc(-1 * var(--cui-sidebar-width));
  }
  .sidebar.hide.sidebar-end ~ * {
    --cui-sidebar-occupy-end: 0;
  }
}
@media (min-width: 768px) {
  .sidebar.sidebar-fixed {
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: 1030;
  }
  html:not([dir=rtl]) .sidebar.sidebar-fixed:not(.sidebar-end) {
    left: 0;
  }
  *[dir=rtl] .sidebar.sidebar-fixed:not(.sidebar-end) {
    right: 0;
  }
  html:not([dir=rtl]) .sidebar.sidebar-fixed.sidebar-end {
    right: 0;
  }
  *[dir=rtl] .sidebar.sidebar-fixed.sidebar-end {
    left: 0;
  }
}
@media (min-width: 768px) {
  .sidebar.sidebar-sticky {
    position: sticky;
    top: 0;
    height: 100vh;
  }
}
.sidebar.sidebar-overlaid {
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: 1032;
}
html:not([dir=rtl]) .sidebar.sidebar-overlaid:not(.sidebar-end) {
  left: 0;
}
*[dir=rtl] .sidebar.sidebar-overlaid:not(.sidebar-end) {
  right: 0;
}
.sidebar.sidebar-overlaid:not(.sidebar-end) ~ * {
  --cui-sidebar-occupy-start: 0;
}
html:not([dir=rtl]) .sidebar.sidebar-overlaid.sidebar-end {
  right: 0;
}
*[dir=rtl] .sidebar.sidebar-overlaid.sidebar-end {
  left: 0;
}
.sidebar.sidebar-overlaid.sidebar-end ~ * {
  --cui-sidebar-occupy-end: 0;
}
@media (max-width: 767.98px) {
  .sidebar {
    --cui-is-mobile: true;
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: 1031;
  }
  html:not([dir=rtl]) .sidebar:not(.sidebar-end) {
    left: 0;
  }
  *[dir=rtl] .sidebar:not(.sidebar-end) {
    right: 0;
  }
  .sidebar:not(.sidebar-end) ~ * {
    --cui-sidebar-occupy-start: 0 !important;
  }
  html:not([dir=rtl]) .sidebar:not(.sidebar-end):not(.show) {
    margin-left: calc(-1 * var(--cui-sidebar-width));
  }
  *[dir=rtl] .sidebar:not(.sidebar-end):not(.show) {
    margin-right: calc(-1 * var(--cui-sidebar-width));
  }
  html:not([dir=rtl]) .sidebar.sidebar-end {
    right: 0;
  }
  *[dir=rtl] .sidebar.sidebar-end {
    left: 0;
  }
  .sidebar.sidebar-end ~ * {
    --cui-sidebar-occupy-end: 0 !important;
  }
  html:not([dir=rtl]) .sidebar.sidebar-end:not(.show) {
    margin-right: calc(-1 * var(--cui-sidebar-width));
  }
  *[dir=rtl] .sidebar.sidebar-end:not(.show) {
    margin-left: calc(-1 * var(--cui-sidebar-width));
  }
}

.sidebar-close {
  position: absolute;
  top: 0;
  width: var(--cui-sidebar-width);
  height: var(--cui-sidebar-header-height);
  color: var(--cui-sidebar-color);
  background: transparent;
  border: 0;
}
html:not([dir=rtl]) .sidebar-close {
  right: 0;
}
*[dir=rtl] .sidebar-close {
  left: 0;
}
.sidebar-close:hover {
  text-decoration: none;
}
.sidebar-close:focus {
  outline: 0;
}

.sidebar-brand {
  display: flex;
  flex: 0 0 var(--cui-sidebar-brand-height);
  align-items: center;
  justify-content: center;
  color: var(--cui-sidebar-brand-color);
  background: var(--cui-sidebar-brand-bg);
}
.sidebar-brand .sidebar-brand-narrow {
  display: none;
}

.sidebar-header {
  flex: 0 0 var(--cui-sidebar-header-height);
  padding: var(--cui-sidebar-header-padding-y) var(--cui-sidebar-header-padding-x);
  text-align: center;
  background: var(--cui-sidebar-header-bg);
  transition: height 0.15s, padding 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-header {
    transition: none;
  }
}
.sidebar-header .nav-link {
  display: flex;
  align-items: center;
  min-height: var(--cui-sidebar-header-height);
}

.sidebar-footer {
  flex: 0 0 var(--cui-sidebar-footer-height);
  padding: var(--cui-sidebar-footer-padding-y) var(--cui-sidebar-footer-padding-x);
  background: var(--cui-sidebar-footer-bg);
  transition: height 0.15s, padding 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-footer {
    transition: none;
  }
}

.sidebar-toggler {
  display: flex;
  flex: 0 0 var(--cui-sidebar-toggler-height);
  justify-content: flex-end;
  width: inherit;
  padding: 0;
  cursor: pointer;
  background-color: var(--cui-sidebar-toggler-bg);
  border: 0;
}
@media (max-width: 767.98px) {
  .sidebar-toggler {
    display: none;
  }
}
.sidebar-toggler::before {
  display: block;
  width: var(--cui-sidebar-toggler-indicator-width);
  height: var(--cui-sidebar-toggler-indicator-height);
  content: "";
  background-image: var(--cui-sidebar-toggler-indicator);
  background-repeat: no-repeat;
  background-position: center;
  background-size: calc(var(--cui-sidebar-toggler-indicator-height) * 0.25);
  transition: transform 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-toggler::before {
    transition: none;
  }
}
*[dir=rtl] .sidebar-toggler::before {
  transform: rotate(-180deg);
}
.sidebar-toggler:focus {
  outline: 0;
}
.sidebar-toggler:hover {
  background-color: var(--cui-sidebar-toggler-hover-bg);
}
.sidebar-toggler:hover::before {
  background-image: var(--cui-sidebar-toggler-indicator-hover);
}
.sidebar-end .sidebar-toggler {
  justify-content: flex-start;
}
.sidebar-end .sidebar-toggler::before {
  transform: rotate(-180deg);
}

.sidebar-backdrop {
  --cui-backdrop-zindex: 1030;
  --cui-backdrop-bg: #463529;
  --cui-backdrop-opacity: 0.5;
}
@media (max-width: 767.98px) {
  .sidebar-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: var(--cui-backdrop-zindex);
    width: 100vw;
    height: 100vh;
    background-color: var(--cui-backdrop-bg);
  }
  .sidebar-backdrop.fade {
    opacity: 0;
  }
  .sidebar-backdrop.show {
    opacity: var(--cui-backdrop-opacity);
  }
}

.sidebar-nav {
  position: relative;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  padding: 0;
  margin-bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;
  list-style: none;
}
.sidebar-nav .nav-title {
  padding: var(--cui-sidebar-nav-title-padding-y) var(--cui-sidebar-nav-title-padding-x);
  margin-top: var(--cui-sidebar-nav-title-margin-top);
  font-size: 80%;
  font-weight: 700;
  color: var(--cui-sidebar-nav-title-color);
  text-transform: uppercase;
  transition: height 0.15s, margin 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-title {
    transition: none;
  }
}
.sidebar-nav .nav-link {
  display: flex;
  flex: 1 1;
  align-items: center;
  padding: var(--cui-sidebar-nav-link-padding-y) var(--cui-sidebar-nav-link-padding-x);
  color: var(--cui-sidebar-nav-link-color);
  text-decoration: none;
  white-space: nowrap;
  background: var(--cui-sidebar-nav-link-bg);
  border: var(--cui-sidebar-nav-link-border);
  border-radius: var(--cui-sidebar-nav-link-border-radius);
  transition: background 0.15s ease, color 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-link {
    transition: none;
  }
}
.sidebar-nav .nav-link.active {
  color: var(--cui-sidebar-nav-link-active-color);
  background: var(--cui-sidebar-nav-link-active-bg);
}
.sidebar-nav .nav-link.active .nav-icon {
  color: var(--cui-sidebar-nav-link-active-icon-color);
}
.sidebar-nav .nav-link.disabled {
  color: var(--cui-sidebar-nav-link-disabled-color);
  pointer-events: none;
  cursor: not-allowed;
  background: transparent;
}
.sidebar-nav .nav-link.disabled .nav-icon {
  color: var(--cui-sidebar-nav-link-disabled-icon-color);
}
.sidebar-nav .nav-link.disabled:hover {
  color: var(--cui-sidebar-nav-link-disabled-color);
}
.sidebar-nav .nav-link.disabled:hover .nav-icon {
  color: var(--cui-sidebar-nav-link-disabled-icon-color);
}
.sidebar-nav .nav-link.disabled:hover.nav-dropdown-toggle::after {
  background-image: var(--cui-sidebar-nav-group-indicator-hover);
}
@media (hover: hover), (-ms-high-contrast: none) {
  .sidebar-nav .nav-link:hover {
    color: var(--cui-sidebar-nav-link-hover-color);
    text-decoration: none;
    background: var(--cui-sidebar-nav-link-hover-bg);
  }
  .sidebar-nav .nav-link:hover .nav-icon {
    color: var(--cui-sidebar-nav-link-hover-icon-color);
  }
  .sidebar-nav .nav-link:hover.nav-group-toggle::after {
    background-image: var(--cui-sidebar-nav-group-indicator-hover);
  }
}
.sidebar-nav .nav-icon {
  flex: 0 0 var(--cui-sidebar-nav-icon-width);
  height: var(--cui-sidebar-nav-icon-height);
  font-size: var(--cui-sidebar-nav-icon-font-size);
  color: var(--cui-sidebar-nav-link-icon-color);
  text-align: center;
  pointer-events: none;
  fill: currentcolor;
  transition: inherit;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-icon {
    transition: none;
  }
}
html:not([dir=rtl]) .sidebar-nav .nav-icon:first-child {
  margin-left: calc(var(--cui-sidebar-nav-link-padding-x) * -1);
}
*[dir=rtl] .sidebar-nav .nav-icon:first-child {
  margin-right: calc(var(--cui-sidebar-nav-link-padding-x) * -1);
}
.sidebar-nav svg.nav-icon {
  overflow: hidden;
}
.sidebar-nav .nav-group {
  position: relative;
  transition: background 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-group {
    transition: none;
  }
}
.sidebar-nav .nav-group .nav-group-items {
  padding: var(--cui-sidebar-nav-group-items-padding-y) var(--cui-sidebar-nav-group-items-padding-x);
  overflow: hidden;
  transition: height 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-group .nav-group-items {
    transition: none;
  }
}
.sidebar-nav .nav-group:not(.show) .nav-group-items {
  display: none;
}
.sidebar-nav .nav-group.show {
  background: var(--cui-sidebar-nav-group-bg);
}
.sidebar-nav .nav-group.show .nav-group-toggle {
  color: var(--cui-sidebar-nav-group-toggle-show-color);
}
.sidebar-nav .nav-group.show > .nav-group-toggle::after {
  transform: rotate(180deg);
}
.sidebar-nav .nav-group.show + .show {
  margin-top: 1px;
}
.sidebar-nav .nav-group-toggle {
  cursor: pointer;
}
.sidebar-nav .nav-group-toggle::after {
  display: block;
  flex: 0 1 12px;
  height: 12px;
  content: "";
  background-image: var(--cui-sidebar-nav-group-indicator);
  background-repeat: no-repeat;
  background-position: center;
  transition: transform 0.15s;
}
html:not([dir=rtl]) .sidebar-nav .nav-group-toggle::after {
  margin-left: auto;
}
*[dir=rtl] .sidebar-nav .nav-group-toggle::after {
  margin-right: auto;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-group-toggle::after {
    transition: none;
  }
}
.sidebar-nav .nav-group-items {
  padding: 0;
  list-style: none;
}
html:not([dir=rtl]) .sidebar-nav .nav-group-items .nav-link {
  padding-left: var(--cui-sidebar-nav-icon-width);
}
*[dir=rtl] .sidebar-nav .nav-group-items .nav-link {
  padding-right: var(--cui-sidebar-nav-icon-width);
}
html:not([dir=rtl]) .sidebar-nav .nav-group-items .nav-link .nav-icon {
  margin-left: calc(var(--cui-sidebar-nav-icon-width) * -1);
}
*[dir=rtl] .sidebar-nav .nav-group-items .nav-link .nav-icon {
  margin-right: calc(var(--cui-sidebar-nav-icon-width) * -1);
}
.sidebar-nav.compact .nav-link,
.sidebar-nav .compact .nav-link {
  padding-top: calc(var(--cui-sidebar-nav-link-padding-y) * 0.5);
  padding-bottom: calc(var(--cui-sidebar-nav-link-padding-y) * 0.5);
}

@media (min-width: 768px) {
  .sidebar-narrow-unfoldable:not(:hover), .sidebar-narrow {
    z-index: 1031;
    flex: 0 0 var(--cui-sidebar-narrow-width);
    width: var(--cui-sidebar-narrow-width);
    padding-bottom: var(--cui-sidebar-toggler-height);
    overflow: visible;
  }
  .sidebar-fixed.sidebar-narrow-unfoldable:not(:hover), .sidebar-fixed.sidebar-narrow {
    z-index: 1031;
    width: var(--cui-sidebar-narrow-width);
  }
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-brand-full, .sidebar-narrow .sidebar-brand-full {
    display: none;
  }
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-brand-narrow, .sidebar-narrow .sidebar-brand-narrow {
    display: block;
  }
  .sidebar-narrow-unfoldable:not(:hover) .d-narrow-none, .sidebar-narrow .d-narrow-none,
  .sidebar-narrow-unfoldable:not(:hover) .nav-label,
  .sidebar-narrow .nav-label,
  .sidebar-narrow-unfoldable:not(:hover) .nav-title,
  .sidebar-narrow .nav-title,
  .sidebar-narrow-unfoldable:not(:hover) .nav-group-items,
  .sidebar-narrow .nav-group-items,
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-footer,
  .sidebar-narrow .sidebar-footer,
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-form,
  .sidebar-narrow .sidebar-form,
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-header,
  .sidebar-narrow .sidebar-header {
    height: 0 !important;
    padding: 0;
    margin: 0;
    visibility: hidden;
    opacity: 0;
  }
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-toggler, .sidebar-narrow .sidebar-toggler {
    position: fixed;
    bottom: 0;
  }
  html:not([dir=rtl]) .sidebar-narrow-unfoldable:not(:hover) .sidebar-toggler::before, html:not([dir=rtl]) .sidebar-narrow .sidebar-toggler::before {
    transform: rotate(-180deg);
  }
  *[dir=rtl] .sidebar-narrow-unfoldable:not(:hover) .sidebar-toggler::before, *[dir=rtl] .sidebar-narrow .sidebar-toggler::before {
    transform: rotate(0deg);
  }
  .sidebar-end.sidebar-narrow-unfoldable:not(:hover) .sidebar-toggler::before, .sidebar-end.sidebar-narrow .sidebar-toggler::before {
    transform: rotate(0deg);
  }
}

.sidebar-narrow:not(.sidebar-end) ~ * {
  --cui-sidebar-occupy-start: 4rem;
}
.sidebar-narrow.sidebar-end ~ * {
  --cui-sidebar-occupy-end: 4rem;
}

.sidebar-narrow-unfoldable {
  position: fixed;
  z-index: 1031;
}
.sidebar-narrow-unfoldable:not(.sidebar-end) ~ * {
  --cui-sidebar-occupy-start: 4rem;
}
.sidebar-narrow-unfoldable.sidebar-end ~ * {
  --cui-sidebar-occupy-end: 4rem;
}
html:not([dir=rtl]) .sidebar-narrow-unfoldable:hover .sidebar-toggler::before {
  transform: rotate(-180deg);
}
*[dir=rtl] .sidebar-narrow-unfoldable:hover .sidebar-toggler::before {
  transform: rotate(0deg);
}
.sidebar-narrow-unfoldable:hover.sidebar-end .sidebar-toggler::before {
  transform: rotate(0deg);
}

html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow:not(.sidebar-end), html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow-unfoldable:not(.sidebar-end) {
  margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
}
*[dir=rtl] .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow:not(.sidebar-end), *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow-unfoldable:not(.sidebar-end) {
  margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
}
html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow.sidebar-end, html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow-unfoldable.sidebar-end {
  margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
}
*[dir=rtl] .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow.sidebar-end, *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow-unfoldable.sidebar-end {
  margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
}

@media (max-width: 575.98px) {
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow:not(.sidebar-end), html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow:not(.sidebar-end), *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow.sidebar-end, html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow-unfoldable.sidebar-end {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow.sidebar-end, *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow-unfoldable.sidebar-end {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
}
@media (max-width: 767.98px) {
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow:not(.sidebar-end), html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow:not(.sidebar-end), *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow.sidebar-end, html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow-unfoldable.sidebar-end {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow.sidebar-end, *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow-unfoldable.sidebar-end {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
}
@media (max-width: 991.98px) {
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow:not(.sidebar-end), html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow:not(.sidebar-end), *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow.sidebar-end, html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow-unfoldable.sidebar-end {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow.sidebar-end, *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow-unfoldable.sidebar-end {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
}
@media (max-width: 1199.98px) {
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow:not(.sidebar-end), html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow:not(.sidebar-end), *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow.sidebar-end, html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow-unfoldable.sidebar-end {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow.sidebar-end, *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow-unfoldable.sidebar-end {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
}
@media (max-width: 1399.98px) {
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow:not(.sidebar-end), html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow:not(.sidebar-end), *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow.sidebar-end, html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow-unfoldable.sidebar-end {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow.sidebar-end, *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow-unfoldable.sidebar-end {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
}
.subheader {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  min-height: 3rem;
  padding: 0.5rem 1rem;
  background: var(--cui-subheader-bg, #FFFFFF);
  border-bottom: var(--cui-subheader-border-width, var(--cui-border-width)) solid var(--cui-subheader-border-color, var(--cui-border-color));
}

.subheader-sticky {
  position: sticky;
  top: 0;
  z-index: 1029;
}

.subheader-nav {
  display: flex;
  flex-direction: row;
  margin-bottom: 0;
  list-style: none;
}
html:not([dir=rtl]) .subheader-nav {
  padding-left: 0;
}
*[dir=rtl] .subheader-nav {
  padding-right: 0;
}
.subheader-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  color: var(--cui-subheader-color, var(--cui-secondary-color));
}
.subheader-nav .nav-link:hover, .subheader-nav .nav-link:focus {
  color: var(--cui-subheader-hover-color, var(--cui-body-color));
}
.subheader-nav .nav-link.disabled {
  color: var(--cui-subheader-disabled-color, rgba(44, 56, 74, 0.38));
}
.subheader-nav .show > .nav-link,
.subheader-nav .nav-link.active {
  color: var(--cui-subheader-active-color, var(--cui-body-color));
}
.subheader-nav .dropdown-menu {
  position: absolute;
}

.subheader-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--cui-subheader-color, var(--cui-secondary-color));
}
.subheader-text a {
  color: var(--cui-subheader-active-color, var(--cui-body-color));
}
.subheader-text a:hover, .subheader-text a:focus {
  color: var(--cui-subheader-active-color, var(--cui-body-color));
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: rgba(255, 255, 255, 0.87) !important;
  background-color: RGBA(var(--cui-primary-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #463529 !important;
  background-color: RGBA(var(--cui-secondary-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #463529 !important;
  background-color: RGBA(var(--cui-success-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #463529 !important;
  background-color: RGBA(var(--cui-info-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: rgba(44, 56, 74, 0.95) !important;
  background-color: RGBA(var(--cui-warning-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #FFFFFF !important;
  background-color: RGBA(var(--cui-danger-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: rgba(44, 56, 74, 0.95) !important;
  background-color: RGBA(var(--cui-light-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #FFFFFF !important;
  background-color: RGBA(var(--cui-dark-rgb), var(--cui-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--cui-primary-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-primary-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(91, 76, 226, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(91, 76, 226, var(--cui-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--cui-secondary-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-secondary-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(177, 183, 193, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(177, 183, 193, var(--cui-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--cui-success-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-success-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(88, 198, 125, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(88, 198, 125, var(--cui-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--cui-info-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-info-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(92, 173, 255, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(92, 173, 255, var(--cui-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--cui-warning-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-warning-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(199, 142, 17, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(199, 142, 17, var(--cui-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--cui-danger-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-danger-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(234, 117, 117, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(234, 117, 117, var(--cui-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--cui-light-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-light-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(188, 190, 191, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(188, 190, 191, var(--cui-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--cui-dark-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-dark-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(154, 154, 154, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(154, 154, 154, var(--cui-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--cui-emphasis-color-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-emphasis-color-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--cui-emphasis-color-rgb), var(--cui-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--cui-emphasis-color-rgb), var(--cui-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--cui-focus-ring-x, 0) var(--cui-focus-ring-y, 0) var(--cui-focus-ring-blur, 0) var(--cui-focus-ring-width) var(--cui-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--cui-link-color-rgb), var(--cui-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--cui-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--cui-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}
html:not([dir=rtl]) .ratio > * {
  left: 0;
}
*[dir=rtl] .ratio > * {
  right: 0;
}

.ratio-1x1 {
  --cui-aspect-ratio: 100%;
}

.ratio-4x3 {
  --cui-aspect-ratio: 75%;
}

.ratio-16x9 {
  --cui-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --cui-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--cui-border-width);
  min-height: 1em;
  padding: 0;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

html:not([dir=rtl]) .float-start {
  float: left !important;
}
*[dir=rtl] .float-start {
  float: right !important;
}

html:not([dir=rtl]) .float-end {
  float: right !important;
}
*[dir=rtl] .float-end {
  float: left !important;
}

html:not([dir=rtl]) .float-none {
  float: none !important;
}
*[dir=rtl] .float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(70, 53, 41, 0.15) !important;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(70, 53, 41, 0.075) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(70, 53, 41, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --cui-focus-ring-color: rgba(var(--cui-primary-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-secondary {
  --cui-focus-ring-color: rgba(var(--cui-secondary-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-success {
  --cui-focus-ring-color: rgba(var(--cui-success-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-info {
  --cui-focus-ring-color: rgba(var(--cui-info-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-warning {
  --cui-focus-ring-color: rgba(var(--cui-warning-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-danger {
  --cui-focus-ring-color: rgba(var(--cui-danger-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-light {
  --cui-focus-ring-color: rgba(var(--cui-light-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-dark {
  --cui-focus-ring-color: rgba(var(--cui-dark-rgb), var(--cui-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

html:not([dir=rtl]) .border-end {
  border-right: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}
*[dir=rtl] .border-end {
  border-left: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

html:not([dir=rtl]) .border-end-0 {
  border-right: 0 !important;
}
*[dir=rtl] .border-end-0 {
  border-left: 0 !important;
}

.border-bottom {
  border-bottom: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

html:not([dir=rtl]) .border-start {
  border-left: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}
*[dir=rtl] .border-start {
  border-right: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

html:not([dir=rtl]) .border-start-0 {
  border-left: 0 !important;
}
*[dir=rtl] .border-start-0 {
  border-right: 0 !important;
}

.border-primary {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-primary-rgb), var(--cui-border-opacity)) !important;
}

.border-secondary {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-secondary-rgb), var(--cui-border-opacity)) !important;
}

.border-success {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-success-rgb), var(--cui-border-opacity)) !important;
}

.border-info {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-info-rgb), var(--cui-border-opacity)) !important;
}

.border-warning {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-warning-rgb), var(--cui-border-opacity)) !important;
}

.border-danger {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-danger-rgb), var(--cui-border-opacity)) !important;
}

.border-light {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-light-rgb), var(--cui-border-opacity)) !important;
}

.border-dark {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-dark-rgb), var(--cui-border-opacity)) !important;
}

.border-white {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-white-rgb), var(--cui-border-opacity)) !important;
}

.border-top-primary {
  border-top-color: #321fdb !important;
}

.border-top-secondary {
  border-top-color: #9da5b1 !important;
}

.border-top-success {
  border-top-color: #2eb85c !important;
}

.border-top-info {
  border-top-color: #39f !important;
}

.border-top-warning {
  border-top-color: #f9b115 !important;
}

.border-top-danger {
  border-top-color: #e55353 !important;
}

.border-top-light {
  border-top-color: #ebedef !important;
}

.border-top-dark {
  border-top-color: #818181 !important;
}

.border-top-white {
  border-top-color: #FFFFFF !important;
}

html:not([dir=rtl]) .border-end-primary {
  border-right-color: #321fdb !important;
}
*[dir=rtl] .border-end-primary {
  border-left-color: #321fdb !important;
}

html:not([dir=rtl]) .border-end-secondary {
  border-right-color: #9da5b1 !important;
}
*[dir=rtl] .border-end-secondary {
  border-left-color: #9da5b1 !important;
}

html:not([dir=rtl]) .border-end-success {
  border-right-color: #2eb85c !important;
}
*[dir=rtl] .border-end-success {
  border-left-color: #2eb85c !important;
}

html:not([dir=rtl]) .border-end-info {
  border-right-color: #39f !important;
}
*[dir=rtl] .border-end-info {
  border-left-color: #39f !important;
}

html:not([dir=rtl]) .border-end-warning {
  border-right-color: #f9b115 !important;
}
*[dir=rtl] .border-end-warning {
  border-left-color: #f9b115 !important;
}

html:not([dir=rtl]) .border-end-danger {
  border-right-color: #e55353 !important;
}
*[dir=rtl] .border-end-danger {
  border-left-color: #e55353 !important;
}

html:not([dir=rtl]) .border-end-light {
  border-right-color: #ebedef !important;
}
*[dir=rtl] .border-end-light {
  border-left-color: #ebedef !important;
}

html:not([dir=rtl]) .border-end-dark {
  border-right-color: #818181 !important;
}
*[dir=rtl] .border-end-dark {
  border-left-color: #818181 !important;
}

html:not([dir=rtl]) .border-end-white {
  border-right-color: #FFFFFF !important;
}
*[dir=rtl] .border-end-white {
  border-left-color: #FFFFFF !important;
}

.border-bottom-primary {
  border-bottom-color: #321fdb !important;
}

.border-bottom-secondary {
  border-bottom-color: #9da5b1 !important;
}

.border-bottom-success {
  border-bottom-color: #2eb85c !important;
}

.border-bottom-info {
  border-bottom-color: #39f !important;
}

.border-bottom-warning {
  border-bottom-color: #f9b115 !important;
}

.border-bottom-danger {
  border-bottom-color: #e55353 !important;
}

.border-bottom-light {
  border-bottom-color: #ebedef !important;
}

.border-bottom-dark {
  border-bottom-color: #818181 !important;
}

.border-bottom-white {
  border-bottom-color: #FFFFFF !important;
}

html:not([dir=rtl]) .border-start-primary {
  border-left-color: #321fdb !important;
}
*[dir=rtl] .border-start-primary {
  border-right-color: #321fdb !important;
}

html:not([dir=rtl]) .border-start-secondary {
  border-left-color: #9da5b1 !important;
}
*[dir=rtl] .border-start-secondary {
  border-right-color: #9da5b1 !important;
}

html:not([dir=rtl]) .border-start-success {
  border-left-color: #2eb85c !important;
}
*[dir=rtl] .border-start-success {
  border-right-color: #2eb85c !important;
}

html:not([dir=rtl]) .border-start-info {
  border-left-color: #39f !important;
}
*[dir=rtl] .border-start-info {
  border-right-color: #39f !important;
}

html:not([dir=rtl]) .border-start-warning {
  border-left-color: #f9b115 !important;
}
*[dir=rtl] .border-start-warning {
  border-right-color: #f9b115 !important;
}

html:not([dir=rtl]) .border-start-danger {
  border-left-color: #e55353 !important;
}
*[dir=rtl] .border-start-danger {
  border-right-color: #e55353 !important;
}

html:not([dir=rtl]) .border-start-light {
  border-left-color: #ebedef !important;
}
*[dir=rtl] .border-start-light {
  border-right-color: #ebedef !important;
}

html:not([dir=rtl]) .border-start-dark {
  border-left-color: #818181 !important;
}
*[dir=rtl] .border-start-dark {
  border-right-color: #818181 !important;
}

html:not([dir=rtl]) .border-start-white {
  border-left-color: #FFFFFF !important;
}
*[dir=rtl] .border-start-white {
  border-right-color: #FFFFFF !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-top-1 {
  border-top-width: 1px !important;
}

.border-top-2 {
  border-top-width: 2px !important;
}

.border-top-3 {
  border-top-width: 3px !important;
}

.border-top-4 {
  border-top-width: 4px !important;
}

.border-top-5 {
  border-top-width: 5px !important;
}

html:not([dir=rtl]) .border-end-1 {
  border-right-width: 1px !important;
}
*[dir=rtl] .border-end-1 {
  border-left-width: 1px !important;
}

html:not([dir=rtl]) .border-end-2 {
  border-right-width: 2px !important;
}
*[dir=rtl] .border-end-2 {
  border-left-width: 2px !important;
}

html:not([dir=rtl]) .border-end-3 {
  border-right-width: 3px !important;
}
*[dir=rtl] .border-end-3 {
  border-left-width: 3px !important;
}

html:not([dir=rtl]) .border-end-4 {
  border-right-width: 4px !important;
}
*[dir=rtl] .border-end-4 {
  border-left-width: 4px !important;
}

html:not([dir=rtl]) .border-end-5 {
  border-right-width: 5px !important;
}
*[dir=rtl] .border-end-5 {
  border-left-width: 5px !important;
}

.border-bottom-1 {
  border-bottom-width: 1px !important;
}

.border-bottom-2 {
  border-bottom-width: 2px !important;
}

.border-bottom-3 {
  border-bottom-width: 3px !important;
}

.border-bottom-4 {
  border-bottom-width: 4px !important;
}

.border-bottom-5 {
  border-bottom-width: 5px !important;
}

html:not([dir=rtl]) .border-start-1 {
  border-left-width: 1px !important;
}
*[dir=rtl] .border-start-1 {
  border-right-width: 1px !important;
}

html:not([dir=rtl]) .border-start-2 {
  border-left-width: 2px !important;
}
*[dir=rtl] .border-start-2 {
  border-right-width: 2px !important;
}

html:not([dir=rtl]) .border-start-3 {
  border-left-width: 3px !important;
}
*[dir=rtl] .border-start-3 {
  border-right-width: 3px !important;
}

html:not([dir=rtl]) .border-start-4 {
  border-left-width: 4px !important;
}
*[dir=rtl] .border-start-4 {
  border-right-width: 4px !important;
}

html:not([dir=rtl]) .border-start-5 {
  border-left-width: 5px !important;
}
*[dir=rtl] .border-start-5 {
  border-right-width: 5px !important;
}

.border-opacity-10 {
  --cui-border-opacity: 0.1;
}

.border-opacity-25 {
  --cui-border-opacity: 0.25;
}

.border-opacity-50 {
  --cui-border-opacity: 0.5;
}

.border-opacity-75 {
  --cui-border-opacity: 0.75;
}

.border-opacity-100 {
  --cui-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

html:not([dir=rtl]) .me-0 {
  margin-right: 0 !important;
}
*[dir=rtl] .me-0 {
  margin-left: 0 !important;
}

html:not([dir=rtl]) .me-1 {
  margin-right: 0.25rem !important;
}
*[dir=rtl] .me-1 {
  margin-left: 0.25rem !important;
}

html:not([dir=rtl]) .me-2 {
  margin-right: 0.5rem !important;
}
*[dir=rtl] .me-2 {
  margin-left: 0.5rem !important;
}

html:not([dir=rtl]) .me-3 {
  margin-right: 1rem !important;
}
*[dir=rtl] .me-3 {
  margin-left: 1rem !important;
}

html:not([dir=rtl]) .me-4 {
  margin-right: 1.5rem !important;
}
*[dir=rtl] .me-4 {
  margin-left: 1.5rem !important;
}

html:not([dir=rtl]) .me-5 {
  margin-right: 3rem !important;
}
*[dir=rtl] .me-5 {
  margin-left: 3rem !important;
}

html:not([dir=rtl]) .me-auto {
  margin-right: auto !important;
}
*[dir=rtl] .me-auto {
  margin-left: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

html:not([dir=rtl]) .ms-0 {
  margin-left: 0 !important;
}
*[dir=rtl] .ms-0 {
  margin-right: 0 !important;
}

html:not([dir=rtl]) .ms-1 {
  margin-left: 0.25rem !important;
}
*[dir=rtl] .ms-1 {
  margin-right: 0.25rem !important;
}

html:not([dir=rtl]) .ms-2 {
  margin-left: 0.5rem !important;
}
*[dir=rtl] .ms-2 {
  margin-right: 0.5rem !important;
}

html:not([dir=rtl]) .ms-3 {
  margin-left: 1rem !important;
}
*[dir=rtl] .ms-3 {
  margin-right: 1rem !important;
}

html:not([dir=rtl]) .ms-4 {
  margin-left: 1.5rem !important;
}
*[dir=rtl] .ms-4 {
  margin-right: 1.5rem !important;
}

html:not([dir=rtl]) .ms-5 {
  margin-left: 3rem !important;
}
*[dir=rtl] .ms-5 {
  margin-right: 3rem !important;
}

html:not([dir=rtl]) .ms-auto {
  margin-left: auto !important;
}
*[dir=rtl] .ms-auto {
  margin-right: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

html:not([dir=rtl]) .pe-0 {
  padding-right: 0 !important;
}
*[dir=rtl] .pe-0 {
  padding-left: 0 !important;
}

html:not([dir=rtl]) .pe-1 {
  padding-right: 0.25rem !important;
}
*[dir=rtl] .pe-1 {
  padding-left: 0.25rem !important;
}

html:not([dir=rtl]) .pe-2 {
  padding-right: 0.5rem !important;
}
*[dir=rtl] .pe-2 {
  padding-left: 0.5rem !important;
}

html:not([dir=rtl]) .pe-3 {
  padding-right: 1rem !important;
}
*[dir=rtl] .pe-3 {
  padding-left: 1rem !important;
}

html:not([dir=rtl]) .pe-4 {
  padding-right: 1.5rem !important;
}
*[dir=rtl] .pe-4 {
  padding-left: 1.5rem !important;
}

html:not([dir=rtl]) .pe-5 {
  padding-right: 3rem !important;
}
*[dir=rtl] .pe-5 {
  padding-left: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

html:not([dir=rtl]) .ps-0 {
  padding-left: 0 !important;
}
*[dir=rtl] .ps-0 {
  padding-right: 0 !important;
}

html:not([dir=rtl]) .ps-1 {
  padding-left: 0.25rem !important;
}
*[dir=rtl] .ps-1 {
  padding-right: 0.25rem !important;
}

html:not([dir=rtl]) .ps-2 {
  padding-left: 0.5rem !important;
}
*[dir=rtl] .ps-2 {
  padding-right: 0.5rem !important;
}

html:not([dir=rtl]) .ps-3 {
  padding-left: 1rem !important;
}
*[dir=rtl] .ps-3 {
  padding-right: 1rem !important;
}

html:not([dir=rtl]) .ps-4 {
  padding-left: 1.5rem !important;
}
*[dir=rtl] .ps-4 {
  padding-right: 1.5rem !important;
}

html:not([dir=rtl]) .ps-5 {
  padding-left: 3rem !important;
}
*[dir=rtl] .ps-5 {
  padding-right: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--cui-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

html:not([dir=rtl]) .text-start {
  text-align: left !important;
}
*[dir=rtl] .text-start {
  text-align: right !important;
}

html:not([dir=rtl]) .text-end {
  text-align: right !important;
}
*[dir=rtl] .text-end {
  text-align: left !important;
}

html:not([dir=rtl]) .text-center {
  text-align: center !important;
}
*[dir=rtl] .text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-primary-rgb), var(--cui-text-opacity)) !important;
}

.text-secondary {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-secondary-rgb), var(--cui-text-opacity)) !important;
}

.text-success {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-success-rgb), var(--cui-text-opacity)) !important;
}

.text-info {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-info-rgb), var(--cui-text-opacity)) !important;
}

.text-warning {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-warning-rgb), var(--cui-text-opacity)) !important;
}

.text-danger {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-danger-rgb), var(--cui-text-opacity)) !important;
}

.text-light {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-light-rgb), var(--cui-text-opacity)) !important;
}

.text-dark {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-dark-rgb), var(--cui-text-opacity)) !important;
}

.text-black {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-black-rgb), var(--cui-text-opacity)) !important;
}

.text-white {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-white-rgb), var(--cui-text-opacity)) !important;
}

.text-body {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-body-color-rgb), var(--cui-text-opacity)) !important;
}

.text-muted {
  --cui-text-opacity: 1;
  color: var(--cui-secondary-color) !important;
}

.text-black-50 {
  --cui-text-opacity: 1;
  color: rgba(70, 53, 41, 0.5) !important;
}

.text-white-50 {
  --cui-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --cui-text-opacity: 1;
  color: var(--cui-secondary-color) !important;
}

.text-body-tertiary {
  --cui-text-opacity: 1;
  color: var(--cui-tertiary-color) !important;
}

.text-body-emphasis {
  --cui-text-opacity: 1;
  color: var(--cui-emphasis-color) !important;
}

.text-reset {
  --cui-text-opacity: 1;
  color: inherit !important;
}

.text-high-emphasis-inverse {
  --cui-text-opacity: 1;
  color: var(--cui-high-emphasis-inverse) !important;
}

.text-medium-emphasis-inverse {
  --cui-text-opacity: 1;
  color: var(--cui-medium-emphasis-inverse) !important;
}

.text-disabled-inverse {
  --cui-text-opacity: 1;
  color: var(--cui-disabled-inverse) !important;
}

.text-high-emphasis {
  --cui-text-opacity: 1;
  color: var(--cui-high-emphasis) !important;
}

.text-medium-emphasis {
  --cui-text-opacity: 1;
  color: var(--cui-medium-emphasis) !important;
}

.text-disabled {
  --cui-text-opacity: 1;
  color: var(--cui-disabled) !important;
}

.text-opacity-25 {
  --cui-text-opacity: 0.25;
}

.text-opacity-50 {
  --cui-text-opacity: 0.5;
}

.text-opacity-75 {
  --cui-text-opacity: 0.75;
}

.text-opacity-100 {
  --cui-text-opacity: 1;
}

.link-opacity-10 {
  --cui-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --cui-link-opacity: 0.1;
}

.link-opacity-25 {
  --cui-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --cui-link-opacity: 0.25;
}

.link-opacity-50 {
  --cui-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --cui-link-opacity: 0.5;
}

.link-opacity-75 {
  --cui-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --cui-link-opacity: 0.75;
}

.link-opacity-100 {
  --cui-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --cui-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-primary-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-secondary-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-success {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-success-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-info {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-info-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-warning {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-warning-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-danger {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-danger-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-light {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-light-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-dark {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-dark-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-link-color-rgb), var(--cui-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --cui-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --cui-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --cui-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --cui-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --cui-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --cui-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --cui-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --cui-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --cui-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --cui-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --cui-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --cui-link-underline-opacity: 1;
}

.bg-primary {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-primary-rgb), var(--cui-bg-opacity)) !important;
}

.bg-secondary {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-secondary-rgb), var(--cui-bg-opacity)) !important;
}

.bg-success {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-success-rgb), var(--cui-bg-opacity)) !important;
}

.bg-info {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-info-rgb), var(--cui-bg-opacity)) !important;
}

.bg-warning {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-warning-rgb), var(--cui-bg-opacity)) !important;
}

.bg-danger {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-danger-rgb), var(--cui-bg-opacity)) !important;
}

.bg-light {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-light-rgb), var(--cui-bg-opacity)) !important;
}

.bg-dark {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-dark-rgb), var(--cui-bg-opacity)) !important;
}

.bg-black {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-black-rgb), var(--cui-bg-opacity)) !important;
}

.bg-white {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-white-rgb), var(--cui-bg-opacity)) !important;
}

.bg-body {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-body-bg-rgb), var(--cui-bg-opacity)) !important;
}

.bg-transparent {
  --cui-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-secondary-bg-rgb), var(--cui-bg-opacity)) !important;
}

.bg-body-tertiary {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-tertiary-bg-rgb), var(--cui-bg-opacity)) !important;
}

.bg-opacity-10 {
  --cui-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --cui-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --cui-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --cui-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --cui-bg-opacity: 1;
}

.bg-gradient {
  background-image: var(--cui-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--cui-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--cui-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--cui-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--cui-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--cui-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--cui-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--cui-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--cui-border-radius) !important;
  border-top-right-radius: var(--cui-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--cui-border-radius-sm) !important;
  border-top-right-radius: var(--cui-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--cui-border-radius) !important;
  border-top-right-radius: var(--cui-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--cui-border-radius-lg) !important;
  border-top-right-radius: var(--cui-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--cui-border-radius-xl) !important;
  border-top-right-radius: var(--cui-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--cui-border-radius-xxl) !important;
  border-top-right-radius: var(--cui-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--cui-border-radius-pill) !important;
  border-top-right-radius: var(--cui-border-radius-pill) !important;
}

html:not([dir=rtl]) .rounded-end {
  border-top-right-radius: var(--cui-border-radius) !important;
}
*[dir=rtl] .rounded-end {
  border-top-left-radius: var(--cui-border-radius) !important;
}
html:not([dir=rtl]) .rounded-end {
  border-bottom-right-radius: var(--cui-border-radius) !important;
}
*[dir=rtl] .rounded-end {
  border-bottom-left-radius: var(--cui-border-radius) !important;
}

html:not([dir=rtl]) .rounded-end-0 {
  border-top-right-radius: 0 !important;
}
*[dir=rtl] .rounded-end-0 {
  border-top-left-radius: 0 !important;
}
html:not([dir=rtl]) .rounded-end-0 {
  border-bottom-right-radius: 0 !important;
}
*[dir=rtl] .rounded-end-0 {
  border-bottom-left-radius: 0 !important;
}

html:not([dir=rtl]) .rounded-end-1 {
  border-top-right-radius: var(--cui-border-radius-sm) !important;
}
*[dir=rtl] .rounded-end-1 {
  border-top-left-radius: var(--cui-border-radius-sm) !important;
}
html:not([dir=rtl]) .rounded-end-1 {
  border-bottom-right-radius: var(--cui-border-radius-sm) !important;
}
*[dir=rtl] .rounded-end-1 {
  border-bottom-left-radius: var(--cui-border-radius-sm) !important;
}

html:not([dir=rtl]) .rounded-end-2 {
  border-top-right-radius: var(--cui-border-radius) !important;
}
*[dir=rtl] .rounded-end-2 {
  border-top-left-radius: var(--cui-border-radius) !important;
}
html:not([dir=rtl]) .rounded-end-2 {
  border-bottom-right-radius: var(--cui-border-radius) !important;
}
*[dir=rtl] .rounded-end-2 {
  border-bottom-left-radius: var(--cui-border-radius) !important;
}

html:not([dir=rtl]) .rounded-end-3 {
  border-top-right-radius: var(--cui-border-radius-lg) !important;
}
*[dir=rtl] .rounded-end-3 {
  border-top-left-radius: var(--cui-border-radius-lg) !important;
}
html:not([dir=rtl]) .rounded-end-3 {
  border-bottom-right-radius: var(--cui-border-radius-lg) !important;
}
*[dir=rtl] .rounded-end-3 {
  border-bottom-left-radius: var(--cui-border-radius-lg) !important;
}

html:not([dir=rtl]) .rounded-end-4 {
  border-top-right-radius: var(--cui-border-radius-xl) !important;
}
*[dir=rtl] .rounded-end-4 {
  border-top-left-radius: var(--cui-border-radius-xl) !important;
}
html:not([dir=rtl]) .rounded-end-4 {
  border-bottom-right-radius: var(--cui-border-radius-xl) !important;
}
*[dir=rtl] .rounded-end-4 {
  border-bottom-left-radius: var(--cui-border-radius-xl) !important;
}

html:not([dir=rtl]) .rounded-end-5 {
  border-top-right-radius: var(--cui-border-radius-xxl) !important;
}
*[dir=rtl] .rounded-end-5 {
  border-top-left-radius: var(--cui-border-radius-xxl) !important;
}
html:not([dir=rtl]) .rounded-end-5 {
  border-bottom-right-radius: var(--cui-border-radius-xxl) !important;
}
*[dir=rtl] .rounded-end-5 {
  border-bottom-left-radius: var(--cui-border-radius-xxl) !important;
}

html:not([dir=rtl]) .rounded-end-circle {
  border-top-right-radius: 50% !important;
}
*[dir=rtl] .rounded-end-circle {
  border-top-left-radius: 50% !important;
}
html:not([dir=rtl]) .rounded-end-circle {
  border-bottom-right-radius: 50% !important;
}
*[dir=rtl] .rounded-end-circle {
  border-bottom-left-radius: 50% !important;
}

html:not([dir=rtl]) .rounded-end-pill {
  border-top-right-radius: var(--cui-border-radius-pill) !important;
}
*[dir=rtl] .rounded-end-pill {
  border-top-left-radius: var(--cui-border-radius-pill) !important;
}
html:not([dir=rtl]) .rounded-end-pill {
  border-bottom-right-radius: var(--cui-border-radius-pill) !important;
}
*[dir=rtl] .rounded-end-pill {
  border-bottom-left-radius: var(--cui-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--cui-border-radius) !important;
  border-bottom-left-radius: var(--cui-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--cui-border-radius-sm) !important;
  border-bottom-left-radius: var(--cui-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--cui-border-radius) !important;
  border-bottom-left-radius: var(--cui-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--cui-border-radius-lg) !important;
  border-bottom-left-radius: var(--cui-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--cui-border-radius-xl) !important;
  border-bottom-left-radius: var(--cui-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--cui-border-radius-xxl) !important;
  border-bottom-left-radius: var(--cui-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--cui-border-radius-pill) !important;
  border-bottom-left-radius: var(--cui-border-radius-pill) !important;
}

html:not([dir=rtl]) .rounded-start {
  border-bottom-left-radius: var(--cui-border-radius) !important;
}
*[dir=rtl] .rounded-start {
  border-bottom-right-radius: var(--cui-border-radius) !important;
}
html:not([dir=rtl]) .rounded-start {
  border-top-left-radius: var(--cui-border-radius) !important;
}
*[dir=rtl] .rounded-start {
  border-top-right-radius: var(--cui-border-radius) !important;
}

html:not([dir=rtl]) .rounded-start-0 {
  border-bottom-left-radius: 0 !important;
}
*[dir=rtl] .rounded-start-0 {
  border-bottom-right-radius: 0 !important;
}
html:not([dir=rtl]) .rounded-start-0 {
  border-top-left-radius: 0 !important;
}
*[dir=rtl] .rounded-start-0 {
  border-top-right-radius: 0 !important;
}

html:not([dir=rtl]) .rounded-start-1 {
  border-bottom-left-radius: var(--cui-border-radius-sm) !important;
}
*[dir=rtl] .rounded-start-1 {
  border-bottom-right-radius: var(--cui-border-radius-sm) !important;
}
html:not([dir=rtl]) .rounded-start-1 {
  border-top-left-radius: var(--cui-border-radius-sm) !important;
}
*[dir=rtl] .rounded-start-1 {
  border-top-right-radius: var(--cui-border-radius-sm) !important;
}

html:not([dir=rtl]) .rounded-start-2 {
  border-bottom-left-radius: var(--cui-border-radius) !important;
}
*[dir=rtl] .rounded-start-2 {
  border-bottom-right-radius: var(--cui-border-radius) !important;
}
html:not([dir=rtl]) .rounded-start-2 {
  border-top-left-radius: var(--cui-border-radius) !important;
}
*[dir=rtl] .rounded-start-2 {
  border-top-right-radius: var(--cui-border-radius) !important;
}

html:not([dir=rtl]) .rounded-start-3 {
  border-bottom-left-radius: var(--cui-border-radius-lg) !important;
}
*[dir=rtl] .rounded-start-3 {
  border-bottom-right-radius: var(--cui-border-radius-lg) !important;
}
html:not([dir=rtl]) .rounded-start-3 {
  border-top-left-radius: var(--cui-border-radius-lg) !important;
}
*[dir=rtl] .rounded-start-3 {
  border-top-right-radius: var(--cui-border-radius-lg) !important;
}

html:not([dir=rtl]) .rounded-start-4 {
  border-bottom-left-radius: var(--cui-border-radius-xl) !important;
}
*[dir=rtl] .rounded-start-4 {
  border-bottom-right-radius: var(--cui-border-radius-xl) !important;
}
html:not([dir=rtl]) .rounded-start-4 {
  border-top-left-radius: var(--cui-border-radius-xl) !important;
}
*[dir=rtl] .rounded-start-4 {
  border-top-right-radius: var(--cui-border-radius-xl) !important;
}

html:not([dir=rtl]) .rounded-start-5 {
  border-bottom-left-radius: var(--cui-border-radius-xxl) !important;
}
*[dir=rtl] .rounded-start-5 {
  border-bottom-right-radius: var(--cui-border-radius-xxl) !important;
}
html:not([dir=rtl]) .rounded-start-5 {
  border-top-left-radius: var(--cui-border-radius-xxl) !important;
}
*[dir=rtl] .rounded-start-5 {
  border-top-right-radius: var(--cui-border-radius-xxl) !important;
}

html:not([dir=rtl]) .rounded-start-circle {
  border-bottom-left-radius: 50% !important;
}
*[dir=rtl] .rounded-start-circle {
  border-bottom-right-radius: 50% !important;
}
html:not([dir=rtl]) .rounded-start-circle {
  border-top-left-radius: 50% !important;
}
*[dir=rtl] .rounded-start-circle {
  border-top-right-radius: 50% !important;
}

html:not([dir=rtl]) .rounded-start-pill {
  border-bottom-left-radius: var(--cui-border-radius-pill) !important;
}
*[dir=rtl] .rounded-start-pill {
  border-bottom-right-radius: var(--cui-border-radius-pill) !important;
}
html:not([dir=rtl]) .rounded-start-pill {
  border-top-left-radius: var(--cui-border-radius-pill) !important;
}
*[dir=rtl] .rounded-start-pill {
  border-top-right-radius: var(--cui-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  html:not([dir=rtl]) .float-sm-start {
    float: left !important;
  }
  *[dir=rtl] .float-sm-start {
    float: right !important;
  }
  html:not([dir=rtl]) .float-sm-end {
    float: right !important;
  }
  *[dir=rtl] .float-sm-end {
    float: left !important;
  }
  html:not([dir=rtl]) .float-sm-none {
    float: none !important;
  }
  *[dir=rtl] .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  html:not([dir=rtl]) .me-sm-0 {
    margin-right: 0 !important;
  }
  *[dir=rtl] .me-sm-0 {
    margin-left: 0 !important;
  }
  html:not([dir=rtl]) .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  *[dir=rtl] .me-sm-1 {
    margin-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  *[dir=rtl] .me-sm-2 {
    margin-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .me-sm-3 {
    margin-right: 1rem !important;
  }
  *[dir=rtl] .me-sm-3 {
    margin-left: 1rem !important;
  }
  html:not([dir=rtl]) .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  *[dir=rtl] .me-sm-4 {
    margin-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .me-sm-5 {
    margin-right: 3rem !important;
  }
  *[dir=rtl] .me-sm-5 {
    margin-left: 3rem !important;
  }
  html:not([dir=rtl]) .me-sm-auto {
    margin-right: auto !important;
  }
  *[dir=rtl] .me-sm-auto {
    margin-left: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  html:not([dir=rtl]) .ms-sm-0 {
    margin-left: 0 !important;
  }
  *[dir=rtl] .ms-sm-0 {
    margin-right: 0 !important;
  }
  html:not([dir=rtl]) .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  *[dir=rtl] .ms-sm-1 {
    margin-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  *[dir=rtl] .ms-sm-2 {
    margin-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ms-sm-3 {
    margin-left: 1rem !important;
  }
  *[dir=rtl] .ms-sm-3 {
    margin-right: 1rem !important;
  }
  html:not([dir=rtl]) .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  *[dir=rtl] .ms-sm-4 {
    margin-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ms-sm-5 {
    margin-left: 3rem !important;
  }
  *[dir=rtl] .ms-sm-5 {
    margin-right: 3rem !important;
  }
  html:not([dir=rtl]) .ms-sm-auto {
    margin-left: auto !important;
  }
  *[dir=rtl] .ms-sm-auto {
    margin-right: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  html:not([dir=rtl]) .pe-sm-0 {
    padding-right: 0 !important;
  }
  *[dir=rtl] .pe-sm-0 {
    padding-left: 0 !important;
  }
  html:not([dir=rtl]) .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  *[dir=rtl] .pe-sm-1 {
    padding-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  *[dir=rtl] .pe-sm-2 {
    padding-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .pe-sm-3 {
    padding-right: 1rem !important;
  }
  *[dir=rtl] .pe-sm-3 {
    padding-left: 1rem !important;
  }
  html:not([dir=rtl]) .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  *[dir=rtl] .pe-sm-4 {
    padding-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .pe-sm-5 {
    padding-right: 3rem !important;
  }
  *[dir=rtl] .pe-sm-5 {
    padding-left: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  html:not([dir=rtl]) .ps-sm-0 {
    padding-left: 0 !important;
  }
  *[dir=rtl] .ps-sm-0 {
    padding-right: 0 !important;
  }
  html:not([dir=rtl]) .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  *[dir=rtl] .ps-sm-1 {
    padding-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  *[dir=rtl] .ps-sm-2 {
    padding-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ps-sm-3 {
    padding-left: 1rem !important;
  }
  *[dir=rtl] .ps-sm-3 {
    padding-right: 1rem !important;
  }
  html:not([dir=rtl]) .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  *[dir=rtl] .ps-sm-4 {
    padding-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ps-sm-5 {
    padding-left: 3rem !important;
  }
  *[dir=rtl] .ps-sm-5 {
    padding-right: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  html:not([dir=rtl]) .text-sm-start {
    text-align: left !important;
  }
  *[dir=rtl] .text-sm-start {
    text-align: right !important;
  }
  html:not([dir=rtl]) .text-sm-end {
    text-align: right !important;
  }
  *[dir=rtl] .text-sm-end {
    text-align: left !important;
  }
  html:not([dir=rtl]) .text-sm-center {
    text-align: center !important;
  }
  *[dir=rtl] .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  html:not([dir=rtl]) .float-md-start {
    float: left !important;
  }
  *[dir=rtl] .float-md-start {
    float: right !important;
  }
  html:not([dir=rtl]) .float-md-end {
    float: right !important;
  }
  *[dir=rtl] .float-md-end {
    float: left !important;
  }
  html:not([dir=rtl]) .float-md-none {
    float: none !important;
  }
  *[dir=rtl] .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  html:not([dir=rtl]) .me-md-0 {
    margin-right: 0 !important;
  }
  *[dir=rtl] .me-md-0 {
    margin-left: 0 !important;
  }
  html:not([dir=rtl]) .me-md-1 {
    margin-right: 0.25rem !important;
  }
  *[dir=rtl] .me-md-1 {
    margin-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .me-md-2 {
    margin-right: 0.5rem !important;
  }
  *[dir=rtl] .me-md-2 {
    margin-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .me-md-3 {
    margin-right: 1rem !important;
  }
  *[dir=rtl] .me-md-3 {
    margin-left: 1rem !important;
  }
  html:not([dir=rtl]) .me-md-4 {
    margin-right: 1.5rem !important;
  }
  *[dir=rtl] .me-md-4 {
    margin-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .me-md-5 {
    margin-right: 3rem !important;
  }
  *[dir=rtl] .me-md-5 {
    margin-left: 3rem !important;
  }
  html:not([dir=rtl]) .me-md-auto {
    margin-right: auto !important;
  }
  *[dir=rtl] .me-md-auto {
    margin-left: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  html:not([dir=rtl]) .ms-md-0 {
    margin-left: 0 !important;
  }
  *[dir=rtl] .ms-md-0 {
    margin-right: 0 !important;
  }
  html:not([dir=rtl]) .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  *[dir=rtl] .ms-md-1 {
    margin-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  *[dir=rtl] .ms-md-2 {
    margin-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ms-md-3 {
    margin-left: 1rem !important;
  }
  *[dir=rtl] .ms-md-3 {
    margin-right: 1rem !important;
  }
  html:not([dir=rtl]) .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  *[dir=rtl] .ms-md-4 {
    margin-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ms-md-5 {
    margin-left: 3rem !important;
  }
  *[dir=rtl] .ms-md-5 {
    margin-right: 3rem !important;
  }
  html:not([dir=rtl]) .ms-md-auto {
    margin-left: auto !important;
  }
  *[dir=rtl] .ms-md-auto {
    margin-right: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  html:not([dir=rtl]) .pe-md-0 {
    padding-right: 0 !important;
  }
  *[dir=rtl] .pe-md-0 {
    padding-left: 0 !important;
  }
  html:not([dir=rtl]) .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  *[dir=rtl] .pe-md-1 {
    padding-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  *[dir=rtl] .pe-md-2 {
    padding-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .pe-md-3 {
    padding-right: 1rem !important;
  }
  *[dir=rtl] .pe-md-3 {
    padding-left: 1rem !important;
  }
  html:not([dir=rtl]) .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  *[dir=rtl] .pe-md-4 {
    padding-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .pe-md-5 {
    padding-right: 3rem !important;
  }
  *[dir=rtl] .pe-md-5 {
    padding-left: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  html:not([dir=rtl]) .ps-md-0 {
    padding-left: 0 !important;
  }
  *[dir=rtl] .ps-md-0 {
    padding-right: 0 !important;
  }
  html:not([dir=rtl]) .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  *[dir=rtl] .ps-md-1 {
    padding-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  *[dir=rtl] .ps-md-2 {
    padding-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ps-md-3 {
    padding-left: 1rem !important;
  }
  *[dir=rtl] .ps-md-3 {
    padding-right: 1rem !important;
  }
  html:not([dir=rtl]) .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  *[dir=rtl] .ps-md-4 {
    padding-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ps-md-5 {
    padding-left: 3rem !important;
  }
  *[dir=rtl] .ps-md-5 {
    padding-right: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  html:not([dir=rtl]) .text-md-start {
    text-align: left !important;
  }
  *[dir=rtl] .text-md-start {
    text-align: right !important;
  }
  html:not([dir=rtl]) .text-md-end {
    text-align: right !important;
  }
  *[dir=rtl] .text-md-end {
    text-align: left !important;
  }
  html:not([dir=rtl]) .text-md-center {
    text-align: center !important;
  }
  *[dir=rtl] .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  html:not([dir=rtl]) .float-lg-start {
    float: left !important;
  }
  *[dir=rtl] .float-lg-start {
    float: right !important;
  }
  html:not([dir=rtl]) .float-lg-end {
    float: right !important;
  }
  *[dir=rtl] .float-lg-end {
    float: left !important;
  }
  html:not([dir=rtl]) .float-lg-none {
    float: none !important;
  }
  *[dir=rtl] .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  html:not([dir=rtl]) .me-lg-0 {
    margin-right: 0 !important;
  }
  *[dir=rtl] .me-lg-0 {
    margin-left: 0 !important;
  }
  html:not([dir=rtl]) .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  *[dir=rtl] .me-lg-1 {
    margin-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  *[dir=rtl] .me-lg-2 {
    margin-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .me-lg-3 {
    margin-right: 1rem !important;
  }
  *[dir=rtl] .me-lg-3 {
    margin-left: 1rem !important;
  }
  html:not([dir=rtl]) .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  *[dir=rtl] .me-lg-4 {
    margin-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .me-lg-5 {
    margin-right: 3rem !important;
  }
  *[dir=rtl] .me-lg-5 {
    margin-left: 3rem !important;
  }
  html:not([dir=rtl]) .me-lg-auto {
    margin-right: auto !important;
  }
  *[dir=rtl] .me-lg-auto {
    margin-left: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  html:not([dir=rtl]) .ms-lg-0 {
    margin-left: 0 !important;
  }
  *[dir=rtl] .ms-lg-0 {
    margin-right: 0 !important;
  }
  html:not([dir=rtl]) .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  *[dir=rtl] .ms-lg-1 {
    margin-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  *[dir=rtl] .ms-lg-2 {
    margin-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ms-lg-3 {
    margin-left: 1rem !important;
  }
  *[dir=rtl] .ms-lg-3 {
    margin-right: 1rem !important;
  }
  html:not([dir=rtl]) .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  *[dir=rtl] .ms-lg-4 {
    margin-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ms-lg-5 {
    margin-left: 3rem !important;
  }
  *[dir=rtl] .ms-lg-5 {
    margin-right: 3rem !important;
  }
  html:not([dir=rtl]) .ms-lg-auto {
    margin-left: auto !important;
  }
  *[dir=rtl] .ms-lg-auto {
    margin-right: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  html:not([dir=rtl]) .pe-lg-0 {
    padding-right: 0 !important;
  }
  *[dir=rtl] .pe-lg-0 {
    padding-left: 0 !important;
  }
  html:not([dir=rtl]) .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  *[dir=rtl] .pe-lg-1 {
    padding-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  *[dir=rtl] .pe-lg-2 {
    padding-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .pe-lg-3 {
    padding-right: 1rem !important;
  }
  *[dir=rtl] .pe-lg-3 {
    padding-left: 1rem !important;
  }
  html:not([dir=rtl]) .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  *[dir=rtl] .pe-lg-4 {
    padding-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .pe-lg-5 {
    padding-right: 3rem !important;
  }
  *[dir=rtl] .pe-lg-5 {
    padding-left: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  html:not([dir=rtl]) .ps-lg-0 {
    padding-left: 0 !important;
  }
  *[dir=rtl] .ps-lg-0 {
    padding-right: 0 !important;
  }
  html:not([dir=rtl]) .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  *[dir=rtl] .ps-lg-1 {
    padding-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  *[dir=rtl] .ps-lg-2 {
    padding-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ps-lg-3 {
    padding-left: 1rem !important;
  }
  *[dir=rtl] .ps-lg-3 {
    padding-right: 1rem !important;
  }
  html:not([dir=rtl]) .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  *[dir=rtl] .ps-lg-4 {
    padding-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ps-lg-5 {
    padding-left: 3rem !important;
  }
  *[dir=rtl] .ps-lg-5 {
    padding-right: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  html:not([dir=rtl]) .text-lg-start {
    text-align: left !important;
  }
  *[dir=rtl] .text-lg-start {
    text-align: right !important;
  }
  html:not([dir=rtl]) .text-lg-end {
    text-align: right !important;
  }
  *[dir=rtl] .text-lg-end {
    text-align: left !important;
  }
  html:not([dir=rtl]) .text-lg-center {
    text-align: center !important;
  }
  *[dir=rtl] .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  html:not([dir=rtl]) .float-xl-start {
    float: left !important;
  }
  *[dir=rtl] .float-xl-start {
    float: right !important;
  }
  html:not([dir=rtl]) .float-xl-end {
    float: right !important;
  }
  *[dir=rtl] .float-xl-end {
    float: left !important;
  }
  html:not([dir=rtl]) .float-xl-none {
    float: none !important;
  }
  *[dir=rtl] .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  html:not([dir=rtl]) .me-xl-0 {
    margin-right: 0 !important;
  }
  *[dir=rtl] .me-xl-0 {
    margin-left: 0 !important;
  }
  html:not([dir=rtl]) .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  *[dir=rtl] .me-xl-1 {
    margin-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  *[dir=rtl] .me-xl-2 {
    margin-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .me-xl-3 {
    margin-right: 1rem !important;
  }
  *[dir=rtl] .me-xl-3 {
    margin-left: 1rem !important;
  }
  html:not([dir=rtl]) .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  *[dir=rtl] .me-xl-4 {
    margin-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .me-xl-5 {
    margin-right: 3rem !important;
  }
  *[dir=rtl] .me-xl-5 {
    margin-left: 3rem !important;
  }
  html:not([dir=rtl]) .me-xl-auto {
    margin-right: auto !important;
  }
  *[dir=rtl] .me-xl-auto {
    margin-left: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  html:not([dir=rtl]) .ms-xl-0 {
    margin-left: 0 !important;
  }
  *[dir=rtl] .ms-xl-0 {
    margin-right: 0 !important;
  }
  html:not([dir=rtl]) .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  *[dir=rtl] .ms-xl-1 {
    margin-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  *[dir=rtl] .ms-xl-2 {
    margin-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ms-xl-3 {
    margin-left: 1rem !important;
  }
  *[dir=rtl] .ms-xl-3 {
    margin-right: 1rem !important;
  }
  html:not([dir=rtl]) .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  *[dir=rtl] .ms-xl-4 {
    margin-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ms-xl-5 {
    margin-left: 3rem !important;
  }
  *[dir=rtl] .ms-xl-5 {
    margin-right: 3rem !important;
  }
  html:not([dir=rtl]) .ms-xl-auto {
    margin-left: auto !important;
  }
  *[dir=rtl] .ms-xl-auto {
    margin-right: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  html:not([dir=rtl]) .pe-xl-0 {
    padding-right: 0 !important;
  }
  *[dir=rtl] .pe-xl-0 {
    padding-left: 0 !important;
  }
  html:not([dir=rtl]) .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  *[dir=rtl] .pe-xl-1 {
    padding-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  *[dir=rtl] .pe-xl-2 {
    padding-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .pe-xl-3 {
    padding-right: 1rem !important;
  }
  *[dir=rtl] .pe-xl-3 {
    padding-left: 1rem !important;
  }
  html:not([dir=rtl]) .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  *[dir=rtl] .pe-xl-4 {
    padding-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .pe-xl-5 {
    padding-right: 3rem !important;
  }
  *[dir=rtl] .pe-xl-5 {
    padding-left: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  html:not([dir=rtl]) .ps-xl-0 {
    padding-left: 0 !important;
  }
  *[dir=rtl] .ps-xl-0 {
    padding-right: 0 !important;
  }
  html:not([dir=rtl]) .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  *[dir=rtl] .ps-xl-1 {
    padding-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  *[dir=rtl] .ps-xl-2 {
    padding-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ps-xl-3 {
    padding-left: 1rem !important;
  }
  *[dir=rtl] .ps-xl-3 {
    padding-right: 1rem !important;
  }
  html:not([dir=rtl]) .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  *[dir=rtl] .ps-xl-4 {
    padding-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ps-xl-5 {
    padding-left: 3rem !important;
  }
  *[dir=rtl] .ps-xl-5 {
    padding-right: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  html:not([dir=rtl]) .text-xl-start {
    text-align: left !important;
  }
  *[dir=rtl] .text-xl-start {
    text-align: right !important;
  }
  html:not([dir=rtl]) .text-xl-end {
    text-align: right !important;
  }
  *[dir=rtl] .text-xl-end {
    text-align: left !important;
  }
  html:not([dir=rtl]) .text-xl-center {
    text-align: center !important;
  }
  *[dir=rtl] .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  html:not([dir=rtl]) .float-xxl-start {
    float: left !important;
  }
  *[dir=rtl] .float-xxl-start {
    float: right !important;
  }
  html:not([dir=rtl]) .float-xxl-end {
    float: right !important;
  }
  *[dir=rtl] .float-xxl-end {
    float: left !important;
  }
  html:not([dir=rtl]) .float-xxl-none {
    float: none !important;
  }
  *[dir=rtl] .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  html:not([dir=rtl]) .me-xxl-0 {
    margin-right: 0 !important;
  }
  *[dir=rtl] .me-xxl-0 {
    margin-left: 0 !important;
  }
  html:not([dir=rtl]) .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  *[dir=rtl] .me-xxl-1 {
    margin-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  *[dir=rtl] .me-xxl-2 {
    margin-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .me-xxl-3 {
    margin-right: 1rem !important;
  }
  *[dir=rtl] .me-xxl-3 {
    margin-left: 1rem !important;
  }
  html:not([dir=rtl]) .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  *[dir=rtl] .me-xxl-4 {
    margin-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .me-xxl-5 {
    margin-right: 3rem !important;
  }
  *[dir=rtl] .me-xxl-5 {
    margin-left: 3rem !important;
  }
  html:not([dir=rtl]) .me-xxl-auto {
    margin-right: auto !important;
  }
  *[dir=rtl] .me-xxl-auto {
    margin-left: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  html:not([dir=rtl]) .ms-xxl-0 {
    margin-left: 0 !important;
  }
  *[dir=rtl] .ms-xxl-0 {
    margin-right: 0 !important;
  }
  html:not([dir=rtl]) .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  *[dir=rtl] .ms-xxl-1 {
    margin-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  *[dir=rtl] .ms-xxl-2 {
    margin-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  *[dir=rtl] .ms-xxl-3 {
    margin-right: 1rem !important;
  }
  html:not([dir=rtl]) .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  *[dir=rtl] .ms-xxl-4 {
    margin-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  *[dir=rtl] .ms-xxl-5 {
    margin-right: 3rem !important;
  }
  html:not([dir=rtl]) .ms-xxl-auto {
    margin-left: auto !important;
  }
  *[dir=rtl] .ms-xxl-auto {
    margin-right: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  html:not([dir=rtl]) .pe-xxl-0 {
    padding-right: 0 !important;
  }
  *[dir=rtl] .pe-xxl-0 {
    padding-left: 0 !important;
  }
  html:not([dir=rtl]) .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  *[dir=rtl] .pe-xxl-1 {
    padding-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  *[dir=rtl] .pe-xxl-2 {
    padding-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  *[dir=rtl] .pe-xxl-3 {
    padding-left: 1rem !important;
  }
  html:not([dir=rtl]) .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  *[dir=rtl] .pe-xxl-4 {
    padding-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  *[dir=rtl] .pe-xxl-5 {
    padding-left: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  html:not([dir=rtl]) .ps-xxl-0 {
    padding-left: 0 !important;
  }
  *[dir=rtl] .ps-xxl-0 {
    padding-right: 0 !important;
  }
  html:not([dir=rtl]) .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  *[dir=rtl] .ps-xxl-1 {
    padding-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  *[dir=rtl] .ps-xxl-2 {
    padding-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  *[dir=rtl] .ps-xxl-3 {
    padding-right: 1rem !important;
  }
  html:not([dir=rtl]) .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  *[dir=rtl] .ps-xxl-4 {
    padding-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  *[dir=rtl] .ps-xxl-5 {
    padding-right: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  html:not([dir=rtl]) .text-xxl-start {
    text-align: left !important;
  }
  *[dir=rtl] .text-xxl-start {
    text-align: right !important;
  }
  html:not([dir=rtl]) .text-xxl-end {
    text-align: right !important;
  }
  *[dir=rtl] .text-xxl-end {
    text-align: left !important;
  }
  html:not([dir=rtl]) .text-xxl-center {
    text-align: center !important;
  }
  *[dir=rtl] .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important;
  }
  .fs-2 {
    font-size: 2rem !important;
  }
  .fs-3 {
    font-size: 1.75rem !important;
  }
  .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
/*!
 * CoreUI Plugins - Chart.js for CoreUI 3
 * @version v3.1.2
 * @link https://coreui.io
 * Copyright (c) 2021 creativeLabs Łukasz Holeczek
 * Licensed under MIT (https://github.com/coreui/coreui-chartjs/blob/main/LICENSE)
 */
.chartjs-tooltip {
  position: absolute;
  z-index: 1021;
  padding: 0.25rem 0.5rem;
  color: #fff;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.7);
  opacity: 0;
  transition: all 0.15s ease;
  transform: translate(-50%, 0);
  border-radius: 0.375rem;
}
@media (prefers-reduced-motion: reduce) {
  .chartjs-tooltip {
    transition: none;
  }
}

.chartjs-tooltip-header {
  margin-bottom: 0.5rem;
}

.chartjs-tooltip-header-item {
  font-size: 0.875rem;
  font-weight: 700;
}

.chartjs-tooltip-body-item {
  align-items: center;
  font-size: 0.875rem;
  white-space: nowrap;
}

body {
  overflow: visible;
  font-family: "Noto Sans JP";
  color: #463529;
}

.wrapper {
  width: 100%;
  will-change: auto;
}

.app-content {
  overflow: auto;
  background-color: #FFF7F2;
}

.header .header-text-list {
  font-weight: 700;
  color: #F8601B;
  text-decoration: none;
}
.header .header-text-list:last-child {
  border-right: none;
}

.sidebar {
  background: #FFFFFF;
  width: 209px;
}
.sidebar .nav-link {
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.25px;
  color: #6C757D;
}
.sidebar .nav-link.active {
  background: #FFF7F2;
  color: #F8601B;
}
.sidebar .nav-link.active .nav-icon {
  color: #F8601B;
}
.sidebar .nav-link:hover {
  background: #FFF7F2;
  color: #F8601B;
}
.sidebar .nav-link:hover .nav-icon {
  color: #F8601B;
}
.sidebar .nav-icon {
  height: 20px;
  width: 20px;
  color: #6C757D;
}

.footer {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  background: #FFFFFF;
  border-top: 1px solid #F8601B;
}

.footer-text-description {
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  color: #1A1311;
  margin-top: 9px;
}
.footer-text-description p {
  margin: 0;
}

.layout-auth {
  background: #FFF7F2;
}
.layout-auth-content {
  margin-top: 68px;
  min-height: calc(100vh - 197px);
  padding: 50px 0;
}

.header-custom {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  background-color: #FFFFFF;
}

@media screen and (min-width: 900px) {
  .sidebar-mitsubachi {
    position: fixed;
    min-height: 100vh !important;
    width: 209px;
    top: 68px !important;
    z-index: 99 !important;
  }
  .sidebar .nav-item {
    width: 186px;
    left: 12px;
    position: relative;
  }
  .sidebar .nav-item .badge {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "Noto Sans JP";
    font-weight: 700;
    font-size: 8px;
    line-height: 12px;
    letter-spacing: -0.28px;
    color: #FFFFFF;
    background-color: #FF594F;
    width: 16px;
    height: 16px;
    position: relative;
    bottom: 7px;
    right: 123px;
    border-radius: 50%;
    border: 1px solid #FFFFFF;
  }
  .app-content {
    margin-left: 209px;
    padding: 1.5em;
    min-height: calc(100vh - 197px);
    font-size: 14px;
    margin-top: 68px;
  }
  .header {
    height: 68px;
    --cui-header-min-height: 68px;
    padding: 14px 24px;
    border-bottom: 1px solid #EDEDED;
  }
  .header .container-fluid, .header .container-sm, .header .container-md, .header .container-lg, .header .container-xl, .header .container-xxl {
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .header .header-logo {
    width: 88.2px;
    height: 18px;
  }
  .header .cursor-pointer {
    cursor: pointer;
  }
  .header .header-text-list {
    border-right: 2px solid #F8601B;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.25px;
    padding: 0px 16px;
  }
  .footer-logo-view {
    width: 278px;
    height: 50px;
    border-right: 1px solid #FFAC7D;
    display: flex;
    align-items: center;
  }
  .footer-logo {
    width: 258px;
    height: 31px;
  }
  .footer-detail {
    width: 70%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .footer-text-description {
    margin-top: 0 !important;
    margin-left: 20px !important;
  }
  .footer {
    height: 129px !important;
    z-index: 100;
    padding: 25px 0;
    justify-content: center;
    width: 100%;
  }
  .footer .footer-list-screen {
    display: flex;
    justify-content: space-around;
    flex-direction: column;
  }
  .footer .footer-list-screen ul {
    list-style: disc;
    color: #F8601B;
  }
  .footer .footer-list-screen ul .footer-text-item {
    color: #F8601B;
    margin-bottom: 6px;
    font-weight: 700;
    font-size: 12px;
    line-height: 18px;
    text-decoration: none;
  }
  .footer-text-list {
    display: block;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.25px;
    color: #F8601B;
    margin: 7px 0;
    text-decoration: none;
    cursor: pointer;
  }
  .footer-text-list:hover {
    color: #2819af;
  }
  .modal-dialog.modal-dialog-centered.modal-xl {
    --cui-modal-width: 95% !important;
    justify-content: center;
  }
  .modal-content {
    max-width: 1080px;
  }
  .footer-modal-iframe .iframe {
    width: 100%;
    height: 500px;
    display: block;
  }
  .footer-modal-iframe .icon-close {
    width: 25px;
    height: 25px;
    position: absolute;
    top: -50px;
    right: 0;
    cursor: pointer;
  }
  .layout-auth-content {
    min-height: calc(100vh - 197px);
  }
  .btn-auth {
    height: 41px !important;
  }
}
@media screen and (max-width: 899px) {
  .layout-auth-content {
    margin-top: 60px;
  }
  .sidebar-mitsubachi {
    position: sticky;
    min-height: auto !important;
    width: 100%;
    top: 68px !important;
    z-index: 99 !important;
  }
  .hidden-on-mobile {
    display: none !important;
  }
  .header {
    height: 60px;
    --cui-header-min-height: 60px;
    padding: 13px 26px;
  }
  .header .container-fluid, .header .container-sm, .header .container-md, .header .container-lg, .header .container-xl, .header .container-xxl {
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .header .header-logo {
    width: 87.52px;
    height: 18px;
  }
  .header .btn-auth {
    height: 36px !important;
  }
  .header .header-text-list {
    display: block;
    padding: 24px 0;
    border-right: 2px solid #F8601B;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
  }
  .app-content {
    margin-left: 0px;
    margin-top: 56px;
    padding: 24px 12px;
    font-size: 12px;
    overflow-x: hidden;
    margin-top: 60px;
  }
  .sidebar {
    width: 100%;
    height: 56px;
    z-index: 1 !important;
    top: 60px !important;
  }
  .sidebar .nav-link .badge {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "Noto Sans JP";
    font-weight: 700;
    font-size: 8px;
    line-height: 12px;
    letter-spacing: -0.28px;
    color: #FFFFFF;
    background-color: #FF594F;
    width: 16px;
    height: 16px;
    position: relative;
    bottom: 40px;
    left: 4px;
    border-radius: 50%;
    border: 1px solid #FFFFFF;
    text-decoration: none !important;
  }
  .sidebar .nav-link.active {
    background-color: #FFFFFF;
  }
  .sidebar .nav-link.active .sideBar-name {
    text-decoration: underline;
    text-underline-offset: 10px;
  }
  .sidebar .nav-link:hover {
    background-color: #FFFFFF;
  }
  .sidebar .nav-link:hover .sideBar-name {
    text-decoration: underline;
    text-underline-offset: 10px;
  }
  .sidebar a {
    float: left;
  }
  .sidebar-nav .nav-link {
    display: grid;
    font-family: "Noto Sans JP";
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 14px;
    letter-spacing: 0.25px;
    color: #6C757D;
    width: 25%;
    justify-content: center;
    justify-items: center;
  }
  .sidebar-nav {
    overflow-x: hidden;
    overflow-y: hidden;
  }
  html:not([dir=rtl]) .sidebar-nav .nav-icon:first-child {
    margin-left: 0;
  }
  .footer {
    height: auto;
    display: block;
    width: 100%;
  }
  .footer .footer-logo {
    width: 199.74px;
    height: 24px;
  }
  .footer .footer-list-screen {
    display: flex;
    flex-direction: column;
    margin-top: 16px;
    padding-bottom: 5px;
  }
  .footer .footer-list-screen ul {
    list-style: disc;
    color: #F8601B;
  }
  .footer .footer-list-screen ul .footer-text-item {
    color: #F8601B;
    margin-bottom: 6px;
    font-weight: 700;
    font-size: 12px;
    line-height: 18px;
    text-decoration: none;
  }
  .footer .footer-list-container {
    width: 100%;
  }
  .footer-text-list {
    display: block;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: #F8601B;
    margin-bottom: 14px;
    text-decoration: none;
  }
  .modal-dialog.modal-dialog-centered.modal-xl {
    --cui-modal-width: 95% !important;
    justify-content: center;
  }
  .modal-content {
    max-width: 1080px;
  }
  .footer-modal-iframe .iframe {
    width: 100%;
    height: 400px;
    display: block;
  }
  .footer-modal-iframe .icon-close {
    width: 20px;
    height: 20px;
    position: absolute;
    top: -50px;
    right: 0;
    cursor: pointer;
  }
  .layout-auth-content {
    min-height: calc(100vh - 237px);
    padding: 12px 4px;
  }
}
@media (max-width: 899px) {
  html:not([dir=rtl]) .sidebar:not(.sidebar-end):not(.show) {
    margin-left: 0 !important;
  }
}
@media (min-width: 900px) {
  html:not([dir=rtl]) .sidebar.hide:not(.sidebar-end) {
    margin-left: 0;
  }
}
.btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 10px;
  border-radius: 4px;
  font-family: "Noto Sans JP";
  font-style: normal;
  text-align: center;
  letter-spacing: 0.25px;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  border: unset;
  cursor: pointer;
  padding: 14px 24px;
}

.btn-orange {
  background: #F8601B;
  color: #FFFFFF;
}
.btn-orange:disabled {
  background-color: #F8601B !important;
  opacity: 0.5;
}
.btn-orange:hover {
  background-color: #F8601B;
}

.btn-yellow {
  background: #FCCA0D;
  color: #463529;
}
.btn-yellow:disabled {
  background-color: #fffaea !important;
  opacity: 0.5;
}
.btn-yellow:hover {
  background-color: #FCCA0D;
}

.btn-light-orange {
  background-color: #FFF7F2;
  color: #F8601B;
}
.btn-light-orange:hover {
  background-color: #F8601B;
}

@media screen and (min-width: 900px) {
  .btn {
    padding: 14px 24px;
    font-size: 16px;
  }
}
@media screen and (max-width: 899px) {
  .btn {
    padding: 9px 12px;
    font-size: 12px;
  }
}
.burger-menu-container {
  position: absolute;
  right: 0px;
  top: 60px;
  width: 100%;
  height: 100vh;
  background-color: rgba(28, 25, 25, 0.5);
}

.burger-icon {
  width: 25px;
  height: 20px;
  color: #F8601B;
}

.burger-list {
  list-style: none;
  background-color: #FFFFFF;
}
.burger-list li {
  position: relative;
  right: 20px;
}
.burger-list li:first-child {
  border-top: none;
}

.burger-list-parent {
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #F8601B;
  border-top: 1px solid #BCBFC4;
}

.burger-button {
  padding-bottom: 24px;
}

.burger-list-child {
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.25px;
  color: #F8601B;
  padding-top: 18px;
}

.burger-sublist {
  list-style: disc;
}

@media screen and (min-width: 900px) {
  .burger-icon {
    display: none;
  }
  .burger-menu-container {
    display: none;
  }
}
.required {
  color: #FF0F00;
}

.card {
  --cui-card-border-width: none;
}

.success {
  border: 1px dashed #358b43;
  color: #358b43;
  font-weight: 500;
  padding: 12px;
  border-left: none;
  border-right: none;
}

.text-ellipse {
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.formInput .form-check-input {
  margin-top: 5px;
  border: 2px solid #B6B6B6;
  -webkit-appearance: none !important;
  cursor: pointer;
}
.formInput .form-check-input:checked {
  background-color: #f8601b;
  border-color: #f8601b;
}

.text-brown {
  color: #6C757D;
}

.word-break-all {
  word-break: break-all;
}

@media screen and (min-width: 900px) {
  .width-date-table {
    width: 10%;
  }
  .width-name-table {
    width: 30%;
  }
  .width-auth {
    width: 600px !important;
  }
  .success {
    font-size: 16px;
    line-height: 24px;
  }
  .formSelect {
    margin: 10px 0;
  }
  .formSelect-label {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: #463529;
    margin: 10px 0;
  }
  .formSelect-custom {
    cursor: pointer;
    height: 56px;
    padding: 10px 18px;
    gap: 10px;
    background-color: #fff7f2;
    border: 1px solid #ffe0ce;
    border-radius: 4px;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.25px;
    color: #463529;
    max-width: 100%;
  }
  .iframe-tag {
    height: calc(100vh - 388px);
    width: 100%;
  }
  .text-18 {
    font-size: 18px;
    line-height: 28px;
  }
  .text-16 {
    font-size: 16px;
    line-height: 24px;
  }
  .text-14 {
    font-size: 14px;
    line-height: 20px;
  }
  .break-spaces {
    white-space: break-spaces !important;
  }
  .card-header {
    padding: 30px 24px;
    height: 82px;
    display: flex;
    justify-content: start;
  }
  .card-body {
    padding: 1em;
  }
  .page-title {
    width: -moz-fit-content;
    width: fit-content;
    color: #F8601B;
    font-family: "Noto Sans JP";
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
    letter-spacing: 0.25px;
  }
  .page-sub-title {
    font-family: "Noto Sans JP";
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 8px;
    letter-spacing: 0.25px;
    margin-top: 15px;
    margin-bottom: 10px;
    color: #463529;
  }
  .sub-title {
    display: contents;
  }
  .sub-title-terms {
    font-size: 14px;
    color: #463529;
    width: 100%;
  }
  .electric-title {
    margin-bottom: 12px;
  }
  .nav {
    padding-left: 24px !important;
  }
  .nav .nav-link {
    width: 180px;
  }
}
input.disabled {
  pointer-events: none;
  color: #333333;
  background: #E4E4E4;
}

@media screen and (max-width: 899px) {
  .width-date-table {
    width: 13%;
  }
  .width-name-table {
    width: 20%;
  }
  .success {
    font-size: 14px;
    line-height: 22px;
    width: 100%;
  }
  .formSelect-label {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.25px;
    color: #463529;
    margin: 8px 0;
  }
  .formSelect-custom {
    cursor: pointer;
    height: 44px;
    padding: 8px 16px;
    gap: 10px;
    background-color: #fff7f2;
    border: 1px solid #ffe0ce;
    border-radius: 4px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: #463529;
    max-width: 100%;
  }
  .formSelect option {
    width: 100%;
    max-width: 100%;
    font-size: 14px;
    line-height: 20px;
  }
  .formInput-label {
    font-size: 12px !important;
  }
  .formInput .form-check-input {
    margin-top: 6px;
  }
  .iframe-tag {
    width: 100%;
    height: 478px;
  }
  .text-18 {
    font-size: 16px;
    line-height: 24px;
  }
  .text-16 {
    font-size: 14px;
    line-height: 20px;
  }
  .text-14 {
    font-size: 12px;
    line-height: 16px;
  }
  .card-header {
    padding: 20px 12px;
    height: 64px;
    display: flex;
    justify-content: center;
  }
  .card-body {
    padding: 20px 12px;
    width: 100%;
  }
  .page-title {
    color: #F8601B;
    font-family: "Noto Sans JP";
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.25px;
  }
  .page-sub-title {
    font-family: "Noto Sans JP";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 0px;
    letter-spacing: -0.28px;
    color: #463529;
    margin-top: 14px;
  }
  .sub-title {
    line-height: 15px;
    display: block;
  }
  .sub-title-terms {
    font-size: 12px;
    color: #463529;
    width: 100%;
  }
  .nav .nav-item {
    width: 50%;
  }
  .nav .nav-item .nav-link {
    width: 100%;
  }
}
.font-weight-normal {
  font-weight: normal !important;
}

.font-weight-700 {
  font-weight: 700 !important;
}

.font-weight-500 {
  font-weight: 500;
}

.font-weight-400 {
  font-weight: 400 !important;
}

.text-orange {
  color: #F8601B;
}

.text-blue {
  color: #21699E;
}

.text-black {
  color: #463529 !important;
}

.text-green {
  color: #4EAE5D;
}

.text-yellow {
  color: #FCCA0D;
}

.card {
  width: 100%;
  filter: drop-shadow(0px 4px 18px #fbd7b6);
  border-top: 4px solid #F8601B;
  min-width: 90%;
}
.card.form-qa-not-login {
  width: 90%;
}

.card-header {
  box-sizing: border-box;
  gap: 10px;
  background: #FFFFFF;
  border-bottom: 1px dashed #F8601B;
  border-radius: 4px 4px 0px 0px;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  align-items: center;
}

.card-body {
  background-color: #FFFFFF;
  gap: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  min-height: calc(100vh - 485px);
}

@media screen and (max-width: 899px) {
  .card-body {
    min-height: calc(100vh - 460px);
  }
  .card.form-qa-not-login {
    width: 95%;
  }
  .chartjs-tooltip {
    transform: translate(-70%, 0);
    display: none !important;
  }
  .chartjs-tooltip-body-item {
    font-size: 0.775rem;
  }
}
.card-outline-orange {
  background-color: #fff7f2;
  border: 2px solid #ffac7d;
  border-radius: 5px;
  padding: 18px 34px;
}

.card-outline-light-orange {
  background-color: #fff7f2;
  border: 4px solid #FFAC7D;
  border-radius: 5px;
  display: inline-block;
  padding: 18px 24px;
}

.card-outline-blue {
  background-color: #ebedfb;
  border: 2px solid #b2b8e7;
  border-radius: 5px;
  display: inline-block;
}

.card-outline-green {
  background-color: #f5fff1;
  border: 2px solid #4eae5d;
  border-radius: 5px;
  display: inline-block;
}

.pagination .page-item.disabled .page-link {
  color: #dbd3d3;
}
.pagination .page-link.active,
.pagination .active > .page-link {
  color: #FFFFFF;
  background-color: #F8601B;
  border-color: #F8601B;
}
.pagination .page-link {
  height: 28px;
  width: auto;
  min-width: 28px;
  color: #F8601B;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pagination .input-password::placeholder {
  font-size: 4px;
}

.nav {
  background-color: #F5F5F5;
  position: relative;
  top: 1px;
}
.nav .nav-item {
  cursor: pointer;
}
.nav .nav-item .nav-link {
  display: flex;
  justify-content: center;
  color: #6c757d;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
}
.nav .nav-item .nav-link.active {
  color: #F8601B;
}

.border-radius-4 {
  border-radius: 4px;
}

.bg-gray {
  background-color: #F5F5F5 !important;
}

.bg-orange {
  background-color: #F8601B !important;
}

.bg-dark-gray {
  background-color: #BCBCBD !important;
}

a {
  text-decoration: none;
}

.formInput {
  margin: 10px 0;
}
.formInput-label {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #463529;
  margin: 10px 0;
}
.formInput-custom {
  padding: 14px 24px;
  gap: 10px;
  height: 56px;
  background: #fff7f2;
  border: 1px solid #ffe7e6;
  border-radius: 4px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #463529;
  outline: none;
  -webkit-appearance: none !important;
  width: 100%;
}
.formInput .link {
  margin-left: 5px;
  cursor: pointer;
}
.formInput .text-link {
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: -0.07px;
  text-decoration: underline;
  margin-left: 5px;
  color: #F8601B;
}
.formInput-error {
  border: 1px solid #ff0f00;
}

.formTextarea {
  margin: 10px 0;
}
.formTextarea-label {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #463529;
  margin: 10px 0;
}
.formTextarea-input {
  padding: 10px 18px;
  gap: 10px;
  background-color: #fff7f2;
  border: 1px solid #ffe0ce;
  border-radius: 4px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #463529;
}

.text-error {
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.25px;
  color: #ff0f00;
  align-self: flex-start;
}

.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

.input-password {
  padding-right: 48px;
}
.input-password::placeholder {
  font-size: 8px;
}

input {
  text-overflow: ellipsis;
}

.pr-48 {
  padding-right: 48px;
}

[data-simplebar] {
  width: 100%;
  height: 100%;
}

.dropdown-scroll {
  display: flex;
  height: 200px;
}

.dropdown {
  width: 100%;
  min-width: 170px;
}
.dropdown-toggle {
  display: flex !important;
  background: rgba(0, 0, 0, 0) !important;
  font-weight: 700 !important;
}
.dropdown-toggle::after {
  margin: 9px -10px auto auto !important;
  border-top: 0.7em solid !important;
  border-right: 0.5em solid transparent !important;
  border-left: 0.5em solid transparent !important;
}
.dropdown-input {
  width: 100%;
  border: none;
  background-color: #F5F5F5;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 14px;
  border-bottom: 1px solid #d8dbe0;
}
.dropdown-input:focus-visible {
  outline: none;
}
.dropdown-label-no-data {
  height: 30px;
  width: 100%;
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  color: #463529;
}
.dropdown-toggle-contract {
  display: flex !important;
  background: rgba(0, 0, 0, 0) !important;
  font-weight: 700 !important;
}
.dropdown-toggle-contract::after {
  margin: 2px -14px auto auto !important;
  border-top: 0.6em solid !important;
  border-right: 0.4em solid transparent !important;
  border-left: 0.4em solid transparent !important;
  color: #463529 !important;
}
.dropdown-menu {
  width: 100% !important;
  position: absolute !important;
  inset: 0 auto auto 0 !important;
  overflow-y: auto;
}
.dropdown-menu.not-padding-top {
  padding-top: unset;
}
.dropdown-item {
  font-size: 14px;
  color: #463529;
  font-weight: 500;
  display: flex;
  align-items: center;
  white-space: break-spaces;
}
.dropdown-item:hover {
  background-color: #FFF7F2 !important;
}

@media screen and (max-width: 899px) {
  .dropdown-toggle::after {
    margin: 8px -2px auto auto !important;
  }
  .dropdown-toggle-contract::after {
    margin: 2px -4px auto auto !important;
    border-top: 0.5em solid !important;
  }
  .dropdown-item {
    font-size: 12px;
  }
  .dropdown-input {
    font-size: 12px;
  }
  .dropdown-label-no-data {
    font-size: 12px;
  }
}
@media screen and (min-width: 900px) {
  .dropdown-toggle-contract-item-selecting {
    font-size: 14px;
    font-weight: 500;
  }
}
.modal-dialog {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--cui-modal-margin) * 2);
  -webkit-appearance: none;
}

.modal-content {
  -webkit-appearance: none;
}

.modal-header {
  background-color: #FFFFFF;
  font-family: "Noto Sans JP";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  display: flex;
  align-items: center;
  letter-spacing: 0.25px;
  color: #F8601B;
  border-top: 4px solid #F8601B;
  border-bottom: 1px dashed #F8601B;
  border-radius: 4px 4px 0px 0px;
}
.modal-header .modal-title {
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.25px;
}

.modal-body {
  display: flex;
  background-color: #FFFFFF;
  justify-content: center;
  border-radius: 4px;
  width: 100%;
  align-items: center;
  flex-direction: column;
  position: relative;
}

.modal-footer {
  display: flex;
  justify-content: center;
  border-top: none;
}

.modal-img {
  width: 271px;
}

.modal-sm {
  --cui-modal-width: 598px !important;
}

.modal-noti {
  padding: 40px 20px 30px;
}
.modal-noti-text-content {
  color: #463529;
  text-align: center;
  padding-right: 20px;
  padding-left: 20px;
  font-weight: 700;
}
.modal-noti-icon-close {
  margin: 20px 20px 0 0;
  align-self: end;
  cursor: pointer;
}
.modal-noti-title {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #463529;
}
.modal-noti-btn button {
  margin-top: 30px;
  background: #F8601B;
  border-radius: 5px;
  padding: 10px;
  min-width: 182px;
  border: unset;
  font-weight: 700;
}
.modal-noti-btn-ok {
  background: #F8601B;
}
.modal-noti-btn-cancel {
  background: #FFFFFF !important;
  border: 1px solid #BCBCBD !important;
  color: #BCBCBD !important;
}
.modal-noti-btn-cancel:hover {
  background: #21699E !important;
}

@media screen and (max-width: 899px) {
  .modal-header .modal-title {
    font-size: 16px;
    line-height: 24px;
  }
}
.confirmContract {
  position: relative;
}
.confirmContract-title {
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  letter-spacing: 0.25px;
  color: #463529;
}
.confirmContract-contract-end {
  color: #FF0F00;
}
.confirmContract-left {
  width: 640px;
}
.confirmContract-left-main {
  margin-top: 36px;
  padding: 32px 0;
  gap: 10px;
  width: 100%;
  background: #ffffff;
  border: 4px solid #ffac7d;
  border-radius: 4px;
}
.confirmContract-left hr {
  width: 100%;
}
.confirmContract-text {
  color: #463529;
}
.confirmContract-text-left {
  font-weight: 400;
  letter-spacing: 0.25px;
}
.confirmContract-text-right {
  font-weight: 500;
  letter-spacing: -0.28px;
}
.confirmContract-right {
  width: 640px;
}
.confirmContract-right-main {
  width: 100%;
  padding: 16px 0;
  gap: 10px;
  position: relative;
}
.confirmContract-right-main .confirmContract-contract-end {
  position: absolute;
  top: 4px;
  width: 100%;
}
.confirmContract-right-top hr {
  width: 100%;
}
.confirmContract-right-bottom hr {
  width: 100%;
}

.myPage-container {
  min-height: calc(100vh - 239px);
  background: #FFFFFF;
  filter: drop-shadow(0px 4px 18px #fbd7b6);
}
.myPage-container-header {
  border-top: 4px solid #F8601B;
  border-bottom: 1px dashed #F8601B;
  border-radius: 4px 4px 0 0;
  height: 82px;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: #F8601B;
  padding: 0 24px;
}
.myPage-container-header .contract-name {
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0.25px;
  color: #6c757d;
}
.myPage-container-header .contract-number {
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.25px;
  color: #463529;
  margin-left: 4px;
}
.myPage-container-main {
  gap: 32px;
  padding: 50px 0;
}
.myPage-container-main .title-list {
  font-weight: 700;
  font-size: 24px;
  line-height: 35px;
  color: #463529;
}
.myPage-container-main .myPage-list {
  gap: 32px;
  width: 100%;
}
.myPage-container-main .myPage-list-item {
  width: 40%;
  height: 162px;
  background: #fff7f2;
  border: 4px solid #ffe6d6;
  border-radius: 4px;
  gap: 10px;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #463529;
  cursor: pointer;
  text-align: center;
}
.myPage-container-main .list-collapse-item {
  margin: 15px 0;
}
.myPage-container-main .list-collapse-item .collapse-inner {
  max-width: 100%;
  width: 775px;
}
.myPage-container-main .list-collapse-item .collapse-wrapper {
  margin-left: 32px;
  margin-right: 32px;
}
.myPage-container-main .list-collapse-item .title-collapse {
  font-weight: 700;
  font-size: 24px;
  line-height: 35px;
  color: #463529;
  padding: 9px 0px 9px 12px;
  gap: 12px;
  height: 53px;
  border-bottom: 4px solid #ffac7d;
  cursor: pointer;
}
.myPage-container-main .list-collapse-item .content-collapse {
  margin-top: 32px;
  margin-bottom: 24px;
  width: 775px;
  background: #FFFFFF;
  border: 4px solid #ffac7d;
  border-radius: 4px;
}
.myPage-container-main .list-collapse-item .content-collapse-top {
  padding: 20px;
  gap: 24px;
  border-bottom: 1px solid #ffac7d;
}
.myPage-container-main .list-collapse-item .content-collapse-top .office-item {
  border-bottom: 1px dashed #FFAC7D;
  padding: 0.5rem 0;
}
.myPage-container-main .list-collapse-item .content-collapse-top .office-item:last-child {
  border-bottom: none;
}
.myPage-container-main .list-collapse-item .content-collapse-top .title {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #F8601B;
}
.myPage-container-main .list-collapse-item .content-collapse-top .text-icon {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #463529;
  gap: 6px;
}
.myPage-container-main .list-collapse-item .content-collapse-top .text-normal {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #463529;
  margin-left: 24px;
}
.myPage-container-main .list-collapse-item .content-collapse-top .title-right a {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  text-decoration-line: underline;
  color: #F8601B;
  margin-left: 24px;
}
.myPage-container-main .list-collapse-item .content-collapse-top .title-item-list {
  border-bottom: "1px dashed #FFAC7D";
}
.myPage-container-main .list-collapse-item .content-collapse-top .title-item-list:last-child {
  border: none;
}
.myPage-container-main .list-collapse-item .content-collapse-bottom {
  padding: 32px;
  gap: 24px;
  height: 50%;
}
.myPage-container-main .list-collapse-item .content-collapse-bottom .text-note {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.25px;
  color: #463529;
}
.myPage-container-main .list-collapse-item .content-collapse-bottom .link-url {
  width: 100%;
  background: #fff7f2;
  border: 1px solid #ffac7d;
  border-radius: 4px;
  padding: 12px;
  gap: 10px;
  position: relative;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.25px;
  color: #f8601b;
}
.myPage-container-main .list-collapse-item .content-collapse-bottom .link-url .icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
}
.myPage-container-main .list-collapse-item .collapse-empty {
  margin-top: 32px;
}
.myPage-container-main .list-collapse-item .data-collapse {
  margin-top: 32px;
  margin-bottom: 24px;
  width: 775px;
}
.myPage-container-main .list-collapse-item .data-collapse-item {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #463529;
  border-bottom: 1px solid #ecedef;
  border-left: 1px solid #ecedef;
  border-right: 1px solid #ecedef;
}
.myPage-container-main .list-collapse-item .data-collapse-item:last-child {
  border-bottom: unset;
}
.myPage-container-main .list-collapse-item .data-collapse-item:first-child {
  border-top: 1px solid #ecedef;
}
.myPage-container-main .list-collapse-item .data-collapse-note {
  background: #fff7f2;
  border-left: 4px solid #f8601b;
  padding: 12px;
  gap: 10px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  letter-spacing: 0.25px;
}
.myPage-container-main .list-collapse-item .data-collapse-note .icon {
  margin-right: 4px;
  vertical-align: middle;
}
.myPage-container-main .list-collapse-item .data-collapse-note a {
  text-decoration-line: underline;
  color: #f8601b;
}
.myPage-container-main .list-collapse-item .data-collapse table th {
  padding: 10px 16px;
}
.myPage-container-main .list-collapse-item .data-collapse table tbody td {
  padding: 10px 16px;
  font-size: 16px;
  line-height: 24px;
}
.myPage-container-main .list-collapse-item .table-collapse {
  margin-top: 40px;
  display: flex;
  width: 100%;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}
.myPage-container-main .list-collapse-item .table-collapse-header {
  background: #f5f5f5;
  padding: 8px;
  gap: 10px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #463529;
  border-bottom: 1px solid #bcbfc4;
}
.myPage-container-main .list-collapse-item .table-collapse-main {
  padding: 6px 8px;
  gap: 10px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #463529;
}
.myPage-container-main .list-collapse-item .table-collapse .table-collapse-item {
  width: 30%;
}
.myPage-container-main .form-title {
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  letter-spacing: 0.25px;
  color: #463529;
}
.myPage-container-main .form-content {
  padding: 0px;
  gap: 32px;
  width: 774px;
}
.myPage-container-main .formInput-content {
  padding: 0px;
  gap: 32px;
  width: 506px;
}
.myPage-container-main .icon-eye {
  top: 66%;
  transform: translateY(-50%);
  right: 20px;
  cursor: pointer;
}
.myPage-container-main .success {
  border-color: #358b43;
  color: #358b43;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
}
.myPage-container-main .formSwitch {
  padding: 44px;
  gap: 10px;
  width: 774px;
  border: 2px solid #bcbfc4;
  border-radius: 4px;
}
.myPage-container-main .formSwitch-left {
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.25px;
  color: #463529;
}
.myPage-container-main .formSwitch-right .form-check-input {
  width: 48px;
  height: 25px;
  cursor: pointer;
  -webkit-appearance: none !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) !important;
  background-color: #BCBFC4;
  background-size: 20.5px;
  background-position: 1px center;
}
.myPage-container-main .formSwitch-right .form-check-input:checked {
  background-color: #f8601b;
  border-color: #f8601b;
  background-position: 24px center !important;
}
.myPage-container-main .form-message {
  gap: 16px;
  width: 774px;
  border-width: 1px 0px;
  background: #fbfcfb;
  padding: 12px 18px;
  border-width: 1px 0px;
  border-style: dashed;
}
.myPage-container .inspection-date {
  background-color: #FFF7F2;
  border: 1px solid #FFE7E6;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.modal-confirm {
  height: 208px;
  padding: 30px;
  gap: 10px;
}
.modal-confirm-header {
  letter-spacing: 0.25px;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #463529;
}
.modal-confirm-button {
  margin-top: 20px;
  padding: 0px;
  gap: 24px;
}
.modal-confirm-button button {
  padding: 14px 24px;
  gap: 10px;
  border: unset;
  height: 52px;
  width: 245px;
  border-radius: 4px;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.25px;
}
.modal-confirm-button .btn-cancel {
  background: #fff7f2;
  color: #F8601B;
}
.modal-confirm-button .btn-logout {
  background: #F8601B;
  color: #FFFFFF;
}

.inquiryForm .modal-content {
  border-radius: 4px 4px 0px 0px !important;
}
.inquiryForm-header {
  border-top: 4px solid #f8601b;
  height: 62px;
  padding: 0 20px;
}
.inquiryForm-header-text {
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0.25px;
  color: #f8601b;
}
.inquiryForm-main {
  background: #f5f5f5;
  padding: 32px 36px;
  gap: 10px;
}
.inquiryForm-main-title {
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.25px;
  color: #463529;
}
.inquiryForm-main-content {
  padding: 26px 32px;
  gap: 10px;
  background: #ffffff;
  border-radius: 4px;
}
.inquiryForm-main-content .content-title {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #463529;
}
.inquiryForm-main-content .content-main {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #463529;
}

.inquiryForm-success .modal-content {
  border-radius: 4px !important;
  padding: 16px 24px 24px;
  gap: 10px;
}
.inquiryForm-success .btn-close {
  position: absolute;
  top: 21px;
  right: 18px;
  cursor: pointer;
}
.inquiryForm-success .btn-thanks {
  margin-top: 40px;
  position: relative;
}
.inquiryForm-success .btn-thanks .arrow-up {
  position: absolute;
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  border-bottom: 20px solid #f8601b;
}
.inquiryForm-success .btn-thanks button {
  height: 59px;
  background: #f8601b;
  box-shadow: 0px 6px 0px #d8bfb7;
  border-radius: 30px;
  padding: 12px 32px;
  gap: 10px;
  font-weight: 700;
  font-size: 24px;
  line-height: 35px;
  color: #FFFFFF;
  border: unset;
}
.inquiryForm-success .text-note {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #463529;
}

.resetPassword-modal .modal-content {
  border-radius: 4px !important;
}
.resetPassword-modal .resetPassword-modal-content {
  padding: 40px;
  gap: 10px;
}
.resetPassword-modal-title {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #463529;
}
.resetPassword-modal .btn-bg-white {
  padding: 14px 24px;
  gap: 10px;
  height: 52px;
  background: #fff7f2;
  border-radius: 4px;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #f8601b;
  border: unset;
  width: calc(50% - 10px);
}
.resetPassword-modal .btn-orange {
  width: calc(50% - 10px);
}

.modal-confirm-logout .modal-content {
  border-radius: 4px !important;
  gap: 10px;
}

.profile-setting-item {
  width: 100%;
  height: 162px;
  background: #fff7f2;
  border: 4px solid #ffe6d6;
  border-radius: 4px;
  gap: 10px;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #463529;
  cursor: pointer;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.formSwitch {
  gap: 10px;
  border: 2px solid #bcbfc4;
  border-radius: 4px;
  width: 100%;
}
.formSwitch-left {
  font-weight: 700;
  color: #463529;
}
.formSwitch-right .form-check-input {
  width: 48px;
  height: 25px;
  cursor: pointer;
  -webkit-appearance: none !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) !important;
  background-color: #BCBFC4;
  background-size: 20.5px;
  background-position: 1px center;
}
.formSwitch-right .form-check-input:checked {
  background-color: #f8601b;
  border-color: #f8601b;
  background-position: 24px center !important;
}

.modal-success .modal-dialog {
  max-width: 618px;
  width: 100%;
}
.modal-success .modal-content {
  padding: 28px 38px;
}
.modal-success__content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.modal-success__content-title {
  color: #F8601B;
  font-size: 18px;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: 0.25px;
  margin-top: 32px;
  margin-bottom: 0;
}
.modal-success__content-sub-title {
  display: block;
  font-size: 14px;
  line-height: 28px;
  letter-spacing: 0.25px;
  margin-top: 16px;
}
.modal-success__content-line {
  width: 46px;
  height: 0;
  border: 1px solid #6C757D;
  display: inline-block;
  margin-top: 28px;
}
.modal-success__content-txt-email {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #333333;
  margin-top: 12px;
}
.modal-success__btn {
  width: 100%;
}

@media screen and (min-width: 900px) {
  .contract-icon {
    width: 24px;
    height: 31px;
    position: relative;
    bottom: 6px;
  }
  .inquiry-form {
    width: 650px;
  }
  .confirmContract-left {
    width: 640px;
  }
  .confirmContract-left hr {
    width: 100%;
  }
  .formSwitch {
    padding: 2em;
    gap: 10px;
    border: 2px solid #bcbfc4;
    border-radius: 4px;
    width: 100%;
  }
  .formSwitch-left {
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    letter-spacing: 0.25px;
  }
  .formSwitch-right .form-check-input {
    width: 48px;
    height: 25px;
    -webkit-appearance: none !important;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) !important;
    background-color: #BCBFC4;
    background-size: 20.5px;
    background-position: 1px center;
  }
  .formSwitch-container {
    width: 50%;
  }
  .profile-setting {
    min-width: 500px;
  }
  .profile-setting-item {
    margin-bottom: 32px;
  }
  .myPage-container {
    min-height: 100%;
  }
  .myPage-container-header {
    font-size: 16px;
    line-height: 24px;
    justify-content: center;
    height: 64px;
  }
  .myPage-container-main {
    min-height: calc(100vh - 326px);
    padding: 24px 12px;
    gap: 24px;
  }
  .myPage-container-main .title-list {
    font-size: 18px;
    letter-spacing: 0.25px;
  }
  .myPage-container-main .myPage-list {
    width: 80%;
    gap: 24px;
  }
  .myPage-container-main .myPage-list-item {
    width: 40%;
    height: 120px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
  }
  .myPage-container-main .myPage-list-item img {
    width: 45px;
    height: 45px;
  }
  .myPage-container-main .list-collapse-item .title-collapse {
    padding: 0;
    font-size: 24px;
    line-height: 34.75px;
    letter-spacing: 0.25px;
  }
  .myPage-container-main .list-collapse-item .content-collapse {
    width: 100% !important;
    height: 100% !important;
    border: 4px solid #ffac7d;
  }
  .myPage-container-main .list-collapse-item .content-collapse-top {
    flex-direction: column !important;
    padding: 10px;
    gap: 15px;
  }
  .myPage-container-main .list-collapse-item .content-collapse-top .info-text {
    width: 100% !important;
  }
  .myPage-container-main .list-collapse-item .content-collapse-bottom {
    padding: 34px;
    gap: 10px;
  }
  .myPage-container-main .list-collapse-item .content-collapse-bottom .link-url {
    font-size: 16px;
    line-height: 24px;
  }
  .myPage-container-main .list-collapse-item .data-collapse {
    width: 100%;
  }
  .myPage-container-main .list-collapse-item .data-collapse-item {
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 0.25px;
    padding: 5px 0;
  }
  .myPage-container-main .form-title {
    font-size: 18px;
    line-height: 26px;
    letter-spacing: 0.25px;
  }
  .myPage-container-main .form-content {
    gap: 22px;
    width: 100%;
  }
  .myPage-container-main .formInput-content {
    gap: 22px;
  }
  .myPage-container-main .confirmContract {
    padding: 16px 12px 20px;
    gap: 10px;
  }
  .myPage-container-main .confirmContract-title {
    font-size: 18px;
    line-height: 26px;
  }
  .myPage-container-main .confirmContract-left {
    margin-top: 20px;
  }
  .myPage-container-main .confirmContract-left-main {
    padding: 16px 12px;
    width: 100%;
    margin-top: 20px;
  }
  .myPage-container-main .confirmContract-right-main {
    padding: 16px 12px;
  }
  .myPage-container-main .confirmContract-right-top {
    margin-top: 25px;
  }
  .myPage-container-main .formSwitch {
    width: 100%;
    padding: 24px 12px;
    gap: 10px;
  }
  .myPage-container-main .formSwitch-left {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.25px;
    color: #463529;
  }
  .myPage-container-main .form-message {
    width: 100%;
  }
  .inspection-date {
    padding: 12px 32px;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }
  .changeID .modal-dialog {
    width: 618px !important;
  }
  .changeID .modal-content {
    border-radius: 4px !important;
    padding: 25px 46px;
    gap: 10px;
  }
  .changeID-icon-close {
    width: 14px;
    height: 14px;
    align-self: end;
    cursor: pointer;
  }
  .changeID-text {
    color: #463529;
    text-align: center;
    font-size: 14px;
  }
  .changeID-text.title {
    font-size: 24px;
    font-weight: 700;
  }
  .changeID-text.content {
    font-weight: 500;
  }
  .changeID-btn {
    margin-top: 30px;
  }
  .changeID-line {
    background: #f8601b;
    height: 1px;
    width: 162px;
    align-self: center;
    margin-top: 5px;
    margin-bottom: 20px;
  }
}
@media screen and (max-width: 899px) {
  .inquiryForm-success .text-note {
    font-size: 14px;
    line-height: 20px;
  }
  .form-qa-not-login .text-link {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .contract-icon {
    width: 20px;
    height: 26px;
    position: relative;
    bottom: 4px;
  }
  .inquiry-form {
    width: 100%;
  }
  hr {
    width: 100%;
  }
  .confirmContract-left {
    width: 100%;
  }
  .confirmContract-left-main {
    padding: 12px;
  }
  .confirmContract-right {
    width: 100%;
  }
  .confirmContract-right-main {
    width: 100%;
    padding: 12px 0;
    gap: 10px;
  }
  .formSwitch {
    width: 100%;
    padding: 24px 12px;
    gap: 10px;
  }
  .formSwitch-left {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.25px;
    color: #463529;
  }
  .formSwitch-container {
    width: 100%;
  }
  .form-message {
    width: 100%;
  }
  .myPage-container-main .success {
    font-size: 14px;
    line-height: 22px;
  }
  .modal-confirm {
    height: 134px;
    gap: 0px;
  }
  .modal-confirm-header {
    font-size: 14px !important;
    color: #464646;
  }
  .modal-confirm-button button {
    height: 40px;
    font-size: 14px !important;
  }
  .profile-setting {
    width: 100%;
  }
  .profile-setting-item {
    margin-bottom: 12px;
  }
  .myPage-container {
    min-height: 100%;
  }
  .myPage-container-header {
    font-size: 16px;
    line-height: 24px;
    justify-content: center;
    flex-direction: column !important;
    padding: 5px 24px;
  }
  .myPage-container-header .contract {
    justify-content: space-between;
    width: 100%;
  }
  .myPage-container-header .contract-name {
    font-size: 12px;
    line-height: 18px;
  }
  .myPage-container-header .contract-number {
    font-size: 12px;
  }
  .myPage-container-main {
    padding: 24px 12px;
    gap: 10px;
  }
  .myPage-container-main .title-list {
    font-size: 16px;
    letter-spacing: 0.25px;
  }
  .myPage-container-main .myPage-list {
    width: 100%;
    gap: 10px;
  }
  .myPage-container-main .myPage-list-item {
    width: 50%;
    height: 81px;
    font-size: 10px;
    line-height: 18px;
  }
  .myPage-container-main .myPage-list-item img {
    width: 32px;
    height: 32px;
  }
  .myPage-container-main .list-collapse-item .title-collapse {
    padding: unset;
    font-size: 18px;
    line-height: 26px;
    letter-spacing: 0.25px;
  }
  .myPage-container-main .list-collapse-item .collapse-wrapper {
    margin-right: calc(-0.5 * var(--cui-gutter-x));
    margin-left: calc(-0.5 * var(--cui-gutter-x));
  }
  .myPage-container-main .list-collapse-item .content-collapse {
    width: 100% !important;
    height: 100% !important;
    border: 2px solid #ffac7d;
  }
  .myPage-container-main .list-collapse-item .content-collapse-top {
    flex-direction: column !important;
    padding: 10px;
    gap: 15px;
  }
  .myPage-container-main .list-collapse-item .content-collapse-top .text-icon {
    font-size: 14px;
  }
  .myPage-container-main .list-collapse-item .content-collapse-top .info-text {
    width: 100% !important;
  }
  .myPage-container-main .list-collapse-item .content-collapse-bottom {
    padding: 14px;
    gap: 12px;
  }
  .myPage-container-main .list-collapse-item .content-collapse-bottom .text-note {
    font-size: 12px;
    line-height: 20px;
  }
  .myPage-container-main .list-collapse-item .content-collapse-bottom .link-url {
    align-items: flex-start !important;
    font-size: 14px;
    line-height: 22px;
    word-break: break-all;
    white-space: pre-line;
  }
  .myPage-container-main .list-collapse-item .content-collapse-bottom .link-url .icon {
    position: relative;
    top: 4px;
    left: 0;
    transform: unset;
  }
  .myPage-container-main .list-collapse-item .collapse {
    width: 100%;
  }
  .myPage-container-main .list-collapse-item .data-collapse {
    width: 100%;
  }
  .myPage-container-main .list-collapse-item .data-collapse-note {
    font-size: 14px;
    line-height: 20px;
  }
  .myPage-container-main .list-collapse-item .data-collapse-item {
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 0.25px;
    padding: 5px 0;
  }
  .myPage-container-main .list-collapse-item .data-collapse table th {
    padding: 12px;
  }
  .myPage-container-main .list-collapse-item .data-collapse table tbody td {
    font-size: 12px;
    line-height: 18px;
    padding: 12px;
  }
  .myPage-container-main .list-collapse-item .table-collapse {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .myPage-container-main .list-collapse-item .table-collapse-main {
    font-size: 12px;
    line-height: 16px;
  }
  .myPage-container-main .list-collapse-item .table-collapse .table-collapse-item {
    width: 100%;
  }
  .myPage-container-main .form-title {
    font-size: 18px;
    line-height: 26px;
    letter-spacing: 0.25px;
  }
  .myPage-container-main .form-content {
    gap: 22px;
    width: 100%;
  }
  .myPage-container-main .formInput-content {
    gap: 22px;
    width: 100%;
  }
  .myPage-container-main .confirmContract {
    padding: 16px 12px 20px;
  }
  .myPage-container-main .confirmContract-title {
    font-size: 18px;
    line-height: 26px;
  }
  .myPage-container-main .confirmContract-left {
    width: 100%;
    margin-top: 20px;
  }
  .myPage-container-main .confirmContract-left-main {
    padding: 16px 12px;
    margin-top: 20px;
    width: 100%;
  }
  .myPage-container-main .confirmContract-right {
    width: 100%;
  }
  .myPage-container-main .confirmContract-right-main {
    padding: 16px 12px;
  }
  .myPage-container-main .confirmContract-right-top {
    margin-top: 25px;
  }
  .myPage-container-main .title-item-list {
    flex-direction: column !important;
  }
  .myPage-container-main .title-item {
    width: 100% !important;
  }
  .inquiryForm-header-text {
    font-size: 16px;
    line-height: 24px;
  }
  .inspection-date {
    padding: 12px 12px;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
  }
  .changeID .modal-content {
    border-radius: 4px !important;
    padding: 20px 10px;
    gap: 5px;
  }
  .changeID-icon-close {
    width: 14px;
    height: 14px;
    align-self: end;
    cursor: pointer;
    margin-bottom: 10px;
    margin-left: auto;
  }
  .changeID-input {
    height: 40px;
    font-size: 14px;
  }
  .changeID-text {
    color: #463529;
    text-align: center;
    font-size: 12px;
  }
  .changeID-text.title {
    font-size: 18px;
    font-weight: 700;
  }
  .changeID-text.content {
    white-space: break-spaces;
    font-weight: 500;
  }
  .changeID-btn {
    margin-top: 25px;
  }
  .changeID-line {
    background: #f8601b;
    height: 1px;
    width: 75px;
    align-self: center;
    margin-top: 5px;
    margin-bottom: 10px;
  }
  .modal-success .modal-dialog {
    width: auto;
  }
  .modal-success .modal-content {
    padding: 20px 12px;
  }
  .modal-success__content-title {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
  }
  .modal-success__content-sub-title {
    font-size: 12px;
    line-height: 16px;
  }
  .modal-success__content-line {
    width: 36px;
  }
  .modal-success__content-txt-email {
    font-size: 12px;
    line-height: 16px;
  }
  .formSwitch-right .form-check-input {
    width: 48px;
    height: 25px;
    cursor: pointer;
    -webkit-appearance: none !important;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) !important;
    background-color: #BCBFC4;
    background-size: 21px;
    background-position: 1px center;
  }
  .formSwitch-right .form-check-input:checked {
    background-color: #f8601b;
    border-color: #f8601b;
    background-position: 24px center !important;
  }
}
.sendMail {
  width: 618px;
  padding: 72px 68px;
  gap: 10px;
  background: #FFFFFF;
  border-top: 4px solid #F8601B;
  box-shadow: 0px 4px 18px #fbd7b6;
  border-radius: 4px;
}
.sendMail-title {
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  letter-spacing: 0.25px;
  color: #463529;
}
.sendMail-message {
  gap: 40px;
  width: 482px;
  height: 48px;
  border-width: 1px 0px;
  background: #fbfcfb;
  padding: 12px 18px;
  border-width: 1px 0px;
  border-style: dashed;
}
.sendMail .success {
  border-color: #358b43;
  color: #358b43;
  font-weight: 500;
  line-height: 24px;
}
.sendMail hr {
  width: 50px;
}
.sendMail-note {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #333333;
}

.link-terms-of-use {
  padding: 8px 12px;
  gap: 10px;
  background: #FFF7F2;
  border-left: 2px solid #F8601B;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.link-terms-of-use a {
  text-decoration: underline;
  color: #F8601B;
  position: relative;
  left: 5px;
}
.link-terms-of-use a .navigate-text {
  margin-left: 10px;
}

.error {
  gap: 10px;
  width: 100%;
  height: auto;
  border-width: 1px 0px;
  background: #ffe7e6;
  padding: 12px 17px;
  border-width: 1px 0px;
  border-style: dashed;
  color: #ff0f00;
  font-size: 16px;
}

.click-link {
  font-size: 16px;
  line-height: 24px;
  gap: 8px;
}
.click-link a {
  text-decoration-line: underline !important;
  color: #f8601b !important;
}

.auth-container {
  padding: 72px 68px;
  gap: 10px;
  width: 618px;
  background: #FFFFFF;
  border-top: 4px solid #f8601b;
  box-shadow: 0px 4px 18px #fbd7b6;
  border-radius: 4px;
}
.auth-container-title {
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  letter-spacing: 0.25px;
  color: #463529;
}
.auth-container-titleMore {
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.25px;
  color: #463529;
}
.auth-container-titleMore hr {
  width: 160px;
  border-top: 2px solid #f8601b;
}
.auth-container-form .icon-eye {
  top: 66%;
  transform: translateY(-50%);
  right: 20px;
  cursor: pointer;
}
.auth-container-form .remember-password {
  padding: 0px;
  gap: 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #463529;
  margin-top: 8px;
}
.auth-container-form .remember-password .form-check-input {
  -webkit-appearance: none !important;
  cursor: pointer;
}
.auth-container-form .remember-password .form-check-input:checked {
  background-color: #f8601b;
  border-color: #f8601b;
}
.auth-container-form .form-btn-my {
  margin-top: 40px;
  margin-bottom: 32px;
}
.auth-container-form .text-special {
  color: #6C757D;
  height: 22px;
  position: relative;
  width: 162px;
  margin: 20px 0;
}
.auth-container-form .text-special-content {
  left: 50%;
  position: absolute;
  background: #fff;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  padding: 0 10px;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
  z-index: 1;
  top: 50%;
  transform: translate(-50%, -50%);
}
.auth-container-form .text-special-line {
  background: #6c757d;
  height: 1px;
  width: 100%;
  z-index: 0;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}
.auth-container-form .noti-special {
  padding: 12px;
  gap: 10px;
  width: 100%;
  background: #fff7f2;
}
.auth-container-form .noti-special-title {
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #f8601b;
  gap: 6px;
}
.auth-container-form .noti-special-text {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.25px;
  color: #463529;
}
.auth-container-form .noti-special-time {
  font-size: 12px;
}
.auth-container-form .redirect-login {
  padding: 12px;
  gap: 10px;
  width: 100%;
  background: #fff7f2;
  border-top: 1px solid #ffac7d;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #333333;
  text-align: center;
}
.auth-container-form .redirect-login a {
  text-decoration-line: underline;
  color: #f8601b;
}
.auth-container-form .term {
  margin-top: 20px;
  padding: 12px 16px;
  gap: 10px;
  background: #fff7f2;
  border-width: 1px 0px;
  border-style: solid;
  border-color: #ffac7d;
}
.auth-container-form .term-top {
  gap: 10px;
}
.auth-container-form .term-top a {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.25px;
  text-decoration-line: underline;
  color: #f8601b;
}
.auth-container-form .term-bottom {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #463529;
}
.auth-container-form .line-auth {
  width: 50px;
  border-top: 2px solid #bcbfc3;
  margin-top: 20px;
}
.auth-container-form .text-black {
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #463529;
}

.container-verify {
  width: 618px;
  background: #FFFFFF;
  filter: drop-shadow(0px 4px 18px #fbd7b6);
}
.container-verify-header {
  border-bottom: 1px dashed #F8601B;
  border-radius: 4px 4px 0 0;
  height: 82px;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: #F8601B;
  padding: 0 24px;
  width: 100%;
}
.container-verify-table {
  width: 100%;
  padding: 32px 14px;
  gap: 10px;
  background: #fff7f2;
}
.container-verify-table .main-title {
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  letter-spacing: 0.25px;
  color: #463529;
  margin-bottom: 30px;
}
.container-verify-table .main-table {
  padding: 15px 25px;
  gap: 10px;
  width: 90%;
  border: 2px solid #ffac7d;
  border-radius: 4px;
}
.container-verify-table .main-table-item {
  gap: 20px;
  padding: 10px 0;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #463529;
}
.container-verify-table .main-table-item:nth-child(2) {
  border-color: #bcbfc3;
  border-width: 1px 0px;
  border-style: solid;
  padding: 10px 0;
}
.container-verify-slide {
  width: 100%;
  padding: 32px;
  gap: 10px;
  background: #ecf0eb;
}
.container-verify-slide .main-title {
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  letter-spacing: 0.25px;
  color: #463529;
  margin-bottom: 30px;
}
.container-verify-slide .main-table {
  padding: 15px 25px;
  gap: 10px;
  width: 100% !important;
  background: white;
  border: 2px solid #4eae5d;
  border-radius: 4px;
}
.container-verify-slide .main-table-item {
  gap: 20px;
  padding: 10px 0;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #463529;
}
.container-verify-slide .main-table-item:nth-child(2) {
  border-color: #bcbfc3;
  border-width: 1px 0px;
  border-style: solid;
  padding: 10px 0;
}
.container-verify-main {
  padding: 32px;
  gap: 10px;
}
.container-verify-main .main-left {
  width: 100%;
  gap: 32px;
}
.container-verify-main .main-left-title {
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  letter-spacing: 0.25px;
  color: #463529;
}
.container-verify-main .main-left-table {
  padding: 15px 25px;
  gap: 10px;
  width: 100%;
  border: 2px solid #ffac7d;
  border-radius: 4px;
  background: white;
}
.container-verify-main .main-left-table-item {
  gap: 20px;
  padding: 10px 0;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #463529;
}
.container-verify-main .main-left-table-item .font-500 {
  font-weight: 500;
}
.container-verify-main .main-left-table-item:nth-child(2) {
  border-color: #bcbfc3;
  border-width: 1px 0px;
  border-style: solid;
  padding: 10px 0;
}
.container-verify-main .main-right {
  width: 90%;
  margin-top: 50px;
}
.container-verify-main .main-right-title {
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  letter-spacing: 0.25px;
  color: #463529;
}
.container-verify-main .main-right-description {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.25px;
  color: #463529;
}
.container-verify-main .main-right hr {
  width: 160px;
  border-top: 2px solid #f8601b;
}
.container-verify-main .main-right-form {
  gap: 10px;
}
.container-verify-main .main-right-form .icon-eye {
  top: 66%;
  transform: translateY(-50%);
  right: 20px;
  cursor: pointer;
}

.modal-register .text-brown {
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #463529;
  margin-bottom: 4px;
  width: 100%;
  text-align: center;
}
.modal-register .modal-content {
  border-radius: 4px 4px 0px 0px !important;
}
.modal-register-main {
  padding: 16px 12px;
  gap: 10px;
  background: #ffffff;
  border-radius: 4px;
}
.modal-register-main .content img {
  width: 300px;
}
.modal-register-main .content-text {
  padding: 20px 0px;
}
.modal-register-main .content-text .text-orange {
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  letter-spacing: 0.25px;
  color: #f8601b;
  margin: 21px 0;
}

.custom-width {
  width: auto;
}

.modal-slider {
  width: 100%;
  height: 100%;
  padding: 40px;
  align-items: center;
}
.modal-slider .slick-dots li button:before {
  font-size: 8px !important;
}
.modal-slider .slick-dots li.slick-active button:before {
  color: #000000 !important;
}
.modal-slider .custom-arrow:before {
  color: #3ABCEA !important;
  position: absolute;
  transform: scale(1.3);
}
.modal-slider .title {
  font-size: 1.1rem;
  color: #3ABCEA;
  font-weight: bold;
}
.modal-slider .content {
  color: #FFFFFF;
  background-color: #3ABCEA;
  border-radius: 40%/250%;
  padding: 0 5px;
  line-height: 26px;
}
.modal-slider .red {
  color: red;
}
.modal-slider .image {
  max-width: 80%;
  margin: auto;
  margin-bottom: 20px;
}
.modal-slider .icon-close {
  position: absolute;
  cursor: pointer;
  top: 40px;
  right: 25px;
  width: 25px;
  height: 25px;
}

@media screen and (max-width: 899px) {
  .container-verify-slide .main-table {
    padding: 15px 25px;
    gap: 10px;
  }
  .container-verify-slide .main-table-item {
    gap: 20px;
    padding: 10px 0;
    font-size: 14px;
    line-height: 20px;
  }
  .error {
    font-size: 14px;
  }
  .sendMail .success {
    line-height: 22px;
  }
  .modal-register .text-brown {
    line-height: 16px;
  }
  .main-left {
    padding: 0 30px;
  }
  .container-verify-main {
    padding: 32px 2px;
  }
  .custom-width {
    width: 100%;
  }
  .sendMail {
    width: 60%;
    padding: 32px 18px;
  }
  .sendMail-title {
    font-size: 18px;
  }
  .sendMail-message {
    width: 100%;
  }
  .auth-container {
    width: 80%;
    padding: 36px 18px;
    gap: 10px;
  }
  .auth-container-title {
    font-size: 18px;
    line-height: 26px;
  }
  .auth-container .error {
    width: 100%;
  }
  .container-verify-header {
    height: 64px;
    font-size: 16px;
    line-height: 20px;
  }
  .container-verify-main .main-left-title {
    font-size: 18px;
    line-height: 26px;
  }
  .container-verify-main .main-left-table-item {
    padding: 10px 0;
    font-size: 14px;
    line-height: 20px;
  }
  .container-verify-main .main-left-table-item:nth-child(2) {
    padding: 10px 0;
  }
  .container-verify-main .main-right-title {
    font-size: 18px;
    line-height: 26px;
  }
  .container-verify-main .main-right-description {
    font-size: 12px;
    line-height: 18px;
  }
  .container-verify-slide .main-title {
    font-size: 18px;
    line-height: 26px;
  }
  .container-verify-table .main-title {
    font-size: 18px;
    line-height: 26px;
  }
  .custom-width {
    width: auto;
  }
  .modal-slider {
    width: 100%;
    height: 100%;
    padding: 40px;
    padding-top: 20px;
    align-items: center;
  }
  .modal-slider .slick-dots li button:before {
    font-size: 8px !important;
  }
  .modal-slider .slick-dots li.slick-active button:before {
    color: #000000 !important;
  }
  .modal-slider .custom-arrow:before {
    color: #3ABCEA !important;
    position: absolute;
    transform: scale(0.8);
  }
  .modal-slider .title {
    font-size: 1.1rem;
    color: #3ABCEA;
    font-weight: bold;
  }
  .modal-slider .content {
    color: #FFFFFF;
    background-color: #3ABCEA;
    border-radius: 40%/250%;
    padding: 0 5px;
    line-height: 26px;
    font-size: 14.4px;
  }
  .modal-slider .content-2 {
    font-size: 14.4px;
    text-align: center;
  }
  .modal-slider .red {
    color: red;
  }
  .modal-slider .image {
    max-width: 80%;
    margin: auto;
    margin-bottom: 5px;
  }
  .modal-slider .icon-close {
    position: absolute;
    cursor: pointer;
    top: 30px;
    right: 15px;
    width: 15px;
    height: 15px;
  }
}
@media screen and (max-width: 739px) {
  .click-link {
    font-size: 14px;
    gap: 2px;
    letter-spacing: 0.25px;
  }
  .sendMail {
    width: 100%;
    padding: 32px 18px;
  }
  .sendMail-title {
    font-size: 18px;
  }
  .sendMail-message {
    width: 100%;
  }
  .auth-container {
    width: 100%;
    padding: 36px 18px;
    gap: 10px;
  }
  .auth-container-title {
    font-size: 18px;
    line-height: 26px;
  }
  .auth-container .error {
    width: 100%;
  }
  .auth-container-titleMore {
    font-size: 12px;
    white-space: break-spaces;
  }
  .container-verify-header {
    height: 64px;
    font-size: 16px;
    line-height: 20px;
  }
  .container-verify-main {
    padding: 24px 2px;
  }
  .container-verify-main .main-left-title {
    font-size: 18px;
    line-height: 26px;
  }
  .container-verify-main .main-left-table {
    padding: 15px 25px;
  }
  .container-verify-main .main-left-table-item {
    padding: 10px 0;
    font-size: 14px;
    line-height: 20px;
  }
  .container-verify-main .main-left-table-item:nth-child(2) {
    padding: 10px 0;
  }
  .container-verify-main .main-right-title {
    font-size: 18px;
    line-height: 26px;
  }
  .container-verify-slide .main-title {
    font-size: 18px;
    line-height: 26px;
  }
  .container-verify-table .main-title {
    font-size: 18px;
    line-height: 26px;
  }
}
.slick-prev:before,
.slick-next:before {
  color: #4eae5d !important;
}

.slick-dots li button:before {
  font-size: 16px !important;
  line-height: 20px;
}

.slick-dots li.slick-active button:before {
  color: #4eae5d !important;
}

.notification-page {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.noti-item {
  cursor: pointer;
  border-radius: 6px;
}

.readedItem {
  background-color: #F5F5F5;
}

.unReadItem {
  background-color: #FFF7F2;
}

.bell-noti-icon {
  color: #FFFFFF;
  border-radius: 50%;
  padding: 6px;
  width: 16px;
  height: 16px;
  bottom: 4px;
  position: relative;
}

.noti-badge {
  margin-right: 0.2rem;
}
.noti-badge span {
  color: #FFFFFF;
  background-color: #FF0F00;
  font-weight: 500;
  font-size: 10px;
  line-height: 14px;
  border-radius: 14px;
  padding: 4px 0px;
  white-space: nowrap;
}

.noti-content {
  margin-top: 12px;
}

.fileDownload {
  cursor: pointer;
  color: #21699E;
  text-decoration: underline;
  margin-left: 10px;
}

.preview-img {
  width: 100%;
  background: #FFFFFF;
  border: 1px solid #B1B7C1;
  border-radius: 5px;
  margin-bottom: 20px;
  padding: 10px;
}
.preview-img .background-img {
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  border-radius: 5px;
}

@media screen and (min-width: 900px) {
  .noti-date {
    text-align: end;
    min-width: 150px;
  }
  .noti-item {
    padding: 24px 20px;
    margin-bottom: 12px;
    width: 55%;
  }
  .preview-img {
    height: 315px;
  }
  .noti-banner {
    width: 100%;
    max-width: 757px;
    height: auto;
  }
  .noti-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
  }
  .noti-title {
    display: flex;
    justify-content: space-between;
  }
  .card-body {
    display: flex;
    justify-content: center;
  }
  .noti-detail-container {
    width: 70%;
  }
  .noti-detail-container .noti-banner-detail {
    width: 100%;
  }
  .noti-content {
    margin-bottom: 24px;
  }
  .noti-footer {
    padding-top: 24px;
    border-top: 1px dashed #F8601B;
  }
}
@media screen and (max-width: 899px) {
  .noti-item {
    padding: 16px;
    margin-bottom: 16px;
    width: 100%;
  }
  .preview-img {
    height: 113px;
  }
  .noti-banner {
    width: 100%;
  }
  .noti-header {
    display: flex;
    flex-direction: column-reverse;
  }
  .noti-date {
    min-width: 150px;
    text-align: left;
    margin-bottom: 8px;
  }
  .noti-title {
    display: flex;
    justify-content: space-between;
  }
  .noti-title h6, .noti-title .h6 {
    position: relative;
    top: 2px;
  }
  .card-body {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .noti-detail-container {
    width: 100%;
  }
  .noti-detail-container .noti-banner-detail {
    width: 100%;
  }
  .noti-content {
    margin-bottom: 24px;
  }
  .noti-footer {
    padding-top: 24px;
    border-top: 1px dashed #F8601B;
  }
}
.energy-saving-index {
  width: 100%;
}
.energy-saving-index .list-content {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.energy-saving-index .list-content .page-title {
  margin: 0;
}
@media screen and (min-width: 900px) {
  .energy-saving-index .list-item {
    width: 25%;
    flex: 0 0 25%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    margin-bottom: 1.4em;
    height: 21em;
    padding: 0.4rem;
  }
  .energy-saving-index .list-item-img-contain {
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 100%;
    height: 11rem;
    overflow: hidden;
  }
  .energy-saving-index .list-item-img {
    width: 100%;
  }
  .energy-saving-index .date-time {
    margin-top: 0.5em;
    margin-bottom: 0.1em;
  }
}
@media screen and (max-width: 899px) {
  .energy-saving-index .list-item-img-contain {
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 100%;
    height: 180px;
    overflow: hidden;
  }
  .energy-saving-index .list-item {
    margin-bottom: 30px;
    width: 50%;
    flex: 0 0 50%;
  }
  .energy-saving-index .list-item a {
    display: flex;
    justify-content: start;
  }
  .energy-saving-index .date-time {
    display: inline-block;
    margin-top: 10px;
  }
}
@media screen and (max-width: 575px) {
  .energy-saving-index .list-item {
    width: 100%;
    flex: 0 0 100%;
  }
}

.energy-saving-detail .sun-icon {
  width: 30px;
}
.energy-saving-detail .card-outline-top {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #FFF7F2;
  border: 3px solid #FFAC7D;
  box-shadow: 4px 6px 0px #d8bfb7;
  border-radius: 4px;
}
.energy-saving-detail .card-outline-bottom {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #FFF7F2;
  border: 4px solid #FFAC7D;
  border-radius: 4px;
}
.energy-saving-detail .text-explain-contain {
  display: flex;
  align-items: center;
}
.energy-saving-detail .summer-header {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #E2F2FF;
  margin-bottom: 20px;
}
.energy-saving-detail .summer-header h5, .energy-saving-detail .summer-header .h5 {
  color: #0D6FB8;
  margin: 0px 12px;
  font-weight: 700;
}
.energy-saving-detail .winter-header {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #FFF7F2;
  margin-bottom: 20px;
}
.energy-saving-detail .winter-header h5, .energy-saving-detail .winter-header .h5 {
  color: #F8601B;
  margin: 0px 12px;
  font-weight: 700;
}
.energy-saving-detail .content-title {
  background: #FFF7F2;
  border: 4px solid #FFAC7D;
  border-radius: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.energy-saving-detail .content-title .page-title-number {
  color: #FFFFFF;
  background-color: #F8601B;
  margin: 0 0.5rem;
  border-radius: 50%;
  padding: 1px 10px;
}
.energy-saving-detail .snowflake-icon {
  width: 30px;
  height: 30px;
  background: radial-gradient(50% 50% at 50% 50%, #0D6FB8 27.36%, rgba(13, 111, 184, 0) 100%);
  color: #FFFFFF;
  padding: 4px;
}
.energy-saving-detail .sun-icon {
  width: 30px;
  height: 30px;
  background: radial-gradient(50% 50% at 50% 50%, #FCCA0D 0%, rgba(252, 202, 13, 0) 100%);
  color: #FFFFFF;
  padding: 4px;
}
.energy-saving-detail .explain-notice {
  font-weight: 600;
  background: linear-gradient(transparent 60%, #FFEDE1 0%);
}
.energy-saving-detail .supText {
  font-size: 75%;
  position: relative;
  bottom: 0.4em;
}
.energy-saving-detail .summer-txt {
  color: #1F8DE2;
  font-weight: 600;
}
.energy-saving-detail .winter-txt {
  color: #F8601B;
  font-weight: #FB6C0D;
}
.energy-saving-detail a {
  text-decoration: underline;
  color: #F8601B;
  font-weight: 700;
}
.energy-saving-detail .explain-img {
  display: flex;
  justify-content: center;
  align-items: center;
}
.energy-saving-detail .main-content {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  border-radius: 4px;
}
.energy-saving-detail .content-lead {
  background-color: #FFF7F2;
  border-width: 4px 0px;
  border-style: solid;
  border-color: #FFDCC6;
  margin: auto;
}
.energy-saving-detail .top-content {
  margin-bottom: 2rem;
}
.energy-saving-detail .text-explain {
  margin-bottom: 3rem;
}
.energy-saving-detail .content-title h3, .energy-saving-detail .content-title .h3 {
  padding: 20px 30px;
}
.energy-saving-detail .content-sub-title {
  border-bottom: 2px solid #FFAC7D;
  margin-bottom: 20px;
}
@media screen and (min-width: 900px) {
  .energy-saving-detail {
    min-width: 1200px;
  }
  .energy-saving-detail .img-box {
    display: flex;
    justify-content: space-between;
  }
  .energy-saving-detail .content-lead {
    width: 80%;
  }
  .energy-saving-detail .content-lead h4, .energy-saving-detail .content-lead .h4 {
    padding: 32px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
  }
  .energy-saving-detail .top-content {
    padding: 0px 168px;
  }
  .energy-saving-detail .main-content {
    padding: 82px 168px;
  }
  .energy-saving-detail .text-explain {
    font-family: "Noto Sans JP";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
  }
  .energy-saving-detail .card-outline-top {
    padding: 32px;
    margin-bottom: 52px;
  }
  .energy-saving-detail .card-outline-bottom {
    padding: 24px 53px;
    margin-bottom: 18px;
  }
  .energy-saving-detail .summer-header,
  .energy-saving-detail .winter-header {
    padding: 16px;
  }
  .energy-saving-detail .summer-header .h5,
  .energy-saving-detail .winter-header .h5 {
    font-size: 18px;
  }
  .energy-saving-detail .quote-txt {
    font-size: 12px;
  }
  .energy-saving-detail .content-title {
    margin: 43px 0;
  }
  .energy-saving-detail .content-sub-title h4, .energy-saving-detail .content-sub-title .h4 {
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 7px;
  }
}
@media screen and (max-width: 899px) {
  .energy-saving-detail .text-explain {
    font-family: "Noto Sans JP";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
  }
  .energy-saving-detail .card-outline-top,
  .energy-saving-detail .card-outline-bottom {
    padding: 16px 12px;
    margin-bottom: 24px;
  }
  .energy-saving-detail .summer-header,
  .energy-saving-detail .winter-header {
    padding: 13px;
  }
  .energy-saving-detail .summer-header .h5,
  .energy-saving-detail .winter-header .h5 {
    font-size: 16px;
  }
  .energy-saving-detail .quote-txt {
    font-size: 10px;
  }
  .energy-saving-detail .content-lead h4, .energy-saving-detail .content-lead .h4 {
    padding: 13px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
  }
  .energy-saving-detail .top-content {
    padding: 16px 12px;
  }
  .energy-saving-detail .main-content {
    padding: 16px 12px;
  }
  .energy-saving-detail .content-title h3, .energy-saving-detail .content-title .h3 {
    padding: 12px 24px;
  }
  .energy-saving-detail .content-title {
    margin: 24px 0;
  }
  .energy-saving-detail .content-sub-title {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .energy-saving-detail .content-sub-title h4, .energy-saving-detail .content-sub-title .h4 {
    font-weight: 700;
    font-size: 16px;
    line-height: 23px;
    margin-bottom: 7px;
  }
}

.main {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.guide-pages-item {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.item {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 100%;
}

.row-items {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

#usage-guide-text-note {
  border-bottom: 1px solid #F8601B;
  padding: 0px 20px 8px 20px;
}

.contact-contain {
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.contact-contain .contact-item:first-child {
  padding-top: 16px;
  border-top: 1px solid #BCBFC4;
}
.contact-contain .contact-item:last-child {
  padding-bottom: 16px;
  border-bottom: 1px solid #BCBFC4;
}

.card-outline-explain {
  background: #FFF7F2;
  border: 4px solid #FFAC7D;
  border-radius: 4px;
  margin-bottom: 1.5rem;
  width: 100%;
  padding: 1.5em 0.5em;
  letter-spacing: 0.25px;
}

.text-qa-confirm {
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #463529;
  min-height: 2.5em;
  white-space: pre-line;
  word-break: break-all;
}

@media screen and (min-width: 900px) {
  .confirm-qa-modal-group-item {
    display: flex;
    justify-content: space-between;
  }
  .confirm-qa-modal-item {
    width: 50%;
  }
  .text-qa-confirm {
    font-size: 16px;
  }
  .main {
    width: 70%;
  }
  .contact-item {
    padding: 8px;
    display: flex;
    justify-content: space-between;
    width: 60%;
  }
  .guide-pages-item {
    width: 100%;
    margin-bottom: 35px;
  }
  .item-container {
    padding: 16px;
    flex: 0 0 auto;
    width: 50%;
    display: flex;
    cursor: pointer;
  }
  .img-icon {
    width: 18px;
    position: relative;
    left: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  h5, .h5 {
    padding: 0 10px;
    letter-spacing: 0.25px;
    line-height: 24px;
  }
}
@media screen and (max-width: 899px) {
  .card-outline-explain {
    padding: 0.5em 0.1em;
  }
  .click-here {
    display: flex;
    justify-content: center;
  }
  .text-qa-confirm {
    font-size: 14px;
  }
  .main {
    width: 100%;
  }
  .contact-item {
    padding: 6px;
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .guide-pages-item {
    width: 100%;
    margin-bottom: 32px;
  }
  .row-items {
    flex-direction: column;
  }
  .item-container {
    flex: 0 0 auto;
    width: 100%;
    max-width: 100%;
    display: flex;
    justify-content: center;
    padding: 0;
    margin-bottom: 12px;
    cursor: pointer;
  }
  .img-icon {
    width: 14px;
    position: relative;
    left: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  h5, .h5 {
    position: relative;
    top: 2px;
  }
  .title-center {
    width: 100%;
    text-align: center;
  }
  .row-qa {
    padding: 0 16px;
  }
}
.table-fixed-column {
  table-layout: fixed;
}

.table-center {
  text-align: center;
}

.column-middle {
  vertical-align: middle;
}

.graph-header {
  background-color: #FFF;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 16px;
}

.chart-label {
  margin-top: 22px;
  margin-bottom: 0;
  font-size: 24px;
  font-weight: bold;
}

.annotation-flex {
  display: flex;
  align-items: baseline;
  margin-top: 11px;
}

.annotation-last-year {
  width: 43px;
  height: 12px;
  background-color: #467395;
}

.label-last-year {
  margin-left: 7px;
  margin-right: 8px;
  font-size: 14px;
  font-weight: bold;
}

.annotation-this-year {
  width: 43px;
  height: 12px;
  background-color: #FF7F45;
  margin-left: 8px;
}

.label-this-year {
  margin-left: 7px;
  font-size: 14px;
  font-weight: bold;
}

.chart-unit {
  width: 35px;
  font-size: 17px;
  position: relative;
  margin-left: 9px;
  align-self: flex-start;
  color: #F8601B;
}

.top-screen {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.top-screen .nav {
  width: 100%;
}
.top-screen .billing-table th {
  font-family: "Noto Sans JP";
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0.25px;
  color: #463529;
}
.top-screen .billing-table td {
  color: #463529;
}

.billing-table th {
  font-family: "Noto Sans JP";
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0.25px;
  color: #463529;
}
.billing-table td {
  color: #463529;
}
.billing-table .mark-icon {
  left: 2px;
}

.chart-common {
  width: 100%;
  background-color: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 4px;
  cursor: pointer;
}
.chart-common .chart-wrapper {
  width: 100%;
}

.chart-header {
  overflow-y: scroll;
}

.chart-body {
  overflow-y: scroll;
}
.chart-body .chart-wrapper {
  width: 700px;
}

.mark-icon {
  position: relative;
  width: 9px;
  bottom: 1px;
}

.statement-card-body {
  justify-content: flex-start;
}

.bill-detail-item .message {
  text-align: center;
  display: block;
  margin-top: 64px;
}

@media screen and (min-width: 900px) {
  .chart-common h2, .chart-common .h2 {
    font-weight: 700;
    font-size: 24px;
    line-height: 34px;
    letter-spacing: 0.25px;
    color: #463529;
  }
  .card-header {
    display: flex;
    justify-content: space-between;
  }
  .bill-area {
    width: 50%;
    min-width: 600px;
  }
  .bill-area .bill-content {
    width: 80%;
    margin-bottom: 3em;
  }
  .bill-area .bill-content .billing-amount-title {
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
    letter-spacing: 0.25px;
    display: flex;
    align-items: baseline;
  }
  .bill-area .bill-content .yen-icon {
    padding: 8px 12px;
    border-radius: 50%;
    font-size: 18px;
    background-color: #FCCA0D;
    position: relative;
    top: 3px;
  }
  .bill-area .bill-content .amount {
    font-weight: 700;
    font-size: 32px;
    line-height: 44px;
    color: #F8601B;
    letter-spacing: 0.25px;
    margin-left: 15px;
    word-break: break-all;
  }
  .bill-area .bill-content .tax-included {
    font-weight: 700;
    font-size: 32px;
    line-height: 44px;
    letter-spacing: 0.25px;
    color: #6C757D;
  }
  .bill-area .show-bill {
    padding: 2em 2em;
    border: 4px solid #FFAC7D;
    border-radius: 4px;
    background: #FFFFFF;
  }
  .bill-area .group-button .invoice-blue {
    background-color: #21699E;
    color: #ffffff;
  }
  .bill-area .group-button .invoice-gray-light {
    background-color: #d6dce5;
    color: #ffffff;
  }
  .noti-area {
    width: 50%;
    min-width: 600px;
    margin-top: 32px;
  }
  .noti-area .card-header {
    flex-direction: row;
  }
  .noti-area .noti-img {
    width: 302px;
    height: 201px;
  }
  .top-sub-title {
    font-weight: 700;
    font-size: 24px;
    line-height: 35px;
    color: #463529;
  }
  .square {
    position: relative;
    font-size: 10px;
    line-height: 10px;
    bottom: 2px;
    margin-right: 5px;
  }
  .top-screen .navigate-link {
    color: #F8601B;
    cursor: pointer;
  }
  .top-screen .navigate-link .navigate-text {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.28px;
    text-decoration: underline;
    margin-left: 5px;
  }
  .top-screen .info-detail {
    width: 100%;
  }
  .top-screen .info-detail .list-bill-info .list-bill-info-item {
    border-bottom: 1px solid #BCBFC4;
    padding: 20px 0;
  }
  .top-screen .info-detail .list-bill-info .list-bill-info-item .title {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.25px;
  }
  .top-screen .info-detail .list-bill-info .list-bill-info-item:last-child {
    border-bottom: none;
  }
  .top-screen .info-detail .bill-info-detail-table {
    margin-bottom: 20px;
  }
  .top-screen .info-detail .bill-info-detail-table .square {
    position: relative;
    font-size: 14px;
    line-height: 14px;
    bottom: 2px;
    margin-right: 5px;
  }
  .top-screen .info-detail .bill-info-detail-table table {
    margin-bottom: 0px;
  }
  .top-screen .usage-detail {
    min-width: 100%;
  }
  .top-screen .usage-detail .usage-detail-item {
    padding: 24px;
    background: #FFF7F2;
    border: 1px solid #FFAC7D;
    border-radius: 4px;
    margin-top: 20px;
  }
  .top-screen .usage-detail .item-title {
    margin-bottom: 20px;
    display: flex;
  }
  .top-screen .usage-detail .item-title .noti-img {
    width: 18.78px;
    height: 24px;
    margin-right: 5px;
  }
  .top-screen .usage-detail .item-title .square-icon {
    width: 12px;
    position: relative;
    height: 12px;
    top: 5px;
  }
  .top-screen .usage-detail .item-title h4, .top-screen .usage-detail .item-title .h4 {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.25px;
    color: #463529;
  }
  .top-screen .usage-detail table {
    background-color: #FFFFFF;
    margin: 20px 0 0 0;
    table-layout: fixed;
  }
}
@media screen and (max-width: 899px) {
  .chart-label {
    margin-top: 16px;
    font-size: 18px;
    font-weight: bold;
  }
  .label-last-year {
    margin-left: 7px;
    margin-right: 8px;
    font-size: 12px;
    font-weight: bold;
  }
  .label-this-year {
    margin-left: 7px;
    font-size: 12px;
    font-weight: bold;
  }
  .square {
    position: relative;
    font-size: 9px;
    line-height: 9px;
    bottom: 3px;
    margin-right: 5px;
  }
  .chart-common {
    width: 700px;
  }
  .chart-common h2, .chart-common .h2 {
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    letter-spacing: 0.25px;
    color: #463529;
  }
  .card-header {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: auto;
  }
  .bill-detail-contain {
    padding: 0;
    width: 100%;
  }
  .bill-area {
    width: 100%;
  }
  .bill-area .bill-content {
    width: 100%;
    margin-bottom: 50px;
  }
  .bill-area .bill-content .billing-amount-title {
    font-size: 18px;
    line-height: 26px;
  }
  .bill-area .bill-content .yen-icon {
    padding: 6px 10px;
    border-radius: 50%;
    font-size: 18px;
    background-color: #FCCA0D;
    position: relative;
    top: 3px;
  }
  .bill-area .bill-content .amount {
    font-weight: 700;
    font-size: 24px;
    line-height: 34px;
    color: #F8601B;
    letter-spacing: 0.25px;
    margin-left: 8px;
  }
  .bill-area .bill-content .tax-included {
    font-weight: 700;
    font-size: 24px;
    line-height: 34px;
    letter-spacing: 0.25px;
    color: #6C757D;
  }
  .bill-area .show-bill {
    padding: 20px 16px;
    border: 4px solid #FFAC7D;
    border-radius: 4px;
    background: #FFFFFF;
  }
  .bill-area .group-button .invoice-blue {
    background-color: #21699E;
    color: #ffffff;
  }
  .bill-area .group-button .invoice-gray-light {
    background-color: #d6dce5;
    color: #ffffff;
  }
  .noti-area {
    width: 100%;
    margin-top: 24px;
  }
  .noti-area .card-header {
    flex-direction: row;
  }
  .noti-area .noti-img {
    width: 230px;
    height: 153px;
  }
  .top-sub-title {
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    color: #463529;
  }
  .usage-detail {
    width: 100%;
  }
  .usage-detail table {
    width: 100%;
    table-layout: fixed;
    overflow-wrap: break-word;
  }
  .usage-detail table th {
    vertical-align: middle;
  }
  .top-screen .contract {
    justify-content: space-between;
  }
  .top-screen .navigate-link {
    color: #F8601B;
    cursor: pointer;
  }
  .top-screen .navigate-link .navigate-text {
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: -0.07px;
    text-decoration: underline;
    margin-left: 5px;
  }
  .top-screen .info-detail {
    width: 100%;
  }
  .top-screen .info-detail .list-bill-info .list-bill-info-item {
    border-bottom: 1px solid #BCBFC4;
    padding: 16px 0;
  }
  .top-screen .info-detail .list-bill-info .list-bill-info-item .title {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
  }
  .top-screen .info-detail .list-bill-info .list-bill-info-item:last-child {
    border-bottom: none;
  }
  .top-screen .info-detail .bill-info-detail-table {
    margin-bottom: 20px;
  }
  .top-screen .info-detail .bill-info-detail-table .square {
    position: relative;
    font-size: 10px;
    line-height: 10px;
    bottom: 3px;
    margin-right: 5px;
  }
  .top-screen .info-detail .bill-info-detail-table table {
    width: 100%;
    margin-bottom: 20px;
  }
  .top-screen .usage-detail {
    width: 100%;
  }
  .top-screen .usage-detail .billing-table th {
    font-size: 10px;
    line-height: 18px;
    padding: 4px;
  }
  .top-screen .usage-detail .billing-table td {
    padding: 2px;
  }
  .top-screen .usage-detail .usage-detail-item {
    padding: 12px;
    background: #FFF7F2;
    border: 1px solid #FFAC7D;
    border-radius: 4px;
    margin-top: 20px;
  }
  .top-screen .usage-detail .item-title {
    margin-bottom: 20px;
    display: flex;
  }
  .top-screen .usage-detail .item-title .noti-img {
    width: 18.78px;
    height: 24px;
    margin-right: 5px;
  }
  .top-screen .usage-detail .item-title .square-icon {
    width: 12px;
    position: relative;
    height: 12px;
    top: 5px;
  }
  .top-screen .usage-detail .item-title h4, .top-screen .usage-detail .item-title .h4 {
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.25px;
    color: #463529;
  }
  .top-screen .usage-detail table {
    background-color: #FFFFFF;
    margin: 20px 0 0 0;
  }
}
@media screen and (min-width: 900px) {
  .contract {
    display: flex;
    justify-content: flex-end;
  }
  .bill-detail-item {
    width: 600px;
  }
  .contract-number {
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    letter-spacing: 0.25px;
    color: #463529;
  }
  .contract-name {
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    letter-spacing: 0.25px;
    color: #6C757D;
    align-self: center;
  }
  .bill-detail-contain {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .change-month {
    display: flex;
  }
  .change-month .month-year {
    margin: 0 10px;
    background-color: #F5F5F5;
    border-radius: 4px;
    display: inline-flex;
  }
  .change-month .month-year span {
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0.25px;
    color: #463529;
    padding: 4px 6px;
    border-radius: 4px;
  }
  .change-month .change-month-icon {
    display: inline;
    border-radius: 4px;
    padding: 4px 6px;
    background-color: #F8601B;
    color: #FFFFFF;
    cursor: pointer;
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
  }
}
@media screen and (max-width: 899px) {
  .bill-detail-item {
    width: 100%;
  }
  .contract {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .contract-number {
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.25px;
    color: #463529;
  }
  .contract-name {
    font-weight: 500;
    font-size: 16px;
    line-height: 18px;
    letter-spacing: 0.25px;
    color: #6c757d;
    align-self: center;
  }
  .change-month {
    display: flex;
  }
  .change-month .month-year {
    margin: 0 10px;
    background-color: #F5F5F5;
    border-radius: 4px;
    display: inline-flex;
  }
  .change-month .month-year span {
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.25px;
    color: #463529;
    padding: 4px 6px;
    border-radius: 4px;
  }
  .change-month .change-month-icon {
    display: inline;
    border-radius: 4px;
    padding: 4px 6px;
    background-color: #F8601B;
    color: #FFFFFF;
    cursor: pointer;
    font-size: 14px;
    line-height: 22px;
    font-weight: 700;
  }
}
.select-custom {
  gap: 10px;
  background-color: #fff7f2;
  border: 1px solid #ffe7e6;
  border-radius: 4px;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #463529;
  cursor: pointer;
  position: relative;
}
.select-custom .select-item {
  cursor: pointer;
}
.select-custom ul {
  transform: unset !important;
  margin-top: 55px !important;
}

.detail-meter-screen .meter-detail {
  border-top: 1px solid #BCBFC4;
}
@media screen and (min-width: 900px) {
  .detail-meter-screen .card-header {
    display: flex;
    justify-content: space-between;
  }
  .detail-meter-screen .meter-detail-contain {
    width: 50%;
    padding-top: 45px;
  }
  .detail-meter-screen .top-sub-title {
    font-weight: 700;
    font-size: 24px;
    line-height: 35px;
    color: #463529;
    margin-bottom: 25px;
  }
  .detail-meter-screen .meter-detail {
    padding: 20px 0;
  }
  .detail-meter-screen .meter-detail-item-title,
  .detail-meter-screen .id-number {
    padding: 10px 0;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.25px;
    color: #463529;
  }
  .detail-meter-screen .meter-detail-item {
    display: flex;
    justify-content: space-between;
    width: 100%;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.25px;
    color: #463529;
    padding: 10px 0;
  }
  .detail-meter-screen .square {
    position: relative;
    font-size: 10px;
    line-height: 10px;
    bottom: 3px;
    margin-right: 5px;
  }
}
@media screen and (max-width: 899px) {
  .detail-meter-screen .card-header {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: auto;
  }
  .detail-meter-screen .square-icon {
    width: 12px;
    position: relative;
    height: 12px;
    top: 5px;
  }
  .detail-meter-screen .meter-detail-contain {
    width: 100%;
  }
  .detail-meter-screen .top-sub-title {
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    letter-spacing: -0.28px;
    color: #463529;
    margin-bottom: 19px;
  }
  .detail-meter-screen .meter-detail {
    padding: 15px 0;
  }
  .detail-meter-screen .meter-detail-item-title,
  .detail-meter-screen .id-number {
    padding: 8px 0;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 0.25px;
    color: #463529;
  }
  .detail-meter-screen .meter-detail-item {
    display: flex;
    justify-content: space-between;
    width: 100%;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 0.25px;
    color: #463529;
    padding: 10px 0;
  }
}

.tab-content {
  width: 100%;
}

.chart-screen {
  width: 65%;
}
.chart-screen .nav-pills .nav-link.active,
.chart-screen .nav-pills .show > .nav-link {
  color: #FFFFFF;
  background-color: #F8601B;
  border: 2px solid #F8601B;
}
.chart-screen .nav-link {
  border: 2px solid #BCBFC4;
}
.chart-screen .usage-graph {
  padding-bottom: 40px;
}
.chart-screen .electric-chart {
  background-color: #DEEDD8;
}
.chart-screen .gas-chart {
  background-color: #FFF7F2;
}

.chart-display-tab .nav {
  background-color: #FFF7F2;
}

@media screen and (max-width: 1279px) and (min-width: 900px) {
  .chart-container .noti-img {
    width: 20px;
    height: 26px;
    margin-right: 5px;
  }
  .chart-container .noti-large-img {
    width: 46px;
    height: 46px;
    bottom: 6px;
  }
  .detail-amount {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .detail-amount .compare-item {
    display: flex;
    justify-content: flex-start;
    width: 100% !important;
    padding: 15px 24px;
    align-items: center;
  }
  .detail-amount .compare-item:first-child {
    margin-bottom: 8px;
  }
  .detail-amount .compare-item:last-child {
    margin-top: 8px;
  }
  .detail-amount .usage-amount {
    margin-left: 19px;
  }
  .chart-screen {
    min-width: 600px !important;
  }
}
@media screen and (min-width: 900px) {
  .no-bill-record {
    font-weight: 500;
    display: flex;
    justify-content: center;
    text-align: center;
    letter-spacing: 0.25px;
    color: #6C757D;
  }
  .tab-content {
    width: 100%;
    justify-content: center;
    align-items: center;
  }
  .detail-billed-tab {
    width: 100%;
  }
  .chart-display-tab {
    display: flex !important;
    flex-direction: column;
    align-items: center;
  }
  .chart-display-tab .nav {
    padding: 8px !important;
  }
  .chart-container .noti-img {
    width: 25px;
    height: 33px;
    margin-right: 10px;
  }
  .chart-container .noti-large-img {
    width: 80px;
    height: 80px;
    position: relative;
    bottom: 6px;
  }
  .chart-container .message {
    color: #6C757D;
  }
  .chart-screen {
    min-width: 920px;
  }
  .chart-screen .tab-pane {
    width: 100%;
    background-color: #FFF7F2;
  }
  .chart-screen .nav li:first-child {
    margin-right: 8px;
  }
  .detail-amount {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .detail-amount .compare-item {
    background-color: #FFFFFF;
    display: flex;
    justify-content: flex-start;
    width: 49%;
    padding: 32px;
    align-items: center;
    border-radius: 4px;
  }
  .detail-amount .note-text {
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
    letter-spacing: 0.25px;
    color: #6C757D;
    margin-top: 6px;
  }
  .detail-amount .usage-amount {
    margin-left: 24px;
  }
  .detail-amount .amount-text {
    word-break: break-all;
    font-weight: 700;
    font-size: 40px;
    line-height: 44px;
    letter-spacing: 0.25px;
    color: #463529;
  }
  .detail-amount .amount-text .text-status {
    white-space: nowrap;
  }
  .detail-amount .amount-text .up-arrow,
  .detail-amount .amount-text .increase-text {
    color: #FF0F00;
    margin-right: 16px;
  }
  .detail-amount .amount-text .down-arrow,
  .detail-amount .amount-text .decrease-text {
    color: #4EAE5D;
    margin-right: 16px;
  }
  .electric-chart,
  .gas-chart {
    padding: 32px;
  }
  .title-contain img,
  .title-contain .top-sub-title {
    margin-bottom: 24px;
  }
}
@media screen and (max-width: 899px) {
  .usage-graph {
    overflow-x: scroll;
    overscroll-behavior-inline: none;
  }
  .chart-screen {
    width: 100%;
    background-color: #FFF7F2;
  }
  .chart-screen .tab-pane {
    width: 100%;
  }
  .no-bill-record {
    font-weight: 500;
    display: flex;
    justify-content: center;
    text-align: center;
    letter-spacing: 0.25px;
    color: #6C757D;
  }
  .chart-container .noti-img {
    width: 20px;
    height: 26px;
    margin-right: 5px;
  }
  .chart-container .noti-large-img {
    width: 46px;
    height: 46px;
    bottom: 6px;
  }
  .chart-container .message {
    color: #6C757D;
  }
  .chart-screen .nav li:first-child {
    margin-right: 4px;
  }
  .chart-screen .nav li {
    width: 45%;
  }
  .detail-amount {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .detail-amount .compare-item {
    background-color: #FFFFFF;
    display: flex;
    justify-content: flex-start;
    width: 100%;
    padding: 15px 24px;
    align-items: center;
  }
  .detail-amount .compare-item:first-child {
    margin-bottom: 8px;
  }
  .detail-amount .compare-item:last-child {
    margin-top: 8px;
  }
  .detail-amount .note-text {
    font-weight: 700;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.25px;
    color: #6C757D;
    margin-top: 4px;
  }
  .detail-amount .usage-amount {
    margin-left: 19px;
  }
  .detail-amount .amount-text {
    word-break: break-all;
    font-weight: 700;
    font-size: 24px;
    line-height: 34px;
    letter-spacing: 0.25px;
    color: #463529;
  }
  .detail-amount .amount-text .text-status {
    white-space: nowrap;
  }
  .detail-amount .amount-text .up-arrow,
  .detail-amount .amount-text .increase-text {
    color: #FF0F00;
    margin-right: 10px;
  }
  .detail-amount .amount-text .down-arrow,
  .detail-amount .amount-text .decrease-text {
    color: #4EAE5D;
    margin-right: 10px;
  }
  .detail-amount .up-arrow,
  .detail-amount .increase-text {
    color: #FF0F00;
    margin-right: 8px;
  }
  .detail-amount .down-arrow,
  .detail-amount .decrease-text {
    color: #4EAE5D;
    margin-right: 8px;
  }
  .electric-chart,
  .gas-chart {
    padding: 12px;
  }
  .title-contain img,
  .title-contain .top-sub-title {
    margin-bottom: 20px;
  }
}
.err-container {
  border-top: 4px solid #F8601B;
  box-shadow: 0px 4px 18px #FBD7B6;
  border-radius: 4px;
  background-color: #FFFFFF;
}
.err-container .message-container {
  margin-bottom: 1.5em;
  border-top: 1px dashed #6C757D;
  border-bottom: 1px dashed #6C757D;
  background: #F5F5F5;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  color: #6C757D;
}

@media screen and (min-width: 900px) {
  .err-container {
    padding: 2em;
  }
  .err-container img {
    width: 462px;
    margin-bottom: 1.5em;
  }
  .err-container .message-container {
    padding: 12px 100px;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.25px;
  }
  .err-container .message-container .exclamation-icon {
    font-size: 20px;
    margin-right: 7px;
  }
}
@media screen and (max-width: 899px) {
  .err-container img {
    width: 315px;
    margin-bottom: 1em;
  }
  .err-container .message-container {
    padding: 12px 34px;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
  }
  .err-container .message-container .exclamation-icon {
    font-size: 16px;
    margin-right: 7px;
  }
}
#RFS-StepperContainer #RFS-StepMain #RFS-StepButton {
  font-family: "Noto Sans JP";
  pointer-events: none;
  font-size: 16px;
  line-height: 24px;
}
#RFS-StepperContainer #RFS-StepMain #RFS-LabelContainer #RFS-Label {
  font-family: "Noto Sans JP";
  font-style: normal;
  font-weight: 500;
  align-items: center;
  text-align: center;
  letter-spacing: 0.25px;
  color: #6C757D;
  white-space: pre-wrap;
}
#RFS-StepperContainer #RFS-ConnectorContainer .active {
  border-color: #F8601B;
}
#RFS-StepperContainer #RFS-ConnectorContainer .completed {
  border-color: #faa27b;
}
#RFS-StepperContainer .step-label-active {
  color: #F8601B;
  font-weight: 700;
}

.StepperContainer-0-2-1 {
  width: 100%;
  padding: 24px 0px !important;
}

@media screen and (min-width: 900px) {
  #RFS-StepMain #RFS-StepButton {
    font-size: 14px;
    line-height: 22px;
  }
  #RFS-StepMain #RFS-LabelContainer #RFS-Label {
    font-size: 14px;
    line-height: 22px;
  }
}
@media screen and (max-width: 899px) {
  #RFS-StepperContainer #RFS-StepMain #RFS-LabelContainer #RFS-Label {
    font-size: 12px;
    line-height: 18px;
  }
  #RFS-StepperContainer .StepContainer-0-2-2 {
    flex: 1 1;
    position: relative;
    padding-left: 0px;
    padding-right: 0px;
  }
}
/* Add this CSS to your website's stylesheet */
/* Media query specifically for print */
@media print {
  .icon-flame,
  .icon-lightning,
  img[src*=flame],
  img[src*=lightning],
  img.noti-img,
  svg {
    max-width: 24px !important;
    max-height: 24px !important;
    width: 24px !important;
    height: 24px !important;
    object-fit: contain !important;
    display: inline-block !important;
  }
  [class*=icon-] {
    background-size: 24px 24px !important;
    width: 24px !important;
    height: 24px !important;
  }
  [id*=ご利用明細] img,
  [class*=利用明細] img,
  [class*=detail] img {
    max-width: 24px !important;
    max-height: 24px !important;
  }
  body {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  section, .card, .detail-card {
    page-break-inside: avoid;
  }
}`, "",{"version":3,"sources":["webpack://./src/scss/style.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_banner.scss","webpack://./node_modules/@coreui/coreui/scss/_root.scss","webpack://./node_modules/@coreui/coreui/scss/vendor/_rfs.scss","webpack://./node_modules/@coreui/coreui/scss/_reboot.scss","webpack://./node_modules/@coreui/coreui/scss/_variables.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_ltr-rtl.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_border-radius.scss","webpack://./node_modules/@coreui/coreui/scss/_type.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_lists.scss","webpack://./node_modules/@coreui/coreui/scss/_images.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_image.scss","webpack://./node_modules/@coreui/coreui/scss/_containers.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_container.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_breakpoints.scss","webpack://./node_modules/@coreui/coreui/scss/_grid.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_grid.scss","webpack://./node_modules/@coreui/coreui/scss/_tables.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_table-variants.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_labels.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-text.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-control.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_transition.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_gradients.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-select.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-check.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-range.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_floating-labels.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_input-group.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_forms.scss","webpack://./node_modules/@coreui/coreui/scss/_buttons.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_buttons.scss","webpack://./node_modules/@coreui/coreui/scss/_transitions.scss","webpack://./node_modules/@coreui/coreui/scss/_dropdown.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_caret.scss","webpack://./node_modules/@coreui/coreui/scss/_button-group.scss","webpack://./node_modules/@coreui/coreui/scss/_nav.scss","webpack://./node_modules/@coreui/coreui/scss/_navbar.scss","webpack://./node_modules/@coreui/coreui/scss/_card.scss","webpack://./node_modules/@coreui/coreui/scss/_accordion.scss","webpack://./node_modules/@coreui/coreui/scss/_breadcrumb.scss","webpack://./node_modules/@coreui/coreui/scss/_pagination.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_pagination.scss","webpack://./node_modules/@coreui/coreui/scss/_badge.scss","webpack://./node_modules/@coreui/coreui/scss/_alert.scss","webpack://./node_modules/@coreui/coreui/scss/_progress.scss","webpack://./src/scss/_variables.scss","webpack://./node_modules/@coreui/coreui/scss/_list-group.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_list-group.scss","webpack://./node_modules/@coreui/coreui/scss/_close.scss","webpack://./node_modules/@coreui/coreui/scss/_toasts.scss","webpack://./node_modules/@coreui/coreui/scss/_modal.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_backdrop.scss","webpack://./node_modules/@coreui/coreui/scss/_tooltip.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_reset-text.scss","webpack://./node_modules/@coreui/coreui/scss/_popover.scss","webpack://./node_modules/@coreui/coreui/scss/_carousel.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_clearfix.scss","webpack://./node_modules/@coreui/coreui/scss/_spinners.scss","webpack://./node_modules/@coreui/coreui/scss/_offcanvas.scss","webpack://./node_modules/@coreui/coreui/scss/_placeholders.scss","webpack://./node_modules/@coreui/coreui/scss/_avatar.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_avatar.scss","webpack://./node_modules/@coreui/coreui/scss/_callout.scss","webpack://./node_modules/@coreui/coreui/scss/_footer.scss","webpack://./node_modules/@coreui/coreui/scss/_header.scss","webpack://./node_modules/@coreui/coreui/scss/_icon.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_icon.scss","webpack://./node_modules/@coreui/coreui/scss/sidebar/_sidebar.scss","webpack://./node_modules/@coreui/coreui/scss/sidebar/_sidebar-nav.scss","webpack://./node_modules/@coreui/coreui/scss/sidebar/_sidebar-narrow.scss","webpack://./node_modules/@coreui/coreui/scss/_subheader.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_color-bg.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_colored-links.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_focus-ring.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_icon-link.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_ratio.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_position.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_stacks.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_visually-hidden.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_visually-hidden.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_stretched-link.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_text-truncation.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_text-truncate.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_vr.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_utilities.scss","webpack://./node_modules/@coreui/coreui/scss/utilities/_api.scss","webpack://./node_modules/@coreui/chartjs/scss/coreui-chartjs.scss","webpack://./node_modules/@coreui/chartjs/scss/_tooltips.scss","webpack://./src/scss/_layout.scss","webpack://./src/scss/_button.scss","webpack://./src/scss/_burgerMenu.scss","webpack://./src/scss/_common.scss","webpack://./src/scss/_dropdown.scss","webpack://./src/scss/_modal.scss","webpack://./src/scss/_mypage.scss","webpack://./src/scss/_auth.scss","webpack://./src/scss/_pageNotification.scss","webpack://./src/scss/_pageEnergySaving.scss","webpack://./src/scss/_guidePages.scss","webpack://./src/scss/_top.scss","webpack://./src/scss/_errorPages.scss","webpack://./src/scss/_stepper.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACCd;;;;EAAA;ACDF;EAQI,mBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,wBAAA;EAIA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,gBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAIA,8BAAA;EAAA,kCAAA;EAAA,8BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,6BAAA;EAAA,8BAAA;EAAA,6BAAA;EAGF,8BAAA;EACA,2BAAA;EACA,gCAAA;EACA,gCAAA;EAMA,sNAAA;EACA,0GAAA;EACA,0FAAA;EAOA,kDAAA;ECsPI,0BALI;ED/OR,2BAAA;EACA,2BAAA;EAKA,wCAAA;EACA,gCAAA;EACA,sBAAA;EACA,gCAAA;EAEA,6BAAA;EACA,oCAAA;EAEA,8CAAA;EACA,qCAAA;EACA,2BAAA;EACA,qCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAGA,2CAAA;EACA,8CAAA;EACA,sCAAA;EAEA,sDAAA;EACA,uDAAA;EACA,iDAAA;EAEA,4BAAA;EAEA,yBAAA;EACA,iCAAA;EACA,gCAAA;EAEA,+BAAA;EACA,uCAAA;EAMA,yBAAA;EACA,2BAAA;EAGA,uBAAA;EACA,yBAAA;EACA,2BAAA;EACA,uDAAA;EAEA,6BAAA;EACA,+BAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,qDAAA;EACA,+BAAA;EAGA,sDAAA;EACA,+DAAA;EACA,wDAAA;EACA,+DAAA;EAIA,+BAAA;EACA,8BAAA;EACA,+CAAA;EAIA,+BAAA;EACA,sCAAA;EACA,iCAAA;EACA,wCAAA;AFdF;;AI9FA;;;EAGE,sBAAA;AJiGF;;AIlFI;EANJ;IAOM,uBAAA;EJsFJ;AACF;;AIzEA;EACE,SAAA;EACA,wCAAA;ED6OI,oCALI;ECtOR,wCAAA;EACA,wCAAA;EACA,4BAAA;EACA,sCAAA;EACA,oCAAA;EACA,8BAAA;EACA,gDAAA;AJ4EF;;AInEA;EACE,cAAA;EACA,cC6qB4B;ED5qB5B,SAAA;EACA,yCAAA;EACA,aCmrB4B;AL7mB9B;;AI5DA;EACE,aAAA;EACA,qBC0mB4B;EDvmB5B,gBC0mB4B;EDzmB5B,gBC0mB4B;EDzmB5B,+BAAA;AJ6DF;;AI1DA;EDuMQ,iCAAA;AHzIR;AGnBI;EC3CJ;ID8MQ,iBAAA;EH5IN;AACF;;AI9DA;EDkMQ,iCAAA;AHhIR;AG5BI;ECtCJ;IDyMQ,eAAA;EHnIN;AACF;;AIlEA;ED6LQ,+BAAA;AHvHR;AGrCI;ECjCJ;IDoMQ,kBAAA;EH1HN;AACF;;AItEA;EDwLQ,iCAAA;AH9GR;AG9CI;EC5BJ;ID+LQ,iBAAA;EHjHN;AACF;;AI1EA;ED+KM,kBALI;AH5FV;;AIzEA;ED0KM,eALI;AHxFV;;AIlEA;EACE,aAAA;EACA,mBCyY0B;ALpU5B;;AI3DA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,8BAAA;AJ8DF;;AIxDA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AJ2DF;;AIhDA;;;EAGE,aAAA;EACA,mBAAA;AJmDF;;AIhDA;;;;EAIE,gBAAA;AJmDF;;AIhDA;EACE,gBC+e4B;AL5b9B;;AI9CA;EACE,qBAAA;AJiDF;AMvOI;EAgCE,cAAA;AN0MN;AMlOI;EA+BI,eAAA;ANsMR;;AIhDA;EACE,gBAAA;AJmDF;;AI3CA;;EAEE,mBCwd4B;AL1a9B;;AItCA;ED6EM,kBALI;AH9BV;;AInCA;EACE,iBC+iB4B;ED9iB5B,yCAAA;AJsCF;;AI7BA;;EAEE,kBAAA;EDyDI,iBALI;EClDR,cAAA;EACA,wBAAA;AJgCF;;AI7BA;EAAM,eAAA;AJiCN;;AIhCA;EAAM,WAAA;AJoCN;;AI/BA;EACE,kEAAA;EACA,0BCkQwC;ALhO1C;AIhCE;EACE,qDAAA;AJkCJ;;AIxBE;EAEE,cAAA;EACA,qBAAA;AJ0BJ;;AInBA;;;;EAIE,sCCoY4B;EFpXxB,cALI;AHYV;;AIfA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EDII,kBALI;ECGR,6BAAA;AJkBF;AIfE;EDDI,kBALI;ECQN,cAAA;EACA,kBAAA;AJiBJ;;AIbA;EDRM,kBALI;ECeR,4BAAA;EACA,qBAAA;AJgBF;AIbE;EACE,cAAA;AJeJ;;AIXA;EACE,2BAAA;EDpBI,kBALI;EC2BR,+CAAA;EACA,0DAAA;EGnSE,sBAAA;APkTJ;AIZE;EACE,UAAA;ED3BE,cALI;AH+CV;;AIJA;EACE,gBAAA;AJOF;;AIDA;;EAEE,sBAAA;AJIF;;AIIA;EACE,oBAAA;EACA,yBAAA;AJDF;;AIIA;EACE,mBC8b4B;ED7b5B,sBC6b4B;ED5b5B,iEAAA;EACA,gBAAA;AJDF;;AIQA;EAEE,mBAAA;EACA,gCAAA;AJNF;;AISA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AJNF;;AIcA;EACE,qBAAA;AJXF;;AIiBA;EAEE,gBAAA;AJfF;;AIuBA;EACE,UAAA;AJpBF;;AIyBA;;;;;EAKE,SAAA;EACA,oBAAA;ED1HI,kBALI;ECiIR,oBAAA;AJtBF;;AI0BA;;EAEE,oBAAA;AJvBF;;AI4BA;EACE,eAAA;AJzBF;;AI4BA;EAGE,iBAAA;AJ3BF;AI8BE;EACE,UAAA;AJ5BJ;;AImCA;EACE,wBAAA;AJhCF;;AIwCA;;;;EAIE,0BAAA;AJrCF;AIwCI;;;;EACE,eAAA;AJnCN;;AI0CA;EACE,UAAA;EACA,kBAAA;AJvCF;;AI4CA;EACE,gBAAA;AJzCF;;AImDA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AJhDF;;AIwDA;EAEE,WAAA;EACA,UAAA;EACA,qBC+Q4B;EF9dtB,iCAAA;ECkNN,oBAAA;AJvDF;AM5bI;EAgCE,WAAA;AN+ZN;AMvbI;EA+BI,YAAA;AN2ZR;AG7TI;ECuWJ;IDpMQ,iBAAA;EH8JN;AACF;AI8CE;EACE,WAAA;AJ5CJ;;AImDA;;;;;;;EAOE,UAAA;AJhDF;;AImDA;EACE,YAAA;AJhDF;;AIyDA;EACE,6BAAA;EACA,oBAAA;AJtDF;;AI6DE;;;;EAIE,cAAA;AJ1DJ;;AIiEA;EACE,wBAAA;AJ9DF;;AImEA;EACE,UAAA;AJhEF;;AIuEA;EACE,aAAA;EACA,0BAAA;AJpEF;;AIyEA;EACE,qBAAA;AJtEF;;AI2EA;EACE,SAAA;AJxEF;;AI+EA;EACE,kBAAA;EACA,eAAA;AJ5EF;;AIoFA;EACE,wBAAA;AJjFF;;AIyFA;EACE,wBAAA;AJtFF;;AQ5eA;ELmQM,kBALI;EK5PR,gBH0rB8B;AL3MhC;;AQ1eE;ELgQM,iCAAA;EK5PJ,gBH2qBkB;EG1qBlB,gBH0pB0B;AL/K9B;AG5YI;EKpGF;ILuQM,eAAA;EH6ON;AACF;;AQrfE;ELgQM,iCAAA;EK5PJ,gBH2qBkB;EG1qBlB,gBH0pB0B;ALpK9B;AGvZI;EKpGF;ILuQM,iBAAA;EHwPN;AACF;;AQhgBE;ELgQM,iCAAA;EK5PJ,gBH2qBkB;EG1qBlB,gBH0pB0B;ALzJ9B;AGlaI;EKpGF;ILuQM,eAAA;EHmQN;AACF;;AQ3gBE;ELgQM,iCAAA;EK5PJ,gBH2qBkB;EG1qBlB,gBH0pB0B;AL9I9B;AG7aI;EKpGF;ILuQM,iBAAA;EH8QN;AACF;;AQthBE;ELgQM,iCAAA;EK5PJ,gBH2qBkB;EG1qBlB,gBH0pB0B;ALnI9B;AGxbI;EKpGF;ILuQM,eAAA;EHyRN;AACF;;AQjiBE;ELgQM,iCAAA;EK5PJ,gBH2qBkB;EG1qBlB,gBH0pB0B;ALxH9B;AGncI;EKpGF;ILuQM,iBAAA;EHoSN;AACF;;AQphBA;ECtDE,gBAAA;AT8kBF;AMjlBI;EAgCE,eAAA;ANojBN;AM5kBI;EA+BI,gBAAA;ANgjBR;;AQzhBA;EC3DE,gBAAA;ATwlBF;AM3lBI;EAgCE,eAAA;AN8jBN;AMtlBI;EA+BI,gBAAA;AN0jBR;;AQhiBA;EACE,qBAAA;ARmiBF;AMrmBI;EAgCE,oBAAA;ANwkBN;AMhmBI;EA+BI,mBAAA;ANokBR;;AQ5hBA;EL8MM,kBALI;EKvMR,yBAAA;AR+hBF;;AQ3hBA;EACE,mBHkXO;EF3KH,kBALI;AH6VV;AQ5hBE;EACE,gBAAA;AR8hBJ;;AQ1hBA;EACE,iBAAA;EACA,mBHwWO;EF3KH,kBALI;EKtLR,cHrFU;ALknBZ;AQ3hBE;EACE,aAAA;AR6hBJ;;AU7nBA;ECIE,eAAA;EAGA,YAAA;AX2nBF;;AU5nBA;EACE,gBLqxDkC;EKpxDlC,6DAAA;EACA,gGAAA;EHGE,uCAAA;EIRF,eAAA;EAGA,YAAA;AXooBF;;AUtnBA;EAEE,qBAAA;AVwnBF;;AUrnBA;EACE,qBAAA;EACA,cAAA;AVwnBF;;AUrnBA;EPyPM,kBALI;EOlPR,kEAAA;AVwnBF;;AY1pBE;;;;;;;ECHA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,6CAAA;EACA,kBAAA;EACA,iBAAA;AbuqBF;;AcjnBI;EF5CE;IACE,gBPmhBe;EL8IrB;AACF;AcvnBI;EF5CE;IACE,gBPmhBe;ELmJrB;AACF;Ac5nBI;EF5CE;IACE,gBPmhBe;ELwJrB;AACF;AcjoBI;EF5CE;IACE,iBPmhBe;EL6JrB;AACF;ActoBI;EF5CE;IACE,iBPmhBe;ELkKrB;AACF;AetsBA;EAEI,sBAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,4BAAA;EAGF,2BAAA;Af0sBF;;AetsBE;ECRA,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EAEA,0CAAA;EACA,8CAAA;EACA,6CAAA;AhBitBF;Ae7sBI;ECKF,cAAA;EACA,WAAA;EACA,eAAA;EACA,8CAAA;EACA,6CAAA;EACA,+BAAA;AhB2sBF;;AgB5pBM;EACE,SAAA;AhB+pBR;;AgB5pBM;EApCJ,cAAA;EACA,WAAA;AhBosBF;;AgBtrBE;EACE,cAAA;EACA,WAAA;AhByrBJ;;AgB3rBE;EACE,cAAA;EACA,UAAA;AhB8rBJ;;AgBhsBE;EACE,cAAA;EACA,qBAAA;AhBmsBJ;;AgBrsBE;EACE,cAAA;EACA,UAAA;AhBwsBJ;;AgB1sBE;EACE,cAAA;EACA,UAAA;AhB6sBJ;;AgB/sBE;EACE,cAAA;EACA,qBAAA;AhBktBJ;;AgBnrBM;EAhDJ,cAAA;EACA,WAAA;AhBuuBF;;AgBlrBU;EAhEN,cAAA;EACA,kBAAA;AhBsvBJ;;AgBvrBU;EAhEN,cAAA;EACA,mBAAA;AhB2vBJ;;AgB5rBU;EAhEN,cAAA;EACA,UAAA;AhBgwBJ;;AgBjsBU;EAhEN,cAAA;EACA,mBAAA;AhBqwBJ;;AgBtsBU;EAhEN,cAAA;EACA,mBAAA;AhB0wBJ;;AgB3sBU;EAhEN,cAAA;EACA,UAAA;AhB+wBJ;;AgBhtBU;EAhEN,cAAA;EACA,mBAAA;AhBoxBJ;;AgBrtBU;EAhEN,cAAA;EACA,mBAAA;AhByxBJ;;AgB1tBU;EAhEN,cAAA;EACA,UAAA;AhB8xBJ;;AgB/tBU;EAhEN,cAAA;EACA,mBAAA;AhBmyBJ;;AgBpuBU;EAhEN,cAAA;EACA,mBAAA;AhBwyBJ;;AgBzuBU;EAhEN,cAAA;EACA,WAAA;AhB6yBJ;;AM30BI;EAgCE,wBAAA;AN+yBN;AMv0BI;EA+BI,yBAAA;AN2yBR;;AMl1BI;EAgCE,yBAAA;ANszBN;AM90BI;EA+BI,0BAAA;ANkzBR;;AMz1BI;EAgCE,gBAAA;AN6zBN;AMr1BI;EA+BI,iBAAA;ANyzBR;;AMh2BI;EAgCE,yBAAA;ANo0BN;AM51BI;EA+BI,0BAAA;ANg0BR;;AMv2BI;EAgCE,yBAAA;AN20BN;AMn2BI;EA+BI,0BAAA;ANu0BR;;AM92BI;EAgCE,gBAAA;ANk1BN;AM12BI;EA+BI,iBAAA;AN80BR;;AMr3BI;EAgCE,yBAAA;ANy1BN;AMj3BI;EA+BI,0BAAA;ANq1BR;;AM53BI;EAgCE,yBAAA;ANg2BN;AMx3BI;EA+BI,0BAAA;AN41BR;;AMn4BI;EAgCE,gBAAA;ANu2BN;AM/3BI;EA+BI,iBAAA;ANm2BR;;AM14BI;EAgCE,yBAAA;AN82BN;AMt4BI;EA+BI,0BAAA;AN02BR;;AMj5BI;EAgCE,yBAAA;ANq3BN;AM74BI;EA+BI,0BAAA;ANi3BR;;AgBxyBQ;;EAEE,iBAAA;AhB2yBV;;AgBxyBQ;;EAEE,iBAAA;AhB2yBV;;AgBlzBQ;;EAEE,uBAAA;AhBqzBV;;AgBlzBQ;;EAEE,uBAAA;AhBqzBV;;AgB5zBQ;;EAEE,sBAAA;AhB+zBV;;AgB5zBQ;;EAEE,sBAAA;AhB+zBV;;AgBt0BQ;;EAEE,oBAAA;AhBy0BV;;AgBt0BQ;;EAEE,oBAAA;AhBy0BV;;AgBh1BQ;;EAEE,sBAAA;AhBm1BV;;AgBh1BQ;;EAEE,sBAAA;AhBm1BV;;AgB11BQ;;EAEE,oBAAA;AhB61BV;;AgB11BQ;;EAEE,oBAAA;AhB61BV;;Acv5BI;EEUE;IACE,SAAA;EhBi5BN;EgB94BI;IApCJ,cAAA;IACA,WAAA;EhBq7BA;EgBv6BA;IACE,cAAA;IACA,WAAA;EhBy6BF;EgB36BA;IACE,cAAA;IACA,UAAA;EhB66BF;EgB/6BA;IACE,cAAA;IACA,qBAAA;EhBi7BF;EgBn7BA;IACE,cAAA;IACA,UAAA;EhBq7BF;EgBv7BA;IACE,cAAA;IACA,UAAA;EhBy7BF;EgB37BA;IACE,cAAA;IACA,qBAAA;EhB67BF;EgB95BI;IAhDJ,cAAA;IACA,WAAA;EhBi9BA;EgB55BQ;IAhEN,cAAA;IACA,kBAAA;EhB+9BF;EgBh6BQ;IAhEN,cAAA;IACA,mBAAA;EhBm+BF;EgBp6BQ;IAhEN,cAAA;IACA,UAAA;EhBu+BF;EgBx6BQ;IAhEN,cAAA;IACA,mBAAA;EhB2+BF;EgB56BQ;IAhEN,cAAA;IACA,mBAAA;EhB++BF;EgBh7BQ;IAhEN,cAAA;IACA,UAAA;EhBm/BF;EgBp7BQ;IAhEN,cAAA;IACA,mBAAA;EhBu/BF;EgBx7BQ;IAhEN,cAAA;IACA,mBAAA;EhB2/BF;EgB57BQ;IAhEN,cAAA;IACA,UAAA;EhB+/BF;EgBh8BQ;IAhEN,cAAA;IACA,mBAAA;EhBmgCF;EgBp8BQ;IAhEN,cAAA;IACA,mBAAA;EhBugCF;EgBx8BQ;IAhEN,cAAA;IACA,WAAA;EhB2gCF;EMziCE;IAgCE,cAAA;EN4gCJ;EMpiCE;IA+BI,eAAA;ENwgCN;EM/iCE;IAgCE,wBAAA;ENkhCJ;EM1iCE;IA+BI,yBAAA;EN8gCN;EMrjCE;IAgCE,yBAAA;ENwhCJ;EMhjCE;IA+BI,0BAAA;ENohCN;EM3jCE;IAgCE,gBAAA;EN8hCJ;EMtjCE;IA+BI,iBAAA;EN0hCN;EMjkCE;IAgCE,yBAAA;ENoiCJ;EM5jCE;IA+BI,0BAAA;ENgiCN;EMvkCE;IAgCE,yBAAA;EN0iCJ;EMlkCE;IA+BI,0BAAA;ENsiCN;EM7kCE;IAgCE,gBAAA;ENgjCJ;EMxkCE;IA+BI,iBAAA;EN4iCN;EMnlCE;IAgCE,yBAAA;ENsjCJ;EM9kCE;IA+BI,0BAAA;ENkjCN;EMzlCE;IAgCE,yBAAA;EN4jCJ;EMplCE;IA+BI,0BAAA;ENwjCN;EM/lCE;IAgCE,gBAAA;ENkkCJ;EM1lCE;IA+BI,iBAAA;EN8jCN;EMrmCE;IAgCE,yBAAA;ENwkCJ;EMhmCE;IA+BI,0BAAA;ENokCN;EM3mCE;IAgCE,yBAAA;EN8kCJ;EMtmCE;IA+BI,0BAAA;EN0kCN;EgBjgCM;;IAEE,iBAAA;EhBmgCR;EgBhgCM;;IAEE,iBAAA;EhBkgCR;EgBzgCM;;IAEE,uBAAA;EhB2gCR;EgBxgCM;;IAEE,uBAAA;EhB0gCR;EgBjhCM;;IAEE,sBAAA;EhBmhCR;EgBhhCM;;IAEE,sBAAA;EhBkhCR;EgBzhCM;;IAEE,oBAAA;EhB2hCR;EgBxhCM;;IAEE,oBAAA;EhB0hCR;EgBjiCM;;IAEE,sBAAA;EhBmiCR;EgBhiCM;;IAEE,sBAAA;EhBkiCR;EgBziCM;;IAEE,oBAAA;EhB2iCR;EgBxiCM;;IAEE,oBAAA;EhB0iCR;AACF;AcrmCI;EEUE;IACE,SAAA;EhB8lCN;EgB3lCI;IApCJ,cAAA;IACA,WAAA;EhBkoCA;EgBpnCA;IACE,cAAA;IACA,WAAA;EhBsnCF;EgBxnCA;IACE,cAAA;IACA,UAAA;EhB0nCF;EgB5nCA;IACE,cAAA;IACA,qBAAA;EhB8nCF;EgBhoCA;IACE,cAAA;IACA,UAAA;EhBkoCF;EgBpoCA;IACE,cAAA;IACA,UAAA;EhBsoCF;EgBxoCA;IACE,cAAA;IACA,qBAAA;EhB0oCF;EgB3mCI;IAhDJ,cAAA;IACA,WAAA;EhB8pCA;EgBzmCQ;IAhEN,cAAA;IACA,kBAAA;EhB4qCF;EgB7mCQ;IAhEN,cAAA;IACA,mBAAA;EhBgrCF;EgBjnCQ;IAhEN,cAAA;IACA,UAAA;EhBorCF;EgBrnCQ;IAhEN,cAAA;IACA,mBAAA;EhBwrCF;EgBznCQ;IAhEN,cAAA;IACA,mBAAA;EhB4rCF;EgB7nCQ;IAhEN,cAAA;IACA,UAAA;EhBgsCF;EgBjoCQ;IAhEN,cAAA;IACA,mBAAA;EhBosCF;EgBroCQ;IAhEN,cAAA;IACA,mBAAA;EhBwsCF;EgBzoCQ;IAhEN,cAAA;IACA,UAAA;EhB4sCF;EgB7oCQ;IAhEN,cAAA;IACA,mBAAA;EhBgtCF;EgBjpCQ;IAhEN,cAAA;IACA,mBAAA;EhBotCF;EgBrpCQ;IAhEN,cAAA;IACA,WAAA;EhBwtCF;EMtvCE;IAgCE,cAAA;ENytCJ;EMjvCE;IA+BI,eAAA;ENqtCN;EM5vCE;IAgCE,wBAAA;EN+tCJ;EMvvCE;IA+BI,yBAAA;EN2tCN;EMlwCE;IAgCE,yBAAA;ENquCJ;EM7vCE;IA+BI,0BAAA;ENiuCN;EMxwCE;IAgCE,gBAAA;EN2uCJ;EMnwCE;IA+BI,iBAAA;ENuuCN;EM9wCE;IAgCE,yBAAA;ENivCJ;EMzwCE;IA+BI,0BAAA;EN6uCN;EMpxCE;IAgCE,yBAAA;ENuvCJ;EM/wCE;IA+BI,0BAAA;ENmvCN;EM1xCE;IAgCE,gBAAA;EN6vCJ;EMrxCE;IA+BI,iBAAA;ENyvCN;EMhyCE;IAgCE,yBAAA;ENmwCJ;EM3xCE;IA+BI,0BAAA;EN+vCN;EMtyCE;IAgCE,yBAAA;ENywCJ;EMjyCE;IA+BI,0BAAA;ENqwCN;EM5yCE;IAgCE,gBAAA;EN+wCJ;EMvyCE;IA+BI,iBAAA;EN2wCN;EMlzCE;IAgCE,yBAAA;ENqxCJ;EM7yCE;IA+BI,0BAAA;ENixCN;EMxzCE;IAgCE,yBAAA;EN2xCJ;EMnzCE;IA+BI,0BAAA;ENuxCN;EgB9sCM;;IAEE,iBAAA;EhBgtCR;EgB7sCM;;IAEE,iBAAA;EhB+sCR;EgBttCM;;IAEE,uBAAA;EhBwtCR;EgBrtCM;;IAEE,uBAAA;EhButCR;EgB9tCM;;IAEE,sBAAA;EhBguCR;EgB7tCM;;IAEE,sBAAA;EhB+tCR;EgBtuCM;;IAEE,oBAAA;EhBwuCR;EgBruCM;;IAEE,oBAAA;EhBuuCR;EgB9uCM;;IAEE,sBAAA;EhBgvCR;EgB7uCM;;IAEE,sBAAA;EhB+uCR;EgBtvCM;;IAEE,oBAAA;EhBwvCR;EgBrvCM;;IAEE,oBAAA;EhBuvCR;AACF;AclzCI;EEUE;IACE,SAAA;EhB2yCN;EgBxyCI;IApCJ,cAAA;IACA,WAAA;EhB+0CA;EgBj0CA;IACE,cAAA;IACA,WAAA;EhBm0CF;EgBr0CA;IACE,cAAA;IACA,UAAA;EhBu0CF;EgBz0CA;IACE,cAAA;IACA,qBAAA;EhB20CF;EgB70CA;IACE,cAAA;IACA,UAAA;EhB+0CF;EgBj1CA;IACE,cAAA;IACA,UAAA;EhBm1CF;EgBr1CA;IACE,cAAA;IACA,qBAAA;EhBu1CF;EgBxzCI;IAhDJ,cAAA;IACA,WAAA;EhB22CA;EgBtzCQ;IAhEN,cAAA;IACA,kBAAA;EhBy3CF;EgB1zCQ;IAhEN,cAAA;IACA,mBAAA;EhB63CF;EgB9zCQ;IAhEN,cAAA;IACA,UAAA;EhBi4CF;EgBl0CQ;IAhEN,cAAA;IACA,mBAAA;EhBq4CF;EgBt0CQ;IAhEN,cAAA;IACA,mBAAA;EhBy4CF;EgB10CQ;IAhEN,cAAA;IACA,UAAA;EhB64CF;EgB90CQ;IAhEN,cAAA;IACA,mBAAA;EhBi5CF;EgBl1CQ;IAhEN,cAAA;IACA,mBAAA;EhBq5CF;EgBt1CQ;IAhEN,cAAA;IACA,UAAA;EhBy5CF;EgB11CQ;IAhEN,cAAA;IACA,mBAAA;EhB65CF;EgB91CQ;IAhEN,cAAA;IACA,mBAAA;EhBi6CF;EgBl2CQ;IAhEN,cAAA;IACA,WAAA;EhBq6CF;EMn8CE;IAgCE,cAAA;ENs6CJ;EM97CE;IA+BI,eAAA;ENk6CN;EMz8CE;IAgCE,wBAAA;EN46CJ;EMp8CE;IA+BI,yBAAA;ENw6CN;EM/8CE;IAgCE,yBAAA;ENk7CJ;EM18CE;IA+BI,0BAAA;EN86CN;EMr9CE;IAgCE,gBAAA;ENw7CJ;EMh9CE;IA+BI,iBAAA;ENo7CN;EM39CE;IAgCE,yBAAA;EN87CJ;EMt9CE;IA+BI,0BAAA;EN07CN;EMj+CE;IAgCE,yBAAA;ENo8CJ;EM59CE;IA+BI,0BAAA;ENg8CN;EMv+CE;IAgCE,gBAAA;EN08CJ;EMl+CE;IA+BI,iBAAA;ENs8CN;EM7+CE;IAgCE,yBAAA;ENg9CJ;EMx+CE;IA+BI,0BAAA;EN48CN;EMn/CE;IAgCE,yBAAA;ENs9CJ;EM9+CE;IA+BI,0BAAA;ENk9CN;EMz/CE;IAgCE,gBAAA;EN49CJ;EMp/CE;IA+BI,iBAAA;ENw9CN;EM//CE;IAgCE,yBAAA;ENk+CJ;EM1/CE;IA+BI,0BAAA;EN89CN;EMrgDE;IAgCE,yBAAA;ENw+CJ;EMhgDE;IA+BI,0BAAA;ENo+CN;EgB35CM;;IAEE,iBAAA;EhB65CR;EgB15CM;;IAEE,iBAAA;EhB45CR;EgBn6CM;;IAEE,uBAAA;EhBq6CR;EgBl6CM;;IAEE,uBAAA;EhBo6CR;EgB36CM;;IAEE,sBAAA;EhB66CR;EgB16CM;;IAEE,sBAAA;EhB46CR;EgBn7CM;;IAEE,oBAAA;EhBq7CR;EgBl7CM;;IAEE,oBAAA;EhBo7CR;EgB37CM;;IAEE,sBAAA;EhB67CR;EgB17CM;;IAEE,sBAAA;EhB47CR;EgBn8CM;;IAEE,oBAAA;EhBq8CR;EgBl8CM;;IAEE,oBAAA;EhBo8CR;AACF;Ac//CI;EEUE;IACE,SAAA;EhBw/CN;EgBr/CI;IApCJ,cAAA;IACA,WAAA;EhB4hDA;EgB9gDA;IACE,cAAA;IACA,WAAA;EhBghDF;EgBlhDA;IACE,cAAA;IACA,UAAA;EhBohDF;EgBthDA;IACE,cAAA;IACA,qBAAA;EhBwhDF;EgB1hDA;IACE,cAAA;IACA,UAAA;EhB4hDF;EgB9hDA;IACE,cAAA;IACA,UAAA;EhBgiDF;EgBliDA;IACE,cAAA;IACA,qBAAA;EhBoiDF;EgBrgDI;IAhDJ,cAAA;IACA,WAAA;EhBwjDA;EgBngDQ;IAhEN,cAAA;IACA,kBAAA;EhBskDF;EgBvgDQ;IAhEN,cAAA;IACA,mBAAA;EhB0kDF;EgB3gDQ;IAhEN,cAAA;IACA,UAAA;EhB8kDF;EgB/gDQ;IAhEN,cAAA;IACA,mBAAA;EhBklDF;EgBnhDQ;IAhEN,cAAA;IACA,mBAAA;EhBslDF;EgBvhDQ;IAhEN,cAAA;IACA,UAAA;EhB0lDF;EgB3hDQ;IAhEN,cAAA;IACA,mBAAA;EhB8lDF;EgB/hDQ;IAhEN,cAAA;IACA,mBAAA;EhBkmDF;EgBniDQ;IAhEN,cAAA;IACA,UAAA;EhBsmDF;EgBviDQ;IAhEN,cAAA;IACA,mBAAA;EhB0mDF;EgB3iDQ;IAhEN,cAAA;IACA,mBAAA;EhB8mDF;EgB/iDQ;IAhEN,cAAA;IACA,WAAA;EhBknDF;EMhpDE;IAgCE,cAAA;ENmnDJ;EM3oDE;IA+BI,eAAA;EN+mDN;EMtpDE;IAgCE,wBAAA;ENynDJ;EMjpDE;IA+BI,yBAAA;ENqnDN;EM5pDE;IAgCE,yBAAA;EN+nDJ;EMvpDE;IA+BI,0BAAA;EN2nDN;EMlqDE;IAgCE,gBAAA;ENqoDJ;EM7pDE;IA+BI,iBAAA;ENioDN;EMxqDE;IAgCE,yBAAA;EN2oDJ;EMnqDE;IA+BI,0BAAA;ENuoDN;EM9qDE;IAgCE,yBAAA;ENipDJ;EMzqDE;IA+BI,0BAAA;EN6oDN;EMprDE;IAgCE,gBAAA;ENupDJ;EM/qDE;IA+BI,iBAAA;ENmpDN;EM1rDE;IAgCE,yBAAA;EN6pDJ;EMrrDE;IA+BI,0BAAA;ENypDN;EMhsDE;IAgCE,yBAAA;ENmqDJ;EM3rDE;IA+BI,0BAAA;EN+pDN;EMtsDE;IAgCE,gBAAA;ENyqDJ;EMjsDE;IA+BI,iBAAA;ENqqDN;EM5sDE;IAgCE,yBAAA;EN+qDJ;EMvsDE;IA+BI,0BAAA;EN2qDN;EMltDE;IAgCE,yBAAA;ENqrDJ;EM7sDE;IA+BI,0BAAA;ENirDN;EgBxmDM;;IAEE,iBAAA;EhB0mDR;EgBvmDM;;IAEE,iBAAA;EhBymDR;EgBhnDM;;IAEE,uBAAA;EhBknDR;EgB/mDM;;IAEE,uBAAA;EhBinDR;EgBxnDM;;IAEE,sBAAA;EhB0nDR;EgBvnDM;;IAEE,sBAAA;EhBynDR;EgBhoDM;;IAEE,oBAAA;EhBkoDR;EgB/nDM;;IAEE,oBAAA;EhBioDR;EgBxoDM;;IAEE,sBAAA;EhB0oDR;EgBvoDM;;IAEE,sBAAA;EhByoDR;EgBhpDM;;IAEE,oBAAA;EhBkpDR;EgB/oDM;;IAEE,oBAAA;EhBipDR;AACF;Ac5sDI;EEUE;IACE,SAAA;EhBqsDN;EgBlsDI;IApCJ,cAAA;IACA,WAAA;EhByuDA;EgB3tDA;IACE,cAAA;IACA,WAAA;EhB6tDF;EgB/tDA;IACE,cAAA;IACA,UAAA;EhBiuDF;EgBnuDA;IACE,cAAA;IACA,qBAAA;EhBquDF;EgBvuDA;IACE,cAAA;IACA,UAAA;EhByuDF;EgB3uDA;IACE,cAAA;IACA,UAAA;EhB6uDF;EgB/uDA;IACE,cAAA;IACA,qBAAA;EhBivDF;EgBltDI;IAhDJ,cAAA;IACA,WAAA;EhBqwDA;EgBhtDQ;IAhEN,cAAA;IACA,kBAAA;EhBmxDF;EgBptDQ;IAhEN,cAAA;IACA,mBAAA;EhBuxDF;EgBxtDQ;IAhEN,cAAA;IACA,UAAA;EhB2xDF;EgB5tDQ;IAhEN,cAAA;IACA,mBAAA;EhB+xDF;EgBhuDQ;IAhEN,cAAA;IACA,mBAAA;EhBmyDF;EgBpuDQ;IAhEN,cAAA;IACA,UAAA;EhBuyDF;EgBxuDQ;IAhEN,cAAA;IACA,mBAAA;EhB2yDF;EgB5uDQ;IAhEN,cAAA;IACA,mBAAA;EhB+yDF;EgBhvDQ;IAhEN,cAAA;IACA,UAAA;EhBmzDF;EgBpvDQ;IAhEN,cAAA;IACA,mBAAA;EhBuzDF;EgBxvDQ;IAhEN,cAAA;IACA,mBAAA;EhB2zDF;EgB5vDQ;IAhEN,cAAA;IACA,WAAA;EhB+zDF;EM71DE;IAgCE,cAAA;ENg0DJ;EMx1DE;IA+BI,eAAA;EN4zDN;EMn2DE;IAgCE,wBAAA;ENs0DJ;EM91DE;IA+BI,yBAAA;ENk0DN;EMz2DE;IAgCE,yBAAA;EN40DJ;EMp2DE;IA+BI,0BAAA;ENw0DN;EM/2DE;IAgCE,gBAAA;ENk1DJ;EM12DE;IA+BI,iBAAA;EN80DN;EMr3DE;IAgCE,yBAAA;ENw1DJ;EMh3DE;IA+BI,0BAAA;ENo1DN;EM33DE;IAgCE,yBAAA;EN81DJ;EMt3DE;IA+BI,0BAAA;EN01DN;EMj4DE;IAgCE,gBAAA;ENo2DJ;EM53DE;IA+BI,iBAAA;ENg2DN;EMv4DE;IAgCE,yBAAA;EN02DJ;EMl4DE;IA+BI,0BAAA;ENs2DN;EM74DE;IAgCE,yBAAA;ENg3DJ;EMx4DE;IA+BI,0BAAA;EN42DN;EMn5DE;IAgCE,gBAAA;ENs3DJ;EM94DE;IA+BI,iBAAA;ENk3DN;EMz5DE;IAgCE,yBAAA;EN43DJ;EMp5DE;IA+BI,0BAAA;ENw3DN;EM/5DE;IAgCE,yBAAA;ENk4DJ;EM15DE;IA+BI,0BAAA;EN83DN;EgBrzDM;;IAEE,iBAAA;EhBuzDR;EgBpzDM;;IAEE,iBAAA;EhBszDR;EgB7zDM;;IAEE,uBAAA;EhB+zDR;EgB5zDM;;IAEE,uBAAA;EhB8zDR;EgBr0DM;;IAEE,sBAAA;EhBu0DR;EgBp0DM;;IAEE,sBAAA;EhBs0DR;EgB70DM;;IAEE,oBAAA;EhB+0DR;EgB50DM;;IAEE,oBAAA;EhB80DR;EgBr1DM;;IAEE,sBAAA;EhBu1DR;EgBp1DM;;IAEE,sBAAA;EhBs1DR;EgB71DM;;IAEE,oBAAA;EhB+1DR;EgB51DM;;IAEE,oBAAA;EhB81DR;AACF;AiBp9DA;EAEE,+BAAA;EACA,4BAAA;EACA,gCAAA;EACA,6BAAA;EAEA,wCAAA;EACA,kCAAA;EACA,iDAAA;EACA,kCAAA;EACA,gDAAA;EACA,8CAAA;EACA,+CAAA;EACA,4CAAA;EACA,8CAAA;EACA,6CAAA;EAEA,WAAA;EACA,mBZmbO;EYlbP,mBZuwB4B;EYtwB5B,2CAAA;AjBm9DF;AiB58DE;EACE,sBAAA;EAEA,wFAAA;EACA,qCAAA;EACA,4CZ+wB0B;EY9wB1B,8GAAA;AjB68DJ;AiB18DE;EACE,uBAAA;AjB48DJ;AiBz8DE;EACE,sBAAA;AjB28DJ;;AiBv8DA;EACE,gEAAA;AjB08DF;;AiBn8DA;EACE,iBAAA;AjBs8DF;;AiB57DE;EACE,wBAAA;AjB+7DJ;;AiBh7DE;EACE,uCAAA;AjBm7DJ;AiBh7DI;EACE,uCAAA;AjBk7DN;;AiB36DE;EACE,sBAAA;AjB86DJ;AiB36DE;EACE,mBAAA;AjB66DJ;;AiBn6DE;EACE,sDAAA;EACA,gDAAA;AjBs6DJ;;AiBh6DE;EACE,sDAAA;EACA,gDAAA;AjBm6DJ;;AiB35DA;EACE,sDAAA;EACA,gDAAA;AjB85DF;;AiBt5DE;EACE,qDAAA;EACA,+CAAA;AjBy5DJ;;AkBriEE;EAOE,yCAAA;EACA,uBAAA;EACA,oDAAA;EACA,mDAAA;EACA,iDAAA;EACA,iDAAA;EACA,gDAAA;EACA,kDAAA;EACA,+CAAA;EAEA,6BAAA;EACA,2CAAA;AlBiiEJ;;AkBnjEE;EAOE,yCAAA;EACA,uBAAA;EACA,oDAAA;EACA,mDAAA;EACA,iDAAA;EACA,iDAAA;EACA,gDAAA;EACA,kDAAA;EACA,+CAAA;EAEA,6BAAA;EACA,2CAAA;AlB+iEJ;;AkBjkEE;EAOE,yCAAA;EACA,uBAAA;EACA,oDAAA;EACA,mDAAA;EACA,iDAAA;EACA,iDAAA;EACA,gDAAA;EACA,kDAAA;EACA,+CAAA;EAEA,6BAAA;EACA,2CAAA;AlB6jEJ;;AkB/kEE;EAOE,yCAAA;EACA,uBAAA;EACA,oDAAA;EACA,mDAAA;EACA,iDAAA;EACA,iDAAA;EACA,gDAAA;EACA,kDAAA;EACA,+CAAA;EAEA,6BAAA;EACA,2CAAA;AlB2kEJ;;AkB7lEE;EAOE,yCAAA;EACA,uBAAA;EACA,oDAAA;EACA,mDAAA;EACA,iDAAA;EACA,iDAAA;EACA,gDAAA;EACA,kDAAA;EACA,+CAAA;EAEA,6BAAA;EACA,2CAAA;AlBylEJ;;AkB3mEE;EAOE,yCAAA;EACA,uBAAA;EACA,oDAAA;EACA,mDAAA;EACA,iDAAA;EACA,iDAAA;EACA,gDAAA;EACA,kDAAA;EACA,+CAAA;EAEA,6BAAA;EACA,2CAAA;AlBumEJ;;AkBznEE;EAOE,yCAAA;EACA,uBAAA;EACA,oDAAA;EACA,mDAAA;EACA,iDAAA;EACA,iDAAA;EACA,gDAAA;EACA,kDAAA;EACA,+CAAA;EAEA,6BAAA;EACA,2CAAA;AlBqnEJ;;AkBvoEE;EAOE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;EACA,kCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EAEA,6BAAA;EACA,2CAAA;AlBmoEJ;;AiBl/DI;EACE,gBAAA;EACA,iCAAA;AjBq/DN;;AchlEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjB2/DJ;AACF;AcvlEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBigEJ;AACF;Ac7lEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBugEJ;AACF;AcnmEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjB6gEJ;AACF;AczmEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBmhEJ;AACF;AmBvrEA;EACE,qBd87BsC;Ec17BtC,oCAAA;AnBsrEF;;AmBjrEA;EACE,qDAAA;EACA,wDAAA;EACA,gBAAA;EhB8QI,kBALI;EgBrQR,gBdipB4B;EchpB5B,oCAAA;AnBkrEF;;AmB/qEA;EACE,mDAAA;EACA,sDAAA;EhBoQI,kBALI;AHo7DV;;AmB/qEA;EACE,oDAAA;EACA,uDAAA;EhB8PI,mBALI;AH07DV;;AoBhtEA;EACE,mBfs7BsC;EF5pBlC,kBALI;EiBjRR,6DAAA;ApBitEF;;AqBttEA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;ElBwRI,eALI;EkBhRR,gBhBopB4B;EgBnpB5B,gBhB2pB4B;EgB1pB5B,oDAAA;EACA,gBAAA;EACA,yDAAA;EACA,4BAAA;EACA,4FAAA;EdGE,uCAAA;EeHE,wEDMJ;ArBotEF;AsBttEM;EDhBN;ICiBQ,gBAAA;EtBytEN;AACF;AqBvtEE;EACE,gBAAA;ArBytEJ;AqBvtEI;EACE,eAAA;ArBytEN;AqBptEE;EACE,0DAAA;EACA,+DAAA;EACA,0DAAA;EACA,UAAA;EAKE,iDhBokBkB;AL8oDxB;AqB3sEE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;ArB+rEJ;AqB1rEE;EACE,cAAA;EACA,UAAA;ArB4rEJ;AqBxrEE;EACE,qEAAA;EAEA,UAAA;ArByrEJ;AqBjrEE;EAEE,yChBk4BoC;EgB/3BpC,UAAA;ArBgrEJ;AqB5qEE;EACE,yBAAA;EACA,0BAAA;EACA,0BhBivB0B;EgBhvB1B,+DAAA;EEjGF,wEFkGuB;EACrB,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,gDhB6vB0B;EgB5vB1B,gBAAA;EC5FE,qID6FF;ArB8qEJ;AsBvwEM;ED6EJ;IC5EM,gBAAA;EtB0wEN;AACF;AqBhrEE;EACE,+EAAA;ArBkrEJ;;AqBzqEA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBhBuiB4B;EgBtiB5B,8DAAA;EACA,6BAAA;EACA,yBAAA;EACA,uCAAA;ArB4qEF;AqB1qEE;EACE,UAAA;ArB4qEJ;AqBzqEE;EAEE,gBAAA;EACA,eAAA;ArB0qEJ;;AqB/pEA;EACE,oEhBg2BsC;EgB/1BtC,uBAAA;ElBsII,mBALI;EIvQN,0CAAA;AP0yEJ;AqBhqEE;EACE,uBAAA;EACA,wBAAA;EACA,yBhBisB0B;ALi+C9B;;AqB9pEA;EACE,kEhBo1BsC;EgBn1BtC,oBAAA;ElByHI,kBALI;EIvQN,0CAAA;APszEJ;AqB/pEE;EACE,oBAAA;EACA,qBAAA;EACA,uBhBwrB0B;ALy+C9B;;AqBzpEE;EACE,qEhBi0BoC;AL21CxC;AqBzpEE;EACE,oEhB8zBoC;AL61CxC;AqBxpEE;EACE,kEhB2zBoC;AL+1CxC;;AqBrpEA;EACE,WhByzBsC;EgBxzBtC,iEhBkzBsC;EgBjzBtC,iBhB8oB4B;AL0gD9B;AqBtpEE;EACE,eAAA;ArBwpEJ;AqBrpEE;EACE,oBAAA;Ed1LA,uCAAA;APk1EJ;AqBppEE;EACE,oBAAA;Ed/LA,uCAAA;APs1EJ;AqBnpEE;EAAoB,gEhBkyBkB;ALo3CxC;AqBrpEE;EAAoB,8DhBkyBkB;ALs3CxC;;AwB12EA;EACE,iEAAA;EAEA,cAAA;EACA,WAAA;EAEA,uCAAA;ErBoRI,eALI;EqB5QR,gBnBgpB4B;EmB/oB5B,gBnBupB4B;EmBtpB5B,0DAAA;EACA,gBAAA;EACA,+DAAA;EACA,qFAAA;EACA,4BAAA;EAEA,0BnBkkCkC;EmBjkClC,kGAAA;EjBJE,uCAAA;EeHE,wEEUJ;AxBw2EF;AMh4EI;EA+DE,0CAAA;ANo0EN;AM33EI;EA2DI,0CAAA;ANm0ER;AMt4EI;EA+DE,yCAAA;AN00EN;AMj4EI;EA6DI,wCAAA;ANu0ER;AsB13EM;EEfN;IFgBQ,gBAAA;EtB63EN;AACF;AwBv3EE;EACE,gEAAA;EACA,UAAA;EAKE,iDnBokC4B;ALizClC;AwBj3EE;EAGE,sBAAA;AxBi3EJ;AMz5EI;EAgCE,sBAAA;AN43EN;AMp5EI;EA+BI,qBAAA;ANw3ER;AwBp3EE;EACE,8CAAA;EACA,6EAAA;AxBs3EJ;AwBj3EE;EACE,kBAAA;EACA,sEAAA;AxBm3EJ;;AwB/2EA;EACE,oBnBqyB4B;EmBpyB5B,uBnBoyB4B;EFjkBxB,mBALI;EIvQN,0CAAA;AP65EJ;AM96EI;EAgCE,oBAAA;ANi5EN;AMz6EI;EA+BI,qBAAA;AN64ER;;AwBp3EA;EACE,mBnBiyB4B;EmBhyB5B,sBnBgyB4B;EFrkBxB,kBALI;EIvQN,0CAAA;AP06EJ;AM37EI;EAgCE,kBAAA;AN85EN;AMt7EI;EA+BI,mBAAA;AN05ER;;AyB/7EA;EACE,cAAA;EACA,kBpB4/BwC;EoB1/BxC,uBpB4/BwC;ALq8C1C;AMv8EI;EAgCE,mBAAA;AN06EN;AMl8EI;EA+BI,oBAAA;ANs6ER;AM78EI;EAgCE,WAAA;ANg7EN;AMx8EI;EA+BI,YAAA;AN46ER;AMn9EI;EAgCE,mBAAA;ANs7EN;AM98EI;EA+BI,oBAAA;ANk7ER;;AMz9EI;EAgCE,oBAAA;AN67EN;AMr9EI;EA+BI,mBAAA;ANy7ER;AMh+EI;EAgCE,eAAA;ANm8EN;AM39EI;EA+BI,gBAAA;AN+7ER;AMt+EI;EAgCE,iBAAA;ANy8EN;AMj+EI;EA+BI,gBAAA;ANq8ER;AM5+EI;EAgCE,YAAA;AN+8EN;AMv+EI;EA+BI,WAAA;AN28ER;AMl/EI;EAgCE,oBAAA;ANq9EN;AM7+EI;EA+BI,mBAAA;ANi9ER;AMx/EI;EAgCE,cAAA;AN29EN;AMn/EI;EA+BI,eAAA;ANu9ER;;AyBp+EA;EACE,uCAAA;EAEA,UpBk+BwC;EoBj+BxC,WpBi+BwC;EoBh+BxC,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;EACA,gDAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,6DpBm+BwC;EoBl+BxC,iCAAA;UAAA,yBAAA;AzBs+EF;AyBn+EE;ElB1BE,qBAAA;APggFJ;AyBl+EE;EAEE,kBpB29BsC;ALwgD1C;AyBh+EE;EACE,uBpBk9BsC;ALghD1C;AyB/9EE;EACE,qBpB86BoC;EoB76BpC,UAAA;EACA,iDpBijBoB;ALg7DxB;AyB99EE;EACE,uEAAA;EACA,uEAAA;AzBg+EJ;AyB99EI;EAII,kEAAA;AzB69ER;AyBz9EI;EAII,kEAAA;AzBw9ER;AyBn9EE;EACE,yBpBNY;EoBOZ,qBpBPY;EoBYV,kEAAA;AzBi9EN;AyB78EE;EACE,oBAAA;EACA,YAAA;EACA,YpB07BuC;ALqhD3C;AyBx8EI;EACE,eAAA;EACA,YpBi7BqC;ALyhD3C;;AyBr8EA;EACE,0CAAA;AzBw8EF;;AMxjFI;EAgCE,mBAAA;AN4hFN;AMpjFI;EA+BI,oBAAA;ANwhFR;AyBp8EE;EACE,6DAAA;EAEA,UpBs6B8B;EoBp6B9B,2CAAA;EACA,gCAAA;ElBhHA,kBAAA;EeHE,iDGqHF;AzBo8EJ;AMvkFI;EAgCE,mBAAA;AN0iFN;AMlkFI;EA+BI,oBAAA;ANsiFR;AsB3jFM;EGyGJ;IHxGM,gBAAA;EtB8jFN;AACF;AyB78EI;EACE,6DAAA;AzB+8EN;AyB58EI;EACE,iCpBq6B4B;EoBh6B1B,6DAAA;AzB08ER;AMzlFI;EAgCE,oBAAA;AN4jFN;AMplFI;EA+BI,mBAAA;ANwjFR;AM/lFI;EAgCE,eAAA;ANkkFN;AM1lFI;EA+BI,gBAAA;AN8jFR;AMrmFI;EAgCE,oBAAA;ANwkFN;AMhmFI;EA+BI,mBAAA;ANokFR;AM3mFI;EAgCE,cAAA;AN8kFN;AMtmFI;EA+BI,eAAA;AN0kFR;;AyB98EE;EACE,kBAHO;AzBo9EX;AMrnFI;EAgCE,oBAAA;ANwlFN;AMhnFI;EA+BI,qBAAA;ANolFR;AyBp9EI;EACE,aARI;EASJ,cARK;AzB89EX;AM/nFI;EAgCE,oBAAA;ANkmFN;AM1nFI;EA+BI,qBAAA;AN8lFR;AyBx9EI;EAEE,sCAAA;AzBy9EN;;AyBr+EE;EACE,iBAHO;AzB2+EX;AM5oFI;EAgCE,mBAAA;AN+mFN;AMvoFI;EA+BI,oBAAA;AN2mFR;AyB3+EI;EACE,UARI;EASJ,aARK;AzBq/EX;AMtpFI;EAgCE,mBAAA;ANynFN;AMjpFI;EA+BI,oBAAA;ANqnFR;AyB/+EI;EAEE,qCAAA;AzBg/EN;;AyB3+EA;EACE,qBAAA;AzB8+EF;AMnqFI;EAgCE,kBAAA;ANsoFN;AM9pFI;EA+BI,iBAAA;ANkoFR;;AyBh/EA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;AzBm/EF;AyB/+EI;EACE,oBAAA;EACA,YAAA;EACA,apBksBwB;AL+yD9B;;A0BhrFA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A1BmrFF;A0BjrFE;EACE,UAAA;A1BmrFJ;A0B/qFI;EAA0B,oErBknCa;ALgkD3C;A0BjrFI;EAA0B,oErBinCa;ALmkD3C;A0BjrFE;EACE,SAAA;A1BmrFJ;A0BhrFE;EACE,WrBmmCuC;EqBlmCvC,YrBkmCuC;EqBjmCvC,oBAAA;EACA,gBAAA;EH1BF,yDG2BuB;EACrB,SrBimCuC;EE9mCvC,mBAAA;EeHE,oHImBF;EJnBE,4GImBF;A1BirFJ;AsBhsFM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;EtBmsFN;AACF;A0BprFI;EHjCF,gEGkCyB;A1BsrF3B;A0BlrFE;EACE,WrB4kC8B;EqB3kC9B,crB4kC8B;EqB3kC9B,kBAAA;EACA,erB2kC8B;EqB1kC9B,wEAAA;EACA,yBAAA;EnB7BA,mBAAA;APktFJ;A0BhrFE;EACE,WrBwkCuC;EqBvkCvC,YrBukCuC;EqBtkCvC,gBAAA;EHpDF,yDGqDuB;EACrB,SrBukCuC;EE9mCvC,mBAAA;EeHE,iHI6CF;EJ7CE,4GI6CF;A1BirFJ;AsB1tFM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;EtB6tFN;AACF;A0BprFI;EH3DF,gEG4DyB;A1BsrF3B;A0BlrFE;EACE,WrBkjC8B;EqBjjC9B,crBkjC8B;EqBjjC9B,kBAAA;EACA,erBijC8B;EqBhjC9B,wEAAA;EACA,yBAAA;EnBvDA,mBAAA;AP4uFJ;A0BhrFE;EACE,oBAAA;A1BkrFJ;A0BhrFI;EACE,qFAAA;A1BkrFN;A0B/qFI;EACE,qFAAA;A1BirFN;;A2BxwFA;EACE,kBAAA;A3B2wFF;A2BzwFE;;;EAGE,wDtB4oCoC;EsB3oCpC,4DtB2oCoC;EsB1oCpC,iBtB2oCoC;ALgoDxC;A2BxwFE;EACE,kBAAA;EACA,MAAA;EAEA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iDAAA;EACA,qBAAA;ELRE,gEKSF;A3BywFJ;AMhyFI;EAgCE,OAAA;ANmwFN;AM3xFI;EA+BI,QAAA;AN+vFR;AsBpxFM;EKTJ;ILUM,gBAAA;EtBuxFN;AACF;A2BjxFE;;EAEE,qBAAA;A3BmxFJ;A2BjxFI;;EACE,kBAAA;A3BoxFN;A2BjxFI;;;EAEE,qBtBgnCkC;EsB/mClC,wBtBgnCkC;ALoqDxC;A2BjxFI;;EACE,qBtB2mCkC;EsB1mClC,wBtB2mCkC;ALyqDxC;A2BhxFE;EACE,qBtBqmCoC;EsBpmCpC,wBtBqmCoC;AL6qDxC;A2B3wFI;;;;EACE,4CAAA;EACA,8DtB+lCkC;ALirDxC;A2B9wFM;;;;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,atBulCgC;EsBtlChC,WAAA;EACA,oCtBu5BgC;EEv8BpC,uCAAA;APo0FJ;A2B7wFI;EACE,4CAAA;EACA,8DtB8kCkC;ALisDxC;A2B1wFI;EACE,uCAAA;A3B4wFN;A2BxwFE;;EAEE,ctBzEQ;ALm1FZ;A2BxwFI;;EACE,yCtBi4BkC;AL04DxC;;A4Bl2FA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A5Bq2FF;A4Bn2FE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A5Bq2FJ;A4Bj2FE;;;EAGE,UAAA;A5Bm2FJ;A4B71FE;EACE,kBAAA;EACA,UAAA;A5B+1FJ;A4B71FI;EACE,UAAA;A5B+1FN;;A4Bp1FA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EzB8OI,eALI;EyBvOR,gBvB2mB4B;EuB1mB5B,gBvBknB4B;EuBjnB5B,gEAAA;EACA,kBAAA;EACA,mBAAA;EACA,yEAAA;EACA,wGAAA;ErBtCE,uCAAA;AP83FJ;;A4B90FA;;;;EAIE,oBAAA;EzBwNI,kBALI;EIvQN,0CAAA;APu4FJ;;A4B90FA;;;;EAIE,uBAAA;EzB+MI,mBALI;EIvQN,0CAAA;APg5FJ;;AMj6FI;;EAgCE,mBAAA;ANs4FN;AM95FI;;EA+BI,kBAAA;ANm4FR;;AM16FI;;;;EAgCE,0BAAA;ANi5FN;AMz6FI;;;;EA+BI,yBAAA;ANg5FR;AMv7FI;;;;EAgCE,6BAAA;AN65FN;AMr7FI;;;;EA+BI,4BAAA;AN45FR;AMn8FI;;;;EAgCE,0BAAA;ANy6FN;AMj8FI;;;;EA+BI,yBAAA;ANw6FR;AM/8FI;;;;EAgCE,6BAAA;ANq7FN;AM78FI;;;;EA+BI,4BAAA;ANo7FR;AM39FI;EAgCE,+CAAA;AN87FN;AMt9FI;EA+BI,gDAAA;AN07FR;AMj+FI;EAgCE,yBAAA;ANo8FN;AM59FI;EA+BI,0BAAA;ANg8FR;AMv+FI;EAgCE,4BAAA;AN08FN;AMl+FI;EA+BI,6BAAA;ANs8FR;AM7+FI;;EAgCE,yBAAA;ANi9FN;AMz+FI;;EA+BI,0BAAA;AN88FR;AMr/FI;;EAgCE,4BAAA;ANy9FN;AMj/FI;;EA+BI,6BAAA;ANs9FR;;A6Br+FE;EACE,aAAA;EACA,WAAA;EACA,mBxB85BoC;EF5pBlC,kBALI;E0B1PN,kCxBspCqB;ALi1DzB;;A6Bp+FE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WxByoCqB;EwBxoCrB,oCxBwoCqB;EEnqCrB,uCAAA;APkgGJ;;A6Bl+FI;;;;EAEE,cAAA;A7Bu+FN;;A6BthGI;EAqDE,gDxB2nCmB;EwBvnCjB,yDAAA;EACA,4BAAA;EAEA,gEAAA;A7Bi+FR;AMjiGI;EAgCE,oCAAA;ANogGN;AM5hGI;EA+BI,mCAAA;ANggGR;AMviGI;EA+DE,2DAAA;AN2+FN;AMliGI;EA2DI,0DAAA;AN0+FR;A6B1+FM;EACE,gDxBgnCiB;EwB/mCjB,4DxB+mCiB;AL63DzB;;AMjjGI;EAgCE,oCAAA;ANqhGN;AM7iGI;EA+BI,mCAAA;ANihGR;AMxjGI;EA+DE,kFAAA;AN4/FN;AMnjGI;EA2DI,iFAAA;AN2/FR;;A6B1jGI;EAkFE,gDxB8lCmB;AL84DzB;A6Bz+FQ;EAEE,kEAAA;EAGA,2EAAA;A7Bw+FV;AMtkGI;EAgCE,uBAAA;ANyiGN;AMjkGI;EA+BI,sBAAA;ANqiGR;AM5kGI;EA+DE,+DAAA;ANghGN;AMvkGI;EA6DI,6DAAA;AN6gGR;A6Bh/FM;EACE,gDxBilCiB;EwBhlCjB,4DxBglCiB;ALk6DzB;;A6BllGI;EAwGI,yCAAA;A7B8+FR;;A6BtlGI;EA+GE,gDxBikCmB;AL06DzB;A6Bz+FM;EACE,6CxB8jCiB;AL66DzB;A6Bx+FM;EACE,4DxB0jCiB;ALg7DzB;A6Bv+FM;EACE,kCxBsjCiB;ALm7DzB;;AMvmGI;EAgCE,kBAAA;AN2kGN;AMnmGI;EA+BI,mBAAA;ANukGR;;A6B1mGI;;;;;EA0IM,UAAA;A7Bw+FV;;A6B9lGE;EACE,aAAA;EACA,WAAA;EACA,mBxB85BoC;EF5pBlC,kBALI;E0B1PN,oCxBspCqB;AL08DzB;;A6B7lGE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WxByoCqB;EwBxoCrB,mCxBwoCqB;EEnqCrB,uCAAA;AP2nGJ;;A6B3lGI;;;;EAEE,cAAA;A7BgmGN;;A6B/oGI;EAqDE,kDxB2nCmB;EwBvnCjB,yDAAA;EACA,4BAAA;EAEA,gEAAA;A7B0lGR;AM1pGI;EAgCE,oCAAA;AN6nGN;AMrpGI;EA+BI,mCAAA;ANynGR;AMhqGI;EA+DE,2DAAA;ANomGN;AM3pGI;EA2DI,0DAAA;ANmmGR;A6BnmGM;EACE,kDxBgnCiB;EwB/mCjB,2DxB+mCiB;ALs/DzB;;AM1qGI;EAgCE,oCAAA;AN8oGN;AMtqGI;EA+BI,mCAAA;AN0oGR;AMjrGI;EA+DE,kFAAA;ANqnGN;AM5qGI;EA2DI,iFAAA;ANonGR;;A6BnrGI;EAkFE,kDxB8lCmB;ALugEzB;A6BlmGQ;EAEE,kEAAA;EAGA,2EAAA;A7BimGV;AM/rGI;EAgCE,uBAAA;ANkqGN;AM1rGI;EA+BI,sBAAA;AN8pGR;AMrsGI;EA+DE,+DAAA;ANyoGN;AMhsGI;EA6DI,6DAAA;ANsoGR;A6BzmGM;EACE,kDxBilCiB;EwBhlCjB,2DxBglCiB;AL2hEzB;;A6B3sGI;EAwGI,yCAAA;A7BumGR;;A6B/sGI;EA+GE,kDxBikCmB;ALmiEzB;A6BlmGM;EACE,+CxB8jCiB;ALsiEzB;A6BjmGM;EACE,2DxB0jCiB;ALyiEzB;A6BhmGM;EACE,oCxBsjCiB;AL4iEzB;;AMhuGI;EAgCE,kBAAA;ANosGN;AM5tGI;EA+BI,mBAAA;ANgsGR;;A6BnuGI;;;;;EA4IM,UAAA;A7B+lGV;;A8B7uGA;EAEE,4BAAA;EACA,6BAAA;EACA,uBAAA;E3BuRI,yBALI;E2BhRR,0BAAA;EACA,0BAAA;EACA,sCAAA;EACA,yBAAA;EACA,+CAAA;EACA,mCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gGAAA;EACA,gCAAA;EACA,mFAAA;EAGA,qBAAA;EACA,0DAAA;EACA,uCAAA;E3BsQI,mCALI;E2B/PR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,qEAAA;EvBjBE,2CAAA;EgBfF,mCOkCqB;ERtBjB,qIQwBJ;A9B2uGF;AsB/vGM;EQhBN;IRiBQ,gBAAA;EtBkwGN;AACF;A8B9uGE;EACE,iCAAA;EAEA,yCAAA;EACA,+CAAA;A9B+uGJ;A8B5uGE;EAEE,2BAAA;EACA,mCAAA;EACA,yCAAA;A9B6uGJ;A8B1uGE;EACE,iCAAA;EPrDF,yCOsDuB;EACrB,+CAAA;EACA,UAAA;EAKE,2CAAA;A9BwuGN;A8BpuGE;EACE,+CAAA;EACA,UAAA;EAKE,2CAAA;A9BkuGN;A8B9tGE;EAKE,kCAAA;EACA,0CAAA;EAGA,gDAAA;A9B0tGJ;A8BvtGI;EAKI,2CAAA;A9BqtGR;A8BhtGE;EAGE,oCAAA;EACA,oBAAA;EACA,4CAAA;EAEA,kDAAA;EACA,wCAAA;A9B+sGJ;;A8BrsGA;EACE,0CAAA;EACA,4CAAA;EACA,yCAAA;A9BwsGF;;A8BnsGE;EC3GA,0CAAA;EACA,qBAAA;EACA,+BAAA;EACA,gDAAA;EACA,2BAAA;EACA,qCAAA;EACA,uCAAA;EACA,iDAAA;EACA,4BAAA;EACA,sCAAA;EACA,gEAAA;EACA,mDAAA;EACA,8BAAA;EACA,wCAAA;A/BkzGF;;A8BptGE;EC3GA,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,6CAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,8CAAA;EACA,4BAAA;EACA,sCAAA;EACA,gEAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;A/Bm0GF;;A8BruGE;EC3GA,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,6CAAA;EACA,2BAAA;EACA,qCAAA;EACA,uCAAA;EACA,8CAAA;EACA,4BAAA;EACA,sCAAA;EACA,gEAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;A/Bo1GF;;A8BtvGE;EC3GA,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,gEAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;A/Bq2GF;;A8BvwGE;EC3GA,uCAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,wCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,gEAAA;EACA,gDAAA;EACA,8BAAA;EACA,wCAAA;A/Bs3GF;;A8BxxGE;EC3GA,wBAAA;EACA,kBAAA;EACA,4BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,wCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,gEAAA;EACA,iCAAA;EACA,2BAAA;EACA,qCAAA;A/Bu4GF;;A8BzyGE;EC3GA,uCAAA;EACA,qBAAA;EACA,+BAAA;EACA,6CAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,8CAAA;EACA,4BAAA;EACA,sCAAA;EACA,gEAAA;EACA,gDAAA;EACA,8BAAA;EACA,wCAAA;A/Bw5GF;;A8B1zGE;EC3GA,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,gEAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;A/By6GF;;A8Br0GE;ECpFA,wBAAA;EACA,+BAAA;EACA,gDAAA;EACA,2BAAA;EACA,qCAAA;EACA,uCAAA;EACA,iDAAA;EACA,4BAAA;EACA,sCAAA;EACA,gEAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;A/B65GF;;A8Br1GE;ECpFA,wBAAA;EACA,+BAAA;EACA,6CAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,8CAAA;EACA,4BAAA;EACA,sCAAA;EACA,gEAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;A/B66GF;;A8Br2GE;ECpFA,wBAAA;EACA,+BAAA;EACA,6CAAA;EACA,2BAAA;EACA,qCAAA;EACA,uCAAA;EACA,8CAAA;EACA,4BAAA;EACA,sCAAA;EACA,gEAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;A/B67GF;;A8Br3GE;ECpFA,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,uCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,gEAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;A/B68GF;;A8Br4GE;ECpFA,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,wCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,gEAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;A/B69GF;;A8Br5GE;ECpFA,qBAAA;EACA,4BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,wCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kCAAA;EACA,oBAAA;A/B6+GF;;A8Br6GE;ECpFA,wBAAA;EACA,+BAAA;EACA,6CAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,8CAAA;EACA,4BAAA;EACA,sCAAA;EACA,gEAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;A/B6/GF;;A8Br7GE;ECpFA,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,gEAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;A/B6gHF;;A8B/7GE;EC9DA,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,gDAAA;EACA,4BAAA;EACA,sCAAA;EACA,iDAAA;EACA,iCAAA;EACA,wCAAA;A/BigHF;;A8B38GE;EC9DA,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,6CAAA;EACA,4BAAA;EACA,sCAAA;EACA,8CAAA;EACA,iCAAA;EACA,0CAAA;A/B6gHF;;A8Bv9GE;EC9DA,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,6CAAA;EACA,4BAAA;EACA,sCAAA;EACA,8CAAA;EACA,iCAAA;EACA,wCAAA;A/ByhHF;;A8Bn+GE;EC9DA,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,iCAAA;EACA,wCAAA;A/BqiHF;;A8B/+GE;EC9DA,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,iCAAA;EACA,yCAAA;A/BijHF;;A8B3/GE;EC9DA,qBAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,8BAAA;EACA,yCAAA;A/B6jHF;;A8BvgHE;EC9DA,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,6CAAA;EACA,4BAAA;EACA,sCAAA;EACA,8CAAA;EACA,iCAAA;EACA,0CAAA;A/BykHF;;A8BnhHE;EC9DA,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,iCAAA;EACA,0CAAA;A/BqlHF;;A8BnhHA;EACE,0BAAA;EACA,sCAAA;EACA,yBAAA;EACA,mCAAA;EACA,kDAAA;EACA,yCAAA;EACA,0CAAA;EACA,iCAAA;EACA,4CAAA;EACA,0BAAA;EACA,uCAAA;EAEA,0BzBiVwC;ALosG1C;A8B3gHE;EACE,2BAAA;A9B6gHJ;;A8BlgHA;EC9FE,2BAAA;EACA,yBAAA;E5BiMI,4BALI;E4B1LR,oDAAA;A/BomHF;;A8BrgHA;EClGE,4BAAA;EACA,2BAAA;E5BiMI,6BALI;E4B1LR,oDAAA;A/B2mHF;;AgC3sHA;EVgBM,gCUfJ;AhC8sHF;AsB3rHM;EUpBN;IVqBQ,gBAAA;EtB8rHN;AACF;AgCjtHE;EACE,UAAA;AhCmtHJ;;AgC7sHE;EACE,aAAA;AhCgtHJ;;AgC5sHA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;AhC+sHF;AsB7sHM;EULN;IVMQ,gBAAA;EtBgtHN;AACF;AgCltHE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;AhCotHJ;AsBvtHM;EUAJ;IVCM,gBAAA;EtB0tHN;AACF;;AiC/uHA;;;;;;EAME,kBAAA;AjCkvHF;;AiC/uHA;EACE,mBAAA;AjCkvHF;AkC1tHI;EACE,qBAAA;EAEA,uB7B6kBwB;E6B5kBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AlCiwHF;AMpwHI;EAgCE,oBAAA;ANuuHN;AM/vHI;EA+BI,qBAAA;ANmuHR;AM1wHI;EAgCE,cAAA;AN6uHN;AMrwHI;EA+BI,eAAA;ANyuHR;;AiChwHA;EAEE,2BAAA;EACA,+BAAA;EACA,2BAAA;EACA,gCAAA;EACA,+BAAA;E9BuQI,8BALI;E8BhQR,2CAAA;EACA,qCAAA;EACA,gEAAA;EACA,sDAAA;EACA,oDAAA;EACA,4FAAA;EACA,8DAAA;EACA,uCAAA;EACA,+DAAA;EACA,gDAAA;EACA,sDAAA;EACA,oDAAA;EACA,2DAAA;EACA,sCAAA;EACA,6DAAA;EACA,mCAAA;EACA,sCAAA;EACA,oCAAA;EACA,qCAAA;EACA,uCAAA;EAGA,kBAAA;EACA,mCAAA;EACA,aAAA;EACA,wCAAA;EACA,oEAAA;EACA,SAAA;E9B0OI,wCALI;E8BnOR,gCAAA;EACA,gBAAA;EACA,gBAAA;EACA,wCAAA;EACA,4BAAA;EACA,+EAAA;E1BzCE,gDAAA;AP0yHJ;AiC7vHE;EACE,SAAA;EAEA,sCAAA;AjC8vHJ;AM/zHI;EAgCE,OAAA;ANkyHN;AM1zHI;EA+BI,QAAA;AN8xHR;;AiC5uHI;EACE,qBAAA;AjC+uHN;AMz0HI;EAgCE,WAAA;AN4yHN;AMp0HI;EA+BI,UAAA;ANwyHR;AM/0HI;EAgCE,OAAA;ANkzHN;AM10HI;EA+BI,QAAA;AN8yHR;;AiCnvHI;EACE,mBAAA;AjCsvHN;AMz1HI;EAgCE,QAAA;AN4zHN;AMp1HI;EA+BI,OAAA;ANwzHR;AM/1HI;EAgCE,UAAA;ANk0HN;AM11HI;EA+BI,WAAA;AN8zHR;;AcxyHI;EmB4BA;IACE,qBAAA;EjCgxHJ;EM12HE;IAgCE,WAAA;EN60HJ;EMr2HE;IA+BI,UAAA;ENy0HN;EMh3HE;IAgCE,OAAA;ENm1HJ;EM32HE;IA+BI,QAAA;EN+0HN;EiCpxHE;IACE,mBAAA;EjCsxHJ;EMz3HE;IAgCE,QAAA;EN41HJ;EMp3HE;IA+BI,OAAA;ENw1HN;EM/3HE;IAgCE,UAAA;ENk2HJ;EM13HE;IA+BI,WAAA;EN81HN;AACF;Acz0HI;EmB4BA;IACE,qBAAA;EjCgzHJ;EM14HE;IAgCE,WAAA;EN62HJ;EMr4HE;IA+BI,UAAA;ENy2HN;EMh5HE;IAgCE,OAAA;ENm3HJ;EM34HE;IA+BI,QAAA;EN+2HN;EiCpzHE;IACE,mBAAA;EjCszHJ;EMz5HE;IAgCE,QAAA;EN43HJ;EMp5HE;IA+BI,OAAA;ENw3HN;EM/5HE;IAgCE,UAAA;ENk4HJ;EM15HE;IA+BI,WAAA;EN83HN;AACF;Acz2HI;EmB4BA;IACE,qBAAA;EjCg1HJ;EM16HE;IAgCE,WAAA;EN64HJ;EMr6HE;IA+BI,UAAA;ENy4HN;EMh7HE;IAgCE,OAAA;ENm5HJ;EM36HE;IA+BI,QAAA;EN+4HN;EiCp1HE;IACE,mBAAA;EjCs1HJ;EMz7HE;IAgCE,QAAA;EN45HJ;EMp7HE;IA+BI,OAAA;ENw5HN;EM/7HE;IAgCE,UAAA;ENk6HJ;EM17HE;IA+BI,WAAA;EN85HN;AACF;Acz4HI;EmB4BA;IACE,qBAAA;EjCg3HJ;EM18HE;IAgCE,WAAA;EN66HJ;EMr8HE;IA+BI,UAAA;ENy6HN;EMh9HE;IAgCE,OAAA;ENm7HJ;EM38HE;IA+BI,QAAA;EN+6HN;EiCp3HE;IACE,mBAAA;EjCs3HJ;EMz9HE;IAgCE,QAAA;EN47HJ;EMp9HE;IA+BI,OAAA;ENw7HN;EM/9HE;IAgCE,UAAA;ENk8HJ;EM19HE;IA+BI,WAAA;EN87HN;AACF;Acz6HI;EmB4BA;IACE,qBAAA;EjCg5HJ;EM1+HE;IAgCE,WAAA;EN68HJ;EMr+HE;IA+BI,UAAA;ENy8HN;EMh/HE;IAgCE,OAAA;ENm9HJ;EM3+HE;IA+BI,QAAA;EN+8HN;EiCp5HE;IACE,mBAAA;EjCs5HJ;EMz/HE;IAgCE,QAAA;EN49HJ;EMp/HE;IA+BI,OAAA;ENw9HN;EM//HE;IAgCE,UAAA;ENk+HJ;EM1/HE;IA+BI,WAAA;EN89HN;AACF;AiCr5HE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,yCAAA;AjCu5HJ;AkC3+HI;EACE,qBAAA;EAEA,uB7B6kBwB;E6B5kBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AlC2gIF;AMrhII;EAgCE,oBAAA;ANw/HN;AMhhII;EA+BI,qBAAA;ANo/HR;AM3hII;EAgCE,cAAA;AN8/HN;AMthII;EA+BI,eAAA;AN0/HR;;AiCn6HE;EACE,MAAA;EAGA,aAAA;AjCo6HJ;AMtiII;EAgCE,WAAA;ANygIN;AMjiII;EA+BI,UAAA;ANqgIR;AM5iII;EAgCE,UAAA;AN+gIN;AMviII;EA+BI,WAAA;AN2gIR;AMljII;EAgCE,uCAAA;ANqhIN;AM7iII;EA+BI,wCAAA;ANihIR;AkCvhII;EACE,qBAAA;EAEA,uB7B6kBwB;E6B5kBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AlCgjIF;AMjkII;EAgCE,oBAAA;ANoiIN;AM5jII;EA+BI,qBAAA;ANgiIR;AMvkII;EAgCE,cAAA;AN0iIN;AMlkII;EA+BI,eAAA;ANsiIR;AiCr8HI;EACE,iBAAA;AjCu8HN;;AiCj8HE;EACE,MAAA;EAGA,aAAA;AjCk8HJ;AMrlII;EAgCE,WAAA;ANwjIN;AMhlII;EA+BI,UAAA;ANojIR;AM3lII;EAgCE,UAAA;AN8jIN;AMtlII;EA+BI,WAAA;AN0jIR;AMjmII;EAgCE,wCAAA;ANokIN;AM5lII;EA+BI,uCAAA;ANgkIR;AkCtkII;EACE,qBAAA;EAEA,uB7B6kBwB;E6B5kBxB,WAAA;AlCukIN;AM5mII;EAgCE,oBAAA;AN+kIN;AMvmII;EA+BI,qBAAA;AN2kIR;AkClkIM;EACE,aAAA;AlCokIR;AkCjkIM;EACE,qBAAA;EAEA,uB7B0jBsB;E6BzjBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;AlCsmIF;AM7nII;EAgCE,qBAAA;ANgmIN;AMxnII;EA+BI,oBAAA;AN4lIR;AMnoII;EAgCE,cAAA;ANsmIN;AM9nII;EA+BI,eAAA;ANkmIR;AiCh/HI;EACE,iBAAA;AjCk/HN;;AiC3+HA;EACE,SAAA;EACA,8CAAA;EACA,gBAAA;EACA,oDAAA;EACA,UAAA;AjC8+HF;;AiCx+HA;EACE,cAAA;EACA,WAAA;EACA,8EAAA;EACA,WAAA;EACA,gB5B2e4B;E4B1e5B,qCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E1BtKE,wDAAA;APkpIJ;AiCz+HE;EAEE,2CAAA;EV1LF,mDU4LuB;AjCy+HzB;AiCt+HE;EAEE,4CAAA;EACA,qBAAA;EVlMF,oDUmMuB;AjCu+HzB;AiCp+HE;EAEE,8CAAA;EACA,oBAAA;EACA,6BAAA;AjCq+HJ;;AiC/9HA;EACE,cAAA;AjCk+HF;;AiC99HA;EACE,cAAA;EACA,kFAAA;EACA,gBAAA;E9BmEI,mBALI;E8B5DR,uCAAA;EACA,mBAAA;AjCi+HF;;AiC79HA;EACE,cAAA;EACA,8EAAA;EACA,qCAAA;AjCg+HF;;AiC59HA;EAEE,6BAAA;EACA,0BAAA;EACA,gEAAA;EACA,2BAAA;EACA,kCAAA;EACA,0DAAA;EACA,8DAAA;EACA,uDAAA;EACA,2DAAA;EACA,sCAAA;EACA,2CAAA;EACA,oCAAA;AjC89HF;;AmCptIA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AnCutIF;AmCrtIE;;EACE,kBAAA;EACA,cAAA;AnCwtIJ;AmCntIE;;;;;;;;;;;;EAME,UAAA;AnC2tIJ;;AmCttIA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AnCytIF;AmCvtIE;EACE,WAAA;AnCytIJ;;AmCrtIA;E5BhBI,uCAAA;APyuIJ;AM1vII;;EAgCE,+CAAA;AN8tIN;AMtvII;;EA+BI,gDAAA;AN2tIR;AMlwII;;;EAgCE,0BAAA;ANuuIN;AM/vII;;;EA+BI,yBAAA;ANquIR;AM5wII;;;EAgCE,6BAAA;ANivIN;AMzwII;;;EA+BI,4BAAA;AN+uIR;AMtxII;;;EAgCE,yBAAA;AN2vIN;AMnxII;;;EA+BI,0BAAA;ANyvIR;AMhyII;;;EAgCE,4BAAA;ANqwIN;AM7xII;;;EA+BI,6BAAA;ANmwIR;;AmCluIA;EACE,wBAAA;EACA,uBAAA;AnCquIF;AM/yII;EAgCE,cAAA;ANkxIN;AM1yII;EA+BI,eAAA;AN8wIR;AMrzII;EAgCE,eAAA;ANwxIN;AMhzII;EA+BI,cAAA;ANoxIR;;AmCpuIA;EACE,uBAAA;EACA,sBAAA;AnCuuIF;;AmCpuIA;EACE,sBAAA;EACA,qBAAA;AnCuuIF;;AmCntIA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AnCstIF;AmCptIE;;EAEE,WAAA;AnCstIJ;AmCntIE;;EAEE,8CAAA;AnCqtIJ;AmCjtIE;;E5B1FE,6BAAA;EACA,4BAAA;AP+yIJ;AmCjtIE;;E5B7GE,yBAAA;EACA,0BAAA;APk0IJ;;AoC11IA;EAEE,8BAAA;EACA,gCAAA;EAEA,4BAAA;EACA,2CAAA;EACA,uDAAA;EACA,yDAAA;EAGA,aAAA;EACA,eAAA;EAEA,gBAAA;EACA,gBAAA;ApCw1IF;AM12II;EAgCE,eAAA;AN60IN;AMr2II;EA+BI,gBAAA;ANy0IR;;AoC31IA;EACE,cAAA;EACA,oEAAA;EjCsQI,wCALI;EiC/PR,4CAAA;EACA,gCAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;ApC81IF;AsB12IM;EcGN;IdFQ,gBAAA;EtB62IN;AACF;AoCj2IE;EAEE,sCAAA;ApCk2IJ;AoC91IE;EACE,UAAA;EACA,iD/BokBoB;AL4xHxB;AoC51IE;EAEE,yCAAA;EACA,oBAAA;EACA,eAAA;ApC61IJ;;AoCr1IA;EAEE,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,+GAAA;EACA,2DAAA;EACA,iDAAA;EACA,2GAAA;EAGA,sFAAA;ApCq1IF;AoCn1IE;EACE,0DAAA;EACA,0DAAA;E7B7CA,yDAAA;EACA,0DAAA;APm4IJ;AoCp1II;EAGE,kBAAA;EACA,yDAAA;ApCo1IN;AoCh1IE;;EAEE,4CAAA;EACA,oDAAA;EACA,0DAAA;ApCk1IJ;AoC/0IE;EAEE,uDAAA;E7BjEA,yBAAA;EACA,0BAAA;APk5IJ;;AoCv0IA;EAEE,uDAAA;EACA,4DAAA;EACA,uCAAA;ApCy0IF;AoCt0IE;E7B5FE,iDAAA;APq6IJ;AoCr0IE;;EAEE,6CAAA;EbjHF,qDakHuB;ApCu0IzB;;AoC7zIE;;EAEE,cAAA;EACA,kBAAA;ApCg0IJ;;AoC3zIE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;ApC8zIJ;;AoCxzIE;;EACE,WAAA;ApC4zIJ;;AoClzIE;EACE,aAAA;ApCqzIJ;AoCnzIE;EACE,cAAA;ApCqzIJ;;AqCj9IA;EAEE,yBAAA;EACA,8BAAA;EACA,6DAAA;EACA,kEAAA;EACA,qEAAA;EACA,iEAAA;EACA,uCAAA;EACA,mCAAA;EACA,qCAAA;EACA,gEAAA;EACA,sEAAA;EACA,uCAAA;EACA,uCAAA;EACA,uCAAA;EACA,uCAAA;EACA,qEAAA;EACA,4EAAA;EACA,4DAAA;EACA,yCAAA;EACA,6DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,gEAAA;ArCi9IF;AqC38IE;;;;;;;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;ArCy9IJ;AqCr8IA;EACE,8CAAA;EACA,iDAAA;ElC6NI,4CALI;EkCrNR,oCAAA;EACA,qBAAA;EACA,mBAAA;ArCs8IF;AM3gJI;EAgCE,gDAAA;AN8+IN;AMtgJI;EA+BI,+CAAA;AN0+IR;AqC18IE;EAEE,0CAAA;ArC28IJ;;AqCj8IA;EAEE,2BAAA;EACA,gCAAA;EAEA,4BAAA;EACA,6CAAA;EACA,yDAAA;EACA,+DAAA;EAGA,aAAA;EACA,sBAAA;EAEA,gBAAA;EACA,gBAAA;ArC+7IF;AMjiJI;EAgCE,eAAA;ANogJN;AM5hJI;EA+BI,gBAAA;ANggJR;AqCl8II;EAEE,qCAAA;ArCm8IN;AqC/7IE;EACE,gBAAA;ArCi8IJ;;AqCz7IA;EACE,mBhCqnCkC;EgCpnClC,sBhConCkC;EgCnnClC,8BAAA;ArC47IF;AqC17IE;;;EAGE,qCAAA;ArC47IJ;;AqC/6IA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;ArCg7IF;;AqC56IA;EACE,gFAAA;ElC0II,8CALI;EkCnIR,cAAA;EACA,8BAAA;EACA,6BAAA;EACA,4EAAA;E9BvIE,sDAAA;EeHE,gDe4IJ;ArC+6IF;AsBvjJM;EegIN;If/HQ,gBAAA;EtB0jJN;AACF;AqCl7IE;EACE,qBAAA;ArCo7IJ;AqCj7IE;EACE,qBAAA;EACA,UAAA;EACA,uDAAA;ArCm7IJ;;AqC76IA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;ArCg7IF;;AqC76IA;EACE,0CAAA;EACA,gBAAA;ArCg7IF;;AcziJI;EuBqIA;IAEI,iBAAA;IACA,2BAAA;ErCu6IN;EqCr6IM;IACE,mBAAA;ErCu6IR;EqCr6IQ;IACE,kBAAA;ErCu6IV;EqCp6IQ;IACE,mDAAA;IACA,kDAAA;ErCs6IV;EqCl6IM;IACE,iBAAA;ErCo6IR;EqCj6IM;IACE,wBAAA;IACA,gBAAA;ErCm6IR;EqCh6IM;IACE,aAAA;ErCk6IR;EqC/5IM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If7NJ,gBe+NI;ErC+5IR;EqC55IQ;IACE,aAAA;ErC85IV;EqC35IQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErC65IV;AACF;AczlJI;EuBqIA;IAEI,iBAAA;IACA,2BAAA;ErCs9IN;EqCp9IM;IACE,mBAAA;ErCs9IR;EqCp9IQ;IACE,kBAAA;ErCs9IV;EqCn9IQ;IACE,mDAAA;IACA,kDAAA;ErCq9IV;EqCj9IM;IACE,iBAAA;ErCm9IR;EqCh9IM;IACE,wBAAA;IACA,gBAAA;ErCk9IR;EqC/8IM;IACE,aAAA;ErCi9IR;EqC98IM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If7NJ,gBe+NI;ErC88IR;EqC38IQ;IACE,aAAA;ErC68IV;EqC18IQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErC48IV;AACF;AcxoJI;EuBqIA;IAEI,iBAAA;IACA,2BAAA;ErCqgJN;EqCngJM;IACE,mBAAA;ErCqgJR;EqCngJQ;IACE,kBAAA;ErCqgJV;EqClgJQ;IACE,mDAAA;IACA,kDAAA;ErCogJV;EqChgJM;IACE,iBAAA;ErCkgJR;EqC//IM;IACE,wBAAA;IACA,gBAAA;ErCigJR;EqC9/IM;IACE,aAAA;ErCggJR;EqC7/IM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If7NJ,gBe+NI;ErC6/IR;EqC1/IQ;IACE,aAAA;ErC4/IV;EqCz/IQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErC2/IV;AACF;AcvrJI;EuBqIA;IAEI,iBAAA;IACA,2BAAA;ErCojJN;EqCljJM;IACE,mBAAA;ErCojJR;EqCljJQ;IACE,kBAAA;ErCojJV;EqCjjJQ;IACE,mDAAA;IACA,kDAAA;ErCmjJV;EqC/iJM;IACE,iBAAA;ErCijJR;EqC9iJM;IACE,wBAAA;IACA,gBAAA;ErCgjJR;EqC7iJM;IACE,aAAA;ErC+iJR;EqC5iJM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If7NJ,gBe+NI;ErC4iJR;EqCziJQ;IACE,aAAA;ErC2iJV;EqCxiJQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErC0iJV;AACF;ActuJI;EuBqIA;IAEI,iBAAA;IACA,2BAAA;ErCmmJN;EqCjmJM;IACE,mBAAA;ErCmmJR;EqCjmJQ;IACE,kBAAA;ErCmmJV;EqChmJQ;IACE,mDAAA;IACA,kDAAA;ErCkmJV;EqC9lJM;IACE,iBAAA;ErCgmJR;EqC7lJM;IACE,wBAAA;IACA,gBAAA;ErC+lJR;EqC5lJM;IACE,aAAA;ErC8lJR;EqC3lJM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If7NJ,gBe+NI;ErC2lJR;EqCxlJQ;IACE,aAAA;ErC0lJV;EqCvlJQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErCylJV;AACF;AqChpJI;EAEI,iBAAA;EACA,2BAAA;ArCipJR;AqC/oJQ;EACE,mBAAA;ArCipJV;AqC/oJU;EACE,kBAAA;ArCipJZ;AqC9oJU;EACE,mDAAA;EACA,kDAAA;ArCgpJZ;AqC5oJQ;EACE,iBAAA;ArC8oJV;AqC3oJQ;EACE,wBAAA;EACA,gBAAA;ArC6oJV;AqC1oJQ;EACE,aAAA;ArC4oJV;AqCzoJQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef7NJ,gBe+NI;ArCyoJV;AqCtoJU;EACE,aAAA;ArCwoJZ;AqCroJU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;ArCuoJZ;;AqCtnJA;EAEE,6CAAA;EACA,mDAAA;EACA,sDAAA;EACA,kCAAA;EACA,iCAAA;EACA,uCAAA;EACA,2DAAA;EACA,sEAAA;ArCwnJF;;AsCx4JA;EAEE,yBAAA;EACA,yBAAA;EACA,iCAAA;EACA,wBAAA;EACA,2BAAA;EACA,gDAAA;EACA,4DAAA;EACA,kDAAA;EACA,uBAAA;EACA,0FAAA;EACA,gCAAA;EACA,8BAAA;EACA,wDAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;EACA,oCAAA;EACA,gCAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,4BAAA;EACA,qBAAA;EACA,oCAAA;EACA,2BAAA;EACA,uEAAA;E/BjBE,4CAAA;AP05JJ;AsCr4JE;EACE,eAAA;EACA,cAAA;AtCu4JJ;AsCp4JE;EACE,mBAAA;EACA,sBAAA;AtCs4JJ;AsCp4JI;EACE,mBAAA;E/BtBF,2DAAA;EACA,4DAAA;AP65JJ;AsCp4JI;EACE,sBAAA;E/BbF,+DAAA;EACA,8DAAA;APo5JJ;AsCj4JE;;EAEE,aAAA;AtCm4JJ;;AsC/3JA;EAGE,cAAA;EACA,0DAAA;EACA,4BAAA;AtCg4JF;;AsC73JA;EACE,6CAAA;EACA,kCAAA;AtCg4JF;;AsC73JA;EACE,uDAAA;EACA,gBAAA;EACA,qCAAA;AtCg4JF;;AsC73JA;EACE,gBAAA;AtCg4JF;;AMt9JI;EAgCE,qCAAA;AN07JN;AMl9JI;EA+BI,sCAAA;ANs7JR;;AsCt3JA;EACE,oEAAA;EACA,gBAAA;EACA,gCAAA;EACA,wCAAA;EACA,8EAAA;AtCy3JF;AsCv3JE;E/B7FE,0FAAA;APu9JJ;;AsCr3JA;EACE,oEAAA;EACA,gCAAA;EACA,wCAAA;EACA,2EAAA;AtCw3JF;AsCt3JE;E/BxGE,0FAAA;APi+JJ;;AsC/2JA;EACE,wDAAA;EACA,uDAAA;EACA,uDAAA;EACA,gBAAA;AtCk3JF;AsCh3JE;EACE,oCAAA;EACA,uCAAA;AtCk3JJ;;AsC92JA;EACE,wDAAA;EACA,uDAAA;AtCi3JF;;AsC72JA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,4CAAA;E/B1IE,kDAAA;AP2/JJ;;AsC72JA;;;EAGE,WAAA;AtCg3JF;;AsC72JA;;E/B3II,2DAAA;EACA,4DAAA;AP6/JJ;;AsC92JA;;E/BlII,+DAAA;EACA,8DAAA;APq/JJ;;AsCv2JE;EACE,2CAAA;AtC02JJ;Acr+JI;EwBuHJ;IAQI,aAAA;IACA,mBAAA;EtC02JF;EsCv2JE;IAEE,SAAA;IACA,gBAAA;EtCw2JJ;EM3iKE;IAgCE,cAAA;EN8gKJ;EMtiKE;IA+BI,eAAA;EN0gKN;EMjjKE;IAgCE,cAAA;ENohKJ;EM5iKE;IA+BI,eAAA;ENghKN;EMvjKE;IAgCE,0BAAA;EN0hKJ;EMljKE;IA+BI,yBAAA;ENshKN;EM7jKE;IAgCE,6BAAA;ENgiKJ;EMxjKE;IA+BI,4BAAA;EN4hKN;EsCp3JQ;;IAGE,0BAAA;EtCq3JV;EsCn3JQ;;IAGE,6BAAA;EtCo3JV;EM3kKE;IAgCE,yBAAA;EN8iKJ;EMtkKE;IA+BI,0BAAA;EN0iKN;EMjlKE;IAgCE,4BAAA;ENojKJ;EM5kKE;IA+BI,6BAAA;ENgjKN;EsCz3JQ;;IAGE,yBAAA;EtC03JV;EsCx3JQ;;IAGE,4BAAA;EtCy3JV;AACF;;AuC9lKA;EAEE,4CAAA;EACA,sCAAA;EACA,+KAAA;EACA,qDAAA;EACA,qDAAA;EACA,uDAAA;EACA,+FAAA;EACA,sCAAA;EACA,mCAAA;EACA,gDAAA;EACA,+CAAA;EACA,kEAAA;EACA,uCAAA;EACA,mDAAA;EACA,+DAAA;EACA,yEAAA;EACA,+CAAA;EACA,2EAAA;EACA,uCAAA;EACA,oCAAA;EACA,qCAAA;EACA,kCAAA;AvCgmKF;;AuC5lKA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,8EAAA;EpC2PI,eALI;EoCpPR,qCAAA;EACA,gBAAA;EACA,6CAAA;EACA,SAAA;EhCtBE,gBAAA;EgCwBF,qBAAA;EjB3BI,2CiB4BJ;AvC+lKF;AsBvnKM;EiBWN;IjBVQ,gBAAA;EtB0nKN;AACF;AuClmKE;EACE,wCAAA;EACA,gDAAA;EACA,oGAAA;AvComKJ;AuClmKI;EACE,sDAAA;EACA,kDAAA;AvComKN;AuC/lKE;EACE,cAAA;EACA,0CAAA;EACA,2CAAA;EACA,iBAAA;EACA,WAAA;EACA,+CAAA;EACA,4BAAA;EACA,oDAAA;EjBlDE,oDiBmDF;AvCimKJ;AsBhpKM;EiBsCJ;IjBrCM,gBAAA;EtBmpKN;AACF;AuCnmKE;EACE,UAAA;AvCqmKJ;AuClmKE;EACE,UAAA;EACA,yDAAA;EACA,UAAA;EACA,qDAAA;AvComKJ;;AuChmKA;EACE,gBAAA;AvCmmKF;;AuChmKA;EACE,iCAAA;EACA,yCAAA;EACA,iFAAA;AvCmmKF;AuCjmKE;EhC/DE,0DAAA;EACA,2DAAA;APmqKJ;AuClmKI;EhClEA,gEAAA;EACA,iEAAA;APuqKJ;AuCjmKE;EACE,aAAA;AvCmmKJ;AuC/lKE;EhC9DE,8DAAA;EACA,6DAAA;APgqKJ;AuC/lKM;EhClEF,oEAAA;EACA,mEAAA;APoqKJ;AuC9lKI;EhCvEA,8DAAA;EACA,6DAAA;APwqKJ;;AuC5lKA;EACE,gFAAA;AvC+lKF;;AuCtlKE;EACE,eAAA;AvCylKJ;AuCtlKE;EACE,eAAA;EACA,cAAA;EhCpHA,gBAAA;AP6sKJ;AuCtlKI;EAAgB,aAAA;AvCylKpB;AuCxlKI;EAAe,gBAAA;AvC2lKnB;AuCxlKM;EhC3HF,gBAAA;APstKJ;;AwCzuKA;EAEE,6BAAA;EACA,6BAAA;EACA,oCAAA;EAEA,qBAAA;EACA,gCAAA;EACA,0DAAA;EACA,uCAAA;EACA,8DAAA;EAGA,aAAA;EACA,eAAA;EACA,wEAAA;EACA,kDAAA;ErC+QI,0CALI;EqCxQR,gBAAA;EACA,0CAAA;EjCAE,kDAAA;APyuKJ;;AM1vKI;EAgCE,kDAAA;AN8tKN;AMtvKI;EA+BI,mDAAA;AN0tKR;AwCvuKI;EAGE,0CAAA;AxCuuKN;AMpwKI;EAgCE,WAAA;ANuuKN;AM/vKI;EA+BI,YAAA;ANmuKR;AM1wKI;EAgCE,mDAAA;AN6uKN;AMrwKI;EA+BI,kDAAA;ANyuKR;AMhxKI;EAgCE,2CAAA;ANmvKN;AM3wKI;EA4BI,mDAAA;ANkvKR;AwC/uKE;EACE,8CAAA;AxCivKJ;;AyC3xKA;EAEE,mCAAA;EACA,oCAAA;EtC4RI,gCALI;EsCrRR,6CAAA;EACA,uCAAA;EACA,sDAAA;EACA,sDAAA;EACA,wDAAA;EACA,yDAAA;EACA,iDAAA;EACA,4DAAA;EACA,yDAAA;EACA,kDAAA;EACA,wEAAA;EACA,wDAAA;EACA,mCAAA;EACA,6CAAA;EACA,2DAAA;EACA,qDAAA;EACA,+DAAA;EAGA,aAAA;EhCnBA,gBAAA;AT+yKF;AMlzKI;EAgCE,eAAA;ANqxKN;AM7yKI;EA+BI,gBAAA;ANixKR;;AyC9xKA;EACE,kBAAA;EACA,cAAA;EACA,wEAAA;EtCgQI,0CALI;EsCzPR,kCAAA;EACA,qBAAA;EACA,0CAAA;EACA,mFAAA;EnBpBI,qImBqBJ;AzCiyKF;AsBlzKM;EmBQN;InBPQ,gBAAA;EtBqzKN;AACF;AyCpyKE;EACE,UAAA;EACA,wCAAA;EAEA,gDAAA;EACA,sDAAA;AzCqyKJ;AyClyKE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,UpC40CgC;EoC30ChC,kDAAA;AzCoyKJ;AyCjyKE;EAEE,UAAA;EACA,yCAAA;ElBtDF,iDkBuDuB;EACrB,uDAAA;AzCkyKJ;AyC/xKE;EAEE,2CAAA;EACA,oBAAA;EACA,mDAAA;EACA,yDAAA;AzCgyKJ;;AMl2KI;EAgCE,+CAAA;ANs0KN;AM91KI;EA+BI,gDAAA;ANk0KR;AMz2KI;EAgCE,2DAAA;AN40KN;AMp2KI;EA+BI,4DAAA;ANw0KR;AM/2KI;EAgCE,8DAAA;ANk1KN;AM12KI;EA+BI,+DAAA;AN80KR;AMr3KI;EAgCE,4DAAA;ANw1KN;AMh3KI;EA+BI,2DAAA;ANo1KR;AM33KI;EAgCE,+DAAA;AN81KN;AMt3KI;EA+BI,8DAAA;AN01KR;;AyC7xKA;EClGE,kCAAA;EACA,mCAAA;EvC0RI,mCALI;EuCnRR,2DAAA;A1Cm4KF;;AyChyKA;ECtGE,kCAAA;EACA,mCAAA;EvC0RI,oCALI;EuCnRR,2DAAA;A1C04KF;;A2C54KA;EAEE,6BAAA;EACA,6BAAA;ExCuRI,6BALI;EwChRR,4BAAA;EACA,4CAAA;EACA,mDAAA;EAGA,qBAAA;EACA,8DAAA;ExC+QI,qCALI;EwCxQR,yCAAA;EACA,cAAA;EACA,6BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,gDAAA;A3C44KF;A2Cx4KE;EACE,aAAA;A3C04KJ;;A2Cr4KA;EACE,kBAAA;EACA,SAAA;A3Cw4KF;;A2Cj4KA;EACE,4BAAA;EACA,4BAAA;ExCkPI,iBALI;AHwpKV;;A4C96KA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,+BAAA;EACA,0BAAA;EACA,qCAAA;EACA,+EAAA;EACA,mDAAA;EACA,+BAAA;EAGA,kBAAA;EACA,8DAAA;EACA,6CAAA;EACA,6BAAA;EACA,qCAAA;EACA,+BAAA;ErCHE,6CAAA;APk7KJ;;A4C16KA;EAEE,cAAA;A5C46KF;;A4Cx6KA;EACE,gBvC+nB4B;EuC9nB5B,kCAAA;A5C26KF;;AM58KI;EAgCE,mBAAA;ANg7KN;AMx8KI;EA+BI,kBAAA;AN46KR;A4Ct6KE;EACE,kBAAA;EACA,MAAA;EAEA,UAAA;EACA,qBAAA;A5Cu6KJ;AMz9KI;EAgCE,QAAA;AN47KN;AMp9KI;EA+BI,OAAA;ANw7KR;;A4Cr6KE;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;A5Cw6KJ;;A4C56KE;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;A5C+6KJ;;A4Cn7KE;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;A5Cs7KJ;;A4C17KE;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;A5C67KJ;;A4Cj8KE;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;A5Co8KJ;;A4Cx8KE;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;A5C28KJ;;A4C/8KE;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;A5Ck9KJ;;A4Ct9KE;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;A5Cy9KJ;;A6CrhLE;EACE;IAAK,2BxCoqD2B;ELq3HlC;AACF;A6CrhLA;;EAGE,2BAAA;E1CkRI,iCALI;E0C3QR,0CAAA;EACA,sDAAA;EACA,sDAAA;EACA,mDAAA;EACA,yCAAA;EACA,8CAAA;EAGA,aAAA;EACA,kCAAA;EACA,gBAAA;E1CsQI,wCALI;E0C/PR,wCAAA;EtCRE,gDAAA;AP6hLJ;;A6ChhLA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,4CAAA;EvBxBI,8CuByBJ;A7CmhLF;AsBxiLM;EuBYN;IvBXQ,gBAAA;EtB2iLN;AACF;;A6CrhLA;EtBAE,qMAAA;EsBEA,sEAAA;A7CwhLF;;A6CrhLA;EACE,iBAAA;A7CwhLF;;A6CrhLA;EACE,WAAA;A7CwhLF;;A6CphLE;EACE,kDAAA;A7CuhLJ;A6CphLM;EAJJ;IAKM,eAAA;E7CuhLN;AACF;;A6ClhLA;EACE,WAAA;A7CqhLF;;A6CjhLA;EACE,0CAAA;A7CohLF;A6CnhLE;EACE,yBC1EI;A9C+lLR;;A6CjhLA;EACE,aAAA;EACA,mBAAA;EACA,mBxCsXO;AL8pKT;;A6CjhLA;EACE,eAAA;EACA,kBAAA;A7CohLF;;A6CjhLA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBxColDqC;ALg8HvC;;A6CjhLA;EACE,YAAA;EACA,kBAAA;A7CohLF;A6ClhLE;EACE,kBAAA;A7CohLJ;;A6ChhLA;EACE,gBAAA;A7CmhLF;;A+C5nLA;EAEE,6CAAA;EACA,uCAAA;EACA,sDAAA;EACA,sDAAA;EACA,wDAAA;EACA,qCAAA;EACA,uCAAA;EACA,yDAAA;EACA,8DAAA;EACA,wDAAA;EACA,2DAAA;EACA,0DAAA;EACA,2DAAA;EACA,gDAAA;EACA,wDAAA;EACA,mCAAA;EACA,6CAAA;EAGA,aAAA;EACA,sBAAA;EAIA,gBAAA;ExCXE,kDAAA;APqoLJ;AMtpLI;EAgCE,eAAA;ANynLN;AMjpLI;EA+BI,gBAAA;ANqnLR;;A+C5nLA;EACE,qBAAA;EACA,sBAAA;A/C+nLF;A+C7nLE;EAEE,oCAAA;EACA,0BAAA;A/C8nLJ;;A+CrnLA;EACE,WAAA;EACA,yCAAA;EACA,mBAAA;A/CwnLF;A+CrnLE;EAEE,UAAA;EACA,+CAAA;EACA,qBAAA;EACA,uDAAA;A/CsnLJ;A+CnnLE;EACE,gDAAA;EACA,wDAAA;A/CqnLJ;;A+C7mLA;EACE,kBAAA;EACA,cAAA;EACA,kFAAA;EACA,kCAAA;EACA,qBAAA;EACA,0CAAA;EACA,mFAAA;A/CgnLF;A+C9mLE;ExCvDE,+BAAA;EACA,gCAAA;APwqLJ;A+C9mLE;ExC7CE,mCAAA;EACA,kCAAA;AP8pLJ;A+C9mLE;EAEE,2CAAA;EACA,oBAAA;EACA,mDAAA;A/C+mLJ;A+C3mLE;EACE,UAAA;EACA,yCAAA;EACA,iDAAA;EACA,uDAAA;A/C6mLJ;A+CzmLE;EACE,mBAAA;A/C2mLJ;A+CzmLI;EACE,yDAAA;EACA,oDAAA;A/C2mLN;;A+C9lLI;EACE,mBAAA;A/CimLN;AM7tLI;EAgCE,8DAAA;ANgsLN;AMxtLI;EA+BI,+DAAA;AN4rLR;AMnuLI;EAgCE,0BAAA;ANssLN;AM9tLI;EA+BI,yBAAA;ANksLR;AMzuLI;EAgCE,4DAAA;AN4sLN;AMpuLI;EA+BI,2DAAA;ANwsLR;AM/uLI;EAgCE,4BAAA;ANktLN;AM1uLI;EA+BI,6BAAA;AN8sLR;A+C5mLQ;EACE,aAAA;A/C8mLV;A+C3mLQ;EACE,oDAAA;A/C6mLV;AM3vLI;EAgCE,oBAAA;AN8tLN;AMtvLI;EA+BI,qBAAA;AN0tLR;AMjwLI;EAgCE,0DAAA;ANouLN;AM5vLI;EA+BI,2DAAA;ANguLR;AMvwLI;EAgCE,qDAAA;AN0uLN;AMlwLI;EA+BI,sDAAA;ANsuLR;;AchtLI;EiC8DA;IACE,mBAAA;E/CspLJ;EMlxLE;IAgCE,8DAAA;ENqvLJ;EM7wLE;IA+BI,+DAAA;ENivLN;EMxxLE;IAgCE,0BAAA;EN2vLJ;EMnxLE;IA+BI,yBAAA;ENuvLN;EM9xLE;IAgCE,4DAAA;ENiwLJ;EMzxLE;IA+BI,2DAAA;EN6vLN;EMpyLE;IAgCE,4BAAA;ENuwLJ;EM/xLE;IA+BI,6BAAA;ENmwLN;E+CjqLM;IACE,aAAA;E/CmqLR;E+ChqLM;IACE,oDAAA;E/CkqLR;EMhzLE;IAgCE,oBAAA;ENmxLJ;EM3yLE;IA+BI,qBAAA;EN+wLN;EMtzLE;IAgCE,0DAAA;ENyxLJ;EMjzLE;IA+BI,2DAAA;ENqxLN;EM5zLE;IAgCE,qDAAA;EN+xLJ;EMvzLE;IA+BI,sDAAA;EN2xLN;AACF;ActwLI;EiC8DA;IACE,mBAAA;E/C2sLJ;EMv0LE;IAgCE,8DAAA;EN0yLJ;EMl0LE;IA+BI,+DAAA;ENsyLN;EM70LE;IAgCE,0BAAA;ENgzLJ;EMx0LE;IA+BI,yBAAA;EN4yLN;EMn1LE;IAgCE,4DAAA;ENszLJ;EM90LE;IA+BI,2DAAA;ENkzLN;EMz1LE;IAgCE,4BAAA;EN4zLJ;EMp1LE;IA+BI,6BAAA;ENwzLN;E+CttLM;IACE,aAAA;E/CwtLR;E+CrtLM;IACE,oDAAA;E/CutLR;EMr2LE;IAgCE,oBAAA;ENw0LJ;EMh2LE;IA+BI,qBAAA;ENo0LN;EM32LE;IAgCE,0DAAA;EN80LJ;EMt2LE;IA+BI,2DAAA;EN00LN;EMj3LE;IAgCE,qDAAA;ENo1LJ;EM52LE;IA+BI,sDAAA;ENg1LN;AACF;Ac3zLI;EiC8DA;IACE,mBAAA;E/CgwLJ;EM53LE;IAgCE,8DAAA;EN+1LJ;EMv3LE;IA+BI,+DAAA;EN21LN;EMl4LE;IAgCE,0BAAA;ENq2LJ;EM73LE;IA+BI,yBAAA;ENi2LN;EMx4LE;IAgCE,4DAAA;EN22LJ;EMn4LE;IA+BI,2DAAA;ENu2LN;EM94LE;IAgCE,4BAAA;ENi3LJ;EMz4LE;IA+BI,6BAAA;EN62LN;E+C3wLM;IACE,aAAA;E/C6wLR;E+C1wLM;IACE,oDAAA;E/C4wLR;EM15LE;IAgCE,oBAAA;EN63LJ;EMr5LE;IA+BI,qBAAA;ENy3LN;EMh6LE;IAgCE,0DAAA;ENm4LJ;EM35LE;IA+BI,2DAAA;EN+3LN;EMt6LE;IAgCE,qDAAA;ENy4LJ;EMj6LE;IA+BI,sDAAA;ENq4LN;AACF;Ach3LI;EiC8DA;IACE,mBAAA;E/CqzLJ;EMj7LE;IAgCE,8DAAA;ENo5LJ;EM56LE;IA+BI,+DAAA;ENg5LN;EMv7LE;IAgCE,0BAAA;EN05LJ;EMl7LE;IA+BI,yBAAA;ENs5LN;EM77LE;IAgCE,4DAAA;ENg6LJ;EMx7LE;IA+BI,2DAAA;EN45LN;EMn8LE;IAgCE,4BAAA;ENs6LJ;EM97LE;IA+BI,6BAAA;ENk6LN;E+Ch0LM;IACE,aAAA;E/Ck0LR;E+C/zLM;IACE,oDAAA;E/Ci0LR;EM/8LE;IAgCE,oBAAA;ENk7LJ;EM18LE;IA+BI,qBAAA;EN86LN;EMr9LE;IAgCE,0DAAA;ENw7LJ;EMh9LE;IA+BI,2DAAA;ENo7LN;EM39LE;IAgCE,qDAAA;EN87LJ;EMt9LE;IA+BI,sDAAA;EN07LN;AACF;Acr6LI;EiC8DA;IACE,mBAAA;E/C02LJ;EMt+LE;IAgCE,8DAAA;ENy8LJ;EMj+LE;IA+BI,+DAAA;ENq8LN;EM5+LE;IAgCE,0BAAA;EN+8LJ;EMv+LE;IA+BI,yBAAA;EN28LN;EMl/LE;IAgCE,4DAAA;ENq9LJ;EM7+LE;IA+BI,2DAAA;ENi9LN;EMx/LE;IAgCE,4BAAA;EN29LJ;EMn/LE;IA+BI,6BAAA;ENu9LN;E+Cr3LM;IACE,aAAA;E/Cu3LR;E+Cp3LM;IACE,oDAAA;E/Cs3LR;EMpgME;IAgCE,oBAAA;ENu+LJ;EM//LE;IA+BI,qBAAA;ENm+LN;EM1gME;IAgCE,0DAAA;EN6+LJ;EMrgME;IA+BI,2DAAA;ENy+LN;EMhhME;IAgCE,qDAAA;ENm/LJ;EM3gME;IA+BI,sDAAA;EN++LN;AACF;A+Ct3LA;ExChJI,gBAAA;APygMJ;A+Ct3LE;EACE,oDAAA;A/Cw3LJ;A+Ct3LI;EACE,sBAAA;A/Cw3LN;;A+C32LE;EC9KA,mFAAA;EACA,4BAAA;EACA,kCAAA;EACA,gGAAA;EACA,6CAAA;EACA,8FAAA;EACA,wGAAA;AhD6hMF;;A+Cr3LE;EC9KA,qFAAA;EACA,4BAAA;EACA,kCAAA;EACA,kGAAA;EACA,6CAAA;EACA,gGAAA;EACA,0GAAA;AhDuiMF;;A+C/3LE;EC9KA,mFAAA;EACA,4BAAA;EACA,kCAAA;EACA,gGAAA;EACA,6CAAA;EACA,8FAAA;EACA,wGAAA;AhDijMF;;A+Cz4LE;EC9KA,kFAAA;EACA,4BAAA;EACA,kCAAA;EACA,+FAAA;EACA,6CAAA;EACA,6FAAA;EACA,uGAAA;AhD2jMF;;A+Cn5LE;EC9KA,mFAAA;EACA,4BAAA;EACA,kCAAA;EACA,gGAAA;EACA,6CAAA;EACA,8FAAA;EACA,wGAAA;AhDqkMF;;A+C75LE;EC9KA,gFAAA;EACA,4BAAA;EACA,kCAAA;EACA,6FAAA;EACA,6CAAA;EACA,2FAAA;EACA,qGAAA;AhD+kMF;;A+Cv6LE;EC9KA,iFAAA;EACA,4BAAA;EACA,kCAAA;EACA,8FAAA;EACA,6CAAA;EACA,4FAAA;EACA,sGAAA;AhDylMF;;A+Cj7LE;EC9KA,gFAAA;EACA,4BAAA;EACA,kCAAA;EACA,6FAAA;EACA,6CAAA;EACA,2FAAA;EACA,qGAAA;AhDmmMF;;AiD7mMA;EAEE,6CAAA;EACA,4DAAA;EACA,4BAAA;EACA,mCAAA;EACA,mEAAA;EACA,gCAAA;EACA,sCAAA;EACA,wEAAA;EAGA,uBAAA;EACA,U5C+8D2B;E4C98D3B,W5C88D2B;E4C78D3B,sBAAA;EACA,iCAAA;EACA,yEAAA;EACA,SAAA;E1CJE,uBAAA;E0CMF,qCAAA;AjD6mMF;AiD1mME;EACE,iCAAA;EACA,qBAAA;EACA,2CAAA;AjD4mMJ;AiDzmME;EACE,UAAA;EACA,6CAAA;EACA,2CAAA;AjD2mMJ;AiDxmME;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,8CAAA;AjDymMJ;;AiDrmMA;EACE,yCAAA;AjDwmMF;;AkDzpMA;EAEE,wBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;E/CyRI,+BALI;E+ClRR,mBAAA;EACA,kDAAA;EACA,iDAAA;EACA,6DAAA;EACA,mDAAA;EACA,6CAAA;EACA,oDAAA;EACA,yDAAA;EACA,oEAAA;EAGA,iCAAA;EACA,eAAA;E/C2QI,qCALI;E+CpQR,6BAAA;EACA,oBAAA;EACA,qCAAA;EACA,4BAAA;EACA,yEAAA;EACA,uCAAA;E3CRE,6CAAA;APkqMJ;AkDvpME;EACE,UAAA;AlDypMJ;AkDtpME;EACE,aAAA;AlDwpMJ;;AkDppMA;EACE,wBAAA;EAEA,kBAAA;EACA,gCAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AlDspMF;AkDppME;EACE,uCAAA;AlDspMJ;;AkDlpMA;EACE,aAAA;EACA,mBAAA;EACA,8DAAA;EACA,oCAAA;EACA,4CAAA;EACA,4BAAA;EACA,uFAAA;E3ChCE,4FAAA;EACA,6FAAA;APsrMJ;AMjtMI;EAgCE,qDAAA;ANorMN;AM5sMI;EA+BI,oDAAA;ANgrMR;AMvtMI;EAgCE,uCAAA;AN0rMN;AMltMI;EA+BI,wCAAA;ANsrMR;;AkD1pMA;EACE,mCAAA;EACA,qBAAA;AlD6pMF;;AmD3tMA;EAEE,wBAAA;EACA,wBAAA;EACA,yBAAA;EACA,0BAAA;EACA,mBAAA;EACA,kCAAA;EACA,6DAAA;EACA,iDAAA;EACA,sDAAA;EACA,kEAAA;EACA,8FAAA;EACA,kCAAA;EACA,kCAAA;EACA,qCAAA;EACA,wDAAA;EACA,wDAAA;EACA,kCAAA;EACA,8BAAA;EACA,uBAAA;EACA,wDAAA;EACA,wDAAA;EAGA,eAAA;EACA,MAAA;EAEA,gCAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AnDwtMF;AMnwMI;EAgCE,OAAA;ANsuMN;AM9vMI;EA+BI,QAAA;ANkuMR;;AmDvtMA;EACE,kBAAA;EACA,WAAA;EACA,+BAAA;EAEA,oBAAA;AnDytMF;AmDttME;E7B5CI,mC6B6CF;EACA,8B9CmiDgC;ALqrJpC;AsBlwMM;E6BwCJ;I7BvCM,gBAAA;EtBqwMN;AACF;AmD3tME;EACE,e9CiiDgC;AL4rJpC;AmDztME;EACE,sB9C8hDgC;AL6rJpC;;AmDvtMA;EACE,gDAAA;AnD0tMF;AmDxtME;EACE,gBAAA;EACA,gBAAA;AnD0tMJ;AmDvtME;EACE,gBAAA;AnDytMJ;;AmDrtMA;EACE,aAAA;EACA,mBAAA;EACA,oDAAA;AnDwtMF;;AmDptMA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,6BAAA;EACA,oBAAA;EACA,qCAAA;EACA,4BAAA;EACA,yEAAA;E5CrFE,6CAAA;E4CyFF,UAAA;AnDotMF;;AmDhtMA;EAEE,2BAAA;EACA,0BAAA;EACA,2BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,mCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,wCD+G4D;AnDstM9D;AoDl0ME;EAAS,UAAA;ApDq0MX;AoDp0ME;EAAS,oCD2GiF;AnD4tM5F;;AmDvtMA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,wCAAA;EACA,8FAAA;E5CtGE,4DAAA;EACA,6DAAA;APi0MJ;AmDztME;EACE,oGAAA;AnD2tMJ;AM/1MI;EA+DE,yJAAA;ANmyMN;AM11MI;EA2DI,yJAAA;ANkyMR;;AmD3tMA;EACE,gBAAA;EACA,+CAAA;AnD8tMF;;AmDztMA;EACE,kBAAA;EAGA,cAAA;EACA,iCAAA;AnD0tMF;;AmDttMA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,2EAAA;EACA,4CAAA;EACA,2FAAA;E5C1HE,gEAAA;EACA,+DAAA;APo1MJ;AmDrtME;EACE,+CAAA;AnDutMJ;;Acn0MI;EqCkHF;IACE,2BAAA;IACA,4DAAA;EnDqtMF;EmDjtMA;IACE,iCAAA;IACA,kBAAA;IACA,iBAAA;EnDmtMF;EmDhtMA;IACE,wBAAA;EnDktMF;AACF;Acl1MI;EqCoIF;;IAEE,wBAAA;EnDitMF;AACF;Acx1MI;EqC2IF;IACE,yBAAA;EnDgtMF;AACF;AmDvsMI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AnDysMN;AmDvsMM;EACE,YAAA;EACA,SAAA;E5C1MJ,gBAAA;APo5MJ;AmDtsMM;;E5C9MF,gBAAA;APw5MJ;AmDrsMM;EACE,gBAAA;AnDusMR;;Acl2MI;EqCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnD6tMJ;EmD3tMI;IACE,YAAA;IACA,SAAA;I5C1MJ,gBAAA;EPw6MF;EmD1tMI;;I5C9MF,gBAAA;EP46MF;EmDztMI;IACE,gBAAA;EnD2tMN;AACF;Acv3MI;EqCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnDivMJ;EmD/uMI;IACE,YAAA;IACA,SAAA;I5C1MJ,gBAAA;EP47MF;EmD9uMI;;I5C9MF,gBAAA;EPg8MF;EmD7uMI;IACE,gBAAA;EnD+uMN;AACF;Ac34MI;EqCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnDqwMJ;EmDnwMI;IACE,YAAA;IACA,SAAA;I5C1MJ,gBAAA;EPg9MF;EmDlwMI;;I5C9MF,gBAAA;EPo9MF;EmDjwMI;IACE,gBAAA;EnDmwMN;AACF;Ac/5MI;EqCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnDyxMJ;EmDvxMI;IACE,YAAA;IACA,SAAA;I5C1MJ,gBAAA;EPo+MF;EmDtxMI;;I5C9MF,gBAAA;EPw+MF;EmDrxMI;IACE,gBAAA;EnDuxMN;AACF;Acn7MI;EqCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnD6yMJ;EmD3yMI;IACE,YAAA;IACA,SAAA;I5C1MJ,gBAAA;EPw/MF;EmD1yMI;;I5C9MF,gBAAA;EP4/MF;EmDzyMI;IACE,gBAAA;EnD2yMN;AACF;AqDlhNA;EAEE,0BAAA;EACA,8BAAA;EACA,+BAAA;EACA,gCAAA;EACA,sBAAA;ElDwRI,iCALI;EkDjRR,uCAAA;EACA,2CAAA;EACA,qDAAA;EACA,0BAAA;EACA,iCAAA;EACA,kCAAA;EAGA,kCAAA;EACA,cAAA;EACA,iCAAA;EClBA,uCjDipB4B;EiD/oB5B,kBAAA;EACA,gBjD0pB4B;EiDzpB5B,gBjDiqB4B;EiDhqB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EnDgRI,uCALI;EkDhQR,qBAAA;EACA,UAAA;ArD0hNF;AqDxhNE;EAAS,mCAAA;ArD2hNX;AqDzhNE;EACE,cAAA;EACA,qCAAA;EACA,uCAAA;ArD2hNJ;AqDzhNI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ArD2hNN;;AqDthNA;EACE,kDAAA;ArDyhNF;AqDvhNE;EACE,SAAA;EACA,0FAAA;EACA,uCAAA;ArDyhNJ;;AqDrhNA,qBAAA;AACA;EACE,gDAAA;EACA,sCAAA;EACA,sCAAA;ArDwhNF;AqDthNE;EACE,WAAA;EACA,qIAAA;EACA,yCAAA;ArDwhNJ;;AqDphNA,mBAAA;AAEA;EACE,+CAAA;ArDshNF;AqDphNE;EACE,YAAA;EACA,0FAAA;EACA,0CAAA;ArDshNJ;;AqDlhNA,qBAAA;AACA;EACE,iDAAA;EACA,sCAAA;EACA,sCAAA;ArDqhNF;AqDnhNE;EACE,UAAA;EACA,qIAAA;EACA,wCAAA;ArDqhNJ;;AqDjhNA,mBAAA;AAkBA;EACE,uCAAA;EACA,kEAAA;EACA,+BAAA;EACA,kBAAA;EACA,uCAAA;E9CjGE,+CAAA;APqmNJ;;AuDxnNA;EAEE,0BAAA;EACA,8BAAA;EpD4RI,iCALI;EoDrRR,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,wDAAA;EACA,8FAAA;EACA,8DAAA;EACA,oCAAA;EACA,sCAAA;EpDmRI,oCALI;EoD5QR,mCAAA;EACA,gDAAA;EACA,kCAAA;EACA,kCAAA;EACA,+CAAA;EACA,+BAAA;EACA,kCAAA;EACA,2DAAA;EAGA,kCAAA;EACA,cAAA;EACA,uCAAA;EDzBA,uCjDipB4B;EiD/oB5B,kBAAA;EACA,gBjD0pB4B;EiDzpB5B,gBjDiqB4B;EiDhqB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EnDgRI,uCALI;EoD1PR,qBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;EhDhBE,+CAAA;APmpNJ;AuD/nNE;EACE,cAAA;EACA,qCAAA;EACA,uCAAA;AvDioNJ;AuD/nNI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AvDgoNN;;AuD1nNE;EACE,sFAAA;AvD6nNJ;AuD3nNI;EAEE,0FAAA;AvD4nNN;AuDznNI;EACE,SAAA;EACA,iDAAA;AvD2nNN;AuDxnNI;EACE,uCAAA;EACA,uCAAA;AvD0nNN;;AuDrnNA,qBAAA;AAEE;EACE,oFAAA;EACA,sCAAA;EACA,sCAAA;AvDunNJ;AuDrnNI;EAEE,qIAAA;AvDsnNN;AuDnnNI;EACE,OAAA;EACA,mDAAA;AvDqnNN;AuDlnNI;EACE,qCAAA;EACA,yCAAA;AvDonNN;;AuD/mNA,mBAAA;AAGE;EACE,mFAAA;AvDgnNJ;AuD9mNI;EAEE,0FAAA;AvD+mNN;AuD5mNI;EACE,MAAA;EACA,oDAAA;AvD8mNN;AuD3mNI;EACE,oCAAA;EACA,0CAAA;AvD6mNN;AuDxmNE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,qCAAA;EACA,wDAAA;EACA,WAAA;EACA,iFAAA;AvD0mNJ;;AuDtmNA,qBAAA;AAEE;EACE,qFAAA;EACA,sCAAA;EACA,sCAAA;AvDwmNJ;AuDtmNI;EAEE,qIAAA;AvDumNN;AuDpmNI;EACE,QAAA;EACA,kDAAA;AvDsmNN;AuDnmNI;EACE,sCAAA;EACA,wCAAA;AvDqmNN;;AuDhmNA,mBAAA;AAkBA;EACE,gFAAA;EACA,gBAAA;EpD2GI,8CALI;EoDpGR,sCAAA;EACA,8CAAA;EACA,oFAAA;EhD5JE,8DAAA;EACA,+DAAA;AP+uNJ;AuDjlNE;EACE,aAAA;AvDmlNJ;;AuD/kNA;EACE,4EAAA;EACA,oCAAA;AvDklNF;;AwDvwNA;EACE,kBAAA;AxD0wNF;;AwDvwNA;EACE,mBAAA;AxD0wNF;;AwDvwNA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AxD0wNF;AyDhyNE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AzDkyNJ;;AwD3wNA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;ElClBI,sCkCmBJ;AxD8wNF;AsB7xNM;EkCQN;IlCPQ,gBAAA;EtBgyNN;AACF;;AwDhxNA;;;EAGE,cAAA;AxDmxNF;;AwDhxNA;;EAEE,2BAAA;AxDmxNF;;AwDhxNA;;EAEE,4BAAA;AxDmxNF;;AwD1wNE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AxD6wNJ;AwD1wNE;;;EAGE,UAAA;EACA,UAAA;AxD4wNJ;AwDzwNE;;EAEE,UAAA;EACA,UAAA;ElC5DE,2BkC6DF;AxD2wNJ;AsBp0NM;EkCqDJ;;IlCpDM,gBAAA;EtBw0NN;AACF;;AwDxwNA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UnDsuDmC;EmDruDnC,UAAA;EACA,mEAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YnDiuDmC;EiBvzD/B,8BkCuFJ;AxD0wNF;AsB71NM;EkCkEN;;IlCjEQ,gBAAA;EtBi2NN;AACF;AwD7wNE;;;EAEE,mEAAA;EACA,qBAAA;EACA,UAAA;EACA,YnDytDiC;ALujKrC;;AwD7wNA;EACE,OAAA;AxDgxNF;;AwD7wNA;EACE,QAAA;AxDgxNF;;AwD3wNA;;EAEE,qBAAA;EACA,WnD0tDmC;EmDztDnC,YnDytDmC;EmDxtDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AxD8wNF;;AwD3wNA;;;;;;;GAAA;AAQA;EACE,0DAAA;AxD8wNF;;AwD5wNA;EACE,0DAAA;AxD+wNF;;AwDvwNA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBnDkqDmC;EmDjqDnC,mBAAA;EACA,gBnDgqDmC;EmD/pDnC,gBAAA;AxDywNF;AwDvwNE;EACE,uBAAA;EACA,cAAA;EACA,WnD+pDiC;EmD9pDjC,WnD+pDiC;EmD9pDjC,UAAA;EACA,iBnD+pDiC;EmD9pDjC,gBnD8pDiC;EmD7pDjC,mBAAA;EACA,eAAA;EACA,kEAAA;EACA,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YnDspDiC;EiB/zD/B,6BkC0KF;AxDwwNJ;AsB96NM;EkCqJJ;IlCpJM,gBAAA;EtBi7NN;AACF;AwD1wNE;EACE,UnDmpDiC;ALynKrC;;AwDnwNA;EACE,kBAAA;EACA,UAAA;EACA,enD6oDmC;EmD5oDnC,SAAA;EACA,oBnD0oDmC;EmDzoDnC,uBnDyoDmC;EmDxoDnC,mEAAA;EACA,kBAAA;AxDswNF;;AwDjwNA;EACE,2CAAA;EACA,oDAAA;AxDowNF;AwDnwNE;;EAEE,gCnD4oDiC;ALynKrC;AwDlwNE;EACE,yBVzNI;A9C69NR;AwDjwNE;EACE,6BnD3LuB;AL87N3B;;A0Dh+NA;;EAEE,qBAAA;EACA,+BAAA;EACA,iCAAA;EACA,iDAAA;EAEA,kBAAA;EACA,+FAAA;A1Dk+NF;;A0D99NA;EACE;IAAK,0CAAA;E1Dk+NL;AACF;A0D/9NA;EAEE,yBAAA;EACA,0BAAA;EACA,sCAAA;EACA,kCAAA;EACA,oCAAA;EACA,4CAAA;EAGA,0DAAA;EACA,+BAAA;A1D89NF;;A0D39NA;EAEE,yBAAA;EACA,0BAAA;EACA,iCAAA;A1D69NF;;A0Dp9NA;EACE;IACE,mBAAA;E1Du9NF;E0Dr9NA;IACE,UAAA;IACA,eAAA;E1Du9NF;AACF;A0Dn9NA;EAEE,yBAAA;EACA,0BAAA;EACA,sCAAA;EACA,oCAAA;EACA,0CAAA;EAGA,8BAAA;EACA,UAAA;A1Dk9NF;;A0D/8NA;EACE,yBAAA;EACA,0BAAA;A1Dk9NF;;A0D98NE;EACE;;IAEE,mCAAA;E1Di9NJ;AACF;A2DjiOA;EAEE,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,+BAAA;EACA,+BAAA;EACA,4CAAA;EACA,sCAAA;EACA,qDAAA;EACA,iEAAA;EACA,sEAAA;EACA,sDAAA;EACA,sCAAA;A3DkiOF;;Acr+NI;E6C5CF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IrC5BA,2CqC8BA;E3DmhOJ;AACF;AsB9iOM;EqCYJ;IrCXM,gBAAA;EtBijON;AACF;Ac3/NI;E6C5BE;IACE,MAAA;IAEA,iCAAA;E3DyhON;EM1kOE;IAgCE,OAAA;EN6iOJ;EMrkOE;IA+BI,QAAA;ENyiON;EMhlOE;IAgCE,uFAAA;ENmjOJ;EM3kOE;IA+BI,sFAAA;EN+iON;EMtlOE;IA+DE,4BAAA;EN0hOJ;EMjlOE;IA2DI,2BAAA;ENyhON;E2DtiOI;IACE,MAAA;IAEA,iCAAA;IAEA,2BAAA;E3DsiON;EMjmOE;IAgCE,QAAA;ENokOJ;EM5lOE;IA+BI,OAAA;ENgkON;EMvmOE;IAgCE,sFAAA;EN0kOJ;EMlmOE;IA+BI,uFAAA;ENskON;E2D/iOI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E3DijON;E2D9iOI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E3DgjON;E2D7iOI;IAEE,0BAAA;E3D8iON;E2D3iOI;IAGE,mBAAA;E3D2iON;AACF;AcxkOI;E6C/BF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E3D0iON;E2DxiOM;IACE,aAAA;E3D0iOR;E2DviOM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3DwiOR;AACF;;Ac5kOI;E6C5CF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IrC5BA,2CqC8BA;E3D0nOJ;AACF;AsBrpOM;EqCYJ;IrCXM,gBAAA;EtBwpON;AACF;AclmOI;E6C5BE;IACE,MAAA;IAEA,iCAAA;E3DgoON;EMjrOE;IAgCE,OAAA;ENopOJ;EM5qOE;IA+BI,QAAA;ENgpON;EMvrOE;IAgCE,uFAAA;EN0pOJ;EMlrOE;IA+BI,sFAAA;ENspON;EM7rOE;IA+DE,4BAAA;ENioOJ;EMxrOE;IA2DI,2BAAA;ENgoON;E2D7oOI;IACE,MAAA;IAEA,iCAAA;IAEA,2BAAA;E3D6oON;EMxsOE;IAgCE,QAAA;EN2qOJ;EMnsOE;IA+BI,OAAA;ENuqON;EM9sOE;IAgCE,sFAAA;ENirOJ;EMzsOE;IA+BI,uFAAA;EN6qON;E2DtpOI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E3DwpON;E2DrpOI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E3DupON;E2DppOI;IAEE,0BAAA;E3DqpON;E2DlpOI;IAGE,mBAAA;E3DkpON;AACF;Ac/qOI;E6C/BF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E3DipON;E2D/oOM;IACE,aAAA;E3DipOR;E2D9oOM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3D+oOR;AACF;;AcnrOI;E6C5CF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IrC5BA,2CqC8BA;E3DiuOJ;AACF;AsB5vOM;EqCYJ;IrCXM,gBAAA;EtB+vON;AACF;AczsOI;E6C5BE;IACE,MAAA;IAEA,iCAAA;E3DuuON;EMxxOE;IAgCE,OAAA;EN2vOJ;EMnxOE;IA+BI,QAAA;ENuvON;EM9xOE;IAgCE,uFAAA;ENiwOJ;EMzxOE;IA+BI,sFAAA;EN6vON;EMpyOE;IA+DE,4BAAA;ENwuOJ;EM/xOE;IA2DI,2BAAA;ENuuON;E2DpvOI;IACE,MAAA;IAEA,iCAAA;IAEA,2BAAA;E3DovON;EM/yOE;IAgCE,QAAA;ENkxOJ;EM1yOE;IA+BI,OAAA;EN8wON;EMrzOE;IAgCE,sFAAA;ENwxOJ;EMhzOE;IA+BI,uFAAA;ENoxON;E2D7vOI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E3D+vON;E2D5vOI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E3D8vON;E2D3vOI;IAEE,0BAAA;E3D4vON;E2DzvOI;IAGE,mBAAA;E3DyvON;AACF;ActxOI;E6C/BF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E3DwvON;E2DtvOM;IACE,aAAA;E3DwvOR;E2DrvOM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3DsvOR;AACF;;Ac1xOI;E6C5CF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IrC5BA,2CqC8BA;E3Dw0OJ;AACF;AsBn2OM;EqCYJ;IrCXM,gBAAA;EtBs2ON;AACF;AchzOI;E6C5BE;IACE,MAAA;IAEA,iCAAA;E3D80ON;EM/3OE;IAgCE,OAAA;ENk2OJ;EM13OE;IA+BI,QAAA;EN81ON;EMr4OE;IAgCE,uFAAA;ENw2OJ;EMh4OE;IA+BI,sFAAA;ENo2ON;EM34OE;IA+DE,4BAAA;EN+0OJ;EMt4OE;IA2DI,2BAAA;EN80ON;E2D31OI;IACE,MAAA;IAEA,iCAAA;IAEA,2BAAA;E3D21ON;EMt5OE;IAgCE,QAAA;ENy3OJ;EMj5OE;IA+BI,OAAA;ENq3ON;EM55OE;IAgCE,sFAAA;EN+3OJ;EMv5OE;IA+BI,uFAAA;EN23ON;E2Dp2OI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E3Ds2ON;E2Dn2OI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E3Dq2ON;E2Dl2OI;IAEE,0BAAA;E3Dm2ON;E2Dh2OI;IAGE,mBAAA;E3Dg2ON;AACF;Ac73OI;E6C/BF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E3D+1ON;E2D71OM;IACE,aAAA;E3D+1OR;E2D51OM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3D61OR;AACF;;Acj4OI;E6C5CF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IrC5BA,2CqC8BA;E3D+6OJ;AACF;AsB18OM;EqCYJ;IrCXM,gBAAA;EtB68ON;AACF;Acv5OI;E6C5BE;IACE,MAAA;IAEA,iCAAA;E3Dq7ON;EMt+OE;IAgCE,OAAA;ENy8OJ;EMj+OE;IA+BI,QAAA;ENq8ON;EM5+OE;IAgCE,uFAAA;EN+8OJ;EMv+OE;IA+BI,sFAAA;EN28ON;EMl/OE;IA+DE,4BAAA;ENs7OJ;EM7+OE;IA2DI,2BAAA;ENq7ON;E2Dl8OI;IACE,MAAA;IAEA,iCAAA;IAEA,2BAAA;E3Dk8ON;EM7/OE;IAgCE,QAAA;ENg+OJ;EMx/OE;IA+BI,OAAA;EN49ON;EMngPE;IAgCE,sFAAA;ENs+OJ;EM9/OE;IA+BI,uFAAA;ENk+ON;E2D38OI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E3D68ON;E2D18OI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E3D48ON;E2Dz8OI;IAEE,0BAAA;E3D08ON;E2Dv8OI;IAGE,mBAAA;E3Du8ON;AACF;Acp+OI;E6C/BF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E3Ds8ON;E2Dp8OM;IACE,aAAA;E3Ds8OR;E2Dn8OM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3Do8OR;AACF;;A2DphPE;EAEI,eAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,iCAAA;EACA,kBAAA;EACA,yCAAA;EACA,4BAAA;EACA,UAAA;ErC5BA,2CqC8BA;A3DqhPN;AsB/iPM;EqCYJ;IrCXM,gBAAA;EtBkjPN;AACF;A2DxhPM;EACE,MAAA;EAEA,iCAAA;A3DyhPR;AM1kPI;EAgCE,OAAA;AN6iPN;AMrkPI;EA+BI,QAAA;ANyiPR;AMhlPI;EAgCE,uFAAA;ANmjPN;AM3kPI;EA+BI,sFAAA;AN+iPR;AMtlPI;EA+DE,4BAAA;AN0hPN;AMjlPI;EA2DI,2BAAA;ANyhPR;A2DtiPM;EACE,MAAA;EAEA,iCAAA;EAEA,2BAAA;A3DsiPR;AMjmPI;EAgCE,QAAA;ANokPN;AM5lPI;EA+BI,OAAA;ANgkPR;AMvmPI;EAgCE,sFAAA;AN0kPN;AMlmPI;EA+BI,uFAAA;ANskPR;A2D/iPM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,mCAAA;EACA,gBAAA;EACA,wFAAA;EACA,4BAAA;A3DijPR;A2D9iPM;EACE,QAAA;EACA,OAAA;EACA,mCAAA;EACA,gBAAA;EACA,qFAAA;EACA,2BAAA;A3DgjPR;A2D7iPM;EAEE,0BAAA;A3D8iPR;A2D3iPM;EAGE,mBAAA;A3D2iPR;;A2DhhPA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a/CgtCkC;E+C/sClC,YAAA;EACA,aAAA;EACA,2DO+GsD;A3DyhPxD;AoDroPE;EAAS,UAAA;ApDwoPX;AoDvoPE;EAAS,Y/CokDyB;ALskMpC;;A2D5hPA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sEAAA;A3D+hPF;A2D7hPE;EACE,8FAAA;EACA,uDAAA;EAEA,0DAAA;A3D8hPJ;AMhqPI;EAgCE,yDAAA;ANmoPN;AM3pPI;EA+BI,wDAAA;AN+nPR;;A2DhiPA;EACE,gBAAA;EACA,mDAAA;A3DmiPF;;A2DhiPA;EACE,YAAA;EACA,sEAAA;EACA,gBAAA;A3DmiPF;;A4DnrPA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YvDi5CkC;ALqyMpC;A4DprPE;EACE,qBAAA;EACA,WAAA;A5DsrPJ;;A4DjrPA;EACE,iBAAA;A5DorPF;;A4DjrPA;EACE,iBAAA;A5DorPF;;A4DjrPA;EACE,iBAAA;A5DorPF;;A4D/qPE;EACE,mDAAA;A5DkrPJ;;A4D9qPA;EACE;IACE,YvDo3CgC;EL6zMlC;AACF;A4D9qPA;EACE,6FAAA;UAAA,qFAAA;EACA,4BAAA;UAAA,oBAAA;EACA,8CAAA;A5DgrPF;;A4D7qPA;EACE;IACE,+BAAA;YAAA,uBAAA;E5DgrPF;AACF;A6DjuPA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EtDcE,mBAAA;EeHE,wBuCTJ;ECNA,WzDymDc;EyDxmDd,YzDwmDc;EyDvmDd,iBAAA;A9D0uPF;AsBztPM;EuCpBN;IvCqBQ,gBAAA;EtB4tPN;AACF;A8D7uPE;EACE,sBAAA;EACA,uBAAA;A9D+uPJ;;A6D3uPA;EACE,WAAA;EACA,YAAA;EtDME,mBAAA;APyuPJ;;A6D3uPA;EACE,kBAAA;EAEA,SAAA;EACA,cAAA;EACA,yBAAA;EtDHE,mBAAA;APivPJ;AMlwPI;EAgCE,QAAA;ANquPN;AM7vPI;EA+BI,OAAA;ANiuPR;;A6D/uPE;EC1BA,azD2mDc;EyD1mDd,czD0mDc;EyDzmDd,iBAAA;A9D6wPF;A8D3wPE;EACE,aAAA;EACA,cAAA;A9D6wPJ;;A6DzvPE;EC1BA,azD2mDc;EyD1mDd,czD0mDc;EyDzmDd,eAAA;A9DuxPF;A8DrxPE;EACE,sBAAA;EACA,uBAAA;A9DuxPJ;;A6DnwPE;EC1BA,WzD2mDc;EyD1mDd,YzD0mDc;EyDzmDd,iBAAA;A9DiyPF;A8D/xPE;EACE,aAAA;EACA,cAAA;A9DiyPJ;;A6D7wPE;EC1BA,WzD2mDc;EyD1mDd,YzD0mDc;EyDzmDd,iBAAA;A9D2yPF;A8DzyPE;EACE,sBAAA;EACA,uBAAA;A9D2yPJ;;A6DlxPA;EACE,aAAA;A7DqxPF;AMpzPI;EAgCE,qBAAA;ANuxPN;AM/yPI;EA+BI,oBAAA;ANmxPR;AM1zPI;EAgCE,eAAA;AN6xPN;AMrzPI;EA+BI,cAAA;ANyxPR;AMh0PI;EAgCE,qBAAA;ANmyPN;AM3zPI;EA+BI,oBAAA;AN+xPR;AMt0PI;EAgCE,mBAAA;ANyyPN;AMj0PI;EA+BI,kBAAA;ANqyPR;AM50PI;EAgCE,qBAAA;AN+yPN;AMv0PI;EA+BI,oBAAA;AN2yPR;AMl1PI;EAgCE,qBAAA;ANqzPN;AM70PI;EA+BI,oBAAA;ANizPR;;A+D11PA;EAEE,6BAAA;EACA,6BAAA;EACA,yBAAA;EACA,4BAAA;EACA,mDAAA;EACA,mDAAA;EACA,kEAAA;EACA,qDAAA;EAGA,kEAAA;EACA,+DAAA;EACA,6EAAA;ExDKE,+CAAA;APs1PJ;AMv2PI;EAgCE,uDAAA;AN00PN;AMl2PI;EA+BI,yDAAA;ANs0PR;AM72PI;EAgCE,uDAAA;ANg1PN;AMx2PI;EA+BI,yDAAA;AN40PR;;A+D91PE;EACE,wCAAA;A/Di2PJ;;A+Dl2PE;EACE,wCAAA;A/Dq2PJ;;A+Dt2PE;EACE,wCAAA;A/Dy2PJ;;A+D12PE;EACE,wCAAA;A/D62PJ;;A+D92PE;EACE,wCAAA;A/Di3PJ;;A+Dl3PE;EACE,qCAAA;A/Dq3PJ;;A+Dt3PE;EACE,wCAAA;A/Dy3PJ;;A+D13PE;EACE,wCAAA;A/D63PJ;;AgEr5PA;EAEE,6BAAA;EACA,4BAAA;EACA,8BAAA;EACA,yCAAA;EACA,uCAAA;EACA,kDAAA;EACA,iFAAA;EAGA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,wCAAA;EACA,gEAAA;EACA,8BAAA;EACA,gCAAA;EACA,oCAAA;AhEq5PF;;AgEl5PA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a3DwrCkC;AL6tNpC;;AgEl5PA;EACE,gBAAA;EACA,SAAA;EACA,a3DkrCkC;ALmuNpC;;AiEt7PA;EAEE,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,mCAAA;EACA,6DAAA;EACA,kDAAA;EACA,iFAAA;EACA,kEAAA;EACA,qEAAA;EACA,iEAAA;EACA,uCAAA;EACA,iCAAA;EACA,uCAAA;EACA,uCAAA;EACA,uCAAA;EACA,oCAAA;EACA,qEAAA;EACA,4DAAA;EACA,wEAAA;EACA,sEAAA;EACA,4EAAA;EACA,uCAAA;EACA,uCAAA;EACA,0DAAA;EACA,iGAAA;EACA,gCAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,wCAAA;EACA,gEAAA;EACA,gCAAA;EACA,uCAAA;AjEs7PF;AiEj7PE;;;;;;;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AjE+7PJ;AiEj7PE;;;;;;;EAEE,gFAAA;AjEw7PJ;AiEr7PE;;;;;;;EAEE,mFAAA;AjE47PJ;AiEz7PE;EACE,gBAAA;EACA,MAAA;EACA,aAAA;AjE27PJ;;AiEv7PA;EACE,wDAAA;EACA,SAAA;EACA,0EAAA;EACA,4CAAA;AjE07PF;;AiEn7PA;EACE,8CAAA;EACA,iDAAA;E9DoMI,kBALI;E8D5LR,oCAAA;EACA,qBAAA;EACA,mBAAA;AjEq7PF;AMnhQI;EAgCE,kBAAA;ANs/PN;AM9gQI;EA+BI,iBAAA;ANk/PR;AiEz7PE;EAEE,0CAAA;AjE07PJ;;AiEj7PA;EACE,aAAA;EACA,mBAAA;EAEA,gBAAA;EACA,gBAAA;AjEm7PF;AMniQI;EAgCE,eAAA;ANsgQN;AM9hQI;EA+BI,gBAAA;ANkgQR;AiEv7PE;EACE,kFAAA;EACA,8BAAA;AjEy7PJ;AiEv7PI;EAEE,oCAAA;AjEw7PN;AiEr7PI;EACE,uCAAA;AjEu7PN;AiEn7PE;;EAEE,qCAAA;AjEq7PJ;AiEl7PE;EACE,kBAAA;AjEo7PJ;;AiE36PA;EACE,iDAAA;EACA,oDAAA;EACA,8BAAA;AjE86PF;AiE56PE;EACE,qCAAA;AjE86PJ;AiE56PI;EAEE,qCAAA;AjE66PN;;AiEx6PA;EACE,gFAAA;E9D8HI,kBALI;E8DvHR,sCAAA;EACA,8CAAA;EACA,SAAA;E1DlJE,sDAAA;AP8jQJ;AiEz6PE;EACE,4CAAA;EACA,qBAAA;AjE26PJ;AiEx6PE;EACE,UAAA;AjE06PJ;AiEt6PE;EACE,eAAA;AjEw6PJ;;AiEp6PA;EACE,cAAA;EACA,iBAAA;EACA,mDAAA;EACA,4BAAA;EACA,kCAAA;EACA,0BAAA;AjEu6PF;AiEr6PE;EACE,yDAAA;AjEu6PJ;;AkEvmQA;EACE,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AlE0mQF;AkEzmQE;ECJA,W9D4wBgB;E8D3wBhB,Y9D2wBgB;E8D1wBhB,e9D0wBgB;ALs2OlB;AkE3mQI;ECPF,W9DgxBgB;E8D/wBhB,Y9D+wBgB;E8D9wBhB,e9D8wBgB;ALu2OlB;AkE5mQI;ECXF,a9D+wBgB;E8D9wBhB,c9D8wBgB;E8D7wBhB,iB9D6wBgB;AL62OlB;AkE7mQI;ECfF,c9D8wBgB;E8D7wBhB,e9D6wBgB;E8D5wBhB,kB9D4wBgB;ALm3OlB;AkE9mQI;ECnBF,e9D6wBgB;E8D5wBhB,gB9D4wBgB;E8D3wBhB,mB9D2wBgB;ALy3OlB;AkE9mQM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;AlEknQ3B;AkEnnQM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;AlEunQ3B;AkExnQM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;AlE4nQ3B;AkE7nQM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;AlEioQ3B;AkEloQM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;AlEsoQ3B;AkEvoQM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;AlE2oQ3B;AkE5oQM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;AlEgpQ3B;;AoE3qQA;EAEE,0BAAA;EACA,yBAAA;EACA,0BAAA;EACA,0BAAA;EACA,8CAAA;EACA,6BAAA;EACA,uCAAA;EACA,oDAAA;EACA,gCAAA;EACA,6CAAA;EACA,iCAAA;EACA,8CAAA;EACA,oCAAA;EACA,uCAAA;EACA,8CAAA;EACA,iCAAA;EACA,oCAAA;EACA,uCAAA;EACA,+CAAA;EACA,kCAAA;EACA,yEAAA;EACA,2CAAA;EACA,4CAAA;EACA,kDAAA;EACA,+EAAA;EAEA,gCAAA;EAEA,uCAAA;EACA,0CAAA;EACA,wCAAA;EACA,uDAAA;EACA,sCAAA;EACA,2CAAA;EACA,sDAAA;EACA,sCAAA;EACA,gDAAA;EACA,+EAAA;EACA,uCAAA;EACA,8DAAA;EACA,2DAAA;EACA,mEAAA;EACA,gEAAA;EACA,oEAAA;EACA,6DAAA;EACA,0DAAA;EACA,kEAAA;EACA,kCAAA;EACA,sCAAA;EACA,yCAAA;EACA,2DAAA;EACA,8CAAA;EACA,0CAAA;EACA,0CAAA;EACA,2EAAA;EACA,iFAAA;EACA,mEAAA;EAGA,kBAAA;EACA,aAAA;EAEA,kCAAA;EACA,sBAAA;EAEA,SAAA;EACA,+BAAA;EACA,kEAAA;EACA,+BAAA;EACA,iCAAA;EAEA,gBAAA;E9CzDI,yH8C0DJ;ApEsqQF;AM9uQI;EAgCE,mFAAA;ANitQN;AMzuQI;EA+BI,kFAAA;AN6sQR;AsBluQM;E8CpBN;I9CqBQ,gBAAA;EtBquQN;AACF;AMzvQI;EAgCE,cAAA;AN4tQN;AMpvQI;EA+BI,eAAA;ANwtQR;AoEnrQI;EACE,iCAAA;ApEqrQN;AoEjrQE;EACE,SAAA;ApEmrQJ;AMrwQI;EAgCE,eAAA;ANwuQN;AMhwQI;EA+BI,cAAA;ANouQR;AoEvrQI;EACE,+BAAA;ApEyrQN;AoErrQE;EACE,mCAAA;ApEurQJ;AoEnrQI;EACE,0BAAA;ApEqrQN;AcvtQI;EsDqCM;IACE,iCAAA;EpEqrQV;EoEjrQQ;IACE,+BAAA;EpEmrQV;AACF;AoE9rQI;EACE,0BAAA;ApEgsQN;AcluQI;EsDqCM;IACE,iCAAA;EpEgsQV;EoE5rQQ;IACE,+BAAA;EpE8rQV;AACF;AoEzsQI;EACE,0BAAA;ApE2sQN;Ac7uQI;EsDqCM;IACE,iCAAA;EpE2sQV;EoEvsQQ;IACE,+BAAA;EpEysQV;AACF;AcrvQI;ER7DA;IAgCE,gDAAA;ENsxQJ;EM9yQE;IA+BI,iDAAA;ENkxQN;EoEtsQM;IACE,6BAAA;EpEwsQR;EM5zQE;IAgCE,iDAAA;EN+xQJ;EMvzQE;IA+BI,gDAAA;EN2xQN;EoEzsQM;IACE,2BAAA;EpE2sQR;AACF;AczwQI;EsDmEF;IAEI,eAAA;IACA,MAAA;IACA,SAAA;IACA,a/D4kC8B;EL4nOlC;EM70QE;IAgCE,OAAA;ENgzQJ;EMx0QE;IA+BI,QAAA;EN4yQN;EMn1QE;IAgCE,QAAA;ENszQJ;EM90QE;IA+BI,OAAA;ENkzQN;AACF;Ac7xQI;EsDoFF;IAEI,gBAAA;IACA,MAAA;IACA,aAAA;EpE2sQJ;AACF;AoExsQE;EACE,eAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;ApE0sQJ;AMv2QI;EAgCE,OAAA;AN00QN;AMl2QI;EA+BI,QAAA;ANs0QR;AoE5sQM;EACE,6BAAA;ApE8sQR;AMh3QI;EAgCE,QAAA;ANm1QN;AM32QI;EA+BI,OAAA;AN+0QR;AoE9sQM;EACE,2BAAA;ApEgtQR;Ac/yQI;EsD5EJ;IAkLI,qBAAA;IACA,eAAA;IACA,MAAA;IACA,SAAA;IACA,aAAA;EpE6sQF;EMj4QE;IAgCE,OAAA;ENo2QJ;EM53QE;IA+BI,QAAA;ENg2QN;EoE/sQI;IACE,wCAAA;EpEitQN;EM14QE;IAgCE,gDAAA;EN62QJ;EMr4QE;IA+BI,iDAAA;ENy2QN;EMh5QE;IAgCE,QAAA;ENm3QJ;EM34QE;IA+BI,OAAA;EN+2QN;EoEptQI;IACE,sCAAA;EpEstQN;EMz5QE;IAgCE,iDAAA;EN43QJ;EMp5QE;IA+BI,gDAAA;ENw3QN;AACF;;AoEntQA;EACE,kBAAA;EACA,MAAA;EAEA,+BAAA;EACA,wCAAA;EACA,+BAAA;EACA,uBAAA;EACA,SAAA;ApEqtQF;AM16QI;EAgCE,QAAA;AN64QN;AMr6QI;EA+BI,OAAA;ANy4QR;AoEztQE;EACE,qBAAA;ApE2tQJ;AoExtQE;EACE,UAAA;ApE0tQJ;;AoEttQA;EACE,aAAA;EACA,yCAAA;EACA,mBAAA;EACA,uBAAA;EACA,qCAAA;EACA,uCAAA;ApEytQF;AoEvtQE;EACE,aAAA;ApEytQJ;;AoErtQA;EACE,0CAAA;EACA,gFAAA;EACA,kBAAA;EACA,wCAAA;E9CnOI,uC8CoOJ;ApEwtQF;AsBx7QM;E8C2NN;I9C1NQ,gBAAA;EtB27QN;AACF;AoE3tQE;EACE,aAAA;EACA,mBAAA;EACA,4CAAA;ApE6tQJ;;AoEztQA;EACE,0CAAA;EACA,gFAAA;EACA,wCAAA;E9ChPI,uC8CiPJ;ApE4tQF;AsBz8QM;E8CyON;I9CxOQ,gBAAA;EtB48QN;AACF;;AoE9tQA;EACE,aAAA;EACA,2CAAA;EACA,yBAAA;EACA,cAAA;EACA,UAAA;EACA,eAAA;EACA,+CAAA;EACA,SAAA;ApEiuQF;Acj6QI;EsDwLJ;IAWI,aAAA;EpEkuQF;AACF;AoEhuQE;EACE,cAAA;EACA,iDAAA;EACA,mDAAA;EACA,WAAA;EACA,sDAAA;EACA,4BAAA;EACA,2BAAA;EACA,yEAAA;E9C1QE,2B8C2QF;ApEkuQJ;AsBz+QM;E8C8PJ;I9C7PM,gBAAA;EtB4+QN;AACF;AMx/QI;E8DmRE,0BAAA;ApEwuQN;AoEpuQE;EACE,UAAA;ApEsuQJ;AoEnuQE;EACE,qDAAA;ApEquQJ;AoEpuQI;EACE,4DAAA;ApEsuQN;AoEluQE;EACE,2BAAA;ApEouQJ;AoEnuQI;EACE,0BAAA;ApEquQN;;AoE9tQA;EAEE,2BAAA;EACA,0BAAA;EACA,2BAAA;ApEguQF;Ac98QI;EsD0OJ;IhBpTE,eAAA;IACA,MAAA;IACA,OAAA;IACA,mCgByT4B;IhBxT5B,YAAA;IACA,aAAA;IACA,wCgBsT8D;EpEsuQ9D;EoDzhRA;IAAS,UAAA;EpD4hRT;EoD3hRA;IAAS,oCgBkTmF;EpE4uQ5F;AACF;;AqEziRA;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ArE4iRF;AqE1iRE;EACE,sFAAA;EACA,mDAAA;EACA,cAAA;EACA,gBAAA;EACA,yCAAA;EACA,yBAAA;E/CHE,sC+CIF;ArE4iRJ;AsB5iRM;E+CPJ;I/CQM,gBAAA;EtB+iRN;AACF;AqE9iRE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,oFAAA;EACA,wCAAA;EACA,qBAAA;EACA,mBAAA;EACA,0CAAA;EACA,0CAAA;E9DbA,wDAAA;EeHE,mD+CkBF;ArEgjRJ;AsB9jRM;E+CGJ;I/CFM,gBAAA;EtBikRN;AACF;AqEnjRI;EACE,+CAAA;EACA,iDAAA;ArEqjRN;AqEnjRM;EACE,oDAAA;ArEqjRR;AqEjjRI;EACE,iDAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;ArEmjRN;AqEjjRM;EACE,sDAAA;ArEmjRR;AqEhjRM;EACE,iDAAA;ArEkjRR;AqEhjRQ;EACE,sDAAA;ArEkjRV;AqE/iRQ;EACE,8DAAA;ArEijRV;AqE5iRI;EACE;IACE,8CAAA;IACA,qBAAA;IACA,gDAAA;ErE8iRN;EqE5iRM;IACE,mDAAA;ErE8iRR;EqE3iRM;IACE,8DAAA;ErE6iRR;AACF;AqExiRE;EACE,2CAAA;EACA,0CAAA;EACA,gDAAA;EACA,6CAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;E/C5EE,mB+C6EF;ArE0iRJ;AsBnnRM;E+CiEJ;I/ChEM,gBAAA;EtBsnRN;AACF;AM1oRI;EAgCE,6DAAA;AN6mRN;AMroRI;EA+BI,8DAAA;ANymRR;AqE9iRE;EACE,gBAAA;ArEgjRJ;AqE7iRE;EACE,kBAAA;E/CzFE,wC+C0FF;ArE+iRJ;AsBroRM;E+CoFJ;I/CnFM,gBAAA;EtBwoRN;AACF;AqEljRI;EACE,kGAAA;EACA,gBAAA;E/C9FA,6B+C+FA;ArEojRN;AsB/oRM;E+CwFF;I/CvFI,gBAAA;EtBkpRN;AACF;AqEtjRI;EACE,aAAA;ArEwjRN;AqErjRI;EACE,2CAAA;ArEujRN;AqErjRM;EACE,qDAAA;ArEujRR;AqEpjRM;EACE,yBAAA;ArEsjRR;AqEnjRM;EACE,eAAA;ArEqjRR;AqEhjRE;EACE,eAAA;ArEkjRJ;AqEhjRI;EACE,cAAA;EACA,cAAA;EACA,YAAA;EAEA,WAAA;EACA,wDAAA;EACA,4BAAA;EACA,2BAAA;E/ClIA,2B+CmIA;ArEijRN;AMlsRI;EAgCE,iBAAA;ANqqRN;AM7rRI;EA+BI,kBAAA;ANiqRR;AsBtrRM;E+CsHF;I/CrHI,gBAAA;EtByrRN;AACF;AqExjRE;EACE,UAAA;EACA,gBAAA;ArE0jRJ;AMjtRI;EAgCE,+CAAA;ANorRN;AM5sRI;EA+BI,gDAAA;ANgrRR;AMvtRI;EAgCE,yDAAA;AN0rRN;AMltRI;EA+BI,0DAAA;ANsrRR;AqEzjRI;;EACE,8DAAA;EACA,iEAAA;ArE4jRN;;AcrqRI;EwD/DJ;IAEI,aAAA;IACA,yCAAA;IACA,sCAAA;IACA,iDAAA;IACA,iBAAA;EtEuuRF;EsEruRE;IACE,aAAA;IACA,sCAAA;EtEuuRJ;EsEpuRE;IACE,aAAA;EtEsuRJ;EsEnuRE;IACE,cAAA;EtEquRJ;EsEluRE;;;;;;;;;;;;;IAQE,oBAAA;IACA,UAAA;IACA,SAAA;IACA,kBAAA;IACA,UAAA;EtEyuRJ;EsEtuRE;IACE,eAAA;IACA,SAAA;EtEwuRJ;EM5wRE;IAgCE,0BAAA;EN+uRJ;EMvwRE;IA4BI,uBAAA;EN8uRN;EsEvuRE;IACE,uBAAA;EtEyuRJ;AACF;;AsEnuRE;EACE,gCAAA;AtEsuRJ;AsEpuRE;EACE,8BAAA;AtEsuRJ;;AsEluRA;EACE,eAAA;EACA,aAAA;AtEquRF;AsEnuRE;EACE,gCAAA;AtEquRJ;AsEnuRE;EACE,8BAAA;AtEquRJ;AMxyRI;EAgCE,0BAAA;AN2wRN;AMnyRI;EA4BI,uBAAA;AN0wRR;AsE7tRI;EACE,uBAAA;AtE+tRN;;AMjzRI;EAgCE,uDAAA;ANqxRN;AM7yRI;EA+BI,wDAAA;ANixRR;AMxzRI;EAgCE,wDAAA;AN2xRN;AMnzRI;EA+BI,uDAAA;ANuxRR;;AcpvRI;ER1EA;IAgCE,uDAAA;ENmyRJ;EM3zRE;IA+BI,wDAAA;EN+xRN;EMt0RE;IAgCE,wDAAA;ENyyRJ;EMj0RE;IA+BI,uDAAA;ENqyRN;AACF;AcnwRI;ER1EA;IAgCE,uDAAA;ENizRJ;EMz0RE;IA+BI,wDAAA;EN6yRN;EMp1RE;IAgCE,wDAAA;ENuzRJ;EM/0RE;IA+BI,uDAAA;ENmzRN;AACF;AcjxRI;ER1EA;IAgCE,uDAAA;EN+zRJ;EMv1RE;IA+BI,wDAAA;EN2zRN;EMl2RE;IAgCE,wDAAA;ENq0RJ;EM71RE;IA+BI,uDAAA;ENi0RN;AACF;Ac/xRI;ER1EA;IAgCE,uDAAA;EN60RJ;EMr2RE;IA+BI,wDAAA;ENy0RN;EMh3RE;IAgCE,wDAAA;ENm1RJ;EM32RE;IA+BI,uDAAA;EN+0RN;AACF;Ac7yRI;ER1EA;IAgCE,uDAAA;EN21RJ;EMn3RE;IA+BI,wDAAA;ENu1RN;EM93RE;IAgCE,wDAAA;ENi2RJ;EMz3RE;IA+BI,uDAAA;EN61RN;AACF;AuEv4RA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBlEuwD+B;EkEtwD/B,oBAAA;EACA,4CAAA;EACA,0IAAA;AvEy4RF;;AuEt4RA;EACE,gBAAA;EACA,MAAA;EACA,aAAA;AvEy4RF;;AuEl4RA;EACE,aAAA;EACA,mBAAA;EAEA,gBAAA;EACA,gBAAA;AvEo4RF;AM75RI;EAgCE,eAAA;ANg4RN;AMx5RI;EA+BI,gBAAA;AN43RR;AuEx4RE;EACE,qBlEqvD4B;EkEpvD5B,oBlEovD4B;EkEnvD5B,6DAAA;AvE04RJ;AuEx4RI;EAEE,8DAAA;AvEy4RN;AuEt4RI;EACE,kEAAA;AvEw4RN;AuEp4RE;;EAEE,+DAAA;AvEs4RJ;AuEn4RE;EACE,kBAAA;AvEq4RJ;;AuE73RA;EACE,mBlEirCkC;EkEhrClC,sBlEgrCkC;EkE/qClC,6DAAA;AvEg4RF;AuE93RE;EACE,+DAAA;AvEg4RJ;AuE93RI;EAEE,+DAAA;AvE+3RN;;AyDj8RE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AzDo8RJ;;AwEv8RE;EACE,2CAAA;EACA,mFAAA;AxE08RJ;;AwE58RE;EACE,yBAAA;EACA,qFAAA;AxE+8RJ;;AwEj9RE;EACE,yBAAA;EACA,mFAAA;AxEo9RJ;;AwEt9RE;EACE,yBAAA;EACA,gFAAA;AxEy9RJ;;AwE39RE;EACE,wCAAA;EACA,mFAAA;AxE89RJ;;AwEh+RE;EACE,yBAAA;EACA,kFAAA;AxEm+RJ;;AwEr+RE;EACE,wCAAA;EACA,iFAAA;AxEw+RJ;;AwE1+RE;EACE,yBAAA;EACA,gFAAA;AxE6+RJ;;AyE/+RE;EACE,0EAAA;EACA,oGAAA;AzEk/RJ;AyE/+RM;EAGE,+DAAA;EACA,yFAAA;AzE++RR;;AyEx/RE;EACE,4EAAA;EACA,sGAAA;AzE2/RJ;AyEx/RM;EAGE,iEAAA;EACA,2FAAA;AzEw/RR;;AyEjgSE;EACE,0EAAA;EACA,oGAAA;AzEogSJ;AyEjgSM;EAGE,gEAAA;EACA,0FAAA;AzEigSR;;AyE1gSE;EACE,uEAAA;EACA,iGAAA;AzE6gSJ;AyE1gSM;EAGE,gEAAA;EACA,0FAAA;AzE0gSR;;AyEnhSE;EACE,0EAAA;EACA,oGAAA;AzEshSJ;AyEnhSM;EAGE,gEAAA;EACA,0FAAA;AzEmhSR;;AyE5hSE;EACE,yEAAA;EACA,mGAAA;AzE+hSJ;AyE5hSM;EAGE,iEAAA;EACA,2FAAA;AzE4hSR;;AyEriSE;EACE,wEAAA;EACA,kGAAA;AzEwiSJ;AyEriSM;EAGE,iEAAA;EACA,2FAAA;AzEqiSR;;AyE9iSE;EACE,uEAAA;EACA,iGAAA;AzEijSJ;AyE9iSM;EAGE,iEAAA;EACA,2FAAA;AzE8iSR;;AyEviSA;EACE,iFAAA;EACA,2GAAA;AzE0iSF;AyEviSI;EAEE,oFAAA;EACA,8GAAA;AzEwiSN;;A0ElkSA;EACE,UAAA;EAEA,uJAAA;A1EokSF;;A2EvkSA;EACE,oBAAA;EACA,atE8f4B;EsE7f5B,mBAAA;EACA,oFAAA;EACA,6BtE4f4B;EsE3f5B,2BAAA;A3E0kSF;A2ExkSE;EACE,cAAA;EACA,UtEwf0B;EsEvf1B,WtEuf0B;EsEtf1B,kBAAA;ErDIE,sCqDHF;A3E0kSJ;AsBnkSM;EqDZJ;IrDaM,gBAAA;EtBskSN;AACF;;A2ExkSI;EACE,oEAAA;A3E2kSN;;A4E9lSA;EACE,kBAAA;EACA,WAAA;A5EimSF;A4E/lSE;EACE,cAAA;EACA,oCAAA;EACA,WAAA;A5EimSJ;A4E9lSE;EACE,kBAAA;EACA,MAAA;EAEA,WAAA;EACA,YAAA;A5E+lSJ;AM9mSI;EAgCE,OAAA;ANilSN;AMzmSI;EA+BI,QAAA;AN6kSR;;A4EhmSE;EACE,wBAAA;A5EmmSJ;;A4EpmSE;EACE,uBAAA;A5EumSJ;;A4ExmSE;EACE,0BAAA;A5E2mSJ;;A4E5mSE;EACE,kCAAA;A5E+mSJ;;A6EpoSA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,axE4sCkC;AL27PpC;;A6EpoSA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,axEosCkC;ALm8PpC;;A6E/nSI;EACE,gBAAA;EACA,MAAA;EACA,axEwrC8B;AL08PpC;;A6E/nSI;EACE,gBAAA;EACA,SAAA;EACA,axEkrC8B;ALg9PpC;;AcnmSI;E+DxCA;IACE,gBAAA;IACA,MAAA;IACA,axEwrC8B;ELu9PlC;E6E5oSE;IACE,gBAAA;IACA,SAAA;IACA,axEkrC8B;EL49PlC;AACF;AchnSI;E+DxCA;IACE,gBAAA;IACA,MAAA;IACA,axEwrC8B;ELm+PlC;E6ExpSE;IACE,gBAAA;IACA,SAAA;IACA,axEkrC8B;ELw+PlC;AACF;Ac5nSI;E+DxCA;IACE,gBAAA;IACA,MAAA;IACA,axEwrC8B;EL++PlC;E6EpqSE;IACE,gBAAA;IACA,SAAA;IACA,axEkrC8B;ELo/PlC;AACF;AcxoSI;E+DxCA;IACE,gBAAA;IACA,MAAA;IACA,axEwrC8B;EL2/PlC;E6EhrSE;IACE,gBAAA;IACA,SAAA;IACA,axEkrC8B;ELggQlC;AACF;AcppSI;E+DxCA;IACE,gBAAA;IACA,MAAA;IACA,axEwrC8B;ELugQlC;E6E5rSE;IACE,gBAAA;IACA,SAAA;IACA,axEkrC8B;EL4gQlC;AACF;A8E9tSA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;A9EguSF;;A8E7tSA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;A9EguSF;;A+ExuSA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AhFyuSF;AgFtuSE;;EACE,6BAAA;AhFyuSJ;;AiFvvSE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U5EifsC;E4EhftC,WAAA;AjF0vSJ;;AkFlwSA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AnFswSF;;AoF5wSA;EACE,qBAAA;EACA,mBAAA;EACA,8B/E2vB4B;E+E1vB5B,eAAA;EACA,UAAA;EACA,8BAAA;EACA,a/EovB4B;AL2hR9B;;AqFjtSQ;EAUM,mCAAA;ArF2sSd;;AqFrtSQ;EAUM,8BAAA;ArF+sSd;;AqFztSQ;EAUM,iCAAA;ArFmtSd;;AqF7tSQ;EAUM,iCAAA;ArFutSd;;AqFjuSQ;EAUM,sCAAA;ArF2tSd;;AqFruSQ;EAUM,mCAAA;ArF+tSd;;AM5ySI;EAgCE,sBAAA;ANgxSN;AMxySI;EA+BI,uBAAA;AN4wSR;;AMnzSI;EAgCE,uBAAA;ANuxSN;AM/ySI;EA+BI,sBAAA;ANmxSR;;AM1zSI;EAgCE,sBAAA;AN8xSN;AMtzSI;EA+BI,sBAAA;AN0xSR;;AqF9vSQ;EAUM,8BAAA;ArFwvSd;;AqFlwSQ;EAUM,4BAAA;ArF4vSd;;AqFtwSQ;EAUM,2BAAA;ArFgwSd;;AqF1wSQ;EAUM,iCAAA;ArFowSd;;AqF9wSQ;EAUM,2BAAA;ArFwwSd;;AqFlxSQ;EAUM,qBAAA;ArF4wSd;;AqFtxSQ;EAUM,wBAAA;ArFgxSd;;AqF1xSQ;EAUM,uBAAA;ArFoxSd;;AqF9xSQ;EAUM,wBAAA;ArFwxSd;;AqFlySQ;EAUM,qBAAA;ArF4xSd;;AqFtySQ;EAUM,yBAAA;ArFgySd;;AqF1ySQ;EAUM,2BAAA;ArFoySd;;AqF9ySQ;EAUM,4BAAA;ArFwySd;;AqFlzSQ;EAUM,2BAAA;ArF4ySd;;AqFtzSQ;EAUM,2BAAA;ArFgzSd;;AqF1zSQ;EAUM,6BAAA;ArFozSd;;AqF9zSQ;EAUM,8BAAA;ArFwzSd;;AqFl0SQ;EAUM,6BAAA;ArF4zSd;;AqFt0SQ;EAUM,2BAAA;ArFg0Sd;;AqF10SQ;EAUM,6BAAA;ArFo0Sd;;AqF90SQ;EAUM,8BAAA;ArFw0Sd;;AqFl1SQ;EAUM,6BAAA;ArF40Sd;;AqFt1SQ;EAUM,0BAAA;ArFg1Sd;;AqF11SQ;EAUM,gCAAA;ArFo1Sd;;AqF91SQ;EAUM,yBAAA;ArFw1Sd;;AqFl2SQ;EAUM,wBAAA;ArF41Sd;;AqFt2SQ;EAUM,+BAAA;ArFg2Sd;;AqF12SQ;EAUM,yBAAA;ArFo2Sd;;AqF92SQ;EAUM,6BAAA;ArFw2Sd;;AqFl3SQ;EAUM,8BAAA;ArF42Sd;;AqFt3SQ;EAUM,wBAAA;ArFg3Sd;;AqF13SQ;EAUM,+BAAA;ArFo3Sd;;AqF93SQ;EAUM,wBAAA;ArFw3Sd;;AqFl4SQ;EAUM,2DAAA;ArF43Sd;;AqFt4SQ;EAUM,iEAAA;ArFg4Sd;;AqF14SQ;EAUM,0DAAA;ArFo4Sd;;AqF94SQ;EAUM,2BAAA;ArFw4Sd;;AqF55SQ;EACE,mFAAA;ArF+5SV;;AqFh6SQ;EACE,qFAAA;ArFm6SV;;AqFp6SQ;EACE,mFAAA;ArFu6SV;;AqFx6SQ;EACE,gFAAA;ArF26SV;;AqF56SQ;EACE,mFAAA;ArF+6SV;;AqFh7SQ;EACE,kFAAA;ArFm7SV;;AqFp7SQ;EACE,iFAAA;ArFu7SV;;AqFx7SQ;EACE,gFAAA;ArF27SV;;AqFl7SQ;EAUM,2BAAA;ArF46Sd;;AqFt7SQ;EAUM,6BAAA;ArFg7Sd;;AqF17SQ;EAUM,6BAAA;ArFo7Sd;;AqF97SQ;EAUM,0BAAA;ArFw7Sd;;AqFl8SQ;EAUM,2BAAA;ArF47Sd;;AqFt8SQ;EAUM,iBAAA;ArFg8Sd;;AqF18SQ;EAUM,mBAAA;ArFo8Sd;;AqF98SQ;EAUM,oBAAA;ArFw8Sd;;AqFl9SQ;EAUM,oBAAA;ArF48Sd;;AqFt9SQ;EAUM,sBAAA;ArFg9Sd;;AqF19SQ;EAUM,uBAAA;ArFo9Sd;;AqF99SQ;EAUM,kBAAA;ArFw9Sd;;AqFl+SQ;EAUM,oBAAA;ArF49Sd;;AqFt+SQ;EAUM,qBAAA;ArFg+Sd;;AqF1+SQ;EAUM,mBAAA;ArFo+Sd;;AqF9+SQ;EAUM,qBAAA;ArFw+Sd;;AqFl/SQ;EAUM,sBAAA;ArF4+Sd;;AqFt/SQ;EAUM,2CAAA;ArFg/Sd;;AqF1/SQ;EAUM,sCAAA;ArFo/Sd;;AqF9/SQ;EAUM,sCAAA;ArFw/Sd;;AqFlgTQ;EAUM,0FAAA;ArF4/Sd;;AqFtgTQ;EAUM,oBAAA;ArFggTd;;AqF1gTQ;EAUM,8FAAA;ArFogTd;;AqF9gTQ;EAUM,wBAAA;ArFwgTd;;AMrlTI;EAgCE,gGAAA;ANyjTN;AMjlTI;EA+BI,+FAAA;ANqjTR;;AM5lTI;EAgCE,0BAAA;ANgkTN;AMxlTI;EA+BI,yBAAA;AN4jTR;;AqFhiTQ;EAUM,iGAAA;ArF0hTd;;AqFpiTQ;EAUM,2BAAA;ArF8hTd;;AM3mTI;EAgCE,+FAAA;AN+kTN;AMvmTI;EA+BI,gGAAA;AN2kTR;;AMlnTI;EAgCE,yBAAA;ANslTN;AM9mTI;EA+BI,0BAAA;ANklTR;;AqFtjTQ;EAIQ,uBAAA;EAMF,gFAAA;ArFijTd;;AqF3jTQ;EAIQ,uBAAA;EAMF,kFAAA;ArFsjTd;;AqFhkTQ;EAIQ,uBAAA;EAMF,gFAAA;ArF2jTd;;AqFrkTQ;EAIQ,uBAAA;EAMF,6EAAA;ArFgkTd;;AqF1kTQ;EAIQ,uBAAA;EAMF,gFAAA;ArFqkTd;;AqF/kTQ;EAIQ,uBAAA;EAMF,+EAAA;ArF0kTd;;AqFplTQ;EAIQ,uBAAA;EAMF,8EAAA;ArF+kTd;;AqFzlTQ;EAIQ,uBAAA;EAMF,6EAAA;ArFolTd;;AqF9lTQ;EAIQ,uBAAA;EAMF,8EAAA;ArFylTd;;AqFnmTQ;EAUM,oCAAA;ArF6lTd;;AqFvmTQ;EAUM,oCAAA;ArFimTd;;AqF3mTQ;EAUM,oCAAA;ArFqmTd;;AqF/mTQ;EAUM,iCAAA;ArFymTd;;AqFnnTQ;EAUM,oCAAA;ArF6mTd;;AqFvnTQ;EAUM,oCAAA;ArFinTd;;AqF3nTQ;EAUM,oCAAA;ArFqnTd;;AqF/nTQ;EAUM,oCAAA;ArFynTd;;AqFnoTQ;EAUM,oCAAA;ArF6nTd;;AM1sTI;EAgCE,sCAAA;AN8qTN;AMtsTI;EA+BI,qCAAA;AN0qTR;;AMjtTI;EAgCE,sCAAA;ANqrTN;AM7sTI;EA+BI,qCAAA;ANirTR;;AMxtTI;EAgCE,sCAAA;AN4rTN;AMptTI;EA+BI,qCAAA;ANwrTR;;AM/tTI;EAgCE,mCAAA;ANmsTN;AM3tTI;EA+BI,kCAAA;AN+rTR;;AMtuTI;EAgCE,sCAAA;AN0sTN;AMluTI;EA+BI,qCAAA;ANssTR;;AM7uTI;EAgCE,sCAAA;ANitTN;AMzuTI;EA+BI,qCAAA;AN6sTR;;AMpvTI;EAgCE,sCAAA;ANwtTN;AMhvTI;EA+BI,qCAAA;ANotTR;;AM3vTI;EAgCE,sCAAA;AN+tTN;AMvvTI;EA+BI,qCAAA;AN2tTR;;AMlwTI;EAgCE,sCAAA;ANsuTN;AM9vTI;EA+BI,qCAAA;ANkuTR;;AqFtsTQ;EAUM,uCAAA;ArFgsTd;;AqF1sTQ;EAUM,uCAAA;ArFosTd;;AqF9sTQ;EAUM,uCAAA;ArFwsTd;;AqFltTQ;EAUM,oCAAA;ArF4sTd;;AqFttTQ;EAUM,uCAAA;ArFgtTd;;AqF1tTQ;EAUM,uCAAA;ArFotTd;;AqF9tTQ;EAUM,uCAAA;ArFwtTd;;AqFluTQ;EAUM,uCAAA;ArF4tTd;;AqFtuTQ;EAUM,uCAAA;ArFguTd;;AM7yTI;EAgCE,qCAAA;ANixTN;AMzyTI;EA+BI,sCAAA;AN6wTR;;AMpzTI;EAgCE,qCAAA;ANwxTN;AMhzTI;EA+BI,sCAAA;ANoxTR;;AM3zTI;EAgCE,qCAAA;AN+xTN;AMvzTI;EA+BI,sCAAA;AN2xTR;;AMl0TI;EAgCE,kCAAA;ANsyTN;AM9zTI;EA+BI,mCAAA;ANkyTR;;AMz0TI;EAgCE,qCAAA;AN6yTN;AMr0TI;EA+BI,sCAAA;ANyyTR;;AMh1TI;EAgCE,qCAAA;ANozTN;AM50TI;EA+BI,sCAAA;ANgzTR;;AMv1TI;EAgCE,qCAAA;AN2zTN;AMn1TI;EA+BI,sCAAA;ANuzTR;;AM91TI;EAgCE,qCAAA;ANk0TN;AM11TI;EA+BI,sCAAA;AN8zTR;;AMr2TI;EAgCE,qCAAA;ANy0TN;AMj2TI;EA+BI,sCAAA;ANq0TR;;AqFzyTQ;EAUM,4BAAA;ArFmyTd;;AqF7yTQ;EAUM,4BAAA;ArFuyTd;;AqFjzTQ;EAUM,4BAAA;ArF2yTd;;AqFrzTQ;EAUM,4BAAA;ArF+yTd;;AqFzzTQ;EAUM,4BAAA;ArFmzTd;;AqF7zTQ;EAUM,gCAAA;ArFuzTd;;AqFj0TQ;EAUM,gCAAA;ArF2zTd;;AqFr0TQ;EAUM,gCAAA;ArF+zTd;;AqFz0TQ;EAUM,gCAAA;ArFm0Td;;AqF70TQ;EAUM,gCAAA;ArFu0Td;;AMp5TI;EAgCE,kCAAA;ANw3TN;AMh5TI;EA+BI,iCAAA;ANo3TR;;AM35TI;EAgCE,kCAAA;AN+3TN;AMv5TI;EA+BI,iCAAA;AN23TR;;AMl6TI;EAgCE,kCAAA;ANs4TN;AM95TI;EA+BI,iCAAA;ANk4TR;;AMz6TI;EAgCE,kCAAA;AN64TN;AMr6TI;EA+BI,iCAAA;ANy4TR;;AMh7TI;EAgCE,kCAAA;ANo5TN;AM56TI;EA+BI,iCAAA;ANg5TR;;AqFp3TQ;EAUM,mCAAA;ArF82Td;;AqFx3TQ;EAUM,mCAAA;ArFk3Td;;AqF53TQ;EAUM,mCAAA;ArFs3Td;;AqFh4TQ;EAUM,mCAAA;ArF03Td;;AqFp4TQ;EAUM,mCAAA;ArF83Td;;AM38TI;EAgCE,iCAAA;AN+6TN;AMv8TI;EA+BI,kCAAA;AN26TR;;AMl9TI;EAgCE,iCAAA;ANs7TN;AM98TI;EA+BI,kCAAA;ANk7TR;;AMz9TI;EAgCE,iCAAA;AN67TN;AMr9TI;EA+BI,kCAAA;ANy7TR;;AMh+TI;EAgCE,iCAAA;ANo8TN;AM59TI;EA+BI,kCAAA;ANg8TR;;AMv+TI;EAgCE,iCAAA;AN28TN;AMn+TI;EA+BI,kCAAA;ANu8TR;;AqFr7TQ;EACE,yBAAA;ArFw7TV;;AqFz7TQ;EACE,0BAAA;ArF47TV;;AqF77TQ;EACE,yBAAA;ArFg8TV;;AqFj8TQ;EACE,0BAAA;ArFo8TV;;AqFr8TQ;EACE,uBAAA;ArFw8TV;;AqF/7TQ;EAUM,qBAAA;ArFy7Td;;AqFn8TQ;EAUM,qBAAA;ArF67Td;;AqFv8TQ;EAUM,qBAAA;ArFi8Td;;AqF38TQ;EAUM,sBAAA;ArFq8Td;;AqF/8TQ;EAUM,sBAAA;ArFy8Td;;AqFn9TQ;EAUM,0BAAA;ArF68Td;;AqFv9TQ;EAUM,uBAAA;ArFi9Td;;AqF39TQ;EAUM,2BAAA;ArFq9Td;;AqF/9TQ;EAUM,sBAAA;ArFy9Td;;AqFn+TQ;EAUM,sBAAA;ArF69Td;;AqFv+TQ;EAUM,sBAAA;ArFi+Td;;AqF3+TQ;EAUM,uBAAA;ArFq+Td;;AqF/+TQ;EAUM,uBAAA;ArFy+Td;;AqFn/TQ;EAUM,2BAAA;ArF6+Td;;AqFv/TQ;EAUM,wBAAA;ArFi/Td;;AqF3/TQ;EAUM,4BAAA;ArFq/Td;;AqF//TQ;EAUM,yBAAA;ArFy/Td;;AqFngUQ;EAUM,8BAAA;ArF6/Td;;AqFvgUQ;EAUM,iCAAA;ArFigUd;;AqF3gUQ;EAUM,sCAAA;ArFqgUd;;AqF/gUQ;EAUM,yCAAA;ArFygUd;;AqFnhUQ;EAUM,uBAAA;ArF6gUd;;AqFvhUQ;EAUM,uBAAA;ArFihUd;;AqF3hUQ;EAUM,yBAAA;ArFqhUd;;AqF/hUQ;EAUM,yBAAA;ArFyhUd;;AqFniUQ;EAUM,0BAAA;ArF6hUd;;AqFviUQ;EAUM,4BAAA;ArFiiUd;;AqF3iUQ;EAUM,kCAAA;ArFqiUd;;AqF/iUQ;EAUM,sCAAA;ArFyiUd;;AqFnjUQ;EAUM,oCAAA;ArF6iUd;;AqFvjUQ;EAUM,kCAAA;ArFijUd;;AqF3jUQ;EAUM,yCAAA;ArFqjUd;;AqF/jUQ;EAUM,wCAAA;ArFyjUd;;AqFnkUQ;EAUM,wCAAA;ArF6jUd;;AqFvkUQ;EAUM,kCAAA;ArFikUd;;AqF3kUQ;EAUM,gCAAA;ArFqkUd;;AqF/kUQ;EAUM,8BAAA;ArFykUd;;AqFnlUQ;EAUM,gCAAA;ArF6kUd;;AqFvlUQ;EAUM,+BAAA;ArFilUd;;AqF3lUQ;EAUM,oCAAA;ArFqlUd;;AqF/lUQ;EAUM,kCAAA;ArFylUd;;AqFnmUQ;EAUM,gCAAA;ArF6lUd;;AqFvmUQ;EAUM,uCAAA;ArFimUd;;AqF3mUQ;EAUM,sCAAA;ArFqmUd;;AqF/mUQ;EAUM,iCAAA;ArFymUd;;AqFnnUQ;EAUM,2BAAA;ArF6mUd;;AqFvnUQ;EAUM,iCAAA;ArFinUd;;AqF3nUQ;EAUM,+BAAA;ArFqnUd;;AqF/nUQ;EAUM,6BAAA;ArFynUd;;AqFnoUQ;EAUM,+BAAA;ArF6nUd;;AqFvoUQ;EAUM,8BAAA;ArFioUd;;AqF3oUQ;EAUM,oBAAA;ArFqoUd;;AqF/oUQ;EAUM,mBAAA;ArFyoUd;;AqFnpUQ;EAUM,mBAAA;ArF6oUd;;AqFvpUQ;EAUM,mBAAA;ArFipUd;;AqF3pUQ;EAUM,mBAAA;ArFqpUd;;AqF/pUQ;EAUM,mBAAA;ArFypUd;;AqFnqUQ;EAUM,mBAAA;ArF6pUd;;AqFvqUQ;EAUM,mBAAA;ArFiqUd;;AqF3qUQ;EAUM,oBAAA;ArFqqUd;;AqF/qUQ;EAUM,0BAAA;ArFyqUd;;AqFnrUQ;EAUM,yBAAA;ArF6qUd;;AqFvrUQ;EAUM,uBAAA;ArFirUd;;AqF3rUQ;EAUM,yBAAA;ArFqrUd;;AqF/rUQ;EAUM,uBAAA;ArFyrUd;;AqFnsUQ;EAUM,uBAAA;ArF6rUd;;AqFvsUQ;EAUM,0BAAA;EAAA,yBAAA;ArFksUd;;AqF5sUQ;EAUM,gCAAA;EAAA,+BAAA;ArFusUd;;AqFjtUQ;EAUM,+BAAA;EAAA,8BAAA;ArF4sUd;;AqFttUQ;EAUM,6BAAA;EAAA,4BAAA;ArFitUd;;AqF3tUQ;EAUM,+BAAA;EAAA,8BAAA;ArFstUd;;AqFhuUQ;EAUM,6BAAA;EAAA,4BAAA;ArF2tUd;;AqFruUQ;EAUM,6BAAA;EAAA,4BAAA;ArFguUd;;AqF1uUQ;EAUM,wBAAA;EAAA,2BAAA;ArFquUd;;AqF/uUQ;EAUM,8BAAA;EAAA,iCAAA;ArF0uUd;;AqFpvUQ;EAUM,6BAAA;EAAA,gCAAA;ArF+uUd;;AqFzvUQ;EAUM,2BAAA;EAAA,8BAAA;ArFovUd;;AqF9vUQ;EAUM,6BAAA;EAAA,gCAAA;ArFyvUd;;AqFnwUQ;EAUM,2BAAA;EAAA,8BAAA;ArF8vUd;;AqFxwUQ;EAUM,2BAAA;EAAA,8BAAA;ArFmwUd;;AqF7wUQ;EAUM,wBAAA;ArFuwUd;;AqFjxUQ;EAUM,8BAAA;ArF2wUd;;AqFrxUQ;EAUM,6BAAA;ArF+wUd;;AqFzxUQ;EAUM,2BAAA;ArFmxUd;;AqF7xUQ;EAUM,6BAAA;ArFuxUd;;AqFjyUQ;EAUM,2BAAA;ArF2xUd;;AqFryUQ;EAUM,2BAAA;ArF+xUd;;AM52UI;EAgCE,0BAAA;ANg1UN;AMx2UI;EA+BI,yBAAA;AN40UR;;AMn3UI;EAgCE,gCAAA;ANu1UN;AM/2UI;EA+BI,+BAAA;ANm1UR;;AM13UI;EAgCE,+BAAA;AN81UN;AMt3UI;EA+BI,8BAAA;AN01UR;;AMj4UI;EAgCE,6BAAA;ANq2UN;AM73UI;EA+BI,4BAAA;ANi2UR;;AMx4UI;EAgCE,+BAAA;AN42UN;AMp4UI;EA+BI,8BAAA;ANw2UR;;AM/4UI;EAgCE,6BAAA;ANm3UN;AM34UI;EA+BI,4BAAA;AN+2UR;;AMt5UI;EAgCE,6BAAA;AN03UN;AMl5UI;EA+BI,4BAAA;ANs3UR;;AqF11UQ;EAUM,2BAAA;ArFo1Ud;;AqF91UQ;EAUM,iCAAA;ArFw1Ud;;AqFl2UQ;EAUM,gCAAA;ArF41Ud;;AqFt2UQ;EAUM,8BAAA;ArFg2Ud;;AqF12UQ;EAUM,gCAAA;ArFo2Ud;;AqF92UQ;EAUM,8BAAA;ArFw2Ud;;AqFl3UQ;EAUM,8BAAA;ArF42Ud;;AMz7UI;EAgCE,yBAAA;AN65UN;AMr7UI;EA+BI,0BAAA;ANy5UR;;AMh8UI;EAgCE,+BAAA;ANo6UN;AM57UI;EA+BI,gCAAA;ANg6UR;;AMv8UI;EAgCE,8BAAA;AN26UN;AMn8UI;EA+BI,+BAAA;ANu6UR;;AM98UI;EAgCE,4BAAA;ANk7UN;AM18UI;EA+BI,6BAAA;AN86UR;;AMr9UI;EAgCE,8BAAA;ANy7UN;AMj9UI;EA+BI,+BAAA;ANq7UR;;AM59UI;EAgCE,4BAAA;ANg8UN;AMx9UI;EA+BI,6BAAA;AN47UR;;AMn+UI;EAgCE,4BAAA;ANu8UN;AM/9UI;EA+BI,6BAAA;ANm8UR;;AqFv6UQ;EAUM,qBAAA;ArFi6Ud;;AqF36UQ;EAUM,2BAAA;ArFq6Ud;;AqF/6UQ;EAUM,0BAAA;ArFy6Ud;;AqFn7UQ;EAUM,wBAAA;ArF66Ud;;AqFv7UQ;EAUM,0BAAA;ArFi7Ud;;AqF37UQ;EAUM,wBAAA;ArFq7Ud;;AqF/7UQ;EAUM,2BAAA;EAAA,0BAAA;ArF07Ud;;AqFp8UQ;EAUM,iCAAA;EAAA,gCAAA;ArF+7Ud;;AqFz8UQ;EAUM,gCAAA;EAAA,+BAAA;ArFo8Ud;;AqF98UQ;EAUM,8BAAA;EAAA,6BAAA;ArFy8Ud;;AqFn9UQ;EAUM,gCAAA;EAAA,+BAAA;ArF88Ud;;AqFx9UQ;EAUM,8BAAA;EAAA,6BAAA;ArFm9Ud;;AqF79UQ;EAUM,yBAAA;EAAA,4BAAA;ArFw9Ud;;AqFl+UQ;EAUM,+BAAA;EAAA,kCAAA;ArF69Ud;;AqFv+UQ;EAUM,8BAAA;EAAA,iCAAA;ArFk+Ud;;AqF5+UQ;EAUM,4BAAA;EAAA,+BAAA;ArFu+Ud;;AqFj/UQ;EAUM,8BAAA;EAAA,iCAAA;ArF4+Ud;;AqFt/UQ;EAUM,4BAAA;EAAA,+BAAA;ArFi/Ud;;AqF3/UQ;EAUM,yBAAA;ArFq/Ud;;AqF//UQ;EAUM,+BAAA;ArFy/Ud;;AqFngVQ;EAUM,8BAAA;ArF6/Ud;;AqFvgVQ;EAUM,4BAAA;ArFigVd;;AqF3gVQ;EAUM,8BAAA;ArFqgVd;;AqF/gVQ;EAUM,4BAAA;ArFygVd;;AMtlVI;EAgCE,2BAAA;AN0jVN;AMllVI;EA+BI,0BAAA;ANsjVR;;AM7lVI;EAgCE,iCAAA;ANikVN;AMzlVI;EA+BI,gCAAA;AN6jVR;;AMpmVI;EAgCE,gCAAA;ANwkVN;AMhmVI;EA+BI,+BAAA;ANokVR;;AM3mVI;EAgCE,8BAAA;AN+kVN;AMvmVI;EA+BI,6BAAA;AN2kVR;;AMlnVI;EAgCE,gCAAA;ANslVN;AM9mVI;EA+BI,+BAAA;ANklVR;;AMznVI;EAgCE,8BAAA;AN6lVN;AMrnVI;EA+BI,6BAAA;ANylVR;;AqF7jVQ;EAUM,4BAAA;ArFujVd;;AqFjkVQ;EAUM,kCAAA;ArF2jVd;;AqFrkVQ;EAUM,iCAAA;ArF+jVd;;AqFzkVQ;EAUM,+BAAA;ArFmkVd;;AqF7kVQ;EAUM,iCAAA;ArFukVd;;AqFjlVQ;EAUM,+BAAA;ArF2kVd;;AMxpVI;EAgCE,0BAAA;AN4nVN;AMppVI;EA+BI,2BAAA;ANwnVR;;AM/pVI;EAgCE,gCAAA;ANmoVN;AM3pVI;EA+BI,iCAAA;AN+nVR;;AMtqVI;EAgCE,+BAAA;AN0oVN;AMlqVI;EA+BI,gCAAA;ANsoVR;;AM7qVI;EAgCE,6BAAA;ANipVN;AMzqVI;EA+BI,8BAAA;AN6oVR;;AMprVI;EAgCE,+BAAA;ANwpVN;AMhrVI;EA+BI,gCAAA;ANopVR;;AM3rVI;EAgCE,6BAAA;AN+pVN;AMvrVI;EA+BI,8BAAA;AN2pVR;;AqF/nVQ;EAUM,iBAAA;ArFynVd;;AqFnoVQ;EAUM,uBAAA;ArF6nVd;;AqFvoVQ;EAUM,sBAAA;ArFioVd;;AqF3oVQ;EAUM,oBAAA;ArFqoVd;;AqF/oVQ;EAUM,sBAAA;ArFyoVd;;AqFnpVQ;EAUM,oBAAA;ArF6oVd;;AqFvpVQ;EAUM,qBAAA;ArFipVd;;AqF3pVQ;EAUM,2BAAA;ArFqpVd;;AqF/pVQ;EAUM,0BAAA;ArFypVd;;AqFnqVQ;EAUM,wBAAA;ArF6pVd;;AqFvqVQ;EAUM,0BAAA;ArFiqVd;;AqF3qVQ;EAUM,wBAAA;ArFqqVd;;AqF/qVQ;EAUM,wBAAA;ArFyqVd;;AqFnrVQ;EAUM,8BAAA;ArF6qVd;;AqFvrVQ;EAUM,6BAAA;ArFirVd;;AqF3rVQ;EAUM,2BAAA;ArFqrVd;;AqF/rVQ;EAUM,6BAAA;ArFyrVd;;AqFnsVQ;EAUM,2BAAA;ArF6rVd;;AqFvsVQ;EAUM,iDAAA;ArFisVd;;AqF3sVQ;EAUM,4CAAA;ArFqsVd;;AqF/sVQ;EAUM,4CAAA;ArFysVd;;AqFntVQ;EAUM,0CAAA;ArF6sVd;;AqFvtVQ;EAUM,4CAAA;ArFitVd;;AqF3tVQ;EAUM,6BAAA;ArFqtVd;;AqF/tVQ;EAUM,0BAAA;ArFytVd;;AqFnuVQ;EAUM,6BAAA;ArF6tVd;;AqFvuVQ;EAUM,6BAAA;ArFiuVd;;AqF3uVQ;EAUM,+BAAA;ArFquVd;;AqF/uVQ;EAUM,2BAAA;ArFyuVd;;AqFnvVQ;EAUM,2BAAA;ArF6uVd;;AqFvvVQ;EAUM,2BAAA;ArFivVd;;AqF3vVQ;EAUM,2BAAA;ArFqvVd;;AqF/vVQ;EAUM,2BAAA;ArFyvVd;;AqFnwVQ;EAUM,8BAAA;ArF6vVd;;AqFvwVQ;EAUM,yBAAA;ArFiwVd;;AqF3wVQ;EAUM,4BAAA;ArFqwVd;;AqF/wVQ;EAUM,2BAAA;ArFywVd;;AqFnxVQ;EAUM,yBAAA;ArF6wVd;;AM11VI;EAgCE,2BAAA;AN8zVN;AMt1VI;EA+BI,4BAAA;AN0zVR;;AMj2VI;EAgCE,4BAAA;ANq0VN;AM71VI;EA+BI,2BAAA;ANi0VR;;AMx2VI;EAgCE,6BAAA;AN40VN;AMp2VI;EA+BI,6BAAA;ANw0VR;;AqF5yVQ;EAUM,gCAAA;ArFsyVd;;AqFhzVQ;EAUM,qCAAA;ArF0yVd;;AqFpzVQ;EAUM,wCAAA;ArF8yVd;;AqFxzVQ;EAUM,oCAAA;ArFkzVd;;AqF5zVQ;EAUM,oCAAA;ArFszVd;;AqFh0VQ;EAUM,qCAAA;ArF0zVd;;AqFp0VQ;EAUM,8BAAA;ArF8zVd;;AqFx0VQ;EAUM,8BAAA;ArFk0Vd;;AqF11VQ,qBAAA;AAcA;EAUM,gCAAA;EAAA,iCAAA;ArFw0Vd;;AqFpzVQ,mBAAA;AA9BA;EAIQ,qBAAA;EAMF,uEAAA;ArF80Vd;;AqFx1VQ;EAIQ,qBAAA;EAMF,yEAAA;ArFm1Vd;;AqF71VQ;EAIQ,qBAAA;EAMF,uEAAA;ArFw1Vd;;AqFl2VQ;EAIQ,qBAAA;EAMF,oEAAA;ArF61Vd;;AqFv2VQ;EAIQ,qBAAA;EAMF,uEAAA;ArFk2Vd;;AqF52VQ;EAIQ,qBAAA;EAMF,sEAAA;ArFu2Vd;;AqFj3VQ;EAIQ,qBAAA;EAMF,qEAAA;ArF42Vd;;AqFt3VQ;EAIQ,qBAAA;EAMF,oEAAA;ArFi3Vd;;AqF33VQ;EAIQ,qBAAA;EAMF,qEAAA;ArFs3Vd;;AqFh4VQ;EAIQ,qBAAA;EAMF,qEAAA;ArF23Vd;;AqFr4VQ;EAIQ,qBAAA;EAMF,0EAAA;ArFg4Vd;;AqF14VQ;EAIQ,qBAAA;EAMF,4CAAA;ArFq4Vd;;AqF/4VQ;EAIQ,qBAAA;EAMF,uCAAA;ArF04Vd;;AqFp5VQ;EAIQ,qBAAA;EAMF,0CAAA;ArF+4Vd;;AqFz5VQ;EAIQ,qBAAA;EAMF,4CAAA;ArFo5Vd;;AqF95VQ;EAIQ,qBAAA;EAMF,2CAAA;ArFy5Vd;;AqFn6VQ;EAIQ,qBAAA;EAMF,2CAAA;ArF85Vd;;AqFx6VQ;EAIQ,qBAAA;EAMF,yBAAA;ArFm6Vd;;AqF76VQ;EAIQ,qBAAA;EAMF,kDAAA;ArFw6Vd;;AqFl7VQ;EAIQ,qBAAA;EAMF,oDAAA;ArF66Vd;;AqFv7VQ;EAIQ,qBAAA;EAMF,6CAAA;ArFk7Vd;;AqF57VQ;EAIQ,qBAAA;EAMF,0CAAA;ArFu7Vd;;AqFj8VQ;EAIQ,qBAAA;EAMF,4CAAA;ArF47Vd;;AqFt8VQ;EAIQ,qBAAA;EAMF,qCAAA;ArFi8Vd;;AqFr9VQ;EACE,wBAAA;ArFw9VV;;AqFz9VQ;EACE,uBAAA;ArF49VV;;AqF79VQ;EACE,wBAAA;ArFg+VV;;AqFj+VQ;EACE,qBAAA;ArFo+VV;;AqFr+VQ;EACE,uBAAA;ArFw+VV;;AqFp+VU;EACE,uBAAA;ArFu+VZ;;AqF7+VQ;EACE,wBAAA;ArFg/VV;;AqF5+VU;EACE,wBAAA;ArF++VZ;;AqFr/VQ;EACE,uBAAA;ArFw/VV;;AqFp/VU;EACE,uBAAA;ArFu/VZ;;AqF7/VQ;EACE,wBAAA;ArFggWV;;AqF5/VU;EACE,wBAAA;ArF+/VZ;;AqFrgWQ;EACE,qBAAA;ArFwgWV;;AqFpgWU;EACE,qBAAA;ArFugWZ;;AqFngWQ;EAUM,yCAAA;ArF6/Vd;;AqFv/VU;EAOI,yCAAA;ArFo/Vd;;AqF3gWQ;EAUM,wCAAA;ArFqgWd;;AqF//VU;EAOI,wCAAA;ArF4/Vd;;AqFnhWQ;EAUM,yCAAA;ArF6gWd;;AqFvgWU;EAOI,yCAAA;ArFogWd;;AqF3hWQ;EAIQ,+BAAA;EAMF,iGAAA;ArFshWd;;AqFhiWQ;EAIQ,+BAAA;EAMF,mGAAA;ArF2hWd;;AqFriWQ;EAIQ,+BAAA;EAMF,iGAAA;ArFgiWd;;AqF1iWQ;EAIQ,+BAAA;EAMF,8FAAA;ArFqiWd;;AqF/iWQ;EAIQ,+BAAA;EAMF,iGAAA;ArF0iWd;;AqFpjWQ;EAIQ,+BAAA;EAMF,gGAAA;ArF+iWd;;AqFzjWQ;EAIQ,+BAAA;EAMF,+FAAA;ArFojWd;;AqF9jWQ;EAIQ,+BAAA;EAMF,8FAAA;ArFyjWd;;AqFnkWQ;EAIQ,+BAAA;EAMF,uGAAA;ArF8jWd;;AqFllWQ;EACE,+BAAA;ArFqlWV;;AqFjlWU;EACE,+BAAA;ArFolWZ;;AqF1lWQ;EACE,iCAAA;ArF6lWV;;AqFzlWU;EACE,iCAAA;ArF4lWZ;;AqFlmWQ;EACE,kCAAA;ArFqmWV;;AqFjmWU;EACE,kCAAA;ArFomWZ;;AqF1mWQ;EACE,iCAAA;ArF6mWV;;AqFzmWU;EACE,iCAAA;ArF4mWZ;;AqFlnWQ;EACE,kCAAA;ArFqnWV;;AqFjnWU;EACE,kCAAA;ArFonWZ;;AqF1nWQ;EACE,+BAAA;ArF6nWV;;AqFznWU;EACE,+BAAA;ArF4nWZ;;AqFxnWQ;EAIQ,mBAAA;EAMF,gFAAA;ArFmnWd;;AqF7nWQ;EAIQ,mBAAA;EAMF,kFAAA;ArFwnWd;;AqFloWQ;EAIQ,mBAAA;EAMF,gFAAA;ArF6nWd;;AqFvoWQ;EAIQ,mBAAA;EAMF,6EAAA;ArFkoWd;;AqF5oWQ;EAIQ,mBAAA;EAMF,gFAAA;ArFuoWd;;AqFjpWQ;EAIQ,mBAAA;EAMF,+EAAA;ArF4oWd;;AqFtpWQ;EAIQ,mBAAA;EAMF,8EAAA;ArFipWd;;AqF3pWQ;EAIQ,mBAAA;EAMF,6EAAA;ArFspWd;;AqFhqWQ;EAIQ,mBAAA;EAMF,8EAAA;ArF2pWd;;AqFrqWQ;EAIQ,mBAAA;EAMF,8EAAA;ArFgqWd;;AqF1qWQ;EAIQ,mBAAA;EAMF,gFAAA;ArFqqWd;;AqF/qWQ;EAIQ,mBAAA;EAMF,wCAAA;ArF0qWd;;AqFprWQ;EAIQ,mBAAA;EAMF,qFAAA;ArF+qWd;;AqFzrWQ;EAIQ,mBAAA;EAMF,oFAAA;ArForWd;;AqFxsWQ;EACE,qBAAA;ArF2sWV;;AqF5sWQ;EACE,sBAAA;ArF+sWV;;AqFhtWQ;EACE,qBAAA;ArFmtWV;;AqFptWQ;EACE,sBAAA;ArFutWV;;AqFxtWQ;EACE,mBAAA;ArF2tWV;;AqFltWQ;EAUM,gDAAA;ArF4sWd;;AqFttWQ;EAUM,mCAAA;UAAA,2BAAA;ArFgtWd;;AqF1tWQ;EAUM,oCAAA;UAAA,4BAAA;ArFotWd;;AqF9tWQ;EAUM,oCAAA;UAAA,4BAAA;ArFwtWd;;AqFluWQ;EAUM,+BAAA;ArF4tWd;;AqFtuWQ;EAUM,+BAAA;ArFguWd;;AqF1uWQ;EAUM,kDAAA;ArFouWd;;AqF9uWQ;EAUM,2BAAA;ArFwuWd;;AqFlvWQ;EAUM,qDAAA;ArF4uWd;;AqFtvWQ;EAUM,kDAAA;ArFgvWd;;AqF1vWQ;EAUM,qDAAA;ArFovWd;;AqF9vWQ;EAUM,qDAAA;ArFwvWd;;AqFlwWQ;EAUM,sDAAA;ArF4vWd;;AqFtwWQ;EAUM,6BAAA;ArFgwWd;;AqF1wWQ;EAUM,uDAAA;ArFowWd;;AqF9wWQ;EAUM,2DAAA;EAAA,4DAAA;ArFywWd;;AqFnxWQ;EAUM,oCAAA;EAAA,qCAAA;ArF8wWd;;AqFxxWQ;EAUM,8DAAA;EAAA,+DAAA;ArFmxWd;;AqF7xWQ;EAUM,2DAAA;EAAA,4DAAA;ArFwxWd;;AqFlyWQ;EAUM,8DAAA;EAAA,+DAAA;ArF6xWd;;AqFvyWQ;EAUM,8DAAA;EAAA,+DAAA;ArFkyWd;;AqF5yWQ;EAUM,+DAAA;EAAA,gEAAA;ArFuyWd;;AqFjzWQ;EAUM,sCAAA;EAAA,uCAAA;ArF4yWd;;AqFtzWQ;EAUM,gEAAA;EAAA,iEAAA;ArFizWd;;AM93WI;EAgCE,4DAAA;ANk2WN;AM13WI;EA+BI,2DAAA;AN81WR;AMr4WI;EAgCE,+DAAA;ANw2WN;AMh4WI;EA+BI,8DAAA;ANo2WR;;AM34WI;EAgCE,qCAAA;AN+2WN;AMv4WI;EA+BI,oCAAA;AN22WR;AMl5WI;EAgCE,wCAAA;ANq3WN;AM74WI;EA+BI,uCAAA;ANi3WR;;AMx5WI;EAgCE,+DAAA;AN43WN;AMp5WI;EA+BI,8DAAA;ANw3WR;AM/5WI;EAgCE,kEAAA;ANk4WN;AM15WI;EA+BI,iEAAA;AN83WR;;AMr6WI;EAgCE,4DAAA;ANy4WN;AMj6WI;EA+BI,2DAAA;ANq4WR;AM56WI;EAgCE,+DAAA;AN+4WN;AMv6WI;EA+BI,8DAAA;AN24WR;;AMl7WI;EAgCE,+DAAA;ANs5WN;AM96WI;EA+BI,8DAAA;ANk5WR;AMz7WI;EAgCE,kEAAA;AN45WN;AMp7WI;EA+BI,iEAAA;ANw5WR;;AM/7WI;EAgCE,+DAAA;ANm6WN;AM37WI;EA+BI,8DAAA;AN+5WR;AMt8WI;EAgCE,kEAAA;ANy6WN;AMj8WI;EA+BI,iEAAA;ANq6WR;;AM58WI;EAgCE,gEAAA;ANg7WN;AMx8WI;EA+BI,+DAAA;AN46WR;AMn9WI;EAgCE,mEAAA;ANs7WN;AM98WI;EA+BI,kEAAA;ANk7WR;;AMz9WI;EAgCE,uCAAA;AN67WN;AMr9WI;EA+BI,sCAAA;ANy7WR;AMh+WI;EAgCE,0CAAA;ANm8WN;AM39WI;EA+BI,yCAAA;AN+7WR;;AMt+WI;EAgCE,iEAAA;AN08WN;AMl+WI;EA+BI,gEAAA;ANs8WR;AM7+WI;EAgCE,oEAAA;ANg9WN;AMx+WI;EA+BI,mEAAA;AN48WR;;AqFh7WQ;EAUM,+DAAA;EAAA,8DAAA;ArF26Wd;;AqFr7WQ;EAUM,wCAAA;EAAA,uCAAA;ArFg7Wd;;AqF17WQ;EAUM,kEAAA;EAAA,iEAAA;ArFq7Wd;;AqF/7WQ;EAUM,+DAAA;EAAA,8DAAA;ArF07Wd;;AqFp8WQ;EAUM,kEAAA;EAAA,iEAAA;ArF+7Wd;;AqFz8WQ;EAUM,kEAAA;EAAA,iEAAA;ArFo8Wd;;AqF98WQ;EAUM,mEAAA;EAAA,kEAAA;ArFy8Wd;;AqFn9WQ;EAUM,0CAAA;EAAA,yCAAA;ArF88Wd;;AqFx9WQ;EAUM,oEAAA;EAAA,mEAAA;ArFm9Wd;;AMhiXI;EAgCE,8DAAA;ANogXN;AM5hXI;EA+BI,+DAAA;ANggXR;AMviXI;EAgCE,2DAAA;AN0gXN;AMliXI;EA+BI,4DAAA;ANsgXR;;AM7iXI;EAgCE,uCAAA;ANihXN;AMziXI;EA+BI,wCAAA;AN6gXR;AMpjXI;EAgCE,oCAAA;ANuhXN;AM/iXI;EA+BI,qCAAA;ANmhXR;;AM1jXI;EAgCE,iEAAA;AN8hXN;AMtjXI;EA+BI,kEAAA;AN0hXR;AMjkXI;EAgCE,8DAAA;ANoiXN;AM5jXI;EA+BI,+DAAA;ANgiXR;;AMvkXI;EAgCE,8DAAA;AN2iXN;AMnkXI;EA+BI,+DAAA;ANuiXR;AM9kXI;EAgCE,2DAAA;ANijXN;AMzkXI;EA+BI,4DAAA;AN6iXR;;AMplXI;EAgCE,iEAAA;ANwjXN;AMhlXI;EA+BI,kEAAA;ANojXR;AM3lXI;EAgCE,8DAAA;AN8jXN;AMtlXI;EA+BI,+DAAA;AN0jXR;;AMjmXI;EAgCE,iEAAA;ANqkXN;AM7lXI;EA+BI,kEAAA;ANikXR;AMxmXI;EAgCE,8DAAA;AN2kXN;AMnmXI;EA+BI,+DAAA;ANukXR;;AM9mXI;EAgCE,kEAAA;ANklXN;AM1mXI;EA+BI,mEAAA;AN8kXR;AMrnXI;EAgCE,+DAAA;ANwlXN;AMhnXI;EA+BI,gEAAA;ANolXR;;AM3nXI;EAgCE,yCAAA;AN+lXN;AMvnXI;EA+BI,0CAAA;AN2lXR;AMloXI;EAgCE,sCAAA;ANqmXN;AM7nXI;EA+BI,uCAAA;ANimXR;;AMxoXI;EAgCE,mEAAA;AN4mXN;AMpoXI;EA+BI,oEAAA;ANwmXR;AM/oXI;EAgCE,gEAAA;ANknXN;AM1oXI;EA+BI,iEAAA;AN8mXR;;AqFllXQ;EAUM,8BAAA;ArF4kXd;;AqFtlXQ;EAUM,6BAAA;ArFglXd;;AqF1lXQ;EAUM,sBAAA;ArFolXd;;AqF9lXQ;EAUM,qBAAA;ArFwlXd;;AqFlmXQ;EAUM,qBAAA;ArF4lXd;;AqFtmXQ;EAUM,qBAAA;ArFgmXd;;AqF1mXQ;EAUM,qBAAA;ArFomXd;;AcpnXI;ER7DA;IAgCE,sBAAA;ENspXJ;EM9qXE;IA+BI,uBAAA;ENkpXN;EMzrXE;IAgCE,uBAAA;EN4pXJ;EMprXE;IA+BI,sBAAA;ENwpXN;EM/rXE;IAgCE,sBAAA;ENkqXJ;EM1rXE;IA+BI,sBAAA;EN8pXN;EqFloXM;IAUM,8BAAA;ErF2nXZ;EqFroXM;IAUM,4BAAA;ErF8nXZ;EqFxoXM;IAUM,2BAAA;ErFioXZ;EqF3oXM;IAUM,iCAAA;ErFooXZ;EqF9oXM;IAUM,2BAAA;ErFuoXZ;EqFjpXM;IAUM,0BAAA;ErF0oXZ;EqFppXM;IAUM,gCAAA;ErF6oXZ;EqFvpXM;IAUM,yBAAA;ErFgpXZ;EqF1pXM;IAUM,wBAAA;ErFmpXZ;EqF7pXM;IAUM,+BAAA;ErFspXZ;EqFhqXM;IAUM,yBAAA;ErFypXZ;EqFnqXM;IAUM,6BAAA;ErF4pXZ;EqFtqXM;IAUM,8BAAA;ErF+pXZ;EqFzqXM;IAUM,wBAAA;ErFkqXZ;EqF5qXM;IAUM,+BAAA;ErFqqXZ;EqF/qXM;IAUM,wBAAA;ErFwqXZ;EqFlrXM;IAUM,yBAAA;ErF2qXZ;EqFrrXM;IAUM,8BAAA;ErF8qXZ;EqFxrXM;IAUM,iCAAA;ErFirXZ;EqF3rXM;IAUM,sCAAA;ErForXZ;EqF9rXM;IAUM,yCAAA;ErFurXZ;EqFjsXM;IAUM,uBAAA;ErF0rXZ;EqFpsXM;IAUM,uBAAA;ErF6rXZ;EqFvsXM;IAUM,yBAAA;ErFgsXZ;EqF1sXM;IAUM,yBAAA;ErFmsXZ;EqF7sXM;IAUM,0BAAA;ErFssXZ;EqFhtXM;IAUM,4BAAA;ErFysXZ;EqFntXM;IAUM,kCAAA;ErF4sXZ;EqFttXM;IAUM,sCAAA;ErF+sXZ;EqFztXM;IAUM,oCAAA;ErFktXZ;EqF5tXM;IAUM,kCAAA;ErFqtXZ;EqF/tXM;IAUM,yCAAA;ErFwtXZ;EqFluXM;IAUM,wCAAA;ErF2tXZ;EqFruXM;IAUM,wCAAA;ErF8tXZ;EqFxuXM;IAUM,kCAAA;ErFiuXZ;EqF3uXM;IAUM,gCAAA;ErFouXZ;EqF9uXM;IAUM,8BAAA;ErFuuXZ;EqFjvXM;IAUM,gCAAA;ErF0uXZ;EqFpvXM;IAUM,+BAAA;ErF6uXZ;EqFvvXM;IAUM,oCAAA;ErFgvXZ;EqF1vXM;IAUM,kCAAA;ErFmvXZ;EqF7vXM;IAUM,gCAAA;ErFsvXZ;EqFhwXM;IAUM,uCAAA;ErFyvXZ;EqFnwXM;IAUM,sCAAA;ErF4vXZ;EqFtwXM;IAUM,iCAAA;ErF+vXZ;EqFzwXM;IAUM,2BAAA;ErFkwXZ;EqF5wXM;IAUM,iCAAA;ErFqwXZ;EqF/wXM;IAUM,+BAAA;ErFwwXZ;EqFlxXM;IAUM,6BAAA;ErF2wXZ;EqFrxXM;IAUM,+BAAA;ErF8wXZ;EqFxxXM;IAUM,8BAAA;ErFixXZ;EqF3xXM;IAUM,oBAAA;ErFoxXZ;EqF9xXM;IAUM,mBAAA;ErFuxXZ;EqFjyXM;IAUM,mBAAA;ErF0xXZ;EqFpyXM;IAUM,mBAAA;ErF6xXZ;EqFvyXM;IAUM,mBAAA;ErFgyXZ;EqF1yXM;IAUM,mBAAA;ErFmyXZ;EqF7yXM;IAUM,mBAAA;ErFsyXZ;EqFhzXM;IAUM,mBAAA;ErFyyXZ;EqFnzXM;IAUM,oBAAA;ErF4yXZ;EqFtzXM;IAUM,0BAAA;ErF+yXZ;EqFzzXM;IAUM,yBAAA;ErFkzXZ;EqF5zXM;IAUM,uBAAA;ErFqzXZ;EqF/zXM;IAUM,yBAAA;ErFwzXZ;EqFl0XM;IAUM,uBAAA;ErF2zXZ;EqFr0XM;IAUM,uBAAA;ErF8zXZ;EqFx0XM;IAUM,0BAAA;IAAA,yBAAA;ErFk0XZ;EqF50XM;IAUM,gCAAA;IAAA,+BAAA;ErFs0XZ;EqFh1XM;IAUM,+BAAA;IAAA,8BAAA;ErF00XZ;EqFp1XM;IAUM,6BAAA;IAAA,4BAAA;ErF80XZ;EqFx1XM;IAUM,+BAAA;IAAA,8BAAA;ErFk1XZ;EqF51XM;IAUM,6BAAA;IAAA,4BAAA;ErFs1XZ;EqFh2XM;IAUM,6BAAA;IAAA,4BAAA;ErF01XZ;EqFp2XM;IAUM,wBAAA;IAAA,2BAAA;ErF81XZ;EqFx2XM;IAUM,8BAAA;IAAA,iCAAA;ErFk2XZ;EqF52XM;IAUM,6BAAA;IAAA,gCAAA;ErFs2XZ;EqFh3XM;IAUM,2BAAA;IAAA,8BAAA;ErF02XZ;EqFp3XM;IAUM,6BAAA;IAAA,gCAAA;ErF82XZ;EqFx3XM;IAUM,2BAAA;IAAA,8BAAA;ErFk3XZ;EqF53XM;IAUM,2BAAA;IAAA,8BAAA;ErFs3XZ;EqFh4XM;IAUM,wBAAA;ErFy3XZ;EqFn4XM;IAUM,8BAAA;ErF43XZ;EqFt4XM;IAUM,6BAAA;ErF+3XZ;EqFz4XM;IAUM,2BAAA;ErFk4XZ;EqF54XM;IAUM,6BAAA;ErFq4XZ;EqF/4XM;IAUM,2BAAA;ErFw4XZ;EqFl5XM;IAUM,2BAAA;ErF24XZ;EMx9XE;IAgCE,0BAAA;EN27XJ;EMn9XE;IA+BI,yBAAA;ENu7XN;EM99XE;IAgCE,gCAAA;ENi8XJ;EMz9XE;IA+BI,+BAAA;EN67XN;EMp+XE;IAgCE,+BAAA;ENu8XJ;EM/9XE;IA+BI,8BAAA;ENm8XN;EM1+XE;IAgCE,6BAAA;EN68XJ;EMr+XE;IA+BI,4BAAA;ENy8XN;EMh/XE;IAgCE,+BAAA;ENm9XJ;EM3+XE;IA+BI,8BAAA;EN+8XN;EMt/XE;IAgCE,6BAAA;ENy9XJ;EMj/XE;IA+BI,4BAAA;ENq9XN;EM5/XE;IAgCE,6BAAA;EN+9XJ;EMv/XE;IA+BI,4BAAA;EN29XN;EqF/7XM;IAUM,2BAAA;ErFw7XZ;EqFl8XM;IAUM,iCAAA;ErF27XZ;EqFr8XM;IAUM,gCAAA;ErF87XZ;EqFx8XM;IAUM,8BAAA;ErFi8XZ;EqF38XM;IAUM,gCAAA;ErFo8XZ;EqF98XM;IAUM,8BAAA;ErFu8XZ;EqFj9XM;IAUM,8BAAA;ErF08XZ;EMvhYE;IAgCE,yBAAA;EN0/XJ;EMlhYE;IA+BI,0BAAA;ENs/XN;EM7hYE;IAgCE,+BAAA;ENggYJ;EMxhYE;IA+BI,gCAAA;EN4/XN;EMniYE;IAgCE,8BAAA;ENsgYJ;EM9hYE;IA+BI,+BAAA;ENkgYN;EMziYE;IAgCE,4BAAA;EN4gYJ;EMpiYE;IA+BI,6BAAA;ENwgYN;EM/iYE;IAgCE,8BAAA;ENkhYJ;EM1iYE;IA+BI,+BAAA;EN8gYN;EMrjYE;IAgCE,4BAAA;ENwhYJ;EMhjYE;IA+BI,6BAAA;ENohYN;EM3jYE;IAgCE,4BAAA;EN8hYJ;EMtjYE;IA+BI,6BAAA;EN0hYN;EqF9/XM;IAUM,qBAAA;ErFu/XZ;EqFjgYM;IAUM,2BAAA;ErF0/XZ;EqFpgYM;IAUM,0BAAA;ErF6/XZ;EqFvgYM;IAUM,wBAAA;ErFggYZ;EqF1gYM;IAUM,0BAAA;ErFmgYZ;EqF7gYM;IAUM,wBAAA;ErFsgYZ;EqFhhYM;IAUM,2BAAA;IAAA,0BAAA;ErF0gYZ;EqFphYM;IAUM,iCAAA;IAAA,gCAAA;ErF8gYZ;EqFxhYM;IAUM,gCAAA;IAAA,+BAAA;ErFkhYZ;EqF5hYM;IAUM,8BAAA;IAAA,6BAAA;ErFshYZ;EqFhiYM;IAUM,gCAAA;IAAA,+BAAA;ErF0hYZ;EqFpiYM;IAUM,8BAAA;IAAA,6BAAA;ErF8hYZ;EqFxiYM;IAUM,yBAAA;IAAA,4BAAA;ErFkiYZ;EqF5iYM;IAUM,+BAAA;IAAA,kCAAA;ErFsiYZ;EqFhjYM;IAUM,8BAAA;IAAA,iCAAA;ErF0iYZ;EqFpjYM;IAUM,4BAAA;IAAA,+BAAA;ErF8iYZ;EqFxjYM;IAUM,8BAAA;IAAA,iCAAA;ErFkjYZ;EqF5jYM;IAUM,4BAAA;IAAA,+BAAA;ErFsjYZ;EqFhkYM;IAUM,yBAAA;ErFyjYZ;EqFnkYM;IAUM,+BAAA;ErF4jYZ;EqFtkYM;IAUM,8BAAA;ErF+jYZ;EqFzkYM;IAUM,4BAAA;ErFkkYZ;EqF5kYM;IAUM,8BAAA;ErFqkYZ;EqF/kYM;IAUM,4BAAA;ErFwkYZ;EMrpYE;IAgCE,2BAAA;ENwnYJ;EMhpYE;IA+BI,0BAAA;ENonYN;EM3pYE;IAgCE,iCAAA;EN8nYJ;EMtpYE;IA+BI,gCAAA;EN0nYN;EMjqYE;IAgCE,gCAAA;ENooYJ;EM5pYE;IA+BI,+BAAA;ENgoYN;EMvqYE;IAgCE,8BAAA;EN0oYJ;EMlqYE;IA+BI,6BAAA;ENsoYN;EM7qYE;IAgCE,gCAAA;ENgpYJ;EMxqYE;IA+BI,+BAAA;EN4oYN;EMnrYE;IAgCE,8BAAA;ENspYJ;EM9qYE;IA+BI,6BAAA;ENkpYN;EqFtnYM;IAUM,4BAAA;ErF+mYZ;EqFznYM;IAUM,kCAAA;ErFknYZ;EqF5nYM;IAUM,iCAAA;ErFqnYZ;EqF/nYM;IAUM,+BAAA;ErFwnYZ;EqFloYM;IAUM,iCAAA;ErF2nYZ;EqFroYM;IAUM,+BAAA;ErF8nYZ;EM3sYE;IAgCE,0BAAA;EN8qYJ;EMtsYE;IA+BI,2BAAA;EN0qYN;EMjtYE;IAgCE,gCAAA;ENorYJ;EM5sYE;IA+BI,iCAAA;ENgrYN;EMvtYE;IAgCE,+BAAA;EN0rYJ;EMltYE;IA+BI,gCAAA;ENsrYN;EM7tYE;IAgCE,6BAAA;ENgsYJ;EMxtYE;IA+BI,8BAAA;EN4rYN;EMnuYE;IAgCE,+BAAA;ENssYJ;EM9tYE;IA+BI,gCAAA;ENksYN;EMzuYE;IAgCE,6BAAA;EN4sYJ;EMpuYE;IA+BI,8BAAA;ENwsYN;EqF5qYM;IAUM,iBAAA;ErFqqYZ;EqF/qYM;IAUM,uBAAA;ErFwqYZ;EqFlrYM;IAUM,sBAAA;ErF2qYZ;EqFrrYM;IAUM,oBAAA;ErF8qYZ;EqFxrYM;IAUM,sBAAA;ErFirYZ;EqF3rYM;IAUM,oBAAA;ErForYZ;EqF9rYM;IAUM,qBAAA;ErFurYZ;EqFjsYM;IAUM,2BAAA;ErF0rYZ;EqFpsYM;IAUM,0BAAA;ErF6rYZ;EqFvsYM;IAUM,wBAAA;ErFgsYZ;EqF1sYM;IAUM,0BAAA;ErFmsYZ;EqF7sYM;IAUM,wBAAA;ErFssYZ;EqFhtYM;IAUM,wBAAA;ErFysYZ;EqFntYM;IAUM,8BAAA;ErF4sYZ;EqFttYM;IAUM,6BAAA;ErF+sYZ;EqFztYM;IAUM,2BAAA;ErFktYZ;EqF5tYM;IAUM,6BAAA;ErFqtYZ;EqF/tYM;IAUM,2BAAA;ErFwtYZ;EMryYE;IAgCE,2BAAA;ENwwYJ;EMhyYE;IA+BI,4BAAA;ENowYN;EM3yYE;IAgCE,4BAAA;EN8wYJ;EMtyYE;IA+BI,2BAAA;EN0wYN;EMjzYE;IAgCE,6BAAA;ENoxYJ;EM5yYE;IA+BI,6BAAA;ENgxYN;AACF;Ac3vYI;ER7DA;IAgCE,sBAAA;EN4xYJ;EMpzYE;IA+BI,uBAAA;ENwxYN;EM/zYE;IAgCE,uBAAA;ENkyYJ;EM1zYE;IA+BI,sBAAA;EN8xYN;EMr0YE;IAgCE,sBAAA;ENwyYJ;EMh0YE;IA+BI,sBAAA;ENoyYN;EqFxwYM;IAUM,8BAAA;ErFiwYZ;EqF3wYM;IAUM,4BAAA;ErFowYZ;EqF9wYM;IAUM,2BAAA;ErFuwYZ;EqFjxYM;IAUM,iCAAA;ErF0wYZ;EqFpxYM;IAUM,2BAAA;ErF6wYZ;EqFvxYM;IAUM,0BAAA;ErFgxYZ;EqF1xYM;IAUM,gCAAA;ErFmxYZ;EqF7xYM;IAUM,yBAAA;ErFsxYZ;EqFhyYM;IAUM,wBAAA;ErFyxYZ;EqFnyYM;IAUM,+BAAA;ErF4xYZ;EqFtyYM;IAUM,yBAAA;ErF+xYZ;EqFzyYM;IAUM,6BAAA;ErFkyYZ;EqF5yYM;IAUM,8BAAA;ErFqyYZ;EqF/yYM;IAUM,wBAAA;ErFwyYZ;EqFlzYM;IAUM,+BAAA;ErF2yYZ;EqFrzYM;IAUM,wBAAA;ErF8yYZ;EqFxzYM;IAUM,yBAAA;ErFizYZ;EqF3zYM;IAUM,8BAAA;ErFozYZ;EqF9zYM;IAUM,iCAAA;ErFuzYZ;EqFj0YM;IAUM,sCAAA;ErF0zYZ;EqFp0YM;IAUM,yCAAA;ErF6zYZ;EqFv0YM;IAUM,uBAAA;ErFg0YZ;EqF10YM;IAUM,uBAAA;ErFm0YZ;EqF70YM;IAUM,yBAAA;ErFs0YZ;EqFh1YM;IAUM,yBAAA;ErFy0YZ;EqFn1YM;IAUM,0BAAA;ErF40YZ;EqFt1YM;IAUM,4BAAA;ErF+0YZ;EqFz1YM;IAUM,kCAAA;ErFk1YZ;EqF51YM;IAUM,sCAAA;ErFq1YZ;EqF/1YM;IAUM,oCAAA;ErFw1YZ;EqFl2YM;IAUM,kCAAA;ErF21YZ;EqFr2YM;IAUM,yCAAA;ErF81YZ;EqFx2YM;IAUM,wCAAA;ErFi2YZ;EqF32YM;IAUM,wCAAA;ErFo2YZ;EqF92YM;IAUM,kCAAA;ErFu2YZ;EqFj3YM;IAUM,gCAAA;ErF02YZ;EqFp3YM;IAUM,8BAAA;ErF62YZ;EqFv3YM;IAUM,gCAAA;ErFg3YZ;EqF13YM;IAUM,+BAAA;ErFm3YZ;EqF73YM;IAUM,oCAAA;ErFs3YZ;EqFh4YM;IAUM,kCAAA;ErFy3YZ;EqFn4YM;IAUM,gCAAA;ErF43YZ;EqFt4YM;IAUM,uCAAA;ErF+3YZ;EqFz4YM;IAUM,sCAAA;ErFk4YZ;EqF54YM;IAUM,iCAAA;ErFq4YZ;EqF/4YM;IAUM,2BAAA;ErFw4YZ;EqFl5YM;IAUM,iCAAA;ErF24YZ;EqFr5YM;IAUM,+BAAA;ErF84YZ;EqFx5YM;IAUM,6BAAA;ErFi5YZ;EqF35YM;IAUM,+BAAA;ErFo5YZ;EqF95YM;IAUM,8BAAA;ErFu5YZ;EqFj6YM;IAUM,oBAAA;ErF05YZ;EqFp6YM;IAUM,mBAAA;ErF65YZ;EqFv6YM;IAUM,mBAAA;ErFg6YZ;EqF16YM;IAUM,mBAAA;ErFm6YZ;EqF76YM;IAUM,mBAAA;ErFs6YZ;EqFh7YM;IAUM,mBAAA;ErFy6YZ;EqFn7YM;IAUM,mBAAA;ErF46YZ;EqFt7YM;IAUM,mBAAA;ErF+6YZ;EqFz7YM;IAUM,oBAAA;ErFk7YZ;EqF57YM;IAUM,0BAAA;ErFq7YZ;EqF/7YM;IAUM,yBAAA;ErFw7YZ;EqFl8YM;IAUM,uBAAA;ErF27YZ;EqFr8YM;IAUM,yBAAA;ErF87YZ;EqFx8YM;IAUM,uBAAA;ErFi8YZ;EqF38YM;IAUM,uBAAA;ErFo8YZ;EqF98YM;IAUM,0BAAA;IAAA,yBAAA;ErFw8YZ;EqFl9YM;IAUM,gCAAA;IAAA,+BAAA;ErF48YZ;EqFt9YM;IAUM,+BAAA;IAAA,8BAAA;ErFg9YZ;EqF19YM;IAUM,6BAAA;IAAA,4BAAA;ErFo9YZ;EqF99YM;IAUM,+BAAA;IAAA,8BAAA;ErFw9YZ;EqFl+YM;IAUM,6BAAA;IAAA,4BAAA;ErF49YZ;EqFt+YM;IAUM,6BAAA;IAAA,4BAAA;ErFg+YZ;EqF1+YM;IAUM,wBAAA;IAAA,2BAAA;ErFo+YZ;EqF9+YM;IAUM,8BAAA;IAAA,iCAAA;ErFw+YZ;EqFl/YM;IAUM,6BAAA;IAAA,gCAAA;ErF4+YZ;EqFt/YM;IAUM,2BAAA;IAAA,8BAAA;ErFg/YZ;EqF1/YM;IAUM,6BAAA;IAAA,gCAAA;ErFo/YZ;EqF9/YM;IAUM,2BAAA;IAAA,8BAAA;ErFw/YZ;EqFlgZM;IAUM,2BAAA;IAAA,8BAAA;ErF4/YZ;EqFtgZM;IAUM,wBAAA;ErF+/YZ;EqFzgZM;IAUM,8BAAA;ErFkgZZ;EqF5gZM;IAUM,6BAAA;ErFqgZZ;EqF/gZM;IAUM,2BAAA;ErFwgZZ;EqFlhZM;IAUM,6BAAA;ErF2gZZ;EqFrhZM;IAUM,2BAAA;ErF8gZZ;EqFxhZM;IAUM,2BAAA;ErFihZZ;EM9lZE;IAgCE,0BAAA;ENikZJ;EMzlZE;IA+BI,yBAAA;EN6jZN;EMpmZE;IAgCE,gCAAA;ENukZJ;EM/lZE;IA+BI,+BAAA;ENmkZN;EM1mZE;IAgCE,+BAAA;EN6kZJ;EMrmZE;IA+BI,8BAAA;ENykZN;EMhnZE;IAgCE,6BAAA;ENmlZJ;EM3mZE;IA+BI,4BAAA;EN+kZN;EMtnZE;IAgCE,+BAAA;ENylZJ;EMjnZE;IA+BI,8BAAA;ENqlZN;EM5nZE;IAgCE,6BAAA;EN+lZJ;EMvnZE;IA+BI,4BAAA;EN2lZN;EMloZE;IAgCE,6BAAA;ENqmZJ;EM7nZE;IA+BI,4BAAA;ENimZN;EqFrkZM;IAUM,2BAAA;ErF8jZZ;EqFxkZM;IAUM,iCAAA;ErFikZZ;EqF3kZM;IAUM,gCAAA;ErFokZZ;EqF9kZM;IAUM,8BAAA;ErFukZZ;EqFjlZM;IAUM,gCAAA;ErF0kZZ;EqFplZM;IAUM,8BAAA;ErF6kZZ;EqFvlZM;IAUM,8BAAA;ErFglZZ;EM7pZE;IAgCE,yBAAA;ENgoZJ;EMxpZE;IA+BI,0BAAA;EN4nZN;EMnqZE;IAgCE,+BAAA;ENsoZJ;EM9pZE;IA+BI,gCAAA;ENkoZN;EMzqZE;IAgCE,8BAAA;EN4oZJ;EMpqZE;IA+BI,+BAAA;ENwoZN;EM/qZE;IAgCE,4BAAA;ENkpZJ;EM1qZE;IA+BI,6BAAA;EN8oZN;EMrrZE;IAgCE,8BAAA;ENwpZJ;EMhrZE;IA+BI,+BAAA;ENopZN;EM3rZE;IAgCE,4BAAA;EN8pZJ;EMtrZE;IA+BI,6BAAA;EN0pZN;EMjsZE;IAgCE,4BAAA;ENoqZJ;EM5rZE;IA+BI,6BAAA;ENgqZN;EqFpoZM;IAUM,qBAAA;ErF6nZZ;EqFvoZM;IAUM,2BAAA;ErFgoZZ;EqF1oZM;IAUM,0BAAA;ErFmoZZ;EqF7oZM;IAUM,wBAAA;ErFsoZZ;EqFhpZM;IAUM,0BAAA;ErFyoZZ;EqFnpZM;IAUM,wBAAA;ErF4oZZ;EqFtpZM;IAUM,2BAAA;IAAA,0BAAA;ErFgpZZ;EqF1pZM;IAUM,iCAAA;IAAA,gCAAA;ErFopZZ;EqF9pZM;IAUM,gCAAA;IAAA,+BAAA;ErFwpZZ;EqFlqZM;IAUM,8BAAA;IAAA,6BAAA;ErF4pZZ;EqFtqZM;IAUM,gCAAA;IAAA,+BAAA;ErFgqZZ;EqF1qZM;IAUM,8BAAA;IAAA,6BAAA;ErFoqZZ;EqF9qZM;IAUM,yBAAA;IAAA,4BAAA;ErFwqZZ;EqFlrZM;IAUM,+BAAA;IAAA,kCAAA;ErF4qZZ;EqFtrZM;IAUM,8BAAA;IAAA,iCAAA;ErFgrZZ;EqF1rZM;IAUM,4BAAA;IAAA,+BAAA;ErForZZ;EqF9rZM;IAUM,8BAAA;IAAA,iCAAA;ErFwrZZ;EqFlsZM;IAUM,4BAAA;IAAA,+BAAA;ErF4rZZ;EqFtsZM;IAUM,yBAAA;ErF+rZZ;EqFzsZM;IAUM,+BAAA;ErFksZZ;EqF5sZM;IAUM,8BAAA;ErFqsZZ;EqF/sZM;IAUM,4BAAA;ErFwsZZ;EqFltZM;IAUM,8BAAA;ErF2sZZ;EqFrtZM;IAUM,4BAAA;ErF8sZZ;EM3xZE;IAgCE,2BAAA;EN8vZJ;EMtxZE;IA+BI,0BAAA;EN0vZN;EMjyZE;IAgCE,iCAAA;ENowZJ;EM5xZE;IA+BI,gCAAA;ENgwZN;EMvyZE;IAgCE,gCAAA;EN0wZJ;EMlyZE;IA+BI,+BAAA;ENswZN;EM7yZE;IAgCE,8BAAA;ENgxZJ;EMxyZE;IA+BI,6BAAA;EN4wZN;EMnzZE;IAgCE,gCAAA;ENsxZJ;EM9yZE;IA+BI,+BAAA;ENkxZN;EMzzZE;IAgCE,8BAAA;EN4xZJ;EMpzZE;IA+BI,6BAAA;ENwxZN;EqF5vZM;IAUM,4BAAA;ErFqvZZ;EqF/vZM;IAUM,kCAAA;ErFwvZZ;EqFlwZM;IAUM,iCAAA;ErF2vZZ;EqFrwZM;IAUM,+BAAA;ErF8vZZ;EqFxwZM;IAUM,iCAAA;ErFiwZZ;EqF3wZM;IAUM,+BAAA;ErFowZZ;EMj1ZE;IAgCE,0BAAA;ENozZJ;EM50ZE;IA+BI,2BAAA;ENgzZN;EMv1ZE;IAgCE,gCAAA;EN0zZJ;EMl1ZE;IA+BI,iCAAA;ENszZN;EM71ZE;IAgCE,+BAAA;ENg0ZJ;EMx1ZE;IA+BI,gCAAA;EN4zZN;EMn2ZE;IAgCE,6BAAA;ENs0ZJ;EM91ZE;IA+BI,8BAAA;ENk0ZN;EMz2ZE;IAgCE,+BAAA;EN40ZJ;EMp2ZE;IA+BI,gCAAA;ENw0ZN;EM/2ZE;IAgCE,6BAAA;ENk1ZJ;EM12ZE;IA+BI,8BAAA;EN80ZN;EqFlzZM;IAUM,iBAAA;ErF2yZZ;EqFrzZM;IAUM,uBAAA;ErF8yZZ;EqFxzZM;IAUM,sBAAA;ErFizZZ;EqF3zZM;IAUM,oBAAA;ErFozZZ;EqF9zZM;IAUM,sBAAA;ErFuzZZ;EqFj0ZM;IAUM,oBAAA;ErF0zZZ;EqFp0ZM;IAUM,qBAAA;ErF6zZZ;EqFv0ZM;IAUM,2BAAA;ErFg0ZZ;EqF10ZM;IAUM,0BAAA;ErFm0ZZ;EqF70ZM;IAUM,wBAAA;ErFs0ZZ;EqFh1ZM;IAUM,0BAAA;ErFy0ZZ;EqFn1ZM;IAUM,wBAAA;ErF40ZZ;EqFt1ZM;IAUM,wBAAA;ErF+0ZZ;EqFz1ZM;IAUM,8BAAA;ErFk1ZZ;EqF51ZM;IAUM,6BAAA;ErFq1ZZ;EqF/1ZM;IAUM,2BAAA;ErFw1ZZ;EqFl2ZM;IAUM,6BAAA;ErF21ZZ;EqFr2ZM;IAUM,2BAAA;ErF81ZZ;EM36ZE;IAgCE,2BAAA;EN84ZJ;EMt6ZE;IA+BI,4BAAA;EN04ZN;EMj7ZE;IAgCE,4BAAA;ENo5ZJ;EM56ZE;IA+BI,2BAAA;ENg5ZN;EMv7ZE;IAgCE,6BAAA;EN05ZJ;EMl7ZE;IA+BI,6BAAA;ENs5ZN;AACF;Acj4ZI;ER7DA;IAgCE,sBAAA;ENk6ZJ;EM17ZE;IA+BI,uBAAA;EN85ZN;EMr8ZE;IAgCE,uBAAA;ENw6ZJ;EMh8ZE;IA+BI,sBAAA;ENo6ZN;EM38ZE;IAgCE,sBAAA;EN86ZJ;EMt8ZE;IA+BI,sBAAA;EN06ZN;EqF94ZM;IAUM,8BAAA;ErFu4ZZ;EqFj5ZM;IAUM,4BAAA;ErF04ZZ;EqFp5ZM;IAUM,2BAAA;ErF64ZZ;EqFv5ZM;IAUM,iCAAA;ErFg5ZZ;EqF15ZM;IAUM,2BAAA;ErFm5ZZ;EqF75ZM;IAUM,0BAAA;ErFs5ZZ;EqFh6ZM;IAUM,gCAAA;ErFy5ZZ;EqFn6ZM;IAUM,yBAAA;ErF45ZZ;EqFt6ZM;IAUM,wBAAA;ErF+5ZZ;EqFz6ZM;IAUM,+BAAA;ErFk6ZZ;EqF56ZM;IAUM,yBAAA;ErFq6ZZ;EqF/6ZM;IAUM,6BAAA;ErFw6ZZ;EqFl7ZM;IAUM,8BAAA;ErF26ZZ;EqFr7ZM;IAUM,wBAAA;ErF86ZZ;EqFx7ZM;IAUM,+BAAA;ErFi7ZZ;EqF37ZM;IAUM,wBAAA;ErFo7ZZ;EqF97ZM;IAUM,yBAAA;ErFu7ZZ;EqFj8ZM;IAUM,8BAAA;ErF07ZZ;EqFp8ZM;IAUM,iCAAA;ErF67ZZ;EqFv8ZM;IAUM,sCAAA;ErFg8ZZ;EqF18ZM;IAUM,yCAAA;ErFm8ZZ;EqF78ZM;IAUM,uBAAA;ErFs8ZZ;EqFh9ZM;IAUM,uBAAA;ErFy8ZZ;EqFn9ZM;IAUM,yBAAA;ErF48ZZ;EqFt9ZM;IAUM,yBAAA;ErF+8ZZ;EqFz9ZM;IAUM,0BAAA;ErFk9ZZ;EqF59ZM;IAUM,4BAAA;ErFq9ZZ;EqF/9ZM;IAUM,kCAAA;ErFw9ZZ;EqFl+ZM;IAUM,sCAAA;ErF29ZZ;EqFr+ZM;IAUM,oCAAA;ErF89ZZ;EqFx+ZM;IAUM,kCAAA;ErFi+ZZ;EqF3+ZM;IAUM,yCAAA;ErFo+ZZ;EqF9+ZM;IAUM,wCAAA;ErFu+ZZ;EqFj/ZM;IAUM,wCAAA;ErF0+ZZ;EqFp/ZM;IAUM,kCAAA;ErF6+ZZ;EqFv/ZM;IAUM,gCAAA;ErFg/ZZ;EqF1/ZM;IAUM,8BAAA;ErFm/ZZ;EqF7/ZM;IAUM,gCAAA;ErFs/ZZ;EqFhgaM;IAUM,+BAAA;ErFy/ZZ;EqFngaM;IAUM,oCAAA;ErF4/ZZ;EqFtgaM;IAUM,kCAAA;ErF+/ZZ;EqFzgaM;IAUM,gCAAA;ErFkgaZ;EqF5gaM;IAUM,uCAAA;ErFqgaZ;EqF/gaM;IAUM,sCAAA;ErFwgaZ;EqFlhaM;IAUM,iCAAA;ErF2gaZ;EqFrhaM;IAUM,2BAAA;ErF8gaZ;EqFxhaM;IAUM,iCAAA;ErFihaZ;EqF3haM;IAUM,+BAAA;ErFohaZ;EqF9haM;IAUM,6BAAA;ErFuhaZ;EqFjiaM;IAUM,+BAAA;ErF0haZ;EqFpiaM;IAUM,8BAAA;ErF6haZ;EqFviaM;IAUM,oBAAA;ErFgiaZ;EqF1iaM;IAUM,mBAAA;ErFmiaZ;EqF7iaM;IAUM,mBAAA;ErFsiaZ;EqFhjaM;IAUM,mBAAA;ErFyiaZ;EqFnjaM;IAUM,mBAAA;ErF4iaZ;EqFtjaM;IAUM,mBAAA;ErF+iaZ;EqFzjaM;IAUM,mBAAA;ErFkjaZ;EqF5jaM;IAUM,mBAAA;ErFqjaZ;EqF/jaM;IAUM,oBAAA;ErFwjaZ;EqFlkaM;IAUM,0BAAA;ErF2jaZ;EqFrkaM;IAUM,yBAAA;ErF8jaZ;EqFxkaM;IAUM,uBAAA;ErFikaZ;EqF3kaM;IAUM,yBAAA;ErFokaZ;EqF9kaM;IAUM,uBAAA;ErFukaZ;EqFjlaM;IAUM,uBAAA;ErF0kaZ;EqFplaM;IAUM,0BAAA;IAAA,yBAAA;ErF8kaZ;EqFxlaM;IAUM,gCAAA;IAAA,+BAAA;ErFklaZ;EqF5laM;IAUM,+BAAA;IAAA,8BAAA;ErFslaZ;EqFhmaM;IAUM,6BAAA;IAAA,4BAAA;ErF0laZ;EqFpmaM;IAUM,+BAAA;IAAA,8BAAA;ErF8laZ;EqFxmaM;IAUM,6BAAA;IAAA,4BAAA;ErFkmaZ;EqF5maM;IAUM,6BAAA;IAAA,4BAAA;ErFsmaZ;EqFhnaM;IAUM,wBAAA;IAAA,2BAAA;ErF0maZ;EqFpnaM;IAUM,8BAAA;IAAA,iCAAA;ErF8maZ;EqFxnaM;IAUM,6BAAA;IAAA,gCAAA;ErFknaZ;EqF5naM;IAUM,2BAAA;IAAA,8BAAA;ErFsnaZ;EqFhoaM;IAUM,6BAAA;IAAA,gCAAA;ErF0naZ;EqFpoaM;IAUM,2BAAA;IAAA,8BAAA;ErF8naZ;EqFxoaM;IAUM,2BAAA;IAAA,8BAAA;ErFkoaZ;EqF5oaM;IAUM,wBAAA;ErFqoaZ;EqF/oaM;IAUM,8BAAA;ErFwoaZ;EqFlpaM;IAUM,6BAAA;ErF2oaZ;EqFrpaM;IAUM,2BAAA;ErF8oaZ;EqFxpaM;IAUM,6BAAA;ErFipaZ;EqF3paM;IAUM,2BAAA;ErFopaZ;EqF9paM;IAUM,2BAAA;ErFupaZ;EMpuaE;IAgCE,0BAAA;ENusaJ;EM/taE;IA+BI,yBAAA;ENmsaN;EM1uaE;IAgCE,gCAAA;EN6saJ;EMruaE;IA+BI,+BAAA;ENysaN;EMhvaE;IAgCE,+BAAA;ENmtaJ;EM3uaE;IA+BI,8BAAA;EN+saN;EMtvaE;IAgCE,6BAAA;ENytaJ;EMjvaE;IA+BI,4BAAA;ENqtaN;EM5vaE;IAgCE,+BAAA;EN+taJ;EMvvaE;IA+BI,8BAAA;EN2taN;EMlwaE;IAgCE,6BAAA;ENquaJ;EM7vaE;IA+BI,4BAAA;ENiuaN;EMxwaE;IAgCE,6BAAA;EN2uaJ;EMnwaE;IA+BI,4BAAA;ENuuaN;EqF3saM;IAUM,2BAAA;ErFosaZ;EqF9saM;IAUM,iCAAA;ErFusaZ;EqFjtaM;IAUM,gCAAA;ErF0saZ;EqFptaM;IAUM,8BAAA;ErF6saZ;EqFvtaM;IAUM,gCAAA;ErFgtaZ;EqF1taM;IAUM,8BAAA;ErFmtaZ;EqF7taM;IAUM,8BAAA;ErFstaZ;EMnyaE;IAgCE,yBAAA;ENswaJ;EM9xaE;IA+BI,0BAAA;ENkwaN;EMzyaE;IAgCE,+BAAA;EN4waJ;EMpyaE;IA+BI,gCAAA;ENwwaN;EM/yaE;IAgCE,8BAAA;ENkxaJ;EM1yaE;IA+BI,+BAAA;EN8waN;EMrzaE;IAgCE,4BAAA;ENwxaJ;EMhzaE;IA+BI,6BAAA;ENoxaN;EM3zaE;IAgCE,8BAAA;EN8xaJ;EMtzaE;IA+BI,+BAAA;EN0xaN;EMj0aE;IAgCE,4BAAA;ENoyaJ;EM5zaE;IA+BI,6BAAA;ENgyaN;EMv0aE;IAgCE,4BAAA;EN0yaJ;EMl0aE;IA+BI,6BAAA;ENsyaN;EqF1waM;IAUM,qBAAA;ErFmwaZ;EqF7waM;IAUM,2BAAA;ErFswaZ;EqFhxaM;IAUM,0BAAA;ErFywaZ;EqFnxaM;IAUM,wBAAA;ErF4waZ;EqFtxaM;IAUM,0BAAA;ErF+waZ;EqFzxaM;IAUM,wBAAA;ErFkxaZ;EqF5xaM;IAUM,2BAAA;IAAA,0BAAA;ErFsxaZ;EqFhyaM;IAUM,iCAAA;IAAA,gCAAA;ErF0xaZ;EqFpyaM;IAUM,gCAAA;IAAA,+BAAA;ErF8xaZ;EqFxyaM;IAUM,8BAAA;IAAA,6BAAA;ErFkyaZ;EqF5yaM;IAUM,gCAAA;IAAA,+BAAA;ErFsyaZ;EqFhzaM;IAUM,8BAAA;IAAA,6BAAA;ErF0yaZ;EqFpzaM;IAUM,yBAAA;IAAA,4BAAA;ErF8yaZ;EqFxzaM;IAUM,+BAAA;IAAA,kCAAA;ErFkzaZ;EqF5zaM;IAUM,8BAAA;IAAA,iCAAA;ErFszaZ;EqFh0aM;IAUM,4BAAA;IAAA,+BAAA;ErF0zaZ;EqFp0aM;IAUM,8BAAA;IAAA,iCAAA;ErF8zaZ;EqFx0aM;IAUM,4BAAA;IAAA,+BAAA;ErFk0aZ;EqF50aM;IAUM,yBAAA;ErFq0aZ;EqF/0aM;IAUM,+BAAA;ErFw0aZ;EqFl1aM;IAUM,8BAAA;ErF20aZ;EqFr1aM;IAUM,4BAAA;ErF80aZ;EqFx1aM;IAUM,8BAAA;ErFi1aZ;EqF31aM;IAUM,4BAAA;ErFo1aZ;EMj6aE;IAgCE,2BAAA;ENo4aJ;EM55aE;IA+BI,0BAAA;ENg4aN;EMv6aE;IAgCE,iCAAA;EN04aJ;EMl6aE;IA+BI,gCAAA;ENs4aN;EM76aE;IAgCE,gCAAA;ENg5aJ;EMx6aE;IA+BI,+BAAA;EN44aN;EMn7aE;IAgCE,8BAAA;ENs5aJ;EM96aE;IA+BI,6BAAA;ENk5aN;EMz7aE;IAgCE,gCAAA;EN45aJ;EMp7aE;IA+BI,+BAAA;ENw5aN;EM/7aE;IAgCE,8BAAA;ENk6aJ;EM17aE;IA+BI,6BAAA;EN85aN;EqFl4aM;IAUM,4BAAA;ErF23aZ;EqFr4aM;IAUM,kCAAA;ErF83aZ;EqFx4aM;IAUM,iCAAA;ErFi4aZ;EqF34aM;IAUM,+BAAA;ErFo4aZ;EqF94aM;IAUM,iCAAA;ErFu4aZ;EqFj5aM;IAUM,+BAAA;ErF04aZ;EMv9aE;IAgCE,0BAAA;EN07aJ;EMl9aE;IA+BI,2BAAA;ENs7aN;EM79aE;IAgCE,gCAAA;ENg8aJ;EMx9aE;IA+BI,iCAAA;EN47aN;EMn+aE;IAgCE,+BAAA;ENs8aJ;EM99aE;IA+BI,gCAAA;ENk8aN;EMz+aE;IAgCE,6BAAA;EN48aJ;EMp+aE;IA+BI,8BAAA;ENw8aN;EM/+aE;IAgCE,+BAAA;ENk9aJ;EM1+aE;IA+BI,gCAAA;EN88aN;EMr/aE;IAgCE,6BAAA;ENw9aJ;EMh/aE;IA+BI,8BAAA;ENo9aN;EqFx7aM;IAUM,iBAAA;ErFi7aZ;EqF37aM;IAUM,uBAAA;ErFo7aZ;EqF97aM;IAUM,sBAAA;ErFu7aZ;EqFj8aM;IAUM,oBAAA;ErF07aZ;EqFp8aM;IAUM,sBAAA;ErF67aZ;EqFv8aM;IAUM,oBAAA;ErFg8aZ;EqF18aM;IAUM,qBAAA;ErFm8aZ;EqF78aM;IAUM,2BAAA;ErFs8aZ;EqFh9aM;IAUM,0BAAA;ErFy8aZ;EqFn9aM;IAUM,wBAAA;ErF48aZ;EqFt9aM;IAUM,0BAAA;ErF+8aZ;EqFz9aM;IAUM,wBAAA;ErFk9aZ;EqF59aM;IAUM,wBAAA;ErFq9aZ;EqF/9aM;IAUM,8BAAA;ErFw9aZ;EqFl+aM;IAUM,6BAAA;ErF29aZ;EqFr+aM;IAUM,2BAAA;ErF89aZ;EqFx+aM;IAUM,6BAAA;ErFi+aZ;EqF3+aM;IAUM,2BAAA;ErFo+aZ;EMjjbE;IAgCE,2BAAA;ENohbJ;EM5ibE;IA+BI,4BAAA;ENghbN;EMvjbE;IAgCE,4BAAA;EN0hbJ;EMljbE;IA+BI,2BAAA;ENshbN;EM7jbE;IAgCE,6BAAA;ENgibJ;EMxjbE;IA+BI,6BAAA;EN4hbN;AACF;AcvgbI;ER7DA;IAgCE,sBAAA;ENwibJ;EMhkbE;IA+BI,uBAAA;ENoibN;EM3kbE;IAgCE,uBAAA;EN8ibJ;EMtkbE;IA+BI,sBAAA;EN0ibN;EMjlbE;IAgCE,sBAAA;ENojbJ;EM5kbE;IA+BI,sBAAA;ENgjbN;EqFphbM;IAUM,8BAAA;ErF6gbZ;EqFvhbM;IAUM,4BAAA;ErFghbZ;EqF1hbM;IAUM,2BAAA;ErFmhbZ;EqF7hbM;IAUM,iCAAA;ErFshbZ;EqFhibM;IAUM,2BAAA;ErFyhbZ;EqFnibM;IAUM,0BAAA;ErF4hbZ;EqFtibM;IAUM,gCAAA;ErF+hbZ;EqFzibM;IAUM,yBAAA;ErFkibZ;EqF5ibM;IAUM,wBAAA;ErFqibZ;EqF/ibM;IAUM,+BAAA;ErFwibZ;EqFljbM;IAUM,yBAAA;ErF2ibZ;EqFrjbM;IAUM,6BAAA;ErF8ibZ;EqFxjbM;IAUM,8BAAA;ErFijbZ;EqF3jbM;IAUM,wBAAA;ErFojbZ;EqF9jbM;IAUM,+BAAA;ErFujbZ;EqFjkbM;IAUM,wBAAA;ErF0jbZ;EqFpkbM;IAUM,yBAAA;ErF6jbZ;EqFvkbM;IAUM,8BAAA;ErFgkbZ;EqF1kbM;IAUM,iCAAA;ErFmkbZ;EqF7kbM;IAUM,sCAAA;ErFskbZ;EqFhlbM;IAUM,yCAAA;ErFykbZ;EqFnlbM;IAUM,uBAAA;ErF4kbZ;EqFtlbM;IAUM,uBAAA;ErF+kbZ;EqFzlbM;IAUM,yBAAA;ErFklbZ;EqF5lbM;IAUM,yBAAA;ErFqlbZ;EqF/lbM;IAUM,0BAAA;ErFwlbZ;EqFlmbM;IAUM,4BAAA;ErF2lbZ;EqFrmbM;IAUM,kCAAA;ErF8lbZ;EqFxmbM;IAUM,sCAAA;ErFimbZ;EqF3mbM;IAUM,oCAAA;ErFombZ;EqF9mbM;IAUM,kCAAA;ErFumbZ;EqFjnbM;IAUM,yCAAA;ErF0mbZ;EqFpnbM;IAUM,wCAAA;ErF6mbZ;EqFvnbM;IAUM,wCAAA;ErFgnbZ;EqF1nbM;IAUM,kCAAA;ErFmnbZ;EqF7nbM;IAUM,gCAAA;ErFsnbZ;EqFhobM;IAUM,8BAAA;ErFynbZ;EqFnobM;IAUM,gCAAA;ErF4nbZ;EqFtobM;IAUM,+BAAA;ErF+nbZ;EqFzobM;IAUM,oCAAA;ErFkobZ;EqF5obM;IAUM,kCAAA;ErFqobZ;EqF/obM;IAUM,gCAAA;ErFwobZ;EqFlpbM;IAUM,uCAAA;ErF2obZ;EqFrpbM;IAUM,sCAAA;ErF8obZ;EqFxpbM;IAUM,iCAAA;ErFipbZ;EqF3pbM;IAUM,2BAAA;ErFopbZ;EqF9pbM;IAUM,iCAAA;ErFupbZ;EqFjqbM;IAUM,+BAAA;ErF0pbZ;EqFpqbM;IAUM,6BAAA;ErF6pbZ;EqFvqbM;IAUM,+BAAA;ErFgqbZ;EqF1qbM;IAUM,8BAAA;ErFmqbZ;EqF7qbM;IAUM,oBAAA;ErFsqbZ;EqFhrbM;IAUM,mBAAA;ErFyqbZ;EqFnrbM;IAUM,mBAAA;ErF4qbZ;EqFtrbM;IAUM,mBAAA;ErF+qbZ;EqFzrbM;IAUM,mBAAA;ErFkrbZ;EqF5rbM;IAUM,mBAAA;ErFqrbZ;EqF/rbM;IAUM,mBAAA;ErFwrbZ;EqFlsbM;IAUM,mBAAA;ErF2rbZ;EqFrsbM;IAUM,oBAAA;ErF8rbZ;EqFxsbM;IAUM,0BAAA;ErFisbZ;EqF3sbM;IAUM,yBAAA;ErFosbZ;EqF9sbM;IAUM,uBAAA;ErFusbZ;EqFjtbM;IAUM,yBAAA;ErF0sbZ;EqFptbM;IAUM,uBAAA;ErF6sbZ;EqFvtbM;IAUM,uBAAA;ErFgtbZ;EqF1tbM;IAUM,0BAAA;IAAA,yBAAA;ErFotbZ;EqF9tbM;IAUM,gCAAA;IAAA,+BAAA;ErFwtbZ;EqFlubM;IAUM,+BAAA;IAAA,8BAAA;ErF4tbZ;EqFtubM;IAUM,6BAAA;IAAA,4BAAA;ErFgubZ;EqF1ubM;IAUM,+BAAA;IAAA,8BAAA;ErFoubZ;EqF9ubM;IAUM,6BAAA;IAAA,4BAAA;ErFwubZ;EqFlvbM;IAUM,6BAAA;IAAA,4BAAA;ErF4ubZ;EqFtvbM;IAUM,wBAAA;IAAA,2BAAA;ErFgvbZ;EqF1vbM;IAUM,8BAAA;IAAA,iCAAA;ErFovbZ;EqF9vbM;IAUM,6BAAA;IAAA,gCAAA;ErFwvbZ;EqFlwbM;IAUM,2BAAA;IAAA,8BAAA;ErF4vbZ;EqFtwbM;IAUM,6BAAA;IAAA,gCAAA;ErFgwbZ;EqF1wbM;IAUM,2BAAA;IAAA,8BAAA;ErFowbZ;EqF9wbM;IAUM,2BAAA;IAAA,8BAAA;ErFwwbZ;EqFlxbM;IAUM,wBAAA;ErF2wbZ;EqFrxbM;IAUM,8BAAA;ErF8wbZ;EqFxxbM;IAUM,6BAAA;ErFixbZ;EqF3xbM;IAUM,2BAAA;ErFoxbZ;EqF9xbM;IAUM,6BAAA;ErFuxbZ;EqFjybM;IAUM,2BAAA;ErF0xbZ;EqFpybM;IAUM,2BAAA;ErF6xbZ;EM12bE;IAgCE,0BAAA;EN60bJ;EMr2bE;IA+BI,yBAAA;ENy0bN;EMh3bE;IAgCE,gCAAA;ENm1bJ;EM32bE;IA+BI,+BAAA;EN+0bN;EMt3bE;IAgCE,+BAAA;ENy1bJ;EMj3bE;IA+BI,8BAAA;ENq1bN;EM53bE;IAgCE,6BAAA;EN+1bJ;EMv3bE;IA+BI,4BAAA;EN21bN;EMl4bE;IAgCE,+BAAA;ENq2bJ;EM73bE;IA+BI,8BAAA;ENi2bN;EMx4bE;IAgCE,6BAAA;EN22bJ;EMn4bE;IA+BI,4BAAA;ENu2bN;EM94bE;IAgCE,6BAAA;ENi3bJ;EMz4bE;IA+BI,4BAAA;EN62bN;EqFj1bM;IAUM,2BAAA;ErF00bZ;EqFp1bM;IAUM,iCAAA;ErF60bZ;EqFv1bM;IAUM,gCAAA;ErFg1bZ;EqF11bM;IAUM,8BAAA;ErFm1bZ;EqF71bM;IAUM,gCAAA;ErFs1bZ;EqFh2bM;IAUM,8BAAA;ErFy1bZ;EqFn2bM;IAUM,8BAAA;ErF41bZ;EMz6bE;IAgCE,yBAAA;EN44bJ;EMp6bE;IA+BI,0BAAA;ENw4bN;EM/6bE;IAgCE,+BAAA;ENk5bJ;EM16bE;IA+BI,gCAAA;EN84bN;EMr7bE;IAgCE,8BAAA;ENw5bJ;EMh7bE;IA+BI,+BAAA;ENo5bN;EM37bE;IAgCE,4BAAA;EN85bJ;EMt7bE;IA+BI,6BAAA;EN05bN;EMj8bE;IAgCE,8BAAA;ENo6bJ;EM57bE;IA+BI,+BAAA;ENg6bN;EMv8bE;IAgCE,4BAAA;EN06bJ;EMl8bE;IA+BI,6BAAA;ENs6bN;EM78bE;IAgCE,4BAAA;ENg7bJ;EMx8bE;IA+BI,6BAAA;EN46bN;EqFh5bM;IAUM,qBAAA;ErFy4bZ;EqFn5bM;IAUM,2BAAA;ErF44bZ;EqFt5bM;IAUM,0BAAA;ErF+4bZ;EqFz5bM;IAUM,wBAAA;ErFk5bZ;EqF55bM;IAUM,0BAAA;ErFq5bZ;EqF/5bM;IAUM,wBAAA;ErFw5bZ;EqFl6bM;IAUM,2BAAA;IAAA,0BAAA;ErF45bZ;EqFt6bM;IAUM,iCAAA;IAAA,gCAAA;ErFg6bZ;EqF16bM;IAUM,gCAAA;IAAA,+BAAA;ErFo6bZ;EqF96bM;IAUM,8BAAA;IAAA,6BAAA;ErFw6bZ;EqFl7bM;IAUM,gCAAA;IAAA,+BAAA;ErF46bZ;EqFt7bM;IAUM,8BAAA;IAAA,6BAAA;ErFg7bZ;EqF17bM;IAUM,yBAAA;IAAA,4BAAA;ErFo7bZ;EqF97bM;IAUM,+BAAA;IAAA,kCAAA;ErFw7bZ;EqFl8bM;IAUM,8BAAA;IAAA,iCAAA;ErF47bZ;EqFt8bM;IAUM,4BAAA;IAAA,+BAAA;ErFg8bZ;EqF18bM;IAUM,8BAAA;IAAA,iCAAA;ErFo8bZ;EqF98bM;IAUM,4BAAA;IAAA,+BAAA;ErFw8bZ;EqFl9bM;IAUM,yBAAA;ErF28bZ;EqFr9bM;IAUM,+BAAA;ErF88bZ;EqFx9bM;IAUM,8BAAA;ErFi9bZ;EqF39bM;IAUM,4BAAA;ErFo9bZ;EqF99bM;IAUM,8BAAA;ErFu9bZ;EqFj+bM;IAUM,4BAAA;ErF09bZ;EMvicE;IAgCE,2BAAA;EN0gcJ;EMlicE;IA+BI,0BAAA;ENsgcN;EM7icE;IAgCE,iCAAA;ENghcJ;EMxicE;IA+BI,gCAAA;EN4gcN;EMnjcE;IAgCE,gCAAA;ENshcJ;EM9icE;IA+BI,+BAAA;ENkhcN;EMzjcE;IAgCE,8BAAA;EN4hcJ;EMpjcE;IA+BI,6BAAA;ENwhcN;EM/jcE;IAgCE,gCAAA;ENkicJ;EM1jcE;IA+BI,+BAAA;EN8hcN;EMrkcE;IAgCE,8BAAA;ENwicJ;EMhkcE;IA+BI,6BAAA;ENoicN;EqFxgcM;IAUM,4BAAA;ErFigcZ;EqF3gcM;IAUM,kCAAA;ErFogcZ;EqF9gcM;IAUM,iCAAA;ErFugcZ;EqFjhcM;IAUM,+BAAA;ErF0gcZ;EqFphcM;IAUM,iCAAA;ErF6gcZ;EqFvhcM;IAUM,+BAAA;ErFghcZ;EM7lcE;IAgCE,0BAAA;ENgkcJ;EMxlcE;IA+BI,2BAAA;EN4jcN;EMnmcE;IAgCE,gCAAA;ENskcJ;EM9lcE;IA+BI,iCAAA;ENkkcN;EMzmcE;IAgCE,+BAAA;EN4kcJ;EMpmcE;IA+BI,gCAAA;ENwkcN;EM/mcE;IAgCE,6BAAA;ENklcJ;EM1mcE;IA+BI,8BAAA;EN8kcN;EMrncE;IAgCE,+BAAA;ENwlcJ;EMhncE;IA+BI,gCAAA;ENolcN;EM3ncE;IAgCE,6BAAA;EN8lcJ;EMtncE;IA+BI,8BAAA;EN0lcN;EqF9jcM;IAUM,iBAAA;ErFujcZ;EqFjkcM;IAUM,uBAAA;ErF0jcZ;EqFpkcM;IAUM,sBAAA;ErF6jcZ;EqFvkcM;IAUM,oBAAA;ErFgkcZ;EqF1kcM;IAUM,sBAAA;ErFmkcZ;EqF7kcM;IAUM,oBAAA;ErFskcZ;EqFhlcM;IAUM,qBAAA;ErFykcZ;EqFnlcM;IAUM,2BAAA;ErF4kcZ;EqFtlcM;IAUM,0BAAA;ErF+kcZ;EqFzlcM;IAUM,wBAAA;ErFklcZ;EqF5lcM;IAUM,0BAAA;ErFqlcZ;EqF/lcM;IAUM,wBAAA;ErFwlcZ;EqFlmcM;IAUM,wBAAA;ErF2lcZ;EqFrmcM;IAUM,8BAAA;ErF8lcZ;EqFxmcM;IAUM,6BAAA;ErFimcZ;EqF3mcM;IAUM,2BAAA;ErFomcZ;EqF9mcM;IAUM,6BAAA;ErFumcZ;EqFjncM;IAUM,2BAAA;ErF0mcZ;EMvrcE;IAgCE,2BAAA;EN0pcJ;EMlrcE;IA+BI,4BAAA;ENspcN;EM7rcE;IAgCE,4BAAA;ENgqcJ;EMxrcE;IA+BI,2BAAA;EN4pcN;EMnscE;IAgCE,6BAAA;ENsqcJ;EM9rcE;IA+BI,6BAAA;ENkqcN;AACF;Ac7ocI;ER7DA;IAgCE,sBAAA;EN8qcJ;EMtscE;IA+BI,uBAAA;EN0qcN;EMjtcE;IAgCE,uBAAA;ENorcJ;EM5scE;IA+BI,sBAAA;ENgrcN;EMvtcE;IAgCE,sBAAA;EN0rcJ;EMltcE;IA+BI,sBAAA;ENsrcN;EqF1pcM;IAUM,8BAAA;ErFmpcZ;EqF7pcM;IAUM,4BAAA;ErFspcZ;EqFhqcM;IAUM,2BAAA;ErFypcZ;EqFnqcM;IAUM,iCAAA;ErF4pcZ;EqFtqcM;IAUM,2BAAA;ErF+pcZ;EqFzqcM;IAUM,0BAAA;ErFkqcZ;EqF5qcM;IAUM,gCAAA;ErFqqcZ;EqF/qcM;IAUM,yBAAA;ErFwqcZ;EqFlrcM;IAUM,wBAAA;ErF2qcZ;EqFrrcM;IAUM,+BAAA;ErF8qcZ;EqFxrcM;IAUM,yBAAA;ErFircZ;EqF3rcM;IAUM,6BAAA;ErForcZ;EqF9rcM;IAUM,8BAAA;ErFurcZ;EqFjscM;IAUM,wBAAA;ErF0rcZ;EqFpscM;IAUM,+BAAA;ErF6rcZ;EqFvscM;IAUM,wBAAA;ErFgscZ;EqF1scM;IAUM,yBAAA;ErFmscZ;EqF7scM;IAUM,8BAAA;ErFsscZ;EqFhtcM;IAUM,iCAAA;ErFyscZ;EqFntcM;IAUM,sCAAA;ErF4scZ;EqFttcM;IAUM,yCAAA;ErF+scZ;EqFztcM;IAUM,uBAAA;ErFktcZ;EqF5tcM;IAUM,uBAAA;ErFqtcZ;EqF/tcM;IAUM,yBAAA;ErFwtcZ;EqFlucM;IAUM,yBAAA;ErF2tcZ;EqFrucM;IAUM,0BAAA;ErF8tcZ;EqFxucM;IAUM,4BAAA;ErFiucZ;EqF3ucM;IAUM,kCAAA;ErFoucZ;EqF9ucM;IAUM,sCAAA;ErFuucZ;EqFjvcM;IAUM,oCAAA;ErF0ucZ;EqFpvcM;IAUM,kCAAA;ErF6ucZ;EqFvvcM;IAUM,yCAAA;ErFgvcZ;EqF1vcM;IAUM,wCAAA;ErFmvcZ;EqF7vcM;IAUM,wCAAA;ErFsvcZ;EqFhwcM;IAUM,kCAAA;ErFyvcZ;EqFnwcM;IAUM,gCAAA;ErF4vcZ;EqFtwcM;IAUM,8BAAA;ErF+vcZ;EqFzwcM;IAUM,gCAAA;ErFkwcZ;EqF5wcM;IAUM,+BAAA;ErFqwcZ;EqF/wcM;IAUM,oCAAA;ErFwwcZ;EqFlxcM;IAUM,kCAAA;ErF2wcZ;EqFrxcM;IAUM,gCAAA;ErF8wcZ;EqFxxcM;IAUM,uCAAA;ErFixcZ;EqF3xcM;IAUM,sCAAA;ErFoxcZ;EqF9xcM;IAUM,iCAAA;ErFuxcZ;EqFjycM;IAUM,2BAAA;ErF0xcZ;EqFpycM;IAUM,iCAAA;ErF6xcZ;EqFvycM;IAUM,+BAAA;ErFgycZ;EqF1ycM;IAUM,6BAAA;ErFmycZ;EqF7ycM;IAUM,+BAAA;ErFsycZ;EqFhzcM;IAUM,8BAAA;ErFyycZ;EqFnzcM;IAUM,oBAAA;ErF4ycZ;EqFtzcM;IAUM,mBAAA;ErF+ycZ;EqFzzcM;IAUM,mBAAA;ErFkzcZ;EqF5zcM;IAUM,mBAAA;ErFqzcZ;EqF/zcM;IAUM,mBAAA;ErFwzcZ;EqFl0cM;IAUM,mBAAA;ErF2zcZ;EqFr0cM;IAUM,mBAAA;ErF8zcZ;EqFx0cM;IAUM,mBAAA;ErFi0cZ;EqF30cM;IAUM,oBAAA;ErFo0cZ;EqF90cM;IAUM,0BAAA;ErFu0cZ;EqFj1cM;IAUM,yBAAA;ErF00cZ;EqFp1cM;IAUM,uBAAA;ErF60cZ;EqFv1cM;IAUM,yBAAA;ErFg1cZ;EqF11cM;IAUM,uBAAA;ErFm1cZ;EqF71cM;IAUM,uBAAA;ErFs1cZ;EqFh2cM;IAUM,0BAAA;IAAA,yBAAA;ErF01cZ;EqFp2cM;IAUM,gCAAA;IAAA,+BAAA;ErF81cZ;EqFx2cM;IAUM,+BAAA;IAAA,8BAAA;ErFk2cZ;EqF52cM;IAUM,6BAAA;IAAA,4BAAA;ErFs2cZ;EqFh3cM;IAUM,+BAAA;IAAA,8BAAA;ErF02cZ;EqFp3cM;IAUM,6BAAA;IAAA,4BAAA;ErF82cZ;EqFx3cM;IAUM,6BAAA;IAAA,4BAAA;ErFk3cZ;EqF53cM;IAUM,wBAAA;IAAA,2BAAA;ErFs3cZ;EqFh4cM;IAUM,8BAAA;IAAA,iCAAA;ErF03cZ;EqFp4cM;IAUM,6BAAA;IAAA,gCAAA;ErF83cZ;EqFx4cM;IAUM,2BAAA;IAAA,8BAAA;ErFk4cZ;EqF54cM;IAUM,6BAAA;IAAA,gCAAA;ErFs4cZ;EqFh5cM;IAUM,2BAAA;IAAA,8BAAA;ErF04cZ;EqFp5cM;IAUM,2BAAA;IAAA,8BAAA;ErF84cZ;EqFx5cM;IAUM,wBAAA;ErFi5cZ;EqF35cM;IAUM,8BAAA;ErFo5cZ;EqF95cM;IAUM,6BAAA;ErFu5cZ;EqFj6cM;IAUM,2BAAA;ErF05cZ;EqFp6cM;IAUM,6BAAA;ErF65cZ;EqFv6cM;IAUM,2BAAA;ErFg6cZ;EqF16cM;IAUM,2BAAA;ErFm6cZ;EMh/cE;IAgCE,0BAAA;ENm9cJ;EM3+cE;IA+BI,yBAAA;EN+8cN;EMt/cE;IAgCE,gCAAA;ENy9cJ;EMj/cE;IA+BI,+BAAA;ENq9cN;EM5/cE;IAgCE,+BAAA;EN+9cJ;EMv/cE;IA+BI,8BAAA;EN29cN;EMlgdE;IAgCE,6BAAA;ENq+cJ;EM7/cE;IA+BI,4BAAA;ENi+cN;EMxgdE;IAgCE,+BAAA;EN2+cJ;EMngdE;IA+BI,8BAAA;ENu+cN;EM9gdE;IAgCE,6BAAA;ENi/cJ;EMzgdE;IA+BI,4BAAA;EN6+cN;EMphdE;IAgCE,6BAAA;ENu/cJ;EM/gdE;IA+BI,4BAAA;ENm/cN;EqFv9cM;IAUM,2BAAA;ErFg9cZ;EqF19cM;IAUM,iCAAA;ErFm9cZ;EqF79cM;IAUM,gCAAA;ErFs9cZ;EqFh+cM;IAUM,8BAAA;ErFy9cZ;EqFn+cM;IAUM,gCAAA;ErF49cZ;EqFt+cM;IAUM,8BAAA;ErF+9cZ;EqFz+cM;IAUM,8BAAA;ErFk+cZ;EM/idE;IAgCE,yBAAA;ENkhdJ;EM1idE;IA+BI,0BAAA;EN8gdN;EMrjdE;IAgCE,+BAAA;ENwhdJ;EMhjdE;IA+BI,gCAAA;ENohdN;EM3jdE;IAgCE,8BAAA;EN8hdJ;EMtjdE;IA+BI,+BAAA;EN0hdN;EMjkdE;IAgCE,4BAAA;ENoidJ;EM5jdE;IA+BI,6BAAA;ENgidN;EMvkdE;IAgCE,8BAAA;EN0idJ;EMlkdE;IA+BI,+BAAA;ENsidN;EM7kdE;IAgCE,4BAAA;ENgjdJ;EMxkdE;IA+BI,6BAAA;EN4idN;EMnldE;IAgCE,4BAAA;ENsjdJ;EM9kdE;IA+BI,6BAAA;ENkjdN;EqFthdM;IAUM,qBAAA;ErF+gdZ;EqFzhdM;IAUM,2BAAA;ErFkhdZ;EqF5hdM;IAUM,0BAAA;ErFqhdZ;EqF/hdM;IAUM,wBAAA;ErFwhdZ;EqFlidM;IAUM,0BAAA;ErF2hdZ;EqFridM;IAUM,wBAAA;ErF8hdZ;EqFxidM;IAUM,2BAAA;IAAA,0BAAA;ErFkidZ;EqF5idM;IAUM,iCAAA;IAAA,gCAAA;ErFsidZ;EqFhjdM;IAUM,gCAAA;IAAA,+BAAA;ErF0idZ;EqFpjdM;IAUM,8BAAA;IAAA,6BAAA;ErF8idZ;EqFxjdM;IAUM,gCAAA;IAAA,+BAAA;ErFkjdZ;EqF5jdM;IAUM,8BAAA;IAAA,6BAAA;ErFsjdZ;EqFhkdM;IAUM,yBAAA;IAAA,4BAAA;ErF0jdZ;EqFpkdM;IAUM,+BAAA;IAAA,kCAAA;ErF8jdZ;EqFxkdM;IAUM,8BAAA;IAAA,iCAAA;ErFkkdZ;EqF5kdM;IAUM,4BAAA;IAAA,+BAAA;ErFskdZ;EqFhldM;IAUM,8BAAA;IAAA,iCAAA;ErF0kdZ;EqFpldM;IAUM,4BAAA;IAAA,+BAAA;ErF8kdZ;EqFxldM;IAUM,yBAAA;ErFildZ;EqF3ldM;IAUM,+BAAA;ErFoldZ;EqF9ldM;IAUM,8BAAA;ErFuldZ;EqFjmdM;IAUM,4BAAA;ErF0ldZ;EqFpmdM;IAUM,8BAAA;ErF6ldZ;EqFvmdM;IAUM,4BAAA;ErFgmdZ;EM7qdE;IAgCE,2BAAA;ENgpdJ;EMxqdE;IA+BI,0BAAA;EN4odN;EMnrdE;IAgCE,iCAAA;ENspdJ;EM9qdE;IA+BI,gCAAA;ENkpdN;EMzrdE;IAgCE,gCAAA;EN4pdJ;EMprdE;IA+BI,+BAAA;ENwpdN;EM/rdE;IAgCE,8BAAA;ENkqdJ;EM1rdE;IA+BI,6BAAA;EN8pdN;EMrsdE;IAgCE,gCAAA;ENwqdJ;EMhsdE;IA+BI,+BAAA;ENoqdN;EM3sdE;IAgCE,8BAAA;EN8qdJ;EMtsdE;IA+BI,6BAAA;EN0qdN;EqF9odM;IAUM,4BAAA;ErFuodZ;EqFjpdM;IAUM,kCAAA;ErF0odZ;EqFppdM;IAUM,iCAAA;ErF6odZ;EqFvpdM;IAUM,+BAAA;ErFgpdZ;EqF1pdM;IAUM,iCAAA;ErFmpdZ;EqF7pdM;IAUM,+BAAA;ErFspdZ;EMnudE;IAgCE,0BAAA;ENssdJ;EM9tdE;IA+BI,2BAAA;ENksdN;EMzudE;IAgCE,gCAAA;EN4sdJ;EMpudE;IA+BI,iCAAA;ENwsdN;EM/udE;IAgCE,+BAAA;ENktdJ;EM1udE;IA+BI,gCAAA;EN8sdN;EMrvdE;IAgCE,6BAAA;ENwtdJ;EMhvdE;IA+BI,8BAAA;ENotdN;EM3vdE;IAgCE,+BAAA;EN8tdJ;EMtvdE;IA+BI,gCAAA;EN0tdN;EMjwdE;IAgCE,6BAAA;ENoudJ;EM5vdE;IA+BI,8BAAA;ENgudN;EqFpsdM;IAUM,iBAAA;ErF6rdZ;EqFvsdM;IAUM,uBAAA;ErFgsdZ;EqF1sdM;IAUM,sBAAA;ErFmsdZ;EqF7sdM;IAUM,oBAAA;ErFssdZ;EqFhtdM;IAUM,sBAAA;ErFysdZ;EqFntdM;IAUM,oBAAA;ErF4sdZ;EqFttdM;IAUM,qBAAA;ErF+sdZ;EqFztdM;IAUM,2BAAA;ErFktdZ;EqF5tdM;IAUM,0BAAA;ErFqtdZ;EqF/tdM;IAUM,wBAAA;ErFwtdZ;EqFludM;IAUM,0BAAA;ErF2tdZ;EqFrudM;IAUM,wBAAA;ErF8tdZ;EqFxudM;IAUM,wBAAA;ErFiudZ;EqF3udM;IAUM,8BAAA;ErFoudZ;EqF9udM;IAUM,6BAAA;ErFuudZ;EqFjvdM;IAUM,2BAAA;ErF0udZ;EqFpvdM;IAUM,6BAAA;ErF6udZ;EqFvvdM;IAUM,2BAAA;ErFgvdZ;EM7zdE;IAgCE,2BAAA;ENgydJ;EMxzdE;IA+BI,4BAAA;EN4xdN;EMn0dE;IAgCE,4BAAA;ENsydJ;EM9zdE;IA+BI,2BAAA;ENkydN;EMz0dE;IAgCE,6BAAA;EN4ydJ;EMp0dE;IA+BI,6BAAA;ENwydN;AACF;AsF/zdA;EDkDQ;IAUM,4BAAA;ErFuwdZ;EqFjxdM;IAUM,0BAAA;ErF0wdZ;EqFpxdM;IAUM,6BAAA;ErF6wdZ;EqFvxdM;IAUM,4BAAA;ErFgxdZ;AACF;AsF1zdA;ED+BQ;IAUM,0BAAA;ErFqxdZ;EqF/xdM;IAUM,gCAAA;ErFwxdZ;EqFlydM;IAUM,yBAAA;ErF2xdZ;EqFrydM;IAUM,wBAAA;ErF8xdZ;EqFxydM;IAUM,+BAAA;ErFiydZ;EqF3ydM;IAUM,yBAAA;ErFoydZ;EqF9ydM;IAUM,6BAAA;ErFuydZ;EqFjzdM;IAUM,8BAAA;ErF0ydZ;EqFpzdM;IAUM,wBAAA;ErF6ydZ;EqFvzdM;IAUM,+BAAA;ErFgzdZ;EqF1zdM;IAUM,wBAAA;ErFmzdZ;AACF;AuFn4dA;;;;;;EAAA;ACEA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,oBAAA;EACA,8BAAA;EACA,UAAA;ElEOI,0BkENJ;EACA,6BAAA;EjFQE,uBAAA;APm4dJ;AsBl4dM;EkElBN;IlEmBQ,gBAAA;EtBq4dN;AACF;;AwF54dA;EACE,qBAAA;AxF+4dF;;AwF54dA;EACE,mBnFqoB4B;EmFpoB5B,gBnF4oB4B;ALmwc9B;;AwF54dA;EACE,mBAAA;EACA,mBnF+nB4B;EmF9nB5B,mBAAA;AxF+4dF;;AyF16dA;EACE,iBAAA;EACA,2BAAA;EACA,c3CCM;A9C46dR;;AyF16dA;EACE,WAAA;EAEA,iBAAA;AzF46dF;;AyFx6dA;EACE,cAAA;EACA,yB3Cda;A9Cy7df;;AyFv6dE;EACE,gBAAA;EACA,c3CrBK;E2CsBL,qBAAA;AzF06dJ;AyFv6dE;EACE,kBAAA;AzFy6dJ;;AyFr6dA;EACE,mBAAA;EACA,YAAA;AzFw6dF;AyFt6dE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;AzFw6dJ;AyFt6dI;EACE,mBAAA;EACA,c3C3CG;A9Cm9dT;AyFt6dM;EACE,c3C9CC;A9Cs9dT;AyFp6dI;EACE,mBAAA;EACA,c3CpDG;A9C09dT;AyFp6dM;EACE,c3CvDC;A9C69dT;AyFj6dE;EACE,YAAA;EACA,WAAA;EACA,cAAA;AzFm6dJ;;AyF/5dA;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,6BAAA;AzFk6dF;;AyF95dA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AzFi6dF;AyF/5dE;EACE,SAAA;AzFi6dJ;;AyF75dA;EACE,mBAAA;AzFg6dF;AyF95dE;EACE,gBAAA;EACA,+BAAA;EACA,eAAA;AzFg6dJ;;AyF55dA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,yB3CvGM;A9CsgeR;;AyF55dA;EACE;IACE,eAAA;IACA,4BAAA;IACA,YAAA;IACA,oBAAA;IACA,sBAAA;EzF+5dF;EyF35dE;IACE,YAAA;IACA,UAAA;IACA,kBAAA;EzF65dJ;EyF35dI;IACE,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,2BAAA;IACA,gBAAA;IACA,cAAA;IACA,iBAAA;IACA,uBAAA;IACA,cAAA;IACA,yBAAA;IACA,WAAA;IACA,YAAA;IACA,kBAAA;IACA,WAAA;IACA,YAAA;IACA,kBAAA;IACA,yBAAA;EzF65dN;EyFx5dA;IACE,kBAAA;IACA,cAAA;IACA,+BAAA;IACA,eAAA;IACA,gBAAA;EzF05dF;EyFv5dA;IACE,YAAA;IACA,6BAAA;IACA,kBAAA;IACA,gCAAA;EzFy5dF;EyFv5dE;IACE,gBAAA;IACA,mBAAA;EzFy5dJ;EyFt5dE;IACE,aAAA;IACA,YAAA;EzFw5dJ;EyFr5dE;IACE,eAAA;EzFu5dJ;EyFp5dE;IACE,+BAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,iBAAA;EzFs5dJ;EyFj5dA;IACE,YAAA;IACA,YAAA;IACA,+BAAA;IACA,aAAA;IACA,mBAAA;EzFm5dF;EyFh5dA;IACE,YAAA;IACA,YAAA;EzFk5dF;EyF/4dA;IACE,UAAA;IACA,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;EzFi5dF;EyF94dA;IACE,wBAAA;IACA,4BAAA;EzFg5dF;EyF74dA;IACE,wBAAA;IACA,YAAA;IACA,eAAA;IACA,uBAAA;IACA,WAAA;EzF+4dF;EyF74dE;IACE,aAAA;IACA,6BAAA;IACA,sBAAA;EzF+4dJ;EyF74dI;IACE,gBAAA;IACA,c3ChOC;E9C+meP;EyF74dM;IACE,c3CnOD;I2CoOC,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,qBAAA;EzF+4dR;EyFz4dA;IACE,cAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,c3CpPK;I2CqPL,aAAA;IACA,qBAAA;IACA,eAAA;EzF24dF;EyF14dE;IACE,cAAA;EzF44dJ;EyFt4dI;IACE,iCAAA;IACA,uBAAA;EzFw4dN;EyFp4dA;IACE,iBAAA;EzFs4dF;EyFn4dE;IACE,WAAA;IACA,aAAA;IACA,cAAA;EzFq4dJ;EyFn4dE;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,UAAA;IACA,QAAA;IACA,eAAA;EzFq4dJ;EyFh4dE;IACE,+BAAA;EzFk4dJ;EyF93dA;IACE,uBAAA;EzFg4dF;AACF;AyF73dA;EAEI;IACE,gBAAA;EzF83dJ;EyF13dA;IACE,gBAAA;IACA,2BAAA;IACA,WAAA;IACA,oBAAA;IACA,sBAAA;EzF43dF;EyFz3dA;IACE,wBAAA;EzF23dF;EyFx3dA;IACE,YAAA;IACA,6BAAA;IACA,kBAAA;EzF03dF;EyFx3dE;IACE,gBAAA;IACA,mBAAA;EzF03dJ;EyFv3dE;IACE,cAAA;IACA,YAAA;EzFy3dJ;EyFt3dE;IACE,uBAAA;EzFw3dJ;EyFp3dE;IACE,cAAA;IACA,eAAA;IACA,+BAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;EzFs3dJ;EyFl3dA;IACE,gBAAA;IACA,gBAAA;IACA,kBAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;EzFo3dF;EyFj3dA;IACE,WAAA;IACA,YAAA;IACA,qBAAA;IACA,oBAAA;EzFm3dF;EyFh3dI;IACE,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,2BAAA;IACA,gBAAA;IACA,cAAA;IACA,iBAAA;IACA,uBAAA;IACA,cAAA;IACA,yBAAA;IACA,WAAA;IACA,YAAA;IACA,kBAAA;IACA,YAAA;IACA,SAAA;IACA,kBAAA;IACA,yBAAA;IACA,gCAAA;EzFk3dN;EyF/2dI;IACE,yBAAA;EzFi3dN;EyF/2dM;IACE,0BAAA;IACA,2BAAA;EzFi3dR;EyF72dI;IACE,yBAAA;EzF+2dN;EyF72dM;IACE,0BAAA;IACA,2BAAA;EzF+2dR;EyFz2dA;IACE,WAAA;EzF22dF;EyFx2dA;IACE,aAAA;IACA,2BAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,cAAA;IACA,UAAA;IACA,uBAAA;IACA,qBAAA;EzF02dF;EyFv2dA;IACE,kBAAA;IACA,kBAAA;EzFy2dF;EyFt2dA;IACE,cAAA;EzFw2dF;EyFr2dA;IACE,YAAA;IACA,cAAA;IACA,WAAA;EzFu2dF;EyFr2dE;IACE,eAAA;IACA,YAAA;EzFu2dJ;EyFp2dE;IACE,aAAA;IACA,sBAAA;IACA,gBAAA;IACA,mBAAA;EzFs2dJ;EyFp2dI;IACE,gBAAA;IACA,c3C1bC;E9CgyeP;EyFn2dM;IACE,c3C9bD;I2C+bC,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,qBAAA;EzFq2dR;EyFh2dE;IACE,WAAA;EzFk2dJ;EyF91dA;IACE,cAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,c3CndK;I2CodL,mBAAA;IACA,qBAAA;EzFg2dF;EyF31dI;IACE,iCAAA;IACA,uBAAA;EzF61dN;EyFz1dA;IACE,iBAAA;EzF21dF;EyFx1dE;IACE,WAAA;IACA,aAAA;IACA,cAAA;EzF01dJ;EyFx1dE;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,UAAA;IACA,QAAA;IACA,eAAA;EzF01dJ;EyFr1dE;IACE,+BAAA;IACA,iBAAA;EzFu1dJ;AACF;AyFl1dA;EACE;IACE,yBAAA;EzFo1dF;AACF;AyFj1dA;EACE;IACE,cAAA;EzFm1dF;AACF;A0Fx1eA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,2BAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;A1F01eJ;;A0Ft1eA;EACI,mB5CtBK;E4CuBL,c5CpBI;A9C62eR;A0Fv1eI;EACI,oCAAA;EACA,YAAA;A1Fy1eR;A0Ft1eI;EACI,yB5C/BC;A9Cu3eT;;A0Fp1eA;EACI,mB5ClCK;E4CmCL,c5CjCI;A9Cw3eR;A0Fr1eI;EACI,oCAAA;EACA,YAAA;A1Fu1eR;A0Fp1eI;EACI,yB5C3CC;A9Ci4eT;;A0Fj1eA;EACI,yB5ClDW;E4CmDX,c5CpDK;A9Cw4eT;A0Fl1eI;EACI,yB5CvDC;A9C24eT;;A0F/0eA;EACI;IACI,kBAAA;IACA,eAAA;E1Fk1eN;AACF;A0F70eA;EACI;IACI,iBAAA;IACA,eAAA;E1F+0eN;AACF;A2Fx5eA;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,uCAAA;A3F05eJ;;A2Fv5eA;EACI,WAAA;EACA,YAAA;EACA,cAAA;A3F05eJ;;A2Fv5eA;EACI,gBAAA;EACA,yBAAA;A3F05eJ;A2Fx5eI;EACI,kBAAA;EACA,WAAA;A3F05eR;A2Fv5eI;EACI,gBAAA;A3Fy5eR;;A2Fp5eA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,6BAAA;A3Fu5eJ;;A2Fp5eA;EACI,oBAAA;A3Fu5eJ;;A2Fp5eA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,iBAAA;A3Fu5eJ;;A2Fp5eA;EACI,gBAAA;A3Fu5eJ;;A2Fp5eA;EACI;IACI,aAAA;E3Fu5eN;E2Fp5eE;IACI,aAAA;E3Fs5eN;AACF;A4Fr9eA;EACE,c9CQI;A9C+8eN;;A4Fp9eA;EACE,6BAAA;A5Fu9eF;;A4Fp9eA;EACE,0BAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;A5Fu9eF;;A4Fp9eA;EACE,uBAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;A5Fu9eF;;A4Fn9eE;EACE,eAAA;EACA,yBAAA;EACA,mCAAA;EACA,eAAA;A5Fs9eJ;A4Fn9eE;EACE,yBAAA;EACA,qBAAA;A5Fq9eJ;;A4Fj9eA;EACE,cAAA;A5Fo9eF;;A4Fj9eA;EACE,qBAAA;A5Fo9eF;;A4Fh9eA;EACE;IACE,UAAA;E5Fm9eF;E4Fh9eA;IACE,UAAA;E5Fk9eF;E4F/8eA;IACE,uBAAA;E5Fi9eF;E4F98eA;IACE,eAAA;IACA,iBAAA;E5Fg9eF;E4F78eA;IACE,cAAA;E5F+8eF;E4F78eE;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,c9CvEE;I8CwEF,cAAA;E5F+8eJ;E4F58eE;IACE,eAAA;IACA,YAAA;IACA,kBAAA;IACA,SAAA;IACA,yBAAA;IACA,yBAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,c9CvFE;I8CwFF,eAAA;E5F88eJ;E4F18eA;IACE,2BAAA;IACA,WAAA;E5F48eF;E4Fz8eA;IACE,eAAA;IACA,iBAAA;E5F28eF;E4Fx8eA;IACE,eAAA;IACA,iBAAA;E5F08eF;E4Fv8eA;IACE,eAAA;IACA,iBAAA;E5Fy8eF;E4Ft8eA;IACE,oCAAA;E5Fw8eF;E4Fr8eA;IACE,kBAAA;IACA,YAAA;IACA,aAAA;IACA,sBAAA;E5Fu8eF;E4Fp8eA;IACE,YAAA;E5Fs8eF;E4Fn8eA;IACE,uBAAA;IAAA,kBAAA;IACA,c9CrIK;I8CsIL,2BAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;E5Fq8eF;E4Fl8eA;IACE,2BAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;IACA,sBAAA;IACA,gBAAA;IACA,mBAAA;IACA,c9CnJI;E9CulfN;E4Fl8eA;IACE,iBAAA;E5Fo8eF;E4Fn8eE;IACE,eAAA;IACA,c9CzJE;I8C0JF,WAAA;E5Fq8eJ;E4Fl8eA;IACE,mBAAA;E5Fo8eF;E4Fj8eA;IACE,6BAAA;E5Fm8eF;E4Fj8eE;IACE,YAAA;E5Fm8eJ;AACF;A4F/7eA;EACE,oBAAA;EACA,cAAA;EACA,mBAAA;A5Fi8eF;;A4F77eA;EACE;IACE,UAAA;E5Fg8eF;E4F77eA;IACE,UAAA;E5F+7eF;E4F57eA;IACE,eAAA;IACA,iBAAA;IACA,WAAA;E5F87eF;E4F17eE;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,c9CtME;I8CuMF,aAAA;E5F47eJ;E4Fz7eE;IACE,eAAA;IACA,YAAA;IACA,iBAAA;IACA,SAAA;IACA,yBAAA;IACA,yBAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,c9CtNE;I8CuNF,eAAA;E5F27eJ;E4Fx7eE;IACE,WAAA;IACA,eAAA;IACA,eAAA;IACA,iBAAA;E5F07eJ;E4Fr7eE;IACE,0BAAA;E5Fu7eJ;E4Fp7eE;IACE,eAAA;E5Fs7eJ;E4Fl7eA;IACE,WAAA;IACA,aAAA;E5Fo7eF;E4Fj7eA;IACE,eAAA;IACA,iBAAA;E5Fm7eF;E4Fh7eA;IACE,eAAA;IACA,iBAAA;E5Fk7eF;E4F/6eA;IACE,eAAA;IACA,iBAAA;E5Fi7eF;E4F96eA;IACE,kBAAA;IACA,YAAA;IACA,aAAA;IACA,uBAAA;E5Fg7eF;E4F76eA;IACE,kBAAA;IACA,WAAA;E5F+6eF;E4F56eA;IACE,c9CjRK;I8CkRL,2BAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;IACA,sBAAA;E5F86eF;E4F36eA;IACE,2BAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;IACA,uBAAA;IACA,c9C9RI;I8C+RJ,gBAAA;E5F66eF;E4F16eA;IACE,iBAAA;IACA,cAAA;E5F46eF;E4F36eE;IACE,eAAA;IACA,c9CvSE;I8CwSF,WAAA;E5F66eJ;E4Fx6eE;IACE,UAAA;E5F06eJ;E4Fx6eI;IACE,WAAA;E5F06eN;AACF;A4Fr6eA;EACE,8BAAA;A5Fu6eF;;A4Fp6eA;EACE,2BAAA;A5Fu6eF;;A4Fp6eA;EACE,gBAAA;A5Fu6eF;;A4Fp6eA;EACE,2BAAA;A5Fu6eF;;A4Fp6eA;EACE,c9C5UO;A9CmvfT;;A4Fp6eA;EACE,c9C3UK;A9CkvfP;;A4Fp6eA;EACE,yBAAA;A5Fu6eF;;A4Fp6eA;EACE,c9ClVM;A9CyvfR;;A4Fp6eA;EACE,c9C1VO;A9CiwfT;;A4Fp6eA;EACE,WAAA;EACA,yCAAA;EACA,6BAAA;EACA,cAAA;A5Fu6eF;A4Fr6eE;EACE,UAAA;A5Fu6eJ;;A4Fn6eA;EACE,sBAAA;EACA,SAAA;EACA,mB9C1WM;E8C2WN,iCAAA;EACA,8BAAA;EACA,UAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;A5Fs6eF;;A4Fn6eA;EACE,yB9CrXM;E8CsXN,SAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,+BAAA;A5Fs6eF;;A4Fn6eA;EACE;IACE,+BAAA;E5Fs6eF;E4Fl6eE;IACE,UAAA;E5Fo6eJ;E4Fj6eA;IACE,6BAAA;IACA,wBAAA;E5Fm6eF;E4Fj6eA;IACE,mBAAA;E5Fm6eF;AACF;A4Fh6eA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;A5Fk6eF;;A4F/5eA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;A5Fk6eF;;A4F/5eA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;A5Fk6eF;;A4F/5eA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;A5Fk6eF;;A4F55eM;EACE,cAAA;A5F+5eR;A4F15eE;;EAEE,c9C1bI;E8C2bJ,yB9C9bK;E8C+bL,qB9C/bK;A9C21fT;A4Fz5eE;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,c9CtcK;E8CucL,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A5F25eJ;A4Fv5eI;EACE,cAAA;A5Fy5eN;;A4Fp5eA;EACE,yB9C9cK;E8C+cL,kBAAA;EACA,QAAA;A5Fu5eF;A4Fr5eE;EACE,eAAA;A5Fu5eJ;A4Fr5eI;EACE,aAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;A5Fu5eN;A4Fr5eM;EACE,c9CreC;A9C43fT;;A4Fj5eA;EACE,kBAAA;A5Fo5eF;;A4Fj5eA;EACE,oCAAA;A5Fo5eF;;A4Fj5eA;EACE,oCAAA;A5Fo5eF;;A4Fj5eA;EACE,oCAAA;A5Fo5eF;;A4Fj5eA;EACE,qBAAA;A5Fo5eF;;A4Fj5eA;EACE,cAAA;A5Fo5eF;A4Fl5eE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,c9CngBI;E8CogBJ,cAAA;A5Fo5eJ;A4Fj5eE;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,c9ClhBI;E8CmhBJ,aAAA;EACA,mCAAA;EACA,WAAA;A5Fm5eJ;A4Fh5eE;EACE,gBAAA;EACA,eAAA;A5Fk5eJ;A4F/4eE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,0BAAA;EACA,gBAAA;EACA,c9CxiBK;A9Cy7fT;A4Fz4eE;EACE,yBAAA;A5F24eJ;;A4Fv4eA;EACE,cAAA;A5F04eF;A4Fx4eE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,c9CzjBI;E8C0jBJ,cAAA;A5F04eJ;A4Fv4eE;EACE,kBAAA;EACA,SAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,c9CvkBI;A9Cg9fR;;A4Fr4eA;EACE,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,sBAAA;A5Fw4eF;;A4Fr4eA;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;A5Fw4eF;;A4Fr4eA;EACE,mBAAA;A5Fw4eF;A4Ft4eE;EACE,cAAA;A5Fw4eJ;;A4Fp4eA;EACE,uBAAA;A5Fu4eF;;A4Fp4eA;EACE,mBAAA;A5Fu4eF;;A4Fp4eA;EACE,WAAA;EACA,YAAA;A5Fu4eF;;A6Ft/fA;EACE,aAAA;EACA,aAAA;A7Fy/fF;;A6Ft/fA;EACE,WAAA;EACA,gBAAA;A7Fy/fF;A6Fv/fE;EACE,wBAAA;EACA,uCAAA;EACA,2BAAA;A7Fy/fJ;A6Fv/fI;EACE,sCAAA;EACA,kCAAA;EACA,gDAAA;EACA,+CAAA;A7Fy/fN;A6Fr/fE;EACE,WAAA;EACA,YAAA;EACA,yB/ClBG;E+CmBH,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;A7Fu/fJ;A6Ft/fI;EACE,aAAA;A7Fw/fN;A6Fp/fE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,c/CrCI;A9C2hgBR;A6Fn/fE;EACE,wBAAA;EACA,uCAAA;EACA,2BAAA;A7Fq/fJ;A6Fn/fI;EACE,sCAAA;EACA,kCAAA;EACA,gDAAA;EACA,+CAAA;EACA,yBAAA;A7Fq/fN;A6Fj/fE;EACE,sBAAA;EACA,6BAAA;EACA,+BAAA;EACA,gBAAA;A7Fm/fJ;A6Fj/fI;EACE,kBAAA;A7Fm/fN;A6F/+fE;EACE,eAAA;EACA,c/CnEI;E+CoEJ,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;A7Fi/fJ;A6Fh/fI;EACE,oCAAA;A7Fk/fN;;A6F7+fA;EAGM;IACE,qCAAA;E7F8+fN;E6F1+fI;IACE,qCAAA;IACA,kCAAA;E7F4+fN;E6Fz+fE;IACE,eAAA;E7F2+fJ;E6Fz+fE;IACE,eAAA;E7F2+fJ;E6Fz+fE;IACE,eAAA;E7F2+fJ;AACF;A6Fv+fA;EAGM;IACE,eAAA;IACA,gBAAA;E7Fu+fN;AACF;A8FxlgBA;EACE,aAAA;EACA,mBAAA;EACA,oDAAA;EACA,wBAAA;A9F0lgBF;;A8FvlgBA;EACE,wBAAA;A9F0lgBF;;A8FvlgBA;EACE,yBhDTM;EgDUN,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,chDrBO;EgDsBP,6BAAA;EACA,iCAAA;EACA,8BAAA;A9F0lgBF;A8FxlgBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;A9F0lgBJ;;A8FtlgBA;EACE,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;A9FylgBF;;A8FtlgBA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;A9FylgBF;;A8FtlgBA;EACE,YAAA;A9FylgBF;;A8FtlgBA;EACE,mCAAA;A9FylgBF;;A8FtlgBA;EACE,uBAAA;A9FylgBF;A8FvlgBE;EACE,chD3DI;EgD4DJ,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;A9FylgBJ;A8FtlgBE;EACE,qBAAA;EACA,eAAA;EACA,eAAA;A9FwlgBJ;A8FrlgBE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,chD5EI;A9CmqgBR;A8FnlgBI;EACE,gBAAA;EACA,mBhDtFG;EgDuFH,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;A9FqlgBN;A8FjlgBE;EACE,mBhDhGK;A9CmrgBT;A8FhlgBE;EACE,8BAAA;EACA,oCAAA;EACA,yBAAA;A9FklgBJ;A8FhlgBI;EACE,8BAAA;A9FklgBN;;A8F7kgBA;EAEI;IACE,eAAA;IACA,iBAAA;E9F+kgBJ;AACF;A+FlsgBA;EACE,kBAAA;A/FosgBF;A+FnsgBE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cjDHI;A9CwsgBR;A+FlsgBE;EACE,cjDFE;A9CssgBN;A+FjsgBE;EACE,YAAA;A/FmsgBJ;A+FjsgBI;EACE,gBAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;A/FmsgBN;A+FhsgBI;EACE,WAAA;A/FksgBN;A+F9rgBE;EACE,cjD7BI;A9C6tgBR;A+F9rgBI;EACE,gBAAA;EACA,sBAAA;A/FgsgBN;A+F7rgBI;EACE,gBAAA;EACA,uBAAA;A/F+rgBN;A+F3rgBE;EACE,YAAA;A/F6rgBJ;A+F3rgBI;EACE,WAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;A/F6rgBN;A+F5rgBM;EACE,kBAAA;EACA,QAAA;EACA,WAAA;A/F8rgBR;A+FzrgBM;EACE,WAAA;A/F2rgBR;A+FtrgBM;EACE,WAAA;A/FwrgBR;;A+FlrgBA;EACE,+BAAA;EACA,mBjD1EM;EiD2EN,yCAAA;A/FqrgBF;A+FnrgBE;EACE,6BAAA;EACA,iCAAA;EACA,0BAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cjDxFK;EiDyFL,eAAA;A/FqrgBJ;A+FnrgBI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;A/FqrgBN;A+FlrgBI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cjDpGE;EiDqGF,gBAAA;A/ForgBN;A+FhrgBE;EACE,SAAA;EACA,eAAA;A/FkrgBJ;A+FhrgBI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cjDjHE;A9CmygBR;A+F/qgBI;EACE,SAAA;EACA,WAAA;A/FirgBN;A+F/qgBM;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cjDnIA;EiDoIA,eAAA;EACA,kBAAA;A/FirgBR;A+F5qgBM;EACE,cAAA;A/F8qgBR;A+F5qgBQ;EACE,eAAA;EACA,YAAA;A/F8qgBV;A+F3qgBQ;EACE,iBAAA;EACA,kBAAA;A/F6qgBV;A+F1qgBQ;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cjD3JF;EiD4JE,yBAAA;EACA,SAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;A/F4qgBV;A+FzqgBQ;EACE,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBjDxKF;EiDyKE,yBAAA;EACA,kBAAA;A/F2qgBV;A+FzqgBU;EACE,aAAA;EACA,SAAA;EACA,gCAAA;A/F2qgBZ;A+FzqgBY;EACE,iCAAA;EACA,iBAAA;A/F2qgBd;A+FzqgBY;EACE,mBAAA;A/F2qgBd;A+FxqgBY;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cjDjML;A9C22gBT;A+FvqgBY;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cjDrMN;EiDsMM,QAAA;A/FyqgBd;A+FtqgBY;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cjD9MN;EiD+MM,iBAAA;A/FwqgBd;A+FpqgBc;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,+BAAA;EACA,cjD7NP;EiD8NO,iBAAA;A/FsqgBhB;A+FlqgBY;EACE,mCAAA;A/FoqgBd;A+FnqgBc;EACE,YAAA;A/FqqgBhB;A+FhqgBU;EACE,aAAA;EACA,SAAA;EACA,WAAA;A/FkqgBZ;A+FhqgBY;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cjDjPN;A9Cm5gBR;A+F/pgBY;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;A/FiqgBd;A+F/pgBc;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;A/FiqgBhB;A+F3pgBQ;EACE,gBAAA;A/F6pgBV;A+F1pgBQ;EACE,gBAAA;EACA,mBAAA;EAEA,YAAA;A/F2pgBV;A+FzpgBU;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cjD5RJ;EiD6RI,gCAAA;EACA,8BAAA;EACA,+BAAA;A/F2pgBZ;A+FxpgBU;EACE,oBAAA;A/F0pgBZ;A+FvpgBU;EACE,6BAAA;A/FypgBZ;A+FtpgBU;EACE,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;A/FwpgBZ;A+FtpgBY;EACE,iBAAA;EACA,sBAAA;A/FwpgBd;A+FrpgBY;EACE,+BAAA;EACA,cAAA;A/FupgBd;A+FlpgBY;EACE,kBAAA;A/FopgBd;A+FlpgBY;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;A/FopgBd;A+F/ogBQ;EACE,gBAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;A/FipgBV;A+F/ogBU;EACE,mBAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cjD3VJ;EiD4VI,gCAAA;A/FipgBZ;A+F9ogBU;EACE,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cjDtWJ;A9Cs/gBR;A+F7ogBU;EACE,UAAA;A/F+ogBZ;A+FzogBI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cjDrXE;A9CgghBR;A+FxogBI;EACE,YAAA;EACA,SAAA;EACA,YAAA;A/F0ogBN;A+FvogBI;EACE,YAAA;EACA,SAAA;EACA,YAAA;A/FyogBN;A+FtogBI;EACE,QAAA;EACA,2BAAA;EACA,WAAA;EACA,eAAA;A/FwogBN;A+FrogBI;EACE,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;A/FuogBN;A+F5ngBI;EACE,aAAA;EACA,SAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;A/F8ngBN;A+F5ngBM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cjDvaA;A9CqihBR;A+F1ngBQ;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,mCAAA;EACA,qEAAA;EACA,yBjDtaD;EiDuaC,uBAAA;EACA,+BAAA;A/F4ngBV;A+FzngBQ;EACE,yBAAA;EACA,qBAAA;EACA,2CAAA;A/F2ngBV;A+FtngBI;EACE,SAAA;EACA,YAAA;EAEA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;A/FungBN;A+FnngBE;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;A/FqngBJ;;A+FjngBA;EACE,aAAA;EACA,aAAA;EACA,SAAA;A/FongBF;A+FlngBE;EACE,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cjD9dI;A9CklhBR;A+FjngBE;EACE,gBAAA;EACA,YAAA;EACA,SAAA;A/FmngBJ;A+FjngBI;EACE,kBAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;A/FmngBN;A+FhngBI;EACE,mBAAA;EACA,cjD1fG;A9C4mhBT;A+F/mgBI;EACE,mBjD9fG;EiD+fH,cjD5fE;A9C6mhBR;;A+F3mgBE;EACE,yCAAA;A/F8mgBJ;A+F3mgBE;EACE,6BAAA;EACA,YAAA;EACA,eAAA;A/F6mgBJ;A+F3mgBI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;A/F6mgBN;A+FzmgBE;EACE,mBAAA;EACA,kBAAA;EACA,SAAA;A/F2mgBJ;A+FzmgBI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cjD7hBE;A9CwohBR;A+FxmgBI;EACE,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;A/F0mgBN;A+FxmgBM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cjD3iBA;A9CqphBR;A+FvmgBM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cjDljBA;A9C2phBR;;A+FlmgBE;EACE,6BAAA;EACA,uBAAA;EACA,SAAA;A/FqmgBJ;A+FlmgBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;A/FomgBJ;A+FjmgBE;EACE,gBAAA;EACA,kBAAA;A/FmmgBJ;A+FjmgBI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EAEA,iCAAA;A/FkmgBN;A+F/lgBI;EACE,YAAA;EACA,mBAAA;EACA,+BAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cjDlmBE;EiDmmBF,aAAA;A/FimgBN;A+F7lgBE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cjD3mBI;A9C0shBR;;A+F1lgBE;EACE,6BAAA;A/F6lgBJ;A+F1lgBE;EACE,aAAA;EACA,SAAA;A/F4lgBJ;A+FzlgBE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cjD9nBI;A9CythBR;A+FxlgBE;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;A/F0lgBJ;A+FvlgBE;EACE,uBAAA;A/FylgBJ;;A+FplgBE;EACE,6BAAA;EACA,SAAA;A/FulgBJ;;A+FnlgBA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cjDvqBM;EiDwqBN,eAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;A/FslgBF;;A+FnlgBA;EACE,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;A/FslgBF;A+FplgBE;EACE,gBAAA;EACA,cjDxrBI;A9C8whBR;A+FllgBI;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,mCAAA;EACA,qEAAA;EACA,yBjDvrBG;EiDwrBH,uBAAA;EACA,+BAAA;A/FolgBN;A+FjlgBI;EACE,yBAAA;EACA,qBAAA;EACA,2CAAA;A/FmlgBN;;A+F7kgBE;EACE,gBAAA;EACA,WAAA;A/FglgBJ;A+F7kgBE;EACE,kBAAA;A/F+kgBJ;A+F5kgBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;A/F8kgBJ;A+F5kgBI;EACE,cjDnuBG;EiDouBH,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;A/F8kgBN;A+F3kgBI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;A/F6kgBN;A+F1kgBI;EACE,WAAA;EACA,SAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;A/F4kgBN;A+FzkgBI;EACE,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;A/F2kgBN;A+FvkgBE;EACE,WAAA;A/FykgBJ;;A+FrkgBA;EACE;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,WAAA;E/FwkgBF;E+FrkgBA;IACE,YAAA;E/FukgBF;E+FnkgBE;IACE,YAAA;E/FqkgBJ;E+FnkgBI;IACE,WAAA;E/FqkgBN;E+FhkgBA;IACE,YAAA;IACA,SAAA;IACA,yBAAA;IACA,kBAAA;IACA,WAAA;E/FkkgBF;E+FhkgBE;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;E/FkkgBJ;E+F9jgBI;IACE,WAAA;IACA,YAAA;IACA,mCAAA;IACA,qEAAA;IACA,yBjDryBC;IiDsyBD,uBAAA;IACA,+BAAA;E/FgkgBN;E+F5jgBE;IACE,UAAA;E/F8jgBJ;E+F1jgBA;IACE,gBAAA;E/F4jgBF;E+F1jgBE;IACE,mBAAA;E/F4jgBJ;E+FxjgBA;IACE,gBAAA;E/F0jgBF;E+FxjgBE;IACE,eAAA;IACA,iBAAA;IACA,uBAAA;IACA,YAAA;E/F0jgBJ;E+FvjgBE;IACE,+BAAA;IACA,kBAAA;IACA,SAAA;E/FyjgBJ;E+FvjgBI;IACE,eAAA;IACA,sBAAA;E/FyjgBN;E+FtjgBI;IACE,UAAA;IACA,SAAA;E/FwjgBN;E+FtjgBM;IACE,UAAA;IACA,aAAA;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;E/FwjgBR;E+FtjgBQ;IACE,WAAA;IACA,YAAA;E/FwjgBV;E+FjjgBQ;IACE,UAAA;IACA,eAAA;IACA,oBAAA;IACA,sBAAA;E/FmjgBV;E+FhjgBQ;IACE,sBAAA;IACA,uBAAA;IACA,yBAAA;E/FkjgBV;E+FhjgBU;IACE,iCAAA;IACA,aAAA;IACA,SAAA;E/FkjgBZ;E+FhjgBY;IACE,sBAAA;E/FkjgBd;E+F9igBU;IACE,aAAA;IACA,SAAA;E/FgjgBZ;E+F9igBY;IACE,eAAA;IACA,iBAAA;E/FgjgBd;E+F3igBQ;IACE,WAAA;E/F6igBV;E+F3igBU;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,cAAA;E/F6igBZ;E+FvigBI;IACE,eAAA;IACA,iBAAA;IACA,sBAAA;E/FyigBN;E+FtigBI;IACE,SAAA;IACA,WAAA;E/FwigBN;E+FrigBI;IACE,SAAA;E/FuigBN;E+FnigBI;IACE,uBAAA;IACA,SAAA;E/FqigBN;E+FnigBM;IACE,eAAA;IACA,iBAAA;E/FqigBR;E+FligBM;IAEE,gBAAA;E/FmigBR;E+FjigBQ;IACE,kBAAA;IACA,WAAA;IACA,gBAAA;E/FmigBV;E+F5hgBQ;IACE,kBAAA;E/F8hgBV;E+F3hgBQ;IACE,gBAAA;E/F6hgBV;E+FvhgBI;IACE,WAAA;IACA,kBAAA;IACA,SAAA;E/FyhgBN;E+FvhgBM;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,cjDt9BF;E9C++hBN;E+FrhgBI;IACE,WAAA;E/FuhgBN;E+FlhgBA;IACE,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;E/FohgBF;E+FhhgBE;IACE,uBAAA;E/FkhgBJ;E+F/ggBE;IACE,6BAAA;IACA,kBAAA;IACA,SAAA;E/FihgBJ;E+F9ggBE;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,eAAA;E/FghgBJ;E+F7ggBE;IACE,cjD1/BE;IiD2/BF,kBAAA;IACA,eAAA;E/F+ggBJ;E+F7ggBI;IACE,eAAA;IACA,gBAAA;E/F+ggBN;E+F5ggBI;IACE,gBAAA;E/F8ggBN;E+F1ggBE;IACE,gBAAA;E/F4ggBJ;E+FzggBE;IACE,mBAAA;IACA,WAAA;IACA,YAAA;IACA,kBAAA;IACA,eAAA;IACA,mBAAA;E/F2ggBJ;AACF;A+FvggBA;EAEI;IACE,eAAA;IACA,iBAAA;E/FwggBJ;E+FnggBE;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;E/FqggBJ;E+FjggBA;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,WAAA;E/FmggBF;E+FhggBA;IACE,WAAA;E/FkggBF;E+F//fA;IACE,WAAA;E/FiggBF;E+F7/fE;IACE,WAAA;E/F+/fJ;E+F7/fI;IACE,aAAA;E/F+/fN;E+F3/fE;IACE,WAAA;E/F6/fJ;E+F3/fI;IACE,WAAA;IACA,eAAA;IACA,SAAA;E/F6/fN;E+Fv/fA;IACE,WAAA;IACA,kBAAA;IACA,SAAA;E/Fy/fF;E+Fv/fE;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,cjDrlCE;E9C8kiBN;E+Ft/fE;IACE,WAAA;E/Fw/fJ;E+Fp/fA;IACE,WAAA;E/Fs/fF;E+Fj/fE;IACE,eAAA;IACA,iBAAA;E/Fm/fJ;E+F/+fA;IACE,aAAA;IACA,QAAA;E/Fi/fF;E+F/+fE;IACE,0BAAA;IACA,cAAA;E/Fi/fJ;E+F7+fI;IACE,YAAA;IACA,0BAAA;E/F++fN;E+F1+fA;IACE,WAAA;E/F4+fF;E+F1+fE;IACE,mBAAA;E/F4+fJ;E+Fx+fA;IACE,gBAAA;E/F0+fF;E+Fx+fE;IACE,eAAA;IACA,iBAAA;IACA,uBAAA;IAEA,iCAAA;IACA,iBAAA;E/Fy+fJ;E+Fv+fI;IACE,8BAAA;IACA,WAAA;E/Fy+fN;E+Fv+fM;IACE,eAAA;IACA,iBAAA;E/Fy+fR;E+Ft+fM;IACE,eAAA;E/Fw+fR;E+Fn+fE;IACE,kBAAA;IACA,SAAA;E/Fq+fJ;E+Fn+fI;IACE,eAAA;IACA,sBAAA;E/Fq+fN;E+Fl+fI;IACE,WAAA;IACA,SAAA;E/Fo+fN;E+Fl+fM;IACE,UAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;E/Fo+fR;E+Fl+fQ;IACE,WAAA;IACA,YAAA;E/Fo+fV;E+F79fQ;IACE,cAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;E/F+9fV;E+F59fQ;IACE,8CAAA;IACA,6CAAA;E/F89fV;E+F39fQ;IACE,sBAAA;IACA,uBAAA;IACA,yBAAA;E/F69fV;E+F39fU;IACE,iCAAA;IACA,aAAA;IACA,SAAA;E/F69fZ;E+F39fY;IACE,eAAA;E/F69fd;E+F19fY;IACE,sBAAA;E/F49fd;E+Fx9fU;IACE,aAAA;IACA,SAAA;E/F09fZ;E+Fx9fY;IACE,eAAA;IACA,iBAAA;E/F09fd;E+Fv9fY;IACE,kCAAA;IACA,eAAA;IACA,iBAAA;IACA,qBAAA;IACA,qBAAA;E/Fy9fd;E+Fv9fc;IACE,kBAAA;IACA,QAAA;IACA,OAAA;IACA,gBAAA;E/Fy9fhB;E+Fn9fQ;IACE,WAAA;E/Fq9fV;E+Fl9fQ;IACE,WAAA;E/Fo9fV;E+Fl9fU;IACE,eAAA;IACA,iBAAA;E/Fo9fZ;E+Fj9fU;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,cAAA;E/Fm9fZ;E+F/8fY;IACE,aAAA;E/Fi9fd;E+F/8fY;IACE,eAAA;IACA,iBAAA;IACA,aAAA;E/Fi9fd;E+F58fQ;IACE,WAAA;IACA,aAAA;IACA,uBAAA;IACA,sBAAA;IACA,mBAAA;E/F88fV;E+F58fU;IACE,eAAA;IACA,iBAAA;E/F88fZ;E+F38fU;IACE,WAAA;E/F68fZ;E+Fv8fI;IACE,eAAA;IACA,iBAAA;IACA,sBAAA;E/Fy8fN;E+Ft8fI;IACE,SAAA;IACA,WAAA;E/Fw8fN;E+Fr8fI;IACE,SAAA;IACA,WAAA;E/Fu8fN;E+Fp8fI;IACE,uBAAA;E/Fs8fN;E+Fp8fM;IACE,eAAA;IACA,iBAAA;E/Fs8fR;E+Fn8fM;IACE,WAAA;IACA,gBAAA;E/Fq8fR;E+Fn8fQ;IACE,kBAAA;IACA,gBAAA;IACA,WAAA;E/Fq8fV;E+Fj8fM;IACE,WAAA;E/Fm8fR;E+Fj8fQ;IACE,kBAAA;E/Fm8fV;E+Fh8fQ;IACE,gBAAA;E/Fk8fV;E+F77fI;IACE,iCAAA;E/F+7fN;E+F57fI;IACE,sBAAA;E/F87fN;E+Fv7fI;IACE,eAAA;IACA,iBAAA;E/Fy7fN;E+Fp7fA;IACE,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;E/Fs7fF;E+Fl7fE;IACE,6BAAA;IACA,kBAAA;IACA,QAAA;E/Fo7fJ;E+Fj7fE;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,eAAA;IACA,mBAAA;IACA,iBAAA;E/Fm7fJ;E+Fh7fE;IACE,YAAA;IACA,eAAA;E/Fk7fJ;E+F/6fE;IACE,cjDp4CE;IiDq4CF,kBAAA;IACA,eAAA;E/Fi7fJ;E+F/6fI;IACE,eAAA;IACA,gBAAA;E/Fi7fN;E+F96fI;IACE,yBAAA;IACA,gBAAA;E/Fg7fN;E+F56fE;IACE,gBAAA;E/F86fJ;E+F36fE;IACE,mBAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,eAAA;IACA,mBAAA;E/F66fJ;E+Fx6fE;IACE,WAAA;E/F06fJ;E+Fv6fE;IACE,kBAAA;E/Fy6fJ;E+Fr6fI;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;E/Fu6fN;E+Fp6fI;IACE,eAAA;IACA,iBAAA;E/Fs6fN;E+Fn6fI;IACE,WAAA;E/Fq6fN;E+Fl6fI;IACE,eAAA;IACA,iBAAA;E/Fo6fN;E+F95fI;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,mCAAA;IACA,qEAAA;IACA,yBjD77CC;IiD87CD,qBAAA;IACA,+BAAA;E/Fg6fN;E+F75fI;IACE,yBAAA;IACA,qBAAA;IACA,2CAAA;E/F+5fN;AACF;AgGp3iBA;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,mBlDDM;EkDEN,6BAAA;EACA,gCAAA;EACA,kBAAA;AhGs3iBF;AgGp3iBE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,clDVI;A9Cg4iBR;AgGn3iBE;EACE,SAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;AhGq3iBJ;AgGl3iBE;EACE,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AhGo3iBJ;AgGj3iBE;EACE,WAAA;AhGm3iBJ;AgGh3iBE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;AhGk3iBJ;;AgG92iBA;EACE,iBAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AhGi3iBF;AgG/2iBE;EACE,0BAAA;EACA,clD3DK;EkD4DL,kBAAA;EACA,SAAA;AhGi3iBJ;AgG/2iBI;EACE,iBAAA;AhGi3iBN;;AgG52iBA;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;AhG+2iBF;;AgG52iBA;EACE,eAAA;EACA,iBAAA;EACA,QAAA;AhG+2iBF;AgG72iBE;EACE,0CAAA;EACA,yBAAA;AhG+2iBJ;;AgG32iBA;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,mBlD9FM;EkD+FN,6BAAA;EACA,gCAAA;EACA,kBAAA;AhG82iBF;AgG52iBE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,clDvGI;A9Cq9iBR;AgG32iBE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,clDhHI;A9C69iBR;AgG32iBI;EACE,YAAA;EACA,6BAAA;AhG62iBN;AgGx2iBI;EACE,QAAA;EACA,2BAAA;EACA,WAAA;EACA,eAAA;AhG02iBN;AgGv2iBI;EACE,YAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,clDvIE;EkDwIF,eAAA;AhGy2iBN;AgGv2iBM;EACE,mCAAA;EACA,eAAA;AhGy2iBR;AgGt2iBM;EACE,yBAAA;EACA,qBAAA;AhGw2iBR;AgGp2iBI;EACE,gBAAA;EACA,mBAAA;AhGs2iBN;AgGn2iBI;EACE,cAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AhGq2iBN;AgGn2iBM;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,gCAAA;AhGq2iBR;AgGl2iBM;EACE,mBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,QAAA;EACA,gCAAA;AhGo2iBR;AgGh2iBI;EACE,aAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;AhGk2iBN;AgGh2iBM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,QAAA;AhGk2iBR;AgG/1iBM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,clDhNA;A9CijjBR;AgG91iBM;EACE,eAAA;AhGg2iBR;AgG51iBI;EACE,aAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;AhG81iBN;AgG51iBM;EACE,+BAAA;EACA,cAAA;AhG81iBR;AgG11iBI;EACE,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,qBAAA;AhG41iBN;AgG11iBM;EACE,SAAA;AhG41iBR;AgG11iBQ;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,+BAAA;EACA,cAAA;AhG41iBV;AgGx1iBM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,clDtQA;A9CgmjBR;AgGt1iBI;EACE,WAAA;EACA,6BAAA;EACA,gBAAA;AhGw1iBN;AgGr1iBI;EACE,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;AhGu1iBN;;AgGl1iBA;EACE,YAAA;EACA,mBlD5RM;EkD6RN,yCAAA;AhGq1iBF;AgGn1iBE;EACE,iCAAA;EACA,0BAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,clDzSK;EkD0SL,eAAA;EACA,WAAA;AhGq1iBJ;AgGl1iBE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;AhGo1iBJ;AgGl1iBI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,clDrTE;EkDsTF,mBAAA;AhGo1iBN;AgGj1iBI;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;AhGm1iBN;AgGj1iBM;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,clDvUA;A9C0pjBR;AgGh1iBM;EACE,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;AhGk1iBR;AgG70iBE;EACE,WAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AhG+0iBJ;AgG70iBI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,clD9VE;EkD+VF,mBAAA;AhG+0iBN;AgG50iBI;EACE,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AhG80iBN;AgG50iBM;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,clDjXA;A9C+rjBR;AgG30iBM;EACE,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;AhG60iBR;AgGx0iBE;EACE,aAAA;EACA,SAAA;AhG00iBJ;AgGx0iBI;EACE,WAAA;EACA,SAAA;AhG00iBN;AgGx0iBM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,clD1YA;A9CotjBR;AgGv0iBM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AhGy0iBR;AgGv0iBQ;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,clD5ZF;A9CqujBR;AgGv0iBU;EACE,gBAAA;AhGy0iBZ;AgGr0iBQ;EACE,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;AhGu0iBV;AgGl0iBI;EACE,UAAA;EACA,gBAAA;AhGo0iBN;AgGl0iBM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,clDrbA;A9CyvjBR;AgGj0iBM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,clD9bA;A9CiwjBR;AgGh0iBM;EACE,YAAA;EACA,6BAAA;AhGk0iBR;AgG/ziBM;EACE,SAAA;AhGi0iBR;AgG/ziBQ;EACE,QAAA;EACA,2BAAA;EACA,WAAA;EACA,eAAA;AhGi0iBV;;AgGzziBE;EACE,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,clDzdI;EkD0dJ,kBAAA;EACA,WAAA;EACA,kBAAA;AhG4ziBJ;AgGzziBE;EACE,yCAAA;AhG2ziBJ;AgGxziBE;EACE,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;AhG0ziBJ;AgGvziBM;EACE,YAAA;AhGyziBR;AgGtziBM;EACE,iBAAA;AhGwziBR;AgGtziBQ;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,cAAA;AhGwziBV;;AgGjziBA;EACE,WAAA;AhGoziBF;;AgGjziBA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AhGoziBF;AgGlziBE;EACE,yBAAA;AhGoziBJ;AgGjziBE;EACE,yBAAA;AhGmziBJ;AgGhziBE;EACE,yBAAA;EACA,kBAAA;EACA,qBAAA;AhGkziBJ;AgG/yiBE;EACE,iBAAA;EACA,cAAA;EACA,iBAAA;AhGiziBJ;AgG9yiBE;EACE,cAAA;EACA,yBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;AhGgziBJ;AgG7yiBE;EACE,UAAA;AhG+yiBJ;AgG5yiBE;EACE,cAAA;EACA,YAAA;EACA,mBAAA;AhG8yiBJ;AgG3yiBE;EACE,kBAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AhG6yiBJ;;AgGzyiBA;EAEI;IACE,kBAAA;IACA,SAAA;EhG2yiBJ;EgGzyiBI;IACE,SAAA;IACA,eAAA;IACA,eAAA;IACA,iBAAA;EhG2yiBN;EgGtyiBA;IACE,eAAA;EhGwyiBF;EgGpyiBE;IACE,iBAAA;EhGsyiBJ;EgGjyiBE;IACE,iBAAA;EhGmyiBJ;EgG/xiBA;IACE,eAAA;EhGiyiBF;EgG7xiBE;IACE,iBAAA;EhG+xiBJ;EgG3xiBA;IACE,WAAA;EhG6xiBF;EgG1xiBA;IACE,UAAA;IACA,kBAAA;EhG4xiBF;EgG1xiBE;IACE,eAAA;EhG4xiBJ;EgGzxiBE;IACE,WAAA;EhG2xiBJ;EgGvxiBA;IACE,UAAA;IACA,kBAAA;IACA,SAAA;EhGyxiBF;EgGvxiBE;IACE,eAAA;IACA,iBAAA;EhGyxiBJ;EgGtxiBE;IACE,WAAA;EhGwxiBJ;EgGjxiBE;IACE,YAAA;IACA,eAAA;IACA,iBAAA;EhGmxiBJ;EgG5wiBM;IACE,eAAA;IACA,iBAAA;EhG8wiBR;EgGxwiBQ;IACE,eAAA;IACA,eAAA;IACA,iBAAA;EhG0wiBV;EgGvwiBQ;IACE,eAAA;EhGywiBV;EgGnwiBM;IACE,eAAA;IACA,iBAAA;EhGqwiBR;EgGlwiBM;IACE,eAAA;IACA,iBAAA;EhGowiBR;EgG9viBI;IACE,eAAA;IACA,iBAAA;EhGgwiBN;EgG3viBI;IACE,eAAA;IACA,iBAAA;EhG6viBN;EgGxviBA;IACE,WAAA;EhG0viBF;EgGvviBA;IACE,WAAA;IACA,YAAA;IACA,aAAA;IACA,iBAAA;IACA,mBAAA;EhGyviBF;EgGvviBE;IACE,yBAAA;EhGyviBJ;EgGtviBE;IACE,yBAAA;EhGwviBJ;EgGrviBE;IACE,yBAAA;IACA,kBAAA;IACA,qBAAA;EhGuviBJ;EgGpviBE;IACE,iBAAA;IACA,cAAA;IACA,iBAAA;EhGsviBJ;EgGnviBE;IACE,cAAA;IACA,yBAAA;IACA,uBAAA;IACA,cAAA;IACA,iBAAA;IACA,iBAAA;EhGqviBJ;EgGlviBE;IACE,iBAAA;IACA,kBAAA;EhGoviBJ;EgGjviBE;IACE,UAAA;EhGmviBJ;EgGhviBE;IACE,cAAA;IACA,YAAA;IACA,kBAAA;EhGkviBJ;EgG/uiBE;IACE,kBAAA;IACA,eAAA;IACA,SAAA;IACA,WAAA;IACA,WAAA;IACA,YAAA;EhGiviBJ;AACF;AgG5uiBA;EACE;IACE,eAAA;IACA,QAAA;IACA,sBAAA;EhG8uiBF;EgGvuiBA;IACE,WAAA;IACA,kBAAA;EhGyuiBF;EgGvuiBE;IACE,eAAA;EhGyuiBJ;EgGtuiBE;IACE,WAAA;EhGwuiBJ;EgGpuiBA;IACE,WAAA;IACA,kBAAA;IACA,SAAA;EhGsuiBF;EgGpuiBE;IACE,eAAA;IACA,iBAAA;EhGsuiBJ;EgGnuiBE;IACE,WAAA;EhGquiBJ;EgGluiBE;IACE,eAAA;IACA,yBAAA;EhGouiBJ;EgG/tiBE;IACE,YAAA;IACA,eAAA;IACA,iBAAA;EhGiuiBJ;EgG9tiBE;IACE,iBAAA;EhGguiBJ;EgG7tiBM;IACE,eAAA;IACA,iBAAA;EhG+tiBR;EgG5tiBM;IACE,kBAAA;EhG8tiBR;EgG5tiBQ;IACE,eAAA;IACA,eAAA;IACA,iBAAA;EhG8tiBV;EgG3tiBQ;IACE,eAAA;EhG6tiBV;EgGvtiBM;IACE,eAAA;IACA,iBAAA;EhGytiBR;EgGntiBI;IACE,eAAA;IACA,iBAAA;EhGqtiBN;EgGhtiBI;IACE,eAAA;IACA,iBAAA;EhGktiBN;AACF;AgG7siBA;;EAEE,yBAAA;AhG+siBF;;AgG5siBA;EACE,0BAAA;EACA,iBAAA;AhG+siBF;;AgG5siBA;EACE,yBAAA;AhG+siBF;;AiGjkkBA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AjGokkBJ;;AiGjkkBA;EACI,eAAA;EACA,kBAAA;AjGokkBJ;;AiGjkkBA;EACI,yBnDNG;A9C0kkBP;;AiGjkkBA;EACI,yBnDhBW;A9ColkBf;;AiGjkkBA;EACI,cnDlBI;EmDmBJ,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AjGokkBJ;;AiGjkkBA;EACI,oBAAA;AjGokkBJ;AiGnkkBI;EACI,cnD9BA;EmD+BA,yBnDzBF;EmD0BE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AjGqkkBR;;AiGjkkBA;EACI,gBAAA;AjGokkBJ;;AiGjkkBA;EACI,eAAA;EACA,cnD7CG;EmD8CH,0BAAA;EACA,iBAAA;AjGokkBJ;;AiGjkkBA;EACI,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;AjGokkBJ;AiGlkkBI;EACI,2BAAA;EACA,wBAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AjGokkBR;;AiG/jkBA;EAKI;IACI,eAAA;IACA,gBAAA;EjG8jkBN;EiG3jkBE;IACI,kBAAA;IACA,mBAAA;IACA,UAAA;EjG6jkBN;EiG1jkBE;IACI,aAAA;EjG4jkBN;EiGzjkBE;IACI,WAAA;IACA,gBAAA;IACA,YAAA;EjG2jkBN;EiGxjkBE;IACI,aAAA;IACA,8BAAA;IACA,mBAAA;EjG0jkBN;EiGvjkBE;IACI,aAAA;IACA,8BAAA;EjGyjkBN;EiGljkBE;IACI,aAAA;IACA,uBAAA;EjGojkBN;EiGjjkBE;IACI,UAAA;EjGmjkBN;EiGjjkBM;IACI,WAAA;EjGmjkBV;EiG/ikBE;IACI,mBAAA;EjGijkBN;EiG9ikBE;IACI,iBAAA;IACA,8BAAA;EjGgjkBN;AACF;AiG5ikBA;EAKI;IACI,aAAA;IACA,mBAAA;IACA,WAAA;EjG0ikBN;EiGvikBE;IACI,aAAA;EjGyikBN;EiGtikBE;IACI,WAAA;EjGwikBN;EiGrikBE;IACI,aAAA;IACA,8BAAA;EjGuikBN;EiGnikBE;IACI,gBAAA;IACA,gBAAA;IACA,kBAAA;EjGqikBN;EiGlikBE;IACI,aAAA;IACA,8BAAA;EjGoikBN;EiGlikBM;IACI,kBAAA;IACA,QAAA;EjGoikBV;EiG5hkBE;IACI,aAAA;IACA,uBAAA;IACA,sBAAA;EjG8hkBN;EiG3hkBE;IACI,WAAA;EjG6hkBN;EiG3hkBM;IACI,WAAA;EjG6hkBV;EiGzhkBE;IACI,mBAAA;EjG2hkBN;EiGxhkBE;IACI,iBAAA;IACA,8BAAA;EjG0hkBN;AACF;AkGvukBA;EACI,WAAA;AlGyukBJ;AkGvukBI;EACI,WAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;AlGyukBR;AkGvukBQ;EACI,SAAA;AlGyukBZ;AkGrukBI;EAEI;IACI,UAAA;IACA,aAAA;IACA,aAAA;IACA,2BAAA;IACA,sBAAA;IACA,oBAAA;IACA,YAAA;IACA,eAAA;ElGsukBV;EkGnukBM;IACI,2BAAA;IACA,wBAAA;IACA,4BAAA;IACA,WAAA;IACA,aAAA;IACA,gBAAA;ElGqukBV;EkGlukBM;IACI,WAAA;ElGoukBV;EkGjukBM;IACI,iBAAA;IACA,oBAAA;ElGmukBV;AACF;AkGhukBI;EACI;IACI,2BAAA;IACA,wBAAA;IACA,4BAAA;IACA,WAAA;IACA,aAAA;IACA,gBAAA;ElGkukBV;EkG3tkBM;IACI,mBAAA;IACA,UAAA;IACA,aAAA;ElG6tkBV;EkG3tkBU;IACI,aAAA;IACA,sBAAA;ElG6tkBd;EkGztkBM;IACI,qBAAA;IACA,gBAAA;ElG2tkBV;AACF;AkGxtkBI;EACI;IACI,WAAA;IACA,cAAA;ElG0tkBV;AACF;;AkGrtkBI;EACI,WAAA;AlGwtkBR;AkGrtkBI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBpD9FO;EoD+FP,yBAAA;EACA,+BAAA;EACA,kBAAA;AlGutkBR;AkGptkBI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBpDzGO;EoD0GP,yBAAA;EACA,kBAAA;AlGstkBR;AkGntkBI;EACI,aAAA;EACA,mBAAA;AlGqtkBR;AkGltkBI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AlGotkBR;AkGltkBQ;EACI,cAAA;EACA,gBAAA;EACA,gBAAA;AlGotkBZ;AkGhtkBI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBpDrIO;EoDsIP,mBAAA;AlGktkBR;AkGhtkBQ;EACI,cpD1IH;EoD2IG,gBAAA;EACA,gBAAA;AlGktkBZ;AkG9skBI;EACI,mBpDhJO;EoDiJP,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AlGgtkBR;AkG9skBQ;EACI,cpDtJJ;EoDuJI,yBpD1JH;EoD2JG,gBAAA;EACA,kBAAA;EACA,iBAAA;AlGgtkBZ;AkG5skBI;EACI,WAAA;EACA,YAAA;EACA,2FAAA;EACA,cpDlKA;EoDmKA,YAAA;AlG8skBR;AkG3skBI;EACI,WAAA;EACA,YAAA;EACA,uFAAA;EACA,cpD1KA;EoD2KA,YAAA;AlG6skBR;AkG1skBI;EACI,gBAAA;EACA,wDAAA;AlG4skBR;AkGzskBI;EACI,cAAA;EACA,kBAAA;EACA,aAAA;AlG2skBR;AkGxskBI;EACI,cAAA;EACA,gBAAA;AlG0skBR;AkGvskBI;EACI,cpDlMC;EoDmMD,oBAAA;AlGyskBR;AkGtskBI;EACI,0BAAA;EACA,cpDxMC;EoDyMD,gBAAA;AlGwskBR;AkGrskBI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AlGuskBR;AkGpskBI;EACI,0DAAA;EACA,kBAAA;AlGsskBR;AkGnskBI;EACI,yBpDvNO;EoDwNP,qBAAA;EACA,mBAAA;EACA,qBAAA;EACA,YAAA;AlGqskBR;AkGlskBI;EACI,mBAAA;AlGoskBR;AkGjskBI;EACI,mBAAA;AlGmskBR;AkG/rkBQ;EACI,kBAAA;AlGiskBZ;AkG7rkBI;EACI,gCAAA;EACA,mBAAA;AlG+rkBR;AkG5rkBI;EA7JJ;IA8JQ,iBAAA;ElG+rkBN;EkG7rkBM;IACI,aAAA;IACA,8BAAA;ElG+rkBV;EkG5rkBM;IACI,UAAA;ElG8rkBV;EkG3rkBU;IACI,eAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;ElG6rkBd;EkGzrkBM;IACI,kBAAA;ElG2rkBV;EkGxrkBM;IACI,mBAAA;ElG0rkBV;EkGvrkBM;IACI,2BAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;ElGyrkBV;EkGtrkBM;IACI,aAAA;IACA,mBAAA;ElGwrkBV;EkGrrkBM;IACI,kBAAA;IACA,mBAAA;ElGurkBV;EkGprkBM;;IAEI,aAAA;ElGsrkBV;EkGprkBU;;IACI,eAAA;ElGurkBd;EkGlrkBM;IACI,eAAA;ElGorkBV;EkGjrkBM;IACI,cAAA;ElGmrkBV;EkG/qkBU;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;ElGirkBd;AACF;AkG7qkBI;EACI;IACI,2BAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;ElG+qkBV;EkG5qkBM;;IAEI,kBAAA;IACA,mBAAA;ElG8qkBV;EkG3qkBM;;IAEI,aAAA;ElG6qkBV;EkG3qkBU;;IACI,eAAA;ElG8qkBd;EkGzqkBM;IACI,eAAA;ElG2qkBV;EkGvqkBU;IACI,eAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;ElGyqkBd;EkGrqkBM;IACI,kBAAA;ElGuqkBV;EkGpqkBM;IACI,kBAAA;ElGsqkBV;EkGlqkBU;IACI,kBAAA;ElGoqkBd;EkGhqkBM;IACI,cAAA;ElGkqkBV;EkG/pkBM;IACI,aAAA;IACA,uBAAA;IACA,mBAAA;ElGiqkBV;EkG/pkBU;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;ElGiqkBd;AACF;;AmGrilBA;EACI,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AnGwilBJ;;AmGrilBA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AnGwilBJ;;AmGrilBA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,eAAA;AnGuilBJ;;AmGpilBA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AnGuilBJ;;AmGpilBA;EACI,gCAAA;EACA,0BAAA;AnGuilBJ;;AmGpilBA;EACI,WAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;AnGuilBJ;AmGrilBI;EACI,iBAAA;EACA,6BAAA;AnGuilBR;AmGpilBI;EACI,oBAAA;EACA,gCAAA;AnGsilBR;;AmGlilBA;EACI,mBrDpDW;EqDqDX,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,oBAAA;EACA,sBAAA;AnGqilBJ;;AmGlilBA;EACI,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,crD9DI;EqD+DJ,iBAAA;EACA,qBAAA;EACA,qBAAA;AnGqilBJ;;AmGlilBA;EACI;IACI,aAAA;IACA,8BAAA;EnGqilBN;EmGlilBE;IACI,UAAA;EnGoilBN;EmGjilBE;IACI,eAAA;EnGmilBN;EmGhilBE;IACI,UAAA;EnGkilBN;EmG/hlBE;IACI,YAAA;IACA,aAAA;IACA,8BAAA;IACA,UAAA;EnGiilBN;EmG9hlBE;IACI,WAAA;IACA,mBAAA;EnGgilBN;EmG7hlBE;IACI,aAAA;IACA,cAAA;IACA,UAAA;IACA,aAAA;IACA,eAAA;EnG+hlBN;EmG3hlBE;IACI,WAAA;IACA,kBAAA;IACA,UAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EnG6hlBN;EmG1hlBE;IACI,eAAA;IACA,sBAAA;IACA,iBAAA;EnG4hlBN;AACF;AmGzhlBA;EACI;IACI,oBAAA;EnG2hlBN;EmGxhlBE;IACI,aAAA;IACA,uBAAA;EnG0hlBN;EmGvhlBE;IACI,eAAA;EnGyhlBN;EmGthlBE;IACI,WAAA;EnGwhlBN;EmGrhlBE;IACI,YAAA;IACA,aAAA;IACA,8BAAA;IACA,WAAA;EnGuhlBN;EmGphlBE;IACI,WAAA;IACA,mBAAA;EnGshlBN;EmGnhlBE;IACI,sBAAA;EnGqhlBN;EmGlhlBE;IACI,cAAA;IACA,WAAA;IACA,eAAA;IACA,aAAA;IACA,uBAAA;IACA,UAAA;IACA,mBAAA;IACA,eAAA;EnGohlBN;EmGhhlBE;IACI,WAAA;IACA,kBAAA;IACA,UAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EnGkhlBN;EmG/glBE;IACI,kBAAA;IACA,QAAA;EnGihlBN;EmG9glBE;IACI,WAAA;IACA,kBAAA;EnGghlBN;EmG7glBE;IACI,eAAA;EnG+glBN;AACF;AoGjtlBA;EACI,mBAAA;ApGmtlBJ;;AoGhtlBA;EACE,kBAAA;ApGmtlBF;;AoGhtlBA;EACE,sBAAA;ApGmtlBF;;AoGhtlBA;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;ApGmtlBF;;AoGhtlBA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;ApGmtlBF;;AoGhtlBA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;ApGmtlBF;;AoGhtlBA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;ApGmtlBF;;AoGhtlBA;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;ApGmtlBF;;AoGhtlBA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;ApGmtlBF;;AoGhtlBA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;ApGmtlBF;;AoGhtlBA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;ApGmtlBF;;AoGhtlBA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;ApGmtlBJ;AoGjtlBI;EACI,WAAA;ApGmtlBR;AoG/slBQ;EACI,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,ctDjFJ;A9CkylBR;AoG9slBQ;EACI,ctDrFJ;A9CqylBR;;AoG1slBE;EACE,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,ctDjGI;A9C8ylBR;AoG1slBE;EACE,ctDrGI;A9CizlBR;AoGzslBE;EACE,SAAA;ApG2slBJ;;AoGvslBA;EACI,WAAA;EACA,yBtDhHI;EsDiHJ,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;ApG0slBJ;AoGxslBI;EACI,WAAA;ApG0slBR;;AoGrslBA;EACE,kBAAA;ApGwslBF;;AoGrslBA;EACE,kBAAA;ApGwslBF;AoGtslBE;EACE,YAAA;ApGwslBJ;;AoGpslBA;EACI,kBAAA;EACA,UAAA;EACA,WAAA;ApGuslBJ;;AoGpslBA;EACI,2BAAA;ApGuslBJ;;AoGnslBI;EACI,kBAAA;EACA,cAAA;EACA,gBAAA;ApGsslBR;;AoGlslBA;EAIQ;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,ctDpKJ;E9Cs2lBN;EoG7rlBE;IACI,aAAA;IACA,8BAAA;EpG+rlBN;EoG5rlBE;IACI,UAAA;IACA,gBAAA;EpG8rlBN;EoG5rlBM;IACI,UAAA;IACA,kBAAA;EpG8rlBV;EoG5rlBU;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,aAAA;IACA,qBAAA;EpG8rlBd;EoG3rlBU;IACI,iBAAA;IACA,kBAAA;IACA,eAAA;IACA,yBtDrMP;IsDsMO,kBAAA;IACA,QAAA;EpG6rlBd;EoG1rlBU;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,ctDhNP;IsDiNO,sBAAA;IACA,iBAAA;IACA,qBAAA;EpG4rlBd;EoGzrlBU;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,cAAA;EpG2rlBd;EoGtrlBM;IACI,gBAAA;IACA,yBAAA;IACA,kBAAA;IACA,mBtDjOJ;E9Cy5lBN;EoGnrlBU;IACI,yBAAA;IACA,cAAA;EpGqrlBd;EoGnrlBU;IACI,yBAAA;IACA,cAAA;EpGqrlBd;EoGhrlBE;IACI,UAAA;IACA,gBAAA;IACA,gBAAA;EpGkrlBN;EoGhrlBM;IACI,mBAAA;EpGkrlBV;EoG/qlBM;IACI,YAAA;IACA,aAAA;EpGirlBV;EoG7qlBE;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,ctDnQA;E9Ck7lBN;EoG5qlBE;IACI,kBAAA;IACA,eAAA;IACA,iBAAA;IACA,WAAA;IACA,iBAAA;EpG8qlBN;EoGzqlBM;IACI,ctDrRH;IsDsRG,eAAA;EpG2qlBV;EoGzqlBU;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,uBAAA;IACA,0BAAA;IACA,gBAAA;EpG2qlBd;EoGvqlBM;IACI,WAAA;EpGyqlBV;EoGtqlBc;IACI,gCAAA;IACA,eAAA;EpGwqlBlB;EoGtqlBkB;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;EpGwqlBtB;EoGpqlBc;IACI,mBAAA;EpGsqlBlB;EoGlqlBU;IACI,mBAAA;EpGoqlBd;EoGlqlBc;IACI,kBAAA;IACA,eAAA;IACA,iBAAA;IACA,WAAA;IACA,iBAAA;EpGoqlBlB;EoGjqlBc;IACI,kBAAA;EpGmqlBlB;EoG5plBM;IACI,eAAA;EpG8plBV;EoG5plBU;IACI,aAAA;IACA,mBAAA;IACA,yBAAA;IACA,kBAAA;IACA,gBAAA;EpG8plBd;EoG3plBU;IACI,mBAAA;IACA,aAAA;EpG6plBd;EoG3plBc;IACI,cAAA;IACA,YAAA;IACA,iBAAA;EpG6plBlB;EoG1plBc;IACI,WAAA;IACA,kBAAA;IACA,YAAA;IACA,QAAA;EpG4plBlB;EoGzplBc;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,ctDvWZ;E9CkgmBN;EoGpplBU;IACI,yBtDhXR;IsDiXQ,kBAAA;IACA,mBAAA;EpGsplBd;AACF;AoGjplBA;EACE;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;EpGmplBF;EoGjplBA;IACE,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,iBAAA;EpGmplBF;EoGhplBA;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;EpGkplBF;EoGhplBE;IACI,kBAAA;IACA,cAAA;IACA,gBAAA;IACA,WAAA;IACA,iBAAA;EpGkplBN;EoG/olBE;IACI,YAAA;EpGiplBN;EoG/olBM;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,ctDzZJ;E9C0imBN;EoG5olBE;IACI,aAAA;IACA,8BAAA;IACA,sBAAA;IACA,YAAA;EpG8olBN;EoG3olBE;IACI,UAAA;IACA,WAAA;EpG6olBN;EoG1olBE;IACI,WAAA;EpG4olBN;EoGzolBM;IACI,WAAA;IACA,mBAAA;EpG2olBV;EoGzolBU;IACI,eAAA;IACA,iBAAA;EpG2olBd;EoGxolBU;IACI,iBAAA;IACA,kBAAA;IACA,eAAA;IACA,yBtD7bP;IsD8bO,kBAAA;IACA,QAAA;EpG0olBd;EoGvolBU;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,ctDxcP;IsDycO,sBAAA;IACA,gBAAA;EpGyolBd;EoGtolBU;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,cAAA;EpGwolBd;EoGpolBM;IACI,kBAAA;IACA,yBAAA;IACA,kBAAA;IACA,mBtDvdJ;E9C6lmBN;EoGlolBU;IACI,yBAAA;IACA,cAAA;EpGoolBd;EoGlolBU;IACI,yBAAA;IACA,cAAA;EpGoolBd;EoG/nlBE;IACI,WAAA;IACA,gBAAA;EpGiolBN;EoG/nlBM;IACI,mBAAA;EpGiolBV;EoG9nlBM;IACI,YAAA;IACA,aAAA;EpGgolBV;EoG5nlBE;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,ctDvfA;E9CqnmBN;EoG3nlBE;IACI,WAAA;EpG6nlBN;EoG3nlBM;IACI,WAAA;IACA,mBAAA;IACA,yBAAA;EpG6nlBV;EoG3nlBU;IACI,sBAAA;EpG6nlBd;EoGvnlBM;IACI,8BAAA;EpGynlBV;EoGtnlBM;IACI,ctDlhBH;IsDmhBG,eAAA;EpGwnlBV;EoGtnlBU;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,uBAAA;IACA,0BAAA;IACA,gBAAA;EpGwnlBd;EoGpnlBM;IACI,WAAA;EpGsnlBV;EoGnnlBc;IACI,gCAAA;IACA,eAAA;EpGqnlBlB;EoGnnlBkB;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;EpGqnlBtB;EoGjnlBc;IACI,mBAAA;EpGmnlBlB;EoG/mlBU;IACI,mBAAA;EpGinlBd;EoG/mlBc;IACI,kBAAA;IACA,eAAA;IACA,iBAAA;IACA,WAAA;IACA,iBAAA;EpGinlBlB;EoG9mlBc;IACI,WAAA;IACA,mBAAA;EpGgnlBlB;EoGzmlBM;IACI,WAAA;EpG2mlBV;EoGxmlBc;IACI,eAAA;IACA,iBAAA;IACA,YAAA;EpG0mlBlB;EoGvmlBc;IACI,YAAA;EpGymlBlB;EoGrmlBU;IACI,aAAA;IACA,mBAAA;IACA,yBAAA;IACA,kBAAA;IACA,gBAAA;EpGumlBd;EoGpmlBU;IACI,mBAAA;IACA,aAAA;EpGsmlBd;EoGpmlBc;IACI,cAAA;IACA,YAAA;IACA,iBAAA;EpGsmlBlB;EoGnmlBc;IACI,WAAA;IACA,kBAAA;IACA,YAAA;IACA,QAAA;EpGqmlBlB;EoGjmlBc;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,ctDlnBZ;E9CqtmBN;EoG9llBU;IACI,yBtDznBR;IsD0nBQ,kBAAA;EpGgmlBd;AACF;AoG3llBA;EACI;IACI,aAAA;IACA,yBAAA;EpG6llBN;EoG1llBE;IACI,YAAA;EpG4llBN;EoGzllBE;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,ctD9oBA;E9CyumBN;EoGxllBE;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,cAAA;IACA,kBAAA;EpG0llBN;EoGvllBE;IACI,aAAA;IACA,sBAAA;IACA,mBAAA;EpGyllBN;EoGtllBE;IACI,aAAA;EpGwllBN;EoGtllBM;IACI,cAAA;IACA,yBAAA;IACA,kBAAA;IACA,oBAAA;EpGwllBV;EoGtllBU;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,ctD9qBR;IsD+qBQ,gBAAA;IACA,kBAAA;EpGwllBd;EoGpllBM;IACI,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,yBtD5rBH;IsD6rBG,ctD1rBJ;IsD2rBI,eAAA;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;EpGsllBV;AACF;AoGlllBA;EAKI;IACI,WAAA;EpGgllBN;EoG7klBE;IACI,WAAA;IACA,aAAA;IACA,8BAAA;EpG+klBN;EoG5klBE;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,ctDttBA;E9CoymBN;EoG3klBE;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,cAAA;IACA,kBAAA;EpG6klBN;EoGzklBE;IACI,aAAA;EpG2klBN;EoGzklBM;IACI,cAAA;IACA,yBAAA;IACA,kBAAA;IACA,oBAAA;EpG2klBV;EoGzklBU;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,ctDjvBR;IsDkvBQ,gBAAA;IACA,kBAAA;EpG2klBd;EoGvklBM;IACI,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,yBtD/vBH;IsDgwBG,ctD7vBJ;IsD8vBI,eAAA;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;EpGyklBV;AACF;AoGrklBA;EAGI,SAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,ctDhxBI;EsDixBJ,eAAA;EACA,kBAAA;ApGqklBJ;AoGpklBI;EACI,eAAA;ApGsklBR;AoGpklBI;EACI,2BAAA;EACA,2BAAA;ApGsklBR;;AoGjklBI;EACI,6BAAA;ApGoklBR;AoGjklBI;EACI;IACI,aAAA;IACA,8BAAA;EpGmklBV;EoGhklBM;IACI,UAAA;IACA,iBAAA;EpGkklBV;EoG/jlBM;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,ctDhzBJ;IsDizBI,mBAAA;EpGiklBV;EoG9jlBM;IACI,eAAA;EpGgklBV;EoG7jlBM;;IAEI,eAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,ctD/zBJ;E9C83mBN;EoG5jlBM;IACI,aAAA;IACA,8BAAA;IACA,WAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,ctD10BJ;IsD20BI,eAAA;EpG8jlBV;EoG3jlBM;IACI,kBAAA;IACA,eAAA;IACA,iBAAA;IACA,WAAA;IACA,iBAAA;EpG6jlBV;AACF;AoG1jlBI;EACI;IACI,aAAA;IACA,8BAAA;IACA,sBAAA;IACA,YAAA;EpG4jlBV;EoGzjlBM;IACI,WAAA;IACA,kBAAA;IACA,YAAA;IACA,QAAA;EpG2jlBV;EoGxjlBM;IACI,WAAA;EpG0jlBV;EoGvjlBM;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,uBAAA;IACA,ctD/2BJ;IsDg3BI,mBAAA;EpGyjlBV;EoGtjlBM;IACI,eAAA;EpGwjlBV;EoGrjlBM;;IAEI,cAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,ctD93BJ;E9Cq7mBN;EoGpjlBM;IACI,aAAA;IACA,8BAAA;IACA,WAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,ctDz4BJ;IsD04BI,eAAA;EpGsjlBV;AACF;;AoGljlBA;EACI,WAAA;ApGqjlBJ;;AoGljlBA;EACI,UAAA;ApGqjlBJ;AoGnjlBI;;EAEI,ctDz5BA;EsD05BA,yBtD75BC;EsD85BD,yBAAA;ApGqjlBR;AoGljlBI;EACI,yBAAA;ApGojlBR;AoGjjlBI;EACI,oBAAA;ApGmjlBR;AoGhjlBI;EACI,yBAAA;ApGkjlBR;AoG/ilBI;EACI,yBtD76BO;A9C89mBf;;AoG5ilBI;EACI,yBtDn7BO;A9Ck+mBf;;AoG3ilBA;EAEQ;IACI,WAAA;IACA,YAAA;IACA,iBAAA;EpG6ilBV;EoG1ilBM;IACI,WAAA;IACA,YAAA;IACA,WAAA;EpG4ilBV;EoGxilBE;IACI,WAAA;IACA,aAAA;IACA,uBAAA;IACA,sBAAA;EpG0ilBN;EoGxilBM;IACI,aAAA;IACA,2BAAA;IACA,sBAAA;IACA,kBAAA;IACA,mBAAA;EpG0ilBV;EoGvilBM;IACI,kBAAA;EpGyilBV;EoGtilBM;IACI,eAAA;EpGwilBV;EoGrilBM;IACI,iBAAA;EpGuilBV;EoGnilBE;IACI,2BAAA;EpGqilBN;AACF;AoGlilBA;EACI;IACI,gBAAA;IACA,aAAA;IACA,uBAAA;IACA,kBAAA;IACA,sBAAA;IACA,cAAA;EpGoilBN;EoGjilBE;IACI,WAAA;IACA,uBAAA;IACA,mBAAA;EpGmilBN;EoGhilBE;IACI,WAAA;EpGkilBN;EoG/hlBE;IACI,wBAAA;IACA,sBAAA;IACA,mBAAA;EpGiilBN;EoG/hlBM;IACI,uBAAA;EpGiilBV;EoG5hlBM;IACI,WAAA;IACA,YAAA;IACA,kBAAA;EpG8hlBV;EoG3hlBM;IACI,WAAA;IACA,YAAA;IACA,kBAAA;IACA,WAAA;EpG6hlBV;EoG1hlBM;IACI,cAAA;EpG4hlBV;EoGxhlBE;IACI,gBAAA;EpG0hlBN;EoGxhlBM;IACI,WAAA;IACA,yBtD5hCG;E9CsjnBb;EoGthlBU;IACI,iBAAA;EpGwhlBd;EoGnhlBE;IACI,WAAA;IACA,aAAA;IACA,8BAAA;EpGqhlBN;EoGnhlBM;IACI,yBtD1iCJ;IsD2iCI,aAAA;IACA,2BAAA;IACA,UAAA;IACA,aAAA;IACA,mBAAA;IACA,kBAAA;EpGqhlBV;EoG1glBM;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,cAAA;IACA,eAAA;EpG4glBV;EoGzglBM;IAEI,iBAAA;EpG0glBV;EoGvglBM;IACI,qBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,ctD9kCJ;E9CulnBN;EoGvglBU;IACI,mBAAA;EpGyglBd;EoGtglBU;;IAEI,ctDjlCV;IsDklCU,kBAAA;EpGwglBd;EoGrglBU;;IAEI,ctD1lCR;IsD2lCQ,kBAAA;EpGuglBd;EoGjglBE;;IAEI,aAAA;EpGmglBN;EoG9/kBM;;IAEI,mBAAA;EpGgglBV;AACF;AoG5/kBA;EACE;IACE,kBAAA;IACA,gCAAA;EpG8/kBF;EoG5/kBE;IACI,WAAA;IACA,yBtD3nCO;E9CynnBb;EoG5/kBM;IACI,WAAA;EpG8/kBV;EoG1/kBE;IACI,gBAAA;IACA,aAAA;IACA,uBAAA;IACA,kBAAA;IACA,sBAAA;IACA,cAAA;EpG4/kBN;EoGx/kBM;IACI,WAAA;IACA,YAAA;IACA,iBAAA;EpG0/kBV;EoGv/kBM;IACI,WAAA;IACA,YAAA;IACA,WAAA;EpGy/kBV;EoGt/kBM;IACI,cAAA;EpGw/kBV;EoGj/kBU;IACI,iBAAA;EpGm/kBd;EoGh/kBU;IACI,UAAA;EpGk/kBd;EoG7+kBE;IACI,WAAA;IACA,aAAA;IACA,uBAAA;IACA,sBAAA;EpG++kBN;EoG7+kBM;IACI,yBtD/qCJ;IsDgrCI,aAAA;IACA,2BAAA;IACA,WAAA;IACA,kBAAA;IACA,mBAAA;EpG++kBV;EoG5+kBM;IACI,kBAAA;EpG8+kBV;EoG3+kBM;IACI,eAAA;EpG6+kBV;EoG1+kBM;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,cAAA;IACA,eAAA;EpG4+kBV;EoGz+kBM;IACI,iBAAA;EpG2+kBV;EoGx+kBM;IACI,qBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,ctDjtCJ;E9C2rnBN;EoGx+kBU;IACI,mBAAA;EpG0+kBd;EoGv+kBU;;IAEI,ctDptCV;IsDqtCU,kBAAA;EpGy+kBd;EoGt+kBU;;IAEI,ctD7tCR;IsD8tCQ,kBAAA;EpGw+kBd;EoGp+kBM;;IAEI,ctDjuCN;IsDkuCM,iBAAA;EpGs+kBV;EoGl+kBM;;IAEI,ctD3uCJ;IsD4uCI,iBAAA;EpGo+kBV;EoGh+kBE;;IAEI,aAAA;EpGk+kBN;EoG79kBM;;IAEI,mBAAA;EpG+9kBV;AACF;AqG/tnBA;EACI,6BAAA;EACA,gCAAA;EACA,kBAAA;EACA,yBvDDI;A9CkunBR;AqG/tnBI;EACI,oBAAA;EACA,8BAAA;EACA,iCAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,gBAAA;EACA,cAAA;ArGgunBR;;AqG3tnBA;EACI;IACI,YAAA;ErG8tnBN;EqG5tnBM;IACI,YAAA;IACA,oBAAA;ErG8tnBV;EqG3tnBM;IACI,mBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;ErG6tnBV;EqG3tnBU;IACI,eAAA;IACA,iBAAA;ErG6tnBd;AACF;AqGxtnBA;EAEQ;IACI,YAAA;IACA,kBAAA;ErGytnBV;EqGrtnBM;IACI,kBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;ErGutnBV;EqGrtnBU;IACI,eAAA;IACA,iBAAA;ErGutnBd;AACF;AsGlxnBQ;EACI,2BAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;AtGoxnBZ;AsGhxnBY;EACI,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,qBAAA;AtGkxnBhB;AsG5wnBQ;EACI,qBxDzBH;A9CuynBT;AsG3wnBQ;EACI,qBAAA;AtG6wnBZ;AsGzwnBI;EACI,cxDlCC;EwDmCD,gBAAA;AtG2wnBR;;AsGvwnBA;EACI,WAAA;EACA,4BAAA;AtG0wnBJ;;AsGvwnBA;EAEQ;IACI,eAAA;IACA,iBAAA;EtGywnBV;EsGrwnBU;IACI,eAAA;IACA,iBAAA;EtGuwnBd;AACF;AsGhwnBA;EAIgB;IACI,eAAA;IACA,iBAAA;EtG+vnBlB;EsG1vnBM;IACI,SAAA;IACA,kBAAA;IACA,iBAAA;IACA,kBAAA;EtG4vnBV;AACF;AA1ynBA,8CAAA;AAEA,uCAAA;AACA;EAEE;;;;;;IAME,0BAAA;IACA,2BAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,gCAAA;EA0ynBF;EAvynBA;IACE,qCAAA;IACA,sBAAA;IACA,uBAAA;EAyynBF;EAtynBA;;;IAGE,0BAAA;IACA,2BAAA;EAwynBF;EArynBA;IACE,4CAAA;IACA,oCAAA;EAuynBF;EApynBA;IACE,wBAAA;EAsynBF;AACF","sourcesContent":["// If you want to override variables do it here\n@import \"variables\";\n\n$enable-ltr: true;\n$enable-rtl: true;\n\n// Import CoreUI for React components library\n@import \"@coreui/coreui/scss/coreui\";\n\n// Import Chart.js custom tooltips styles\n@import \"@coreui/chartjs/scss/coreui-chartjs\";\n\n@import \"layout\";\n\n@import \"slick-carousel/slick/slick.css\";\n@import \"slick-carousel/slick/slick-theme.css\";\n\n// If you want to add custom CSS you can put it here.\n@import \"button\";\n@import \"burgerMenu\";\n@import \"common\";\n@import \"dropdown\";\n@import \"modal\";\n@import \"mypage\";\n@import \"auth\";\n@import \"pageNotification\";\n@import \"pageEnergySaving\";\n@import \"guidePages\";\n@import \"top\";\n@import \"errorPages\";\n@import \"stepper\";\n\n/* Add this CSS to your website's stylesheet */\n\n/* Media query specifically for print */\n@media print {\n\n  .icon-flame,\n  .icon-lightning,\n  img[src*=\"flame\"],\n  img[src*=\"lightning\"],\n  img.noti-img,\n  svg {\n    max-width: 24px !important;\n    max-height: 24px !important;\n    width: 24px !important;\n    height: 24px !important;\n    object-fit: contain !important;\n    display: inline-block !important;\n  }\n\n  [class*=\"icon-\"] {\n    background-size: 24px 24px !important;\n    width: 24px !important;\n    height: 24px !important;\n  }\n\n  [id*=\"ご利用明細\"] img,\n  [class*=\"利用明細\"] img,\n  [class*=\"detail\"] img {\n    max-width: 24px !important;\n    max-height: 24px !important;\n  }\n\n  body {\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n  }\n\n  section, .card, .detail-card {\n    page-break-inside: avoid;\n  }\n}\n\n","@mixin bsBanner($file) {\n  /*!\n   * CoreUI #{$file} v4.3.0 (https://coreui.io)\n   * Copyright (c) 2023 creativeLabs Łukasz Holeczek\n   * Licensed under MIT (https://github.com/coreui/coreui/blob/main/LICENSE)\n   */\n}\n",":root {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}high-emphasis: #{$text-high-emphasis};\n  --#{$prefix}medium-emphasis: #{$text-medium-emphasis};\n  --#{$prefix}disabled: #{$text-disabled};\n\n  --#{$prefix}high-emphasis-inverse: #{$text-high-emphasis-inverse};\n  --#{$prefix}medium-emphasis-inverse: #{$text-medium-emphasis-inverse};\n  --#{$prefix}disabled-inverse: #{$text-disabled-inverse};\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.0.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\n// ol,\n// ul {\n//   @include ltr-rtl(\"padding-left\", 2rem); // TODO: find solution\n// }\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  @include ltr-rtl(\"margin-left\", 0); // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}pre-color, $pre-color);\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: var(--#{$prefix}kbd-color, $kbd-color);\n  background-color: var(--#{$prefix}kbd-bg, $kbd-bg);\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: var(--#{$prefix}table-caption-color, $table-caption-color);\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  @include ltr-rtl(\"float\", left); // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n\n*[dir=\"rtl\"] {\n  [type=\"tel\"],\n  [type=\"url\"],\n  [type=\"email\"],\n  [type=\"number\"] {\n    direction: ltr;\n  }\n}\n\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:     #fff !default;\n$gray-base: #3c4b64 !default;\n$gray-100:  #ebedef !default;\n$gray-200:  #d8dbe0 !default;\n$gray-300:  #c4c9d0 !default;\n$gray-400:  #b1b7c1 !default;\n$gray-500:  #9da5b1 !default;\n$gray-600:  #8a93a2 !default;\n$gray-700:  #768192 !default;\n$gray-800:  #636f83 !default;\n$gray-900:  #4f5d73 !default;\n$black:     #000015 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n$high-emphasis:            rgba(shift-color($gray-base, +26%), .95) !default;\n$medium-emphasis:          rgba(shift-color($gray-base, +26%), .681) !default;\n$disabled:                 rgba(shift-color($gray-base, +26%), .38) !default;\n\n$high-emphasis-inverse:    rgba($white, .87) !default;\n$medium-emphasis-inverse:  rgba($white, .6) !default;\n$disabled-inverse:         rgba($white, .38) !default;\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// fusv-disable\n$primary-dark:  #1f1498 !default;\n$primary-base:  #321fdb !default;\n$primary-50:    #988fed !default;\n$primary-25:    #ccc7f6 !default;\n\n$secondary-dark:  #212233 !default;\n$secondary-base:  #9da5b1 !default;\n$secondary-50:    #9da5b1 !default;\n$secondary-25:    #ced2d8 !default;\n\n$success-dark:  #1b9e3e !default;\n$success-base:  #2eb85c !default;\n$success-50:    #96dbad !default;\n$success-25:    #cbedd6 !default;\n\n$info-dark:  #2982cc !default;\n$info-base:  #39f !default;\n$info-50:    #80c6ff !default;\n$info-25:    #c0e6ff !default;\n\n$warning-dark:  #f6960b !default;\n$warning-base:  #f9b115 !default;\n$warning-50:    #fcd88a !default;\n$warning-25:    #feecc5 !default;\n\n$danger-dark:  #d93737 !default;\n$danger-base:  #e55353 !default;\n$danger-50:    #f2a9a9 !default;\n$danger-25:    #f9d4d4 !default;\n\n$light-dark:     $gray-100 !default;\n$light-base:     $gray-100 !default;\n$light-50:       shift-color($light-base, -70%) !default;\n$light-25:       shift-color($light-base, -80%) !default;\n\n$dark-dark:      $gray-900 !default;\n$dark-base:      $gray-900 !default;\n$dark-50:        shift-color($dark-base, -70%) !default;\n$dark-25:        shift-color($dark-base, -80%) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $primary-base !default;\n$secondary:     $secondary-base !default;\n$success:       $success-base !default;\n$info:          $info-base !default;\n$warning:       $warning-base !default;\n$danger:        $danger-base !default;\n$light:         $light-base !default;\n$dark:          $dark-base !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-colors-rgb\n$theme-colors-rgb: map-loop($theme-colors, to-rgb, \"$value\") !default;\n// scss-docs-end theme-colors-rgb\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $high-emphasis-inverse !default;\n$color-contrast-light:     $high-emphasis !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n$enable-ltr:                  true !default;\n$enable-rtl:                  false !default;\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             cui- !default; // Deprecated in v4.3.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Set mobile breakpoint\n\n$mobile-breakpoint:           md !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $high-emphasis !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      $medium-emphasis !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       $disabled !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n\n$border-style:                solid !default;\n$border-color:                $gray-200 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.0.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $high-emphasis-inverse !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:                $font-size-base * 1.25 !default;\n$lead-font-weight:              300 !default;\n\n$small-font-size:               .875em !default;\n\n$sub-sup-font-size:             .75em !default;\n\n$text-high-emphasis:            $high-emphasis !default;\n$text-medium-emphasis:          $medium-emphasis !default;\n$text-disabled:                 $disabled !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 4.3.0\n// fusv-enable\n\n$text-high-emphasis-inverse:    $high-emphasis-inverse !default;\n$text-medium-emphasis-inverse:  $medium-emphasis-inverse !default;\n$text-disabled-inverse:         $disabled-inverse !default;\n\n$initialism-font-size:          $small-font-size !default;\n\n$blockquote-margin-y:           $spacer !default;\n$blockquote-font-size:          $font-size-base * 1.25 !default;\n$blockquote-footer-color:       $gray-600 !default;\n$blockquote-footer-font-size:   $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v4.2.6\n$hr-height:                   null !default; // Deprecated in v4.2.6\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n// Icons\n$icon-size-base:  1rem !default;\n$icon-size-sm:    $icon-size-base * .875 !default;\n$icon-size-lg:    $icon-size-base * 1.25 !default;\n$icon-size-xl:    $icon-size-base * 1.5 !default;\n$icon-size-xxl:   $icon-size-base * 2 !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}body-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba($black, $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba($black, $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba($black, $table-hover-bg-factor) !default;\n\n$table-border-factor:         .1 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n\n// scss-docs-start button-variants\n$button-variants: (\n  \"primary\": btn-color-map($primary, $primary),\n  \"secondary\": btn-color-map($secondary, $secondary),\n  \"success\": btn-color-map($success, $success),\n  \"danger\": btn-color-map($danger, $danger),\n  \"warning\": btn-color-map($warning, $warning),\n  \"info\": btn-color-map($info, $info),\n  \"light\": btn-color-map($light, $light),\n  \"dark\": btn-color-map($dark, $dark)\n) !default;\n\n$button-outline-ghost-variants: (\n  \"primary\": btn-outline-color-map($primary),\n  \"secondary\": btn-outline-color-map($secondary),\n  \"success\": btn-outline-color-map($success),\n  \"danger\": btn-outline-color-map($danger),\n  \"warning\": btn-outline-color-map($warning),\n  \"info\": btn-outline-color-map($info),\n  \"light\": btn-outline-color-map($light),\n  \"dark\": btn-outline-color-map($dark)\n) !default;\n// scss-docs-end button-variants\n// scss-docs-end btn-variables\n\n\n// Forms\n// scss-docs-start form-variables\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      $box-shadow-inset !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n\n$form-switch-widths: (\n  lg: (\n    width: 1.75em,\n    height: 1.25em\n  ),\n  xl: (\n    width: 2em,\n    height: 1.5em\n  )\n) !default;\n// scss-docs-end form-switch-variables\n\n$form-check-inline-margin-end:    1rem !default;\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          $box-shadow-inset !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     $box-shadow-inset !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n// scss-docs-end form-variables\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-sidebar-backdrop:           1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               $box-shadow !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v4.2.6\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $high-emphasis-inverse !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              tint-color($component-active-bg, 90%) !default;\n$accordion-button-active-color:           shade-color($primary, 10%) !default;\n\n$accordion-button-focus-border-color:     $input-focus-border-color !default;\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $accordion-button-color !default;\n$accordion-icon-active-color:             $accordion-button-active-color !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 4.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                $box-shadow !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in 4.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $high-emphasis-inverse !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n$badge-font-size-sm:                .65em !default;\n$badge-padding-y-sm:                .3em !default;\n$badge-padding-x-sm:                .5em !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       $box-shadow-sm !default;\n$modal-content-box-shadow-sm-up:    $box-shadow !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Avatars\n// scss-docs-start avatar-variables\n$avatar-width:  2rem !default;\n\n$avatar-widths: (\n  sm: 1.5rem,\n  md: 2.5rem,\n  lg: 3rem,\n  xl: 4rem\n) !default;\n\n$avatar-transition: margin .15s !default;\n// scss-docs-end avatar-variables\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-bg-scale:                -80% !default;\n$alert-border-scale:            -70% !default;\n$alert-color-scale:             40% !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// scss-docs-start alert-variants\n$alert-variants: () !default;\n@each $state, $value in $theme-colors {\n  $map: ();\n  $alert-variants: map-merge($alert-variants, map-merge($map, ($state: alert-color-map($value))));\n}\n\n// Callouts\n// scss-docs-start callout-variables\n$callout-padding-y:                 $spacer !default;\n$callout-padding-x:                 $spacer !default;\n$callout-margin-y:                  $spacer !default;\n$callout-margin-x:                  0 !default;\n$callout-border-radius:             var(--#{$prefix}border-radius) !default;\n$callout-border-width:              var(--#{$prefix}border-width) !default;\n$callout-border-color:              var(--#{$prefix}border-color) !default;\n$callout-border-left-width:         calc($callout-border-width * 4) !default; // stylelint-disable-line function-disallowed-list\n\n$callout-variants: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"danger\":     $danger,\n  \"warning\":    $warning,\n  \"info\":       $info,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end callout-variables\n\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $high-emphasis-inverse !default;\n$progress-bar-bg:                   var(--#{$prefix}primary) !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n\n$progress-group-margin-bottom:         $spacer !default;\n$progress-group-header-margin-bottom:  $spacer * .25 !default;\n// scss-docs-end progress-variables\n\n// List group\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n$list-group-item-bg-scale:          -80% !default;\n$list-group-item-color-scale:       40% !default;\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n$list-group-variants: (\n  \"primary\": list-group-color-map($primary),\n  \"secondary\": list-group-color-map($secondary),\n  \"success\": list-group-color-map($success),\n  \"danger\": list-group-color-map($danger),\n  \"warning\": list-group-color-map($warning),\n  \"info\": list-group-color-map($info),\n  \"light\": list-group-color-map($light),\n  \"dark\": list-group-color-map($dark)\n) !default;\n// scss-docs-end list-group-variables\n\n\n// Header\n// scss-docs-start header-variables\n$header-min-height:             4rem !default;\n$header-padding-y:              $spacer * .5 !default;\n$header-padding-x:              $spacer * .5 !default;\n$header-brand-font-size:        $font-size-lg !default;\n$header-color:                  rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$header-bg:                     var(--#{$prefix}body-bg) !default;\n$header-border-color:           var(--#{$prefix}border-color) !default;\n$header-border-width:           var(--#{$prefix}border-width) !default;\n$header-hover-color:            rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$header-active-color:           rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$header-disabled-color:         rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n\n// Compute the header-brand padding-y so the header-brand will have the same height as header-text and nav-link\n$nav-link-height:               $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$header-brand-height:           $header-brand-font-size * $line-height-base !default;\n$header-brand-padding-y:        ($nav-link-height - $header-brand-height) * .5 !default;\n$header-brand-margin-end:       1rem !default;\n$header-brand-font-size:        $font-size-lg !default;\n$header-brand-color:            $gray-900 !default;\n$header-brand-hover-color:      shade-color($gray-900, 10%) !default;\n\n$header-toggler-padding-y:      .25rem !default;\n$header-toggler-padding-x:      .75rem !default;\n$header-toggler-font-size:      $font-size-lg !default;\n$header-toggler-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$header-toggler-bg:             transparent !default;\n$header-toggler-border-radius:  $btn-border-radius !default;\n$header-toggler-hover-color:    rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n\n$header-toggler-icon-color:        currentColor !default; // stylelint-disable-line value-keyword-case\n$header-toggler-icon-bg:           url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$header-toggler-icon-color}' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\") !default;\n$header-toggler-hover-icon-color:  currentColor !default; // stylelint-disable-line value-keyword-case\n$header-toggler-hover-icon-bg:     url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$header-toggler-hover-icon-color}' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\") !default;\n\n$header-nav-link-padding-x:     .5rem !default;\n$header-nav-link-padding-y:     .5rem !default;\n\n$header-divider-border-width:   var(--#{$prefix}border-width) !default;\n$header-divider-border-color:   var(--#{$prefix}border-color) !default;\n// scss-docs-end header-variables\n\n// Subheader\n// scss-docs-start subheader-variables\n$subheader-min-height:           3rem !default;\n$subheader-padding-y:            $spacer * .5 !default;\n$subheader-padding-x:            $spacer !default;\n$subheader-border-color:         var(--#{$prefix}border-color) !default;\n$subheader-border-width:         var(--#{$prefix}border-width) !default;\n\n$subheader-nav-link-padding-x:  .5rem !default;\n// scss-docs-end subheader-variables\n\n// Default theme\n// scss-docs-start subheader-default-themes\n$subheader-bg:                     $white !default;\n$subheader-color:                  var(--#{$prefix}secondary-color) !default;\n$subheader-hover-color:            var(--#{$prefix}body-color) !default;\n$subheader-active-color:           var(--#{$prefix}body-color) !default;\n$subheader-disabled-color:         $disabled !default;\n// scss-docs-end subheader-default-themes\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n// scss-docs-start carousel-variables\n$carousel-control-color:             $high-emphasis-inverse !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $high-emphasis-inverse !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $high-emphasis !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n// scss-docs-start sidebar-variables\n$sidebar-width:                            16rem !default;\n$sidebar-widths: (\n  sm: 12rem,\n  lg: 20rem,\n  xl: 24rem\n) !default;\n$sidebar-padding-y:                        0 !default;\n$sidebar-padding-x:                        0 !default;\n$sidebar-color:                            $high-emphasis-inverse !default;\n$sidebar-bg:                               $gray-base !default;\n$sidebar-border-width:                     0 !default;\n$sidebar-border-color:                     transparent !default;\n$sidebar-transition:                       margin-left .15s, margin-right .15s, box-shadow .075s, transform .15s, width .15s, z-index 0s ease .15s !default;\n\n$sidebar-brand-height:                     4rem !default;\n$sidebar-brand-color:                      $high-emphasis-inverse !default;\n$sidebar-brand-bg:                         rgba($black, .2) !default;\n\n$sidebar-header-height:                    4rem !default;\n$sidebar-header-padding-y:                 .75rem !default;\n$sidebar-header-padding-x:                 1rem !default;\n$sidebar-header-bg:                        rgba($black, .2) !default;\n$sidebar-header-height-transition:         height .15s, padding .15s !default;\n\n$sidebar-narrow-width:                     4rem !default;\n\n$sidebar-backdrop-bg:                      $black !default;\n$sidebar-backdrop-opacity:                 .5 !default;\n\n$sidebar-nav-title-padding-y:              .75rem !default;\n$sidebar-nav-title-padding-x:              1rem !default;\n$sidebar-nav-title-margin-top:             1rem !default;\n$sidebar-nav-title-color:                  $medium-emphasis-inverse !default;\n$sidebar-nav-title-transition:             height .15s, margin .15s !default;\n\n$sidebar-nav-link-padding-y:               .8445rem !default;\n$sidebar-nav-link-padding-x:               1rem !default;\n$sidebar-nav-link-color:                   $medium-emphasis-inverse !default;\n$sidebar-nav-link-bg:                      transparent !default;\n$sidebar-nav-link-border-width:            0 !default;\n$sidebar-nav-link-border-color:            transparent !default;\n$sidebar-nav-link-border-radius:           0 !default;\n$sidebar-nav-link-transition:              background .15s ease, color .15s ease !default;\n$sidebar-nav-link-icon-color:              $medium-emphasis-inverse !default;\n\n$sidebar-nav-link-hover-color:             $high-emphasis-inverse !default;\n$sidebar-nav-link-hover-bg:                rgba($white, .05) !default;\n$sidebar-nav-link-hover-icon-color:        $high-emphasis-inverse !default;\n\n$sidebar-nav-link-active-color:            $high-emphasis-inverse !default;\n$sidebar-nav-link-active-bg:               rgba($white, .05) !default;\n$sidebar-nav-link-active-icon-color:       $high-emphasis-inverse !default;\n\n$sidebar-nav-link-disabled-color:          $disabled-inverse !default;\n$sidebar-nav-link-disabled-icon-color:     $sidebar-nav-link-icon-color !default;\n\n$sidebar-nav-icon-width:                   4rem !default;\n$sidebar-nav-icon-height:                  1.25rem !default;\n$sidebar-nav-icon-font-size:               $sidebar-nav-icon-height !default;\n\n$sidebar-nav-group-bg:                     rgba(0, 0, 0, .2) !default;\n$sidebar-nav-group-transition:             background .15s ease-in-out !default;\n$sidebar-nav-group-toggle-show-color:      $sidebar-nav-link-color !default;\n\n$sidebar-nav-group-items-padding-y:        0 !default;\n$sidebar-nav-group-items-padding-x:        0 !default;\n$sidebar-nav-group-items-transition:       height .15s ease !default;\n\n$sidebar-nav-group-indicator-color:        $medium-emphasis-inverse !default;\n$sidebar-nav-group-indicator-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$sidebar-nav-group-indicator-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$sidebar-nav-group-indicator-hover-color:  $sidebar-nav-link-hover-color !default;\n$sidebar-nav-group-indicator-hover-icon:   url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$sidebar-nav-group-indicator-hover-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$sidebar-nav-group-indicator-transition:   transform .15s !default;\n\n$sidebar-footer-height:                    auto !default;\n$sidebar-footer-padding-y:                 .75rem !default;\n$sidebar-footer-padding-x:                 1rem !default;\n$sidebar-footer-bg:                        rgba($black, .2) !default;\n$sidebar-footer-height-transition:         height .15s, padding .15s !default;\n\n$sidebar-toggler-height:                   3rem !default;\n$sidebar-toggler-bg:                       rgba($black, .2) !default;\n$sidebar-toggler-transition:               transform .15s !default;\n\n$sidebar-toggler-indicator-width:          4rem !default;\n$sidebar-toggler-indicator-height:         3rem !default;\n$sidebar-toggler-indicator-color:          $disabled-inverse !default;\n$sidebar-toggler-indicator-icon:           url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='#{$sidebar-toggler-indicator-color}' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E\") !default;\n$sidebar-toggler-hover-bg:                 rgba(0, 0, 0, .3) !default;\n$sidebar-toggler-indicator-hover-color:    $sidebar-nav-link-hover-color !default;\n$sidebar-toggler-indicator-hover-icon:     url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='#{$sidebar-toggler-indicator-hover-color}' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E\") !default;\n// scss-docs-end sidebar-variables\n\n// Footer\n// scss-docs-start footer-variables\n$footer-min-height:    3rem !default;\n$footer-padding-y:     $spacer * .5 !default;\n$footer-padding-x:     $spacer !default;\n$footer-bg:            var(--#{$prefix}tertiary-bg) !default;\n$footer-color:         var(--#{$prefix}body-color) !default;\n$footer-border-width:  var(--#{$prefix}border-width) !default;\n$footer-border-color:  var(--#{$prefix}border-color) !default;\n// scss-docs-end footer-variables\n\n// Spinners\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $high-emphasis !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v4.2.6, removing in v6\n\n$pre-color:                         null !default;\n","@mixin ltr {\n  @if $enable-ltr {\n    html:not([dir=\"rtl\"]) & {\n      @content;\n    }\n  }\n}\n\n@mixin rtl {\n  @if $enable-rtl {\n    *[dir=\"rtl\"] & {\n      @content;\n    }\n  }\n}\n\n@function reflect($element) {\n  $string: #{$element};\n  @if str-index($string, \"left\") {\n    @return str-replace($string, \"left\", \"right\");\n  }\n  @if str-index($string, \"right\") {\n    @return str-replace($string, \"right\", \"left\");\n  }\n\n  @return unquote($string);\n}\n\n@mixin ltr-rtl($property, $value, $property-rtl: null, $value-rtl: null, $important: null) {\n  $property-reflected: reflect($property);\n  $value-reflected: reflect($value);\n\n  @if $enable-ltr and $enable-rtl {\n    @include ltr() {\n      #{$property}: $value $important;\n    }\n    @include rtl() {\n      @if $value-rtl {\n        #{$property-reflected}: $value-rtl $important;\n      }\n      @else {\n        #{$property-reflected}: $value-reflected $important;\n      }\n    }\n  }\n  @else {\n    @if $enable-rtl {\n      @if $value-rtl {\n        #{$property-reflected}: $value-rtl $important;\n      }\n      @else {\n        #{$property-reflected}: $value-reflected $important;\n      }\n    }\n    @else {\n      #{$property}: $value $important;\n    }\n  }\n}\n\n@mixin ltr-rtl-value-only($property, $value, $value-rtl: null, $important: null) {\n  $value-reflected: reflect($value);\n\n  @if $enable-ltr and $enable-rtl {\n    @include ltr() {\n      #{$property}: $value $important;\n    }\n    @include rtl() {\n      @if $value-rtl {\n        #{$property}: $value-rtl $important;\n      } @else {\n        #{$property}: $value-reflected $important;\n      }\n    }\n  }\n  @else {\n    @if $enable-rtl {\n      @if $value-rtl {\n        #{$property}: $value-rtl $important;\n      } @else {\n        #{$property}: $value-reflected $important;\n      }\n    } @else {\n      #{$property}: $value $important;\n    }\n  }\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-top-right-radius\", valid-radius($radius));\n    @include ltr-rtl(\"border-bottom-right-radius\", valid-radius($radius));\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-top-left-radius\", valid-radius($radius));\n    @include ltr-rtl(\"border-bottom-left-radius\", valid-radius($radius));\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-top-right-radius\", valid-radius($radius));\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-bottom-right-radius\", valid-radius($radius));\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-bottom-left-radius\", valid-radius($radius));\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    @include ltr-rtl(\"margin-right\", $list-inline-padding);\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  @include ltr-rtl(\"padding-left\", 0);\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: var(--#{$prefix}thumbnail-bg, $thumbnail-bg);\n  border: $thumbnail-border-width solid var(--#{$prefix}thumbnail-border-color, $thumbnail-border-color);\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: var(--#{$prefix}figure-caption-color, $figure-caption-color);\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n\n  --#{$prefix}mobile-breakpoint: #{$mobile-breakpoint};\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  @include ltr-rtl(\"margin-left\", if($num == 0, 0, percentage($num)));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: divide(100%, $count);\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is and invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: var(--#{$prefix}form-label-color, $form-label-color);\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: var(--#{$prefix}form-label-color, $form-label-color);\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: var(--#{$prefix}form-text-color, $form-text-color);\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: var(--#{$prefix}input-color, $input-color);\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: var(--#{$prefix}input-bg, $input-bg);\n  background-clip: padding-box;\n  border: $input-border-width solid var(--#{$prefix}input-border-color, $input-border-color);\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: var(--#{$prefix}input-focus-color, $input-focus-color);\n    background-color: var(--#{$prefix}input-focus-bg, $input-focus-bg);\n    border-color: var(--#{$prefix}input-focus-border-color, $input-focus-border-color);\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  // Add some height to date inputs on iOS\n  // https://github.com/twbs/bootstrap/issues/23307\n  // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: var(--#{$prefix}input-placeholder-color, $input-placeholder-color);\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: var(--#{$prefix}form-file-button-color, $form-file-button-color);\n    @include gradient-bg(var(--#{$prefix}form-file-button-bg, $form-file-button-bg));\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: var(--#{$prefix}form-file-button-hover-bg, $form-file-button-hover-bg);\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: var(--#{$prefix}input-plaintext-color, $input-plaintext-color);\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  @include ltr-rtl-value-only(\"padding\", $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x, $form-select-padding-y $form-select-padding-x $form-select-padding-y $form-select-indicator-padding);\n  -moz-padding-start: subtract($form-select-padding-x, 3px); // See https://github.com/twbs/bootstrap/issues/32636\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: var(--#{$prefix}form-select-color, $form-select-color);\n  appearance: none;\n  background-color: var(--#{$prefix}form-select-bg, $form-select-bg);\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  @include ltr-rtl-value-only(\"background-position\", $form-select-bg-position);\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid var(--#{$prefix}form-select-border-color, $form-select-border-color);\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: var(--#{$prefix}form-select-focus-border-color, $form-select-focus-border-color);\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    @include ltr-rtl(\"padding-right\", $form-select-padding-x);\n    background-image: none;\n  }\n\n  &:disabled {\n    color: var(--#{$prefix}form-select-disabled-color, $form-select-disabled-color);\n    background-color: var(--#{$prefix}form-select-disabled-bg, $form-select-disabled-bg);\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 var(--#{$prefix}form-select-color, $form-select-color);\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  @include ltr-rtl(\"padding-left\", $form-select-padding-x-sm);\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  @include ltr-rtl(\"padding-left\", $form-select-padding-x-lg);\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  @include ltr-rtl(\"padding-left\", $form-check-padding-start);\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    @include ltr-rtl(\"float\", left);\n    @include ltr-rtl(\"margin-left\", $form-check-padding-start * -1);\n  }\n}\n\n.form-check-reverse {\n  @include ltr-rtl(\"padding-right\", $form-check-padding-start);\n  @include ltr-rtl(\"padding-left\", 0);\n  @include ltr-rtl(\"text-align\", right);\n\n  .form-check-input {\n    @include ltr-rtl(\"float\", right);\n    @include ltr-rtl(\"margin-right\", $form-check-padding-start * -1);\n    @include ltr-rtl(\"margin-left\", 0);\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: var(--#{$prefix}form-check-input-checked-bg-color, $form-check-input-checked-bg-color);\n    border-color: var(--#{$prefix}form-check-input-checked-border-color, $form-check-input-checked-border-color);\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: var(--#{$prefix}form-check-label-color, $form-check-label-color);\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  @include ltr-rtl(\"padding-left\", $form-switch-padding-start);\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    @include ltr-rtl(\"margin-left\", $form-switch-padding-start * -1);\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    @include ltr-rtl(\"padding-right\", $form-check-padding-start);\n    @include ltr-rtl(\"padding-left\", 0);\n\n    .form-check-input {\n      @include ltr-rtl(\"margin-right\", $form-check-padding-start * -1);\n      @include ltr-rtl(\"margin-left\", 0);\n    }\n  }\n}\n\n@each $size, $map in $form-switch-widths {\n  $width: map-get($map, \"width\");\n  $height: map-get($map, \"height\");\n\n  .form-switch-#{$size} {\n    min-height: $height;\n    @include ltr-rtl(\"padding-left\", $width + .5em);\n\n    .form-check-input {\n      width: $width;\n      height: $height;\n      @include ltr-rtl(\"margin-left\", ($width + .5em) * -1);\n    }\n\n    .form-check-label {\n      // stylelint-disable-next-line function-disallowed-list\n      padding-top: calc((#{$height} - #{$font-size-base}) / 2);\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  @include ltr-rtl(\"margin-right\", $form-check-inline-margin-end);\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg(var(--#{$prefix}form-range-thumb-bg, $form-range-thumb-bg));\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg(var(--#{$prefix}form-range-thumb-active-bg, $form-range-thumb-active-bg));\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: var(--#{$prefix}form-range-track-bg, $form-range-track-bg);\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg(var(--#{$prefix}form-range-thumb-bg, $form-range-thumb-bg));\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg(var(--#{$prefix}form-range-thumb-active-bg, $form-range-thumb-active-bg));\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: var(--#{$prefix}form-range-track-bg, $form-range-track-bg);\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: var(--#{$prefix}form-range-thumb-disabled-bg, $form-range-thumb-disabled-bg);\n    }\n\n    &::-moz-range-thumb {\n      background-color: var(--#{$prefix}form-range-thumb-disabled-bg, $form-range-thumb-disabled-bg);\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    @include ltr-rtl(\"left\", 0);\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: var(--#{$prefix}input-group-addon-color, $input-group-addon-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}input-group-addon-bg, $input-group-addon-bg);\n  border: $input-border-width solid var(--#{$prefix}input-group-addon-border-color, $input-group-addon-border-color);\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  @include ltr-rtl(\"padding-right\", $form-select-padding-x + $form-select-indicator-padding);\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    @include ltr-rtl(\"margin-left\", calc(#{$input-border-width} * -1));\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        @include ltr-rtl(\"padding-right\", $input-height-inner);\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        @include ltr-rtl-value-only(\"background-position\", right $input-height-inner-quarter center, left $input-height-inner-quarter center);\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        @include ltr-rtl(\"padding-right\", $input-height-inner);\n        @include ltr-rtl-value-only(\"background-position\", top $input-height-inner-quarter right $input-height-inner-quarter, top $input-height-inner-quarter left $input-height-inner-quarter);\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          @include ltr-rtl(\"padding-right\", $form-select-feedback-icon-padding-end);\n          @include ltr-rtl-value-only(\"background-position\", #{$form-select-bg-position, $form-select-feedback-icon-position});\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      @include ltr-rtl(\"margin-left\", .5em);\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n.btn-transparent {\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-hover-border-color: transparent;\n}\n\n// scss-docs-start btn-variant-loops\n@each $state, $variant in $button-variants {\n  .btn-#{$state} {\n    @include button-variant($variant);\n  }\n}\n\n@each $state, $variant in $button-outline-ghost-variants {\n  .btn-outline-#{$state} {\n    @include button-outline-variant($variant);\n  }\n}\n\n@each $state, $variant in $button-outline-ghost-variants {\n  .btn-ghost-#{$state} {\n    @include button-ghost-variant($variant);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: none;\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix(color-contrast($primary), $primary, 15%))};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant($variant) {\n  $background: map-get($variant, \"bg\");\n  $border-color: map-get($variant, \"border-color\");\n  $color: map-get($variant, \"color\");\n  $hover-background: map-get($variant, \"hover-bg\");\n  $hover-border-color: map-get($variant, \"hover-border-color\");\n  $hover-color: map-get($variant, \"hover-color\");\n  $active-background: map-get($variant, \"active-bg\");\n  $active-border-color: map-get($variant, \"active-border-color\");\n  $active-color: map-get($variant, \"active-color\");\n  $disabled-background: map-get($variant, \"disabled-bg\");\n  $disabled-border-color: map-get($variant, \"disabled-border-color\");\n  $disabled-color: map-get($variant, \"disabled-color\");\n  $shadow: map-get($variant, \"shadow\");\n\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border-color};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border-color};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border-color, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border-color};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border-color};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant($variant) {\n  $color: map-get($variant, \"color\");\n  $hover-background: map-get($variant, \"hover-bg\");\n  $hover-border-color: map-get($variant, \"hover-border-color\");\n  $hover-color: map-get($variant, \"hover-color\");\n  $active-background: map-get($variant, \"active-bg\");\n  $active-border-color: map-get($variant, \"active-border-color\");\n  $active-color: map-get($variant, \"active-color\");\n  $disabled-color: map-get($variant, \"disabled-color\");\n  $shadow: map-get($variant, \"shadow\");\n\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border-color};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border-color};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-ghost-variant-mixin\n@mixin button-ghost-variant($variant) {\n  $color: map-get($variant, \"color\");\n  $hover-background: map-get($variant, \"hover-bg\");\n  $hover-border-color: map-get($variant, \"hover-border-color\");\n  $hover-color: map-get($variant, \"hover-color\");\n  $active-background: map-get($variant, \"active-bg\");\n  $active-border-color: map-get($variant, \"active-border-color\");\n  $active-color: map-get($variant, \"active-color\");\n  $disabled-color: map-get($variant, \"disabled-color\");\n  $shadow: map-get($variant, \"shadow\");\n\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border-color};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border-color};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-shadow: #{$shadow};\n}\n// scss-docs-end btn-ghost-variant-mixin\n\n// Button sizes\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-coreui-popper] {\n    top: 100%;\n    @include ltr-rtl(\"left\", 0);\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `cui-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --cui-position: start;\n\n      &[data-coreui-popper] {\n        @include ltr-rtl(\"right\", auto);\n        @include ltr-rtl(\"left\", 0);\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --cui-position: end;\n\n      &[data-coreui-popper] {\n        @include ltr-rtl(\"right\", 0);\n        @include ltr-rtl(\"left\", auto);\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-coreui-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-coreui-popper] {\n    top: 0;\n    @include ltr-rtl(\"right\", auto);\n    @include ltr-rtl(\"left\", 100%);\n    margin-top: 0;\n    @include ltr-rtl(\"margin-left\", var(--#{$prefix}dropdown-spacer));\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-coreui-popper] {\n    top: 0;\n    @include ltr-rtl(\"right\", 100%);\n    @include ltr-rtl(\"left\", auto);\n    margin-top: 0;\n    @include ltr-rtl(\"margin-right\", var(--#{$prefix}dropdown-spacer));\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      @include ltr-rtl(\"margin-left\", $spacing);\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        @include ltr-rtl(\"margin-right\", $spacing);\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      @include ltr-rtl(\"margin-left\", 0);\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    @include ltr-rtl(\"margin-left\", calc(#{$btn-border-width} * -1));\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    @include ltr-rtl(\"margin-left\", 0);\n  }\n\n  .dropstart &::before {\n    @include ltr-rtl(\"margin-right\", 0);\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  @include ltr-rtl(\"padding-left\", 0);\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  @include ltr-rtl(\"margin-right\", var(--#{$prefix}navbar-brand-margin-end));\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  @include ltr-rtl(\"padding-left\", 0);\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v4.3.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    @include ltr-rtl(\"margin-left\", var(--#{$prefix}card-spacer-x));\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        @include ltr-rtl(\"margin-left\", 0);\n        @include ltr-rtl(\"border-left\", 0);\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-border-color: #{$accordion-button-focus-border-color};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    border-color: var(--#{$prefix}accordion-btn-focus-border-color);\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  .accordion-collapse {\n    border-width: 0;\n  }\n\n  .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    @include ltr-rtl(\"padding-left\",  var(--#{$prefix}breadcrumb-item-padding-x));\n\n    &::before {\n      @include ltr-rtl(\"float\", left); // Suppress inline spacings and underlining of the separator\n      @include ltr-rtl(\"padding-right\", var(--#{$prefix}breadcrumb-item-padding-x));\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      @include ltr-rtl(\n        \"content\",\n        var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)),\n        null,\n        var(--#{$prefix}breadcrumb-divider-flipped, escape-svg($breadcrumb-divider-flipped))\n      );\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    @include ltr-rtl(\"margin-left\", $pagination-margin-start);\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: var(--#{$prefix}badge-border-radius, 0); // stylelint-disable-line property-disallowed-list\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n//\n// Badge Sizes\n//\n\n.badge-sm {\n  --#{$prefix}badge-padding-x: #{$badge-padding-x-sm};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y-sm};\n  @include font-size($badge-font-size-sm);\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  @include ltr-rtl(\"padding-right\", $alert-dismissible-padding-r);\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    @include ltr-rtl(\"right\", 0);\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert.\n@each $state, $value in $alert-variants {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: #{map-get($value, \"alert-color\")};\n    --#{$prefix}alert-bg: #{map-get($value, \"alert-bg\")};\n    --#{$prefix}alert-border-color: #{map-get($value, \"alert-border\")};\n    --#{$prefix}alert-link-color: #{shade-color(map-get($value, \"alert-color\"), 20%)};\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n\n.progress-thin {\n  height: 4px;\n}\n\n// White progress bar\n.progress.progress-white {\n  background-color: rgba(255, 255, 255, .2);\n  .progress-bar {\n    background-color: $white;\n  }\n}\n\n.progress-group {\n  display: flex;\n  flex-flow: row wrap;\n  margin-bottom: $progress-group-margin-bottom;\n}\n\n.progress-group-prepend {\n  flex: 0 0 100px;\n  align-self: center;\n}\n\n.progress-group-header {\n  display: flex;\n  flex-basis: 100%;\n  align-items: center;\n  margin-bottom: $progress-group-header-margin-bottom;\n}\n\n.progress-group-bars {\n  flex-grow: 1;\n  align-self: center;\n\n  .progress:not(:last-child) {\n    margin-bottom: 2px;\n  }\n}\n\n.progress-group-header + .progress-group-bars {\n  flex-basis: 100%;\n}\n","$orange: #F8601B;\n$light-orange: #FFF7F2;\n$yellow: #FCCA0D;\n$white: #FFFFFF;\n$black: #463529;\n$blue: #21699E;\n$green: #4EAE5D;\n$gray: #F5F5F5;\n$dark-gray: #BCBCBD;\n$red: #FF0F00;\n$transparent: #00000000;\n$dark: #818181;\n$text-black: #464646;\n$color-border: #ffe7e6;\n$border-checkbox: #B6B6B6;\n$switch: #BCBFC4;\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  @include ltr-rtl(\"padding-left\", 0); // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          @include ltr-rtl(\"border-left-width\", 0);\n\n          &.active {\n            @include ltr-rtl(\"margin-left\", calc(-1 * var(--#{$prefix}list-group-border-width)));\n            @include ltr-rtl(\"border-left-width\", var(--#{$prefix}list-group-border-width));\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state, $variant in $list-group-variants {\n  .list-group-item-#{$state} {\n    @include list-group-item-variant($state, $variant);\n  }\n}\n// scss-docs-end list-group-modifiers\n","@include deprecate(\"`list-group-item-variant()`\", \"v4.3.0\", \"v6.0.0\");\n\n// List Groups\n// scss-docs-start list-group-mixin\n@mixin list-group-item-variant($state, $variant) {\n  $background: map-get($variant, \"bg\");\n  $background-hover: map-get($variant, \"bg-hover\");\n  $color: contrast-ratio-correction(map-get($variant, \"color\"), map-get($variant, \"bg\"), abs($alert-color-scale), $state);\n\n  --#{$prefix}list-group-color: #{$color};\n  --#{$prefix}list-group-bg: #{$background};\n  --#{$prefix}list-group-hover-bg: #{$background-hover};\n  --#{$prefix}list-group-action-hover-color: #{$color};\n  --#{$prefix}list-group-action-active-color: #{$white};\n  --#{$prefix}list-group-action-active-bg: #{$color};\n  --#{$prefix}list-group-action-active-border-color: #{$color};\n}\n// scss-docs-end list-group-mixin\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n.btn-close-white {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    @include ltr-rtl(\"margin-right\", calc(-.5 * var(--#{$prefix}toast-padding-x)));\n    @include ltr-rtl(\"margin-left\", var(--#{$prefix}toast-padding-x));\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  @include ltr-rtl(\"left\", 0);\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    @include ltr-rtl-value-only(\"margin\", calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto, calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)));\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v4\", \"v4.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: var(--#{$prefix}carousel-control-color, $carousel-control-color);\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}carousel-control-color, $carousel-control-color);\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-coreui-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  [data-coreui-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: var(--#{$prefix}carousel-indicator-active-bg, $carousel-indicator-active-bg);\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: var(--#{$prefix}carousel-caption-color, $carousel-caption-color);\n  text-align: center;\n}\n\n// Dark mode carousel\n\n.carousel-dark {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-dark-indicator-active-bg};\n  --#{$prefix}carousel-caption-color: #{$carousel-dark-caption-color};\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-coreui-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        @include ltr-rtl(\"left\", 0);\n        width: var(--#{$prefix}offcanvas-width);\n        @include ltr-rtl(\"border-right\", var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color));\n        @include ltr-rtl-value-only(\"transform\", translateX(-100%), translateX(100%));\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        @include ltr-rtl(\"right\", 0);\n        width: var(--#{$prefix}offcanvas-width);\n        @include ltr-rtl(\"border-left\", var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color));\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none !important; // stylelint-disable-line declaration-no-important\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, var(--#{$prefix}offcanvas-backdrop-bg, $offcanvas-backdrop-bg), $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    @include ltr-rtl(\"margin-right\", calc(-.5 * var(--#{$prefix}offcanvas-padding-x)));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n",".avatar {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  vertical-align: middle;\n  @include border-radius(50em);\n  @include transition($avatar-transition);\n  @include avatar($avatar-width);\n}\n\n.avatar-img {\n  width: 100%;\n  height: auto;\n  @include border-radius(50em);\n}\n\n.avatar-status {\n  position: absolute;\n  @include ltr-rtl(\"right\", 0);\n  bottom: 0;\n  display: block;\n  border: 1px solid $white;\n  @include border-radius(50em);\n}\n\n@each $width, $value in $avatar-widths {\n  .avatar-#{$width} {\n    @include avatar($value);\n  }\n}\n\n.avatars-stack {\n  display: flex;\n\n  .avatar {\n    @include ltr-rtl(\"margin-right\", - ($avatar-width * .4));\n\n    &:hover {\n      @include ltr-rtl(\"margin-right\", 0);\n    }\n  }\n\n  @each $width, $value in $avatar-widths {\n    .avatar-#{$width} {\n      @include ltr-rtl(\"margin-right\", - ($value * .4));\n    }\n  }\n}\n","@mixin avatar($width) {\n  width: $width;\n  height: $width;\n  font-size: $width * .4;\n\n  .avatar-status {\n    width: divide($width, 3.75);\n    height: divide($width, 3.75);\n  }\n}\n",".callout {\n  // scss-docs-start callout-css-vars\n  --#{$prefix}callout-padding-x: #{$callout-padding-x};\n  --#{$prefix}callout-padding-y: #{$callout-padding-y};\n  --#{$prefix}callout-margin-x: #{$callout-margin-x};\n  --#{$prefix}callout-margin-y: #{$callout-margin-y};\n  --#{$prefix}callout-border-width: #{$callout-border-width};\n  --#{$prefix}callout-border-color: #{$callout-border-color};\n  --#{$prefix}callout-border-left-width: #{$callout-border-left-width};\n  --#{$prefix}callout-border-radius: #{$callout-border-radius};\n  // scss-docs-end callout-css-vars\n\n  padding: var(--#{$prefix}callout-padding-y) var(--#{$prefix}callout-padding-x);\n  margin: var(--#{$prefix}callout-margin-y) var(--#{$prefix}callout-margin-x);\n  border: var(--#{$prefix}callout-border-width) solid var(--#{$prefix}callout-border-color);\n  @include ltr-rtl(\"border-left-width\", var(--#{$prefix}callout-border-left-width));\n  @include ltr-rtl(\"border-left-color\", var(--#{$prefix}callout-border-left-color));\n  @include border-radius(var(--#{$prefix}callout-border-radius));\n}\n\n// scss-docs-start callout-modifiers\n// Generate contextual modifier classes for colorizing the collor.\n@each $state, $value in $callout-variants {\n  .callout-#{$state} {\n    --#{$prefix}callout-border-left-color: #{$value};\n  }\n}\n// scss-docs-end callout-modifiers\n",".footer {\n  // scss-docs-start footer-css-vars\n  --#{$prefix}footer-min-height: #{$footer-min-height};\n  --#{$prefix}footer-padding-x: #{$footer-padding-x};\n  --#{$prefix}footer-padding-y: #{$footer-padding-y};\n  --#{$prefix}footer-color: #{$footer-color};\n  --#{$prefix}footer-bg: #{$footer-bg};\n  --#{$prefix}footer-border-color: #{$footer-border-color};\n  --#{$prefix}footer-border: #{$footer-border-width} solid var(--#{$prefix}footer-border-color);\n  // scss-docs-end footer-css-vars\n\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between;\n  min-height: var(--#{$prefix}footer-min-height);\n  padding: var(--#{$prefix}footer-padding-y) var(--#{$prefix}footer-padding-x);\n  color: var(--#{$prefix}footer-color);\n  background: var(--#{$prefix}footer-bg);\n  border-top: var(--#{$prefix}footer-border);\n}\n\n.footer-fixed {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.footer-sticky {\n  position: sticky;\n  bottom: 0;\n  z-index: $zindex-fixed;\n}\n",".header {\n  // scss-docs-start header-css-vars\n  --#{$prefix}header-min-height: #{$header-min-height};\n  --#{$prefix}header-padding-x: #{$header-padding-x};\n  --#{$prefix}header-padding-y: #{$header-padding-y};\n  --#{$prefix}header-bg: #{$header-bg};\n  --#{$prefix}header-color: #{$header-color};\n  --#{$prefix}header-border-color: #{$header-border-color};\n  --#{$prefix}header-border: #{$header-border-width} solid var(--#{$prefix}header-border-color);\n  --#{$prefix}header-hover-color: #{$header-hover-color};\n  --#{$prefix}header-disabled-color: #{$header-disabled-color};\n  --#{$prefix}header-active-color: #{$header-active-color};\n  --#{$prefix}header-brand-padding-y: #{$header-brand-padding-y};\n  --#{$prefix}header-brand-color: #{$header-brand-color};\n  --#{$prefix}header-brand-hover-color: #{$header-brand-hover-color};\n  --#{$prefix}header-toggler-padding-x: #{$header-toggler-padding-x};\n  --#{$prefix}header-toggler-padding-y: #{$header-toggler-padding-y};\n  --#{$prefix}header-toggler-bg: #{$header-toggler-bg};\n  --#{$prefix}header-toggler-color: #{$header-toggler-color};\n  --#{$prefix}header-toggler-border-radius: #{$header-toggler-border-radius};\n  --#{$prefix}header-toggler-hover-color: #{$header-toggler-hover-color};\n  --#{$prefix}header-toggler-icon-bg: #{escape-svg($header-toggler-icon-bg)};\n  --#{$prefix}header-toggler-hover-icon-bg: #{escape-svg($header-toggler-hover-icon-bg)};\n  --#{$prefix}header-nav-link-padding-x: #{$header-nav-link-padding-x};\n  --#{$prefix}header-nav-link-padding-y: #{$header-nav-link-padding-y};\n  --#{$prefix}header-divider-border-color: #{$header-divider-border-color};\n  --#{$prefix}header-divider-border: #{$header-divider-border-width} solid var(--#{$prefix}header-divider-border-color);\n  --#{$prefix}subheader-min-height: #{$subheader-min-height};\n  // scss-docs-end header-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  min-height: var(--#{$prefix}header-min-height);\n  padding: var(--#{$prefix}header-padding-y) var(--#{$prefix}header-padding-x);\n  background: var(--#{$prefix}header-bg);\n  border-bottom: var(--#{$prefix}header-border);\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n\n  .container:first-child,\n  .container-fluid:first-child {\n    min-height: calc(var(--#{$prefix}header-min-height) - (2 * var(--#{$prefix}header-padding-y))); // stylelint-disable-line function-disallowed-list\n  }\n\n  .container:nth-child(n+2),\n  .container-fluid:nth-child(n+2) {\n    min-height: calc(var(--#{$prefix}subheader-min-height) - (2 * var(--#{$prefix}header-padding-y))); // stylelint-disable-line function-disallowed-list\n  }\n\n  &.header-sticky {\n    position: sticky;\n    top: 0;\n    z-index: $zindex-fixed - 1;\n  }\n}\n\n.header-divider {\n  flex-basis: calc(100% + (2 * var(--#{$prefix}header-padding-x))); // stylelint-disable-line function-disallowed-list\n  height: 0;\n  margin: var(--#{$prefix}header-padding-y) calc(var(--#{$prefix}header-padding-x) * -1); // stylelint-disable-line function-disallowed-list\n  border-top: var(--#{$prefix}header-divider-border);\n}\n\n// Header brand\n//\n// Used for brand, project, or site names.\n\n.header-brand {\n  padding-top: var(--#{$prefix}header-brand-padding-y);\n  padding-bottom: var(--#{$prefix}header-brand-padding-y);\n  @include ltr-rtl(\"margin-right\", $header-brand-margin-end);\n  @include font-size($header-brand-font-size);\n  color: var(--#{$prefix}header-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}header-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n// Header nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.header-nav {\n  display: flex;\n  flex-direction: row; // cannot use `inherit` to get the `.header`s value\n  @include ltr-rtl(\"padding-left\", 0);\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding: var(--#{$prefix}header-nav-link-padding-y) var(--#{$prefix}header-nav-link-padding-x);\n    color: var(--#{$prefix}header-color);\n\n    &:hover,\n    &:focus {\n      color: var(--#{$prefix}header-hover-color);\n    }\n\n    &.disabled {\n      color: var(--#{$prefix}header-disabled-color);\n    }\n  }\n\n  .show > .nav-link,\n  .nav-link.active {\n    color: var(--#{$prefix}header-active-color);\n  }\n\n  .dropdown-menu {\n    position: absolute;\n  }\n}\n\n\n// Header text\n//\n//\n\n.header-text {\n  padding-top: var(--#{$prefix}header-nav-link-padding-y);\n  padding-bottom: var(--#{$prefix}header-nav-link-padding-y);\n  color: var(--#{$prefix}header-color);\n\n  a {\n    color: var(--#{$prefix}header-active-color);\n\n    &:hover,\n    &:focus {\n      color: var(--#{$prefix}header-active-color);\n    }\n  }\n}\n\n.header-toggler {\n  padding: var(--#{$prefix}header-toggler-padding-y) var(--#{$prefix}header-toggler-padding-x);\n  @include font-size($header-toggler-font-size);\n  color: var(--#{$prefix}header-toggler-color);\n  background-color: var(--#{$prefix}header-toggler-bg);\n  border: 0; // remove default button style\n  @include border-radius(var(--#{$prefix}header-toggler-border-radius));\n\n  &:hover {\n    color: var(--#{$prefix}header-toggler-hover-color);\n    text-decoration: none;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  // Opinionated: add \"hand\" cursor to non-disabled .navbar-toggler elements\n  &:not(:disabled) {\n    cursor: pointer;\n  }\n}\n\n.header-toggler-icon {\n  display: block;\n  height: $header-toggler-font-size * 1.25;\n  background-image: var(--#{$prefix}header-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: 100% 100%;\n\n  &:hover {\n    background-image: var(--#{$prefix}header-toggler-hover-icon-bg);\n  }\n}\n",".icon {\n  display: inline-block;\n  color: inherit;\n  text-align: center;\n  vertical-align: -.125rem; // Fix the position of icon\n  fill: currentcolor;\n  &:not(.icon-c-s):not(.icon-custom-size) {\n    @include icon-size($icon-size-base);\n\n    &.icon-xxl {\n      @include icon-size($icon-size-xxl);\n    }\n\n    &.icon-xl {\n      @include icon-size($icon-size-xl);\n    }\n\n    &.icon-lg {\n      @include icon-size($icon-size-lg);\n    }\n\n    &.icon-sm {\n      @include icon-size($icon-size-sm);\n    }\n\n    @for $i from 3 through 9 {\n      &.icon-#{$i}xl {\n        @include icon-size($i * $icon-size-base);\n      }\n    }\n  }\n}\n","// Icon sizes\n@mixin icon-size($icon-size) {\n  width: $icon-size;\n  height: $icon-size;\n  font-size: $icon-size;\n}\n",".sidebar {\n  // scss-docs-start sidebar-css-vars\n  --#{$prefix}sidebar-width: #{$sidebar-width};\n  --#{$prefix}sidebar-bg: #{$sidebar-bg};\n  --#{$prefix}sidebar-padding-x: #{$sidebar-padding-x};\n  --#{$prefix}sidebar-padding-y: #{$sidebar-padding-y};\n  --#{$prefix}sidebar-color: #{$sidebar-color};\n  --#{$prefix}sidebar-border-width: #{$sidebar-border-width};\n  --#{$prefix}sidebar-border-color: #{$sidebar-border-color};\n  --#{$prefix}sidebar-brand-color: #{$sidebar-brand-color};\n  --#{$prefix}sidebar-brand-height: #{$sidebar-brand-height};\n  --#{$prefix}sidebar-brand-bg: #{$sidebar-brand-bg};\n  --#{$prefix}sidebar-header-height: #{$sidebar-header-height};\n  --#{$prefix}sidebar-header-bg: #{$sidebar-header-bg};\n  --#{$prefix}sidebar-header-padding-x: #{$sidebar-header-padding-x};\n  --#{$prefix}sidebar-header-padding-y: #{$sidebar-header-padding-y};\n  --#{$prefix}sidebar-footer-bg: #{$sidebar-footer-bg};\n  --#{$prefix}sidebar-footer-height: #{$sidebar-footer-height};\n  --#{$prefix}sidebar-footer-padding-x: #{$sidebar-footer-padding-x};\n  --#{$prefix}sidebar-footer-padding-y: #{$sidebar-footer-padding-y};\n  --#{$prefix}sidebar-toggler-bg: #{$sidebar-toggler-bg};\n  --#{$prefix}sidebar-toggler-height: #{$sidebar-toggler-height};\n  --#{$prefix}sidebar-toggler-indicator: #{escape-svg($sidebar-toggler-indicator-icon)};\n  --#{$prefix}sidebar-toggler-indicator-width: #{$sidebar-toggler-indicator-width};\n  --#{$prefix}sidebar-toggler-indicator-height: #{$sidebar-toggler-indicator-height};\n  --#{$prefix}sidebar-toggler-hover-bg: #{$sidebar-toggler-hover-bg};\n  --#{$prefix}sidebar-toggler-indicator-hover: #{escape-svg($sidebar-toggler-indicator-hover-icon)};\n\n  --#{$prefix}sidebar-narrow-width: #{$sidebar-narrow-width};\n\n  --#{$prefix}sidebar-nav-title-padding-x: #{$sidebar-nav-title-padding-x};\n  --#{$prefix}sidebar-nav-title-padding-y: #{$sidebar-nav-title-padding-y};\n  --#{$prefix}sidebar-nav-title-margin-top: #{$sidebar-nav-title-margin-top};\n  --#{$prefix}sidebar-nav-title-color: #{$sidebar-nav-title-color};\n  --#{$prefix}sidebar-nav-link-padding-x: #{$sidebar-nav-link-padding-x};\n  --#{$prefix}sidebar-nav-link-padding-y: #{$sidebar-nav-link-padding-y};\n  --#{$prefix}sidebar-nav-link-color: #{$sidebar-nav-link-color};\n  --#{$prefix}sidebar-nav-link-bg: #{$sidebar-nav-link-bg};\n  --#{$prefix}sidebar-nav-link-border-color: #{$sidebar-nav-link-border-color};\n  --#{$prefix}sidebar-nav-link-border: #{$sidebar-nav-link-border-width} solid var(--#{$prefix}sidebar-nav-link-border-color);\n  --#{$prefix}sidebar-nav-link-border-radius: #{$sidebar-nav-link-border-radius};\n  --#{$prefix}sidebar-nav-link-active-color: #{$sidebar-nav-link-active-color};\n  --#{$prefix}sidebar-nav-link-active-bg: #{$sidebar-nav-link-active-bg};\n  --#{$prefix}sidebar-nav-link-active-icon-color: #{$sidebar-nav-link-active-icon-color};\n  --#{$prefix}sidebar-nav-link-disabled-color: #{$sidebar-nav-link-disabled-color};\n  --#{$prefix}sidebar-nav-link-disabled-icon-color: #{$sidebar-nav-link-disabled-icon-color};\n  --#{$prefix}sidebar-nav-link-hover-color: #{$sidebar-nav-link-hover-color};\n  --#{$prefix}sidebar-nav-link-hover-bg: #{$sidebar-nav-link-hover-bg};\n  --#{$prefix}sidebar-nav-link-hover-icon-color: #{$sidebar-nav-link-hover-icon-color};\n  --#{$prefix}sidebar-nav-icon-width: #{$sidebar-nav-icon-width};\n  --#{$prefix}sidebar-nav-icon-height: #{$sidebar-nav-icon-height};\n  --#{$prefix}sidebar-nav-icon-font-size: #{$sidebar-nav-icon-font-size};\n  --#{$prefix}sidebar-nav-link-icon-color: #{$sidebar-nav-link-icon-color};\n  --#{$prefix}sidebar-nav-group-bg: #{$sidebar-nav-group-bg};\n  --#{$prefix}sidebar-nav-group-items-padding-y: #{$sidebar-nav-group-items-padding-y};\n  --#{$prefix}sidebar-nav-group-items-padding-x: #{$sidebar-nav-group-items-padding-x};\n  --#{$prefix}sidebar-nav-group-indicator: #{escape-svg($sidebar-nav-group-indicator-icon)};\n  --#{$prefix}sidebar-nav-group-indicator-hover: #{escape-svg($sidebar-nav-group-indicator-hover-icon)};\n  --#{$prefix}sidebar-nav-group-toggle-show-color: #{$sidebar-nav-group-toggle-show-color};\n  // scss-docs-end sidebar-css-vars\n\n  position: relative;\n  display: flex;\n  // $sidebar-width is the width of the columns\n  flex: 0 0 var(--#{$prefix}sidebar-width);\n  flex-direction: column;\n  // put the nav on the left\n  order: -1;\n  width: var(--#{$prefix}sidebar-width);\n  padding: var(--#{$prefix}sidebar-padding-y) var(--#{$prefix}sidebar-padding-x);\n  color: var(--#{$prefix}sidebar-color);\n  background: var(--#{$prefix}sidebar-bg);\n  @include ltr-rtl(\"border-right\", var(--#{$prefix}sidebar-border-width) solid var(--#{$prefix}sidebar-border-color));\n  box-shadow: none;\n  @include transition($sidebar-transition);\n\n  &:not(.sidebar-end){\n    @include ltr-rtl(\"margin-left\", 0);\n    ~ * {\n      --#{$prefix}sidebar-occupy-start: #{$sidebar-width};\n    }\n  }\n\n  &.sidebar-end {\n    order: 99;\n    @include ltr-rtl(\"margin-right\", 0);\n    ~ * {\n      --#{$prefix}sidebar-occupy-end: #{$sidebar-width};\n    }\n  }\n\n  &[class*=\"bg-\"]  {\n    border-color: rgba($black, .1);\n  }\n\n  @each $width, $value in $sidebar-widths {\n    &.sidebar-#{$width} {\n      --#{$prefix}sidebar-width: #{$value};\n      @include media-breakpoint-up($mobile-breakpoint) {\n        &:not(.sidebar-end):not(.hide) {\n          ~ * {\n            --#{$prefix}sidebar-occupy-start: #{$value};\n          }\n        }\n        &.sidebar-end:not(.hide) {\n          ~ * {\n            --#{$prefix}sidebar-occupy-end: #{$value};\n          }\n        }\n      }\n    }\n  }\n\n  @include media-breakpoint-up($mobile-breakpoint) {\n    &.hide {\n      &:not(.sidebar-end){\n        @include ltr-rtl(\"margin-left\", calc(-1 * var(--#{$prefix}sidebar-width)));\n        ~ * {\n          --#{$prefix}sidebar-occupy-start: 0;\n        }\n      }\n      &.sidebar-end {\n        @include ltr-rtl(\"margin-right\", calc(-1 * var(--#{$prefix}sidebar-width)));\n        ~ * {\n          --#{$prefix}sidebar-occupy-end: 0;\n        }\n      }\n    }\n  }\n\n  &.sidebar-fixed {\n    @include media-breakpoint-up($mobile-breakpoint) {\n      position: fixed;\n      top: 0;\n      bottom: 0;\n      z-index: $zindex-fixed;\n\n      &:not(.sidebar-end) {\n        @include ltr-rtl(\"left\", 0);\n      }\n\n      &.sidebar-end {\n        @include ltr-rtl(\"right\", 0);\n      }\n    }\n  }\n\n  &.sidebar-sticky {\n    @include media-breakpoint-up($mobile-breakpoint) {\n      position: sticky;\n      top: 0;\n      height: 100vh;\n    }\n  }\n\n  &.sidebar-overlaid {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    z-index: $zindex-fixed + 2;\n\n    &:not(.sidebar-end) {\n      @include ltr-rtl(\"left\", 0);\n      ~ * {\n        --#{$prefix}sidebar-occupy-start: 0;\n      }\n    }\n\n    &.sidebar-end {\n      @include ltr-rtl(\"right\", 0);\n      ~ * {\n        --#{$prefix}sidebar-occupy-end: 0;\n      }\n    }\n  }\n\n  @include media-breakpoint-down($mobile-breakpoint) {\n    // Some of our components use this property to detect if the sidebar has mobile behavior.\n    --#{$prefix}is-mobile: true;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    z-index: $zindex-fixed + 1;\n\n    &:not(.sidebar-end) {\n      @include ltr-rtl(\"left\", 0);\n      ~ * {\n        --#{$prefix}sidebar-occupy-start: 0 !important; // stylelint-disable-line\n      }\n\n      &:not(.show) {\n        @include ltr-rtl(\"margin-left\", calc(-1 * var(--#{$prefix}sidebar-width)));\n      }\n    }\n    &.sidebar-end {\n      @include ltr-rtl(\"right\", 0);\n      ~ * {\n        --#{$prefix}sidebar-occupy-end: 0 !important; // stylelint-disable-line\n      }\n\n      &:not(.show) {\n        @include ltr-rtl(\"margin-right\", calc(-1 * var(--#{$prefix}sidebar-width)));\n      }\n    }\n  }\n}\n\n.sidebar-close {\n  position: absolute;\n  top: 0;\n  @include ltr-rtl(\"right\", 0);\n  width: var(--#{$prefix}sidebar-width);\n  height: var(--#{$prefix}sidebar-header-height);\n  color: var(--#{$prefix}sidebar-color);\n  background: transparent;\n  border: 0;\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n}\n\n.sidebar-brand {\n  display: flex;\n  flex: 0 0 var(--#{$prefix}sidebar-brand-height);\n  align-items: center;\n  justify-content: center;\n  color: var(--#{$prefix}sidebar-brand-color);\n  background: var(--#{$prefix}sidebar-brand-bg);\n\n  .sidebar-brand-narrow {\n    display: none;\n  }\n}\n\n.sidebar-header {\n  flex: 0 0 var(--#{$prefix}sidebar-header-height);\n  padding: var(--#{$prefix}sidebar-header-padding-y) var(--#{$prefix}sidebar-header-padding-x);\n  text-align: center;\n  background: var(--#{$prefix}sidebar-header-bg);\n  @include transition($sidebar-header-height-transition);\n\n  .nav-link {\n    display: flex;\n    align-items: center;\n    min-height: var(--#{$prefix}sidebar-header-height);\n  }\n}\n\n.sidebar-footer {\n  flex: 0 0 var(--#{$prefix}sidebar-footer-height);\n  padding: var(--#{$prefix}sidebar-footer-padding-y) var(--#{$prefix}sidebar-footer-padding-x);\n  background: var(--#{$prefix}sidebar-footer-bg);\n  @include transition($sidebar-footer-height-transition);\n}\n\n.sidebar-toggler {\n  display: flex;\n  flex: 0 0 var(--#{$prefix}sidebar-toggler-height);\n  justify-content: flex-end;\n  width: inherit;\n  padding: 0;\n  cursor: pointer;\n  background-color: var(--#{$prefix}sidebar-toggler-bg);\n  border: 0;\n\n  @include media-breakpoint-down($mobile-breakpoint) {\n    display: none;\n  }\n\n  &::before {\n    display: block;\n    width: var(--#{$prefix}sidebar-toggler-indicator-width);\n    height: var(--#{$prefix}sidebar-toggler-indicator-height);\n    content: \"\";\n    background-image: var(--#{$prefix}sidebar-toggler-indicator);\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: calc(var(--#{$prefix}sidebar-toggler-indicator-height) * .25); // stylelint-disable-line function-disallowed-list\n    @include transition($sidebar-toggler-transition);\n    @include rtl() {\n      transform: rotate(-180deg);\n    }\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:hover {\n    background-color: var(--#{$prefix}sidebar-toggler-hover-bg);\n    &::before {\n      background-image: var(--#{$prefix}sidebar-toggler-indicator-hover);\n    }\n  }\n\n  .sidebar-end & {\n    justify-content: flex-start;\n    &::before {\n      transform: rotate(-180deg);\n    }\n  }\n}\n\n// Backdrop background\n\n.sidebar-backdrop {\n  // scss-docs-start sidebar-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-sidebar-backdrop};\n  --#{$prefix}backdrop-bg: #{$sidebar-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$sidebar-backdrop-opacity};\n  // scss-docs-end sidebar-backdrop-css-vars\n\n  @include media-breakpoint-down($mobile-breakpoint) {\n    @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n  }\n}\n","// Sidebar navigation\n\n.sidebar-nav {\n  position: relative;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  padding: 0;\n  margin-bottom: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  list-style: none;\n\n  .nav-title {\n    padding: var(--#{$prefix}sidebar-nav-title-padding-y) var(--#{$prefix}sidebar-nav-title-padding-x);\n    margin-top: var(--#{$prefix}sidebar-nav-title-margin-top);\n    font-size: 80%;\n    font-weight: 700;\n    color: var(--#{$prefix}sidebar-nav-title-color);\n    text-transform: uppercase;\n    @include transition($sidebar-nav-title-transition);\n  }\n\n  .nav-link {\n    display: flex;\n    flex: 1;\n    align-items: center;\n    padding: var(--#{$prefix}sidebar-nav-link-padding-y) var(--#{$prefix}sidebar-nav-link-padding-x);\n    color: var(--#{$prefix}sidebar-nav-link-color);\n    text-decoration: none;\n    white-space: nowrap;\n    background: var(--#{$prefix}sidebar-nav-link-bg);\n    border: var(--#{$prefix}sidebar-nav-link-border);\n    @include border-radius(var(--#{$prefix}sidebar-nav-link-border-radius));\n    @include transition($sidebar-nav-link-transition);\n\n    &.active {\n      color: var(--#{$prefix}sidebar-nav-link-active-color);\n      background: var(--#{$prefix}sidebar-nav-link-active-bg);\n\n      .nav-icon {\n        color: var(--#{$prefix}sidebar-nav-link-active-icon-color);\n      }\n    }\n\n    &.disabled {\n      color: var(--#{$prefix}sidebar-nav-link-disabled-color);\n      pointer-events: none;\n      cursor: not-allowed;\n      background: transparent;\n\n      .nav-icon {\n        color: var(--#{$prefix}sidebar-nav-link-disabled-icon-color);\n      }\n\n      &:hover {\n        color: var(--#{$prefix}sidebar-nav-link-disabled-color);\n\n        .nav-icon {\n          color: var(--#{$prefix}sidebar-nav-link-disabled-icon-color);\n        }\n\n        &.nav-dropdown-toggle::after {\n          background-image: var(--#{$prefix}sidebar-nav-group-indicator-hover);\n        }\n      }\n    }\n\n    @media (hover: hover), (-ms-high-contrast: none) {\n      &:hover {\n        color: var(--#{$prefix}sidebar-nav-link-hover-color);\n        text-decoration: none;\n        background: var(--#{$prefix}sidebar-nav-link-hover-bg);\n\n        .nav-icon {\n          color: var(--#{$prefix}sidebar-nav-link-hover-icon-color);\n        }\n\n        &.nav-group-toggle::after {\n          background-image: var(--#{$prefix}sidebar-nav-group-indicator-hover);\n        }\n      }\n    }\n  }\n\n  .nav-icon {\n    flex: 0 0 var(--#{$prefix}sidebar-nav-icon-width);\n    height: var(--#{$prefix}sidebar-nav-icon-height);\n    font-size: var(--#{$prefix}sidebar-nav-icon-font-size);\n    color: var(--#{$prefix}sidebar-nav-link-icon-color);\n    text-align: center;\n    pointer-events: none;\n    fill: currentcolor;\n    @include transition(inherit);\n\n    &:first-child {\n      @include ltr-rtl(\"margin-left\", calc(var(--#{$prefix}sidebar-nav-link-padding-x) * -1));\n    }\n  }\n  // stylelint-disable-next-line selector-no-qualifying-type\n  svg.nav-icon {\n    overflow: hidden; // fix chrome 105+ width issue\n  }\n\n  .nav-group {\n    position: relative;\n    @include transition($sidebar-nav-group-transition);\n\n    .nav-group-items {\n      padding: var(--#{$prefix}sidebar-nav-group-items-padding-y) var(--#{$prefix}sidebar-nav-group-items-padding-x);\n      overflow: hidden;\n      @include transition($sidebar-nav-group-items-transition);\n    }\n\n    &:not(.show) .nav-group-items {\n      display: none;\n    }\n\n    &.show {\n      background: var(--#{$prefix}sidebar-nav-group-bg);\n\n      .nav-group-toggle {\n        color: var(--#{$prefix}sidebar-nav-group-toggle-show-color);\n      }\n\n      > .nav-group-toggle::after {\n        transform: rotate(180deg);\n      }\n\n      + .show {\n        margin-top: 1px;\n      }\n    }\n  }\n\n  .nav-group-toggle {\n    cursor: pointer;\n\n    &::after {\n      display: block;\n      flex: 0 12px;\n      height: 12px;\n      @include ltr-rtl(\"margin-left\", auto);\n      content: \"\";\n      background-image: var(--#{$prefix}sidebar-nav-group-indicator);\n      background-repeat: no-repeat;\n      background-position: center;\n      @include transition($sidebar-nav-group-indicator-transition);\n    }\n  }\n\n  .nav-group-items {\n    padding: 0;\n    list-style: none;\n\n    .nav-link {\n      @include ltr-rtl(\"padding-left\", var(--#{$prefix}sidebar-nav-icon-width));\n\n      .nav-icon {\n        @include ltr-rtl(\"margin-left\", calc(var(--#{$prefix}sidebar-nav-icon-width) * -1));\n      }\n    }\n  }\n\n  &.compact,\n  .compact {\n    .nav-link {\n      padding-top: calc(var(--#{$prefix}sidebar-nav-link-padding-y) * .5); // stylelint-disable-line function-disallowed-list\n      padding-bottom: calc(var(--#{$prefix}sidebar-nav-link-padding-y) * .5); // stylelint-disable-line function-disallowed-list\n    }\n  }\n}\n","%sidebar-narrow {\n  @include media-breakpoint-up($mobile-breakpoint) {\n    z-index: $zindex-fixed + 1;\n    flex: 0 0 var(--#{$prefix}sidebar-narrow-width);\n    width: var(--#{$prefix}sidebar-narrow-width);\n    padding-bottom: var(--#{$prefix}sidebar-toggler-height);\n    overflow: visible;\n\n    &.sidebar-fixed {\n      z-index: $zindex-fixed + 1;\n      width: var(--#{$prefix}sidebar-narrow-width);\n    }\n\n    .sidebar-brand-full {\n      display: none;\n    }\n\n    .sidebar-brand-narrow {\n      display: block;\n    }\n\n    .d-narrow-none,\n    .nav-label,\n    .nav-title,\n    .nav-group-items,\n    .nav-group.show .nav-group-items,\n    .sidebar-footer,\n    .sidebar-form,\n    .sidebar-header {\n      height: 0 !important; // stylelint-disable-line declaration-no-important\n      padding: 0;\n      margin: 0;\n      visibility: hidden;\n      opacity: 0;\n    }\n\n    .sidebar-toggler {\n      position: fixed;\n      bottom: 0;\n\n      &::before {\n        @include ltr-rtl(\"transform\", rotate(-180deg), null, rotate(0deg));\n      }\n    }\n\n    &.sidebar-end .sidebar-toggler::before {\n      transform: rotate(0deg);\n    }\n  }\n}\n\n.sidebar-narrow {\n  @extend %sidebar-narrow;\n  &:not(.sidebar-end) ~ * {\n    --#{$prefix}sidebar-occupy-start: #{$sidebar-narrow-width};\n  }\n  &.sidebar-end ~ * {\n    --#{$prefix}sidebar-occupy-end: #{$sidebar-narrow-width};\n  }\n}\n\n.sidebar-narrow-unfoldable {\n  position: fixed;\n  z-index: $zindex-fixed + 1;\n\n  &:not(.sidebar-end) ~ * {\n    --#{$prefix}sidebar-occupy-start: #{$sidebar-narrow-width};\n  }\n  &.sidebar-end ~ * {\n    --#{$prefix}sidebar-occupy-end: #{$sidebar-narrow-width};\n  }\n\n  &:not(:hover) {\n    @extend %sidebar-narrow;\n  }\n\n  &:hover {\n    .sidebar-toggler {\n      &::before {\n        @include ltr-rtl(\"transform\", rotate(-180deg), null, rotate(0deg));\n      }\n    }\n\n    &.sidebar-end .sidebar-toggler::before {\n      transform: rotate(0deg);\n    }\n  }\n}\n\n// Responsive behavior\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-down($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n    .sidebar:not(.show).sidebar-self-hiding#{$infix} {\n      &.sidebar-narrow,\n      &.sidebar-narrow-unfoldable {\n        &:not(.sidebar-end) {\n          @include ltr-rtl(\"margin-left\", calc(var(--#{$prefix}sidebar-narrow-width) * -1));\n        }\n        &.sidebar-end {\n          @include ltr-rtl(\"margin-right\", calc(var(--#{$prefix}sidebar-narrow-width) * -1));\n        }\n      }\n    }\n  }\n}\n",".subheader {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  min-height: $subheader-min-height;\n  padding: $subheader-padding-y $subheader-padding-x;\n  background: var(--#{$prefix}subheader-bg, $subheader-bg);\n  border-bottom: var(--#{$prefix}subheader-border-width, $subheader-border-width) solid var(--#{$prefix}subheader-border-color, $subheader-border-color);\n}\n\n.subheader-sticky {\n  position: sticky;\n  top: 0;\n  z-index: $zindex-fixed - 1;\n}\n\n// Subheader nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.subheader-nav {\n  display: flex;\n  flex-direction: row; // cannot use `inherit` to get the `.header`s value\n  @include ltr-rtl(\"padding-left\", 0);\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: $subheader-nav-link-padding-x;\n    padding-left: $subheader-nav-link-padding-x;\n    color: var(--#{$prefix}subheader-color, $subheader-color);\n\n    &:hover,\n    &:focus {\n      color: var(--#{$prefix}subheader-hover-color, $subheader-hover-color);\n    }\n\n    &.disabled {\n      color: var(--#{$prefix}subheader-disabled-color, $subheader-disabled-color);\n    }\n  }\n\n  .show > .nav-link,\n  .nav-link.active {\n    color: var(--#{$prefix}subheader-active-color, $subheader-active-color);\n  }\n\n  .dropdown-menu {\n    position: absolute;\n  }\n}\n\n// Subheader text\n//\n//\n\n.subheader-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}subheader-color, $subheader-color);\n\n  a {\n    color: var(--#{$prefix}subheader-active-color, $subheader-active-color);\n\n    &:hover,\n    &:focus {\n      color: var(--#{$prefix}subheader-active-color, $subheader-active-color);\n    }\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--cui-focus-ring-x`, `--cui-focus-ring-y`, or `--cui-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    @include ltr-rtl(\"left\", 0);\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  padding: 0;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix, $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    // Generate RTL version\n    $generate-rtl: if(map-has-key($utility, rtl), map-get($utility, rtl), false);\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            @if $generate-rtl == true {\n              @include ltr-rtl($property, $value, null, null, if($enable-important-utilities, !important, null));\n            } @else {\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","/*!\n * CoreUI Plugins - Chart.js for CoreUI 3\n * @version v3.1.2\n * @link https://coreui.io\n * Copyright (c) 2021 creativeLabs Łukasz Holeczek\n * Licensed under MIT (https://github.com/coreui/coreui-chartjs/blob/main/LICENSE)\n */\n\n\n@import \"@coreui/coreui/scss/functions\";\n@import \"@coreui/coreui/scss/variables\";\n@import \"@coreui/coreui/scss/mixins\";\n@import \"tooltips\";\n","// Custom tooltips\n\n.chartjs-tooltip {\n  position: absolute;\n  z-index: $zindex-sticky + 1;\n  padding: ($spacer * .25) ($spacer * .5);\n  color: #fff;\n  pointer-events: none;\n  background: rgba(0, 0, 0, .7);\n  opacity: 0;\n  @include transition(all .15s ease);\n  transform: translate(-50%, 0);\n  @include border-radius($border-radius);\n}\n\n.chartjs-tooltip-header {\n  margin-bottom: ($spacer * .5);\n}\n\n.chartjs-tooltip-header-item {\n  font-size: $font-size-sm;\n  font-weight: $font-weight-bold;\n}\n\n.chartjs-tooltip-body-item {\n  align-items: center;\n  font-size: $font-size-sm;\n  white-space: nowrap;\n}\n","body {\n  overflow: visible;\n  font-family: \"Noto Sans JP\";\n  color: $black;\n}\n\n.wrapper {\n  width: 100%;\n  // @include ltr-rtl(\"padding-left\", var(--cui-sidebar-occupy-start, 0));\n  will-change: auto;\n  // @include transition(padding .15s);\n}\n\n.app-content {\n  overflow: auto;\n  background-color: $light-orange;\n}\n\n.header {\n  .header-text-list {\n    font-weight: 700;\n    color: $orange;\n    text-decoration: none;\n  }\n\n  .header-text-list:last-child {\n    border-right: none;\n  }\n}\n\n.sidebar {\n  background: #FFFFFF;\n  width: 209px;\n\n  .nav-link {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 22px;\n    letter-spacing: 0.25px;\n    color: #6C757D;\n\n    &.active {\n      background: #FFF7F2;\n      color: $orange;\n\n      .nav-icon {\n        color: $orange;\n      }\n    }\n\n    &:hover {\n      background: #FFF7F2;\n      color: $orange;\n\n      .nav-icon {\n        color: $orange;\n      }\n    }\n  }\n\n  .nav-icon {\n    height: 20px;\n    width: 20px;\n    color: #6C757D;\n  }\n}\n\n.footer {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  background: #FFFFFF;\n  border-top: 1px solid $orange;\n\n}\n\n.footer-text-description {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 17px;\n  color: #1A1311;\n  margin-top: 9px;\n\n  p {\n    margin: 0;\n  }\n}\n\n.layout-auth {\n  background: #FFF7F2;\n\n  &-content {\n    margin-top: 68px;\n    min-height: calc(100vh - 197px);\n    padding: 50px 0;\n  }\n}\n\n.header-custom {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 99;\n  background-color: $white;\n}\n\n@media screen and (min-width: 900px) {\n  .sidebar-mitsubachi {\n    position: fixed;\n    min-height: 100vh !important;\n    width: 209px;\n    top: 68px !important;\n    z-index: 99 !important;\n  }\n\n  .sidebar {\n    .nav-item {\n      width: 186px;\n      left: 12px;\n      position: relative;\n\n      .badge {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-family: \"Noto Sans JP\";\n        font-weight: 700;\n        font-size: 8px;\n        line-height: 12px;\n        letter-spacing: -0.28px;\n        color: #FFFFFF;\n        background-color: #FF594F;\n        width: 16px;\n        height: 16px;\n        position: relative;\n        bottom: 7px;\n        right: 123px;\n        border-radius: 50%;\n        border: 1px solid #FFFFFF;\n      }\n    }\n  }\n\n  .app-content {\n    margin-left: 209px;\n    padding: 1.5em;\n    min-height: calc(100vh - 197px);\n    font-size: 14px;\n    margin-top: 68px;\n  }\n\n  .header {\n    height: 68px;\n    --cui-header-min-height: 68px;\n    padding: 14px 24px;\n    border-bottom: 1px solid #EDEDED;\n\n    .container-fluid {\n      padding-top: 0px;\n      padding-bottom: 0px;\n    }\n\n    .header-logo {\n      width: 88.2px;\n      height: 18px;\n    }\n\n    .cursor-pointer {\n      cursor: pointer;\n    }\n\n    .header-text-list {\n      border-right: 2px solid $orange;\n      font-size: 16px;\n      line-height: 24px;\n      letter-spacing: 0.25px;\n      padding: 0px 16px;\n    }\n\n  }\n\n  .footer-logo-view {\n    width: 278px;\n    height: 50px;\n    border-right: 1px solid #FFAC7D;\n    display: flex;\n    align-items: center;\n  }\n\n  .footer-logo {\n    width: 258px;\n    height: 31px;\n  }\n\n  .footer-detail {\n    width: 70%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .footer-text-description {\n    margin-top: 0 !important;\n    margin-left: 20px !important;\n  }\n\n  .footer {\n    height: 129px !important;\n    z-index: 100;\n    padding: 25px 0;\n    justify-content: center;\n    width: 100%;\n\n    .footer-list-screen {\n      display: flex;\n      justify-content: space-around;\n      flex-direction: column;\n\n      ul {\n        list-style: disc;\n        color: $orange;\n\n        .footer-text-item {\n          color: $orange;\n          margin-bottom: 6px;\n          font-weight: 700;\n          font-size: 12px;\n          line-height: 18px;\n          text-decoration: none;\n        }\n      }\n    }\n  }\n\n  .footer-text-list {\n    display: block;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: 0.25px;\n    color: $orange;\n    margin: 7px 0;\n    text-decoration: none;\n    cursor: pointer;\n    &:hover {\n      color: #2819af;\n    }\n  }\n\n  .modal-dialog {\n    &.modal-dialog-centered {\n      &.modal-xl {\n        --cui-modal-width: 95% !important;\n        justify-content: center;\n      }\n    }\n  }\n  .modal-content {\n    max-width: 1080px;\n  }\n  .footer-modal-iframe {\n    .iframe {\n      width: 100%;\n      height: 500px;\n      display: block;\n    }\n    .icon-close {\n      width: 25px;\n      height: 25px;\n      position: absolute;\n      top: -50px;\n      right: 0;\n      cursor: pointer;\n    }\n  }\n\n  .layout-auth {\n    &-content {\n      min-height: calc(100vh - 197px);\n    }\n  }\n\n  .btn-auth {\n    height: 41px !important;\n  }\n}\n\n@media screen and (max-width: 899px) {\n  .layout-auth {\n    &-content {\n      margin-top: 60px;\n    }\n  }\n\n  .sidebar-mitsubachi {\n    position: sticky;\n    min-height: auto !important;\n    width: 100%;\n    top: 68px !important;\n    z-index: 99 !important;\n  }\n\n  .hidden-on-mobile {\n    display: none !important;\n  }\n\n  .header {\n    height: 60px;\n    --cui-header-min-height: 60px;\n    padding: 13px 26px;\n\n    .container-fluid {\n      padding-top: 0px;\n      padding-bottom: 0px;\n    }\n\n    .header-logo {\n      width: 87.52px;\n      height: 18px;\n    }\n\n    .btn-auth {\n      height: 36px !important;\n    }\n\n\n    .header-text-list {\n      display: block;\n      padding: 24px 0;\n      border-right: 2px solid $orange;\n      font-size: 14px;\n      line-height: 20px;\n      letter-spacing: 0.25px;\n    }\n  }\n\n  .app-content {\n    margin-left: 0px;\n    margin-top: 56px;\n    padding: 24px 12px;\n    font-size: 12px;\n    overflow-x: hidden;\n    margin-top: 60px;\n  }\n\n  .sidebar {\n    width: 100%;\n    height: 56px;\n    z-index: 1 !important;\n    top: 60px !important;\n\n    .nav-link {\n      .badge {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-family: \"Noto Sans JP\";\n        font-weight: 700;\n        font-size: 8px;\n        line-height: 12px;\n        letter-spacing: -0.28px;\n        color: #FFFFFF;\n        background-color: #FF594F;\n        width: 16px;\n        height: 16px;\n        position: relative;\n        bottom: 40px;\n        left: 4px;\n        border-radius: 50%;\n        border: 1px solid #FFFFFF;\n        text-decoration: none !important;\n      }\n\n      &.active {\n        background-color: #FFFFFF;\n\n        .sideBar-name {\n          text-decoration: underline;\n          text-underline-offset: 10px;\n        }\n      }\n\n      &:hover {\n        background-color: #FFFFFF;\n\n        .sideBar-name {\n          text-decoration: underline;\n          text-underline-offset: 10px;\n        }\n      }\n    }\n  }\n\n  .sidebar a {\n    float: left;\n  }\n\n  .sidebar-nav .nav-link {\n    display: grid;\n    font-family: 'Noto Sans JP';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 10px;\n    line-height: 14px;\n    letter-spacing: 0.25px;\n    color: #6C757D;\n    width: 25%;\n    justify-content: center;\n    justify-items: center;\n  }\n\n  .sidebar-nav {\n    overflow-x: hidden;\n    overflow-y: hidden;\n  }\n\n  html:not([dir=rtl]) .sidebar-nav .nav-icon:first-child {\n    margin-left: 0;\n  }\n\n  .footer {\n    height: auto;\n    display: block;\n    width: 100%;\n\n    .footer-logo {\n      width: 199.74px;\n      height: 24px\n    }\n\n    .footer-list-screen {\n      display: flex;\n      flex-direction: column;\n      margin-top: 16px;\n      padding-bottom: 5px;\n\n      ul {\n        list-style: disc;\n        color: $orange;\n\n\n        .footer-text-item {\n          color: $orange;\n          margin-bottom: 6px;\n          font-weight: 700;\n          font-size: 12px;\n          line-height: 18px;\n          text-decoration: none;\n        }\n      }\n    }\n\n    .footer-list-container {\n      width: 100%;\n    }\n  }\n\n  .footer-text-list {\n    display: block;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 20px;\n    letter-spacing: 0.25px;\n    color: $orange;\n    margin-bottom: 14px;\n    text-decoration: none;\n  }\n\n  .modal-dialog {\n    &.modal-dialog-centered {\n      &.modal-xl {\n        --cui-modal-width: 95% !important;\n        justify-content: center;\n      }\n    }\n  }\n  .modal-content {\n    max-width: 1080px;\n  }\n  .footer-modal-iframe {\n    .iframe {\n      width: 100%;\n      height: 400px;\n      display: block;\n    }\n    .icon-close {\n      width: 20px;\n      height: 20px;\n      position: absolute;\n      top: -50px;\n      right: 0;\n      cursor: pointer;\n    }\n  }\n\n  .layout-auth {\n    &-content {\n      min-height: calc(100vh - 237px);\n      padding: 12px 4px;\n    }\n  }\n\n}\n\n@media (max-width: 899px) {\n  html:not([dir=rtl]) .sidebar:not(.sidebar-end):not(.show) {\n    margin-left: 0 !important;\n  }\n}\n\n@media (min-width: 900px) {\n  html:not([dir=rtl]) .sidebar.hide:not(.sidebar-end) {\n    margin-left: 0;\n  }\n}\n",".btn {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    gap: 10px;\n    border-radius: 4px;\n    font-family: 'Noto Sans JP';\n    font-style: normal;\n    text-align: center;\n    letter-spacing: 0.25px;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    border: unset;\n    cursor: pointer;\n    padding: 14px 24px;\n}\n\n\n.btn-orange {\n    background: $orange;\n    color: $white;\n\n    &:disabled {\n        background-color: $orange !important;\n        opacity: 0.5;\n    }\n\n    &:hover {\n        background-color: $orange;\n    }\n}\n\n.btn-yellow {\n    background: $yellow;\n    color: $black;\n\n    &:disabled {\n        background-color: #fffaea !important;\n        opacity: 0.5;\n    }\n\n    &:hover {\n        background-color: $yellow;\n    }\n}\n\n\n.btn-light-orange {\n    background-color: $light-orange;\n    color: $orange;\n\n    &:hover {\n        background-color: $orange;\n    }\n}\n\n// destop\n@media screen and (min-width: 900px) {\n    .btn {\n        padding: 14px 24px;\n        font-size: 16px;\n    }\n}\n\n\n// mobile\n@media screen and (max-width: 899px) {\n    .btn {\n        padding: 9px 12px;\n        font-size: 12px;\n    }\n}\n",".burger-menu-container {\n    position: absolute;\n    right: 0px;\n    top: 60px;\n    width: 100%;\n    height: 100vh;\n    background-color: rgba(28, 25, 25, 0.5);\n}\n\n.burger-icon {\n    width: 25px;\n    height: 20px;\n    color: #F8601B;\n}\n\n.burger-list {\n    list-style: none;\n    background-color: #FFFFFF;\n\n    li {\n        position: relative;\n        right: 20px;\n    }\n\n    li:first-child {\n        border-top: none;\n    }\n\n}\n\n.burger-list-parent {\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 20px;\n    letter-spacing: 0.25px;\n    color: #F8601B;\n    border-top: 1px solid #BCBFC4;\n}\n\n.burger-button{\n    padding-bottom: 24px;\n}\n\n.burger-list-child {\n    font-weight: 700;\n    font-size: 12px;\n    line-height: 18px;\n    letter-spacing: 0.25px;\n    color: #F8601B;\n    padding-top: 18px;\n}\n\n.burger-sublist {\n    list-style: disc;\n}\n\n@media screen and (min-width: 900px) {\n    .burger-icon {\n        display: none;\n    }\n\n    .burger-menu-container {\n        display: none;\n    }\n}",".required {\n  color: $red;\n}\n\n.card {\n  --cui-card-border-width: none;\n}\n\n.success {\n  border: 1px dashed #358b43;\n  color: #358b43;\n  font-weight: 500;\n  padding: 12px;\n  border-left: none;\n  border-right: none;\n}\n\n.text-ellipse {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  word-break: break-all;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n}\n\n.formInput {\n  .form-check-input {\n    margin-top: 5px;\n    border: 2px solid $border-checkbox;\n    -webkit-appearance: none !important;\n    cursor: pointer;\n  }\n\n  .form-check-input:checked {\n    background-color: #f8601b;\n    border-color: #f8601b;\n  }\n}\n\n.text-brown {\n  color: #6C757D;\n}\n\n.word-break-all {\n  word-break: break-all;\n}\n\n// destop\n@media screen and (min-width: 900px) {\n  .width-date-table {\n    width: 10%;\n  }\n\n  .width-name-table {\n    width: 30%;\n  }\n\n  .width-auth {\n    width: 600px !important;\n  }\n\n  .success {\n    font-size: 16px;\n    line-height: 24px;\n  }\n\n  .formSelect {\n    margin: 10px 0;\n\n    &-label {\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 20px;\n      letter-spacing: 0.25px;\n      color: $black;\n      margin: 10px 0;\n    }\n\n    &-custom {\n      cursor: pointer;\n      height: 56px;\n      padding: 10px 18px;\n      gap: 10px;\n      background-color: #fff7f2;\n      border: 1px solid #ffe0ce;\n      border-radius: 4px;\n      font-weight: 500;\n      font-size: 16px;\n      line-height: 24px;\n      letter-spacing: 0.25px;\n      color: $black;\n      max-width: 100%;\n    }\n  }\n\n  .iframe-tag {\n    height: calc(100vh - 388px);\n    width: 100%;\n  }\n\n  .text-18 {\n    font-size: 18px;\n    line-height: 28px;\n  }\n\n  .text-16 {\n    font-size: 16px;\n    line-height: 24px;\n  }\n\n  .text-14 {\n    font-size: 14px;\n    line-height: 20px;\n  }\n\n  .break-spaces {\n    white-space: break-spaces !important;\n  }\n\n  .card-header {\n    padding: 30px 24px;\n    height: 82px;\n    display: flex;\n    justify-content: start;\n  }\n\n  .card-body {\n    padding: 1em;\n  }\n\n  .page-title {\n    width: fit-content;\n    color: $orange;\n    font-family: 'Noto Sans JP';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 28px;\n    letter-spacing: 0.25px;\n  }\n\n  .page-sub-title {\n    font-family: 'Noto Sans JP';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 8px;\n    letter-spacing: 0.25px;\n    margin-top: 15px;\n    margin-bottom: 10px;\n    color: $black;\n  }\n  .sub-title {\n    display: contents;\n    &-terms {\n      font-size: 14px;\n      color: $black;\n      width: 100%;\n    }\n  }\n  .electric-title {\n    margin-bottom: 12px;\n  }\n\n  .nav {\n    padding-left: 24px !important;\n\n    .nav-link {\n      width: 180px;\n    }\n  }\n}\n\ninput.disabled {\n  pointer-events: none;\n  color: #333333;\n  background: #E4E4E4;\n}\n\n// mobile\n@media screen and (max-width: 899px) {\n  .width-date-table {\n    width: 13%;\n  }\n\n  .width-name-table {\n    width: 20%;\n  }\n\n  .success {\n    font-size: 14px;\n    line-height: 22px;\n    width: 100%;\n  }\n\n  .formSelect {\n    &-label {\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 16px;\n      letter-spacing: 0.25px;\n      color: $black;\n      margin: 8px 0;\n    }\n\n    &-custom {\n      cursor: pointer;\n      height: 44px;\n      padding: 8px 16px;\n      gap: 10px;\n      background-color: #fff7f2;\n      border: 1px solid #ffe0ce;\n      border-radius: 4px;\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 20px;\n      letter-spacing: 0.25px;\n      color: $black;\n      max-width: 100%;\n    }\n\n    option {\n      width: 100%;\n      max-width: 100%;\n      font-size: 14px;\n      line-height: 20px;\n    }\n  }\n\n  .formInput {\n    &-label {\n      font-size: 12px !important;\n    }\n\n    .form-check-input {\n      margin-top: 6px;\n    }\n  }\n\n  .iframe-tag {\n    width: 100%;\n    height: 478px;\n  }\n\n  .text-18 {\n    font-size: 16px;\n    line-height: 24px;\n  }\n\n  .text-16 {\n    font-size: 14px;\n    line-height: 20px;\n  }\n\n  .text-14 {\n    font-size: 12px;\n    line-height: 16px;\n  }\n\n  .card-header {\n    padding: 20px 12px;\n    height: 64px;\n    display: flex;\n    justify-content: center;\n  }\n\n  .card-body {\n    padding: 20px 12px;\n    width: 100%;\n  }\n\n  .page-title {\n    color: $orange;\n    font-family: 'Noto Sans JP';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    text-align: center;\n    letter-spacing: 0.25px;\n  }\n\n  .page-sub-title {\n    font-family: 'Noto Sans JP';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 0px;\n    letter-spacing: -0.28px;\n    color: $black;\n    margin-top: 14px;\n  }\n\n  .sub-title {\n    line-height: 15px;\n    display: block;\n    &-terms {\n      font-size: 12px;\n      color: $black;\n      width: 100%;\n    }\n  }\n\n  .nav {\n    .nav-item {\n      width: 50%;\n\n      .nav-link {\n        width: 100%;\n      }\n    }\n  }\n}\n\n.font-weight-normal {\n  font-weight: normal !important;\n}\n\n.font-weight-700 {\n  font-weight: 700 !important;\n}\n\n.font-weight-500 {\n  font-weight: 500;\n}\n\n.font-weight-400 {\n  font-weight: 400 !important;\n}\n\n.text-orange {\n  color: $orange;\n}\n\n.text-blue {\n  color: $blue;\n}\n\n.text-black {\n  color: $black !important;\n}\n\n.text-green {\n  color: $green;\n}\n\n.text-yellow {\n  color: $yellow;\n}\n\n.card {\n  width: 100%;\n  filter: drop-shadow(0px 4px 18px #fbd7b6);\n  border-top: 4px solid $orange;\n  min-width: 90%;\n\n  &.form-qa-not-login {\n    width: 90%;\n  }\n}\n\n.card-header {\n  box-sizing: border-box;\n  gap: 10px;\n  background: $white;\n  border-bottom: 1px dashed $orange;\n  border-radius: 4px 4px 0px 0px;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  align-items: center;\n}\n\n.card-body {\n  background-color: $white;\n  gap: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n  min-height: calc(100vh - 485px);\n}\n\n@media screen and (max-width: 899px) {\n  .card-body {\n    min-height: calc(100vh - 460px);\n  }\n\n  .card {\n    &.form-qa-not-login {\n      width: 95%;\n    }\n  }\n  .chartjs-tooltip {\n    transform: translate(-70%, 0);\n    display: none !important;\n  }\n  .chartjs-tooltip-body-item {\n    font-size: 0.775rem;\n  }\n}\n\n.card-outline-orange {\n  background-color: #fff7f2;\n  border: 2px solid #ffac7d;\n  border-radius: 5px;\n  padding: 18px 34px;\n}\n\n.card-outline-light-orange {\n  background-color: #fff7f2;\n  border: 4px solid #FFAC7D;\n  border-radius: 5px;\n  display: inline-block;\n  padding: 18px 24px;\n}\n\n.card-outline-blue {\n  background-color: #ebedfb;\n  border: 2px solid #b2b8e7;\n  border-radius: 5px;\n  display: inline-block;\n}\n\n.card-outline-green {\n  background-color: #f5fff1;\n  border: 2px solid #4eae5d;\n  border-radius: 5px;\n  display: inline-block;\n}\n\n.pagination {\n  .page-item {\n    &.disabled {\n      .page-link {\n        color: #dbd3d3;\n      }\n    }\n  }\n\n  .page-link.active,\n  .active>.page-link {\n    color: $white;\n    background-color: $orange;\n    border-color: $orange;\n  }\n\n  .page-link {\n    height: 28px;\n    width: auto;\n    min-width: 28px;\n    color: $orange;\n    font-size: 14px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .input-password {\n    &::placeholder {\n      font-size: 4px;\n    }\n  }\n}\n\n.nav {\n  background-color: $gray;\n  position: relative;\n  top: 1px;\n\n  .nav-item {\n    cursor: pointer;\n\n    .nav-link {\n      display: flex;\n      justify-content: center;\n      color: #6c757d;\n      font-weight: 700;\n      font-size: 16px;\n      line-height: 24px;\n\n      &.active {\n        color: $orange;\n      }\n    }\n  }\n}\n\n.border-radius-4 {\n  border-radius: 4px;\n}\n\n.bg-gray {\n  background-color: $gray !important;\n}\n\n.bg-orange {\n  background-color: $orange !important;\n}\n\n.bg-dark-gray {\n  background-color: $dark-gray !important;\n}\n\na {\n  text-decoration: none;\n}\n\n.formInput {\n  margin: 10px 0;\n\n  &-label {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    letter-spacing: 0.25px;\n    color: $black;\n    margin: 10px 0;\n  }\n\n  &-custom {\n    padding: 14px 24px;\n    gap: 10px;\n    height: 56px;\n    background: #fff7f2;\n    border: 1px solid #ffe7e6;\n    border-radius: 4px;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: 0.25px;\n    color: $black;\n    outline: none;\n    -webkit-appearance: none !important;\n    width: 100%;\n  }\n\n  .link {\n    margin-left: 5px;\n    cursor: pointer;\n  }\n\n  .text-link {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 22px;\n    letter-spacing: -0.07px;\n    text-decoration: underline;\n    margin-left: 5px;\n    color: $orange;\n  }\n\n  // &-custom:read-only {\n  //   background: #e8e8e8;\n  //   border: unset;\n  // }\n\n  &-error {\n    border: 1px solid #ff0f00;\n  }\n}\n\n.formTextarea {\n  margin: 10px 0;\n\n  &-label {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    letter-spacing: 0.25px;\n    color: $black;\n    margin: 10px 0;\n  }\n\n  &-input {\n    padding: 10px 18px;\n    gap: 10px;\n    background-color: #fff7f2;\n    border: 1px solid #ffe0ce;\n    border-radius: 4px;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: 0.25px;\n    color: $black;\n  }\n}\n\n.text-error {\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0.25px;\n  color: #ff0f00;\n  align-self: flex-start;\n}\n\n.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.input-password {\n  padding-right: 48px;\n\n  &::placeholder {\n    font-size: 8px;\n  }\n}\n\ninput {\n  text-overflow: ellipsis;\n}\n\n.pr-48 {\n  padding-right: 48px;\n}\n\n[data-simplebar] {\n  width: 100%;\n  height: 100%;\n}\n",".dropdown-scroll {\n  display: flex;\n  height: 200px;\n}\n\n.dropdown {\n  width: 100%;\n  min-width: 170px;\n\n  &-toggle {\n    display: flex !important;\n    background: $transparent !important;\n    font-weight: 700 !important;\n\n    &::after {\n      margin: 9px -10px auto auto !important;\n      border-top: 0.7em solid !important;\n      border-right: 0.5em solid transparent !important;\n      border-left: 0.5em solid transparent !important;\n    }\n  }\n\n  &-input {\n    width: 100%;\n    border: none;\n    background-color: $gray;\n    padding-left: 15px;\n    padding-right: 15px;\n    font-size: 14px;\n    border-bottom: 1px solid $border-color;\n    &:focus-visible {\n      outline: none;\n    }\n  }\n\n  &-label-no-data {\n    height: 30px;\n    width: 100%;\n    text-align: center;\n    margin-top: 20px;\n    font-size: 14px;\n    color: $black;\n  }\n\n  &-toggle-contract {\n    display: flex !important;\n    background: $transparent !important;\n    font-weight: 700 !important;\n\n    &::after {\n      margin: 2px -14px auto auto !important;\n      border-top: 0.6em solid !important;\n      border-right: 0.4em solid transparent !important;\n      border-left: 0.4em solid transparent !important;\n      color: $black !important\n    }\n  }\n\n  &-menu {\n    width: 100% !important;\n    position: absolute !important;\n    inset: 0 auto auto 0 !important;\n    overflow-y: auto;\n\n    &.not-padding-top{\n      padding-top: unset;\n    }\n  }\n\n  &-item {\n    font-size: 14px;\n    color: $black;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    white-space: break-spaces;\n    &:hover {\n      background-color: $light-orange !important;\n    }\n  }\n}\n\n@media screen and (max-width: 899px) {\n  .dropdown {\n    &-toggle {\n      &::after {\n        margin: 8px -2px auto auto !important;\n      }\n    }\n    &-toggle-contract {\n      &::after {\n        margin: 2px -4px auto auto !important;\n        border-top: 0.5em solid !important;\n      }\n    }\n    &-item {\n      font-size: 12px;\n    }\n    &-input {\n      font-size: 12px;\n    }\n    &-label-no-data {\n      font-size: 12px;\n    }\n  }\n}\n\n@media screen and (min-width: 900px) {\n  .dropdown {\n    &-toggle-contract {\n      &-item-selecting {\n        font-size: 14px;\n        font-weight: 500;\n      }\n    }\n\n  }\n}\n",".modal-dialog {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--cui-modal-margin) * 2);\n  -webkit-appearance: none;\n}\n\n.modal-content {\n  -webkit-appearance: none;\n}\n\n.modal-header {\n  background-color: $white;\n  font-family: 'Noto Sans JP';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 28px;\n  display: flex;\n  align-items: center;\n  letter-spacing: 0.25px;\n  color: $orange;\n  border-top: 4px solid $orange;\n  border-bottom: 1px dashed $orange;\n  border-radius: 4px 4px 0px 0px;\n\n  .modal-title {\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 28px;\n    letter-spacing: 0.25px;\n  }\n}\n\n.modal-body {\n  display: flex;\n  background-color: #FFFFFF;\n  justify-content: center;\n  border-radius: 4px;\n  width: 100%;\n  align-items: center;\n  flex-direction: column;\n  position: relative;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: center;\n  border-top: none;\n}\n\n.modal-img {\n  width: 271px;\n}\n\n.modal-sm {\n  --cui-modal-width: 598px !important;\n}\n\n.modal-noti {\n  padding: 40px 20px 30px;\n\n  &-text-content {\n    color: $black;\n    text-align: center;\n    padding-right: 20px;\n    padding-left: 20px;\n    font-weight: 700;\n  }\n\n  &-icon-close {\n    margin: 20px 20px 0 0;\n    align-self: end;\n    cursor: pointer;\n  }\n\n  &-title {\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 19px;\n    color: $black;\n  }\n\n  &-btn {\n    button {\n      margin-top: 30px;\n      background: $orange;\n      border-radius: 5px;\n      padding: 10px;\n      min-width: 182px;\n      border: unset;\n      font-weight: 700;\n    }\n  }\n\n  &-btn-ok {\n    background: $orange;\n  }\n\n  &-btn-cancel {\n    background: $white !important;\n    border: 1px solid $dark-gray !important;\n    color: $dark-gray !important;\n\n    &:hover {\n      background: $blue !important;\n    }\n  }\n}\n\n@media screen and (max-width: 899px) {\n  .modal-header {\n    .modal-title {\n      font-size: 16px;\n      line-height: 24px;\n    }\n  }\n}\n",".confirmContract {\n  position: relative;\n  &-title {\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 34px;\n    letter-spacing: 0.25px;\n    color: $black;\n  }\n\n  &-contract-end {\n    color: $red;\n  }\n\n  &-left {\n    width: 640px;\n\n    &-main {\n      margin-top: 36px;\n      padding: 32px 0;\n      gap: 10px;\n      width: 100%;\n      background: #ffffff;\n      border: 4px solid #ffac7d;\n      border-radius: 4px;\n    }\n\n    hr {\n      width: 100%;\n    }\n  }\n\n  &-text {\n    color: $black;\n\n    &-left {\n      font-weight: 400;\n      letter-spacing: 0.25px;\n    }\n\n    &-right {\n      font-weight: 500;\n      letter-spacing: -0.28px;\n    }\n  }\n\n  &-right {\n    width: 640px;\n\n    &-main {\n      width: 100%;\n      padding: 16px 0;\n      gap: 10px;\n      position: relative;\n      .confirmContract-contract-end {\n        position: absolute;\n        top: 4px;\n        width: 100%;\n      }\n    }\n\n    &-top {\n      hr {\n        width: 100%;\n      }\n    }\n\n    &-bottom {\n      hr {\n        width: 100%;\n      }\n    }\n  }\n}\n\n.myPage-container {\n  min-height: calc(100vh - 239px);\n  background: $white;\n  filter: drop-shadow(0px 4px 18px #fbd7b6);\n\n  &-header {\n    border-top: 4px solid $orange;\n    border-bottom: 1px dashed $orange;\n    border-radius: 4px 4px 0 0;\n    height: 82px;\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 28px;\n    color: $orange;\n    padding: 0 24px;\n\n    .contract-name {\n      font-weight: 500;\n      font-size: 18px;\n      line-height: 28px;\n      letter-spacing: 0.25px;\n      color: #6c757d;\n    }\n\n    .contract-number {\n      font-weight: 700;\n      font-size: 18px;\n      line-height: 26px;\n      letter-spacing: 0.25px;\n      color: $black;\n      margin-left: 4px;\n    }\n  }\n\n  &-main {\n    gap: 32px;\n    padding: 50px 0;\n\n    .title-list {\n      font-weight: 700;\n      font-size: 24px;\n      line-height: 35px;\n      color: $black;\n    }\n\n    .myPage-list {\n      gap: 32px;\n      width: 100%;\n\n      &-item {\n        width: 40%;\n        height: 162px;\n        background: #fff7f2;\n        border: 4px solid #ffe6d6;\n        border-radius: 4px;\n        gap: 10px;\n        font-weight: 700;\n        font-size: 16px;\n        line-height: 24px;\n        letter-spacing: 0.25px;\n        color: $black;\n        cursor: pointer;\n        text-align: center;\n      }\n    }\n\n    .list-collapse {\n      &-item {\n        margin: 15px 0;\n\n        .collapse-inner {\n          max-width: 100%;\n          width: 775px;\n        }\n\n        .collapse-wrapper {\n          margin-left: 32px;\n          margin-right: 32px;\n        }\n\n        .title-collapse {\n          font-weight: 700;\n          font-size: 24px;\n          line-height: 35px;\n          color: $black;\n          padding: 9px 0px 9px 12px;\n          gap: 12px;\n          height: 53px;\n          border-bottom: 4px solid #ffac7d;\n          cursor: pointer;\n        }\n\n        .content-collapse {\n          margin-top: 32px;\n          margin-bottom: 24px;\n          width: 775px;\n          background: $white;\n          border: 4px solid #ffac7d;\n          border-radius: 4px;\n\n          &-top {\n            padding: 20px;\n            gap: 24px;\n            border-bottom: 1px solid #ffac7d;\n\n            .office-item {\n              border-bottom: 1px dashed #FFAC7D;\n              padding: 0.5rem 0;\n            }\n            .office-item:last-child {\n              border-bottom: none;\n            }\n\n            .title {\n              font-weight: 700;\n              font-size: 16px;\n              line-height: 24px;\n              letter-spacing: 0.25px;\n              color: $orange;\n            }\n\n            .text-icon {\n              font-weight: 400;\n              font-size: 16px;\n              line-height: 24px;\n              letter-spacing: 0.25px;\n              color: $black;\n              gap: 6px;\n            }\n\n            .text-normal {\n              font-weight: 400;\n              font-size: 14px;\n              line-height: 20px;\n              letter-spacing: 0.25px;\n              color: $black;\n              margin-left: 24px;\n            }\n\n            .title-right {\n              a {\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 20px;\n                letter-spacing: 0.25px;\n                text-decoration-line: underline;\n                color: $orange;\n                margin-left: 24px;\n              }\n            }\n\n            .title-item-list {\n              border-bottom: '1px dashed #FFAC7D';\n              &:last-child {\n                border: none;\n              }\n            }\n          }\n\n          &-bottom {\n            padding: 32px;\n            gap: 24px;\n            height: 50%;\n\n            .text-note {\n              font-weight: 400;\n              font-size: 16px;\n              line-height: 24px;\n              text-align: center;\n              letter-spacing: 0.25px;\n              color: $black;\n            }\n\n            .link-url {\n              width: 100%;\n              background: #fff7f2;\n              border: 1px solid #ffac7d;\n              border-radius: 4px;\n              padding: 12px;\n              gap: 10px;\n              position: relative;\n              font-weight: 500;\n              font-size: 16px;\n              line-height: 24px;\n              text-align: center;\n              letter-spacing: 0.25px;\n              color: #f8601b;\n\n              .icon {\n                position: absolute;\n                left: 10px;\n                top: 50%;\n                transform: translateY(-50%);\n              }\n            }\n          }\n        }\n\n        .collapse-empty {\n          margin-top: 32px;\n        }\n\n        .data-collapse {\n          margin-top: 32px;\n          margin-bottom: 24px;\n          // gap: 10px;\n          width: 775px;\n\n          &-item {\n            font-weight: 400;\n            font-size: 16px;\n            line-height: 24px;\n            letter-spacing: 0.25px;\n            color: $black;\n            border-bottom: 1px solid #ecedef;\n            border-left: 1px solid #ecedef;\n            border-right: 1px solid #ecedef;\n          }\n\n          &-item:last-child {\n            border-bottom: unset;\n          }\n\n          &-item:first-child {\n            border-top: 1px solid #ecedef;\n          }\n\n          &-note {\n            background: #fff7f2;\n            border-left: 4px solid #f8601b;\n            padding: 12px;\n            gap: 10px;\n            font-size: 16px;\n            line-height: 24px;\n            font-weight: 700;\n            letter-spacing: 0.25px;\n\n            .icon {\n              margin-right: 4px;\n              vertical-align: middle;\n            }\n\n            a {\n              text-decoration-line: underline;\n              color: #f8601b;\n            }\n          }\n\n          table {\n            th {\n              padding: 10px 16px;\n            }\n            tbody td {\n              padding: 10px 16px;\n              font-size: 16px;\n              line-height: 24px;\n            }\n          }\n        }\n\n        .table-collapse {\n          margin-top: 40px;\n          display: flex;\n          width: 100%;\n          justify-content: center;\n          gap: 20px;\n          flex-wrap: wrap;\n\n          &-header {\n            background: #f5f5f5;\n            padding: 8px;\n            gap: 10px;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 20px;\n            letter-spacing: 0.25px;\n            color: $black;\n            border-bottom: 1px solid #bcbfc4;\n          }\n\n          &-main {\n            padding: 6px 8px;\n            gap: 10px;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 20px;\n            letter-spacing: 0.25px;\n            color: $black;\n          }\n\n          .table-collapse-item {\n            width: 30%;\n          }\n        }\n      }\n    }\n\n    .form-title {\n      font-weight: 700;\n      font-size: 24px;\n      line-height: 34px;\n      letter-spacing: 0.25px;\n      color: $black;\n    }\n\n    .form-content {\n      padding: 0px;\n      gap: 32px;\n      width: 774px;\n    }\n\n    .formInput-content {\n      padding: 0px;\n      gap: 32px;\n      width: 506px;\n    }\n\n    .icon-eye {\n      top: 66%;\n      transform: translateY(-50%);\n      right: 20px;\n      cursor: pointer;\n    }\n\n    .success {\n      border-color: #358b43;\n      color: #358b43;\n      font-weight: 500;\n      font-size: 16px;\n      line-height: 24px;\n    }\n\n    // .error {\n    //   border-color: red;\n    //   color: red;\n    //   font-weight: 500;\n    //   font-size: 16px;\n    //   line-height: 24px;\n    // }\n\n    .formSwitch {\n      padding: 44px;\n      gap: 10px;\n      width: 774px;\n      border: 2px solid #bcbfc4;\n      border-radius: 4px;\n\n      &-left {\n        font-weight: 700;\n        font-size: 18px;\n        line-height: 26px;\n        letter-spacing: 0.25px;\n        color: $black;\n      }\n\n      &-right {\n        .form-check-input {\n          width: 48px;\n          height: 25px;\n          cursor: pointer;\n          -webkit-appearance: none !important;\n          background-image: url('../assets/images/switch-circle.svg') !important;\n          background-color: $switch;\n          background-size: 20.5px;\n          background-position: 1px center;\n        }\n\n        .form-check-input:checked {\n          background-color: #f8601b;\n          border-color: #f8601b;\n          background-position: 24px center !important;\n        }\n      }\n    }\n\n    .form-message {\n      gap: 16px;\n      width: 774px;\n      // height: 48px;\n      border-width: 1px 0px;\n      background: #fbfcfb;\n      padding: 12px 18px;\n      border-width: 1px 0px;\n      border-style: dashed;\n    }\n  }\n\n  .inspection-date {\n    background-color: #FFF7F2;\n    border: 1px solid #FFE7E6;\n    border-radius: 4px;\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n  }\n}\n\n.modal-confirm {\n  height: 208px;\n  padding: 30px;\n  gap: 10px;\n\n  &-header {\n    letter-spacing: 0.25px;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    color: $black;\n  }\n\n  &-button {\n    margin-top: 20px;\n    padding: 0px;\n    gap: 24px;\n\n    button {\n      padding: 14px 24px;\n      gap: 10px;\n      border: unset;\n      height: 52px;\n      width: 245px;\n      border-radius: 4px;\n      font-weight: 700;\n      font-size: 16px;\n      line-height: 24px;\n      text-align: center;\n      letter-spacing: 0.25px;\n    }\n\n    .btn-cancel {\n      background: #fff7f2;\n      color: $orange;\n    }\n\n    .btn-logout {\n      background: $orange;\n      color: $white;\n    }\n  }\n}\n\n.inquiryForm {\n  .modal-content {\n    border-radius: 4px 4px 0px 0px !important;\n  }\n\n  &-header {\n    border-top: 4px solid #f8601b;\n    height: 62px;\n    padding: 0 20px;\n\n    &-text {\n      font-weight: 700;\n      font-size: 20px;\n      line-height: 28px;\n      letter-spacing: 0.25px;\n      color: #f8601b;\n    }\n  }\n\n  &-main {\n    background: #f5f5f5;\n    padding: 32px 36px;\n    gap: 10px;\n\n    &-title {\n      font-weight: 700;\n      font-size: 18px;\n      line-height: 26px;\n      letter-spacing: 0.25px;\n      color: $black;\n    }\n\n    &-content {\n      padding: 26px 32px;\n      gap: 10px;\n      background: #ffffff;\n      border-radius: 4px;\n\n      .content-title {\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        letter-spacing: 0.25px;\n        color: $black;\n      }\n\n      .content-main {\n        font-weight: 700;\n        font-size: 16px;\n        line-height: 24px;\n        color: $black;\n      }\n    }\n  }\n}\n\n.inquiryForm-success {\n  .modal-content {\n    border-radius: 4px !important;\n    padding: 16px 24px 24px;\n    gap: 10px;\n  }\n\n  .btn-close {\n    position: absolute;\n    top: 21px;\n    right: 18px;\n    cursor: pointer;\n  }\n\n  .btn-thanks {\n    margin-top: 40px;\n    position: relative;\n\n    .arrow-up {\n      position: absolute;\n      width: 0;\n      height: 0;\n      border-left: 20px solid transparent;\n      border-right: 20px solid transparent;\n      top: -20px;\n      left: 50%;\n      transform: translateX(-50%);\n\n      border-bottom: 20px solid #f8601b;\n    }\n\n    button {\n      height: 59px;\n      background: #f8601b;\n      box-shadow: 0px 6px 0px #d8bfb7;\n      border-radius: 30px;\n      padding: 12px 32px;\n      gap: 10px;\n      font-weight: 700;\n      font-size: 24px;\n      line-height: 35px;\n      color: $white;\n      border: unset;\n    }\n  }\n\n  .text-note {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: 0.25px;\n    color: $black;\n  }\n}\n\n.resetPassword-modal {\n  .modal-content {\n    border-radius: 4px !important;\n  }\n\n  .resetPassword-modal-content {\n    padding: 40px;\n    gap: 10px;\n  }\n\n  &-title {\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: 0.25px;\n    color: $black;\n  }\n\n  .btn-bg-white {\n    padding: 14px 24px;\n    gap: 10px;\n    height: 52px;\n    background: #fff7f2;\n    border-radius: 4px;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: 0.25px;\n    color: #f8601b;\n    border: unset;\n    width: calc(50% - 10px);\n  }\n\n  .btn-orange {\n    width: calc(50% - 10px);\n  }\n}\n\n.modal-confirm-logout {\n  .modal-content {\n    border-radius: 4px !important;\n    gap: 10px;\n  }\n}\n\n.profile-setting-item {\n  width: 100%;\n  height: 162px;\n  background: #fff7f2;\n  border: 4px solid #ffe6d6;\n  border-radius: 4px;\n  gap: 10px;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0.25px;\n  color: $black;\n  cursor: pointer;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.formSwitch {\n  gap: 10px;\n  border: 2px solid #bcbfc4;\n  border-radius: 4px;\n  width: 100%;\n\n  &-left {\n    font-weight: 700;\n    color: $black;\n  }\n\n  &-right {\n    .form-check-input {\n      width: 48px;\n      height: 25px;\n      cursor: pointer;\n      -webkit-appearance: none !important;\n      background-image: url('../assets/images/switch-circle.svg') !important;\n      background-color: $switch;\n      background-size: 20.5px;\n      background-position: 1px center;\n    }\n\n    .form-check-input:checked {\n      background-color: #f8601b;\n      border-color: #f8601b;\n      background-position: 24px center !important;\n    }\n  }\n}\n\n.modal-success {\n  .modal-dialog {\n    max-width: 618px;\n    width: 100%;\n  }\n\n  .modal-content {\n    padding: 28px 38px;\n  }\n\n  &__content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    &-title {\n      color: $orange;\n      font-size: 18px;\n      font-weight: 700;\n      line-height: 26px;\n      letter-spacing: 0.25px;\n      margin-top: 32px;\n      margin-bottom: 0;\n    }\n\n    &-sub-title {\n      display: block;\n      font-size: 14px;\n      line-height: 28px;\n      letter-spacing: 0.25px;\n      margin-top: 16px;\n    }\n\n    &-line {\n      width: 46px;\n      height: 0;\n      border: 1px solid #6C757D;\n      display: inline-block;\n      margin-top: 28px;\n    }\n\n    &-txt-email {\n      font-size: 14px;\n      line-height: 20px;\n      letter-spacing: 0.25px;\n      color: #333333;\n      margin-top: 12px;\n    }\n  }\n\n  &__btn {\n    width: 100%;\n  }\n}\n\n@media screen and (min-width: 900px) {\n  .contract-icon{\n    width: 24px;\n    height: 31px;\n    position: relative;\n    bottom: 6px;\n  }\n  \n  .inquiry-form {\n    width: 650px;\n  }\n\n  .confirmContract {\n    &-left {\n      width: 640px;\n\n      hr {\n        width: 100%;\n      }\n    }\n  }\n\n  .formSwitch {\n    padding: 2em;\n    gap: 10px;\n    border: 2px solid #bcbfc4;\n    border-radius: 4px;\n    width: 100%;\n\n    &-left {\n      font-weight: 700;\n      font-size: 18px;\n      line-height: 26px;\n      letter-spacing: 0.25px;\n    }\n\n    &-right {\n      .form-check-input {\n        width: 48px;\n        height: 25px;\n        -webkit-appearance: none !important;\n        background-image: url('../assets/images/switch-circle.svg') !important;\n        background-color: $switch;\n        background-size: 20.5px;\n        background-position: 1px center;\n      }\n    }\n\n    &-container {\n      width: 50%;\n    }\n  }\n\n  .profile-setting {\n    min-width: 500px;\n\n    &-item {\n      margin-bottom: 32px;\n    }\n  }\n\n  .myPage-container {\n    min-height: 100%;\n\n    &-header {\n      font-size: 16px;\n      line-height: 24px;\n      justify-content: center;\n      height: 64px;\n    }\n\n    &-main {\n      min-height: calc(100vh - 326px);\n      padding: 24px 12px;\n      gap: 24px;\n\n      .title-list {\n        font-size: 18px;\n        letter-spacing: 0.25px;\n      }\n\n      .myPage-list {\n        width: 80%;\n        gap: 24px;\n\n        &-item {\n          width: 40%;\n          height: 120px;\n          font-size: 16px;\n          line-height: 24px;\n          font-weight: 700;\n\n          img {\n            width: 45px;\n            height: 45px;\n          }\n        }\n      }\n\n      .list-collapse {\n        &-item {\n          .title-collapse {\n            padding: 0;\n            font-size: 24px;\n            line-height: 34.75px;\n            letter-spacing: 0.25px;\n          }\n\n          .content-collapse {\n            width: 100% !important;\n            height: 100% !important;\n            border: 4px solid #ffac7d;\n\n            &-top {\n              flex-direction: column !important;\n              padding: 10px;\n              gap: 15px;\n\n              .info-text {\n                width: 100% !important;\n              }\n            }\n\n            &-bottom {\n              padding: 34px;\n              gap: 10px;\n\n              .link-url {\n                font-size: 16px;\n                line-height: 24px;\n              }\n            }\n          }\n\n          .data-collapse {\n            width: 100%;\n\n            &-item {\n              font-weight: 500;\n              font-size: 14px;\n              line-height: 22px;\n              letter-spacing: 0.25px;\n              padding: 5px 0;\n            }\n          }\n        }\n      }\n\n      .form-title {\n        font-size: 18px;\n        line-height: 26px;\n        letter-spacing: 0.25px;\n      }\n\n      .form-content {\n        gap: 22px;\n        width: 100%;\n      }\n\n      .formInput-content {\n        gap: 22px;\n        // width: 100%;\n      }\n\n      .confirmContract {\n        padding: 16px 12px 20px;\n        gap: 10px;\n\n        &-title {\n          font-size: 18px;\n          line-height: 26px;\n        }\n        \n        &-left {\n          // width: 100%;\n          margin-top: 20px;\n\n          &-main {\n            padding: 16px 12px;\n            width: 100%;\n            margin-top: 20px;\n          }\n        }\n\n        &-right {\n          // width: 100%;\n\n          &-main {\n            padding: 16px 12px;\n          }\n\n          &-top {\n            margin-top: 25px;\n          }\n        }\n        \n      }\n\n      .formSwitch {\n        width: 100%;\n        padding: 24px 12px;\n        gap: 10px;\n\n        &-left {\n          font-weight: 700;\n          font-size: 16px;\n          line-height: 24px;\n          letter-spacing: 0.25px;\n          color: $black;\n        }\n      }\n\n      .form-message {\n        width: 100%;\n      }\n    }\n  }\n\n  .inspection-date {\n    padding: 12px 32px;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n  }\n\n  .changeID {\n    .modal-dialog {\n      width: 618px !important;\n    }\n\n    .modal-content {\n      border-radius: 4px !important;\n      padding: 25px 46px;\n      gap: 10px;\n    }\n\n    &-icon-close {\n      width: 14px;\n      height: 14px;\n      align-self: end;\n      cursor: pointer;\n    }\n\n    &-text {\n      color: $black;\n      text-align: center;\n      font-size: 14px;\n\n      &.title {\n        font-size: 24px;\n        font-weight: 700;\n      }\n\n      &.content {\n        font-weight: 500;\n      }\n    }\n\n    &-btn {\n      margin-top: 30px;\n    }\n\n    &-line {\n      background: #f8601b;\n      height: 1px;\n      width: 162px;\n      align-self: center;\n      margin-top: 5px;\n      margin-bottom: 20px;\n    }\n  }\n}\n\n@media screen and (max-width: 899px) {\n  .inquiryForm-success{\n    .text-note {\n      font-size: 14px;\n      line-height: 20px;\n    }\n  }\n\n  .form-qa-not-login{\n    .text-link{\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n    }\n  }\n\n  .contract-icon{\n    width: 20px;\n    height: 26px;\n    position: relative;\n    bottom: 4px;\n  }\n\n  .inquiry-form {\n    width: 100%;\n  }\n\n  hr {\n    width: 100%;\n  }\n\n  .confirmContract {\n    &-left {\n      width: 100%;\n\n      &-main {\n        padding: 12px;\n      }\n    }\n\n    &-right {\n      width: 100%;\n\n      &-main {\n        width: 100%;\n        padding: 12px 0;\n        gap: 10px;\n      }\n\n    }\n  }\n\n  .formSwitch {\n    width: 100%;\n    padding: 24px 12px;\n    gap: 10px;\n\n    &-left {\n      font-weight: 700;\n      font-size: 16px;\n      line-height: 24px;\n      letter-spacing: 0.25px;\n      color: $black;\n    }\n\n    &-container {\n      width: 100%;\n    }\n  }\n\n  .form-message {\n    width: 100%;\n  }\n\n\n  .myPage-container-main {\n    .success {\n      font-size: 14px;\n      line-height: 22px;\n    }\n  }\n\n  .modal-confirm {\n    height: 134px;\n    gap: 0px;\n\n    &-header {\n      font-size: 14px !important;\n      color: #464646;\n    }\n\n    &-button {\n      button {\n        height: 40px;\n        font-size: 14px !important;\n      }\n    }\n  }\n\n  .profile-setting {\n    width: 100%;\n\n    &-item {\n      margin-bottom: 12px;\n    }\n  }\n\n  .myPage-container {\n    min-height: 100%;\n\n    &-header {\n      font-size: 16px;\n      line-height: 24px;\n      justify-content: center;\n      // height: 64px;\n      flex-direction: column !important;\n      padding: 5px 24px;\n\n      .contract {\n        justify-content: space-between;\n        width: 100%;\n\n        &-name {\n          font-size: 12px;\n          line-height: 18px;\n        }\n\n        &-number {\n          font-size: 12px;\n        }\n      }\n    }\n\n    &-main {\n      padding: 24px 12px;\n      gap: 10px;\n\n      .title-list {\n        font-size: 16px;\n        letter-spacing: 0.25px;\n      }\n\n      .myPage-list {\n        width: 100%;\n        gap: 10px;\n\n        &-item {\n          width: 50%;\n          height: 81px;\n          font-size: 10px;\n          line-height: 18px;\n\n          img {\n            width: 32px;\n            height: 32px;\n          }\n        }\n      }\n\n      .list-collapse {\n        &-item {\n          .title-collapse {\n            padding: unset;\n            font-size: 18px;\n            line-height: 26px;\n            letter-spacing: 0.25px;\n          }\n\n          .collapse-wrapper {\n            margin-right: calc(-0.5 * var(--cui-gutter-x));\n            margin-left: calc(-0.5 * var(--cui-gutter-x));\n          }\n\n          .content-collapse {\n            width: 100% !important;\n            height: 100% !important;\n            border: 2px solid #ffac7d;\n\n            &-top {\n              flex-direction: column !important;\n              padding: 10px;\n              gap: 15px;\n\n              .text-icon {\n                font-size: 14px;\n              }\n\n              .info-text {\n                width: 100% !important;\n              }\n            }\n\n            &-bottom {\n              padding: 14px;\n              gap: 12px;\n\n              .text-note {\n                font-size: 12px;\n                line-height: 20px;\n              }\n\n              .link-url {\n                align-items: flex-start !important;\n                font-size: 14px;\n                line-height: 22px;\n                word-break: break-all;\n                white-space: pre-line;\n\n                .icon {\n                  position: relative;\n                  top: 4px;\n                  left: 0;\n                  transform: unset;\n                }\n              }\n            }\n          }\n\n          .collapse {\n            width: 100%;\n          }\n\n          .data-collapse {\n            width: 100%;\n\n            &-note {\n              font-size: 14px;\n              line-height: 20px;\n            }\n\n            &-item {\n              font-weight: 500;\n              font-size: 14px;\n              line-height: 22px;\n              letter-spacing: 0.25px;\n              padding: 5px 0;\n            }\n\n            table {\n              th {\n                padding: 12px;\n              }\n              tbody td {\n                font-size: 12px;\n                line-height: 18px;\n                padding: 12px;\n              }\n            }\n          }\n\n          .table-collapse {\n            width: 100%;\n            display: flex;\n            justify-content: center;\n            flex-direction: column;\n            align-items: center;\n\n            &-main {\n              font-size: 12px;\n              line-height: 16px;\n            }\n\n            .table-collapse-item{\n              width: 100%;\n            }\n          }\n        }\n      }\n\n      .form-title {\n        font-size: 18px;\n        line-height: 26px;\n        letter-spacing: 0.25px;\n      }\n\n      .form-content {\n        gap: 22px;\n        width: 100%;\n      }\n\n      .formInput-content {\n        gap: 22px;\n        width: 100%;\n      }\n\n      .confirmContract {\n        padding: 16px 12px 20px;\n\n        &-title {\n          font-size: 18px;\n          line-height: 26px;\n        }\n\n        &-left {\n          width: 100%;\n          margin-top: 20px;\n\n          &-main {\n            padding: 16px 12px;\n            margin-top: 20px;\n            width: 100%;\n          }\n        }\n\n        &-right {\n          width: 100%;\n\n          &-main {\n            padding: 16px 12px;\n          }\n\n          &-top {\n            margin-top: 25px;\n          }\n        }\n      }\n\n      .title-item-list {\n        flex-direction: column !important;\n      }\n\n      .title-item {\n        width: 100% !important;\n      }\n    }\n  }\n\n  .inquiryForm {\n    &-header {\n      &-text {\n        font-size: 16px;\n        line-height: 24px;\n      }\n    }\n  }\n\n  .inspection-date {\n    padding: 12px 12px;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 22px;\n  }\n\n  .changeID {\n    .modal-content {\n      border-radius: 4px !important;\n      padding: 20px 10px;\n      gap: 5px;\n    }\n\n    &-icon-close {\n      width: 14px;\n      height: 14px;\n      align-self: end;\n      cursor: pointer;\n      margin-bottom: 10px;\n      margin-left: auto;\n    }\n\n    &-input {\n      height: 40px;\n      font-size: 14px;\n    }\n\n    &-text {\n      color: $black;\n      text-align: center;\n      font-size: 12px;\n\n      &.title {\n        font-size: 18px;\n        font-weight: 700;\n      }\n\n      &.content {\n        white-space: break-spaces;\n        font-weight: 500;\n      }\n    }\n\n    &-btn {\n      margin-top: 25px;\n    }\n\n    &-line {\n      background: #f8601b;\n      height: 1px;\n      width: 75px;\n      align-self: center;\n      margin-top: 5px;\n      margin-bottom: 10px;\n    }\n  }\n\n  .modal-success {\n    .modal-dialog {\n      width: auto;\n    }\n\n    .modal-content {\n      padding: 20px 12px;\n    }\n\n    &__content {\n      &-title {\n        font-size: 14px;\n        font-weight: 700;\n        line-height: 20px;\n      }\n\n      &-sub-title {\n        font-size: 12px;\n        line-height: 16px;\n      }\n\n      &-line {\n        width: 36px;\n      }\n\n      &-txt-email {\n        font-size: 12px;\n        line-height: 16px;\n      }\n    }\n  }\n  .formSwitch {\n    &-right {\n      .form-check-input {\n        width: 48px;\n        height: 25px;\n        cursor: pointer;\n        -webkit-appearance: none !important;\n        background-image: url('../assets/images/switch-circle.svg') !important;\n        background-color: $switch;\n        background-size: 21px;\n        background-position: 1px center;\n      }\n\n      .form-check-input:checked {\n        background-color: #f8601b;\n        border-color: #f8601b;\n        background-position: 24px center !important;\n      }\n    }\n  }\n}\n",".sendMail {\n  width: 618px;\n  padding: 72px 68px;\n  gap: 10px;\n  background: $white;\n  border-top: 4px solid $orange;\n  box-shadow: 0px 4px 18px #fbd7b6;\n  border-radius: 4px;\n\n  &-title {\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 34px;\n    letter-spacing: 0.25px;\n    color: $black;\n  }\n\n  &-message {\n    gap: 40px;\n    width: 482px;\n    height: 48px;\n    border-width: 1px 0px;\n    background: #fbfcfb;\n    padding: 12px 18px;\n    border-width: 1px 0px;\n    border-style: dashed;\n  }\n\n  .success {\n    border-color: #358b43;\n    color: #358b43;\n    font-weight: 500;\n    line-height: 24px;\n  }\n\n  hr {\n    width: 50px;\n  }\n\n  &-note {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    letter-spacing: 0.25px;\n    color: #333333;\n  }\n}\n\n.link-terms-of-use {\n  padding: 8px 12px;\n  gap: 10px;\n  background: #FFF7F2;\n  border-left: 2px solid #F8601B;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n\n  a {\n    text-decoration: underline;\n    color: $orange;\n    position: relative;\n    left: 5px;\n\n    .navigate-text {\n      margin-left: 10px;\n    }\n  }\n}\n\n.error {\n  gap: 10px;\n  width: 100%;\n  height: auto;\n  border-width: 1px 0px;\n  background: #ffe7e6;\n  padding: 12px 17px;\n  border-width: 1px 0px;\n  border-style: dashed;\n  color: #ff0f00;\n  font-size: 16px;\n}\n\n.click-link {\n  font-size: 16px;\n  line-height: 24px;\n  gap: 8px;\n\n  a {\n    text-decoration-line: underline !important;\n    color: #f8601b !important;\n  }\n}\n\n.auth-container {\n  padding: 72px 68px;\n  gap: 10px;\n  width: 618px;\n  background: $white;\n  border-top: 4px solid #f8601b;\n  box-shadow: 0px 4px 18px #fbd7b6;\n  border-radius: 4px;\n\n  &-title {\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 34px;\n    letter-spacing: 0.25px;\n    color: $black;\n  }\n\n  &-titleMore {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 22px;\n    text-align: center;\n    letter-spacing: 0.25px;\n    color: $black;\n\n    hr {\n      width: 160px;\n      border-top: 2px solid #f8601b;\n    }\n  }\n\n  &-form {\n    .icon-eye {\n      top: 66%;\n      transform: translateY(-50%);\n      right: 20px;\n      cursor: pointer;\n    }\n\n    .remember-password {\n      padding: 0px;\n      gap: 8px;\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 20px;\n      letter-spacing: 0.25px;\n      color: $black;\n      margin-top: 8px;\n\n      .form-check-input {\n        -webkit-appearance: none !important;\n        cursor: pointer;\n      }\n\n      .form-check-input:checked {\n        background-color: #f8601b;\n        border-color: #f8601b;\n      }\n    }\n\n    .form-btn-my {\n      margin-top: 40px;\n      margin-bottom: 32px;\n    }\n\n    .text-special {\n      color: #6C757D;\n      height: 22px;\n      position: relative;\n      width: 162px;\n      margin: 20px 0;\n\n      &-content {\n        left: 50%;\n        position: absolute;\n        background: #fff;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 20px;\n        padding: 0 10px;\n        white-space: nowrap;\n        width: fit-content;\n        z-index: 1;\n        top: 50%;\n        transform: translate(-50%, -50%);\n      }\n\n      &-line {\n        background: #6c757d;\n        height: 1px;\n        width: 100%;\n        z-index: 0;\n        left: 50%;\n        position: absolute;\n        top: 50%;\n        transform: translate(-50%, -50%);\n      }\n    }\n\n    .noti-special {\n      padding: 12px;\n      gap: 10px;\n      width: 100%;\n      background: #fff7f2;\n\n      &-title {\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        letter-spacing: 0.25px;\n        color: #f8601b;\n        gap: 6px;\n      }\n\n      &-text {\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 16px;\n        letter-spacing: 0.25px;\n        color: $black;\n      }\n\n      &-time {\n        font-size: 12px;\n      }\n    }\n\n    .redirect-login {\n      padding: 12px;\n      gap: 10px;\n      width: 100%;\n      background: #fff7f2;\n      border-top: 1px solid #ffac7d;\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 24px;\n      letter-spacing: 0.25px;\n      color: #333333;\n      text-align: center;\n\n      a {\n        text-decoration-line: underline;\n        color: #f8601b;\n      }\n    }\n\n    .term {\n      margin-top: 20px;\n      padding: 12px 16px;\n      gap: 10px;\n      background: #fff7f2;\n      border-width: 1px 0px;\n      border-style: solid;\n      border-color: #ffac7d;\n\n      &-top {\n        gap: 10px;\n\n        a {\n          font-weight: 700;\n          font-size: 16px;\n          line-height: 24px;\n          letter-spacing: 0.25px;\n          text-decoration-line: underline;\n          color: #f8601b;\n        }\n      }\n\n      &-bottom {\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        letter-spacing: 0.25px;\n        color: $black;\n      }\n    }\n\n    .line-auth {\n      width: 50px;\n      border-top: 2px solid #bcbfc3;\n      margin-top: 20px;\n    }\n\n    .text-black {\n      font-weight: 500;\n      line-height: 24px;\n      letter-spacing: 0.25px;\n      color: #463529;\n    }\n  }\n}\n\n.container-verify {\n  width: 618px;\n  background: $white;\n  filter: drop-shadow(0px 4px 18px #fbd7b6);\n\n  &-header {\n    border-bottom: 1px dashed $orange;\n    border-radius: 4px 4px 0 0;\n    height: 82px;\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 28px;\n    color: $orange;\n    padding: 0 24px;\n    width: 100%;\n  }\n\n  &-table {\n    width: 100%;\n    padding: 32px 14px;\n    gap: 10px;\n    background: #fff7f2;\n\n    .main-title {\n      font-weight: 700;\n      font-size: 24px;\n      line-height: 34px;\n      letter-spacing: 0.25px;\n      color: $black;\n      margin-bottom: 30px;\n    }\n\n    .main-table {\n      padding: 15px 25px;\n      gap: 10px;\n      width: 90%;\n      border: 2px solid #ffac7d;\n      border-radius: 4px;\n\n      &-item {\n        gap: 20px;\n        padding: 10px 0;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n        letter-spacing: 0.25px;\n        color: $black;\n      }\n\n      &-item:nth-child(2) {\n        border-color: #bcbfc3;\n        border-width: 1px 0px;\n        border-style: solid;\n        padding: 10px 0;\n      }\n    }\n  }\n\n  &-slide {\n    width: 100%;\n    padding: 32px;\n    gap: 10px;\n    background: #ecf0eb;\n\n    .main-title {\n      font-weight: 700;\n      font-size: 24px;\n      line-height: 34px;\n      letter-spacing: 0.25px;\n      color: $black;\n      margin-bottom: 30px;\n    }\n\n    .main-table {\n      padding: 15px 25px;\n      gap: 10px;\n      width: 100% !important;\n      background: white;\n      border: 2px solid #4eae5d;\n      border-radius: 4px;\n\n      &-item {\n        gap: 20px;\n        padding: 10px 0;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n        letter-spacing: 0.25px;\n        color: $black;\n      }\n\n      &-item:nth-child(2) {\n        border-color: #bcbfc3;\n        border-width: 1px 0px;\n        border-style: solid;\n        padding: 10px 0;\n      }\n    }\n  }\n\n  &-main {\n    padding: 32px;\n    gap: 10px;\n\n    .main-left {\n      width: 100%;\n      gap: 32px;\n\n      &-title {\n        font-weight: 700;\n        font-size: 24px;\n        line-height: 34px;\n        letter-spacing: 0.25px;\n        color: $black;\n      }\n\n      &-table {\n        padding: 15px 25px;\n        gap: 10px;\n        width: 100%;\n        border: 2px solid #ffac7d;\n        border-radius: 4px;\n        background: white;\n\n        &-item {\n          gap: 20px;\n          padding: 10px 0;\n          font-weight: 400;\n          font-size: 16px;\n          line-height: 24px;\n          letter-spacing: 0.25px;\n          color: $black;\n\n          .font-500 {\n            font-weight: 500;\n          }\n        }\n\n        &-item:nth-child(2) {\n          border-color: #bcbfc3;\n          border-width: 1px 0px;\n          border-style: solid;\n          padding: 10px 0;\n        }\n      }\n    }\n\n    .main-right {\n      width: 90%;\n      margin-top: 50px;\n\n      &-title {\n        font-weight: 700;\n        font-size: 24px;\n        line-height: 34px;\n        letter-spacing: 0.25px;\n        color: $black;\n      }\n\n      &-description {\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 20px;\n        text-align: center;\n        letter-spacing: 0.25px;\n        color: $black;\n      }\n\n      hr {\n        width: 160px;\n        border-top: 2px solid #f8601b;\n      }\n\n      &-form {\n        gap: 10px;\n\n        .icon-eye {\n          top: 66%;\n          transform: translateY(-50%);\n          right: 20px;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n}\n\n.modal-register {\n  .text-brown {\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: 0.25px;\n    color: $black;\n    margin-bottom: 4px;\n    width: 100%;\n    text-align: center;\n  }\n\n  .modal-content {\n    border-radius: 4px 4px 0px 0px !important;\n  }\n\n  &-main {\n    padding: 16px 12px;\n    gap: 10px;\n    background: #ffffff;\n    border-radius: 4px;\n\n    .content {\n      img {\n        width: 300px;\n      }\n\n      &-text {\n        padding: 20px 0px;\n\n        .text-orange {\n          font-weight: 700;\n          font-size: 24px;\n          line-height: 34px;\n          letter-spacing: 0.25px;\n          color: #f8601b;\n          margin: 21px 0;\n        }\n      }\n    }\n  }\n}\n\n.custom-width {\n  width: auto;\n}\n\n.modal-slider {\n  width: 100%;\n  height: 100%;\n  padding: 40px;\n  align-items: center;\n\n  .slick-dots li button:before {\n    font-size: 8px !important;\n  }\n\n  .slick-dots li.slick-active button:before {\n    color: #000000 !important;\n  }\n\n  .custom-arrow:before {\n    color: #3ABCEA !important;\n    position: absolute;\n    transform: scale(1.3);\n  }\n\n  .title {\n    font-size: 1.1rem;\n    color: #3ABCEA;\n    font-weight: bold;\n  }\n\n  .content {\n    color: #FFFFFF;\n    background-color: #3ABCEA;\n    border-radius: 40%/250%;\n    padding: 0 5px;\n    line-height: 26px;\n  }\n\n  .red {\n    color: red;\n  }\n\n  .image {\n    max-width: 80%;\n    margin: auto;\n    margin-bottom: 20px;\n  }\n\n  .icon-close {\n    position: absolute;\n    cursor: pointer;\n    top: 40px;\n    right: 25px;\n    width: 25px;\n    height: 25px;\n  }\n}\n\n@media screen and (max-width: 899px) {\n  .container-verify-slide {\n    .main-table {\n      padding: 15px 25px;\n      gap: 10px;\n\n      &-item {\n        gap: 20px;\n        padding: 10px 0;\n        font-size: 14px;\n        line-height: 20px;\n      }\n    }\n  }\n\n  .error{\n    font-size: 14px;\n  }\n\n  .sendMail {\n    .success {\n      line-height: 22px;\n    }\n  }\n\n  .modal-register {\n    .text-brown {\n      line-height: 16px;\n    }\n  }\n\n  .main-left {\n    padding: 0 30px;\n  }\n\n  .container-verify {\n    &-main {\n      padding: 32px 2px;\n    }\n  }\n\n  .custom-width {\n    width: 100%;\n  }\n\n  .sendMail {\n    width: 60%;\n    padding: 32px 18px;\n\n    &-title {\n      font-size: 18px;\n    }\n\n    &-message {\n      width: 100%;\n    }\n  }\n\n  .auth-container {\n    width: 80%;\n    padding: 36px 18px;\n    gap: 10px;\n\n    &-title {\n      font-size: 18px;\n      line-height: 26px;\n    }\n\n    .error {\n      width: 100%;\n    }\n  }\n\n  .container-verify {\n    // width: 80%;\n\n    &-header {\n      height: 64px;\n      font-size: 16px;\n      line-height: 20px;\n    }\n\n    &-main {\n      // padding: 24px 18px;\n\n      .main-left {\n        &-title {\n          font-size: 18px;\n          line-height: 26px;\n        }\n\n        &-table {\n          // padding: 10px;\n\n          &-item {\n            padding: 10px 0;\n            font-size: 14px;\n            line-height: 20px;\n          }\n\n          &-item:nth-child(2) {\n            padding: 10px 0;\n          }\n        }\n      }\n\n      .main-right {\n        &-title {\n          font-size: 18px;\n          line-height: 26px;\n        }\n\n        &-description {\n          font-size: 12px;\n          line-height: 18px;\n        }\n      }\n    }\n\n    &-slide {\n      .main-title {\n        font-size: 18px;\n        line-height: 26px;\n      }\n    }\n\n    &-table {\n      .main-title {\n        font-size: 18px;\n        line-height: 26px;\n      }\n    }\n  }\n\n  .custom-width {\n    width: auto;\n  }\n\n  .modal-slider {\n    width: 100%;\n    height: 100%;\n    padding: 40px;\n    padding-top: 20px;\n    align-items: center;\n\n    .slick-dots li button:before {\n      font-size: 8px !important;\n    }\n\n    .slick-dots li.slick-active button:before {\n      color: #000000 !important;\n    }\n\n    .custom-arrow:before {\n      color: #3ABCEA !important;\n      position: absolute;\n      transform: scale(0.8);\n    }\n\n    .title {\n      font-size: 1.1rem;\n      color: #3ABCEA;\n      font-weight: bold;\n    }\n\n    .content {\n      color: #FFFFFF;\n      background-color: #3ABCEA;\n      border-radius: 40%/250%;\n      padding: 0 5px;\n      line-height: 26px;\n      font-size: 14.4px;\n    }\n\n    .content-2 {\n      font-size: 14.4px;\n      text-align: center;\n    }\n\n    .red {\n      color: red;\n    }\n\n    .image {\n      max-width: 80%;\n      margin: auto;\n      margin-bottom: 5px;\n    }\n\n    .icon-close {\n      position: absolute;\n      cursor: pointer;\n      top: 30px;\n      right: 15px;\n      width: 15px;\n      height: 15px;\n    }\n  }\n\n}\n\n@media screen and (max-width: 739px) {\n  .click-link {\n    font-size: 14px;\n    gap: 2px;\n    letter-spacing: 0.25px;\n  }\n\n  // .custom-width {\n  //   width: 100%;\n  // }\n\n  .sendMail {\n    width: 100%;\n    padding: 32px 18px;\n\n    &-title {\n      font-size: 18px;\n    }\n\n    &-message {\n      width: 100%;\n    }\n  }\n\n  .auth-container {\n    width: 100%;\n    padding: 36px 18px;\n    gap: 10px;\n\n    &-title {\n      font-size: 18px;\n      line-height: 26px;\n    }\n\n    .error {\n      width: 100%;\n    }\n\n    &-titleMore {\n      font-size: 12px;\n      white-space: break-spaces;\n    }\n  }\n\n  .container-verify {\n    &-header {\n      height: 64px;\n      font-size: 16px;\n      line-height: 20px;\n    }\n\n    &-main {\n      padding: 24px 2px;\n\n      .main-left {\n        &-title {\n          font-size: 18px;\n          line-height: 26px;\n        }\n\n        &-table {\n          padding: 15px 25px;\n\n          &-item {\n            padding: 10px 0;\n            font-size: 14px;\n            line-height: 20px;\n          }\n\n          &-item:nth-child(2) {\n            padding: 10px 0;\n          }\n        }\n      }\n\n      .main-right {\n        &-title {\n          font-size: 18px;\n          line-height: 26px;\n        }\n      }\n    }\n\n    &-slide {\n      .main-title {\n        font-size: 18px;\n        line-height: 26px;\n      }\n    }\n\n    &-table {\n      .main-title {\n        font-size: 18px;\n        line-height: 26px;\n      }\n    }\n  }\n}\n\n.slick-prev:before,\n.slick-next:before {\n  color: #4eae5d !important;\n}\n\n.slick-dots li button:before {\n  font-size: 16px !important;\n  line-height: 20px;\n}\n\n.slick-dots li.slick-active button:before {\n  color: #4eae5d !important;\n}\n","// Notification\n.notification-page {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.noti-item {\n    cursor: pointer;\n    border-radius: 6px;\n}\n\n.readedItem {\n    background-color: $gray;\n}\n\n.unReadItem {\n    background-color: $light-orange;\n}\n\n.bell-noti-icon {\n    color: $white;\n    border-radius: 50%;\n    padding: 6px;\n    width: 16px;\n    height: 16px;\n    bottom: 4px;\n    position: relative;\n}\n\n.noti-badge {\n    margin-right: 0.2rem;\n    span {\n        color: $white;\n        background-color: $red;\n        font-weight: 500;\n        font-size: 10px;\n        line-height: 14px;\n        border-radius: 14px;\n        padding: 4px 0px;\n        white-space: nowrap;\n    }\n}\n\n.noti-content {\n    margin-top: 12px;\n}\n\n.fileDownload {\n    cursor: pointer;\n    color: $blue;\n    text-decoration: underline;\n    margin-left: 10px;\n}\n\n.preview-img {\n    width: 100%;\n    background: #FFFFFF;\n    border: 1px solid #B1B7C1;\n    border-radius: 5px;\n    margin-bottom: 20px;\n    padding: 10px;\n\n    .background-img {\n        background-position: center;\n        background-size: contain;\n        background-repeat: no-repeat;\n        width: 100%;\n        height: 100%;\n        border-radius: 5px;\n    }\n}\n\n// pc\n@media screen and (min-width: 900px) {\n\n    // .notification-index {\n    //     min-width: 800px;\n    // }\n    .noti-date {\n        text-align: end;\n        min-width: 150px;\n    }\n\n    .noti-item {\n        padding: 24px 20px;\n        margin-bottom: 12px;\n        width: 55%;\n    }\n\n    .preview-img {\n        height: 315px;\n    }\n\n    .noti-banner {\n        width: 100%;\n        max-width: 757px;\n        height: auto;\n    }\n\n    .noti-header {\n        display: flex;\n        justify-content: space-between;\n        margin-bottom: 12px;\n    }\n\n    .noti-title {\n        display: flex;\n        justify-content: space-between;\n    }\n\n    // .noti-detail-page {\n    //     min-width: 1100px;\n    // }\n\n    .card-body {\n        display: flex;\n        justify-content: center;\n    }\n\n    .noti-detail-container {\n        width: 70%;\n\n        .noti-banner-detail {\n            width: 100%;\n        }\n    }\n\n    .noti-content {\n        margin-bottom: 24px;\n    }\n\n    .noti-footer {\n        padding-top: 24px;\n        border-top: 1px dashed $orange;\n    }\n}\n\n// mobile\n@media screen and (max-width: 899px) {\n    // .notification-index {\n    //     min-width: 300px;\n    // }\n\n    .noti-item {\n        padding: 16px;\n        margin-bottom: 16px;\n        width: 100%;\n    }\n\n    .preview-img {\n        height: 113px;\n    }\n\n    .noti-banner {\n        width: 100%;\n    }\n\n    .noti-header {\n        display: flex;\n        flex-direction: column-reverse;\n\n    }\n\n    .noti-date {\n        min-width: 150px;\n        text-align: left;\n        margin-bottom: 8px;\n    }\n\n    .noti-title {\n        display: flex;\n        justify-content: space-between;\n\n        h6 {\n            position: relative;\n            top: 2px;\n        }\n    }\n\n    // .noti-detail-page {\n    //     min-width: 327px;\n    // }\n\n    .card-body {\n        display: flex;\n        justify-content: center;\n        flex-direction: column;\n    }\n\n    .noti-detail-container {\n        width: 100%;\n\n        .noti-banner-detail {\n            width: 100%;\n        }\n    }\n\n    .noti-content {\n        margin-bottom: 24px;\n    }\n\n    .noti-footer {\n        padding-top: 24px;\n        border-top: 1px dashed $orange;\n    }\n}",".energy-saving-index {\n    width: 100%;\n\n    .list-content {\n        width: 100%;\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n\n        .page-title {\n            margin: 0;\n        }\n    }\n\n    @media screen and (min-width: 900px) {\n\n        .list-item {\n            width: 25%;\n            flex: 0 0 25%;\n            display: flex;\n            justify-content: flex-start;\n            flex-direction: column;\n            margin-bottom: 1.4em;\n            height: 21em;\n            padding: 0.4rem;\n        }\n\n        .list-item-img-contain {\n            background-position: center;\n            background-size: contain;\n            background-repeat: no-repeat;\n            width: 100%;\n            height: 11rem;\n            overflow: hidden;\n        }\n\n        .list-item-img {\n            width: 100%;\n        }\n\n        .date-time {\n            margin-top: 0.5em;\n            margin-bottom: 0.1em;\n        }\n    }\n\n    @media screen and (max-width: 899px) {\n        .list-item-img-contain {\n            background-position: center;\n            background-size: contain;\n            background-repeat: no-repeat;\n            width: 100%;\n            height: 180px;\n            overflow: hidden;\n        }\n\n        // .list-item-img {\n        //     width: 327px;\n        // }\n\n        .list-item {\n            margin-bottom: 30px;\n            width: 50%;\n            flex: 0 0 50%;\n\n            a {\n                display: flex;\n                justify-content: start;\n            }\n        }\n\n        .date-time {\n            display: inline-block;\n            margin-top: 10px;\n        }\n    }\n\n    @media screen and (max-width: 575px) {\n        .list-item {\n            width: 100%;\n            flex: 0 0 100%;\n        }\n    }\n}\n\n.energy-saving-detail {\n    .sun-icon {\n        width: 30px;\n    }\n\n    .card-outline-top {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        background: $light-orange;\n        border: 3px solid #FFAC7D;\n        box-shadow: 4px 6px 0px #d8bfb7;\n        border-radius: 4px;\n    }\n\n    .card-outline-bottom {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        background: $light-orange;\n        border: 4px solid #FFAC7D;\n        border-radius: 4px;\n    }\n\n    .text-explain-contain {\n        display: flex;\n        align-items: center;\n    }\n\n    .summer-header {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background: #E2F2FF;\n        margin-bottom: 20px;\n\n        h5 {\n            color: #0D6FB8;\n            margin: 0px 12px;\n            font-weight: 700;\n        }\n    }\n\n    .winter-header {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background: $light-orange;\n        margin-bottom: 20px;\n\n        h5 {\n            color: $orange;\n            margin: 0px 12px;\n            font-weight: 700;\n        }\n    }\n\n    .content-title {\n        background: $light-orange;\n        border: 4px solid #FFAC7D;\n        border-radius: 60px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        .page-title-number {\n            color: $white;\n            background-color: $orange;\n            margin: 0 0.5rem;\n            border-radius: 50%;\n            padding: 1px 10px;\n        }\n    }\n\n    .snowflake-icon {\n        width: 30px;\n        height: 30px;\n        background: radial-gradient(50% 50% at 50% 50%, #0D6FB8 27.36%, rgba(13, 111, 184, 0) 100%);\n        color: $white;\n        padding: 4px;\n    }\n\n    .sun-icon {\n        width: 30px;\n        height: 30px;\n        background: radial-gradient(50% 50% at 50% 50%, #FCCA0D 0%, rgba(252, 202, 13, 0) 100%);\n        color: $white;\n        padding: 4px;\n    }\n\n    .explain-notice {\n        font-weight: 600;\n        background: linear-gradient(transparent 60%, #FFEDE1 0%);\n    }\n\n    .supText {\n        font-size: 75%;\n        position: relative;\n        bottom: 0.4em;\n    }\n\n    .summer-txt {\n        color: #1F8DE2;\n        font-weight: 600;\n    }\n\n    .winter-txt {\n        color: $orange;\n        font-weight: #FB6C0D;\n    }\n\n    a {\n        text-decoration: underline;\n        color: $orange;\n        font-weight: 700;\n    }\n\n    .explain-img {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .main-content {\n        background-image: url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='4' ry='4' stroke='%23149BFFFF' stroke-width='3' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e\");\n        border-radius: 4px;\n    }\n\n    .content-lead {\n        background-color: $light-orange;\n        border-width: 4px 0px;\n        border-style: solid;\n        border-color: #FFDCC6;\n        margin: auto;\n    }\n\n    .top-content {\n        margin-bottom: 2rem;\n    }\n\n    .text-explain {\n        margin-bottom: 3rem;\n    }\n\n    .content-title {\n        h3 {\n            padding: 20px 30px;\n        }\n    }\n\n    .content-sub-title {\n        border-bottom: 2px solid #FFAC7D;\n        margin-bottom: 20px;\n    }\n\n    @media screen and (min-width: 900px) {\n        min-width: 1200px;\n\n        .img-box {\n            display: flex;\n            justify-content: space-between;\n        }\n\n        .content-lead {\n            width: 80%;\n\n\n            h4 {\n                padding: 32px 0;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                font-weight: 700;\n                font-size: 18px;\n                line-height: 26px;\n            }\n        }\n\n        .top-content {\n            padding: 0px 168px;\n        }\n\n        .main-content {\n            padding: 82px 168px;\n        }\n\n        .text-explain {\n            font-family: 'Noto Sans JP';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 16px;\n            line-height: 24px;\n        }\n\n        .card-outline-top {\n            padding: 32px;\n            margin-bottom: 52px;\n        }\n\n        .card-outline-bottom {\n            padding: 24px 53px;\n            margin-bottom: 18px;\n        }\n\n        .summer-header,\n        .winter-header {\n            padding: 16px;\n\n            .h5 {\n                font-size: 18px;\n            }\n        }\n\n\n        .quote-txt {\n            font-size: 12px;\n        }\n\n        .content-title {\n            margin: 43px 0;\n        }\n\n        .content-sub-title {\n            h4 {\n                font-weight: 700;\n                font-size: 18px;\n                line-height: 26px;\n                margin-bottom: 7px;\n            }\n        }\n    }\n\n    @media screen and (max-width: 899px) {\n        .text-explain {\n            font-family: 'Noto Sans JP';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 17px;\n        }\n\n        .card-outline-top,\n        .card-outline-bottom {\n            padding: 16px 12px;\n            margin-bottom: 24px;\n        }\n\n        .summer-header,\n        .winter-header {\n            padding: 13px;\n\n            .h5 {\n                font-size: 16px;\n            }\n        }\n\n\n        .quote-txt {\n            font-size: 10px;\n        }\n\n        .content-lead {\n            h4 {\n                padding: 13px 0;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                font-weight: 700;\n                font-size: 16px;\n                line-height: 24px;\n            }\n        }\n\n        .top-content {\n            padding: 16px 12px;\n        }\n\n        .main-content {\n            padding: 16px 12px;\n        }\n\n        .content-title {\n            h3 {\n                padding: 12px 24px;\n            }\n        }\n\n        .content-title {\n            margin: 24px 0;\n        }\n\n        .content-sub-title {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n\n            h4 {\n                font-weight: 700;\n                font-size: 16px;\n                line-height: 23px;\n                margin-bottom: 7px;\n            }\n        }\n    }\n}\n",".main {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n}\n\n.guide-pages-item {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n\n.item {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    // padding: 19px 100px;\n    min-width: 100%;\n}\n\n.row-items {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n}\n\n#usage-guide-text-note {\n    border-bottom: 1px solid $orange;\n    padding: 0px 20px 8px 20px;\n}\n\n.contact-contain {\n    width: 100%;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n\n    .contact-item:first-child {\n        padding-top: 16px;\n        border-top: 1px solid #BCBFC4;\n    }\n\n    .contact-item:last-child {\n        padding-bottom: 16px;\n        border-bottom: 1px solid #BCBFC4;\n    }\n}\n\n.card-outline-explain {\n    background: $light-orange;\n    border: 4px solid #FFAC7D;\n    border-radius: 4px;\n    margin-bottom: 1.5rem;\n    width: 100%;\n    padding: 1.5em 0.5em;\n    letter-spacing: 0.25px;\n}\n\n.text-qa-confirm {\n    font-weight: 700;\n    line-height: 24px;\n    letter-spacing: 0.25px;\n    color: $black;\n    min-height: 2.5em;\n    white-space: pre-line;\n    word-break: break-all;\n}\n\n@media screen and (min-width: 900px) {\n    .confirm-qa-modal-group-item {\n        display: flex;\n        justify-content: space-between;\n    }\n\n    .confirm-qa-modal-item {\n        width: 50%;\n    }\n\n    .text-qa-confirm {\n        font-size: 16px;\n    }\n\n    .main {\n        width: 70%;\n    }\n\n    .contact-item {\n        padding: 8px;\n        display: flex;\n        justify-content: space-between;\n        width: 60%;\n    }\n\n    .guide-pages-item {\n        width: 100%;\n        margin-bottom: 35px;\n    }\n\n    .item-container {\n        padding: 16px;\n        flex: 0 0 auto;\n        width: 50%;\n        display: flex;\n        cursor: pointer;\n    }\n\n\n    .img-icon {\n        width: 18px;\n        position: relative;\n        left: 40px;\n        display: flex;\n        align-items: center;\n        justify-content: center\n    }\n\n    h5 {\n        padding: 0 10px;\n        letter-spacing: 0.25px;\n        line-height: 24px;\n    }\n}\n\n@media screen and (max-width: 899px) {\n    .card-outline-explain {\n        padding: 0.5em 0.1em;\n    }\n\n    .click-here {\n        display: flex;\n        justify-content: center;\n    }\n\n    .text-qa-confirm {\n        font-size: 14px;\n    }\n\n    .main {\n        width: 100%;\n    }\n\n    .contact-item {\n        padding: 6px;\n        display: flex;\n        justify-content: space-between;\n        width: 100%;\n    }\n\n    .guide-pages-item {\n        width: 100%;\n        margin-bottom: 32px;\n    }\n\n    .row-items {\n        flex-direction: column;\n    }\n\n    .item-container {\n        flex: 0 0 auto;\n        width: 100%;\n        max-width: 100%;\n        display: flex;\n        justify-content: center;\n        padding: 0;\n        margin-bottom: 12px;\n        cursor: pointer;\n    }\n\n\n    .img-icon {\n        width: 14px;\n        position: relative;\n        left: 28px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    h5 {\n        position: relative;\n        top: 2px;\n    }\n\n    .title-center {\n        width: 100%;\n        text-align: center;\n    }\n\n    .row-qa {\n        padding: 0 16px;\n    }\n}\n",".table-fixed-column {\n    table-layout: fixed;\n}\n\n.table-center  {\n  text-align: center;\n}\n\n.column-middle {\n  vertical-align: middle;\n}\n\n.graph-header {\n  background-color: #FFF;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 16px;\n}\n\n.chart-label {\n  margin-top: 22px;\n  margin-bottom: 0;\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.annotation-flex {\n  display: flex;\n  align-items: baseline;\n  margin-top: 11px;\n}\n\n.annotation-last-year {\n  width: 43px;\n  height: 12px;\n  background-color: #467395;\n}\n\n.label-last-year {\n  margin-left: 7px;\n  margin-right: 8px;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.annotation-this-year {\n  width: 43px;\n  height: 12px;\n  background-color: #FF7F45;\n  margin-left: 8px;\n}\n\n.label-this-year {\n  margin-left: 7px;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.chart-unit {\n  width: 35px;\n  font-size: 17px;\n  position: relative;\n  margin-left: 9px;\n  align-self: flex-start;\n  color: #F8601B;\n}\n\n.top-screen {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    .nav {\n        width: 100%;\n    }\n\n    .billing-table {\n        th {\n            font-family: 'Noto Sans JP';\n            font-style: normal;\n            font-weight: 500;\n            line-height: 22px;\n            letter-spacing: 0.25px;\n            color: $black;\n        }\n\n        td {\n            color: $black;\n        }\n    }\n}\n\n.billing-table {\n  th {\n    font-family: 'Noto Sans JP';\n    font-style: normal;\n    font-weight: 500;\n    line-height: 22px;\n    letter-spacing: 0.25px;\n    color: $black;\n  }\n\n  td {\n    color: $black;\n  }\n\n  .mark-icon {\n    left: 2px;\n  }\n}\n\n.chart-common {\n    width: 100%;\n    background-color: $white;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    border-radius: 4px;\n    cursor: pointer;\n\n    .chart-wrapper {\n        width: 100%;\n    }\n\n}\n\n.chart-header {\n  overflow-y: scroll;\n}\n\n.chart-body {\n  overflow-y: scroll;\n\n  .chart-wrapper {\n    width: 700px;\n  }\n}\n\n.mark-icon {\n    position: relative;\n    width: 9px;\n    bottom: 1px;\n}\n\n.statement-card-body {\n    justify-content: flex-start;\n}\n\n.bill-detail-item {\n    .message {\n        text-align: center;\n        display: block;\n        margin-top: 64px;\n    }\n}\n\n@media screen and (min-width: 900px) {\n\n    .chart-common {\n\n        h2 {\n            font-weight: 700;\n            font-size: 24px;\n            line-height: 34px;\n            letter-spacing: 0.25px;\n            color: $black;\n\n        }\n    }\n\n    .card-header {\n        display: flex;\n        justify-content: space-between;\n    }\n\n    .bill-area {\n        width: 50%;\n        min-width: 600px;\n\n        .bill-content {\n            width: 80%;\n            margin-bottom: 3em;\n\n            .billing-amount-title {\n                font-weight: 700;\n                font-size: 20px;\n                line-height: 28px;\n                letter-spacing: 0.25px;\n                display: flex;\n                align-items: baseline;\n            }\n\n            .yen-icon {\n                padding: 8px 12px;\n                border-radius: 50%;\n                font-size: 18px;\n                background-color: $yellow;\n                position: relative;\n                top: 3px;\n            }\n\n            .amount {\n                font-weight: 700;\n                font-size: 32px;\n                line-height: 44px;\n                color: $orange;\n                letter-spacing: 0.25px;\n                margin-left: 15px;\n                word-break: break-all;\n            }\n\n            .tax-included {\n                font-weight: 700;\n                font-size: 32px;\n                line-height: 44px;\n                letter-spacing: 0.25px;\n                color: #6C757D;\n\n            }\n        }\n\n        .show-bill {\n            padding: 2em 2em;\n            border: 4px solid #FFAC7D;\n            border-radius: 4px;\n            background: $white;\n            // min-width: 594px;\n        }\n\n        .group-button {\n            .invoice-blue {\n                background-color: #21699E;\n                color: #ffffff;\n            }\n            .invoice-gray-light {\n                background-color: #d6dce5;\n                color: #ffffff; \n            }\n        }\n    }\n\n    .noti-area {\n        width: 50%;\n        min-width: 600px;\n        margin-top: 32px;\n\n        .card-header {\n            flex-direction: row;\n        }\n\n        .noti-img {\n            width: 302px;\n            height: 201px;\n        }\n    }\n\n    .top-sub-title {\n        font-weight: 700;\n        font-size: 24px;\n        line-height: 35px;\n        color: $black;\n    }\n\n    .square {\n        position: relative;\n        font-size: 10px;\n        line-height: 10px;\n        bottom: 2px;\n        margin-right: 5px;\n    }\n\n    .top-screen {\n\n        .navigate-link {\n            color: $orange;\n            cursor: pointer;\n\n            .navigate-text {\n                font-weight: 500;\n                font-size: 16px;\n                line-height: 24px;\n                letter-spacing: -0.28px;\n                text-decoration: underline;\n                margin-left: 5px;\n            }\n        }\n\n        .info-detail {\n            width: 100%;\n\n            .list-bill-info {\n                .list-bill-info-item {\n                    border-bottom: 1px solid #BCBFC4;\n                    padding: 20px 0;\n\n                    .title {\n                        font-weight: 400;\n                        font-size: 16px;\n                        line-height: 24px;\n                        letter-spacing: 0.25px;\n                    }\n                }\n\n                .list-bill-info-item:last-child {\n                    border-bottom: none;\n                }\n            }\n\n            .bill-info-detail-table {\n                margin-bottom: 20px;\n\n                .square {\n                    position: relative;\n                    font-size: 14px;\n                    line-height: 14px;\n                    bottom: 2px;\n                    margin-right: 5px;\n                }\n\n                table {\n                    margin-bottom: 0px;\n                }\n            }\n\n\n        }\n\n        .usage-detail {\n            min-width: 100%;\n\n            .usage-detail-item {\n                padding: 24px;\n                background: #FFF7F2;\n                border: 1px solid #FFAC7D;\n                border-radius: 4px;\n                margin-top: 20px;\n            }\n\n            .item-title {\n                margin-bottom: 20px;\n                display: flex;\n\n                .noti-img {\n                    width: 18.78px;\n                    height: 24px;\n                    margin-right: 5px;\n                }\n\n                .square-icon {\n                    width: 12px;\n                    position: relative;\n                    height: 12px;\n                    top: 5px;\n                }\n\n                h4 {\n                    font-weight: 700;\n                    font-size: 16px;\n                    line-height: 24px;\n                    letter-spacing: 0.25px;\n                    color: $black;\n                }\n\n            }\n\n\n\n            table {\n                background-color: $white;\n                margin: 20px 0 0 0;\n                table-layout: fixed;\n            }\n        }\n    }\n}\n\n@media screen and (max-width: 899px) {\n  .chart-label {\n    margin-top: 16px;\n    font-size: 18px;\n    font-weight: bold;\n  }\n  .label-last-year {\n    margin-left: 7px;\n    margin-right: 8px;\n    font-size: 12px;\n    font-weight: bold;\n  }\n\n  .label-this-year {\n    margin-left: 7px;\n    font-size: 12px;\n    font-weight: bold;\n  }\n    .square {\n        position: relative;\n        font-size: 9px;\n        line-height: 9px;\n        bottom: 3px;\n        margin-right: 5px;\n    }\n\n    .chart-common {\n        width: 700px;\n\n        h2 {\n            font-weight: 700;\n            font-size: 18px;\n            line-height: 26px;\n            letter-spacing: 0.25px;\n            color: $black;\n\n        }\n    }\n\n    .card-header {\n        display: flex;\n        justify-content: space-between;\n        flex-direction: column;\n        height: auto;\n    }\n\n    .bill-detail-contain {\n        padding: 0;\n        width: 100%;\n    }\n\n    .bill-area {\n        width: 100%;\n\n\n        .bill-content {\n            width: 100%;\n            margin-bottom: 50px;\n\n            .billing-amount-title {\n                font-size: 18px;\n                line-height: 26px;\n            }\n\n            .yen-icon {\n                padding: 6px 10px;\n                border-radius: 50%;\n                font-size: 18px;\n                background-color: $yellow;\n                position: relative;\n                top: 3px;\n            }\n\n            .amount {\n                font-weight: 700;\n                font-size: 24px;\n                line-height: 34px;\n                color: $orange;\n                letter-spacing: 0.25px;\n                margin-left: 8px;\n            }\n\n            .tax-included {\n                font-weight: 700;\n                font-size: 24px;\n                line-height: 34px;\n                letter-spacing: 0.25px;\n                color: #6C757D;\n            }\n        }\n\n        .show-bill {\n            padding: 20px 16px;\n            border: 4px solid #FFAC7D;\n            border-radius: 4px;\n            background: $white;\n        }\n\n        .group-button {\n            .invoice-blue {\n                background-color: #21699E;\n                color: #ffffff;\n            }\n            .invoice-gray-light {\n                background-color: #d6dce5;\n                color: #ffffff; \n            }\n        }\n    }\n\n    .noti-area {\n        width: 100%;\n        margin-top: 24px;\n\n        .card-header {\n            flex-direction: row;\n        }\n\n        .noti-img {\n            width: 230px;\n            height: 153px;\n        }\n    }\n\n    .top-sub-title {\n        font-weight: 700;\n        font-size: 18px;\n        line-height: 26px;\n        color: $black;\n    }\n\n    .usage-detail {\n        width: 100%;\n\n        table {\n            width: 100%;\n            table-layout: fixed;\n            overflow-wrap: break-word;\n\n            th {\n                vertical-align: middle;\n            }\n        }\n    }\n\n    .top-screen {\n        .contract {\n            justify-content: space-between;\n        }\n\n        .navigate-link {\n            color: $orange;\n            cursor: pointer;\n\n            .navigate-text {\n                font-weight: 500;\n                font-size: 14px;\n                line-height: 22px;\n                letter-spacing: -0.07px;\n                text-decoration: underline;\n                margin-left: 5px;\n            }\n        }\n\n        .info-detail {\n            width: 100%;\n\n            .list-bill-info {\n                .list-bill-info-item {\n                    border-bottom: 1px solid #BCBFC4;\n                    padding: 16px 0;\n\n                    .title {\n                        font-weight: 400;\n                        font-size: 14px;\n                        line-height: 20px;\n                        letter-spacing: 0.25px;\n                    }\n                }\n\n                .list-bill-info-item:last-child {\n                    border-bottom: none;\n                }\n            }\n\n            .bill-info-detail-table {\n                margin-bottom: 20px;\n\n                .square {\n                    position: relative;\n                    font-size: 10px;\n                    line-height: 10px;\n                    bottom: 3px;\n                    margin-right: 5px;\n                }\n\n                table {\n                    width: 100%;\n                    margin-bottom: 20px;\n                }\n            }\n\n\n        }\n\n        .usage-detail {\n            width: 100%;\n\n            .billing-table {\n                th {\n                    font-size: 10px;\n                    line-height: 18px;\n                    padding: 4px;\n                }\n\n                td {\n                    padding: 2px;\n                }\n            }\n\n            .usage-detail-item {\n                padding: 12px;\n                background: #FFF7F2;\n                border: 1px solid #FFAC7D;\n                border-radius: 4px;\n                margin-top: 20px;\n            }\n\n            .item-title {\n                margin-bottom: 20px;\n                display: flex;\n\n                .noti-img {\n                    width: 18.78px;\n                    height: 24px;\n                    margin-right: 5px;\n                }\n\n                .square-icon {\n                    width: 12px;\n                    position: relative;\n                    height: 12px;\n                    top: 5px;\n                    ;\n                }\n\n                h4 {\n                    font-weight: 700;\n                    font-size: 14px;\n                    line-height: 24px;\n                    letter-spacing: 0.25px;\n                    color: $black;\n                }\n\n            }\n\n            table {\n                background-color: $white;\n                margin: 20px 0 0 0;\n            }\n        }\n    }\n}\n\n@media screen and (min-width: 900px) {\n    .contract {\n        display: flex;\n        justify-content: flex-end;\n    }\n\n    .bill-detail-item {\n        width: 600px;\n    }\n\n    .contract-number {\n        font-weight: 700;\n        font-size: 18px;\n        line-height: 26px;\n        letter-spacing: 0.25px;\n        color: $black;\n    }\n\n    .contract-name {\n        font-weight: 500;\n        font-size: 18px;\n        line-height: 28px;\n        letter-spacing: 0.25px;\n        color: #6C757D;\n        align-self: center;\n    }\n\n    .bill-detail-contain {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .change-month {\n        display: flex;\n\n        .month-year {\n            margin: 0 10px;\n            background-color: #F5F5F5;\n            border-radius: 4px;\n            display: inline-flex;\n\n            span {\n                font-weight: 700;\n                font-size: 18px;\n                line-height: 24px;\n                letter-spacing: 0.25px;\n                color: $black;\n                padding: 4px 6px;\n                border-radius: 4px;\n            }\n        }\n\n        .change-month-icon {\n            display: inline;\n            border-radius: 4px;\n            padding: 4px 6px;\n            background-color: $orange;\n            color: $white;\n            cursor: pointer;\n            font-size: 16px;\n            line-height: 24px;\n            font-weight: 700;\n        }\n    }\n}\n\n@media screen and (max-width: 899px) {\n    .select-custom {\n        // width: 209px !important;\n    }\n\n    .bill-detail-item {\n        width: 100%;\n    }\n\n    .contract {\n        width: 100%;\n        display: flex;\n        justify-content: space-between;\n    }\n\n    .contract-number {\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 18px;\n        letter-spacing: 0.25px;\n        color: $black;\n    }\n\n    .contract-name {\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 18px;\n        letter-spacing: 0.25px;\n        color: #6c757d;\n        align-self: center;\n    }\n\n\n    .change-month {\n        display: flex;\n\n        .month-year {\n            margin: 0 10px;\n            background-color: #F5F5F5;\n            border-radius: 4px;\n            display: inline-flex;\n\n            span {\n                font-weight: 700;\n                font-size: 16px;\n                line-height: 22px;\n                letter-spacing: 0.25px;\n                color: $black;\n                padding: 4px 6px;\n                border-radius: 4px;\n            }\n        }\n\n        .change-month-icon {\n            display: inline;\n            border-radius: 4px;\n            padding: 4px 6px;\n            background-color: $orange;\n            color: $white;\n            cursor: pointer;\n            font-size: 14px;\n            line-height: 22px;\n            font-weight: 700;\n        }\n    }\n}\n\n.select-custom {\n    //height: 36px;\n    // width: 306px;\n    gap: 10px;\n    background-color: #fff7f2;\n    border: 1px solid $color-border;\n    border-radius: 4px;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 20px;\n    letter-spacing: 0.25px;\n    color: $black;\n    cursor: pointer;\n    position: relative;\n    .select-item {\n        cursor: pointer;\n    }\n    ul {\n        transform: unset !important;\n        margin-top: 55px !important;\n    }\n}\n\n.detail-meter-screen {\n    .meter-detail {\n        border-top: 1px solid #BCBFC4;\n    }\n\n    @media screen and (min-width: 900px) {\n        .card-header {\n            display: flex;\n            justify-content: space-between;\n        }\n\n        .meter-detail-contain {\n            width: 50%;\n            padding-top: 45px;\n        }\n\n        .top-sub-title {\n            font-weight: 700;\n            font-size: 24px;\n            line-height: 35px;\n            color: $black;\n            margin-bottom: 25px;\n        }\n\n        .meter-detail {\n            padding: 20px 0;\n        }\n\n        .meter-detail-item-title,\n        .id-number {\n            padding: 10px 0;\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 24px;\n            letter-spacing: 0.25px;\n            color: $black;\n        }\n\n        .meter-detail-item {\n            display: flex;\n            justify-content: space-between;\n            width: 100%;\n            font-weight: 400;\n            font-size: 16px;\n            line-height: 24px;\n            letter-spacing: 0.25px;\n            color: $black;\n            padding: 10px 0;\n        }\n\n        .square {\n            position: relative;\n            font-size: 10px;\n            line-height: 10px;\n            bottom: 3px;\n            margin-right: 5px;\n        }\n    }\n\n    @media screen and (max-width: 899px) {\n        .card-header {\n            display: flex;\n            justify-content: space-between;\n            flex-direction: column;\n            height: auto;\n        }\n\n        .square-icon {\n            width: 12px;\n            position: relative;\n            height: 12px;\n            top: 5px;\n        }\n\n        .meter-detail-contain {\n            width: 100%;\n        }\n\n        .top-sub-title {\n            font-weight: 700;\n            font-size: 18px;\n            line-height: 26px;\n            letter-spacing: -0.28px;\n            color: $black;\n            margin-bottom: 19px;\n        }\n\n        .meter-detail {\n            padding: 15px 0;\n        }\n\n        .meter-detail-item-title,\n        .id-number {\n            padding: 8px 0;\n            font-weight: 500;\n            font-size: 14px;\n            line-height: 22px;\n            letter-spacing: 0.25px;\n            color: $black;\n        }\n\n        .meter-detail-item {\n            display: flex;\n            justify-content: space-between;\n            width: 100%;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 22px;\n            letter-spacing: 0.25px;\n            color: $black;\n            padding: 10px 0;\n        }\n    }\n}\n\n.tab-content {\n    width: 100%;\n}\n\n.chart-screen {\n    width: 65%;\n\n    .nav-pills .nav-link.active,\n    .nav-pills .show>.nav-link {\n        color: $white;\n        background-color: $orange;\n        border: 2px solid $orange;\n    }\n\n    .nav-link {\n        border: 2px solid #BCBFC4;\n    }\n\n    .usage-graph {\n        padding-bottom: 40px;\n    }\n\n    .electric-chart {\n        background-color: #DEEDD8;\n    }\n\n    .gas-chart {\n        background-color: $light-orange;\n    }\n}\n\n.chart-display-tab {\n    .nav {\n        background-color: $light-orange;\n    }\n}\n\n@media screen and (max-width: 1279px) and (min-width: 900px) {\n    .chart-container {\n        .noti-img {\n            width: 20px;\n            height: 26px;\n            margin-right: 5px;\n        }\n\n        .noti-large-img {\n            width: 46px;\n            height: 46px;\n            bottom: 6px;\n        }\n    }\n\n    .detail-amount {\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        flex-direction: column;\n\n        .compare-item {\n            display: flex;\n            justify-content: flex-start;\n            width: 100% !important;\n            padding: 15px 24px;\n            align-items: center;\n        }\n\n        .compare-item:first-child {\n            margin-bottom: 8px;\n        }\n\n        .compare-item:last-child {\n            margin-top: 8px;\n        }\n\n        .usage-amount {\n            margin-left: 19px;\n        }\n    }\n\n    .chart-screen {\n        min-width: 600px !important;\n    }\n}\n\n@media screen and (min-width: 900px) {\n    .no-bill-record {\n        font-weight: 500;\n        display: flex;\n        justify-content: center;\n        text-align: center;\n        letter-spacing: 0.25px;\n        color: #6C757D;\n    }\n\n    .tab-content {\n        width: 100%;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .detail-billed-tab {\n        width: 100%;\n    }\n\n    .chart-display-tab {\n        display: flex !important;\n        flex-direction: column;\n        align-items: center;\n\n        .nav {\n            padding: 8px !important;\n        }\n    }\n\n    .chart-container {\n        .noti-img {\n            width: 25px;\n            height: 33px;\n            margin-right: 10px;\n        }\n\n        .noti-large-img {\n            width: 80px;\n            height: 80px;\n            position: relative;\n            bottom: 6px;\n        }\n\n        .message {\n            color: #6C757D;\n        }\n    }\n\n    .chart-screen {\n        min-width: 920px;\n\n        .tab-pane {\n            width: 100%;\n            background-color: $light-orange;\n        }\n\n        .nav {\n            li:first-child {\n                margin-right: 8px;\n            }\n        }\n    }\n\n    .detail-amount {\n        width: 100%;\n        display: flex;\n        justify-content: space-between;\n\n        .compare-item {\n            background-color: $white;\n            display: flex;\n            justify-content: flex-start;\n            width: 49%;\n            padding: 32px;\n            align-items: center;\n            border-radius: 4px;\n        }\n\n        // .compare-item:first-child {\n        //     margin-right: 16px;\n        // }\n\n        // .compare-item:last-child {\n        //     margin-left: 16px;\n        // }\n\n        .note-text {\n            font-weight: 700;\n            font-size: 20px;\n            line-height: 28px;\n            letter-spacing: 0.25px;\n            color: #6C757D;\n            margin-top: 6px;\n        }\n\n        .usage-amount {\n            // white-space: nowrap;\n            margin-left: 24px;\n        }\n\n        .amount-text {\n            word-break: break-all;\n            font-weight: 700;\n            font-size: 40px;\n            line-height: 44px;\n            letter-spacing: 0.25px;\n            color: $black;\n\n            .text-status {\n                white-space: nowrap;\n            }\n\n            .up-arrow,\n            .increase-text {\n                color: $red;\n                margin-right: 16px;\n            }\n\n            .down-arrow,\n            .decrease-text {\n                color: $green;\n                margin-right: 16px;\n            }\n        }\n\n    }\n\n    .electric-chart,\n    .gas-chart {\n        padding: 32px;\n    }\n\n    .title-contain {\n\n        img,\n        .top-sub-title {\n            margin-bottom: 24px;\n        }\n    }\n}\n\n@media screen and (max-width: 899px) {\n  .usage-graph {\n    overflow-x: scroll;\n    overscroll-behavior-inline: none;\n  }\n    .chart-screen {\n        width: 100%;\n        background-color: $light-orange;\n\n        .tab-pane {\n            width: 100%;\n        }\n    }\n\n    .no-bill-record {\n        font-weight: 500;\n        display: flex;\n        justify-content: center;\n        text-align: center;\n        letter-spacing: 0.25px;\n        color: #6C757D;\n    }\n\n    .chart-container {\n        .noti-img {\n            width: 20px;\n            height: 26px;\n            margin-right: 5px;\n        }\n\n        .noti-large-img {\n            width: 46px;\n            height: 46px;\n            bottom: 6px;\n        }\n\n        .message {\n            color: #6C757D;\n        }\n    }\n\n\n    .chart-screen {\n        .nav {\n            li:first-child {\n                margin-right: 4px;\n            }\n\n            li {\n                width: 45%;\n            }\n        }\n    }\n\n    .detail-amount {\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        flex-direction: column;\n\n        .compare-item {\n            background-color: $white;\n            display: flex;\n            justify-content: flex-start;\n            width: 100%;\n            padding: 15px 24px;\n            align-items: center;\n        }\n\n        .compare-item:first-child {\n            margin-bottom: 8px;\n        }\n\n        .compare-item:last-child {\n            margin-top: 8px;\n        }\n\n        .note-text {\n            font-weight: 700;\n            font-size: 12px;\n            line-height: 18px;\n            letter-spacing: 0.25px;\n            color: #6C757D;\n            margin-top: 4px;\n        }\n\n        .usage-amount {\n            margin-left: 19px;\n        }\n\n        .amount-text {\n            word-break: break-all;\n            font-weight: 700;\n            font-size: 24px;\n            line-height: 34px;\n            letter-spacing: 0.25px;\n            color: $black;\n\n            .text-status {\n                white-space: nowrap;\n            }\n\n            .up-arrow,\n            .increase-text {\n                color: $red;\n                margin-right: 10px;\n            }\n\n            .down-arrow,\n            .decrease-text {\n                color: $green;\n                margin-right: 10px;\n            }\n        }\n\n        .up-arrow,\n        .increase-text {\n            color: $red;\n            margin-right: 8px;\n        }\n\n\n        .down-arrow,\n        .decrease-text {\n            color: $green;\n            margin-right: 8px;\n        }\n    }\n\n    .electric-chart,\n    .gas-chart {\n        padding: 12px;\n    }\n\n    .title-contain {\n\n        img,\n        .top-sub-title {\n            margin-bottom: 20px;\n        }\n    }\n}\n",".err-container {\n    border-top: 4px solid #F8601B;\n    box-shadow: 0px 4px 18px #FBD7B6;\n    border-radius: 4px;\n    background-color: $white;\n\n    .message-container {\n        margin-bottom: 1.5em;\n        border-top: 1px dashed #6C757D;\n        border-bottom: 1px dashed #6C757D;\n        background: #F5F5F5;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        font-weight: 500;\n        color: #6C757D;\n\n    }\n}\n\n@media screen and (min-width: 900px) {\n    .err-container {\n        padding: 2em;\n\n        img {\n            width: 462px;\n            margin-bottom: 1.5em;\n        }\n\n        .message-container {\n            padding: 12px 100px;\n            font-size: 16px;\n            line-height: 24px;\n            letter-spacing: 0.25px;\n\n            .exclamation-icon {\n                font-size: 20px;\n                margin-right: 7px;\n            }\n        }\n    }\n}\n\n@media screen and (max-width: 899px) {\n    .err-container {\n        img {\n            width: 315px;\n            margin-bottom: 1em;\n        }\n\n\n        .message-container {\n            padding: 12px 34px;\n            font-size: 14px;\n            line-height: 20px;\n            letter-spacing: 0.25px;\n\n            .exclamation-icon {\n                font-size: 16px;\n                margin-right: 7px;\n            }\n        }\n    }\n}","#RFS-StepperContainer {\n    #RFS-StepMain {\n        #RFS-StepButton{\n            font-family: 'Noto Sans JP';\n            pointer-events: none;\n            font-size: 16px;\n            line-height: 24px;\n        }\n\n        #RFS-LabelContainer {\n            #RFS-Label {\n                font-family: 'Noto Sans JP';\n                font-style: normal;\n                font-weight: 500;\n                align-items: center;\n                text-align: center;\n                letter-spacing: 0.25px;\n                color: #6C757D;\n                white-space: pre-wrap;\n            }\n        }\n    }\n\n    #RFS-ConnectorContainer {\n        .active {\n            border-color: $orange;\n        }\n\n        .completed {\n            border-color: #faa27b;\n        }\n    }\n\n    .step-label-active {\n        color: $orange;\n        font-weight: 700;\n    }\n}\n\n.StepperContainer-0-2-1 {\n    width: 100%;\n    padding: 24px 0px !important;\n}\n\n@media screen and (min-width: 900px) {\n    #RFS-StepMain {\n        #RFS-StepButton{\n            font-size: 14px;\n            line-height: 22px;\n        }\n\n        #RFS-LabelContainer {\n            #RFS-Label {\n                font-size: 14px;\n                line-height: 22px;\n            }\n        }\n    }\n\n\n}\n\n@media screen and (max-width: 899px) {\n    #RFS-StepperContainer {\n        #RFS-StepMain {\n            #RFS-LabelContainer {\n                #RFS-Label {\n                    font-size: 12px;\n                    line-height: 18px;\n                }\n            }\n        }\n\n        .StepContainer-0-2-2 {\n            flex: 1;\n            position: relative;\n            padding-left: 0px;\n            padding-right: 0px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
